var Qo = Object.defineProperty;
var Xo = (e, t, n) => t in e ? Qo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ut = (e, t, n) => Xo(e, typeof t != "symbol" ? t + "" : t, n);
import { u as Ve, a as $e, m as R, j as r, L as Jo, A as ea, c as ta, T as ra, C as na, G as oa, F as aa, l as ia, B as jt, b as qr, d as W, t as X, e as Q1, I as la, f as Qe, g as sa, R as ca, o as o2, S as Le, h as u1, s as Pe, i as ar, k as Ze, n as Ur, p as Xe, q as rt, r as da, v as Gr, w as Kr, x as y2, y as dt, z as ua, D as pa, E as ma, H as ha, J as ga, K as Yr, M as Qr, N as Xr, O as o1, P as Jr, Q as q1, U as a2, V as Ca, W as va, X as fa, Y as xa, Z as ba, _ as wa, $ as ya, a0 as en, a1 as ir, a2 as ka, a3 as i2, a4 as lr, a5 as ja, a6 as Sa, a7 as C1, a8 as tn, a9 as rn, aa as xt, ab as me, ac as La, ad as Ma, ae as sr, af as Ea, ag as Na, ah as cr, ai as Ia, aj as nn, ak as on, al as $a, am as je, an as _a, ao as Va, ap as Aa, aq as Ba, ar as Ha, as as an, at as Da, au as Ta, av as Ra, aw as Fa, ax as za, ay as Wa, az as Oa, aA as Za, aB as Pa, aC as qa, aD as Ua, aE as Ga, aF as Ka, aG as Ya, aH as Qa, aI as Gt, aJ as Xa, aK as Ja, aL as e0, aM as ln, aN as L1, aO as We, aP as t0, aQ as r0, aR as n0, aS as o0, aT as a0, aU as i0, aV as l0, aW as s0, aX as c0, aY as dr, aZ as d0, a_ as u0, a$ as p0, b0 as m0, b1 as h0, b2 as g0, b3 as C0, b4 as v0, b5 as f0, b6 as x0, b7 as Ue, b8 as sn, b9 as b0, ba as w0, bb as y0, bc as l2, bd as k0, be as j0, bf as S0, bg as L0, bh as M0, bi as E0, bj as N0 } from "./vendor-DvskZXh9.js";
import { bk as Hm, bl as Dm, bm as Tm } from "./vendor-DvskZXh9.js";
import * as s from "react";
import qe, { createContext as nt, useState as V, useContext as $1, useEffect as K, useRef as Z, createElement as e1, forwardRef as I0, useCallback as Te, useImperativeHandle as k2, useMemo as M1, Fragment as j2, useLayoutEffect as cn, Component as $0 } from "react";
import { isRouteErrorResponse as _0, useLocation as V0, useNavigate as A0 } from "react-router";
const dn = 640, Kt = 768, _1 = dn, B0 = dn, s2 = 600, Ku = (e) => {
  const t = Ve();
  return $e(t.breakpoints.down(e));
}, H0 = R()((e, { variant: t, hasCloseButton: n }) => ({
  root: {
    position: "relative",
    display: "flex",
    padding: "0.5rem 0.5rem 0.5rem 1rem",
    gap: "1rem",
    borderRadius: "0.25rem",
    width: "100%",
    textAlign: "left",
    containerType: "inline-size"
  },
  rootNeutral: {
    backgroundColor: e.palette.neutral[10],
    border: `1px solid ${e.palette.neutral[30]}`
  },
  rootInfo: {
    backgroundColor: e.palette.info[10],
    border: `1px solid ${e.palette.info["60-key"]}`
  },
  rootSuccess: {
    backgroundColor: e.palette.success[10],
    border: `1px solid ${e.palette.success["60-key"]}`
  },
  rootWarning: {
    backgroundColor: e.palette.warning[10],
    border: `1px solid ${e.palette.warning["60-key"]}`
  },
  rootError: {
    backgroundColor: e.palette.error[10],
    border: `1px solid ${e.palette.error["60-key"]}`
  },
  iconContainer: {
    paddingTop: "0.375rem",
    ...t === "info" && {
      ">svg": {
        color: e.palette.info["60-key"]
      }
    }
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    width: "100%",
    ...n && {
      paddingRight: "2.5rem"
    },
    [`@container (min-width: ${Kt}px)`]: {
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      gap: "0.5rem 1rem"
    }
  },
  content: {
    padding: "0.5rem 0",
    // flexShrink: 1,
    flex: 1
  },
  actionButtonContainer: {
    lineHeight: "1rem",
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",
    paddingBottom: "0.5rem",
    flexWrap: "wrap",
    [`@container (min-width: ${Kt}px)`]: {
      alignItems: "center",
      paddingBottom: 0,
      flexShrink: 0
    }
  },
  title: {
    ...e.typography.h4,
    marginBottom: "0.125rem"
  },
  titleNeutral: {
    color: e.palette.neutral[80]
  },
  titleInfo: {
    color: e.palette.info["60-key"]
  },
  titleSuccess: {
    color: e.palette.success["60-key"]
  },
  titleWarning: {
    color: e.palette.warning["60-key"]
  },
  titleError: {
    color: e.palette.error["60-key"]
  },
  description: {
    ...e.typography.body2,
    color: e.palette.neutral[80],
    [`@container (min-width: ${Kt}px)`]: {
      gridArea: "bottom-left"
    }
  },
  descriptionNeutral: {
    color: e.palette.neutral[60]
  },
  closeButtonContainer: {
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem"
  },
  crossIcon: {
    flexShrink: "0",
    cursor: "pointer"
  }
})), D0 = ({
  children: e
}) => /* @__PURE__ */ r.jsx(Jo, { dateAdapter: ea, children: e }), T0 = "rgba(0, 0, 0, 0.3)", R0 = "#7e29a3", F0 = "lightyellow", x = {
  "primary-10": "#edf4f7",
  "primary-20": "#dbe9ef",
  "primary-30": "#c9dee6",
  "primary-40": "#a5c8d6",
  "primary-50": "#80b1c6",
  "primary-60-key": "#4a90ad",
  "primary-70": "#3b738a",
  "primary-80": "#2c5668",
  "primary-90": "#1e3a45",
  "primary-100": "#0f1d23",
  "primary-60-5": "rgba(74, 144, 173, 0.05)",
  "primary-60-10": "rgba(74, 144, 173, 0.1)",
  "primary-60-15": "rgba(74, 144, 173, 0.15)",
  "primary-60-20": "rgba(74, 144, 173, 0.2)",
  "primary-60-25": "rgba(74, 144, 173, 0.25)",
  "information-10": "#ebf3ff",
  "information-20": "#d8e7ff",
  "information-30": "#c4dbff",
  "information-40": "#9dc3ff",
  "information-50": "#75aaff",
  "information-60-key": "#3a86ff",
  "information-70": "#2e6bcc",
  "information-80": "#235099",
  "information-90": "#173666",
  "information-100": "#0c1b33",
  "information-60-5": "rgba(58, 134, 255, 0.05)",
  "information-60-10": "rgba(58, 134, 255, 0.1)",
  "information-60-15": "rgba(58, 134, 255, 0.15)",
  "information-60-20": "rgba(58, 134, 255, 0.2)",
  "information-60-25": "rgba(58, 134, 255, 0.25)",
  "success-10": "#f2f8e8",
  "success-20": "#e5f1d1",
  "success-30": "#d7eaba",
  "success-40": "#bddd8c",
  "success-50": "#a3cf5e",
  "success-60-key": "#7bba19",
  "success-70": "#629514",
  "success-80": "#4a700f",
  "success-90": "#314a0a",
  "success-100": "#192505",
  "success-60-5": "rgba(123, 186, 25, 0.05)",
  "success-60-10": "rgba(123, 186, 25, 0.1)",
  "success-60-15": "rgba(123, 186, 25, 0.15)",
  "success-60-20": "rgba(123, 186, 25, 0.2)",
  "success-60-25": "rgba(123, 186, 25, 0.25)",
  "warning-10": "#fdf7e9",
  "warning-20": "#fbefd3",
  "warning-30": "#f8e7bd",
  "warning-40": "#f4d791",
  "warning-50": "#f0c765",
  "warning-60-key": "#e9af23",
  "warning-70": "#ba8c1c",
  "warning-80": "#8c6915",
  "warning-90": "#5d460e",
  "warning-100": "#2f2307",
  "warning-60-5": "rgba(242, 144, 30, 0.05)",
  "warning-60-10": "rgba(242, 144, 30, 0.1)",
  "warning-60-15": "rgba(242, 144, 30, 0.15)",
  "warning-60-20": "rgba(242, 144, 30, 0.2)",
  "warning-60-25": "rgba(242, 144, 30, 0.25)",
  "error-10": "#fef0ed",
  "error-20": "#fce0db",
  "error-30": "#fbd1c9",
  "error-40": "#f9b3a6",
  "error-50": "#f69482",
  "error-60-key": "#f2664c",
  "error-70": "#c2523d",
  "error-80": "#913d2e",
  "error-90": "#61291e",
  "error-100": "#30140f",
  "error-60-5": "rgba(224, 58, 45, 0.05)",
  "error-60-10": "rgba(224, 58, 45, 0.1)",
  "error-60-15": "rgba(224, 58, 45, 0.15)",
  "error-60-20": "rgba(224, 58, 45, 0.2)",
  "error-60-25": "rgba(224, 58, 45, 0.25)",
  "avatar-01": "linear-gradient(180deg, #65b3e1 0%, #488fb9 100%)",
  "avatar-02": "linear-gradient(180deg, #90ce75 0%, #5fa04a 100%)",
  "avatar-03": "linear-gradient(180deg, #87d8ce 0%, #4aa99d 100%)",
  "avatar-04": "linear-gradient(180deg, #a6b7ea 0%, #4f66a8 100%)",
  "avatar-05": "linear-gradient(180deg, #ffb15b 0%, #f7901e 100%)",
  "avatar-06": "linear-gradient(180deg, #ff9173 0%, #dd6444 100%)",
  overlay: T0,
  "neutral-white": "#ffffff",
  "neutral-10": "#fafafa",
  "neutral-20": "#f4f4f4",
  "neutral-30": "#e6e6e6",
  "neutral-40": "#d8d8d8",
  "neutral-50": "#bdbdbd",
  "neutral-60": "#a1a1a1",
  "neutral-70": "#767676",
  "neutral-80": "#464646",
  "neutral-90": "#323232",
  "neutral-100": "#161616",
  "neutral-black": "#000000",
  "neutral-white-15": "rgba(255, 255, 255, 0.15)",
  "neutral-50-10": "rgba(189, 189, 189, 0.1)",
  "neutral-80-5": "rgba(70, 70, 70, 0.05)",
  "neutral-80-10": "rgba(70, 70, 70, 0.1)",
  "neutral-80-15": "rgba(70, 70, 70, 0.15)",
  "neutral-80-20": "rgba(70, 70, 70, 0.2)",
  "neutral-80-25": "rgba(70, 70, 70, 0.25)",
  "neutral-black-30": "rgba(0, 0, 0, 0.3)",
  "text-disabled": "#bdbdbd",
  "brand-ia-green": "#8dc63e",
  "brand-ia-green-shade": "#7bba19",
  "brand-ia-gray": "#445c6d",
  "brand-ia-gray-shade-1": "#3f5565",
  "brand-ia-gray-shade-2": "#384d5e",
  "brand-ia-gray-shade-3": "#304453",
  "brand-ia-dark-gray": "#39464b",
  "depth-down": "0px 5px 5px 0px rgba(0, 0, 0, 0.1)",
  "depth-1": "0px 0px 30px 0px rgba(0, 0, 0, 0.05)",
  "depth-2": "0px 0px 30px 0px rgba(0, 0, 0, 0.1)",
  "depth-3": "0px 0px 30px 0px rgba(0, 0, 0, 0.2)",
  "basic-hover": "0px 0px 10px 0px rgba(74, 144, 173, 0.5)",
  "basic-hover-destructive": "0px 0px 10px 0px rgba(241, 75, 53, 0.5)",
  "fab-hover": "0px 0px 30px 0px rgba(0, 0, 0, 0.1), 0px 0px 10px 0px rgba(74, 144, 173, 0.5)",
  documentation: R0,
  mocked: F0
}, ur = {
  color: `var(--neutral-70, ${x["neutral-70"]})`,
  fontSize: "0.75rem",
  fontFamily: "Proxima Nova",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "1rem"
}, pr = {
  color: `var(--neutral-80, ${x["neutral-80"]})`,
  fontSize: "0.875rem",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "1.25rem",
  letterSpacing: "normal"
}, z0 = {
  palette: {
    primary: {
      main: x["primary-10"],
      10: `var(--primary-10, ${x["primary-10"]})`,
      20: `var(--primary-20, ${x["primary-20"]})`,
      30: `var(--primary-30, ${x["primary-30"]})`,
      40: `var(--primary-40, ${x["primary-40"]})`,
      50: `var(--primary-50, ${x["primary-50"]})`,
      "60-key": `var(--primary-60-key, ${x["primary-60-key"]})`,
      70: `var(--primary-70, ${x["primary-70"]})`,
      80: `var(--primary-80, ${x["primary-80"]})`,
      90: `var(--primary-90, ${x["primary-90"]})`,
      100: `var(--primary-100, ${x["primary-100"]})`,
      "60-5": `var(--primary-60-5, ${x["primary-60-5"]})`,
      "60-10": `var(--primary-60-10, ${x["primary-60-10"]})`,
      "60-15": `var(--primary-60-15, ${x["primary-60-15"]})`,
      "60-20": `var(--primary-60-20, ${x["primary-60-20"]})`,
      "60-25": `var(--primary-60-25, ${x["primary-60-25"]})`
    },
    info: {
      main: x["information-10"],
      10: `var(--information-10, ${x["information-10"]})`,
      20: `var(--information-20, ${x["information-20"]})`,
      30: `var(--information-30, ${x["information-30"]})`,
      40: `var(--information-40, ${x["information-40"]})`,
      50: `var(--information-50, ${x["information-50"]})`,
      "60-key": `var(--information-60-key, ${x["information-60-key"]})`,
      70: `var(--information-70, ${x["information-70"]})`,
      80: `var(--information-80, ${x["information-80"]})`,
      90: `var(--information-90, ${x["information-90"]})`,
      100: `var(--information-100, ${x["information-100"]})`,
      documentation: `var(--documentation, ${x.documentation})`,
      "60-5": `var(--information-60-5, ${x["information-60-5"]})`,
      "60-10": `var(--information-60-10, ${x["information-60-10"]})`,
      "60-15": `var(--information-60-15, ${x["information-60-15"]})`,
      "60-20": `var(--information-60-20, ${x["information-60-20"]})`,
      "60-25": `var(--information-60-25, ${x["information-60-25"]})`
    },
    success: {
      main: x["success-10"],
      10: `var(--success-10, ${x["success-10"]})`,
      20: `var(--success-20, ${x["success-20"]})`,
      50: `var(--success-50, ${x["success-50"]})`,
      "60-key": `var(--success-60-key, ${x["success-60-key"]})`,
      70: `var(--success-70, ${x["success-70"]})`,
      80: `var(--success-80, ${x["success-80"]})`,
      90: `var(--success-90, ${x["success-90"]})`,
      100: `var(--success-100, ${x["success-100"]})`,
      "60-5": `var(--success-60-5, ${x["success-60-5"]})`,
      "60-10": `var(--success-60-10, ${x["success-60-10"]})`,
      "60-15": `var(--success-60-15, ${x["success-60-15"]})`,
      "60-20": `var(--success-60-20, ${x["success-60-20"]})`,
      "60-25": `var(--success-60-25, ${x["success-60-25"]})`
    },
    warning: {
      main: x["warning-10"],
      10: `var(--warning-10, ${x["warning-10"]})`,
      20: `var(--warning-20, ${x["warning-20"]})`,
      30: `var(--warning-30, ${x["warning-30"]})`,
      40: `var(--warning-40, ${x["warning-40"]})`,
      50: `var(--warning-50, ${x["warning-50"]})`,
      "60-key": `var(--warning-60-key, ${x["warning-60-key"]})`,
      70: `var(--warning-70, ${x["warning-70"]})`,
      80: `var(--warning-80, ${x["warning-80"]})`,
      90: `var(--warning-90, ${x["warning-90"]})`,
      100: `var(--warning-100, ${x["warning-100"]})`,
      "60-5": `var(--warning-60-5, ${x["warning-60-5"]})`,
      "60-10": `var(--warning-60-10, ${x["warning-60-10"]})`,
      "60-15": `var(--warning-60-15, ${x["warning-60-15"]})`,
      "60-20": `var(--warning-60-20, ${x["warning-60-20"]})`,
      "60-25": `var(--warning-60-25, ${x["warning-60-25"]})`
    },
    error: {
      main: x["error-10"],
      10: `var(--error-10, ${x["error-10"]})`,
      20: `var(--error-20, ${x["error-20"]})`,
      30: `var(--error-30, ${x["error-30"]})`,
      40: `var(--error-40, ${x["error-40"]})`,
      50: `var(--error-50, ${x["error-50"]})`,
      "60-key": `var(--error-60-key, ${x["error-60-key"]})`,
      70: `var(--error-70, ${x["error-70"]})`,
      80: `var(--error-80, ${x["error-80"]})`,
      90: `var(--error-90, ${x["error-90"]})`,
      100: `var(--error-100, ${x["error-100"]})`,
      "60-5": `var(--error-60-5, ${x["error-60-5"]})`,
      "60-10": `var(--error-60-10, ${x["error-60-10"]})`,
      "60-15": `var(--error-60-15, ${x["error-60-15"]})`,
      "60-20": `var(--error-60-20, ${x["error-60-20"]})`,
      "60-25": `var(--error-60-25, ${x["error-60-25"]})`
    },
    neutral: {
      white: `var(--neutral-white, ${x["neutral-white"]})`,
      10: `var(--neutral-10, ${x["neutral-10"]})`,
      20: `var(--neutral-20, ${x["neutral-20"]})`,
      30: `var(--neutral-30, ${x["neutral-30"]})`,
      40: `var(--neutral-40, ${x["neutral-40"]})`,
      50: `var(--neutral-50, ${x["neutral-50"]})`,
      60: `var(--neutral-60, ${x["neutral-60"]})`,
      70: `var(--neutral-70, ${x["neutral-70"]})`,
      80: `var(--neutral-80, ${x["neutral-80"]})`,
      90: `var(--neutral-90, ${x["neutral-90"]})`,
      100: `var(--neutral-100, ${x["neutral-100"]})`,
      black: `var(--neutral-black, ${x["neutral-black"]})`,
      "50-10": `var(--neutral-50-10, ${x["neutral-50-10"]})`,
      "80-5": `var(--neutral-80-5, ${x["neutral-80-5"]})`,
      "80-10": `var(--neutral-80-10, ${x["neutral-80-10"]})`,
      "80-15": `var(--neutral-80-15, ${x["neutral-80-15"]})`,
      "80-20": `var(--neutral-80-20, ${x["neutral-80-20"]})`,
      "80-25": `var(--neutral-80-25, ${x["neutral-80-25"]})`,
      "black-30": `var(--neutral-black-30, ${x["neutral-black-30"]})`
    },
    avatar: {
      1: `var(--avatar-01, ${x["avatar-01"]})`,
      2: `var(--avatar-02, ${x["avatar-02"]})`,
      3: `var(--avatar-03, ${x["avatar-03"]})`,
      4: `var(--avatar-04, ${x["avatar-04"]})`,
      5: `var(--avatar-05, ${x["avatar-05"]})`,
      6: `var(--avatar-06, ${x["avatar-06"]})`
    },
    overlay: {
      primary: `var(--overlay, ${x.overlay})`
    },
    text: {
      disabled: `var(--text-disabled, ${x["text-disabled"]})`
    },
    brand: {
      "ia-green": `var(--brand-ia-green, ${x["brand-ia-green"]})`,
      "ia-green-shade": `var(--brand-ia-green-shade, ${x["brand-ia-green-shade"]})`,
      "ia-gray": `var(--brand-ia-gray, ${x["brand-ia-gray"]})`,
      "ia-gray-shade-1": `var(--brand-ia-gray-shade-1, ${x["brand-ia-gray-shade-1"]})`,
      "ia-gray-shade-2": `var(--brand-ia-gray-shade-2, ${x["brand-ia-gray-shade-2"]})`,
      "ia-gray-shade-3": `var(--brand-ia-gray-shade-3, ${x["brand-ia-gray-shade-3"]})`,
      "ia-dark-gray": `var(--brand-ia-dark-gray, ${x["brand-ia-dark-gray"]})`
    }
  },
  namedShadows: {
    "depth-down": `var(--depth-down, ${x["depth-down"]})`,
    "depth-1": `var(--depth-1, ${x["depth-1"]})`,
    "depth-2": `var(--depth-2, ${x["depth-2"]})`,
    "depth-3": `var(--depth-3, ${x["depth-3"]})`
  },
  hover: {
    basic: `var(--basic-hover, ${x["basic-hover"]})`,
    destructive: `var(--basic-hover-destructive, ${x["basic-hover-destructive"]})`,
    fab: `var(--fab-hover, ${x["fab-hover"]})`
  },
  typography: {
    h1Title: {
      color: `var(--brand-ia-gray, ${x["brand-ia-gray"]})`,
      fontSize: "1.5rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "2rem",
      letterSpacing: "normal"
    },
    h1: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "1.125rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "1.5rem",
      letterSpacing: "normal"
    },
    h2: {
      color: `var(--brand-ia-gray, ${x["brand-ia-gray"]})`,
      fontSize: "1.125rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "1.5rem",
      letterSpacing: "normal"
    },
    h3: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "1rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "1.25rem",
      letterSpacing: "normal"
    },
    h4: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "0.875rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "1.125rem",
      letterSpacing: "normal"
    },
    h5: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "0.75rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "1rem",
      letterSpacing: "normal"
    },
    body1: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "1rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "1.5rem",
      letterSpacing: "normal"
    },
    body2: {
      ...pr,
      fontFamily: "Proxima Nova"
    },
    body3: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "0.75rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "1.125rem"
    },
    body1Link: {
      color: `var(--primary-60-key, ${x["primary-60-key"]})`,
      fontSize: "1rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "1.5rem",
      textDecorationLine: "underline"
    },
    body2Link: {
      color: `var(--primary-60-key, ${x["primary-60-key"]})`,
      fontSize: "0.875rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "1.25rem",
      textDecorationLine: "underline"
    },
    body3Link: {
      color: `var(--primary-60-key, ${x["primary-60-key"]})`,
      fontSize: "0.75rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "1.125rem",
      textDecorationLine: "underline"
    },
    subtitle: ur,
    subtitle1: ur,
    subtitle2: {
      color: `var(--neutral-60, ${x["neutral-60"]})`,
      fontSize: "0.625rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "0.875rem",
      letterSpacing: "normal"
    },
    label: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      leadingTrim: "both",
      textEdge: "cap",
      fontSize: "0.75rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "0.875rem"
    },
    overline: {
      color: `var(--neutral-70, ${x["neutral-70"]})`,
      fontSize: "0.75rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "0.875rem",
      letterSpacing: "0.0375rem",
      textTransform: "uppercase"
    },
    avatarTiny: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "0.5rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "0.5rem",
      letterSpacing: "0.025rem",
      textTransform: "uppercase"
    },
    avatarSmall: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "0.75rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "0.75rem",
      letterSpacing: "0.0375rem",
      textTransform: "uppercase"
    },
    avatarMedium: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "1rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "1rem",
      letterSpacing: "0.05rem",
      textTransform: "uppercase"
    },
    avatarLarge: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "2rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "2rem",
      letterSpacing: "0.1rem",
      textTransform: "uppercase"
    },
    avatarExtraLarge: {
      color: `var(--neutral-80, ${x["neutral-80"]})`,
      fontSize: "2.5rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "2.5rem",
      letterSpacing: "0.1rem",
      textTransform: "uppercase"
    },
    caps: {
      color: `var(--neutral-60, ${x["neutral-60"]})`,
      fontSize: "0.625rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "0.625rem",
      letterSpacing: "0.03125rem",
      textTransform: "uppercase"
    },
    button1: {
      color: `var(--primary-60-key, ${x["primary-60-key"]})`,
      fontSize: "0.875rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "1rem",
      letterSpacing: "normal"
    },
    button1Link: {
      color: `var(--primary-60-key, ${x["primary-60-key"]})`,
      fontSize: "0.875rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "1rem",
      textDecorationLine: "underline",
      letterSpacing: "normal"
    },
    button2: {
      color: `var(--primary-60-key, ${x["primary-60-key"]})`,
      fontSize: "0.75rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "0.75rem",
      letterSpacing: "normal"
    },
    button2Link: {
      color: `var(--primary-60-key, ${x["primary-60-key"]})`,
      fontSize: "0.75rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "0.75rem",
      textDecorationLine: "underline",
      letterSpacing: "normal"
    },
    buttonSmall: {
      fontSize: "0.875rem",
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "1rem",
      letterSpacing: "normal"
    },
    pre: {
      ...pr,
      fontFamily: "Noto Sans Mono",
      whiteSpace: "pre",
      whiteSpaceCollapse: "preserve",
      textWrap: "nowrap",
      "& code": {
        fontFamily: "inherit"
      }
    }
  },
  cssVariables: !0
}, W0 = ({ baseAssetUrl: e }) => [
  {
    "@font-face": {
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: 100,
      src: `url(${e}font/ProximaNova/ProximaNova-100-Thin.ttf) format("truetype")`
    }
  },
  {
    "@font-face": {
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: 300,
      src: `url(${e}font/ProximaNova/ProximaNova-300-Light.ttf) format("truetype")`
    }
  },
  {
    "@font-face": {
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: 400,
      src: `url(${e}font/ProximaNova/ProximaNova-400-Regular.ttf) format("truetype")`
    }
  },
  {
    "@font-face": {
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: 500,
      src: `url(${e}font/ProximaNova/ProximaNova-500-Medium.ttf) format("truetype")`
    }
  },
  {
    "@font-face": {
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: 600,
      src: `url(${e}font/ProximaNova/ProximaNova-600-Semibold.ttf) format("truetype")`
    }
  },
  {
    "@font-face": {
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: 700,
      src: `url(${e}font/ProximaNova/ProximaNova-700-Bold.ttf) format("truetype")`
    }
  },
  {
    "@font-face": {
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: 800,
      src: `url(${e}font/ProximaNova/ProximaNova-800-Extrabold.ttf) format("truetype")`
    }
  },
  {
    "@font-face": {
      fontFamily: "Proxima Nova",
      fontStyle: "normal",
      fontWeight: 900,
      src: `url(${e}font/ProximaNova/ProximaNova-900-Black.ttf) format("truetype")`
    }
  },
  {
    "@font-face": {
      fontFamily: "Noto Sans Mono",
      fontStyle: "normal",
      fontWeight: 400,
      src: `url(${e}font/NotoSansMono/NotoSansMono-Regular.ttf) format("truetype")`
    }
  },
  {
    "html, body": {
      fontFamily: "Proxima Nova, Arial, sans-serif"
    }
  },
  {
    ".os-scrollbar": {
      "--os-handle-bg": "rgba(0, 0, 0, 0.3)",
      "--os-handle-border-radius": "0.5rem",
      "--os-padding-perpendicular": "0.25rem",
      "--os-padding-axis": "0.25rem",
      "--os-size": "1rem",
      "--os-handle-bg-hover": "rgba(0, 0, 0, 0.3)",
      "--os-handle-bg-active": "rgba(0, 0, 0, 0.5)"
    }
  },
  {
    ".os-theme-hidden": {
      "--os-size": "0px"
    }
  },
  {
    "@media(hover: hover) and (pointer: fine)": {
      // See background on this query: https://itnext.io/finally-a-css-only-solution-to-hover-on-touchscreens-c498af39c31c
      body: {
        overscrollBehavior: "none"
      },
      html: {
        overscrollBehavior: "none"
      }
    }
  },
  {
    pre: {
      all: "unset",
      "& code": {
        all: "unset"
      }
    }
  }
], O0 = ta(z0), Z0 = ({
  children: e,
  theme: t = O0,
  baseAssetUrl: n
}) => /* @__PURE__ */ r.jsxs(ra, { theme: t, children: [
  /* @__PURE__ */ r.jsx(na, {}),
  /* @__PURE__ */ r.jsx(oa, { styles: W0({ baseAssetUrl: n }) }),
  e
] }), P0 = 500, q0 = 250, U0 = {
  common: {
    actions: "Actions",
    checkbox_tooltip: "Select",
    radio_tooltip: "Select",
    switch_tooltip: "Select",
    select_date: "Select a Date",
    delete: "Delete",
    download: "Download",
    close: "Close",
    clear: "Clear",
    done: "Done",
    show: "Show",
    hide: "Hide",
    show_contents: "Show contents",
    hide_contents: "Hide contents",
    filter: "Filter",
    all: "All",
    select_all: "Select all",
    clear_all: "Clear all",
    clear_all_filters: "Clear all filters",
    no_results: "No results",
    no_results_match_your_search: "No results match your search.",
    no_data_available_to_filter: "No data available to filter",
    search: "Search",
    date: "Date",
    invalid_date: "Enter a valid date.",
    cancel: "Cancel",
    edit: "Edit",
    save: "Save",
    back: "Back",
    next: "Next",
    start: "Start",
    finish: "Finish",
    skip_step: "Skip step",
    save_and_review: "Save and review",
    print_receipt: "Print Receipt",
    form: {
      error_message: "Failed to update {{key}}",
      exceeds_max_length_error: "Field must be fewer than {{max_chars}} characters",
      required_error: "This field cannot be left blank",
      success_message: "{{key}} updated"
    },
    inputs: {
      optional: "Optional",
      phone: {
        label: "Phone number",
        non_numeric_error: "Phone number must be numeric.",
        not_possible_error: "Enter a valid phone number."
      }
    },
    code_block: {
      label: "Config",
      copy_message: "Code copied",
      code: "Code"
    },
    copy: "Copy",
    copy_message: "{{data}} copied",
    select_a_step: "Select a step"
  }
}, G0 = {
  avatar_upload: {
    // Represents a file the user uploaded.
    uploaded_avatar_alt_text: "Uploaded avatar image",
    // Represents the preview of the avatar the user has uploaded and possibly cropped.
    preview_avatar_alt_text: "Preview of new avatar",
    remove_avatar_description: "Are you sure you want to remove your current profile picture?",
    actions: {
      edit_button_label: "Edit",
      cancel: "Cancel",
      try_again: "Try again",
      crop_photo: "Crop photo",
      back: "Back",
      done: "Done",
      change: "Change",
      remove: "Remove",
      remove_profile_picture: "Remove profile picture"
    },
    headings: {
      uploading: "Uploading your photo",
      error: "Uploading your photo",
      crop: "Crop your photo",
      preview: "Preview your photo",
      edit_existing: "Your photo",
      remove_existing: "Remove profile picture"
    },
    errors: {
      invalid_file_type: "Not a permitted image type",
      file_size_limit: "File must be less than",
      megabyte_abbreviation: "MB",
      uploaded_file_size: "Your file is",
      bytes: "bytes",
      no_file_selected: "No file selected."
    }
  }
}, K0 = {
  data_grid: {
    table_options: "Table options",
    sort_drawer_heading: "Sort by",
    download_dialog: {
      headline: "Download CSV",
      cancel_label: "Cancel",
      content_area_text: (e, t) => `Download the ${e} ${t} shown as a csv file.`,
      download_submit_label: "Download CSV"
    },
    selected_count_suffix: "Selected",
    filter_tooltip: "Filter",
    download_tooltip: "Download",
    download_tooltip_disabled: "No data available to download",
    info_tooltip: "Info",
    clear_selection_tooltip: "Clear selection"
  }
}, Y0 = {
  date_picker: {
    previous_month: "Previous month",
    select_month: "Select month",
    next_month: "Next month",
    previous_year: "Previous year",
    select_year: "Select year",
    next_year: "Next year"
  }
}, Q0 = {
  file_upload: {
    drop_files: "Drop files to upload",
    drop_file: "Drop file to upload",
    uploading: "Uploading",
    retry: "Try again",
    error: "An error occurred",
    choose_files: "choose files",
    choose_file: "choose file",
    choose_new_file: "choose new file",
    drag_files: "Drag files here or",
    drag_file: "Drop file here or",
    replace_file: "Replace file or",
    view: "View",
    download: "Download"
  }
}, X0 = {
  forms: {
    prefix: "Prefix (Optional)",
    street_address_line1: "Street address",
    show_street_address_line2: "Add additional address information (Optional)",
    hide_street_address_line2: "Hide additional address information",
    street_address_line2: "Apt, suite, unit (Optional)",
    suggestions: "Suggestions"
  }
}, J0 = {
  item_drawer: {
    meta_heading: "Meta",
    tag_heading: "Tags",
    tag_helper_message: "Add tags to make this item more searchable. A tag can be a single word with no spaces.",
    tag_validation_errors: {
      invalid_tag: "Invalid tag.",
      tag_already_in_use: "Tag already in use."
    },
    tag_add_button_label: "Add",
    info_tab_label: "Info",
    activity_tab_label: "Activity",
    pinned_heading: "Pinned",
    all_heading: "All",
    no_activity: "No activity",
    no_activity_for_item: "No activity available for this item.",
    no_results: "No results",
    no_results_match_search: "No results match your search.",
    activity_event_filter: "Event",
    activity_people_filter: "People",
    add_note: "Add note",
    activity_items: {
      add_note: "Add note",
      edit_note: "Edit note",
      pin_note: "Pin note",
      unpin_note: "Unpin note",
      pin_event: "Pin event",
      unpin_event: "Unpin event",
      delete_note: "Delete note"
    }
  }
}, ei = {
  errors: {
    request_failed: "We are unable to load your information, please reload the page to try again.",
    general_message: "Sorry! We weren't able to load this page, please reload the page to try again. Still having issues? Visit the help center for more information.",
    reload_page: "Reload page",
    help_center: "Help center"
  },
  unsaved_warning: {
    heading: "Unsaved changes",
    description: "Are you sure you want to discard your changes?",
    dialog_description: "You have unsaved changes, would you like to discard your changes?",
    submit_label: "Discard and close",
    cancel_label: "Keep editing"
  },
  restricted_access: {
    heading: "Restricted access",
    description: "You do not have access to this information."
  }
}, ti = {
  ...U0,
  ...Q0,
  ...ei,
  ...Y0,
  ...G0,
  ...K0,
  ...X0,
  ...J0
}, ri = {
  locale: "en-US",
  translations: ti,
  baseAssetUrl: "https://static-assets.test.inductiveautomation.com/",
  environment: "development",
  showEnvironmentBanner: !0,
  closeEnvironmentBanner: () => {
  }
}, un = nt(ri), Yu = ({
  translations: e,
  locale: t,
  baseAssetUrl: n,
  environment: o,
  children: a
}) => {
  const [i, l] = V(!0);
  return /* @__PURE__ */ r.jsx(
    aa,
    {
      delay: { open: P0 },
      timeoutMs: q0,
      children: /* @__PURE__ */ r.jsx(
        un.Provider,
        {
          value: {
            locale: t,
            translations: e,
            baseAssetUrl: n,
            environment: o,
            showEnvironmentBanner: i,
            closeEnvironmentBanner: () => l(!1)
          },
          children: /* @__PURE__ */ r.jsx(D0, { children: /* @__PURE__ */ r.jsx(Z0, { baseAssetUrl: n, children: a }) })
        }
      )
    }
  );
}, Q = () => $1(un), pn = () => {
  const [e, t] = V();
  return K(() => {
    const n = window.matchMedia("(hover: hover) and (pointer: fine)");
    t(n.matches ? "mouse" : "touch");
  }, []), e;
}, ot = {
  // This hides an element visually but keeps it available for screen readers: https://www.w3.org/WAI/tutorials/forms/labels/#note-on-hiding-elements
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px"
}, Re = (e) => ({
  ...e.typography.subtitle,
  color: e.palette.neutral[70]
}), ni = R()((e) => ({
  root: {
    width: "fit-content",
    maxWidth: "100%"
  },
  avatarContainer: {
    position: "relative",
    display: "block",
    width: "5rem",
    height: "5rem",
    borderRadius: "100%"
  },
  editButton: {
    position: "absolute",
    inset: 0,
    display: "grid",
    placeItems: "center",
    border: 0,
    borderRadius: "100%",
    backgroundColor: `${x["neutral-20"]}F2`,
    boxShadow: e.namedShadows["depth-2"],
    cursor: "pointer"
  },
  editButtonIcon: {
    width: "1.5rem",
    height: "1.5rem"
  },
  editButtonText: {
    ...e.typography.h5
  },
  fileInput: {
    // Opacity is used for accessibility reasons instead of hidin the input entirely.
    // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#sect11
    opacity: 0,
    width: 0,
    height: 0
  },
  editExistingButtonContainer: {
    backgroundColor: "transparent",
    border: 0,
    padding: 0
  },
  visuallyHidden: ot
})), S2 = R()((e) => ({
  root: {
    paddingTop: "0.3125rem",
    paddingBottom: "0.3125rem",
    [e.breakpoints.down(600)]: {
      paddingTop: "0.625rem",
      paddingBottom: "0.625rem"
    }
  },
  centered: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    gap: "2rem"
  },
  preview: {
    width: "20rem",
    height: "20rem",
    borderRadius: "100%",
    overflow: "hidden",
    objectFit: "contain"
  },
  text: {
    textAlign: "center"
  },
  removeAvatar: {
    width: "20rem",
    height: "20rem",
    fontSize: "8rem",
    lineHeight: "2rem",
    fontWeight: 500,
    letterSpacing: "5%"
  }
})), oi = R()((e) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    paddingTop: "0.3125rem",
    paddingBottom: "0.3125rem",
    [e.breakpoints.down(600)]: {
      paddingTop: "0.625rem",
      paddingBottom: "0.625rem"
    }
  },
  cropContainer: {
    position: "relative",
    width: "20rem",
    height: "20rem",
    borderRadius: "0.25rem",
    userSelect: "none",
    overflow: "hidden",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "contain"
    }
  },
  cropBox: {
    position: "absolute",
    inset: 0,
    border: `1px dashed ${e.palette.neutral.white}`
  },
  imageOverlay: {
    position: "absolute",
    inset: 0,
    backgroundColor: e.palette.overlay.primary
  },
  maskedImage: {
    position: "absolute",
    inset: 0,
    backgroundColor: e.palette.neutral.white,
    mask: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewbox='0 0 20 20'%3E%3Ccircle cx='10' cy='10' r='10'/%3E%3C/svg%3E")`,
    maskPosition: "top left",
    maskSize: "100% 100%",
    maskRepeat: "no-repeat",
    overflow: "hidden"
  }
})), ai = (e, t) => [
  {
    testId: "upload-cancel",
    label: e.avatar_upload.actions.cancel,
    type: "cancel",
    onClick: t
  }
], ii = (e, t) => [
  {
    testId: "error-cancel",
    label: e.avatar_upload.actions.cancel,
    type: "cancel",
    onClick: t
  },
  {
    testId: "error-try-again",
    label: e.avatar_upload.actions.try_again,
    type: "submit",
    onClick: t
  }
], li = (e, t, n) => [
  {
    testId: "crop-cancel",
    label: e.avatar_upload.actions.back,
    type: "cancel",
    onClick: t
  },
  {
    testId: "crop-submit",
    label: e.avatar_upload.actions.crop_photo,
    type: "submit",
    onClick: n
  }
], si = (e, t, n) => [
  {
    testId: "preview-cancel",
    label: e.avatar_upload.actions.back,
    type: "cancel",
    onClick: t
  },
  {
    testId: "preview-submit",
    label: e.avatar_upload.actions.done,
    type: "submit",
    onClick: n
  }
], ci = (e, t, n) => [
  {
    testId: "edit-existing-change",
    label: e.avatar_upload.actions.change,
    type: "submit",
    onClick: t
  },
  {
    testId: "edit-existing-remove",
    label: e.avatar_upload.actions.remove,
    type: "submit",
    onClick: n
  }
], di = (e, t, n) => [
  {
    testId: "remove-existing-cancel",
    label: e.avatar_upload.actions.back,
    type: "cancel",
    onClick: t
  },
  {
    testId: "remove-existing-submit",
    label: e.avatar_upload.actions.remove_profile_picture,
    type: "submit",
    onClick: n
  }
], ui = {
  none: () => [],
  uploading: ai,
  error: ii,
  crop: li,
  preview: si,
  "edit-existing": ci,
  "remove-existing": di
}, pi = ({
  fileUrl: e,
  fileType: t,
  cropData: n,
  onImageCropped: o
}) => {
  const { translations: a } = Q(), { classes: i } = oi(), l = Z(void 0), c = (d) => {
    const u = d.currentTarget.cropper;
    clearTimeout(l.current), l.current = setTimeout(() => {
      o(
        u.getCroppedCanvas().toDataURL(t ?? "image/jpeg"),
        u.getData()
      );
    }, 200);
  };
  return /* @__PURE__ */ r.jsx("div", { className: i.root, children: /* @__PURE__ */ r.jsx(
    ia,
    {
      src: e,
      data: n.current ?? void 0,
      guides: !1,
      center: !1,
      movable: !1,
      rotatable: !1,
      scalable: !1,
      zoomable: !1,
      zoomOnWheel: !1,
      dragMode: "none",
      toggleDragModeOnDblclick: !1,
      aspectRatio: 1,
      initialAspectRatio: 1,
      viewMode: 1,
      autoCropArea: 1,
      style: {
        width: "20rem",
        height: "20rem"
      },
      alt: a.avatar_upload.uploaded_avatar_alt_text,
      crop: c
    }
  ) });
}, mi = R()(() => ({
  inverse: {
    stroke: x["neutral-white"]
  },
  primary: {
    stroke: x["primary-60-key"]
  }
})), mr = {
  small: "1.5rem",
  large: "3rem"
}, mn = ({
  size: e = "large",
  color: t = "primary",
  className: n = "",
  testId: o,
  ...a
}) => {
  const { cx: i, classes: l } = mi(), c = mr[e] || mr.large, d = l[t] || l.primary, u = {
    primary: x["primary-60-key"],
    inverse: x["neutral-white"]
  };
  return /* @__PURE__ */ r.jsx(jt, { sx: { color: u[t], lineHeight: "0" }, children: /* @__PURE__ */ r.jsx(
    qr,
    {
      "data-testid": o,
      className: i(d, n),
      size: c,
      color: "inherit",
      ...a
    }
  ) });
}, hi = ({ parentTestId: e }) => {
  const { classes: t } = S2();
  return /* @__PURE__ */ r.jsx("div", { className: t.centered, children: /* @__PURE__ */ r.jsx(mn, { testId: `${e}-progress` }) });
}, gi = ({
  parentTestId: e,
  message: t
}) => /* @__PURE__ */ r.jsx(
  Ke,
  {
    id: `${e}-alert`,
    variant: "error",
    description: t,
    closeButtonEventHandler: () => {
    }
  }
), hr = ({ dataUrl: e }) => {
  const { translations: t } = Q(), { cx: n, classes: o } = S2();
  return /* @__PURE__ */ r.jsx("div", { className: n(o.root, o.centered), children: /* @__PURE__ */ r.jsx(
    "img",
    {
      src: e,
      alt: t.avatar_upload.preview_avatar_alt_text,
      className: o.preview,
      width: "100%",
      height: "100%"
    }
  ) });
}, Ci = ({ dataUrl: e }) => {
  const { translations: t } = Q(), { classes: n } = S2();
  return /* @__PURE__ */ r.jsx("div", { className: n.centered, children: /* @__PURE__ */ r.jsx(
    "img",
    {
      src: e,
      alt: t.avatar_upload.preview_avatar_alt_text,
      className: n.preview,
      width: "100%",
      height: "100%"
    }
  ) });
}, vi = (e, t) => e === "edit-existing" ? t.avatar_upload.headings.edit_existing : e === "remove-existing" ? t.avatar_upload.headings.remove_existing : e === "none" ? "" : t.avatar_upload.headings[e], fi = ({
  testId: e,
  step: t,
  onCancel: n,
  onNext: o,
  onClose: a,
  fileUrl: i,
  fileType: l,
  errorMessage: c
}) => {
  const { translations: d } = Q(), [u, p] = V(), m = Z(void 0), g = Ve(), h = $e(g.breakpoints.down(600));
  K(() => {
    (t === "none" || t === "uploading") && (m.current = void 0);
  }, [t]);
  const C = vi(t, d), v = ui[t](
    d,
    n,
    () => o(u)
  ), b = ["crop", "preview", "edit-existing", "remove-existing"].includes(t) && h;
  return /* @__PURE__ */ r.jsx(
    Q2,
    {
      testId: e,
      maintainHeight: b,
      isOpen: t !== "none",
      headline: C,
      collapseContentScrollGutter: !0,
      supportingText: t === "remove-existing" ? d.avatar_upload.remove_avatar_description : void 0,
      contentArea: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        t === "uploading" ? /* @__PURE__ */ r.jsx(hi, { parentTestId: e }) : null,
        t === "error" && c ? /* @__PURE__ */ r.jsx(gi, { parentTestId: e, message: c }) : null,
        t === "crop" && i ? /* @__PURE__ */ r.jsx(
          pi,
          {
            fileUrl: i,
            fileType: l,
            cropData: m,
            onImageCropped: (f, y) => {
              p(f), m.current = y;
            }
          }
        ) : null,
        t === "preview" ? /* @__PURE__ */ r.jsx(hr, { dataUrl: u }) : null,
        t === "edit-existing" ? /* @__PURE__ */ r.jsx(hr, { dataUrl: i }) : null,
        t === "remove-existing" ? /* @__PURE__ */ r.jsx(Ci, { dataUrl: i }) : null
      ] }),
      actions: v,
      onClose: a,
      showCloseButton: !0
    }
  );
}, hn = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp"
], xi = [
  "image/jpeg",
  "image/png",
  "image/gif"
  // Safari does not support conversion to image/webp as of 6/5/25
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toDataURL#browser_compatibility
], gn = 5242880, bi = (e) => hn.includes(e.type), wi = (e) => e.size < gn, yi = (e) => (t) => e.avatar_upload.errors[t], ki = (e, t) => {
  const n = yi(t);
  if (!bi(e))
    return `${n("invalid_file_type")}: ${e.type}`;
  if (!wi(e))
    return `${n("file_size_limit")} ${gr(gn)}${n("megabyte_abbreviation")}. ${n("uploaded_file_size")} ${gr(e.size)}${n("megabyte_abbreviation")}`;
}, gr = (e) => {
  const t = e / 1024 / 1024;
  return Math.round(t * 100) / 100;
}, ji = (e, t) => {
  if (e && e.length > 0 && e[0]) {
    const n = e[0], o = ki(n, t);
    return o ? {
      success: !1,
      error: o
    } : {
      success: !0,
      value: [URL.createObjectURL(n), n.type]
    };
  }
  return {
    success: !1,
    error: t.avatar_upload.errors.no_file_selected
  };
}, Si = ({
  testId: e,
  defaultAvatarProps: t,
  url: n,
  onImageSelected: o,
  onImageUploaded: a,
  onImageRemoval: i
}) => {
  const { translations: l } = Q(), { cx: c, classes: d } = ni(), [u, p] = V(!1), [m, g] = V(), [h, C] = V(), v = Z(null), b = pn(), [f, y] = V(), [w, k] = V("none");
  K(() => {
    g(n);
  }, [n]);
  const M = (_) => {
    const B = ji(_.currentTarget.files, l);
    if (B.success) {
      const [O, A] = B.value;
      g(O), C(
        xi.includes(A) ? A : "image/jpeg"
      ), k("uploading"), o(O, () => k("crop"));
    } else
      y(B.error), k("error");
    _.currentTarget.value = "", p(!1);
  }, L = () => {
    k("edit-existing"), p(!1);
  }, j = () => {
    var _;
    ["uploading", "error"].includes(w) ? (k("none"), p(!1)) : w === "preview" ? k("crop") : ["crop", "edit-existing"].includes(w) ? (_ = v.current) == null || _.click() : w === "remove-existing" && k("edit-existing");
  }, N = (_) => {
    w === "uploading" ? k("crop") : w === "crop" ? k("preview") : w === "preview" ? (_ && a(_), k("none"), p(!1)) : w === "edit-existing" ? k("remove-existing") : w === "remove-existing" && (i(), k("none"), p(!1));
  }, E = {
    size: "large",
    bottomBadgeProps: u ? void 0 : {
      size: "large",
      icon: "edit-outlined"
    }
  }, $ = {
    "data-testid": e,
    className: c(d.avatarContainer, d.editExistingButtonContainer)
  }, S = ({ children: _ }) => n ? /* @__PURE__ */ r.jsx("button", { ...$, onClick: L, children: _ }) : /* @__PURE__ */ r.jsx("label", { ...$, htmlFor: "avatar-upload-file", children: _ });
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: d.root,
      ...b === "mouse" ? {
        onMouseEnter: () => p(!0),
        onMouseLeave: () => p(!1)
      } : {},
      children: [
        /* @__PURE__ */ r.jsxs(S, { children: [
          n ? /* @__PURE__ */ r.jsx(we, { ...E, variant: "image", imageUrl: n }) : /* @__PURE__ */ r.jsx(we, { ...E, variant: "text", ...t }),
          u ? /* @__PURE__ */ r.jsx("div", { className: d.editButton, children: /* @__PURE__ */ r.jsxs("div", { children: [
            /* @__PURE__ */ r.jsx(te, { name: "edit-outlined", className: d.editButtonIcon }),
            /* @__PURE__ */ r.jsx(W, { className: d.editButtonText, children: l.avatar_upload.actions.edit_button_label })
          ] }) }) : null
        ] }),
        /* @__PURE__ */ r.jsx("label", { htmlFor: "avatar-upload-file", className: d.visuallyHidden, children: l.file_upload.choose_file }),
        /* @__PURE__ */ r.jsx(
          "input",
          {
            type: "file",
            id: "avatar-upload-file",
            "data-testid": "avatar-upload-file",
            name: "avatar-upload-file",
            ref: v,
            accept: hn.join(),
            onChange: M,
            className: d.fileInput
          }
        ),
        /* @__PURE__ */ r.jsx(
          fi,
          {
            testId: `${e}-dialog`,
            step: w,
            errorMessage: f,
            fileUrl: m ?? n,
            fileType: h,
            onCancel: j,
            onNext: N,
            onClose: () => {
              k("none"), p(!1);
            }
          }
        )
      ]
    }
  );
}, V1 = R()(
  (e, { size: t }) => ({
    base: {
      borderRadius: ".25rem",
      cursor: "pointer",
      boxShadow: "none",
      textTransform: "none",
      "@media print": {
        display: "none"
      }
    },
    sizeMedium: {
      height: "2.5rem",
      padding: ".25rem 1rem",
      minWidth: "fit-content",
      ...e.typography.button1
    },
    sizeSmall: {
      height: "1.5rem",
      padding: "0.375rem 0.5rem",
      minWidth: "fit-content",
      ...e.typography.button2
    },
    primary: {
      color: e.palette.neutral.white,
      backgroundColor: e.palette.primary["60-key"],
      // for consistent sizing between disabled and primary state
      border: `1px solid ${e.palette.primary["60-key"]}`,
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: e.palette.primary["60-key"],
          boxShadow: e.hover.basic
        }
      },
      "&:active": {
        backgroundColor: e.palette.primary[70],
        boxShadow: e.hover.basic
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: "1px",
        boxShadow: e.hover.basic
      },
      "&:disabled": {
        border: `1px solid ${e.palette.neutral[30]}`,
        backgroundColor: e.palette.neutral[20],
        color: e.palette.neutral[50]
      }
    },
    secondary: {
      color: e.palette.primary["60-key"],
      border: `1px solid ${e.palette.primary["60-key"]}`,
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: e.palette.primary[10],
          border: `1px solid ${e.palette.primary["60-key"]}`
        }
      },
      "&:active": {
        backgroundColor: e.palette.primary[20]
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: e.palette.primary[10],
        outlineOffset: "1px"
      },
      "&:disabled": {
        border: `.063rem solid ${e.palette.neutral[30]}`,
        color: e.palette.neutral[50]
      }
    },
    tertiary: {
      color: e.palette.neutral[80],
      border: `1px solid ${e.palette.neutral[40]}`,
      background: e.palette.neutral.white,
      "@media (hover: hover)": {
        "&:hover": {
          border: `1px solid ${e.palette.neutral[40]}`,
          background: e.palette.neutral.white,
          boxShadow: e.namedShadows["depth-1"]
        }
      },
      "&:active": {
        border: `1px solid ${e.palette.neutral[40]}`,
        background: e.palette.neutral[20]
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: e.palette.primary.white,
        outlineOffset: "1px",
        boxShadow: e.namedShadows["depth-1"]
      },
      "&:disabled": {
        border: `.063rem solid ${e.palette.neutral[30]}`,
        backgroundColor: e.palette.neutral[20],
        color: e.palette.neutral[50]
      }
    },
    destructive: {
      backgroundColor: e.palette.error["60-key"],
      border: `1px solid ${e.palette.error["60-key"]}`,
      color: e.palette.neutral.white,
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: e.palette.error["60-key"],
          boxShadow: e.hover.destructive
        }
      },
      "&:active": {
        backgroundColor: e.palette.error["60-key"],
        border: `1px solid ${e.palette.error["60-key"]}`,
        boxShadow: e.hover.destructive
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: e.palette.error["60-key"],
        outlineOffset: "1px",
        boxShadow: e.hover.destructive
      },
      "&:disabled": {
        border: `.063rem solid ${e.palette.neutral[30]}`,
        backgroundColor: e.palette.neutral[20],
        color: e.palette.neutral[50]
      }
    },
    text: {
      border: "none",
      textDecoration: "none",
      minWidth: "fit-content",
      height: "fit-content",
      padding: t === "small" ? "0.25rem 0.125rem 0.25rem 0.125rem" : 0,
      lineHeight: "inherit",
      verticalAlign: "inherit",
      "@media (hover: hover)": {
        "&:hover": {
          border: "none",
          textDecoration: "underline"
        }
      },
      "&:active": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: t === "small" ? 0 : "2px",
        textDecoration: "underline"
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: t === "small" ? 0 : "2px"
      },
      "&:disabled": {
        border: "none",
        color: e.palette.neutral[50]
      },
      "& .MuiButton-endIcon": {
        marginLeft: 0,
        marginRight: 0,
        width: "1rem",
        height: "1rem",
        svg: {
          width: "100%",
          height: "100%"
        }
      }
    },
    textSecondary: {
      color: e.palette.neutral[60],
      border: "none",
      textDecoration: "none",
      minWidth: "fit-content",
      height: "fit-content",
      padding: "0px",
      "@media (hover: hover)": {
        "&:hover": {
          border: "none",
          textDecoration: "underline"
        }
      },
      "&:active": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: "1px",
        textDecoration: "underline"
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        border: "none",
        backgroundColor: e.palette.neutral[20],
        color: e.palette.neutral[50]
      }
    },
    menuPrimary: {
      ...e.typography.button1,
      padding: ".25rem .5rem .25rem 1rem",
      background: e.palette.primary["60-key"],
      color: e.palette.neutral.white,
      // for consistent sizing between disabled and primary state
      border: `1px solid ${e.palette.primary["60-key"]}`,
      "> span": {
        marginRight: "0px",
        marginLeft: "4px",
        "> svg.MuiSvgIcon-root": {
          fontSize: "24px"
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          background: e.palette.primary["60-key"],
          boxShadow: e.hover.basic
        }
      },
      "&:active": {
        background: e.palette.primary[70],
        boxShadow: e.hover.basic
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        background: e.palette.primary["60-key"],
        outlineOffset: "1px",
        boxShadow: e.hover.basic
      },
      "&:disabled": {
        border: `1px solid ${e.palette.neutral[30]}`,
        backgroundColor: e.palette.neutral[20],
        color: e.palette.neutral[50]
      }
    },
    menuSecondary: {
      ...e.typography.button1,
      padding: ".25rem .5rem .25rem 1rem",
      border: `1px solid ${e.palette.primary["60-key"]}`,
      "> span": {
        marginRight: "0px",
        marginLeft: "4px",
        "> svg.MuiSvgIcon-root": {
          fontSize: "24px"
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          background: e.palette.primary[10]
        }
      },
      "&:active": {
        background: e.palette.primary[20]
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        background: e.palette.primary[10],
        outlineOffset: "1px"
      },
      "&:disabled": {
        border: `1px solid ${e.palette.neutral[30]}`,
        backgroundColor: e.palette.neutral.white,
        color: e.palette.neutral[50]
      }
    },
    menuTertiary: {
      ...e.typography.button1,
      padding: ".25rem .5rem .25rem 1rem",
      background: e.palette.neutral.white,
      border: `1px solid ${e.palette.neutral[40]}`,
      color: e.palette.neutral[80],
      "> span": {
        marginRight: "0px",
        marginLeft: "4px",
        "> svg.MuiSvgIcon-root": {
          fontSize: "24px"
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          boxShadow: e.namedShadows["depth-1"]
        }
      },
      "&:active": {
        background: e.palette.neutral[20]
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        background: e.palette.neutral.white,
        outlineOffset: "1px",
        boxShadow: e.namedShadows["depth-1"]
      },
      "&:disabled": {
        border: `1px solid ${e.palette.neutral[30]}`,
        backgroundColor: e.palette.neutral[20],
        color: e.palette.neutral[50]
      }
    },
    menuText: {
      ...e.typography.button1,
      border: "1px solid transparent",
      padding: ".25rem .5rem .25rem 1rem",
      color: e.palette.neutral[80],
      "> span": {
        marginRight: "0px",
        marginLeft: "4px",
        "> svg.MuiSvgIcon-root": {
          fontSize: "24px"
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          border: `1px solid ${e.palette.neutral[40]}`,
          background: e.palette.neutral.white,
          boxShadow: e.namedShadows["depth-1"]
        }
      },
      "&:active": {
        border: `1px solid ${e.palette.neutral[40]}`,
        background: e.palette.neutral[20]
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: "1px",
        boxShadow: e.namedShadows["depth-1"],
        border: `1px solid ${e.palette.neutral[40]}`
      },
      "&:disabled": {
        border: `1px solid ${e.palette.neutral[30]}`,
        backgroundColor: e.palette.neutral[20],
        color: e.palette.neutral[50]
      }
    },
    menuTextBorderless: {
      ...e.typography.button1,
      padding: ".25rem .5rem .25rem 1rem",
      color: e.palette.neutral[80],
      "> span": {
        marginRight: "0px",
        marginLeft: "4px",
        "> svg.MuiSvgIcon-root": {
          fontSize: "24px"
        }
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        borderRadius: "0.75rem",
        outlineOffset: "-0.375rem"
      },
      "&:disabled": {
        color: e.palette.neutral[50],
        "> span > svg": {
          fill: e.palette.neutral[50]
        }
      }
    },
    smallMenuTextBorderless: {
      padding: "0.375rem 0.5rem",
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        borderRadius: "0.375rem",
        outlineOffset: "0rem"
      }
    },
    menuChevronIcon: {
      // NOTE: (2024-11-04) Noah Settersten => This adjustment allows our icon to match the position of the
      // previously-used MUI "ExpandMore" icon.
      position: "relative",
      top: "-1px"
    },
    fab: {
      ...e.typography.button1,
      textTransform: "none",
      backgroundColor: e.palette.primary["60-key"],
      color: e.palette.neutral[10],
      padding: "0.5rem 1.125rem 0.5rem 0.625rem",
      borderRadius: "1.5rem",
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: e.palette.primary["60-key"],
          boxShadow: e.hover.fab
        }
      },
      "&:active": {
        backgroundColor: e.palette.primary[70],
        boxShadow: e.hover.fab
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: "1px",
        boxShadow: e.hover.fab
      },
      "> span": {
        marginLeft: "0px"
      }
    },
    fabSecondary: {
      ...e.typography.button1,
      textTransform: "none",
      backgroundColor: e.palette.neutral.white,
      color: e.palette.neutral[80],
      padding: "0.5rem 1.125rem 0.5rem 0.625rem",
      borderRadius: "1.5rem",
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: e.palette.neutral.white,
          boxShadow: e.namedShadows["depth-2"]
        }
      },
      "&:active": {
        backgroundColor: e.palette.neutral.white,
        boxShadow: e.namedShadows["depth-2"]
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: "1px",
        boxShadow: e.namedShadows["depth-2"]
      },
      "> span": {
        marginLeft: "0px"
      }
    },
    fabWithoutContent: {
      minWidth: "unset",
      paddingRight: "0.625rem",
      "> span": {
        marginRight: 0
      }
    },
    basicText: {
      color: e.palette.primary["60-key"],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: e.palette.neutral[20]
        }
      },
      "&:active": {
        backgroundColor: e.palette.neutral[30]
      },
      "&:focus-visible": {
        border: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: e.palette.neutral[20]
      },
      "&:disabled": {
        color: e.palette.neutral[50]
      }
    },
    icon: {
      height: "2.25rem",
      width: "2.25rem",
      padding: "0px",
      // NOTE: (2024-11-04) Noah Settersten => Override the pointer event disabling for buttons within read-only text
      // fields.
      pointerEvents: "all"
    },
    // alpha % values to add to end of hex values
    // https://stackoverflow.com/a/8254129
    iconNeutral: {
      color: e.palette.neutral[80],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["neutral-80"]}0C`
        }
      },
      "&:active": {
        backgroundColor: `${x["neutral-80"]}19`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: `${x["neutral-80"]}0C`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.neutral[80],
        opacity: "0.4"
      }
    },
    iconNeutralSelected: {
      backgroundColor: `${x["neutral-80"]}0C`
    },
    iconNeutralLight: {
      color: e.palette.neutral[50],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["neutral-80"]}0C`
        }
      },
      "&:active": {
        backgroundColor: `${x["neutral-80"]}19`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: `${x["neutral-80"]}0C`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.neutral[50],
        opacity: "0.4"
      }
    },
    iconNeutralLightSelected: {
      backgroundColor: `${x["neutral-80"]}0C`
    },
    iconDocumentation: {
      color: e.palette.neutral[80],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["neutral-80"]}0C`
        }
      },
      "&:active": {
        backgroundColor: `${x["neutral-80"]}19`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: `${x["neutral-80"]}0C`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.neutral[80],
        opacity: "0.4"
      }
    },
    iconDocumentationSelected: {
      backgroundColor: `${x["neutral-80"]}0C`
    },
    iconDocumentationLight: {
      color: e.palette.neutral[50],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["neutral-80"]}0C`
        }
      },
      "&:active": {
        backgroundColor: `${x["neutral-80"]}19`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: `${x["neutral-80"]}0C`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.neutral[50],
        opacity: "0.4"
      }
    },
    iconDocumentationLightSelected: {
      backgroundColor: `${x["neutral-80"]}0C`
    },
    iconPrimary: {
      color: e.palette.primary["60-key"],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["primary-60-key"]}0C`
        }
      },
      "&:active": {
        backgroundColor: `${x["primary-60-key"]}19`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: `${x["primary-60-key"]}0C`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.primary["60-key"],
        opacity: "0.4"
      }
    },
    iconPrimarySelected: {
      backgroundColor: `${x["primary-60-key"]}0C`
    },
    iconInfo: {
      color: e.palette.info["60-key"],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["information-60-10"]}`
        }
      },
      "&:active": {
        backgroundColor: `${x["information-60-15"]}`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: `${x["information-60-10"]}`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.info["60-key"],
        opacity: "0.4"
      }
    },
    iconInfoSelected: {
      backgroundColor: `${x["information-60-10"]}`
    },
    iconSuccess: {
      color: e.palette.success["60-key"],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["success-60-10"]}`
        }
      },
      "&:active": {
        backgroundColor: `${x["success-60-15"]}`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: `${x["success-60-10"]}`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.success["60-key"],
        opacity: "0.4"
      }
    },
    iconSuccessSelected: {
      backgroundColor: `${x["success-60-10"]}`
    },
    iconWarning: {
      color: e.palette.warning["60-key"],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["warning-60-10"]}`
        }
      },
      "&:active": {
        backgroundColor: `${x["warning-60-15"]}`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        backgroundColor: `${x["warning-60-10"]}`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.warning["60-key"],
        opacity: "0.4"
      }
    },
    iconWarningSelected: {
      backgroundColor: `${x["warning-60-10"]}`
    },
    iconDestructive: {
      color: e.palette.error["60-key"],
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["error-60-10"]} !important`
        }
      },
      "&:active": {
        backgroundColor: `${x["error-60-15"]} !important`
      },
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]} !important`,
        backgroundColor: `${x["error-60-10"]} !important`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        color: e.palette.error["60-key"],
        opacity: "0.4"
      }
    },
    iconDestructiveSelected: {
      backgroundColor: `${x["error-60-10"]} !important`
    },
    iconInverse: {
      color: e.palette.neutral.white,
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: `${x["neutral-white"]}19`
        }
      },
      "&:active": {
        backgroundColor: `${x["neutral-white"]}26`
      },
      "&:focus-visible": {
        backgroundColor: `${x["neutral-white"]}19`,
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: "1px"
      },
      "&:disabled": {
        opacity: "0.4",
        color: e.palette.neutral.white
      }
    },
    iconInverseSelected: {
      backgroundColor: `${x["neutral-white"]}19`,
      color: e.palette.neutral.white
    },
    iconSmall: {
      height: "24px",
      width: "24px",
      "> svg": {
        height: "16px",
        width: "16px"
      }
    }
  })
), Li = X.create(() => ({
  root: {
    position: "fixed",
    bottom: "1.5rem",
    right: "1.5rem",
    zIndex: 10,
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem"
  }
})), Mi = ({
  testid: e,
  finalTabIndex: t,
  buttonVariant: n,
  size: o = "medium",
  disabled: a,
  isReadOnly: i,
  onClick: l,
  label: c,
  children: d,
  additionalClassName: u,
  listItems: p,
  ...m
}) => {
  const { classes: g, cx: h } = V1({ size: o }), C = Z(null), [v, b] = V(null);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      Q1,
      {
        ref: C,
        ...m,
        tabIndex: t,
        "data-testid": e,
        className: h(
          g.base,
          o === "medium" ? g.sizeMedium : g.sizeSmall,
          g[n],
          u,
          {
            [g.smallMenuTextBorderless]: n === "menuTextBorderless" && o === "small"
          }
        ),
        disabled: a,
        disableRipple: !0,
        onClick: (f) => {
          l == null || l(f), b(C.current);
        },
        endIcon: i ? /* @__PURE__ */ r.jsx("span", { style: { marginLeft: "4px" } }) : o === "medium" ? /* @__PURE__ */ r.jsx(
          te,
          {
            name: "chevron-thick",
            className: g.menuChevronIcon
          }
        ) : /* @__PURE__ */ r.jsx(te, { name: "caret" }),
        children: c ?? d
      }
    ),
    p.length > 0 ? /* @__PURE__ */ r.jsx(ze, { anchor: v, onClose: () => b(null), children: /* @__PURE__ */ r.jsx(
      Ie,
      {
        lists: p.map((f) => ({
          items: f,
          itemComponent: Se,
          onSelection: ({ id: y, value: w }) => {
            var M;
            const k = f.find((L) => L.id === y);
            (M = k == null ? void 0 : k.onSelection) == null || M.call(k, { id: y, value: w }), b(null);
          }
        }))
      }
    ) }) : null
  ] });
}, G = ({
  buttonVariant: e,
  label: t,
  disabled: n,
  isReadOnly: o,
  tabIndex: a,
  href: i,
  onClick: l,
  size: c = "medium",
  icon: d = "placeholder",
  iconVariant: u = "warning",
  testId: p,
  className: m = "",
  children: g,
  ...h
}) => {
  const C = o ? -1 : a ?? void 0, { classes: v, cx: b } = V1({ size: c }), f = p ?? `${e}-${t}`, y = (!t || t.length === 0) && (g !== void 0 || g !== null);
  if (e === "icon" || e === "avatar") {
    const w = h.selected ?? !1;
    return /* @__PURE__ */ r.jsx(
      la,
      {
        "aria-label": t,
        ...h,
        tabIndex: C,
        "data-testid": f,
        className: b(
          v.icon,
          v[`icon${Qe(u)}`],
          m,
          {
            [v.iconSmall]: c === "small",
            [v[`icon${Qe(u)}Selected`]]: w
          }
        ),
        disableRipple: !0,
        disabled: n,
        onClick: l,
        children: e === "icon" ? /* @__PURE__ */ r.jsx(te, { name: d }) : g
      }
    );
  }
  return e === "fab" || e === "fabSecondary" ? /* @__PURE__ */ r.jsx(
    Q1,
    {
      ...h,
      tabIndex: C,
      "data-testid": f,
      className: b(
        v[e],
        { [v.fabWithoutContent]: y },
        m
      ),
      startIcon: /* @__PURE__ */ r.jsx(te, { name: d }),
      disableRipple: !0,
      onClick: l,
      children: t ?? g
    }
  ) : e === "menuPrimary" || e === "menuSecondary" || e === "menuTertiary" || e === "menuText" || e === "menuTextBorderless" ? /* @__PURE__ */ r.jsx(
    Mi,
    {
      testid: f,
      finalTabIndex: C,
      buttonVariant: e,
      size: c,
      disabled: n,
      isReadOnly: o,
      onClick: l,
      additionalClassName: m,
      label: t,
      children: g,
      listItems: [],
      ...h
    }
  ) : /* @__PURE__ */ r.jsx(
    Q1,
    {
      ...h,
      tabIndex: C,
      "data-testid": f,
      className: b(
        v.base,
        c === "medium" ? v.sizeMedium : v.sizeSmall,
        v[e],
        m
      ),
      disabled: n,
      disableRipple: !0,
      href: i || void 0,
      onClick: l,
      children: t ?? g
    }
  );
}, Ei = R()((e) => ({
  buttonSmall: {
    ...e.typography.buttonSmall,
    height: "2rem",
    padding: "0.75rem",
    minWidth: "fit-content"
  }
})), St = ({
  buttonVariant: e,
  label: t,
  disabled: n,
  tabIndex: o,
  href: a,
  onClick: i,
  testId: l,
  className: c = "",
  children: d,
  ...u
}) => {
  const p = o ?? void 0, { classes: m, cx: g } = V1({ size: "medium" }), { classes: h } = Ei(), C = l ?? `${e}-small-${t}`;
  return /* @__PURE__ */ r.jsx(
    Q1,
    {
      ...u,
      tabIndex: p,
      "data-testid": C,
      className: g(
        m.base,
        m[e],
        h.buttonSmall,
        c
      ),
      disabled: n,
      disableRipple: !0,
      href: a || void 0,
      onClick: i,
      children: t ?? d
    }
  );
}, Cr = ({
  label: e,
  icon: t,
  children: n,
  secondary: o = !1,
  additionalButtons: a,
  containerClassName: i,
  ...l
}) => {
  const { cx: c, classes: d } = Li();
  return /* @__PURE__ */ r.jsxs("div", { className: c(d.root, i), children: [
    /* @__PURE__ */ r.jsx(
      G,
      {
        buttonVariant: o ? "fabSecondary" : "fab",
        icon: t,
        label: e,
        ...l,
        children: n
      }
    ),
    a
  ] });
}, Ni = R()((e, { checked: t, disabled: n }) => ({
  checkbox: {
    alignSelf: "baseline",
    "&:hover": {
      backgroundColor: n ? "" : `${x["neutral-80"]}0C`
    },
    "&:hover span": {
      border: !t && !n ? `2px solid ${e.palette.neutral[40]}` : ""
    },
    "&:has(input:active)": {
      backgroundColor: n ? "" : `${x["neutral-80"]}19`
    },
    "&:has(input:active) span": {
      border: !t && !n ? `2px solid ${e.palette.neutral[50]}` : ""
    },
    "&:has(input:focus-visible)": {
      backgroundColor: `${x["neutral-80"]}0C`,
      outline: `1px solid ${e.palette.primary["60-key"]}`
    },
    "&has(input:focus-visible) span": {
      border: !t && !n ? `2px solid ${e.palette.neutral[50]}` : ""
    },
    "& .MuiTouchRipple-root": {
      display: "none"
    }
  },
  iconBase: {
    border: `2px solid ${e.palette.neutral[30]}`,
    borderRadius: "4px",
    width: "1.125rem",
    height: "1.125rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: e.palette.neutral.white
  },
  checked: {
    backgroundColor: `${e.palette.primary["60-key"]}`,
    border: "none"
  },
  checkedDisabled: {
    backgroundColor: `${e.palette.neutral[30]}`,
    border: "none"
  },
  uncheckedDisabled: {
    backgroundColor: `${e.palette.neutral[20]}`,
    borderColor: `${e.palette.neutral[30]}`
  },
  checkBoxLabel: {
    display: "inline-flex",
    cursor: n ? "default" : "pointer",
    ...e.typography.body1,
    // styles for activiating focus states on checkbox sibling of this label
    "&:hover .MuiCheckbox-root": {
      backgroundColor: n ? "" : `${x["neutral-80"]}0C`
    },
    "&:hover .MuiCheckbox-root span": {
      border: !t && !n ? `2px solid ${e.palette.neutral[40]}` : ""
    },
    "&:active .MuiCheckbox-root": {
      backgroundColor: n ? "" : `${x["neutral-80"]}19`
    },
    "&:active .MuiCheckbox-root span": {
      border: !t && !n ? `2px solid ${e.palette.neutral[50]}` : ""
    },
    "&:focus-visible": {
      outline: "none"
    },
    "&:focus-visible .MuiCheckbox-root": {
      backgroundColor: `${x["neutral-80"]}0C`,
      outline: `1px solid ${e.palette.primary["60-key"]}`
    },
    "&:focus-visible .MuiCheckbox-root span": {
      border: !t && !n ? `2px solid ${e.palette.neutral[40]}` : ""
    }
  },
  checkBoxLabelTextContainer: {
    marginTop: "0.4rem"
  },
  checkBoxLabelText: {
    ...n && {
      color: `${e.palette.text.disabled} !important`
    }
  }
})), p1 = ({
  id: e,
  disabled: t = !1,
  checked: n,
  label: o,
  labelHidden: a,
  labelClassName: i,
  onValueChange: l,
  type: c = "check",
  className: d = "",
  testId: u,
  ...p
}) => {
  const { classes: m, cx: g } = Ni({ checked: n, disabled: t }), h = c == "check" ? /* @__PURE__ */ r.jsx(te, { name: "checkbox-check" }) : /* @__PURE__ */ r.jsx(te, { name: "checkbox-dash" }), C = g(m.iconBase, {
    [m.checked]: !t,
    [m.checkedDisabled]: t
  }), v = g(m.iconBase, {
    [m.uncheckedDisabled]: t
  }), b = /* @__PURE__ */ r.jsx("span", { className: v }), f = /* @__PURE__ */ r.jsx("span", { className: C, children: h }), y = /* @__PURE__ */ r.jsx(
    sa,
    {
      ...p,
      "data-testid": u,
      checked: n,
      icon: b,
      checkedIcon: f,
      className: m.checkbox,
      inputProps: {
        "aria-label": a ? o : void 0
      },
      "data-label": `${o}-checkbox`,
      disabled: t,
      disableRipple: !0,
      onChange: () => {
        l({ id: e, value: !n });
      }
    }
  );
  return /* @__PURE__ */ r.jsxs("label", { className: g(m.checkBoxLabel, d), children: [
    /* @__PURE__ */ r.jsx(Z2, { parentTestId: u, kind: "checkbox", children: y }),
    a ? null : /* @__PURE__ */ r.jsx("div", { className: m.checkBoxLabelTextContainer, children: /* @__PURE__ */ r.jsx(W, { className: g(m.checkBoxLabelText, i), children: o }) })
  ] });
}, Ii = R()((e, { checked: t, disabled: n }) => ({
  checkboxCardRoot: {
    background: e.palette.neutral.white,
    cursor: "pointer",
    padding: "1.5rem",
    paddingLeft: "1.175rem",
    minWidth: "12.375rem",
    border: `1px solid ${t ? e.palette.neutral[50] : e.palette.neutral[30]}`,
    borderRadius: "0.25rem",
    width: "100%",
    ".MuiTypography-root": {
      marginTop: "-0.16rem",
      paddingLeft: "0.2505rem"
    },
    "&:hover": {
      border: `1px solid ${e.palette.neutral[40]}`
    },
    "&:hover .MuiCheckbox-root": {
      backgroundColor: n ? "" : `${x["neutral-80"]}0C`,
      "> span": {
        border: !t && !n ? `2px solid ${e.palette.neutral[40]}` : ""
      }
    },
    "&:active": {
      border: `1px solid ${e.palette.neutral[50]}`
    },
    "&:active .MuiCheckbox-root": {
      backgroundColor: n ? "" : `${x["neutral-80"]}19`
    },
    "&:active .MuiCheckbox-root > span": {
      border: !t && !n ? `2px solid ${e.palette.neutral[50]}` : ""
    },
    "&:focus-visible": {
      outline: "none"
    },
    "&:focus-visible .MuiCheckbox-root": {
      backgroundColor: `${x["neutral-80"]}0C`,
      outline: `1px solid ${e.palette.primary["60-key"]}`
    }
  },
  checkboxContainer: {
    marginBottom: "-0.6rem"
  },
  checkbox: {
    "& > div > div > div > span": {
      position: "relative",
      top: "-0.325rem"
    }
  },
  disabledCheckboxRoot: {
    border: `1px solid ${e.palette.neutral[30]}`,
    pointerEvents: "none"
  },
  helperMessage: {
    ...Re(e),
    marginTop: "0.25rem",
    marginLeft: "2.825rem"
  },
  description: {
    ...e.typography.body2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginLeft: "2.825rem"
  },
  disabledExtraInfo: {
    opacity: 0.4
  },
  label: {
    ...e.typography.h3,
    marginLeft: "0.325rem",
    paddingBottom: "0.75rem",
    color: n ? e.palette.text.disabled : e.palette.neutral[80]
  }
})), $i = ({
  id: e,
  label: t,
  checked: n = !1,
  disabled: o = !1,
  type: a = "check",
  description: i,
  helperMessage: l,
  onValueChange: c,
  testId: d = e,
  ...u
}) => {
  const { cx: p, classes: m } = Ii({ checked: n, disabled: o });
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: p(m.checkboxCardRoot, {
        [m.disabledCheckboxRoot]: o
      }),
      onClick: (g) => {
        const h = g.target;
        h.tagName === "P" || h.className === "tooltip-container" || (c({ id: e, value: !n }), g.stopPropagation());
      },
      children: [
        /* @__PURE__ */ r.jsx("div", { className: m.checkboxContainer, children: /* @__PURE__ */ e1(
          p1,
          {
            testId: d,
            ...u,
            id: e,
            checked: n,
            label: t,
            labelClassName: m.label,
            disabled: o,
            key: e,
            type: a,
            onValueChange: c,
            className: m.checkbox
          }
        ) }),
        i && /* @__PURE__ */ r.jsx(
          "div",
          {
            className: p(m.description, {
              [m.disabledExtraInfo]: o
            }),
            children: i
          }
        ),
        l && /* @__PURE__ */ r.jsx(
          "div",
          {
            className: p(m.helperMessage, {
              [m.disabledExtraInfo]: o
            }),
            children: l
          }
        )
      ]
    }
  );
}, _i = R()((e, { checked: t, disabled: n }) => ({
  radioLabel: {
    display: "inline-flex",
    cursor: n ? "default" : "pointer",
    alignItems: "start",
    ...e.typography.body1,
    ".MuiTypography-root": {
      paddingTop: "0.4rem"
    },
    ".MuiRadio-root": {
      padding: "0.375rem",
      "circle.emptyIcon": {
        stroke: n ? "" : e.palette.neutral[30]
      }
    },
    "&:hover": {
      ".MuiRadio-root": {
        backgroundColor: n ? "" : `${x["neutral-80"]}0C`
      },
      "circle.emptyIcon": {
        stroke: n ? "" : e.palette.neutral[40]
      }
    },
    "&:has(input:active)": {
      ".MuiRadio-root": {
        backgroundColor: n ? "" : `${x["neutral-80"]}19 !important`
      },
      "circle.emptyIcon": {
        stroke: n ? "" : e.palette.neutral[50]
      }
    },
    "&:has(input:focus-visible)": {
      outline: "none",
      ".MuiRadio-root": {
        backgroundColor: `${x["neutral-80"]}0C`,
        outline: `1px solid ${e.palette.primary["60-key"]}`
      },
      "circle.emptyIcon": {
        stroke: !t && !n ? e.palette.neutral[50] : ""
      }
    },
    "& .MuiTouchRipple-root": {
      display: "none"
    }
  },
  iconBase: {
    border: `2px solid ${e.palette.neutral[30]}`,
    borderRadius: "4px",
    width: "1.125rem",
    height: "1.125rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: e.palette.neutral.white
  },
  checked: {
    backgroundColor: `${e.palette.primary["60-key"]}`,
    border: "none"
  },
  checkedDisabled: {
    backgroundColor: `${e.palette.neutral[30]}`,
    border: "none"
  },
  uncheckedDisabled: {
    backgroundColor: `${e.palette.neutral[20]}`,
    borderColor: `${e.palette.neutral[30]}`
  },
  radioLabelTextContainer: {},
  radioLabelText: {
    ...n && {
      color: `${e.palette.text.disabled} !important`
    }
  }
})), Vi = R()((e, { disabled: t }) => ({
  main: {
    "circle.emptyIcon": {
      stroke: t ? e.palette.neutral[30] : "",
      fill: t ? e.palette.neutral[20] : ""
    },
    "circle.filledIcon": {
      fill: t ? e.palette.neutral[30] : ""
    }
  }
})), Ai = /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r.jsx(
      "circle",
      {
        className: "emptyIcon",
        cx: "12",
        cy: "12",
        r: "9",
        fill: "white",
        stroke: "#D8D8D8",
        strokeWidth: "2"
      }
    )
  }
), Bi = /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r.jsx("circle", { className: "filledIcon", cx: "12", cy: "12", r: "10", fill: "#4A90AD" }),
      /* @__PURE__ */ r.jsx("circle", { cx: "12", cy: "12", r: "4", fill: "white" })
    ]
  }
), Hi = ({
  value: e,
  disabled: t,
  checked: n,
  onChange: o,
  testId: a,
  ariaLabel: i
}) => {
  const { classes: l } = Vi({ disabled: t, checked: n });
  return /* @__PURE__ */ r.jsx(
    ca,
    {
      "data-testid": a,
      inputProps: {
        "aria-label": i
      },
      icon: Ai,
      checkedIcon: Bi,
      checked: n,
      className: l.main,
      disabled: t,
      disableRipple: !0,
      onChange: () => o(e)
    }
  );
}, at = ({
  label: e,
  labelHidden: t,
  labelClassName: n,
  value: o,
  disabled: a = !1,
  checked: i = !1,
  onValueChange: l,
  testId: c,
  className: d = ""
}) => {
  const { cx: u, classes: p } = _i({ disabled: a, checked: i }), m = /* @__PURE__ */ r.jsx(
    Hi,
    {
      testId: c,
      value: o,
      ariaLabel: t ? e : void 0,
      disabled: a,
      checked: i,
      onChange: l
    }
  );
  return /* @__PURE__ */ r.jsxs("label", { className: u(p.radioLabel, d), children: [
    /* @__PURE__ */ r.jsx(Z2, { parentTestId: c, kind: "radio", children: m }),
    t ? null : /* @__PURE__ */ r.jsx("div", { className: p.radioLabelTextContainer, children: /* @__PURE__ */ r.jsx(W, { className: u(p.radioLabelText, n), children: e }) })
  ] });
}, Di = R()((e, { checked: t, disabled: n }) => ({
  radioRoot: {
    background: e.palette.neutral.white,
    cursor: "pointer",
    padding: "1.5rem",
    paddingLeft: "1.175rem",
    minWidth: "12.375rem",
    border: `1px solid ${t ? e.palette.neutral[50] : e.palette.neutral[30]}`,
    borderRadius: "0.25rem",
    width: "100%",
    ".MuiTypography-root": {
      marginTop: "-0.16rem",
      paddingLeft: "0.2505rem"
    },
    "&:hover": {
      border: `1px solid ${e.palette.neutral[40]}`
    },
    "&:hover .MuiRadio-root": {
      backgroundColor: n ? "" : `${x["neutral-80"]}0C`,
      "circle.emptyIcon": {
        stroke: n ? "" : e.palette.neutral[40]
      }
    },
    "&:active": {
      border: `1px solid ${e.palette.neutral[50]}`
    },
    "&:active .MuiRadio-root": {
      backgroundColor: n ? "" : `${x["neutral-80"]}19`,
      "circle.emptyIcon": {
        stroke: n ? "" : e.palette.neutral[50]
      }
    },
    "&:active .MuiRadio-root > span": {
      border: !t && !n ? `2px solid ${e.palette.neutral[50]}` : ""
    },
    "&:focus-visible": {
      outline: "none"
    },
    "&:focus-visible .MuiRadio-root": {
      backgroundColor: `${x["neutral-80"]}0C`,
      outline: `1px solid ${e.palette.primary["60-key"]}`
    }
  },
  radioContainer: {
    // margin-bottom of -0.6rem is about right for Firefox, -0.7rem for Safari and Chrome
    marginBottom: "-0.6rem"
  },
  radio: {
    "span:first-of-type": {
      position: "relative",
      top: "-0.325rem"
    }
  },
  disabledRadioRoot: {
    border: `1px solid ${e.palette.neutral[30]}`,
    pointerEvents: "none"
  },
  helperMessage: {
    ...Re(e),
    marginTop: "0.25rem",
    marginLeft: "2.825rem"
  },
  description: {
    ...e.typography.body2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginLeft: "2.825rem"
  },
  disabledExtraInfo: {
    opacity: 0.4
  },
  label: {
    ...e.typography.h3,
    marginLeft: "0.325rem",
    paddingBottom: "0.75rem",
    color: n ? e.palette.text.disabled : e.palette.neutral[80]
  }
})), Ti = ({
  value: e,
  label: t,
  checked: n = !1,
  disabled: o = !1,
  description: a,
  helperMessage: i,
  onValueChange: l,
  testId: c
}) => {
  const { cx: d, classes: u } = Di({ checked: n, disabled: o });
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: d(u.radioRoot, {
        [u.disabledRadioRoot]: o
      }),
      onClick: () => !n && l(e),
      children: [
        /* @__PURE__ */ r.jsx("div", { className: u.radioContainer, children: /* @__PURE__ */ r.jsx(
          at,
          {
            testId: c,
            value: e,
            checked: n,
            label: t,
            labelClassName: u.label,
            disabled: o,
            onValueChange: l,
            className: u.radio
          }
        ) }),
        a && /* @__PURE__ */ r.jsx(
          "div",
          {
            className: d(u.description, {
              [u.disabledExtraInfo]: o
            }),
            children: a
          }
        ),
        i && /* @__PURE__ */ r.jsx(
          "div",
          {
            className: d(u.helperMessage, {
              [u.disabledExtraInfo]: o
            }),
            children: i
          }
        )
      ]
    }
  );
}, Ri = R()(
  (e, { disabled: t }) => ({
    switchContainer: {
      display: "flex"
    },
    switch: {
      position: "relative",
      display: "inline-block",
      width: "40px",
      minWidth: "40px",
      height: "16px",
      input: {
        opacity: "0",
        width: "0",
        height: "0",
        // Show an outline around the `.slider` span when the input is focused.
        ":focus-visible + span:before": {
          outline: `6px solid ${x["neutral-80"]}0C`,
          boxShadow: "0px 5px 5px 6px rgba(0, 0, 0, 0.10)"
        }
      }
    },
    checkedSlider: {
      backgroundColor: t ? e.palette.neutral[30] : e.palette.primary["60-key"],
      transition: "background-color .6s",
      "&:before": {
        left: "20px"
      }
    },
    slider: {
      position: "absolute",
      cursor: "pointer",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      backgroundColor: e.palette.neutral[30],
      borderRadius: "8px",
      pointerEvents: t ? "none" : "auto",
      "&:before": {
        display: "block",
        content: "''",
        height: "24px",
        width: "24px",
        left: "-4px",
        bottom: "4px",
        transition: "left .3s",
        borderRadius: "50%",
        border: `1px solid ${e.palette.neutral[30]}`,
        background: t ? e.palette.neutral[20] : e.palette.neutral.white,
        position: "relative",
        boxShadow: t ? "unset" : e.namedShadows["depth-down"]
      },
      "&:hover:before": {
        outline: `6px solid ${x["neutral-80"]}0C`,
        boxShadow: "0px 5px 5px 6px rgba(0, 0, 0, 0.10)"
      },
      "&:active:before": {
        outline: `6px solid ${x["neutral-80"]}19`,
        boxShadow: "0px 5px 5px 6px rgba(0, 0, 0, 0.10)"
      },
      "&:focus-visible:before": {
        outline: `6px solid ${x["neutral-80"]}0C`,
        boxShadow: "0px 5px 5px 6px rgba(0, 0, 0, 0.10)"
      }
    },
    label: {
      ...e.typography.body1,
      position: "relative",
      top: "-3px",
      marginLeft: "8px",
      color: t ? e.palette.text.disabled : e.palette.neutral[80]
    }
  })
), Fi = ({
  id: e,
  testId: t = e,
  checked: n,
  onChange: o,
  disabled: a = !1,
  label: i,
  labelHidden: l = !1
}) => {
  const { cx: c, classes: d } = Ri({ disabled: a }), u = () => {
    a || (m(!p), o({ id: e, value: !p }));
  }, [p, m] = V(n);
  return K(() => {
    m(n);
  }, [n]), /* @__PURE__ */ r.jsx("div", { className: d.switchContainer, children: /* @__PURE__ */ r.jsxs("label", { children: [
    /* @__PURE__ */ r.jsx(Z2, { parentTestId: t, kind: "switch", children: /* @__PURE__ */ r.jsxs("div", { className: d.switch, children: [
      /* @__PURE__ */ r.jsx(
        "input",
        {
          id: e,
          "data-testid": t,
          "aria-label": l ? i : void 0,
          type: "checkbox",
          checked: p,
          onChange: u
        }
      ),
      /* @__PURE__ */ r.jsx(
        "span",
        {
          id: `${e}-span`,
          "data-testid": `${t}-span`,
          className: c(d.slider, {
            [d.checkedSlider]: p
          })
        }
      )
    ] }) }),
    l ? null : /* @__PURE__ */ r.jsx("span", { className: d.label, children: i })
  ] }) });
}, zi = R()(
  (e, { disabled: t }) => ({
    root: {
      background: e.palette.neutral.white,
      minWidth: "12.375rem",
      padding: "1.5rem",
      paddingTop: "1.9rem",
      border: `1px solid ${e.palette.neutral[30]}`,
      borderRadius: "4px",
      cursor: "pointer",
      "&:hover": {
        borderColor: e.palette.neutral[40],
        "& > div > span > div > label > div > div > div > span:before": {
          outline: `6px solid ${x["neutral-80"]}0C`,
          boxShadow: "0px 5px 5px 6px rgba(0, 0, 0, 0.10)"
        }
      },
      "&:active": {
        borderColor: e.palette.neutral[50],
        "& > div > span > div > label > div > div > div >  span:before": {
          outline: `6px solid ${x["neutral-80"]}19`,
          boxShadow: "0px 5px 5px 6px rgba(0, 0, 0, 0.10)"
        }
      },
      "&:focus-visible": {
        outline: "none",
        borderColor: e.palette.neutral[50],
        "& > div > span > div > label > div > div > div >  span:before": {
          outline: `6px solid ${x["neutral-80"]}0C`,
          boxShadow: "0px 5px 5px 6px rgba(0, 0, 0, 0.10)"
        }
      }
    },
    selectedRoot: {
      border: `1px solid ${e.palette.neutral[50]}`
    },
    disabled: {
      borderColor: e.palette.neutral[30],
      pointerEvents: "none"
    },
    label: {
      ...e.typography.h3,
      marginTop: "-0.1875rem",
      marginRight: "0.5rem",
      paddingBottom: "0.175rem",
      color: t ? e.palette.text.disabled : e.palette.neutral[80]
    },
    description: {
      ...e.typography.body2,
      marginRight: "3rem",
      overflow: "hidden",
      textOverflow: "ellipsis",
      opacity: t ? 0.4 : 1
    },
    helperMessage: {
      ...Re(e),
      opacity: t ? 0.4 : 1,
      marginTop: "0.25rem",
      marginRight: "3rem"
    },
    topContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between"
    }
  })
), Wi = ({
  id: e,
  testId: t = e,
  label: n,
  checked: o = !1,
  disabled: a = !0,
  description: i,
  helperMessage: l,
  onChange: c
}) => {
  const { cx: d, classes: u } = zi({ disabled: a });
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: d(u.root, {
        [u.selectedRoot]: o && !a,
        [u.disabled]: a
      }),
      onClick: () => c({ id: e, value: !o }),
      children: [
        /* @__PURE__ */ r.jsxs("div", { className: u.topContainer, children: [
          /* @__PURE__ */ r.jsx("div", { className: u.label, children: n }),
          /* @__PURE__ */ r.jsx(
            "span",
            {
              onClick: (p) => {
                (p.target.id === e || p.target.id === `${e}-span`) && p.stopPropagation();
              },
              children: /* @__PURE__ */ r.jsx(
                Fi,
                {
                  testId: t,
                  id: e,
                  checked: o,
                  disabled: a,
                  onChange: c,
                  label: n,
                  labelHidden: !0
                }
              )
            }
          )
        ] }),
        !!i && /* @__PURE__ */ r.jsx("div", { className: u.description, children: i }),
        !!l && /* @__PURE__ */ r.jsx("div", { className: u.helperMessage, children: l })
      ]
    }
  );
}, Oi = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.8491 0.543401C18.5468 0.176817 19.325 -0.00995061 20.1132 5.1352e-06C20.9141 -0.0162964 21.706 0.170657 22.4151 0.543401L35.9094 8.30189C36.5795 8.73781 37.138 9.32464 37.5404 10.0153C37.9428 10.706 38.1777 11.4814 38.2264 12.2793V27.7208C38.1777 28.5186 37.9428 29.294 37.5404 29.9847C37.138 30.6754 36.5795 31.2622 35.9094 31.6981L22.4151 39.4566C21.706 39.8294 20.9141 40.0163 20.1132 40C19.325 40.01 18.5468 39.8232 17.8491 39.4566L4.31698 31.6981C3.64696 31.2622 3.08837 30.6754 2.68601 29.9847C2.28365 29.294 2.0487 28.5186 2 27.7208V12.2793C2.0487 11.4814 2.28365 10.706 2.68601 10.0153C3.08837 9.32464 3.64696 8.73781 4.31698 8.30189L17.8491 0.543401ZM28.0929 21.612L29.8097 21.9516C29.9345 21.3204 30 20.6679 30 20C30 19.3321 29.9345 18.6796 29.8097 18.0484L28.0929 18.388C28.1958 18.908 28.25 19.4468 28.25 20C28.25 20.5532 28.1958 21.092 28.0929 21.612ZM26.8615 15.4174L28.3157 14.4438C27.5856 13.3533 26.6467 12.4144 25.5562 11.6843L24.5826 13.1385C25.483 13.7414 26.2586 14.517 26.8615 15.4174ZM21.612 11.9071L21.9516 10.1903C21.3204 10.0655 20.6679 10 20 10C19.3321 10 18.6796 10.0655 18.0484 10.1903L18.388 11.9071C18.908 11.8042 19.4468 11.75 20 11.75C20.5532 11.75 21.092 11.8042 21.612 11.9071ZM15.4174 13.1385L14.4438 11.6843C13.3533 12.4144 12.4144 13.3533 11.6843 14.4438L13.1385 15.4174C13.7414 14.517 14.517 13.7414 15.4174 13.1385ZM10 20C10 19.3321 10.0655 18.6796 10.1903 18.0484L11.9071 18.388C11.8042 18.908 11.75 19.4468 11.75 20C11.75 20.5532 11.8042 21.092 11.9071 21.612L10.1903 21.9516C10.0655 21.3204 10 20.6679 10 20ZM13.1385 24.5826L11.6843 25.5562C12.4144 26.6467 13.3533 27.5856 14.4438 28.3157L15.4174 26.8615C14.517 26.2586 13.7414 25.483 13.1385 24.5826ZM18.388 28.0929L18.0484 29.8097C18.6796 29.9345 19.3321 30 20 30C20.6679 30 21.3204 29.9345 21.9516 29.8097L21.612 28.0929C21.092 28.1958 20.5532 28.25 20 28.25C19.4468 28.25 18.908 28.1958 18.388 28.0929ZM24.5826 26.8615L25.5562 28.3157C26.6467 27.5856 27.5856 26.6467 28.3157 25.5562L26.8615 24.5826C26.2586 25.483 25.483 26.2586 24.5826 26.8615Z", fill: "#7E29A3" })), Zi = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_2591_70845)" }, /* @__PURE__ */ s.createElement("path", { d: "M24.6415 23.3962H15.5849C15.1845 23.3962 14.8006 23.5553 14.5175 23.8383C14.2345 24.1214 14.0754 24.5053 14.0754 24.9057V26.4151C14.0754 26.8154 14.2345 27.1994 14.5175 27.4824C14.8006 27.7655 15.1845 27.9245 15.5849 27.9245H24.6415C25.0418 27.9245 25.4257 27.7655 25.7088 27.4824C25.9919 27.1994 26.1509 26.8154 26.1509 26.4151V24.9057C26.1509 24.5053 25.9919 24.1214 25.7088 23.8383C25.4257 23.5553 25.0418 23.3962 24.6415 23.3962Z", fill: "#4AA99D" }), /* @__PURE__ */ s.createElement("path", { d: "M24.6415 11.3208H15.5849C15.1845 11.3208 14.8006 11.4798 14.5175 11.7629C14.2345 12.046 14.0754 12.4299 14.0754 12.8302V14.3397C14.0754 14.74 14.2345 15.1239 14.5175 15.407C14.8006 15.6901 15.1845 15.8491 15.5849 15.8491H24.6415C25.0418 15.8491 25.4257 15.6901 25.7088 15.407C25.9919 15.1239 26.1509 14.74 26.1509 14.3397V12.8302C26.1509 12.4299 25.9919 12.046 25.7088 11.7629C25.4257 11.4798 25.0418 11.3208 24.6415 11.3208Z", fill: "#4AA99D" }), /* @__PURE__ */ s.createElement("path", { d: "M24.6415 17.3585H15.5849C15.1845 17.3585 14.8006 17.5175 14.5175 17.8006C14.2345 18.0837 14.0754 18.4676 14.0754 18.868V20.3774C14.0754 20.7777 14.2345 21.1616 14.5175 21.4447C14.8006 21.7278 15.1845 21.8868 15.5849 21.8868H24.6415C25.0418 21.8868 25.4257 21.7278 25.7088 21.4447C25.9919 21.1616 26.1509 20.7777 26.1509 20.3774V18.868C26.1509 18.4676 25.9919 18.0837 25.7088 17.8006C25.4257 17.5175 25.0418 17.3585 24.6415 17.3585Z", fill: "#4AA99D" }), /* @__PURE__ */ s.createElement("path", { d: "M35.9094 8.30189L22.4151 0.543401C21.706 0.170657 20.9141 -0.0162964 20.1132 5.1352e-06C19.325 -0.00995061 18.5468 0.176817 17.8491 0.543401L4.31698 8.30189C3.64696 8.73781 3.08837 9.32464 2.68601 10.0153C2.28365 10.706 2.0487 11.4814 2 12.2793L2 27.7208C2.0487 28.5186 2.28365 29.294 2.68601 29.9847C3.08837 30.6754 3.64696 31.2622 4.31698 31.6981L17.8491 39.4566C18.5468 39.8232 19.325 40.01 20.1132 40C20.9141 40.0163 21.706 39.8294 22.4151 39.4566L35.9094 31.6981C36.5795 31.2622 37.138 30.6754 37.5404 29.9847C37.9428 29.294 38.1777 28.5186 38.2264 27.7208V12.2793C38.1777 11.4814 37.9428 10.706 37.5404 10.0153C37.138 9.32464 36.5795 8.73781 35.9094 8.30189ZM27.6604 14.3396C27.658 14.7694 27.5638 15.1937 27.3842 15.5842C27.2046 15.9747 26.9436 16.3223 26.6189 16.6038C26.9436 16.8853 27.2046 17.2329 27.3842 17.6234C27.5638 18.0138 27.658 18.4381 27.6604 18.8679V20.3774C27.658 20.8072 27.5638 21.2315 27.3842 21.6219C27.2046 22.0124 26.9436 22.36 26.6189 22.6415C26.9436 22.923 27.2046 23.2706 27.3842 23.6611C27.5638 24.0516 27.658 24.4759 27.6604 24.9057V26.4151C27.6604 27.2158 27.3423 27.9836 26.7762 28.5498C26.21 29.1159 25.4422 29.434 24.6415 29.434H15.5849C14.7843 29.434 14.0164 29.1159 13.4502 28.5498C12.8841 27.9836 12.566 27.2158 12.566 26.4151V24.9057C12.5685 24.4759 12.6626 24.0516 12.8422 23.6611C13.0219 23.2706 13.2828 22.923 13.6075 22.6415C13.2828 22.36 13.0219 22.0124 12.8422 21.6219C12.6626 21.2315 12.5685 20.8072 12.566 20.3774V18.8679C12.5685 18.4381 12.6626 18.0138 12.8422 17.6234C13.0219 17.2329 13.2828 16.8853 13.6075 16.6038C13.2828 16.3223 13.0219 15.9747 12.8422 15.5842C12.6626 15.1937 12.5685 14.7694 12.566 14.3396V12.8302C12.566 12.0295 12.8841 11.2617 13.4502 10.6955C14.0164 10.1294 14.7843 9.81133 15.5849 9.81133H24.6415C25.4422 9.81133 26.21 10.1294 26.7762 10.6955C27.3423 11.2617 27.6604 12.0295 27.6604 12.8302V14.3396Z", fill: "#4AA99D" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_2591_70845" }, /* @__PURE__ */ s.createElement("rect", { width: 40, height: 40, fill: "white" })))), Pi = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_2591_70740)" }, /* @__PURE__ */ s.createElement("path", { d: "M17.4792 22.166L14.4603 20.3849C14.344 20.3234 14.2145 20.2913 14.083 20.2913C13.9514 20.2913 13.8219 20.3234 13.7056 20.3849L10.6867 22.166C10.5741 22.2328 10.4807 22.3277 10.4159 22.4415C10.3511 22.5553 10.317 22.6841 10.3169 22.815V26.415C10.3156 26.5473 10.3491 26.6776 10.414 26.7928C10.4789 26.908 10.573 27.0042 10.6867 27.0716L13.7056 28.8452C13.8203 28.9115 13.9505 28.9463 14.083 28.9463C14.2154 28.9463 14.3456 28.9115 14.4603 28.8452L17.4792 27.0716C17.593 27.0042 17.687 26.908 17.7519 26.7928C17.8168 26.6776 17.8503 26.5473 17.849 26.415V22.815C17.849 22.6841 17.8149 22.5553 17.75 22.4415C17.6852 22.3277 17.5919 22.2328 17.4792 22.166Z", fill: "#5FA04A" }), /* @__PURE__ */ s.createElement("path", { d: "M23.8868 15.6755V12.0755C23.8881 11.9432 23.8546 11.813 23.7897 11.6977C23.7248 11.5825 23.6307 11.4863 23.517 11.4189L20.4981 9.6453C20.3834 9.57906 20.2532 9.54419 20.1207 9.54419C19.9883 9.54419 19.8581 9.57906 19.7434 9.6453L16.7245 11.4189C16.6079 11.4844 16.5109 11.5797 16.4432 11.6951C16.3756 11.8105 16.3398 11.9418 16.3396 12.0755V15.683C16.3396 15.814 16.3737 15.9427 16.4386 16.0565C16.5034 16.1703 16.5967 16.2653 16.7094 16.3321L19.7283 18.1132C19.843 18.1795 19.9732 18.2143 20.1056 18.2143C20.2381 18.2143 20.3683 18.1795 20.483 18.1132L23.5019 16.3321C23.6184 16.2666 23.7155 16.1712 23.7831 16.0559C23.8508 15.9405 23.8865 15.8092 23.8868 15.6755Z", fill: "#5FA04A" }), /* @__PURE__ */ s.createElement("path", { d: "M35.9094 8.30189L22.4151 0.543401C21.706 0.170657 20.9141 -0.0162964 20.1132 5.1352e-06C19.325 -0.00995061 18.5468 0.176817 17.8491 0.543401L4.31698 8.30189C3.64696 8.73781 3.08837 9.32464 2.68601 10.0153C2.28365 10.706 2.0487 11.4814 2 12.2793L2 27.7208C2.0487 28.5186 2.28365 29.294 2.68601 29.9847C3.08837 30.6754 3.64696 31.2622 4.31698 31.6981L17.8491 39.4566C18.5468 39.8232 19.325 40.01 20.1132 40C20.9141 40.0163 21.706 39.8294 22.4151 39.4566L35.9094 31.6981C36.5795 31.2622 37.138 30.6754 37.5404 29.9847C37.9428 29.294 38.1777 28.5186 38.2264 27.7208V12.2793C38.1777 11.4814 37.9428 10.706 37.5404 10.0153C37.138 9.32464 36.5795 8.73781 35.9094 8.30189ZM19.3585 26.4151C19.359 26.81 19.2561 27.1982 19.0602 27.5411C18.8642 27.884 18.582 28.1697 18.2415 28.3698L15.2226 30.1434C14.8784 30.3421 14.488 30.4467 14.0906 30.4467C13.6931 30.4467 13.3027 30.3421 12.9585 30.1434L9.93962 28.3698C9.59351 28.1735 9.30524 27.8895 9.10384 27.5463C8.90245 27.2032 8.79505 26.813 8.79245 26.4151V22.8151C8.7933 22.4214 8.89676 22.0348 9.09264 21.6933C9.28852 21.3519 9.57004 21.0674 9.90943 20.8679L12.9283 19.0868C13.2737 18.8917 13.6637 18.7892 14.0604 18.7892C14.4571 18.7892 14.847 18.8917 15.1925 19.0868L18.2113 20.8679C18.5563 21.0636 18.8439 21.3464 19.0452 21.6882C19.2465 22.0299 19.3546 22.4185 19.3585 22.8151V26.4151ZM18.966 19.3962L15.9472 17.6151C15.6089 17.4163 15.3281 17.133 15.1322 16.793C14.9364 16.4529 14.8323 16.0679 14.8302 15.6755V12.0755C14.8297 11.6805 14.9326 11.2923 15.1285 10.9494C15.3244 10.6065 15.6067 10.3209 15.9472 10.1208L18.966 8.34718C19.3102 8.14845 19.7007 8.04384 20.0981 8.04384C20.4956 8.04384 20.886 8.14845 21.2302 8.34718L24.2491 10.1208C24.5952 10.317 24.8834 10.6011 25.0848 10.9442C25.2862 11.2874 25.3936 11.6776 25.3962 12.0755V15.683C25.3954 16.0767 25.2919 16.4633 25.096 16.8048C24.9002 17.1462 24.6186 17.4307 24.2792 17.6302L21.2604 19.4113C20.9162 19.61 20.5257 19.7147 20.1283 19.7147C19.7309 19.7147 19.3404 19.61 18.9962 19.4113L18.966 19.3962ZM31.434 26.4151C31.4344 26.81 31.3316 27.1982 31.1356 27.5411C30.9397 27.884 30.6575 28.1697 30.317 28.3698L27.2981 30.1434C26.9539 30.3421 26.5635 30.4467 26.166 30.4467C25.7686 30.4467 25.3782 30.3421 25.034 30.1434L22.0151 28.3698C21.669 28.1735 21.3807 27.8895 21.1793 27.5463C20.9779 27.2032 20.8705 26.813 20.8679 26.4151V22.8151C20.8688 22.4214 20.9722 22.0348 21.1681 21.6933C21.364 21.3519 21.6455 21.0674 21.9849 20.8679L25.0038 19.0868C25.3492 18.8917 25.7391 18.7892 26.1358 18.7892C26.5325 18.7892 26.9225 18.8917 27.2679 19.0868L30.2868 20.8679C30.6318 21.0636 30.9194 21.3464 31.1207 21.6882C31.322 22.0299 31.43 22.4185 31.434 22.8151V26.4151Z", fill: "#5FA04A" }), /* @__PURE__ */ s.createElement("path", { d: "M29.5548 22.166L26.5359 20.3849C26.4196 20.3234 26.2901 20.2913 26.1585 20.2913C26.027 20.2913 25.8975 20.3234 25.7812 20.3849L22.7623 22.166C22.6496 22.2328 22.5563 22.3277 22.4915 22.4415C22.4266 22.5553 22.3925 22.6841 22.3925 22.815V26.415C22.3912 26.5473 22.4247 26.6776 22.4896 26.7928C22.5545 26.908 22.6485 27.0042 22.7623 27.0716L25.7812 28.8452C25.8959 28.9115 26.026 28.9463 26.1585 28.9463C26.291 28.9463 26.4212 28.9115 26.5359 28.8452L29.5548 27.0716C29.6685 27.0042 29.7626 26.908 29.8275 26.7928C29.8924 26.6776 29.9259 26.5473 29.9246 26.415V22.815C29.9245 22.6841 29.8904 22.5553 29.8256 22.4415C29.7608 22.3277 29.6674 22.2328 29.5548 22.166Z", fill: "#5FA04A" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_2591_70740" }, /* @__PURE__ */ s.createElement("rect", { width: 36.2264, height: 40, fill: "white", transform: "translate(2)" })))), qi = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_2591_70872)" }, /* @__PURE__ */ s.createElement("path", { d: "M28.2415 12.634C28.191 12.5485 28.1094 12.4859 28.0137 12.4591C27.9181 12.4324 27.8158 12.4437 27.7283 12.4906L24.7849 14.1887L25.5396 15.4717C25.6298 15.6442 25.6499 15.8449 25.5957 16.0319C25.5415 16.2188 25.4171 16.3776 25.2486 16.475C25.08 16.5724 24.8804 16.6009 24.6913 16.5546C24.5022 16.5083 24.3384 16.3907 24.2339 16.2265L23.4792 14.9434L19.2302 17.3963L20.6868 19.9246L20.7547 20.0076C20.8449 20.1801 20.865 20.3808 20.8108 20.5677C20.7566 20.7547 20.6322 20.9134 20.4637 21.0108C20.2951 21.1083 20.0955 21.1368 19.9064 21.0905C19.7173 21.0442 19.5535 20.9266 19.449 20.7623C19.4332 20.731 19.4205 20.6981 19.4113 20.6642L17.9245 18.151L13.683 20.6038L14.4377 21.9019C14.4923 21.9878 14.529 22.0839 14.5455 22.1843C14.562 22.2848 14.5581 22.3875 14.5338 22.4864C14.5096 22.5852 14.4657 22.6782 14.4046 22.7596C14.3435 22.8411 14.2666 22.9093 14.1785 22.9602C14.0904 23.0112 13.9929 23.0438 13.8918 23.056C13.7908 23.0683 13.6883 23.06 13.5905 23.0317C13.4928 23.0033 13.4018 22.9555 13.323 22.891C13.2442 22.8266 13.1792 22.7468 13.1321 22.6567L12.3773 21.3585L9.4264 23.0567C9.3402 23.1085 9.27772 23.192 9.25233 23.2893C9.22694 23.3867 9.24066 23.4901 9.29055 23.5774L11.1773 26.8453C11.2016 26.8885 11.2342 26.9264 11.2734 26.9567C11.3125 26.987 11.3573 27.0092 11.4052 27.0218C11.4531 27.0345 11.503 27.0374 11.552 27.0305C11.601 27.0235 11.6481 27.0067 11.6905 26.9812L29.9924 16.4151C30.0356 16.3909 30.0735 16.3583 30.1038 16.3191C30.1341 16.28 30.1563 16.2351 30.1689 16.1873C30.1816 16.1394 30.1845 16.0895 30.1776 16.0405C30.1706 15.9915 30.1538 15.9444 30.1283 15.9019L28.2415 12.634Z", fill: "#488FB9" }), /* @__PURE__ */ s.createElement("path", { d: "M35.9094 8.30189L22.4151 0.543401C21.706 0.170657 20.9141 -0.0162964 20.1132 5.1352e-06C19.325 -0.00995061 18.5468 0.176817 17.8491 0.543401L4.31698 8.30189C3.64696 8.73781 3.08837 9.32464 2.68601 10.0153C2.28365 10.706 2.0487 11.4814 2 12.2793L2 27.7208C2.0487 28.5186 2.28365 29.294 2.68601 29.9847C3.08837 30.6754 3.64696 31.2622 4.31698 31.6981L17.8491 39.4566C18.5468 39.8232 19.325 40.01 20.1132 40C20.9141 40.0163 21.706 39.8294 22.4151 39.4566L35.9094 31.6981C36.5795 31.2622 37.138 30.6754 37.5404 29.9847C37.9428 29.294 38.1777 28.5186 38.2264 27.7208V12.2793C38.1777 11.4814 37.9428 10.706 37.5404 10.0153C37.138 9.32464 36.5795 8.73781 35.9094 8.30189ZM11.6679 13.3585C11.7241 13.3573 11.7793 13.3731 11.8264 13.4038L15.9925 15.8038L12.9736 17.5472L10.1736 15.9321C10.1207 15.9041 10.0764 15.8624 10.0453 15.8113L8.34717 13.117L11.6679 13.3585ZM31.2302 26.3245C31.0337 26.6663 30.7113 26.9177 30.3319 27.0249C29.9525 27.1321 29.5463 27.0866 29.2 26.8981L23.5396 23.6302L26.5585 21.8868L30.6792 24.2792C31.0212 24.4796 31.2706 24.8064 31.3737 25.189C31.4768 25.5717 31.4252 25.9795 31.2302 26.3245ZM31.0717 17.5321L12.1208 28.4755C11.8914 28.6085 11.6311 28.6788 11.366 28.6793C11.2333 28.6808 11.1011 28.663 10.9736 28.6264C10.7815 28.5758 10.6012 28.4877 10.4432 28.3673C10.2852 28.2468 10.1526 28.0964 10.0528 27.9245L7.78868 24C7.69006 23.828 7.62627 23.6384 7.60097 23.4417C7.57566 23.2451 7.58933 23.0455 7.64119 22.8541C7.69305 22.6628 7.78209 22.4836 7.90322 22.3267C8.02435 22.1698 8.17521 22.0382 8.34717 21.9396L17.1698 16.8453L18.4755 16.0906L27.2981 10.9962C27.5274 10.8632 27.7877 10.7929 28.0528 10.7925C28.1852 10.7952 28.3169 10.8129 28.4453 10.8453C28.8305 10.9494 29.1588 11.2017 29.3585 11.5472L31.6226 15.4717C31.8224 15.8181 31.8766 16.2296 31.7733 16.6159C31.6701 17.0021 31.4177 17.3317 31.0717 17.5321Z", fill: "#488FB9" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_2591_70872" }, /* @__PURE__ */ s.createElement("rect", { width: 36.2264, height: 40, fill: "white", transform: "translate(2)" })))), Ui = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_2591_70794)" }, /* @__PURE__ */ s.createElement("path", { d: "M14.0754 30.1887H26.1509V10.566H14.0754V30.1887ZM20.1132 27.1698C19.6654 27.1698 19.2276 27.037 18.8553 26.7882C18.4829 26.5394 18.1927 26.1858 18.0214 25.7721C17.85 25.3584 17.8052 24.9032 17.8925 24.4639C17.9799 24.0247 18.1955 23.6213 18.5122 23.3047C18.8288 22.988 19.2323 22.7724 19.6715 22.685C20.1107 22.5977 20.5659 22.6425 20.9796 22.8139C21.3933 22.9852 21.747 23.2754 21.9957 23.6478C22.2445 24.0201 22.3773 24.4579 22.3773 24.9057C22.3773 25.5062 22.1388 26.082 21.7142 26.5067C21.2896 26.9313 20.7137 27.1698 20.1132 27.1698ZM17.0943 13.5849H23.132C23.3322 13.5849 23.5242 13.6644 23.6657 13.806C23.8072 13.9475 23.8868 14.1395 23.8868 14.3396C23.8868 14.5398 23.8072 14.7318 23.6657 14.8733C23.5242 15.0148 23.3322 15.0943 23.132 15.0943H17.0943C16.8941 15.0943 16.7022 15.0148 16.5606 14.8733C16.4191 14.7318 16.3396 14.5398 16.3396 14.3396C16.3396 14.1395 16.4191 13.9475 16.5606 13.806C16.7022 13.6644 16.8941 13.5849 17.0943 13.5849ZM17.0943 18.1132H23.132C23.3322 18.1132 23.5242 18.1927 23.6657 18.3343C23.8072 18.4758 23.8868 18.6678 23.8868 18.8679C23.8868 19.0681 23.8072 19.2601 23.6657 19.4016C23.5242 19.5431 23.3322 19.6226 23.132 19.6226H17.0943C16.8941 19.6226 16.7022 19.5431 16.5606 19.4016C16.4191 19.2601 16.3396 19.0681 16.3396 18.8679C16.3396 18.6678 16.4191 18.4758 16.5606 18.3343C16.7022 18.1927 16.8941 18.1132 17.0943 18.1132Z", fill: "#4AA99D" }), /* @__PURE__ */ s.createElement("path", { d: "M20.1132 25.6604C20.5301 25.6604 20.868 25.3225 20.868 24.9057C20.868 24.4889 20.5301 24.151 20.1132 24.151C19.6964 24.151 19.3585 24.4889 19.3585 24.9057C19.3585 25.3225 19.6964 25.6604 20.1132 25.6604Z", fill: "#4AA99D" }), /* @__PURE__ */ s.createElement("path", { d: "M35.9094 8.30189L22.4151 0.543401C21.706 0.170657 20.9141 -0.0162964 20.1132 5.1352e-06C19.325 -0.00995061 18.5468 0.176817 17.8491 0.543401L4.31698 8.30189C3.64696 8.73781 3.08837 9.32464 2.68601 10.0153C2.28365 10.706 2.0487 11.4814 2 12.2793L2 27.7208C2.0487 28.5186 2.28365 29.294 2.68601 29.9847C3.08837 30.6754 3.64696 31.2622 4.31698 31.6981L17.8491 39.4566C18.5468 39.8232 19.325 40.01 20.1132 40C20.9141 40.0163 21.706 39.8294 22.4151 39.4566L35.9094 31.6981C36.5795 31.2622 37.138 30.6754 37.5404 29.9847C37.9428 29.294 38.1777 28.5186 38.2264 27.7208V12.2793C38.1777 11.4814 37.9428 10.706 37.5404 10.0153C37.138 9.32464 36.5795 8.73781 35.9094 8.30189ZM27.6604 30.1887C27.6604 30.589 27.5013 30.9729 27.2183 31.256C26.9352 31.5391 26.5513 31.6981 26.1509 31.6981H14.0755C13.6751 31.6981 13.2912 31.5391 13.0081 31.256C12.7251 30.9729 12.566 30.589 12.566 30.1887V10.566C12.566 10.1657 12.7251 9.78179 13.0081 9.49871C13.2912 9.21564 13.6751 9.05661 14.0755 9.05661H26.1509C26.5513 9.05661 26.9352 9.21564 27.2183 9.49871C27.5013 9.78179 27.6604 10.1657 27.6604 10.566V30.1887Z", fill: "#4AA99D" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_2591_70794" }, /* @__PURE__ */ s.createElement("rect", { width: 36.2264, height: 40, fill: "white", transform: "translate(2)" })))), Gi = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_2591_70820)" }, /* @__PURE__ */ s.createElement("path", { d: "M11.434 22.3245C12.8929 22.3245 14.0755 21.1419 14.0755 19.683C14.0755 18.2241 12.8929 17.0415 11.434 17.0415C9.97512 17.0415 8.79248 18.2241 8.79248 19.683C8.79248 21.1419 9.97512 22.3245 11.434 22.3245Z", fill: "#4AA99D" }), /* @__PURE__ */ s.createElement("path", { d: "M35.9094 8.30189L22.4151 0.543401C21.706 0.170657 20.9141 -0.0162964 20.1132 5.1352e-06C19.325 -0.00995061 18.5468 0.176817 17.8491 0.543401L4.31698 8.30189C3.64696 8.73781 3.08837 9.32464 2.68601 10.0153C2.28365 10.706 2.0487 11.4814 2 12.2793L2 27.7208C2.0487 28.5186 2.28365 29.294 2.68601 29.9847C3.08837 30.6754 3.64696 31.2622 4.31698 31.6981L17.8491 39.4566C18.5468 39.8232 19.325 40.01 20.1132 40C20.9141 40.0163 21.706 39.8294 22.4151 39.4566L35.9094 31.6981C36.5795 31.2622 37.138 30.6754 37.5404 29.9847C37.9428 29.294 38.1777 28.5186 38.2264 27.7208V12.2793C38.1777 11.4814 37.9428 10.706 37.5404 10.0153C37.138 9.32464 36.5795 8.73781 35.9094 8.30189ZM11.434 23.834C10.613 23.834 9.81044 23.5905 9.12782 23.1344C8.4452 22.6783 7.91317 22.03 7.59899 21.2715C7.28482 20.513 7.20261 19.6784 7.36278 18.8732C7.52294 18.068 7.91828 17.3284 8.4988 16.7479C9.07932 16.1673 9.81895 15.772 10.6242 15.6118C11.4294 15.4517 12.264 15.5339 13.0225 15.8481C13.7809 16.1622 14.4292 16.6943 14.8853 17.3769C15.3415 18.0595 15.5849 18.862 15.5849 19.683C15.5849 20.7839 15.1476 21.8397 14.3691 22.6182C13.5907 23.3966 12.5349 23.834 11.434 23.834ZM25.3962 30.9434C24.5956 30.9434 23.8277 30.6253 23.2616 30.0592C22.6954 29.493 22.3774 28.7252 22.3774 27.9245C22.3808 27.669 22.4188 27.4151 22.4906 27.1698L17.2075 24.1509C17.0334 24.0509 16.9062 23.8857 16.8538 23.6918C16.8014 23.4979 16.8282 23.2911 16.9283 23.117C17.0284 22.9428 17.1935 22.8156 17.3874 22.7632C17.5814 22.7109 17.7881 22.7377 17.9623 22.8377L23.2453 25.8113C23.5258 25.5252 23.8604 25.2977 24.2297 25.1422C24.599 24.9867 24.9955 24.9063 25.3962 24.9057C26.1969 24.9057 26.9647 25.2237 27.5309 25.7899C28.097 26.356 28.4151 27.1239 28.4151 27.9245C28.4151 28.7252 28.097 29.493 27.5309 30.0592C26.9647 30.6253 26.1969 30.9434 25.3962 30.9434ZM25.3962 14.5811C24.9865 14.5807 24.5811 14.4968 24.2048 14.3346C23.8286 14.1724 23.4892 13.9353 23.2075 13.6377L17.9245 16.5585C17.8102 16.6177 17.6834 16.6488 17.5547 16.6491C17.421 16.6488 17.2897 16.6131 17.1743 16.5454C17.059 16.4778 16.9636 16.3807 16.8981 16.2642C16.85 16.1774 16.8194 16.0821 16.8082 15.9836C16.797 15.885 16.8052 15.7853 16.8326 15.69C16.8599 15.5946 16.9058 15.5056 16.9675 15.428C17.0293 15.3504 17.1057 15.2858 17.1925 15.2377L22.4755 12.3094C22.318 11.6994 22.3553 11.0554 22.5821 10.4677C22.809 9.87992 23.214 9.37787 23.7406 9.03188C24.2671 8.68588 24.8886 8.51327 25.5181 8.53824C26.1477 8.56321 26.7536 8.78451 27.251 9.17112C27.7485 9.55774 28.1125 10.0903 28.2921 10.6942C28.4717 11.298 28.4579 11.943 28.2525 12.5386C28.0472 13.1342 27.6607 13.6507 27.1471 14.0156C26.6336 14.3805 26.0187 14.5756 25.3887 14.5736L25.3962 14.5811Z", fill: "#4AA99D" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_2591_70820" }, /* @__PURE__ */ s.createElement("rect", { width: 36.2264, height: 40, fill: "white", transform: "translate(2)" })))), Ki = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_2591_59546)" }, /* @__PURE__ */ s.createElement("path", { d: "M23.8868 16.9509L20.1132 19.0868L16.3396 16.9509L20.1132 14.7698L23.8868 16.9509ZM15.5849 22.6415L19.3585 24.8226V20.3774L15.5849 18.2415V22.6415ZM20.8679 24.8226L24.6415 22.6415V18.2566L20.8679 20.3774V24.8226ZM38.2264 12.2793V27.7208C38.1777 28.5186 37.9428 29.294 37.5404 29.9847C37.138 30.6754 36.5795 31.2622 35.9094 31.6981L22.4151 39.4566C21.706 39.8294 20.9141 40.0163 20.1132 40C19.325 40.01 18.5468 39.8232 17.8491 39.4566L4.31698 31.6981C3.64696 31.2622 3.08837 30.6754 2.68601 29.9847C2.28365 29.294 2.0487 28.5186 2 27.7208V12.2793C2.0487 11.4814 2.28365 10.706 2.68601 10.0153C3.08837 9.32464 3.64696 8.73781 4.31698 8.30189L17.8491 0.543401C18.5468 0.176817 19.325 -0.00995061 20.1132 5.1352e-06C20.9141 -0.0162964 21.706 0.170657 22.4151 0.543401L35.9094 8.30189C36.5795 8.73781 37.138 9.32464 37.5404 10.0153C37.9428 10.706 38.1777 11.4814 38.2264 12.2793ZM17.0943 10.5208C17.0943 10.7209 17.1739 10.9129 17.3154 11.0544C17.4569 11.196 17.6489 11.2755 17.8491 11.2755H22.3774C22.5775 11.2755 22.7695 11.196 22.911 11.0544C23.0526 10.9129 23.1321 10.7209 23.1321 10.5208C23.1321 10.3206 23.0526 10.1286 22.911 9.98709C22.7695 9.84556 22.5775 9.76604 22.3774 9.76604H17.8491C17.6489 9.76604 17.4569 9.84556 17.3154 9.98709C17.1739 10.1286 17.0943 10.3206 17.0943 10.5208ZM9.54717 13.5396C9.54717 13.7398 9.62668 13.9318 9.76822 14.0733C9.90976 14.2148 10.1017 14.2943 10.3019 14.2943C10.502 14.2943 10.694 14.2148 10.8356 14.0733C10.9771 13.9318 11.0566 13.7398 11.0566 13.5396V11.2755H13.3208C13.5209 11.2755 13.7129 11.196 13.8544 11.0544C13.996 10.9129 14.0755 10.7209 14.0755 10.5208C14.0755 10.3206 13.996 10.1286 13.8544 9.98709C13.7129 9.84556 13.5209 9.76604 13.3208 9.76604H10.3019C10.1017 9.76604 9.90976 9.84556 9.76822 9.98709C9.62668 10.1286 9.54717 10.3206 9.54717 10.5208V13.5396ZM9.54717 22.0981C9.54717 22.2983 9.62668 22.4902 9.76822 22.6318C9.90976 22.7733 10.1017 22.8528 10.3019 22.8528C10.502 22.8528 10.694 22.7733 10.8356 22.6318C10.9771 22.4902 11.0566 22.2983 11.0566 22.0981V17.8189C11.0566 17.6187 10.9771 17.4267 10.8356 17.2852C10.694 17.1437 10.502 17.0642 10.3019 17.0642C10.1017 17.0642 9.90976 17.1437 9.76822 17.2852C9.62668 17.4267 9.54717 17.6187 9.54717 17.8189V22.0981ZM14.0755 29.3887C14.0755 29.1885 13.996 28.9966 13.8544 28.855C13.7129 28.7135 13.5209 28.634 13.3208 28.634H11.0566V26.3698C11.0566 26.1697 10.9771 25.9777 10.8356 25.8362C10.694 25.6946 10.502 25.6151 10.3019 25.6151C10.1017 25.6151 9.90976 25.6946 9.76822 25.8362C9.62668 25.9777 9.54717 26.1697 9.54717 26.3698V29.3887C9.54717 29.5888 9.62668 29.7808 9.76822 29.9223C9.90976 30.0639 10.1017 30.1434 10.3019 30.1434H13.3208C13.5209 30.1434 13.7129 30.0639 13.8544 29.9223C13.996 29.7808 14.0755 29.5888 14.0755 29.3887ZM23.1321 29.3887C23.1321 29.1885 23.0526 28.9966 22.911 28.855C22.7695 28.7135 22.5775 28.634 22.3774 28.634H17.8491C17.6489 28.634 17.4569 28.7135 17.3154 28.855C17.1739 28.9966 17.0943 29.1885 17.0943 29.3887C17.0943 29.5888 17.1739 29.7808 17.3154 29.9223C17.4569 30.0639 17.6489 30.1434 17.8491 30.1434H22.3774C22.5775 30.1434 22.7695 30.0639 22.911 29.9223C23.0526 29.7808 23.1321 29.5888 23.1321 29.3887ZM26.1509 22.5962V17.3585C26.152 17.0925 26.0828 16.831 25.9502 16.6004C25.8177 16.3698 25.6266 16.1783 25.3962 16.0453L20.8679 13.434C20.6385 13.3015 20.3782 13.2317 20.1132 13.2317C19.8482 13.2317 19.588 13.3015 19.3585 13.434L14.8302 16.0755C14.6042 16.2059 14.4159 16.3926 14.2837 16.6175C14.1514 16.8423 14.0797 17.0977 14.0755 17.3585V22.6415C14.0744 22.9075 14.1437 23.169 14.2762 23.3996C14.4087 23.6302 14.5998 23.8217 14.8302 23.9547L19.3585 26.566C19.588 26.6985 19.8482 26.7683 20.1132 26.7683C20.3782 26.7683 20.6385 26.6985 20.8679 26.566L25.3962 23.9547C25.6266 23.8217 25.8177 23.6302 25.9502 23.3996C26.0828 23.169 26.152 22.9075 26.1509 22.6415V22.5962ZM30.6792 26.3698C30.6792 26.1697 30.5997 25.9777 30.4582 25.8362C30.3167 25.6946 30.1247 25.6151 29.9245 25.6151C29.7244 25.6151 29.5324 25.6946 29.3909 25.8362C29.2493 25.9777 29.1698 26.1697 29.1698 26.3698V28.634H26.9057C26.7055 28.634 26.5135 28.7135 26.372 28.855C26.2305 28.9966 26.1509 29.1885 26.1509 29.3887C26.1509 29.5888 26.2305 29.7808 26.372 29.9223C26.5135 30.0639 26.7055 30.1434 26.9057 30.1434H29.9245C30.1247 30.1434 30.3167 30.0639 30.4582 29.9223C30.5997 29.7808 30.6792 29.5888 30.6792 29.3887V26.3698ZM30.6792 17.8189C30.6792 17.6187 30.5997 17.4267 30.4582 17.2852C30.3167 17.1437 30.1247 17.0642 29.9245 17.0642C29.7244 17.0642 29.5324 17.1437 29.3909 17.2852C29.2493 17.4267 29.1698 17.6187 29.1698 17.8189V22.0981C29.1698 22.2983 29.2493 22.4902 29.3909 22.6318C29.5324 22.7733 29.7244 22.8528 29.9245 22.8528C30.1247 22.8528 30.3167 22.7733 30.4582 22.6318C30.5997 22.4902 30.6792 22.2983 30.6792 22.0981V17.8189ZM30.6792 10.5208C30.6792 10.3206 30.5997 10.1286 30.4582 9.98709C30.3167 9.84556 30.1247 9.76604 29.9245 9.76604H26.9057C26.7055 9.76604 26.5135 9.84556 26.372 9.98709C26.2305 10.1286 26.1509 10.3206 26.1509 10.5208C26.1509 10.7209 26.2305 10.9129 26.372 11.0544C26.5135 11.196 26.7055 11.2755 26.9057 11.2755H29.1698V13.5396C29.1698 13.7398 29.2493 13.9318 29.3909 14.0733C29.5324 14.2148 29.7244 14.2943 29.9245 14.2943C30.1247 14.2943 30.3167 14.2148 30.4582 14.0733C30.5997 13.9318 30.6792 13.7398 30.6792 13.5396V10.5208Z", fill: "url(#paint0_linear_2591_59546)" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_2591_59546", x1: -19.3736, y1: 62.8021, x2: 43.8392, y2: 6.27571, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#59DDF2" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#B0B3EF" })), /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_2591_59546" }, /* @__PURE__ */ s.createElement("rect", { width: 40, height: 40, fill: "white" })))), Yi = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_2591_59589)" }, /* @__PURE__ */ s.createElement("path", { d: "M20.1132 10.3623L22.7245 14.8906H17.5019L20.1132 10.3623ZM26.1509 20.5509C25.5539 20.5509 24.9702 20.728 24.4737 21.0597C23.9773 21.3914 23.5904 21.8629 23.3619 22.4145C23.1334 22.9662 23.0736 23.5732 23.1901 24.1588C23.3066 24.7444 23.5941 25.2823 24.0163 25.7045C24.4385 26.1267 24.9764 26.4142 25.562 26.5307C26.1476 26.6472 26.7546 26.5874 27.3062 26.3589C27.8578 26.1304 28.3293 25.7435 28.661 25.247C28.9928 24.7506 29.1698 24.1669 29.1698 23.5698C29.1698 22.7692 28.8518 22.0013 28.2856 21.4352C27.7195 20.869 26.9516 20.5509 26.1509 20.5509ZM11.8113 20.9283V26.2113H17.0943V20.9283H11.8113ZM38.2264 12.2793V27.7208C38.1777 28.5186 37.9428 29.294 37.5404 29.9847C37.138 30.6754 36.5795 31.2622 35.9094 31.6981L22.4151 39.4566C21.706 39.8294 20.9141 40.0163 20.1132 40C19.325 40.01 18.5468 39.8232 17.8491 39.4566L4.31698 31.6981C3.64696 31.2622 3.08837 30.6754 2.68601 29.9847C2.28365 29.294 2.0487 28.5186 2 27.7208V12.2793C2.0487 11.4814 2.28365 10.706 2.68601 10.0153C3.08837 9.32464 3.64696 8.73781 4.31698 8.30189L17.8491 0.543401C18.5468 0.176817 19.325 -0.00995061 20.1132 5.1352e-06C20.9141 -0.0162964 21.706 0.170657 22.4151 0.543401L35.9094 8.30189C36.5795 8.73781 37.138 9.32464 37.5404 10.0153C37.9428 10.706 38.1777 11.4814 38.2264 12.2793ZM18.6038 20.9283C18.6038 20.528 18.4447 20.1441 18.1617 19.861C17.8786 19.5779 17.4947 19.4189 17.0943 19.4189H11.8113C11.411 19.4189 11.0271 19.5779 10.744 19.861C10.4609 20.1441 10.3019 20.528 10.3019 20.9283V26.2113C10.3019 26.6117 10.4609 26.9956 10.744 27.2787C11.0271 27.5617 11.411 27.7208 11.8113 27.7208H17.0943C17.4947 27.7208 17.8786 27.5617 18.1617 27.2787C18.4447 26.9956 18.6038 26.6117 18.6038 26.2113V20.9283ZM24.0377 16.4C24.1698 16.3992 24.2994 16.3638 24.4135 16.2972C24.5276 16.2306 24.6222 16.1353 24.6879 16.0207C24.7536 15.9061 24.7881 15.7763 24.7879 15.6442C24.7877 15.5121 24.7528 15.3823 24.6868 15.2679L20.7698 8.47548C20.704 8.35933 20.6085 8.26272 20.4932 8.1955C20.3778 8.12829 20.2467 8.09287 20.1132 8.09287C19.9797 8.09287 19.8486 8.12829 19.7332 8.1955C19.6179 8.26272 19.5224 8.35933 19.4566 8.47548L15.5396 15.2679C15.4736 15.3823 15.4387 15.5121 15.4385 15.6442C15.4383 15.7763 15.4728 15.9061 15.5385 16.0207C15.6042 16.1353 15.6988 16.2306 15.8129 16.2972C15.927 16.3638 16.0566 16.3992 16.1887 16.4H24.0377ZM30.6792 23.5698C30.6792 22.6742 30.4137 21.7987 29.9161 21.054C29.4185 20.3094 28.7113 19.7289 27.8838 19.3862C27.0564 19.0435 26.1459 18.9538 25.2675 19.1285C24.3891 19.3033 23.5822 19.7345 22.9489 20.3678C22.3157 21.0011 21.8844 21.808 21.7097 22.6864C21.5349 23.5648 21.6246 24.4753 21.9673 25.3027C22.3101 26.1302 22.8905 26.8374 23.6352 27.335C24.3798 27.8325 25.2553 28.0981 26.1509 28.0981C27.3519 28.0981 28.5037 27.621 29.3529 26.7718C30.2022 25.9226 30.6792 24.7708 30.6792 23.5698Z", fill: "url(#paint0_linear_2591_59589)" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_2591_59589", x1: 2, y1: 40.001, x2: 50.2047, y2: -4.01472, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#E78470" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#6DA2FF" })), /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_2591_59589" }, /* @__PURE__ */ s.createElement("rect", { width: 40, height: 40, fill: "white" })))), Qi = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M29.4943 19.3057L27.9321 18.5208C27.6075 18.3547 27.3509 18.083 27.2151 17.7509L26.7321 16.5811C26.5962 16.2491 26.5811 15.8717 26.6943 15.5245L27.2453 13.8642C27.3358 13.5849 27.2679 13.2755 27.0566 13.0642C26.9057 12.9132 26.7094 12.8377 26.5057 12.8377C26.4226 12.8377 26.3396 12.8528 26.2566 12.8755L24.5962 13.4264C24.4377 13.4792 24.2792 13.5019 24.1208 13.5019C23.9245 13.5019 23.7283 13.4642 23.5396 13.3887L22.3698 12.9057C22.0377 12.7698 21.7585 12.5132 21.6 12.1887L20.8151 10.6264C20.6792 10.3623 20.4151 10.1962 20.1208 10.1962C19.8264 10.1962 19.5547 10.3623 19.4264 10.6264L18.6415 12.1887C18.4755 12.5132 18.2038 12.7698 17.8717 12.9057L16.7019 13.3887C16.5208 13.4642 16.3245 13.5019 16.1208 13.5019C15.9623 13.5019 15.7962 13.4792 15.6453 13.4264L13.9849 12.8755C13.9019 12.8453 13.8189 12.8377 13.7358 12.8377C13.5245 12.8377 13.3283 12.9208 13.1849 13.0642C12.9736 13.2755 12.9057 13.5774 12.9962 13.8642L13.5472 15.5245C13.6604 15.8717 13.6453 16.2415 13.5094 16.5811L13.0264 17.7509C12.8906 18.083 12.634 18.3623 12.3094 18.5208L10.7472 19.3057C10.483 19.4415 10.317 19.7057 10.317 20C10.317 20.2943 10.483 20.566 10.7472 20.6943L12.3094 21.4792C12.634 21.6453 12.8906 21.917 13.0264 22.2491L13.5094 23.4189C13.6453 23.7509 13.6604 24.1283 13.5472 24.4755L12.9962 26.1359C12.9057 26.4151 12.9736 26.7245 13.1849 26.9358C13.3358 27.0868 13.5321 27.1623 13.7358 27.1623C13.8189 27.1623 13.9019 27.1472 13.9849 27.1245L15.6453 26.5736C15.8038 26.5208 15.9623 26.4981 16.1208 26.4981C16.317 26.4981 16.5132 26.5358 16.7019 26.6113L17.8717 27.0943C18.2038 27.2302 18.483 27.4868 18.6415 27.8113L19.4264 29.3736C19.5623 29.6377 19.8264 29.8038 20.1208 29.8038C20.4151 29.8038 20.6868 29.6377 20.8151 29.3736L21.6 27.8113C21.766 27.4868 22.0377 27.2302 22.3698 27.0943L23.5396 26.6113C23.7208 26.5358 23.917 26.4981 24.1208 26.4981C24.2792 26.4981 24.4453 26.5208 24.5962 26.5736L26.2566 27.1245C26.3396 27.1547 26.4226 27.1623 26.5057 27.1623C26.717 27.1623 26.9132 27.0792 27.0566 26.9358C27.2679 26.7245 27.3358 26.4226 27.2453 26.1359L26.6943 24.4755C26.5811 24.1283 26.5962 23.7585 26.7321 23.4189L27.2151 22.2491C27.3509 21.917 27.6075 21.6377 27.9321 21.4792L29.4943 20.6943C29.7585 20.5585 29.9245 20.2943 29.9245 20C29.9245 19.7057 29.7585 19.434 29.4943 19.3057ZM20.1132 23.7736C18.0302 23.7736 16.3396 22.083 16.3396 20C16.3396 17.917 18.0302 16.2264 20.1132 16.2264C22.1962 16.2264 23.8868 17.917 23.8868 20C23.8868 22.083 22.1962 23.7736 20.1132 23.7736ZM35.9094 8.27925L22.4151 0.543396C21.7811 0.181132 20.9434 0 20.1132 0C19.283 0 18.4453 0.181132 17.8113 0.543396L4.31698 8.27925C3.04151 9.01132 2 10.8151 2 12.2792V27.7132C2 29.1849 3.04151 30.9811 4.31698 31.7132L17.8038 39.4491C18.4377 39.8113 19.2755 39.9925 20.1057 39.9925C20.9358 39.9925 21.7736 39.8113 22.4075 39.4491L35.8943 31.7132C37.1698 30.9811 38.2113 29.1774 38.2113 27.7132V12.2792C38.2113 10.8075 37.1698 9.01132 35.8943 8.27925H35.9094ZM30.166 22.0453L28.6038 22.8302L28.1208 24L28.6717 25.6604C28.9434 26.483 28.7321 27.3887 28.1208 28C27.683 28.4377 27.1019 28.6717 26.4981 28.6717C26.2566 28.6717 26.0151 28.634 25.7736 28.5509L24.1132 28L22.9434 28.483L22.1585 30.0453C21.7736 30.8226 20.9811 31.3132 20.1132 31.3132C19.2453 31.3132 18.4528 30.8226 18.0679 30.0453L17.283 28.483L16.1132 28L14.4528 28.5509C14.2189 28.6264 13.9698 28.6717 13.7283 28.6717C13.1321 28.6717 12.5434 28.4377 12.1057 28C11.4943 27.3887 11.2755 26.483 11.5547 25.6604L12.1057 24L11.6226 22.8302L10.0604 22.0453C9.28302 21.6604 8.79245 20.8679 8.79245 20C8.79245 19.1321 9.28302 18.3396 10.0604 17.9547L11.6226 17.1698L12.1057 16L11.5547 14.3396C11.283 13.517 11.4943 12.6113 12.1057 12C12.5434 11.5623 13.1245 11.3283 13.7283 11.3283C13.9698 11.3283 14.2113 11.366 14.4528 11.4491L16.1132 12L17.283 11.517L18.0679 9.95472C18.4528 9.17736 19.2453 8.68679 20.1132 8.68679C20.9811 8.68679 21.7736 9.17736 22.1585 9.95472L22.9434 11.517L24.1132 12L25.7736 11.4491C26.0075 11.3736 26.2566 11.3283 26.4981 11.3283C27.0943 11.3283 27.683 11.5623 28.1208 12C28.7321 12.6113 28.9509 13.517 28.6717 14.3396L28.1208 16L28.6038 17.1698L30.166 17.9547C30.9434 18.3396 31.434 19.1321 31.434 20C31.434 20.8679 30.9434 21.6604 30.166 22.0453ZM22.3774 20C22.3774 21.2453 21.3585 22.2642 20.1132 22.2642C18.8679 22.2642 17.8491 21.2453 17.8491 20C17.8491 18.7547 18.8679 17.7358 20.1132 17.7358C21.3585 17.7358 22.3774 18.7547 22.3774 20Z", fill: "url(#paint0_linear_2591_74002)" }), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_2591_74002", x1: 6.2717, y1: 33.8415, x2: 33.9547, y2: 6.15849, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#0071AB" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#8CC53E" })))), Xi = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M28.4151 21.5094V23.3962H20.8679V21.5094C20.8679 21.2981 21.034 21.1321 21.2453 21.1321H28.0377C28.2491 21.1321 28.4151 21.2981 28.4151 21.5094ZM20.8679 28.3019C20.8679 28.5132 21.034 28.6792 21.2453 28.6792H28.0377C28.2491 28.6792 28.4151 28.5132 28.4151 28.3019V24.9057H20.8679V28.3019ZM38.2264 12.2792V27.7132C38.2264 29.1849 37.1849 30.9811 35.9094 31.7132L22.4226 39.4491C21.7887 39.8113 20.9509 39.9925 20.1208 39.9925C19.2906 39.9925 18.4528 39.8113 17.8189 39.4491L4.31698 31.7208C3.04151 30.9887 2 29.1849 2 27.7208V12.2868C2 10.8151 3.04151 9.01887 4.31698 8.28679L17.8113 0.543396C18.4453 0.181132 19.283 0 20.1132 0C20.9434 0 21.7811 0.181132 22.4151 0.543396L35.9019 8.27925C37.1774 9.01132 38.2189 10.8151 38.2189 12.2792H38.2264ZM13.3208 19.6226H12.1887C11.9774 19.6226 11.8113 19.4566 11.8113 19.2453V12.4528C11.8113 12.2415 11.9774 12.0755 12.1887 12.0755H18.9811C19.1925 12.0755 19.3585 12.2415 19.3585 12.4528V13.5849H20.8679V12.0755C20.8679 11.2453 20.1887 10.566 19.3585 10.566H11.8113C10.9811 10.566 10.3019 11.2453 10.3019 12.0755V19.6226C10.3019 20.4528 10.9811 21.1321 11.8113 21.1321H13.3208V19.6226ZM17.8491 24.1509H16.717C16.5057 24.1509 16.3396 23.9849 16.3396 23.7736V16.9811C16.3396 16.7698 16.5057 16.6038 16.717 16.6038H23.5094C23.7208 16.6038 23.8868 16.7698 23.8868 16.9811V18.1132H25.3962V16.6038C25.3962 15.7736 24.717 15.0943 23.8868 15.0943H16.3396C15.5094 15.0943 14.8302 15.7736 14.8302 16.6038V24.1509C14.8302 24.9811 15.5094 25.6604 16.3396 25.6604H17.8491V24.1509ZM29.9245 21.1321C29.9245 20.3019 29.2453 19.6226 28.4151 19.6226H20.8679C20.0377 19.6226 19.3585 20.3019 19.3585 21.1321V28.6792C19.3585 29.5094 20.0377 30.1887 20.8679 30.1887H28.4151C29.2453 30.1887 29.9245 29.5094 29.9245 28.6792V21.1321Z", fill: "url(#paint0_linear_2591_74044)" }), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_2591_74044", x1: 6.2717, y1: 33.8415, x2: 33.9547, y2: 6.15849, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#0071AB" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#8CC53E" })))), Ji = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M15.9094 17.1396L19.3585 15.1472V19.5623L15.5321 21.7736V17.7887C15.5321 17.517 15.6755 17.2679 15.9094 17.1321V17.1396ZM15.1547 24.1736C14.4604 23.7736 14.0226 23.0189 14.0226 22.2113V17.7887C14.0226 17.6528 14.0528 17.517 14.0755 17.3887L12.0377 16.2113C11.9019 16.1283 11.766 16.1057 11.6453 16.1057C11.4642 16.1057 11.3208 16.1736 11.2453 16.2113C11.1321 16.2792 10.8679 16.4755 10.8528 16.8679V24.9132C10.8528 24.9811 10.8604 25.0491 10.8755 25.1094C10.9132 25.2377 10.9811 25.3509 11.0717 25.4491C11.117 25.4943 11.1698 25.5396 11.2302 25.5698L18.1962 29.5925C18.5358 29.7736 18.8453 29.6528 18.9585 29.5849C19.0792 29.517 19.3509 29.3132 19.3509 28.9057V26.5509C19.2226 26.5057 19.0943 26.4679 18.9736 26.3925L15.1472 24.1811L15.1547 24.1736ZM20.8679 15.1472V19.5623L24.6943 21.7736V17.7887C24.6943 17.517 24.5509 17.2679 24.317 17.1321L20.8679 15.1396V15.1472ZM12.7925 14.8981L13.0792 15.0642L14.8302 16.0755C14.9358 15.9849 15.034 15.8943 15.1547 15.8264L18.9811 13.6151C19.683 13.2151 20.5434 13.2151 21.2453 13.6151L25.0717 15.8264C25.1925 15.8943 25.2906 15.9849 25.3962 16.0755L27.434 14.8981C27.7887 14.6943 27.8264 14.3547 27.8264 14.2189C27.8264 14.083 27.7887 13.7585 27.4491 13.5547L20.483 9.53208C20.4226 9.50189 20.3623 9.4717 20.3019 9.4566C20.2415 9.44151 20.1736 9.43396 20.1057 9.43396C20.0377 9.43396 19.9774 9.44151 19.9094 9.4566C19.8491 9.4717 19.7811 9.50189 19.7283 9.53208L12.7623 13.5547C12.4302 13.7585 12.3849 14.083 12.3849 14.2189C12.3849 14.3547 12.4226 14.6943 12.7774 14.8981H12.7925ZM20.1132 20.8679L16.2868 23.0792L19.7358 25.0717C19.9698 25.2075 20.2566 25.2075 20.4906 25.0717L23.9396 23.0792L20.1132 20.8679ZM38.2264 12.2792V27.7132C38.2264 29.1849 37.1849 30.9811 35.9094 31.7132L22.4226 39.4491C21.7887 39.8113 20.9509 39.9925 20.1208 39.9925C19.2906 39.9925 18.4528 39.8113 17.8189 39.4491L4.31698 31.7208C3.04151 30.9887 2 29.1849 2 27.7208V12.2868C2 10.8151 3.04151 9.01887 4.31698 8.28679L17.8113 0.543396C18.4453 0.181132 19.283 0 20.1132 0C20.9434 0 21.7811 0.181132 22.4151 0.543396L35.9019 8.27925C37.1774 9.01132 38.2189 10.8151 38.2189 12.2792H38.2264ZM30.883 16.8906C30.883 16.8906 30.883 16.8679 30.883 16.8528V15.0943C30.883 14.2868 30.4528 13.5396 29.7509 13.1321L28.2264 12.2491C28.2264 12.2491 28.2113 12.234 28.2038 12.2264L21.2755 8.22641C21.0943 8.12075 20.9057 8.04528 20.7094 7.99245C20.3245 7.89434 19.9245 7.89434 19.5472 7.99245C19.3509 8.04528 19.1623 8.12075 18.9811 8.22641L12.0528 12.2264C12.0528 12.2264 12.0377 12.2415 12.0226 12.2491L10.4981 13.1321C9.80377 13.5321 9.36604 14.2868 9.36604 15.0943V16.8528C9.36604 16.8528 9.36604 16.8755 9.36604 16.8906V24.8906C9.36604 25.2981 9.47924 25.6906 9.67547 26.0377C9.77358 26.2038 9.89434 26.3623 10.0302 26.5057C10.1736 26.6491 10.3321 26.7774 10.5132 26.883L17.4415 30.883C17.4415 30.883 17.4642 30.883 17.4717 30.8981L18.9962 31.7811C19.3434 31.9849 19.7358 32.083 20.1283 32.083C20.5208 32.083 20.9132 31.9849 21.2604 31.7811L22.7849 30.8981C22.7849 30.8981 22.8075 30.8981 22.8151 30.883L29.7434 26.883C29.9245 26.7774 30.083 26.6491 30.2264 26.5057C30.3623 26.3623 30.483 26.2113 30.5811 26.0377C30.7774 25.6906 30.8906 25.2981 30.8906 24.8906V16.8906H30.883ZM28.9736 16.2113C28.8981 16.166 28.7547 16.1057 28.5736 16.1057C28.4604 16.1057 28.3245 16.1358 28.1887 16.2113L26.1509 17.3887C26.1736 17.5245 26.2038 17.6528 26.2038 17.7962V22.2189C26.2038 23.0264 25.7736 23.7736 25.0717 24.1811L21.2453 26.3925C21.1245 26.4604 20.9962 26.5057 20.8679 26.5509V28.9057C20.8679 29.3132 21.1396 29.517 21.2604 29.5849C21.3736 29.6528 21.6755 29.7811 22.0226 29.5925L28.9887 25.5698C29.0491 25.5396 29.1019 25.4943 29.1472 25.4491C29.2377 25.3585 29.3057 25.2377 29.3434 25.1094C29.3585 25.0491 29.366 24.9811 29.366 24.9132V16.8679C29.3509 16.4755 29.0943 16.2792 28.9736 16.2113Z", fill: "url(#paint0_linear_2737_99824)" }), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_2737_99824", x1: 6.2717, y1: 33.8415, x2: 33.9547, y2: 6.15849, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#59DCF1" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#AFB2EE" })))), el = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M19.3585 20.8906V28.8906C19.3585 29.2981 19.0868 29.5019 18.966 29.5698C18.8453 29.6377 18.5358 29.7736 18.1811 29.5698L11.2528 25.5698C11.0113 25.4264 10.8604 25.1698 10.8604 24.8906V16.8906C10.8604 16.483 11.1321 16.2792 11.2528 16.2113C11.3283 16.1736 11.4717 16.1057 11.6528 16.1057C11.7736 16.1057 11.9019 16.1358 12.0453 16.2113L18.9736 20.2113C19.2151 20.3547 19.366 20.6113 19.366 20.8906H19.3585ZM27.8264 14.2189C27.8264 14.083 27.7887 13.7434 27.434 13.5396L20.5057 9.53962C20.3849 9.4717 20.2491 9.43396 20.1132 9.43396C19.9774 9.43396 19.8415 9.4717 19.7208 9.53962L12.7925 13.5396C12.4377 13.7434 12.4 14.083 12.4 14.2189C12.4 14.3547 12.4377 14.6943 12.7925 14.8981L19.7208 18.8981C19.9623 19.0415 20.2642 19.0415 20.5057 18.8981L27.434 14.8981C27.7887 14.6943 27.8264 14.3547 27.8264 14.2189ZM28.9736 16.2113C28.8981 16.1736 28.7547 16.1057 28.5736 16.1057C28.4528 16.1057 28.3245 16.1358 28.1811 16.2113L21.2528 20.2113C21.0113 20.3547 20.8604 20.6113 20.8604 20.8906V28.8906C20.8604 29.2981 21.1321 29.5019 21.2528 29.5698C21.3736 29.6377 21.683 29.7736 22.0377 29.5698L28.966 25.5698C29.2075 25.4264 29.3585 25.1698 29.3585 24.8906V16.8906C29.3585 16.483 29.0868 16.2792 28.966 16.2113H28.9736ZM38.2264 12.2792V27.7132C38.2264 29.1849 37.1849 30.9811 35.9094 31.7132L22.4226 39.4491C21.7887 39.8113 20.9509 39.9925 20.1208 39.9925C19.2906 39.9925 18.4528 39.8113 17.8189 39.4491L4.31698 31.7208C3.04151 30.9887 2 29.1849 2 27.7208V12.2868C2 10.8151 3.04151 9.01887 4.31698 8.28679L17.8113 0.543396C18.4453 0.181132 19.283 0 20.1132 0C20.9434 0 21.7811 0.181132 22.4151 0.543396L35.9019 8.27925C37.1774 9.01132 38.2189 10.8151 38.2189 12.2792H38.2264ZM30.8755 15.1094C30.8755 14.2943 30.4377 13.5321 29.7283 13.1245L21.2604 8.23396C20.5509 7.82642 19.6755 7.82642 18.966 8.23396L10.4981 13.1245C9.78868 13.5321 9.35094 14.2943 9.35094 15.1094V24.8906C9.35094 25.7057 9.78868 26.4679 10.4981 26.8755L17.4264 30.8755L18.966 31.766C19.3208 31.9698 19.7208 32.0755 20.1132 32.0755C20.5057 32.0755 20.9057 31.9698 21.2604 31.766L29.7283 26.8755C30.4377 26.4679 30.8755 25.7057 30.8755 24.8906V15.1094Z", fill: "url(#paint0_linear_2737_100529)" }), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_2737_100529", x1: 6.2717, y1: 33.8415, x2: 33.9547, y2: 6.15849, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#59DCF1" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#AFB2EE" })))), tl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M10.5 15H13.5L12.92 11.77C13.25 11.6 13.52 11.36 13.71 11.04C13.9 10.72 14 10.37 14 9.99C14 9.44 13.8 8.97 13.41 8.58C13.02 8.19 12.55 7.99 12 7.99C11.45 7.99 10.98 8.19 10.59 8.58C10.2 8.97 10 9.44 10 9.99C10 10.37 10.1 10.72 10.29 11.04C10.48 11.36 10.74 11.6 11.08 11.77L10.5 15ZM12 22C9.68 21.42 7.77 20.09 6.26 18.01C4.75 15.93 4 13.63 4 11.1V5L12 2L20 5V11.1C20 13.63 19.25 15.94 17.74 18.01C16.23 20.08 14.32 21.41 12 22Z", fill: "currentColor" })), rl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M20 23H18V20H15V18H18V15H20V18H23V20H20V23ZM12.6 21.82C12.4 21.88 12.21 21.95 12 22C9.68 21.42 7.77 20.09 6.26 18.01C4.75 15.93 4 13.63 4 11.1V5L12 2L20 5V11.1C20 11.43 19.99 11.75 19.96 12.07C19.65 12.03 19.33 12 19 12C16.74 12 14.73 13.08 13.45 14.74L12.92 11.77C13.25 11.6 13.52 11.36 13.71 11.04C13.9 10.72 14 10.37 14 9.99C14 9.44 13.8 8.97 13.41 8.58C13.02 8.19 12.55 7.99 12 7.99C11.45 7.99 10.98 8.19 10.59 8.58C10.2 8.97 10 9.44 10 9.99C10 10.37 10.1 10.72 10.29 11.04C10.48 11.36 10.74 11.6 11.08 11.77L10.5 14.99H13.26C12.47 16.12 12 17.5 12 18.99C12 19.99 12.22 20.95 12.6 21.81V21.82Z", fill: "currentColor" })), nl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "4 4 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M10.88 14.2498H13.13L12.7 11.8298C12.95 11.7098 13.15 11.5198 13.29 11.2898C13.43 11.0498 13.51 10.7898 13.51 10.4998C13.51 10.0898 13.36 9.72976 13.07 9.43976C12.78 9.14977 12.42 8.99977 12.01 8.99977C11.6 8.99977 11.24 9.14977 10.95 9.43976C10.66 9.72976 10.51 10.0898 10.51 10.4998C10.51 10.7898 10.58 11.0498 10.73 11.2898C10.87 11.5298 11.07 11.7098 11.32 11.8298L10.89 14.2498H10.88ZM12 19.4998C10.26 19.0598 8.83 18.0698 7.7 16.5098C6.57 14.9498 6 13.2298 6 11.3298V6.75977L12 4.50977L18 6.75977V11.3298C18 13.2298 17.43 14.9598 16.3 16.5098C15.17 18.0598 13.73 19.0598 12 19.4998ZM12 17.9198C13.3 17.5098 14.38 16.6798 15.23 15.4398C16.08 14.1998 16.5 12.8298 16.5 11.3198V7.77977L12 6.08977L7.5 7.77977V11.3198C7.5 12.8298 7.92 14.2098 8.77 15.4398C9.62 16.6698 10.69 17.4998 12 17.9198Z", fill: "currentColor" })), ol = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M21.71 18.29C21.52 18.1 21.28 18 21 18V17C21 16.45 20.8 15.98 20.41 15.59C20.02 15.2 19.55 15 19 15C18.45 15 17.98 15.2 17.59 15.59C17.2 15.98 17 16.45 17 17V18C16.72 18 16.48 18.1 16.29 18.29C16.1 18.48 16 18.72 16 19V22C16 22.28 16.1 22.52 16.29 22.71C16.48 22.9 16.72 23 17 23H21C21.28 23 21.52 22.9 21.71 22.71C21.9 22.52 22 22.28 22 22V19C22 18.72 21.9 18.48 21.71 18.29ZM20 18H18V17C18 16.72 18.1 16.48 18.29 16.29C18.48 16.1 18.72 16 19 16C19.28 16 19.52 16.1 19.71 16.29C19.9 16.48 20 16.72 20 17V18ZM12.6 21.82C12.4 21.88 12.21 21.95 12 22C9.68 21.42 7.77 20.09 6.26 18.01C4.75 15.93 4 13.63 4 11.1V5L12 2L20 5V11.1C20 11.43 19.99 11.75 19.96 12.07C19.65 12.03 19.33 12 19 12C16.74 12 14.73 13.08 13.45 14.74L12.92 11.77C13.25 11.6 13.52 11.36 13.71 11.04C13.9 10.72 14 10.37 14 9.99C14 9.44 13.8 8.97 13.41 8.58C13.02 8.19 12.55 7.99 12 7.99C11.45 7.99 10.98 8.19 10.59 8.58C10.2 8.97 10 9.44 10 9.99C10 10.37 10.1 10.72 10.29 11.04C10.48 11.36 10.74 11.6 11.08 11.77L10.5 14.99H13.26C12.47 16.12 12 17.5 12 18.99C12 19.99 12.22 20.95 12.6 21.81V21.82Z", fill: "currentColor" })), al = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M28 28C28.55 28 29.02 27.8 29.41 27.41C29.8 27.02 30 26.55 30 26C30 25.45 29.8 24.98 29.41 24.59C29.02 24.2 28.55 24 28 24C27.45 24 26.98 24.2 26.59 24.59C26.2 24.98 26 25.45 26 26C26 26.55 26.2 27.02 26.59 27.41C26.98 27.8 27.45 28 28 28ZM28 38C25.32 35.72 23.31 33.6 21.99 31.64C20.67 29.68 20 27.87 20 26.2C20 23.7 20.8 21.71 22.41 20.22C24.02 18.74 25.88 17.99 28 17.99C30.12 17.99 31.98 18.73 33.59 20.22C35.2 21.71 36 23.7 36 26.2C36 27.87 35.34 29.68 34.01 31.64C32.68 33.6 30.68 35.72 28 38Z" }))), il = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -64)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M28 76C28.55 76 29.02 75.8 29.41 75.41C29.8 75.02 30 74.55 30 74C30 73.45 29.8 72.98 29.41 72.59C29.02 72.2 28.55 72 28 72C27.45 72 26.98 72.2 26.59 72.59C26.2 72.98 26 73.45 26 74C26 74.55 26.2 75.02 26.59 75.41C26.98 75.8 27.45 76 28 76ZM28 83.35C30.03 81.48 31.54 79.79 32.53 78.26C33.52 76.73 34.01 75.38 34.01 74.2C34.01 72.38 33.43 70.9 32.27 69.74C31.11 68.58 29.69 68 28.01 68C26.33 68 24.91 68.58 23.75 69.74C22.59 70.9 22.01 72.39 22.01 74.2C22.01 75.38 22.5 76.74 23.49 78.26C24.48 79.78 25.98 81.48 28.02 83.35H28ZM28 86C25.32 83.72 23.31 81.6 21.99 79.64C20.67 77.68 20 75.87 20 74.2C20 71.7 20.8 69.71 22.41 68.22C24.02 66.74 25.88 65.99 28 65.99C30.12 65.99 31.98 66.73 33.59 68.22C35.2 69.71 36 71.7 36 74.2C36 75.87 35.34 77.68 34.01 79.64C32.68 81.6 30.68 83.72 28 86Z" }))), ll = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-112 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M125 35C125 31.22 128 28.15 131.75 28.01C131.91 27.39 132 26.78 132 26.2C132 23.7 131.2 21.71 129.59 20.22C127.98 18.73 126.12 18 124 18C121.88 18 120.02 18.74 118.41 20.22C116.8 21.7 116 23.7 116 26.2C116 27.87 116.66 29.68 117.99 31.64C119.32 33.6 121.32 35.72 124 38C124.44 37.62 124.86 37.25 125.26 36.89C125.09 36.29 125 35.66 125 35ZM122.59 27.41C122.2 27.02 122 26.55 122 26C122 25.45 122.2 24.98 122.59 24.59C122.98 24.2 123.45 24 124 24C124.55 24 125.02 24.2 125.41 24.59C125.8 24.98 126 25.45 126 26C126 26.55 125.8 27.02 125.41 27.41C125.02 27.8 124.55 28 124 28C123.45 28 122.98 27.8 122.59 27.41ZM136 34V36H133V39H131V36H128V34H131V31H133V34H136Z" }))), sl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-112 -64)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M125 83C125 83.65 125.1 84.29 125.26 84.89C124.85 85.26 124.44 85.63 124 86C121.32 83.72 119.31 81.6 117.99 79.64C116.67 77.68 116 75.87 116 74.2C116 71.7 116.8 69.71 118.41 68.23C120.02 66.75 121.88 66.01 124 66.01C126.12 66.01 127.98 66.75 129.59 68.23C131.2 69.71 132 71.7 132 74.2C132 74.79 131.91 75.39 131.75 76.01C130.95 76.04 130.18 76.2 129.47 76.48C129.81 75.66 130 74.9 130 74.2C130 72.38 129.42 70.9 128.26 69.74C127.1 68.58 125.68 68 124 68C122.32 68 120.9 68.58 119.74 69.74C118.58 70.9 118 72.39 118 74.2C118 75.38 118.49 76.74 119.48 78.26C120.46 79.79 121.97 81.48 124 83.35C124.37 83.01 124.7 82.69 125.03 82.36C125.01 82.57 125 82.78 125 83ZM133 82V79H131V82H128V84H131V87H133V84H136V82H133ZM124 72C123.45 72 122.98 72.2 122.59 72.59C122.2 72.98 122 73.45 122 74C122 74.55 122.2 75.02 122.59 75.41C122.98 75.8 123.45 76 124 76C124.55 76 125.02 75.8 125.41 75.41C125.8 75.02 126 74.55 126 74C126 73.45 125.8 72.98 125.41 72.59C125.02 72.2 124.55 72 124 72Z" }))), cl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-64 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M77 35C77 31.22 80 28.15 83.75 28.01C83.91 27.39 84 26.78 84 26.2C84 23.7 83.2 21.71 81.59 20.22C79.98 18.73 78.12 18 76 18C73.88 18 72.02 18.74 70.41 20.22C68.8 21.7 68 23.7 68 26.2C68 27.87 68.66 29.68 69.99 31.64C71.32 33.6 73.32 35.72 76 38C76.44 37.62 76.86 37.25 77.26 36.89C77.09 36.29 77 35.66 77 35ZM74.59 27.41C74.2 27.02 74 26.55 74 26C74 25.45 74.2 24.98 74.59 24.59C74.98 24.2 75.45 24 76 24C76.55 24 77.02 24.2 77.41 24.59C77.8 24.98 78 25.45 78 26C78 26.55 77.8 27.02 77.41 27.41C77.02 27.8 76.55 28 76 28C75.45 28 74.98 27.8 74.59 27.41ZM85.41 35L87.53 37.12L86.12 38.53L84 36.41L81.88 38.53L80.47 37.12L82.59 35L80.47 32.88L81.88 31.47L84 33.59L86.12 31.47L87.53 32.88L85.41 35Z" }))), dl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-64 -64)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M75.41 72.59C75.8 72.98 76 73.45 76 74C76 74.55 75.8 75.02 75.41 75.41C75.02 75.8 74.55 76 74 76C73.45 76 72.98 75.8 72.59 75.41C72.2 75.02 72 74.55 72 74C72 73.45 72.2 72.98 72.59 72.59C72.98 72.2 73.45 72 74 72C74.55 72 75.02 72.2 75.41 72.59ZM85.54 80.88L84.13 79.47L82.01 81.59L79.89 79.47L78.48 80.88L80.6 83L78.48 85.12L79.89 86.53L82.01 84.41L84.13 86.53L85.54 85.12L83.42 83L85.54 80.88ZM79.47 76.48C80.18 76.2 80.95 76.04 81.75 76.01C81.91 75.39 82 74.78 82 74.2C82 71.7 81.2 69.71 79.59 68.23C77.98 66.75 76.12 66.01 74 66.01C71.88 66.01 70.02 66.75 68.41 68.23C66.8 69.71 66 71.7 66 74.2C66 75.87 66.66 77.68 67.99 79.64C69.32 81.6 71.32 83.72 74 86C74.44 85.62 74.86 85.25 75.26 84.89C75.09 84.29 75 83.66 75 83C75 82.78 75.01 82.57 75.03 82.36C74.7 82.69 74.37 83.01 74 83.35C71.97 81.48 70.46 79.79 69.48 78.26C68.5 76.74 68 75.38 68 74.2C68 72.38 68.58 70.9 69.74 69.74C70.9 68.58 72.32 68 74 68C75.68 68 77.1 68.58 78.26 69.74C79.42 70.9 80 72.39 80 74.2C80 74.9 79.81 75.66 79.47 76.48Z" }))), ul = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-160 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M179.75 28.01C179.91 27.39 180 26.78 180 26.2C180 23.7 179.2 21.71 177.59 20.22C175.98 18.73 174.12 18 172 18C169.88 18 168.02 18.74 166.41 20.22C164.8 21.7 164 23.7 164 26.2C164 27.87 164.66 29.68 165.99 31.64C167.32 33.6 169.32 35.72 172 38C172.44 37.62 172.86 37.25 173.26 36.89C173.09 36.29 173 35.66 173 35C173 31.22 176 28.15 179.75 28.01ZM173.41 27.41C173.02 27.8 172.55 28 172 28C171.45 28 170.98 27.8 170.59 27.41C170.2 27.02 170 26.55 170 26C170 25.45 170.2 24.98 170.59 24.59C170.98 24.2 171.45 24 172 24C172.55 24 173.02 24.2 173.41 24.59C173.8 24.98 174 25.45 174 26C174 26.55 173.8 27.02 173.41 27.41ZM179 33V34H182C182.28 34 182.52 34.1 182.71 34.29C182.9 34.48 183 34.72 183 35V38C183 38.28 182.9 38.52 182.71 38.71C182.52 38.9 182.28 39 182 39H181V40H179V39H177V37H181V36H178C177.72 36 177.48 35.9 177.29 35.71C177.1 35.52 177 35.28 177 35V32C177 31.72 177.1 31.48 177.29 31.29C177.48 31.1 177.72 31 178 31H179V30H181V31H183V33H179Z" }))), pl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-160 -64)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M178 74.2C178 72.38 177.42 70.9 176.26 69.74C175.1 68.58 173.68 68 172 68C170.32 68 168.9 68.58 167.74 69.74C166.58 70.9 166 72.39 166 74.2C166 75.38 166.49 76.74 167.48 78.26C168.46 79.79 169.97 81.48 172 83.35C172.37 83.01 172.7 82.69 173.03 82.36C173.01 82.57 173 82.78 173 83C173 83.65 173.1 84.29 173.26 84.89C172.85 85.26 172.44 85.63 172 86C169.32 83.72 167.31 81.6 165.99 79.64C164.67 77.68 164 75.87 164 74.2C164 71.7 164.8 69.71 166.41 68.23C168.02 66.75 169.88 66.01 172 66.01C174.12 66.01 175.98 66.75 177.59 68.23C179.2 69.71 180 71.7 180 74.2C180 74.79 179.91 75.39 179.75 76.01C178.95 76.04 178.18 76.2 177.47 76.48C177.81 75.66 178 74.9 178 74.2ZM172 72C171.45 72 170.98 72.2 170.59 72.59C170.2 72.98 170 73.45 170 74C170 74.55 170.2 75.02 170.59 75.41C170.98 75.8 171.45 76 172 76C172.55 76 173.02 75.8 173.41 75.41C173.8 75.02 174 74.55 174 74C174 73.45 173.8 72.98 173.41 72.59C173.02 72.2 172.55 72 172 72ZM183 81V79H181V78H179V79H178C177.72 79 177.48 79.1 177.29 79.29C177.1 79.48 177 79.72 177 80V83C177 83.28 177.1 83.52 177.29 83.71C177.48 83.9 177.72 84 178 84H181V85H177V87H179V88H181V87H182C182.28 87 182.52 86.9 182.71 86.71C182.9 86.52 183 86.28 183 86V83C183 82.72 182.9 82.48 182.71 82.29C182.52 82.1 182.28 82 182 82H179V81H183Z" }))), ml = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#BDBDBD", d: "M6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4" })), hl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M18.413 11.002H9.825l3.588-3.588-1.417-1.412-6 6 6 6 1.417-1.412-3.588-3.588h8.588z" })), gl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M11.207 5.795v8.588l-3.588-3.588-1.412 1.417 6 6 6-6-1.412-1.417-3.588 3.588V5.795z" })), Cl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M13 18V9.412L16.588 13 18 11.583l-6-6-6 6L7.412 13 11 9.412V18z" })), vl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M18 15.75q0 2.6-1.825 4.425Q14.349 22 11.75 22q-2.6 0-4.425-1.825T5.5 15.75V6.5q0-1.875 1.313-3.187Q8.124 2 10 2t3.188 1.313T14.5 6.5v8.75q0 1.15-.8 1.95t-1.95.8a2.65 2.65 0 0 1-1.95-.8 2.65 2.65 0 0 1-.8-1.95V6h2v9.25a.73.73 0 0 0 .75.75.73.73 0 0 0 .75-.75V6.5q-.025-1.05-.738-1.775Q11.05 4 10 4t-1.775.725T7.5 6.5v9.25q-.025 1.775 1.225 3.012T11.75 20q1.75 0 2.975-1.238T16 15.75V6h2z" })), fl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 80, height: 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_13723_338849)" }, /* @__PURE__ */ s.createElement("path", { d: "M8.88665 1.33496H71.1084C75.2775 1.33496 78.6649 4.72239 78.6649 8.89153V71.1133C78.6649 75.2824 75.2775 78.6698 71.1084 78.6698H8.88665C4.71751 78.6698 1.33008 75.2824 1.33008 71.1133V8.88696C1.33465 4.71782 4.71751 1.33496 8.88665 1.33496Z", fill: "white" }), /* @__PURE__ */ s.createElement("path", { d: "M71.1131 2.66514C74.5463 2.66514 77.3349 5.45829 77.3349 8.88686V71.1086C77.3349 74.5417 74.5417 77.3303 71.1131 77.3303H8.88686C5.45371 77.3303 2.66514 74.5371 2.66514 71.1086V8.88686C2.66514 5.45371 5.45829 2.66514 8.88686 2.66514H71.1086M71.1131 0H8.88686C3.98171 0 0 3.98171 0 8.88686V71.1086C0 76.0183 3.98171 79.9954 8.88686 79.9954H71.1086C76.0183 79.9954 79.9954 76.0137 79.9954 71.1086V8.88686C79.9954 3.97714 76.0137 0 71.1086 0H71.1131Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M17.8927 56.3062L17.3533 54.9027H13.8882L13.3487 56.3062H11.9453L14.8207 48.9873H16.4207L19.2962 56.3062H17.8927ZM15.6207 50.0753L14.2493 53.7736H16.9922L15.6207 50.0753Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M23.8444 56.3068V55.6028C23.4604 56.0325 22.8021 56.4348 21.9701 56.4348C20.8272 56.4348 20.2695 55.8405 20.2695 54.757V51.0039H21.4215V54.341C21.4215 55.1639 21.8375 55.4153 22.4867 55.4153C23.0672 55.4153 23.5747 55.0862 23.849 54.725V51.0039H25.001V56.3022H23.849L23.8444 56.3068Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M27.0027 55.077V52.0141H26.125V51.0038H27.0027V49.5547H28.1547V51.0038H29.229V52.0141H28.1547V54.789C28.1547 55.1501 28.3284 55.4153 28.6576 55.4153C28.877 55.4153 29.0873 55.3284 29.1741 55.2278L29.4484 56.0964C29.2381 56.293 28.8999 56.4347 28.3604 56.4347C27.4736 56.4347 26.9981 55.9501 26.9981 55.0724L27.0027 55.077Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M34.153 56.3062V52.969C34.153 52.1462 33.7233 51.8947 33.0787 51.8947C32.4982 51.8947 31.9907 52.2467 31.7165 52.6079V56.3062H30.5645V48.9873H31.7165V51.7302C32.0685 51.3142 32.7587 50.8753 33.5907 50.8753C34.7336 50.8753 35.3005 51.465 35.3005 52.553V56.3062H34.1484H34.153Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M36.7227 53.6508C36.7227 52.1377 37.7649 50.876 39.4427 50.876C41.1204 50.876 42.1764 52.1377 42.1764 53.6508C42.1764 55.164 41.1432 56.4394 39.4427 56.4394C37.7421 56.4394 36.7227 55.1777 36.7227 53.6508ZM40.9787 53.6508C40.9787 52.7183 40.4301 51.8954 39.4427 51.8954C38.4552 51.8954 37.9158 52.7183 37.9158 53.6508C37.9158 54.5834 38.4644 55.4154 39.4427 55.4154C40.4209 55.4154 40.9787 54.5925 40.9787 53.6508Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M43.6113 56.3068V51.0085H44.7633V51.7902C45.1565 51.2828 45.7965 50.8896 46.4868 50.8896V52.0325C46.3862 52.0096 46.2673 52.0005 46.1256 52.0005C45.641 52.0005 44.9965 52.3296 44.7633 52.7045V56.3159H43.6113V56.3068Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M47.5117 49.4172C47.5117 49.0241 47.8409 48.7041 48.2249 48.7041C48.6089 48.7041 48.938 49.0241 48.938 49.4172C48.938 49.8104 48.618 50.1304 48.2249 50.1304C47.8317 50.1304 47.5117 49.8104 47.5117 49.4172ZM47.6534 56.3064V51.0081H48.8054V56.3064H47.6534Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M50.1895 56.3068V55.4382L52.8135 52.0142H50.1895V51.0039H54.3495V51.8496L51.7072 55.3056H54.3952V56.3022H50.194L50.1895 56.3068Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M58.0747 50.876C59.6656 50.876 60.685 52.092 60.685 53.7605V54.0348H56.5936C56.6804 54.8348 57.2839 55.4931 58.285 55.4931C58.8016 55.4931 59.4141 55.2828 59.789 54.9126L60.3147 55.6714C59.789 56.1743 59.0073 56.4394 58.1616 56.4394C56.5707 56.4394 55.3867 55.3331 55.3867 53.6508C55.3867 52.1148 56.5067 50.876 58.0747 50.876ZM56.5844 53.2257H59.5696C59.5467 52.5994 59.1216 51.8223 58.0793 51.8223C57.0919 51.8223 56.6439 52.5811 56.589 53.2257H56.5844Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M65.8602 56.3065V55.5842C65.4534 56.1099 64.8408 56.439 64.1596 56.439C62.7974 56.439 61.8008 55.4059 61.8008 53.6642C61.8008 51.9225 62.7882 50.8756 64.1596 50.8756C64.8179 50.8756 65.4305 51.1819 65.8602 51.7442V48.9922H67.0122V56.311H65.8602V56.3065ZM65.8602 52.6082C65.5951 52.215 65.0374 51.895 64.4888 51.895C63.5791 51.895 62.9985 52.631 62.9985 53.6596C62.9985 54.6882 63.5791 55.415 64.4888 55.415C65.0374 55.415 65.5951 55.1088 65.8602 54.711V52.6036V52.6082Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M13.4043 67.2778V59.959H16.1243C18.4054 59.959 19.9552 61.4721 19.9552 63.6253C19.9552 65.7784 18.41 67.2778 16.1243 67.2778H13.4043ZM14.6843 66.1487H16.1197C17.7106 66.1487 18.634 65.0058 18.634 63.6253C18.634 62.2447 17.7563 61.0927 16.1197 61.0927H14.6843V66.1487Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M21.3262 60.3889C21.3262 59.9958 21.6553 59.6758 22.0393 59.6758C22.4233 59.6758 22.7525 59.9958 22.7525 60.3889C22.7525 60.7821 22.4325 61.1021 22.0393 61.1021C21.6462 61.1021 21.3262 60.7821 21.3262 60.3889ZM21.4725 67.2781V61.9798H22.6245V67.2781H21.4725Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M24.4534 65.7513C24.8283 66.1353 25.5597 66.4965 26.2546 66.4965C26.9494 66.4965 27.2969 66.2451 27.2969 65.8473C27.2969 65.3856 26.7392 65.2211 26.09 65.0793C25.1803 64.8828 24.0923 64.6405 24.0923 63.4565C24.0923 62.5879 24.8374 61.8428 26.1769 61.8428C27.0774 61.8428 27.7586 62.1628 28.2386 62.5879L27.754 63.4016C27.434 63.0405 26.8443 62.7662 26.186 62.7662C25.5826 62.7662 25.1986 62.9856 25.1986 63.3605C25.1986 63.7673 25.7243 63.9091 26.3506 64.0508C27.274 64.2473 28.4032 64.5125 28.4032 65.7605C28.4032 66.6931 27.626 67.4062 26.1997 67.4062C25.2992 67.4062 24.4763 67.1228 23.9277 66.5833L24.4534 65.7513Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M30.157 66.0477V62.9848H29.2793V61.9745H30.157V60.5254H31.309V61.9745H32.3833V62.9848H31.309V65.7597C31.309 66.1208 31.4827 66.386 31.8119 66.386C32.0313 66.386 32.2416 66.2991 32.3284 66.1985L32.6027 67.0671C32.3924 67.2637 32.0542 67.4054 31.5147 67.4054C30.6279 67.4054 30.1524 66.9208 30.1524 66.0431L30.157 66.0477Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M33.7148 67.2775V61.9792H34.8668V62.7609C35.26 62.2535 35.9 61.8604 36.5903 61.8604V63.0032C36.4897 62.9804 36.3708 62.9712 36.2291 62.9712C35.7446 62.9712 35.1 63.3003 34.8668 63.6752V67.2866H33.7148V67.2775Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M37.6133 60.3889C37.6133 59.9958 37.9424 59.6758 38.3264 59.6758C38.7104 59.6758 39.0396 59.9958 39.0396 60.3889C39.0396 60.7821 38.7196 61.1021 38.3264 61.1021C37.9333 61.1021 37.6133 60.7821 37.6133 60.3889ZM37.755 67.2781V61.9798H38.907V67.2781H37.755Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M40.6484 67.2778V59.959H41.8004V62.711C42.2164 62.1533 42.8336 61.8424 43.501 61.8424C44.8633 61.8424 45.8507 62.9167 45.8507 64.631C45.8507 66.3453 44.8542 67.4058 43.501 67.4058C42.8107 67.4058 42.2073 67.0767 41.8004 66.551V67.2733H40.6484V67.2778ZM41.8004 65.687C42.0519 66.0801 42.6233 66.391 43.1627 66.391C44.0862 66.391 44.6667 65.6687 44.6667 64.6356C44.6667 63.6024 44.0862 62.871 43.1627 62.871C42.6233 62.871 42.0564 63.2001 41.8004 63.5933V65.687Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M50.8717 67.2775V66.5735C50.4877 67.0032 49.8294 67.4055 48.9974 67.4055C47.8546 67.4055 47.2969 66.8112 47.2969 65.7278V61.9746H48.4489V65.3117C48.4489 66.1346 48.8649 66.386 49.514 66.386C50.0946 66.386 50.602 66.0569 50.8763 65.6958V61.9746H52.0283V67.2729H50.8763L50.8717 67.2775Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M54.0301 66.0477V62.9848H53.1523V61.9745H54.0301V60.5254H55.1821V61.9745H56.2563V62.9848H55.1821V65.7597C55.1821 66.1208 55.3558 66.386 55.6849 66.386C55.9043 66.386 56.1146 66.2991 56.2015 66.1985L56.4758 67.0671C56.2655 67.2637 55.9272 67.4054 55.3878 67.4054C54.5009 67.4054 54.0255 66.9208 54.0255 66.0431L54.0301 66.0477Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M57.1211 64.6215C57.1211 63.1084 58.1634 61.8467 59.8411 61.8467C61.5188 61.8467 62.5748 63.1084 62.5748 64.6215C62.5748 66.1347 61.5417 67.4101 59.8411 67.4101C58.1405 67.4101 57.1211 66.1484 57.1211 64.6215ZM61.3771 64.6215C61.3771 63.689 60.8285 62.8661 59.8411 62.8661C58.8537 62.8661 58.3142 63.689 58.3142 64.6215C58.3142 65.5541 58.8628 66.3861 59.8411 66.3861C60.8194 66.3861 61.3771 65.5633 61.3771 64.6215Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M64.0098 67.2775V61.9792H65.1618V62.7609C65.5549 62.2535 66.1949 61.8604 66.8852 61.8604V63.0032C66.7846 62.9804 66.6658 62.9712 66.5241 62.9712C66.0395 62.9712 65.3949 63.3003 65.1618 63.6752V67.2866H64.0098V67.2775Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M9.0293 40H70.9722", stroke: "#8DC63E", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ s.createElement("path", { d: "M69.6875 27.9817C69.6875 27.6434 69.9572 27.3691 70.3001 27.3691C70.6429 27.3691 70.9126 27.6389 70.9126 27.9817C70.9126 28.3246 70.6429 28.5943 70.3001 28.5943C69.9572 28.5943 69.6875 28.3246 69.6875 27.9817ZM70.8212 27.9817C70.8212 27.6937 70.5835 27.4651 70.3001 27.4651C70.0166 27.4651 69.7789 27.6937 69.7789 27.9817C69.7789 28.2697 70.0166 28.4983 70.3001 28.4983C70.5835 28.4983 70.8212 28.2697 70.8212 27.9817ZM70.5926 28.3109H70.4784L70.2772 28.0046H70.1629V28.3109H70.0669V27.6434H70.3595C70.4829 27.6434 70.5972 27.6754 70.5972 27.8217C70.5972 27.9543 70.5058 28.0046 70.3869 28.0046L70.5881 28.3109H70.5926ZM70.2818 27.9086C70.3641 27.9086 70.5104 27.9223 70.5104 27.8171C70.5104 27.7486 70.4189 27.7349 70.3458 27.7349H70.1675V27.9086H70.2818Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M30.5888 22.5879V18.2314H29.8848V17.4679H31.4985V22.5879H30.5888ZM31.0871 15.5251C31.2425 15.5251 31.3751 15.5799 31.4848 15.6897C31.5945 15.7994 31.6493 15.9319 31.6493 16.0828C31.6493 16.2337 31.5945 16.3708 31.4848 16.4805C31.3751 16.5902 31.2425 16.6451 31.0871 16.6451C30.9316 16.6451 30.8036 16.5902 30.6939 16.4805C30.5842 16.3708 30.5293 16.2382 30.5293 16.0828C30.5293 15.9274 30.5842 15.7948 30.6939 15.6851C30.8036 15.5754 30.9362 15.5205 31.0916 15.5205L31.0871 15.5251Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M35.8274 22.5878V19.6072C35.8274 19.0632 35.7452 18.6792 35.5806 18.4598C35.416 18.2403 35.1417 18.1306 34.7577 18.1306C34.552 18.1306 34.3326 18.1946 34.1086 18.318C33.88 18.4415 33.7063 18.5969 33.5874 18.7752V22.5832H32.6777V17.4632H33.2994L33.5874 18.1215C33.8892 17.6186 34.3783 17.3672 35.0549 17.3672C36.1794 17.3672 36.7372 18.0483 36.7372 19.4152V22.5878H35.8274Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M41.0806 22.5832V22.2038C40.7652 22.5192 40.3034 22.6746 39.7046 22.6746C39.0646 22.6746 38.5434 22.4461 38.1457 21.9844C37.748 21.5272 37.5469 20.9146 37.5469 20.1466C37.5469 19.3786 37.7754 18.7204 38.2372 18.1764C38.6943 17.6324 39.2429 17.3626 39.8783 17.3626C40.4086 17.3626 40.8109 17.4861 41.0852 17.7375V15.3604H41.9949V22.5786H41.0852L41.0806 22.5832ZM41.0806 18.6518C40.852 18.3089 40.5366 18.1352 40.1389 18.1352C39.6497 18.1352 39.2566 18.3181 38.9549 18.6792C38.6532 19.0449 38.5023 19.5066 38.5023 20.0644C38.5023 21.2986 39.0646 21.9158 40.1846 21.9158C40.3263 21.9158 40.5 21.8701 40.7012 21.7786C40.9023 21.6872 41.0257 21.5912 41.0806 21.4906V18.6518Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M44.1024 17.4629V20.7315C44.1024 21.5223 44.4453 21.9155 45.131 21.9155C45.4327 21.9155 45.707 21.8286 45.9538 21.6595C46.2007 21.4857 46.3653 21.2892 46.4476 21.0606V17.4629H47.3573V22.5829H46.4476V21.8743C46.347 22.0755 46.1413 22.2583 45.835 22.4275C45.5287 22.5966 45.227 22.6789 44.9344 22.6789C44.3721 22.6789 43.9424 22.5189 43.6453 22.1943C43.3481 21.8743 43.1973 21.4126 43.1973 20.8229V17.4629H44.107H44.1024Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M52.5039 17.8789L52.0559 18.5189C51.9644 18.4274 51.7999 18.3406 51.5667 18.2537C51.3336 18.1714 51.1004 18.1303 50.8764 18.1303C50.3827 18.1303 49.9896 18.304 49.7016 18.6514C49.4136 18.9989 49.2673 19.4697 49.2673 20.0732C49.2673 20.6766 49.4136 21.1292 49.7107 21.4446C50.0079 21.76 50.4193 21.9154 50.945 21.9154C51.3519 21.9154 51.7633 21.7554 52.1793 21.44L52.5359 22.2034C52.0467 22.5189 51.4433 22.6743 50.721 22.6743C49.9987 22.6743 49.4456 22.4412 48.9884 21.9703C48.5313 21.4994 48.3027 20.8686 48.3027 20.0686C48.3027 19.2686 48.5404 18.5966 49.0113 18.1029C49.4867 17.6092 50.1313 17.3623 50.9542 17.3623C51.2193 17.3623 51.5073 17.4172 51.8136 17.5314C52.1244 17.6412 52.3484 17.76 52.4993 17.8743L52.5039 17.8789Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M53.6197 18.1808H53.0254V17.463H53.6197V16.3933L54.5294 16.0459V17.4676H55.9374V18.1853H54.5294V20.7316C54.5294 21.1613 54.6025 21.4676 54.7488 21.6505C54.8951 21.8333 55.1282 21.9248 55.4482 21.9248C55.6814 21.9248 55.9237 21.8653 56.1705 21.7465L56.3031 22.5465C55.9283 22.6425 55.5122 22.6882 55.0642 22.6882C54.6574 22.6882 54.3191 22.5373 54.0402 22.2356C53.7614 21.9339 53.6197 21.5545 53.6197 21.0973V18.1899V18.1808Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M57.5185 22.5879V18.2314H56.8145V17.4679H58.4282V22.5879H57.5185ZM58.0167 15.5251C58.1722 15.5251 58.3047 15.5799 58.4145 15.6897C58.5242 15.7994 58.579 15.9319 58.579 16.0828C58.579 16.2337 58.5242 16.3708 58.4145 16.4805C58.3047 16.5902 58.1722 16.6451 58.0167 16.6451C57.8613 16.6451 57.7333 16.5902 57.6236 16.4805C57.5139 16.3708 57.459 16.2382 57.459 16.0828C57.459 15.9274 57.5139 15.7948 57.6236 15.6851C57.7333 15.5754 57.8659 15.5205 58.0213 15.5205L58.0167 15.5251Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M61.5238 22.6835H61.2861L59.0918 17.4492H60.0884L61.4415 21.0378L62.8221 17.4492H63.7729L61.5238 22.6835Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M68.545 20.1146H64.8512C64.8512 20.7135 65.0158 21.1752 65.345 21.4952C65.633 21.774 66.0078 21.9158 66.465 21.9158C66.9861 21.9158 67.4204 21.7649 67.7678 21.4632L68.1518 22.1169C68.0101 22.2586 67.7952 22.3775 67.5072 22.4826C67.1461 22.6152 66.7392 22.6838 66.2912 22.6838C65.6467 22.6838 65.1027 22.4643 64.6501 22.03C64.1472 21.55 63.9004 20.9009 63.9004 20.0872C63.9004 19.2735 64.1564 18.5649 64.6684 18.0529C65.1255 17.5958 65.6695 17.3672 66.3004 17.3672C67.0318 17.3672 67.6032 17.5729 68.0192 17.9843C68.4215 18.382 68.6227 18.9032 68.6227 19.5569C68.6227 19.758 68.5998 19.9409 68.5495 20.11L68.545 20.1146ZM66.337 18.1352C65.9301 18.1352 65.5918 18.2678 65.3175 18.5283C65.057 18.7752 64.9061 19.086 64.8741 19.4563H67.7084C67.7084 19.0906 67.5941 18.7843 67.3655 18.5375C67.1141 18.2678 66.7712 18.1352 66.337 18.1352Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M31.7125 28.1053C31.4839 28.3887 31.1365 28.5305 30.6702 28.5305C30.4188 28.5305 30.1993 28.439 30.0165 28.2562C29.8336 28.0733 29.7422 27.8493 29.7422 27.575C29.7422 27.2505 29.8839 26.9762 30.1673 26.7522C30.4508 26.5282 30.8119 26.4139 31.2553 26.4139C31.3742 26.4139 31.5113 26.4413 31.6622 26.4916C31.6622 25.975 31.429 25.7145 30.9673 25.7145C30.6108 25.7145 30.341 25.8105 30.149 26.0025L29.9113 25.527C30.021 25.4402 30.1673 25.3625 30.3593 25.303C30.5513 25.239 30.7296 25.207 30.9033 25.207C31.3696 25.207 31.7033 25.3122 31.9136 25.5225C32.1239 25.7327 32.229 26.071 32.229 26.5282V27.6756C32.229 27.959 32.3113 28.1419 32.4805 28.2379V28.5213C32.2473 28.5213 32.0782 28.4893 31.9639 28.4207C31.8496 28.3567 31.7673 28.247 31.717 28.0962L31.7125 28.1053ZM31.6576 26.8985C31.4793 26.8573 31.3513 26.839 31.2828 26.839C30.9948 26.839 30.7616 26.9122 30.5788 27.0585C30.3959 27.2047 30.3045 27.3785 30.3045 27.5796C30.3045 27.9133 30.501 28.0779 30.8942 28.0779C31.1822 28.0779 31.4336 27.9407 31.6576 27.6665V26.8939V26.8985Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M34.4243 25.2712V27.3146C34.4243 27.8083 34.6391 28.0552 35.0688 28.0552C35.2563 28.0552 35.4254 28.0003 35.5809 27.8952C35.7363 27.7855 35.8368 27.662 35.8871 27.5203V25.2712H36.454V28.4712H35.8871V28.0277C35.8231 28.1512 35.6951 28.27 35.5031 28.3752C35.3111 28.4803 35.1237 28.5306 34.9409 28.5306C34.5889 28.5306 34.3237 28.43 34.1363 28.2289C33.9489 28.0277 33.8574 27.7397 33.8574 27.3695V25.2666H34.4243V25.2712Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M38.3547 25.7193H37.9844V25.2713H38.3547V24.5993L38.9215 24.3799V25.2667H39.7992V25.7147H38.9215V27.3056C38.9215 27.5753 38.9672 27.7673 39.0587 27.8816C39.1501 27.9959 39.2964 28.0507 39.4975 28.0507C39.6438 28.0507 39.7947 28.0142 39.9501 27.941L40.0324 28.4393C39.7992 28.4987 39.5387 28.5307 39.2598 28.5307C39.0084 28.5307 38.7935 28.4347 38.6198 28.2473C38.4461 28.0599 38.3592 27.8222 38.3592 27.5342V25.7147L38.3547 25.7193Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M41.1667 26.8619C41.1667 26.3682 41.2993 25.9705 41.5644 25.6642C41.8295 25.3625 42.1815 25.207 42.6158 25.207C43.073 25.207 43.4295 25.3533 43.681 25.6459C43.9324 25.9385 44.0604 26.3453 44.0604 26.8619C44.0604 27.3785 43.9324 27.7853 43.6718 28.0825C43.4112 28.3796 43.0593 28.5305 42.6158 28.5305C42.1724 28.5305 41.8021 28.3796 41.5461 28.0779C41.2901 27.7762 41.1621 27.3693 41.1621 26.8619H41.1667ZM41.761 26.8619C41.761 27.6665 42.0444 28.0687 42.6112 28.0687C42.8764 28.0687 43.0821 27.959 43.233 27.7442C43.3838 27.5293 43.457 27.2367 43.457 26.8619C43.457 26.0665 43.1735 25.6733 42.6067 25.6733C42.3461 25.6733 42.1404 25.7785 41.985 25.9887C41.8295 26.199 41.7518 26.4916 41.7518 26.8619H41.761Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M49.3298 28.4713V26.4462C49.3298 25.9433 49.1104 25.6919 48.6761 25.6919C48.539 25.6919 48.411 25.7331 48.2921 25.8199C48.1732 25.9068 48.091 26.0028 48.0452 26.1079V28.4759H47.4784V26.1993C47.4784 26.0393 47.419 25.9159 47.3001 25.8291C47.1812 25.7376 47.0258 25.6919 46.8292 25.6919C46.715 25.6919 46.5961 25.7376 46.4681 25.8245C46.3401 25.9113 46.2487 26.0073 46.1938 26.1125V28.4759H45.627V25.2759H45.9972L46.1847 25.6462C46.4041 25.3582 46.6784 25.2165 47.0075 25.2165C47.4647 25.2165 47.7847 25.3582 47.9721 25.6416C48.0361 25.5182 48.155 25.4176 48.3287 25.3353C48.5024 25.2531 48.6807 25.2119 48.8635 25.2119C49.1927 25.2119 49.4487 25.3125 49.6315 25.5045C49.8144 25.6965 49.9058 25.9753 49.9058 26.3319V28.4713H49.339H49.3298Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M53.4312 28.1053C53.2027 28.3887 52.8552 28.5305 52.3889 28.5305C52.1375 28.5305 51.9181 28.439 51.7352 28.2562C51.5524 28.0733 51.4609 27.8493 51.4609 27.575C51.4609 27.2505 51.6027 26.9762 51.8861 26.7522C52.1695 26.5282 52.5307 26.4139 52.9741 26.4139C53.0929 26.4139 53.2301 26.4413 53.3809 26.4916C53.3809 25.975 53.1478 25.7145 52.6861 25.7145C52.3295 25.7145 52.0598 25.8105 51.8678 26.0025L51.6301 25.527C51.7398 25.4402 51.8861 25.3625 52.0781 25.303C52.2701 25.239 52.4484 25.207 52.6221 25.207C53.0884 25.207 53.4221 25.3122 53.6324 25.5225C53.8427 25.7327 53.9478 26.071 53.9478 26.5282V27.6756C53.9478 27.959 54.0301 28.1419 54.1992 28.2379V28.5213C53.9661 28.5213 53.7969 28.4893 53.6827 28.4207C53.5684 28.3567 53.4861 28.247 53.4358 28.0962L53.4312 28.1053ZM53.3764 26.8985C53.1981 26.8573 53.0701 26.839 53.0015 26.839C52.7135 26.839 52.4804 26.9122 52.2975 27.0585C52.1147 27.2047 52.0278 27.3785 52.0278 27.5796C52.0278 27.9133 52.2244 28.0779 52.6175 28.0779C52.9055 28.0779 53.1569 27.9407 53.3809 27.6665V26.8939L53.3764 26.8985Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M55.8996 25.7193H55.5293V25.2713H55.8996V24.5993L56.4664 24.3799V25.2667H57.3442V25.7147H56.4664V27.3056C56.4664 27.5753 56.5122 27.7673 56.6036 27.8816C56.695 27.9959 56.8413 28.0507 57.0424 28.0507C57.1887 28.0507 57.3396 28.0142 57.495 27.941L57.5773 28.4393C57.3442 28.4987 57.0836 28.5307 56.8047 28.5307C56.5533 28.5307 56.3384 28.4347 56.1647 28.2473C55.991 28.0599 55.9042 27.8222 55.9042 27.5342V25.7147L55.8996 25.7193Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M59.2553 28.471V25.7464H58.8164V25.2664H59.8221V28.4664H59.2553V28.471ZM59.5661 24.0596C59.6621 24.0596 59.749 24.0916 59.8176 24.1647C59.8861 24.2333 59.9227 24.3156 59.9227 24.4116C59.9227 24.5076 59.8861 24.5944 59.8176 24.663C59.749 24.7316 59.6667 24.7681 59.5661 24.7681C59.4655 24.7681 59.3878 24.7316 59.3193 24.663C59.2507 24.5944 59.2141 24.5121 59.2141 24.4116C59.2141 24.311 59.2461 24.2333 59.3147 24.1647C59.3833 24.0961 59.4655 24.0641 59.5615 24.0641L59.5661 24.0596Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M61.3757 26.8619C61.3757 26.3682 61.5082 25.9705 61.7734 25.6642C62.0385 25.3625 62.3905 25.207 62.8248 25.207C63.2819 25.207 63.6385 25.3533 63.8899 25.6459C64.1414 25.9385 64.2694 26.3453 64.2694 26.8619C64.2694 27.3785 64.1414 27.7853 63.8808 28.0825C63.6202 28.3796 63.2682 28.5305 62.8248 28.5305C62.3814 28.5305 62.0111 28.3796 61.7551 28.0779C61.4991 27.7762 61.3711 27.3693 61.3711 26.8619H61.3757ZM61.9745 26.8619C61.9745 27.6665 62.2579 28.0687 62.8248 28.0687C63.0899 28.0687 63.2957 27.959 63.4465 27.7442C63.5974 27.5293 63.6705 27.2367 63.6705 26.8619C63.6705 26.0665 63.3871 25.6733 62.8202 25.6733C62.5597 25.6733 62.354 25.7785 62.1985 25.9887C62.0431 26.199 61.9654 26.4916 61.9654 26.8619H61.9745Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M67.7301 28.4707V26.6101C67.7301 26.2672 67.6798 26.0295 67.5746 25.8924C67.4741 25.7552 67.3003 25.6867 67.0581 25.6867C66.9301 25.6867 66.7929 25.7278 66.6512 25.8055C66.5095 25.8832 66.3998 25.9792 66.3266 26.0935V28.4752H65.7598V25.2752H66.1483L66.3266 25.6867C66.514 25.3712 66.8203 25.2158 67.2455 25.2158C67.9495 25.2158 68.2969 25.641 68.2969 26.4958V28.4798H67.7301V28.4707Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M24.9971 22.4045C24.9971 22.1714 24.988 21.9383 24.9651 21.7097L26.4966 20.6811C26.4188 20.288 26.3183 19.9085 26.1903 19.5383L24.3526 19.4148C24.1606 18.9897 23.9274 18.5874 23.6577 18.2125L24.4668 16.5623C24.2063 16.2651 23.9274 15.9817 23.6303 15.7211L21.98 16.5303C21.6051 16.2605 21.2028 16.0274 20.7777 15.8354L20.6543 13.9977C20.284 13.8697 19.9 13.7691 19.5114 13.6914L18.4828 15.2183C18.2543 15.1954 18.0211 15.1863 17.788 15.1863C17.5548 15.1863 17.3217 15.1954 17.0931 15.2183L16.0691 13.6914C15.676 13.7691 15.2966 13.8697 14.9217 13.9977L14.7983 15.8354C14.3731 16.0274 13.9708 16.2605 13.596 16.5303L11.9457 15.7211C11.6486 15.9817 11.3651 16.2605 11.1091 16.5623L11.9228 18.2125C11.6531 18.5874 11.42 18.9897 11.228 19.4148L9.39027 19.5383C9.26227 19.9085 9.1617 20.2925 9.08398 20.6811L10.6154 21.7051C10.5926 21.9337 10.5788 22.1668 10.5788 22.4C10.5788 22.6331 10.5926 22.8663 10.6154 23.0948L9.08398 24.1188C9.1617 24.512 9.26227 24.8914 9.39027 25.2663L11.228 25.3897C11.42 25.8148 11.6531 26.2125 11.9228 26.5874L11.1091 28.2377C11.3697 28.5348 11.6531 28.8183 11.9503 29.0788L13.6006 28.2697C13.9754 28.5348 14.3777 28.7725 14.7983 28.9645L14.9217 30.8023C15.292 30.9303 15.676 31.0308 16.0646 31.1085L17.0931 29.5771C17.3217 29.6 17.5503 29.6137 17.788 29.6137C18.0257 29.6137 18.2543 29.6 18.4828 29.5771L19.5114 31.1085C19.9 31.0308 20.284 30.9303 20.6543 30.8023L20.7777 28.9645C21.2028 28.7725 21.6051 28.5394 21.98 28.2697L23.6303 29.0788C23.9274 28.8183 24.2063 28.5394 24.4668 28.2423L23.6577 26.592C23.9274 26.2171 24.1606 25.8148 24.3526 25.3897L26.1903 25.2663C26.3183 24.896 26.4188 24.512 26.4966 24.1188L24.9651 23.0948C24.988 22.8663 24.9971 22.6377 24.9971 22.4V22.4045ZM17.788 27.8217C14.7937 27.8217 12.3663 25.3943 12.3663 22.4C12.3663 19.4057 14.7937 16.9783 17.788 16.9783C20.7823 16.9783 23.2097 19.4057 23.2097 22.4C23.2097 25.3943 20.7823 27.8217 17.788 27.8217Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M21.2117 22.3998C21.2117 21.9518 19.2917 19.0626 19.2917 19.0626C19.1408 18.802 18.6517 18.802 18.1991 19.0626C17.7465 19.3232 17.5042 19.7483 17.6597 20.0135L17.8745 20.3838L18.4688 21.4169H14.5785C14.2768 21.4169 14.03 21.8558 14.0254 22.4043C14.0254 22.9529 14.2722 23.3918 14.5785 23.3918H15.6162H18.4688L17.8745 24.4249L17.6597 24.7952C17.5088 25.0558 17.7511 25.4855 18.1991 25.746C18.6517 26.0066 19.1408 26.0066 19.2917 25.746C19.2917 25.746 21.2117 22.8569 21.2117 22.4089V22.3998Z", fill: "#8DC63E" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_13723_338849" }, /* @__PURE__ */ s.createElement("rect", { width: 80, height: 80, fill: "white" })))), xl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12 14q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 12q0-.825.588-1.412A1.93 1.93 0 0 1 12 10q.825 0 1.412.588Q14 11.175 14 12t-.588 1.412A1.93 1.93 0 0 1 12 14m0 7q-3.475 0-6.025-2.288T3.05 13H5.1q.35 2.6 2.313 4.3Q9.375 19 12 19q2.925 0 4.962-2.038T19 12t-2.038-4.962T12 5a6.75 6.75 0 0 0-3.225.8A7.4 7.4 0 0 0 6.25 8H9v2H3V4h2v2.35a8.7 8.7 0 0 1 3.113-2.475A8.9 8.9 0 0 1 12 3q1.874 0 3.512.712a9.2 9.2 0 0 1 2.85 1.926 9.2 9.2 0 0 1 1.926 2.85A8.7 8.7 0 0 1 21 12q0 1.874-.712 3.512a9.2 9.2 0 0 1-1.925 2.85 9.2 9.2 0 0 1-2.85 1.926A8.7 8.7 0 0 1 12 21" })), bl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 42, height: 42, fill: "none", viewBox: "0 0 42 42", ...e }, /* @__PURE__ */ s.createElement("rect", { width: 40, height: 40, x: 1, y: 1, fill: "#F4F4F4", stroke: "#BDBDBD", strokeDasharray: "4 4", strokeLinecap: "round", strokeLinejoin: "round", rx: 6 })), wl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 12, fill: "none", viewBox: "0 0 8 12", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#BDBDBD", d: "m7.71 6-6-6L.3 1.41 4.88 6 .3 10.59 1.71 12z" })), yl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M20 18H9C8.46957 18 7.96086 17.7893 7.58579 17.4142C7.21071 17.0391 7 16.5304 7 16V5C7 4.46957 7.21071 3.96086 7.58579 3.58579C7.96086 3.21071 8.46957 3 9 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18ZM20 5H9V16H20V5ZM17 20H5V9H3V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H17V20Z", fill: "currentColor" })), kl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "inherit", d: "M5 22c-.55 0-1.02-.2-1.41-.59S3 20.55 3 20V6c0-.55.2-1.02.59-1.41S4.45 4 5 4h1V2.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5V4h8V2.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5V4h1c.55 0 1.02.2 1.41.59S21 5.45 21 6v14c0 .55-.2 1.02-.59 1.41S19.55 22 19 22zm.5-2h13c.28 0 .5-.22.5-.5v-9c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5v9c0 .28.22.5.5.5m0-12h13c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5m6.5 6c-.28 0-.52-.1-.71-.29A.97.97 0 0 1 11 13c0-.28.1-.52.29-.71s.43-.29.71-.29.52.1.71.29.29.43.29.71-.1.52-.29.71-.43.29-.71.29m-4 0c-.28 0-.52-.1-.71-.29A.97.97 0 0 1 7 13c0-.28.1-.52.29-.71S7.72 12 8 12s.52.1.71.29.29.43.29.71-.1.52-.29.71S8.28 14 8 14m8 0c-.28 0-.52-.1-.71-.29A.97.97 0 0 1 15 13c0-.28.1-.52.29-.71s.43-.29.71-.29.52.1.71.29.29.43.29.71-.1.52-.29.71-.43.29-.71.29m-4 4c-.28 0-.52-.1-.71-.29A.97.97 0 0 1 11 17c0-.28.1-.52.29-.71s.43-.29.71-.29.52.1.71.29.29.43.29.71-.1.52-.29.71-.43.29-.71.29m-4 0c-.28 0-.52-.1-.71-.29A.97.97 0 0 1 7 17c0-.28.1-.52.29-.71S7.72 16 8 16s.52.1.71.29.29.43.29.71-.1.52-.29.71S8.28 18 8 18m8 0c-.28 0-.52-.1-.71-.29A.97.97 0 0 1 15 17c0-.28.1-.52.29-.71s.43-.29.71-.29.52.1.71.29.29.43.29.71-.1.52-.29.71-.43.29-.71.29" })), jl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 22, fill: "#464646", viewBox: "0 0 8 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "inherit", d: "M6 10H2a.5.5 0 0 0-.4.8l2 2.667a.5.5 0 0 0 .8 0l2-2.667A.5.5 0 0 0 6 10" })), Sl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M8.14 12.49C8.01 12.31 7.92 12.17 7.87 12.08C7.81 11.99 7.77 11.9 7.73 11.83C7.63 11.63 7.62 11.43 7.69 11.24C7.76 11.05 7.9 10.91 8.11 10.8C8.32 10.7 8.53 10.68 8.71 10.74C8.9 10.8 9.05 10.94 9.15 11.14C9.18 11.21 9.22 11.3 9.26 11.4C9.3 11.5 9.35 11.66 9.41 11.87L9.55 12.35C9.7 12.84 9.92 13.56 10.03 13.98C9.78 14.03 9.56 14.13 9.36 14.26C9.05 13.84 8.57 13.13 8.29 12.72L8.12 12.48L8.14 12.49ZM10.41 17.06C9.81 17.06 9.33 16.57 9.33 15.98C9.33 15.39 9.82 14.9 10.41 14.9C11 14.9 11.49 15.39 11.49 15.98C11.49 16.57 11 17.06 10.41 17.06ZM16.19 7.58C16.15 7.66 15.96 7.94 15.64 8.41L14.49 10.12C14.04 10.79 13.55 11.51 13.02 12.28C12.75 12.68 12.49 13.08 12.24 13.46C12.03 13.79 11.82 14.11 11.62 14.41C11.42 14.24 11.19 14.11 10.93 14.04C11.05 13.79 11.32 13.22 11.61 12.62C11.94 11.93 12.29 11.2 12.42 10.92C12.67 10.38 12.91 9.86 13.14 9.37C13.37 8.88 13.58 8.44 13.76 8.05L14.21 7.08C14.33 6.82 14.41 6.66 14.44 6.61C14.62 6.29 14.85 6.12 15.11 6.09C15.36 6.06 15.59 6.11 15.81 6.23C16.03 6.35 16.19 6.53 16.29 6.76C16.4 7 16.36 7.29 16.18 7.6L16.19 7.58ZM18 4C19.1 4 20 4.9 20 6V18C20 19.1 19.1 20 18 20H6C4.9 20 4 19.1 4 18V6C4 4.9 4.9 4 6 4H18ZM18 2H6C3.79 2 2 3.79 2 6V18C2 20.21 3.79 22 6 22H18C20.21 22 22 20.21 22 18V6C22 3.79 20.21 2 18 2Z", fill: "currentColor" })), Ll = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M18 2H6C3.79 2 2 3.79 2 6V18C2 20.21 3.79 22 6 22H18C20.21 22 22 20.21 22 18V6C22 3.79 20.21 2 18 2ZM8.14 12.49C8.01 12.31 7.92 12.17 7.87 12.08C7.81 11.99 7.77 11.9 7.73 11.83C7.63 11.63 7.62 11.43 7.69 11.24C7.76 11.05 7.9 10.91 8.11 10.8C8.32 10.7 8.53 10.68 8.71 10.74C8.9 10.8 9.05 10.94 9.15 11.14C9.18 11.21 9.22 11.3 9.26 11.4C9.3 11.5 9.35 11.66 9.41 11.87L9.55 12.35C9.7 12.84 9.92 13.56 10.03 13.98C9.78 14.03 9.56 14.13 9.36 14.26C9.05 13.84 8.57 13.13 8.29 12.72L8.12 12.48L8.14 12.49ZM10.41 17.06C9.81 17.06 9.33 16.57 9.33 15.98C9.33 15.39 9.82 14.9 10.41 14.9C11 14.9 11.49 15.39 11.49 15.98C11.49 16.57 11 17.06 10.41 17.06ZM16.19 7.58C16.15 7.66 15.96 7.94 15.64 8.41L14.49 10.12C14.04 10.79 13.55 11.51 13.02 12.28C12.75 12.68 12.49 13.08 12.24 13.46C12.03 13.79 11.82 14.11 11.62 14.41C11.42 14.24 11.19 14.11 10.93 14.04C11.05 13.79 11.32 13.22 11.61 12.62C11.94 11.93 12.29 11.2 12.42 10.92C12.67 10.38 12.91 9.86 13.14 9.37C13.37 8.88 13.58 8.44 13.76 8.05L14.21 7.08C14.33 6.82 14.41 6.66 14.44 6.61C14.62 6.29 14.85 6.12 15.11 6.09C15.36 6.06 15.59 6.11 15.81 6.23C16.03 6.35 16.19 6.53 16.29 6.76C16.4 7 16.36 7.29 16.18 7.6L16.19 7.58Z", fill: "currentColor" })), Ml = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 8, fill: "none", viewBox: "0 0 10 8", ...e }, /* @__PURE__ */ s.createElement("path", { stroke: "#fff", strokeWidth: 2, d: "m1 3 3 3 5-5" })), El = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 2, fill: "none", viewBox: "0 0 8 2", ...e }, /* @__PURE__ */ s.createElement("path", { stroke: "#fff", strokeWidth: 2, d: "M0 1h8" })), Nl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 12, fill: "none", viewBox: "0 0 8 12", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "m7.71 6-6-6L.3 1.41 4.88 6 .3 10.59 1.71 12z" })), Il = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "m12 16.71 6-6-1.41-1.41L12 13.88 7.41 9.3 6 10.71z" })), $l = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M6.21 10c0-.13.05-.26.15-.35.19-.2.51-.2.71 0l4.94 4.94 4.94-4.94c.2-.2.51-.2.71 0s.2.51 0 .71l-5.29 5.29c-.2.2-.51.2-.71 0l-5.29-5.29c-.1-.1-.15-.23-.15-.35z" })), _l = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M13.65 15.18 10.47 12l3.18-3.18-1.06-1.06L8.35 12l4.24 4.24z" })), Vl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M11 20H6.5q-2.275 0-3.887-1.575T1 14.575q0-1.95 1.175-3.475Q3.349 9.575 5.25 9.15q.625-2.3 2.5-3.725T12 4q2.925 0 4.962 2.037T19 11q1.725.2 2.863 1.488A4.4 4.4 0 0 1 23 15.5q0 1.875-1.312 3.188Q20.375 20 18.5 20H13v-7.15l1.6 1.55L16 13l-4-4-4 4 1.4 1.4 1.6-1.55z" })), Al = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M8.14 12.4899C8.01 12.3099 7.92 12.1699 7.87 12.0799C7.81 11.9899 7.77 11.8999 7.73 11.8299C7.63 11.6299 7.62 11.4299 7.69 11.2399C7.76 11.0499 7.9 10.9099 8.11 10.7999C8.32 10.6999 8.53 10.6799 8.71 10.7399C8.9 10.7999 9.05 10.9399 9.15 11.1399C9.18 11.2099 9.22 11.2999 9.26 11.3999C9.3 11.4999 9.35 11.6599 9.41 11.8699L9.55 12.3499C9.7 12.8399 9.92 13.5599 10.03 13.9799C9.78 14.0299 9.56 14.1299 9.36 14.2599C9.05 13.8399 8.57 13.1299 8.29 12.7199L8.12 12.4799L8.14 12.4899ZM10.41 17.0599C9.81 17.0599 9.33 16.5699 9.33 15.9799C9.33 15.3899 9.82 14.8999 10.41 14.8999C11 14.8999 11.49 15.3899 11.49 15.9799C11.49 16.5699 11 17.0599 10.41 17.0599ZM16.19 7.57995C16.15 7.65995 15.96 7.93995 15.64 8.40995L14.49 10.1199C14.04 10.7899 13.55 11.5099 13.02 12.2799C12.75 12.6799 12.49 13.0799 12.24 13.4599C12.03 13.7899 11.82 14.1099 11.62 14.4099C11.42 14.2399 11.19 14.1099 10.93 14.0399C11.05 13.7899 11.32 13.2199 11.61 12.6199C11.94 11.9299 12.29 11.1999 12.42 10.9199C12.67 10.3799 12.91 9.85995 13.14 9.36995C13.37 8.87995 13.58 8.43995 13.76 8.04995L14.21 7.07995C14.33 6.81995 14.41 6.65995 14.44 6.60995C14.62 6.28995 14.85 6.11995 15.11 6.08995C15.36 6.05995 15.59 6.10995 15.81 6.22995C16.03 6.34995 16.19 6.52995 16.29 6.75995C16.4 6.99995 16.36 7.28995 16.18 7.59995L16.19 7.57995ZM12 3.06995C12.35 3.06995 12.7 3.15995 13 3.33995L19 6.79995C19.62 7.15995 20 7.81995 20 8.52995V15.4599C20 16.1699 19.62 16.8399 19 17.1899L13 20.6499C12.7 20.8299 12.35 20.9199 12 20.9199C11.65 20.9199 11.3 20.8299 11 20.6499L5 17.1899C4.38 16.8299 4 16.1699 4 15.4599V8.52995C4 7.81995 4.38 7.14995 5 6.79995L11 3.33995C11.3 3.15995 11.65 3.06995 12 3.06995ZM12 1.06995C11.31 1.06995 10.62 1.24995 10 1.60995L4 5.06995C2.76 5.77995 2 7.10995 2 8.52995V15.4599C2 16.8899 2.76 18.2099 4 18.9199L10 22.3799C10.62 22.7399 11.31 22.9199 12 22.9199C12.69 22.9199 13.38 22.7399 14 22.3799L20 18.9199C21.24 18.2099 22 16.8799 22 15.4599V8.52995C22 7.09995 21.24 5.77995 20 5.06995L14 1.60995C13.38 1.24995 12.69 1.06995 12 1.06995Z", fill: "currentColor" })), Bl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M20 5.07001L14 1.61001C12.76 0.900015 11.24 0.900015 10 1.61001L4 5.07001C2.76 5.78001 2 7.11001 2 8.53001V15.46C2 16.89 2.76 18.21 4 18.92L10 22.38C11.24 23.09 12.76 23.09 14 22.38L20 18.92C21.24 18.21 22 16.88 22 15.46V8.53001C22 7.10001 21.24 5.78001 20 5.07001ZM8.14 12.49C8.01 12.31 7.92 12.17 7.87 12.08C7.81 11.99 7.77 11.9 7.73 11.83C7.63 11.63 7.62 11.43 7.69 11.24C7.76 11.05 7.9 10.91 8.11 10.8C8.32 10.7 8.53 10.68 8.71 10.74C8.9 10.8 9.05 10.94 9.15 11.14C9.18 11.21 9.22 11.3 9.26 11.4C9.3 11.5 9.35 11.66 9.41 11.87L9.55 12.35C9.7 12.84 9.92 13.56 10.03 13.98C9.78 14.03 9.56 14.13 9.36 14.26C9.05 13.84 8.57 13.13 8.29 12.72L8.12 12.48L8.14 12.49ZM10.41 17.06C9.81 17.06 9.33 16.57 9.33 15.98C9.33 15.39 9.82 14.9 10.41 14.9C11 14.9 11.49 15.39 11.49 15.98C11.49 16.57 11 17.06 10.41 17.06ZM16.19 7.58001C16.15 7.66001 15.96 7.94001 15.64 8.41001L14.49 10.12C14.04 10.79 13.55 11.51 13.02 12.28C12.75 12.68 12.49 13.08 12.24 13.46C12.03 13.79 11.82 14.11 11.62 14.41C11.42 14.24 11.19 14.11 10.93 14.04C11.05 13.79 11.32 13.22 11.61 12.62C11.94 11.93 12.29 11.2 12.42 10.92C12.67 10.38 12.91 9.86001 13.14 9.37001C13.37 8.88001 13.58 8.44001 13.76 8.05001L14.21 7.08001C14.33 6.82001 14.41 6.66002 14.44 6.61001C14.62 6.29001 14.85 6.12002 15.11 6.09001C15.36 6.06001 15.59 6.11001 15.81 6.23001C16.03 6.35001 16.19 6.53001 16.29 6.76002C16.4 7.00001 16.36 7.29001 16.18 7.60001L16.19 7.58001Z", fill: "currentColor" })), Hl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M20.5996 5.07014L14.5996 1.61014C13.3596 0.900137 11.8396 0.900137 10.5996 1.61014L4.59961 5.07014C3.35961 5.78014 2.59961 7.11014 2.59961 8.53014V15.4601C2.59961 16.8901 3.35961 18.2101 4.59961 18.9201L10.5996 22.3801C11.8396 23.0901 13.3596 23.0901 14.5996 22.3801L20.5996 18.9201C21.8396 18.2101 22.5996 16.8801 22.5996 15.4601V8.53014C22.5996 7.10014 21.8396 5.78014 20.5996 5.07014ZM8.73961 12.4901C8.60961 12.3101 8.51961 12.1701 8.46961 12.0801C8.40961 11.9901 8.36961 11.9001 8.32961 11.8301C8.22961 11.6301 8.21961 11.4301 8.28961 11.2401C8.35961 11.0501 8.49961 10.9101 8.70961 10.8001C8.91961 10.7001 9.12961 10.6801 9.30961 10.7401C9.49961 10.8001 9.64961 10.9401 9.74961 11.1401C9.77961 11.2101 9.81961 11.3001 9.85961 11.4001C9.89961 11.5001 9.94961 11.6601 10.0096 11.8701L10.1496 12.3501C10.2996 12.8401 10.5196 13.5601 10.6296 13.9801C10.3796 14.0301 10.1596 14.1301 9.95961 14.2601C9.64961 13.8401 9.16961 13.1301 8.88961 12.7201L8.71961 12.4801L8.73961 12.4901ZM11.0096 17.0601C10.4096 17.0601 9.92961 16.5701 9.92961 15.9801C9.92961 15.3901 10.4196 14.9001 11.0096 14.9001C11.5996 14.9001 12.0896 15.3901 12.0896 15.9801C12.0896 16.5701 11.5996 17.0601 11.0096 17.0601ZM16.7896 7.58014C16.7496 7.66014 16.5596 7.94014 16.2396 8.41014L15.0896 10.1201C14.6396 10.7901 14.1496 11.5101 13.6196 12.2801C13.3496 12.6801 13.0896 13.0801 12.8396 13.4601C12.6296 13.7901 12.4196 14.1101 12.2196 14.4101C12.0196 14.2401 11.7896 14.1101 11.5296 14.0401C11.6496 13.7901 11.9196 13.2201 12.2096 12.6201C12.5396 11.9301 12.8896 11.2001 13.0196 10.9201C13.2696 10.3801 13.5096 9.86014 13.7396 9.37014C13.9696 8.88014 14.1796 8.44014 14.3596 8.05014L14.8096 7.08014C14.9296 6.82014 15.0096 6.66014 15.0396 6.61014C15.2196 6.29014 15.4496 6.12014 15.7096 6.09014C15.9596 6.06014 16.1896 6.11014 16.4096 6.23014C16.6296 6.35014 16.7896 6.53014 16.8896 6.76014C16.9996 7.00014 16.9596 7.29014 16.7796 7.60014L16.7896 7.58014Z", fill: "url(#paint0_linear_5690_68911)" }), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_5690_68911", x1: -9.20039, y1: 35.3586, x2: 25.3456, y2: 4.11381, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#59DDF2" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#B0B3EF" })))), Dl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M20.5996 5.07014L14.5996 1.61014C13.3596 0.900137 11.8396 0.900137 10.5996 1.61014L4.59961 5.07014C3.35961 5.78014 2.59961 7.11014 2.59961 8.53014V15.4601C2.59961 16.8901 3.35961 18.2101 4.59961 18.9201L10.5996 22.3801C11.8396 23.0901 13.3596 23.0901 14.5996 22.3801L20.5996 18.9201C21.8396 18.2101 22.5996 16.8801 22.5996 15.4601V8.53014C22.5996 7.10014 21.8396 5.78014 20.5996 5.07014ZM8.73961 12.4901C8.60961 12.3101 8.51961 12.1701 8.46961 12.0801C8.40961 11.9901 8.36961 11.9001 8.32961 11.8301C8.22961 11.6301 8.21961 11.4301 8.28961 11.2401C8.35961 11.0501 8.49961 10.9101 8.70961 10.8001C8.91961 10.7001 9.12961 10.6801 9.30961 10.7401C9.49961 10.8001 9.64961 10.9401 9.74961 11.1401C9.77961 11.2101 9.81961 11.3001 9.85961 11.4001C9.89961 11.5001 9.94961 11.6601 10.0096 11.8701L10.1496 12.3501C10.2996 12.8401 10.5196 13.5601 10.6296 13.9801C10.3796 14.0301 10.1596 14.1301 9.95961 14.2601C9.64961 13.8401 9.16961 13.1301 8.88961 12.7201L8.71961 12.4801L8.73961 12.4901ZM11.0096 17.0601C10.4096 17.0601 9.92961 16.5701 9.92961 15.9801C9.92961 15.3901 10.4196 14.9001 11.0096 14.9001C11.5996 14.9001 12.0896 15.3901 12.0896 15.9801C12.0896 16.5701 11.5996 17.0601 11.0096 17.0601ZM16.7896 7.58014C16.7496 7.66014 16.5596 7.94014 16.2396 8.41014L15.0896 10.1201C14.6396 10.7901 14.1496 11.5101 13.6196 12.2801C13.3496 12.6801 13.0896 13.0801 12.8396 13.4601C12.6296 13.7901 12.4196 14.1101 12.2196 14.4101C12.0196 14.2401 11.7896 14.1101 11.5296 14.0401C11.6496 13.7901 11.9196 13.2201 12.2096 12.6201C12.5396 11.9301 12.8896 11.2001 13.0196 10.9201C13.2696 10.3801 13.5096 9.86014 13.7396 9.37014C13.9696 8.88014 14.1796 8.44014 14.3596 8.05014L14.8096 7.08014C14.9296 6.82014 15.0096 6.66014 15.0396 6.61014C15.2196 6.29014 15.4496 6.12014 15.7096 6.09014C15.9596 6.06014 16.1896 6.11014 16.4096 6.23014C16.6296 6.35014 16.7896 6.53014 16.8896 6.76014C16.9996 7.00014 16.9596 7.29014 16.7796 7.60014L16.7896 7.58014Z", fill: "url(#paint0_linear_5690_68913)" }), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_5690_68913", x1: -0.700389, y1: 26.2971, x2: 33.2409, y2: -4.89147, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#0071AC" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#8DC63E" })))), Tl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M18 4C19.1 4 20 4.9 20 6V15.54C20 16.25 19.62 16.92 19 17.27L13 20.73C12.7 20.91 12.35 21 12 21C11.65 21 11.3 20.91 11 20.73L5 17.27C4.38 16.91 4 16.25 4 15.54V6C4 4.9 4.9 4 6 4H18ZM18 2H6C3.79 2 2 3.79 2 6V15.54C2 16.97 2.76 18.29 4 19L10 22.46C10.62 22.82 11.31 23 12 23C12.69 23 13.38 22.82 14 22.46L20 19C21.24 18.29 22 16.96 22 15.54V6C22 3.79 20.21 2 18 2ZM8.14 12.49C8.01 12.31 7.92 12.17 7.87 12.08C7.81 11.99 7.77 11.9 7.73 11.83C7.63 11.63 7.62 11.43 7.69 11.24C7.76 11.05 7.9 10.91 8.11 10.8C8.32 10.7 8.53 10.68 8.71 10.74C8.9 10.8 9.05 10.94 9.15 11.14C9.18 11.21 9.22 11.3 9.26 11.4C9.3 11.5 9.35 11.66 9.41 11.87L9.55 12.35C9.7 12.84 9.92 13.56 10.03 13.98C9.78 14.03 9.56 14.13 9.36 14.26C9.05 13.84 8.57 13.13 8.29 12.72L8.12 12.48L8.14 12.49ZM10.41 17.06C9.81 17.06 9.33 16.57 9.33 15.98C9.33 15.39 9.82 14.9 10.41 14.9C11 14.9 11.49 15.39 11.49 15.98C11.49 16.57 11 17.06 10.41 17.06ZM16.19 7.58C16.15 7.66 15.96 7.94 15.64 8.41L14.49 10.12C14.04 10.79 13.55 11.51 13.02 12.28C12.75 12.68 12.49 13.08 12.24 13.46C12.03 13.79 11.82 14.11 11.62 14.41C11.42 14.24 11.19 14.11 10.93 14.04C11.05 13.79 11.32 13.22 11.61 12.62C11.94 11.93 12.29 11.2 12.42 10.92C12.67 10.38 12.91 9.86 13.14 9.37C13.37 8.88 13.58 8.44 13.76 8.05L14.21 7.08C14.33 6.82 14.41 6.66 14.44 6.61C14.62 6.29 14.85 6.12 15.11 6.09C15.36 6.06 15.59 6.11 15.81 6.23C16.03 6.35 16.19 6.53 16.29 6.76C16.4 7 16.36 7.29 16.18 7.6L16.19 7.58Z", fill: "currentColor" })), Rl = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M18 2H6C3.79 2 2 3.79 2 6V15.54C2 16.97 2.76 18.29 4 19L10 22.46C11.24 23.17 12.76 23.17 14 22.46L20 19C21.24 18.29 22 16.96 22 15.54V6C22 3.79 20.21 2 18 2ZM8.14 12.49C8.01 12.31 7.92 12.17 7.87 12.08C7.81 11.99 7.77 11.9 7.73 11.83C7.63 11.63 7.62 11.43 7.69 11.24C7.76 11.05 7.9 10.91 8.11 10.8C8.32 10.7 8.53 10.68 8.71 10.74C8.9 10.8 9.05 10.94 9.15 11.14C9.18 11.21 9.22 11.3 9.26 11.4C9.3 11.5 9.35 11.66 9.41 11.87L9.55 12.35C9.7 12.84 9.92 13.56 10.03 13.98C9.78 14.03 9.56 14.13 9.36 14.26C9.05 13.84 8.57 13.13 8.29 12.72L8.12 12.48L8.14 12.49ZM10.41 17.06C9.81 17.06 9.33 16.57 9.33 15.98C9.33 15.39 9.82 14.9 10.41 14.9C11 14.9 11.49 15.39 11.49 15.98C11.49 16.57 11 17.06 10.41 17.06ZM16.19 7.58C16.15 7.66 15.96 7.94 15.64 8.41L14.49 10.12C14.04 10.79 13.55 11.51 13.02 12.28C12.75 12.68 12.49 13.08 12.24 13.46C12.03 13.79 11.82 14.11 11.62 14.41C11.42 14.24 11.19 14.11 10.93 14.04C11.05 13.79 11.32 13.22 11.61 12.62C11.94 11.93 12.29 11.2 12.42 10.92C12.67 10.38 12.91 9.86 13.14 9.37C13.37 8.88 13.58 8.44 13.76 8.05L14.21 7.08C14.33 6.82 14.41 6.66 14.44 6.61C14.62 6.29 14.85 6.12 15.11 6.09C15.36 6.06 15.59 6.11 15.81 6.23C16.03 6.35 16.19 6.53 16.29 6.76C16.4 7 16.36 7.29 16.18 7.6L16.19 7.58Z", fill: "currentColor" })), Fl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })), zl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M11.025 21v-2.15a5.1 5.1 0 0 1-2.288-1.15q-.962-.85-1.412-2.4l1.85-.75q.374 1.2 1.112 1.825t1.938.625q1.025 0 1.738-.462.712-.463.712-1.438 0-.875-.55-1.387-.55-.513-2.55-1.163-2.15-.675-2.95-1.613t-.8-2.287q0-1.625 1.05-2.525t2.15-1.025V3h2v2.1q1.249.2 2.063.913a4.2 4.2 0 0 1 1.187 1.737l-1.85.8q-.3-.8-.85-1.2t-1.5-.4q-1.1 0-1.675.487-.575.488-.575 1.213 0 .825.75 1.3t2.6 1q1.724.5 2.612 1.588.888 1.086.888 2.512 0 1.774-1.05 2.7-1.05.925-2.6 1.15V21z" })), Wl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M15 21q-2.95 0-5.25-1.675T6.5 15H3v-2h3.05q-.075-.6-.062-1.113Q6 11.375 6.05 11H3V9h3.5q.95-2.65 3.25-4.325T15 3q1.725 0 3.262.612A9.1 9.1 0 0 1 21 5.3l-1.425 1.4a7 7 0 0 0-2.087-1.25A6.8 6.8 0 0 0 15 5q-2.125 0-3.8 1.112A7.1 7.1 0 0 0 8.675 9H15v2H8.075q-.1.675-.075 1.188t.075.812H15v2H8.675a7.1 7.1 0 0 0 2.525 2.887Q12.875 19 15 19a6.8 6.8 0 0 0 2.488-.45q1.161-.45 2.087-1.25L21 18.7a9.1 9.1 0 0 1-2.738 1.688A8.7 8.7 0 0 1 15 21" })), Ol = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M7 21v-3H5v-2h2V3h11v2H9v6h8v2H9v3h4v2H9v3z" })), Zl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M9 21v-5.15l-3 1.875V15.35l3-1.875v-2.35L6 13v-2.35l3-1.9V3h2v4.5L15 5v2.35l-4 2.525v2.35l4-2.5v2.35L11 14.6V19q2.075 0 3.537-1.462Q16 16.074 16 14h2q0 2.925-2.037 4.962T11 21z" })), Pl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M6 21v-2l.412-.25a5 5 0 0 0 .9-.738q.488-.487.888-1.25Q8.6 16 8.6 15q0-.274-.037-.525A7 7 0 0 0 8.475 14H6v-2h1.5a27 27 0 0 1-1.013-1.738Q6 9.35 6 8q0-2.3 1.6-3.9t3.9-1.6q1.774 0 3.15.975A5.45 5.45 0 0 1 16.625 6l-1.85.775a3.5 3.5 0 0 0-1.263-1.638A3.36 3.36 0 0 0 11.5 4.5q-1.45 0-2.475 1.025A3.37 3.37 0 0 0 8 8q0 1.2.6 2t1.225 2H14v2h-3.475q.05.225.063.475T10.6 15q0 1.25-.437 2.25A7.3 7.3 0 0 1 9.1 19H14q1 0 1.525-.525t.725-1.35L18 18a3.42 3.42 0 0 1-1.413 2.188Q15.45 21 14 21z" })), ql = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M7 21v-3H5v-2h2v-2H5v-2h2V3h6.5q2.3 0 3.9 1.6T19 8.5t-1.6 3.9-3.9 1.6H9v2h4v2H9v3zm2-9h4.5q1.45 0 2.475-1.025A3.37 3.37 0 0 0 17 8.5q0-1.45-1.025-2.475A3.37 3.37 0 0 0 13.5 5H9z" })), Ul = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M13.725 21 7 14v-2h3.5q1.325 0 2.287-.863A3.52 3.52 0 0 0 13.95 9H6V7h7.65a3.6 3.6 0 0 0-1.263-1.437A3.3 3.3 0 0 0 10.5 5H6V3h12v2h-3.25q.35.425.625.925T15.8 7H18v2h-2.025q-.2 2.125-1.75 3.563Q12.675 14 10.5 14h-.725l6.725 7z" })), Gl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M11 21v-4H6v-2h5v-2H6v-2h4.075L5 3h2.375L12 10.3 16.625 3H19l-5.075 8H18v2h-5v2h5v2h-5v4z" })), Kl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M11 21v-7H6v-2h4.725L5 3h2.375L12 10.3 16.625 3H19l-5.725 9H18v2h-5v7z" })), Yl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-.5 7h-5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5m-13-5h5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5M13 18.5v-6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5" })), Ql = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M4.99902 3H10.499C10.6316 3 10.7588 3.05268 10.8526 3.14645C10.9463 3.24021 10.999 3.36739 10.999 3.5V20.5C10.999 20.6326 10.9463 20.7598 10.8526 20.8536C10.7588 20.9473 10.6316 21 10.499 21H4.99902C4.46859 21 3.95988 20.7893 3.58481 20.4142C3.20974 20.0391 2.99902 19.5304 2.99902 19V5C2.99902 4.46957 3.20974 3.96086 3.58481 3.58579C3.95988 3.21071 4.46859 3 4.99902 3ZM18.999 3H13.499C13.3664 3 13.2392 3.05268 13.1455 3.14645C13.0517 3.24021 12.999 3.36739 12.999 3.5V9.5C12.999 9.63261 13.0517 9.75979 13.1455 9.85355C13.2392 9.94732 13.3664 10 13.499 10H20.499C20.6316 10 20.7588 9.94732 20.8526 9.85355C20.9463 9.75979 20.999 9.63261 20.999 9.5V5C20.999 4.46957 20.7883 3.96086 20.4132 3.58579C20.0382 3.21071 19.5295 3 18.999 3ZM13.499 21H18.999C19.5295 21 20.0382 20.7893 20.4132 20.4142C20.7883 20.0391 20.999 19.5304 20.999 19V12.5C20.999 12.3674 20.9463 12.2402 20.8526 12.1464C20.7588 12.0527 20.6316 12 20.499 12H13.499C13.3664 12 13.2392 12.0527 13.1455 12.1464C13.0517 12.2402 12.999 12.3674 12.999 12.5V20.5C12.999 20.6326 13.0517 20.7598 13.1455 20.8536C13.2392 20.9473 13.3664 21 13.499 21Z", fill: "currentColor" })), Xl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M9.001 15.5v-6a1 1 0 1 1 2 0v6a1 1 0 0 1-2 0m5 1a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1m6-11.5v2h-1v11a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V7h-1V5h6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm-3 2h-10v10.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5z" })), Jl = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M14.004 5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1h-6v2h1v11a2.006 2.006 0 0 0 2 2h9.994a2.006 2.006 0 0 0 2-2V7h1V5zm-3 10.5a1 1 0 1 1-2 0v-6a1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0v-6a1 1 0 0 1 2 0z" })), es = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M6.001 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2zm8-14h4.174L14 3.828z" })), ts = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8zm.75 3.58.84.84.84.84h-1.67V5.59zM17.5 20h-11c-.28 0-.5-.22-.5-.5v-15c0-.28.22-.5.5-.5h6.25v4.25c0 .55.45 1 1 1H18V19.5c0 .28-.22.5-.5.5" })), rs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M5 20v-2h14v2zM6 9.42 7.41 8l3.591 3.589V3h2v8.59L16.59 8 18 9.42l-6 5.99z" })), ns = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M3.333 12.667h.95L10.8 6.15l-.95-.95-6.517 6.517zM2 14v-2.833l8.8-8.784q.2-.183.442-.283.24-.1.508-.1.267 0 .517.1.249.1.433.3l.917.933q.2.184.291.434a1.44 1.44 0 0 1 0 1.008 1.25 1.25 0 0 1-.291.442L4.833 14zm8.317-8.317L9.85 5.2l.95.95z" })), os = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M3 21v-4.25L16.2 3.575q.3-.275.663-.425.362-.15.762-.15t.775.15.65.45L20.425 5q.3.275.438.65a2.17 2.17 0 0 1 0 1.512 1.9 1.9 0 0 1-.438.663L7.25 21zM17.6 7.8 19 6.4 17.6 5l-1.4 1.4z" })), as = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M18 15L22 19L18 23L16.6 21.6L18.17 20H14V18H18.17L16.6 16.4L18 15ZM22 6V13.26C21.4 12.84 20.72 12.51 20 12.29V6.88L12 13.28L4 6.88V17.5C4 17.78 4.22 18 4.5 18H11.08C11.03 18.33 11 18.66 11 19C11 19.34 11.03 19.67 11.08 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6ZM17.9 6H6.1L12 10.72L17.9 6Z", fill: "currentColor" })), is = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm8-7 8-5V6l-8 5-8-5v2z" })), ls = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "m12 13.28 8-6.4v5.41c.72.22 1.4.54 2 .97V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7.08c-.05-.33-.08-.66-.08-1s.03-.67.08-1H4.5c-.28 0-.5-.22-.5-.5V6.88zM17.9 6 12 10.72 6.1 6zm4.44 11.13-5.15 5.15-3.54-3.54 1.36-1.36 2.12 2.12 3.79-3.79 1.41 1.41z" })), ss = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M21 10c.34 0 .68-.04 1-.1V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h12.1c-.07.32-.1.66-.1 1s.04.68.1 1h-10l5.9 4.72 4.49-3.59c.29.61.7 1.15 1.2 1.6L12 13.29 4 6.88V17.5c0 .28.22.5.5.5h15c.28 0 .5-.22.5-.5V9.9c.32.07.66.1 1 .1m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3" })), cs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7.08c-.05-.33-.08-.66-.08-1s.03-.67.08-1H4.5c-.28 0-.5-.22-.5-.5V6.88l8 6.4 8-6.4v5.41c.72.22 1.4.54 2 .97V6c0-1.1-.9-2-2-2m-8 6.72L6.1 6h11.8zm9.54 6.16L19.42 19l2.12 2.12-1.41 1.41-2.12-2.12-2.12 2.12-1.41-1.41L16.6 19l-2.12-2.12 1.41-1.41 2.12 2.12 2.12-2.12z" })), ds = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-2.1 2L12 10.72 6.1 6zM4 17.5V6.88l8 6.4 8-6.4V17.5c0 .28-.22.5-.5.5h-15c-.28 0-.5-.22-.5-.5" })), us = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M1.05 21v-2.8q0-.825.425-1.55t1.175-1.1q1.275-.65 2.875-1.1T9.05 14t3.525.45 2.875 1.1q.75.375 1.175 1.1t.425 1.55V21zm2-2h12v-.8a.97.97 0 0 0-.5-.85q-.9-.45-2.312-.9Q10.825 16 9.05 16t-3.188.45-2.312.9a.97.97 0 0 0-.5.85zm6-6q-1.65 0-2.825-1.175T5.05 9H4.8a.5.5 0 0 1-.363-.137A.5.5 0 0 1 4.3 8.5q0-.224.137-.363A.5.5 0 0 1 4.8 8h.25q0-1.125.55-2.025T7.05 4.55v.95q0 .225.137.362A.5.5 0 0 0 7.55 6a.5.5 0 0 0 .362-.138.5.5 0 0 0 .138-.362V4.15q.225-.075.475-.113Q8.775 4 9.05 4q.274 0 .525.037.25.038.475.113V5.5q0 .225.137.362A.5.5 0 0 0 10.55 6a.5.5 0 0 0 .362-.138.5.5 0 0 0 .138-.362v-.95q.9.525 1.45 1.425T13.05 8h.25q.224 0 .362.137a.5.5 0 0 1 .138.363.5.5 0 0 1-.138.363A.5.5 0 0 1 13.3 9h-.25q0 1.65-1.175 2.825T9.05 13m0-2q.825 0 1.412-.588.588-.587.588-1.412h-4q0 .825.587 1.412Q8.225 11 9.05 11m7.5 4-.15-.75a3 3 0 0 1-.287-.113.9.9 0 0 1-.263-.187l-.7.25-.5-.9.55-.5v-.6l-.55-.5.5-.9.7.25a1 1 0 0 1 .25-.175q.15-.075.3-.125l.15-.75h1l.15.75q.15.05.3.125t.25.175l.7-.25.5.9-.55.5v.6l.55.5-.5.9-.7-.25a.9.9 0 0 1-.262.188 3 3 0 0 1-.288.112l-.15.75zm.5-1.75a.72.72 0 0 0 .525-.225.72.72 0 0 0 .225-.525.72.72 0 0 0-.225-.525.72.72 0 0 0-.525-.225.72.72 0 0 0-.525.225.72.72 0 0 0-.225.525q0 .3.225.525a.72.72 0 0 0 .525.225m1.8-3.25-.2-1.05a2 2 0 0 1-.412-.187A1.7 1.7 0 0 1 17.9 8.5l-1.05.35-.7-1.2.85-.75a.6.6 0 0 1-.05-.2v-.4q0-.075.05-.2l-.85-.75.7-1.2 1.05.35q.15-.15.338-.263.187-.112.412-.187l.2-1.05h1.4l.2 1.05q.225.075.413.188.187.112.337.262l1.05-.35.7 1.2-.85.75q.05.125.05.2v.4q0 .075-.05.2l.85.75-.7 1.2-1.05-.35q-.15.15-.337.262a2 2 0 0 1-.413.188l-.2 1.05zm.7-2.25q.525 0 .887-.362.363-.363.363-.888t-.363-.888a1.2 1.2 0 0 0-.887-.362q-.525 0-.887.362a1.2 1.2 0 0 0-.363.888q0 .525.363.888.362.362.887.362" })), ps = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M1.04999 21V18.2C1.04999 17.65 1.19165 17.1333 1.47499 16.65C1.75832 16.1667 2.14999 15.8 2.64999 15.55C3.49999 15.1167 4.45832 14.75 5.52499 14.45C6.59165 14.15 7.76665 14 9.04999 14C10.3333 14 11.5083 14.15 12.575 14.45C13.6417 14.75 14.6 15.1167 15.45 15.55C15.95 15.8 16.3417 16.1667 16.625 16.65C16.9083 17.1333 17.05 17.65 17.05 18.2V21H1.04999ZM9.04999 13C7.94999 13 7.00832 12.6083 6.22499 11.825C5.44165 11.0417 5.04999 10.1 5.04999 9H4.79999C4.64999 9 4.52915 8.95417 4.43749 8.8625C4.34582 8.77083 4.29999 8.65 4.29999 8.5C4.29999 8.35 4.34582 8.22917 4.43749 8.1375C4.52915 8.04583 4.64999 8 4.79999 8H5.04999C5.04999 7.25 5.23332 6.575 5.59999 5.975C5.96665 5.375 6.44999 4.9 7.04999 4.55V5.5C7.04999 5.65 7.09582 5.77083 7.18749 5.8625C7.27915 5.95417 7.39999 6 7.54999 6C7.69999 6 7.82082 5.95417 7.91249 5.8625C8.00415 5.77083 8.04999 5.65 8.04999 5.5V4.15C8.19999 4.1 8.35832 4.0625 8.52499 4.0375C8.69165 4.0125 8.86665 4 9.04999 4C9.23332 4 9.40832 4.0125 9.57499 4.0375C9.74165 4.0625 9.89999 4.1 10.05 4.15V5.5C10.05 5.65 10.0958 5.77083 10.1875 5.8625C10.2792 5.95417 10.4 6 10.55 6C10.7 6 10.8208 5.95417 10.9125 5.8625C11.0042 5.77083 11.05 5.65 11.05 5.5V4.55C11.65 4.9 12.1333 5.375 12.5 5.975C12.8667 6.575 13.05 7.25 13.05 8H13.3C13.45 8 13.5708 8.04583 13.6625 8.1375C13.7542 8.22917 13.8 8.35 13.8 8.5C13.8 8.65 13.7542 8.77083 13.6625 8.8625C13.5708 8.95417 13.45 9 13.3 9H13.05C13.05 10.1 12.6583 11.0417 11.875 11.825C11.0917 12.6083 10.15 13 9.04999 13ZM9.04999 11C9.59999 11 10.0708 10.8042 10.4625 10.4125C10.8542 10.0208 11.05 9.55 11.05 9H7.04999C7.04999 9.55 7.24582 10.0208 7.63749 10.4125C8.02915 10.8042 8.49999 11 9.04999 11ZM16.55 15L16.4 14.25C16.3 14.2167 16.2042 14.1792 16.1125 14.1375C16.0208 14.0958 15.9333 14.0333 15.85 13.95L15.15 14.2L14.65 13.3L15.2 12.8V12.2L14.65 11.7L15.15 10.8L15.85 11.05C15.9167 10.9833 16 10.925 16.1 10.875C16.2 10.825 16.3 10.7833 16.4 10.75L16.55 10H17.55L17.7 10.75C17.8 10.7833 17.9 10.825 18 10.875C18.1 10.925 18.1833 10.9833 18.25 11.05L18.95 10.8L19.45 11.7L18.9 12.2V12.8L19.45 13.3L18.95 14.2L18.25 13.95C18.1667 14.0333 18.0792 14.0958 17.9875 14.1375C17.8958 14.1792 17.8 14.2167 17.7 14.25L17.55 15H16.55ZM17.05 13.25C17.25 13.25 17.425 13.175 17.575 13.025C17.725 12.875 17.8 12.7 17.8 12.5C17.8 12.3 17.725 12.125 17.575 11.975C17.425 11.825 17.25 11.75 17.05 11.75C16.85 11.75 16.675 11.825 16.525 11.975C16.375 12.125 16.3 12.3 16.3 12.5C16.3 12.7 16.375 12.875 16.525 13.025C16.675 13.175 16.85 13.25 17.05 13.25ZM18.85 10L18.65 8.95C18.5 8.9 18.3625 8.8375 18.2375 8.7625C18.1125 8.6875 18 8.6 17.9 8.5L16.85 8.85L16.15 7.65L17 6.9C16.9667 6.81667 16.95 6.75 16.95 6.7V6.3C16.95 6.25 16.9667 6.18333 17 6.1L16.15 5.35L16.85 4.15L17.9 4.5C18 4.4 18.1125 4.3125 18.2375 4.2375C18.3625 4.1625 18.5 4.1 18.65 4.05L18.85 3H20.25L20.45 4.05C20.6 4.1 20.7375 4.1625 20.8625 4.2375C20.9875 4.3125 21.1 4.4 21.2 4.5L22.25 4.15L22.95 5.35L22.1 6.1C22.1333 6.18333 22.15 6.25 22.15 6.3V6.7C22.15 6.75 22.1333 6.81667 22.1 6.9L22.95 7.65L22.25 8.85L21.2 8.5C21.1 8.6 20.9875 8.6875 20.8625 8.7625C20.7375 8.8375 20.6 8.9 20.45 8.95L20.25 10H18.85ZM19.55 7.75C19.9 7.75 20.1958 7.62917 20.4375 7.3875C20.6792 7.14583 20.8 6.85 20.8 6.5C20.8 6.15 20.6792 5.85417 20.4375 5.6125C20.1958 5.37083 19.9 5.25 19.55 5.25C19.2 5.25 18.9042 5.37083 18.6625 5.6125C18.4208 5.85417 18.3 6.15 18.3 6.5C18.3 6.85 18.4208 7.14583 18.6625 7.3875C18.9042 7.62917 19.2 7.75 19.55 7.75Z", fill: "currentColor" })), ms = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "#F2664C", d: "M28 33C28.28 33 28.52 32.9 28.71 32.71C28.9 32.52 29 32.28 29 32C29 31.72 28.9 31.48 28.71 31.29C28.52 31.1 28.28 31 28 31C27.72 31 27.48 31.1 27.29 31.29C27.1 31.48 27 31.72 27 32C27 32.28 27.1 32.52 27.29 32.71C27.48 32.9 27.72 33 28 33ZM27 29H29V23H27V29ZM28 38C26.62 38 25.32 37.74 24.1 37.21C22.88 36.68 21.82 35.97 20.92 35.07C20.02 34.17 19.31 33.11 18.78 31.89C18.25 30.67 17.99 29.37 17.99 27.99C17.99 26.61 18.25 25.31 18.78 24.09C19.31 22.87 20.02 21.81 20.92 20.91C21.82 20.01 22.88 19.3 24.1 18.77C25.32 18.24 26.62 17.98 28 17.98C29.38 17.98 30.68 18.24 31.9 18.77C33.12 19.3 34.18 20.01 35.08 20.91C35.98 21.81 36.69 22.87 37.22 24.09C37.75 25.31 38.01 26.61 38.01 27.99C38.01 29.37 37.75 30.67 37.22 31.89C36.69 33.11 35.98 34.17 35.08 35.07C34.18 35.97 33.12 36.68 31.9 37.21C30.68 37.74 29.38 38 28 38Z" }))), hs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "m17.784 19.675-3.817-3.816 1.77-1.766.11-.12 3.826 3.813a1.339 1.339 0 0 1-1.89 1.889m-13.4-.084a1.34 1.34 0 0 1 0-1.889l5.408-5.4a.436.436 0 0 0 0-.62L4.384 6.279a1.336 1.336 0 0 1 1.892-1.886l6.993 6.99a.905.905 0 0 1 0 1.26l-6.993 6.99a1.344 1.344 0 0 1-1.892-.04zm11.276-9.6-1.771-1.789 3.82-3.814a1.34 1.34 0 0 1 1.464-.283 1.34 1.34 0 0 1 .425 2.19l-3.829 3.816z" })), gs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19.95 15.95 18.4 14.4a7.4 7.4 0 0 0 1.725-2.425A7.2 7.2 0 0 0 20.75 9q0-1.575-.625-2.95a7.5 7.5 0 0 0-1.725-2.4l1.55-1.6a10 10 0 0 1 2.225 3.125Q23 6.975 23 9t-.825 3.825a10 10 0 0 1-2.225 3.125m-3.2-3.2-1.6-1.6q.45-.425.725-.963.275-.537.275-1.187t-.275-1.187a3.5 3.5 0 0 0-.725-.963l1.6-1.6A5.3 5.3 0 0 1 18 6.938q.45.962.45 2.062T18 11.063a5.3 5.3 0 0 1-1.25 1.687M9 13q-1.65 0-2.825-1.175T5 9t1.175-2.825T9 5t2.825 1.175T13 9t-1.175 2.825T9 13m-8 8v-2.8q0-.825.425-1.55t1.175-1.1q1.275-.65 2.875-1.1T9 14t3.525.45 2.875 1.1q.75.375 1.175 1.1T17 18.2V21zm2-2h12v-.8a.97.97 0 0 0-.5-.85q-.9-.45-2.312-.9Q10.775 16 9 16t-3.187.45-2.313.9a.97.97 0 0 0-.5.85zm6-8q.825 0 1.412-.588Q11 9.826 11 9q0-.824-.588-1.412A1.93 1.93 0 0 0 9 7q-.825 0-1.412.588A1.93 1.93 0 0 0 7 9q0 .825.588 1.412Q8.175 11 9 11" })), Cs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M10.002 18h4v-2h-4zm-7-12v2h18V6zm3 7h12v-2h-12z" })), vs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M7 18a.97.97 0 0 1-.713-.288A.97.97 0 0 1 6 17v-2h13V6h2q.424 0 .712.287Q22 6.576 22 7v15l-4-4zm-5-1V3q0-.424.288-.712A.97.97 0 0 1 3 2h13q.424 0 .712.288Q17 2.575 17 3v9q0 .424-.288.713A.97.97 0 0 1 16 13H6zm13-6V4H4v7z" })), fs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M19.3789 12.68C19.4089 12.56 19.4289 12.45 19.4289 12.34V11.67C19.4289 11.56 19.4289 11.45 19.4089 11.33L21.6289 9.65C21.8289 9.5 21.8889 9.22 21.7589 9L19.4489 5.01C19.3189 4.79 19.0589 4.7 18.8189 4.8L16.2489 5.88C16.0689 5.75 15.8789 5.62 15.6889 5.5C15.4989 5.38 15.2889 5.28 15.0789 5.2L14.7289 2.44C14.6989 2.19 14.4889 2 14.2289 2H9.60886C9.35886 2 9.14886 2.19 9.10886 2.44L8.75886 5.2C8.55886 5.28 8.35886 5.38 8.15886 5.5C7.95886 5.62 7.76886 5.74 7.57886 5.88L5.00886 4.8C4.77886 4.7 4.50886 4.8 4.37886 5.01L2.06886 9C1.93886 9.22 1.99886 9.5 2.19886 9.65L4.41886 11.33C4.39886 11.45 4.38886 11.56 4.38886 11.67V12.34C4.38886 12.45 4.38886 12.56 4.41886 12.68L2.19886 14.36C1.99886 14.51 1.93886 14.79 2.06886 15.01L4.37886 19C4.50886 19.22 4.76886 19.31 5.00886 19.21L7.57886 18.13C7.75886 18.26 7.94886 18.39 8.13886 18.51C8.32886 18.63 8.53886 18.73 8.74886 18.81L9.09886 21.57C9.12886 21.82 9.33886 22.01 9.59886 22.01H14.2189C14.4689 22.01 14.6789 21.82 14.7189 21.57L15.0689 18.81C15.2689 18.73 15.4689 18.63 15.6689 18.51C15.8689 18.39 16.0589 18.27 16.2489 18.13L18.7889 19.21C19.0189 19.31 19.2889 19.21 19.4189 19L21.7289 15.01C21.8589 14.79 21.7989 14.51 21.5989 14.36L19.3789 12.68ZM14.4489 14.48C13.7689 15.16 12.9389 15.51 11.9789 15.51C11.0189 15.51 10.1689 15.17 9.48886 14.48C8.81886 13.8 8.47886 12.97 8.47886 12.01C8.47886 11.05 8.81886 10.22 9.48886 9.53C10.1689 8.85 10.9889 8.51 11.9789 8.51C12.9689 8.51 13.7689 8.85 14.4489 9.53C15.1289 10.21 15.4789 11.04 15.4789 12.01C15.4789 12.98 15.1389 13.8 14.4489 14.48Z", fill: "currentColor" })), xs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M9.599 22.02c-.25 0-.46-.19-.5-.44l-.35-2.76c-.22-.08-.42-.18-.61-.3s-.38-.24-.56-.38l-2.57 1.08c-.23.1-.5 0-.63-.21l-2.31-3.99c-.13-.22-.07-.5.13-.65l2.22-1.68c-.02-.12-.02-.23-.02-.34v-.68c0-.11 0-.22.03-.34l-2.22-1.68a.497.497 0 0 1-.13-.65l2.31-3.99c.13-.22.39-.31.63-.21l2.57 1.08c.18-.13.38-.26.58-.38q.3-.18.6-.3l.35-2.76c.03-.25.24-.44.5-.44h4.62c.25 0 .46.19.5.44l.35 2.76c.22.08.42.18.61.3s.38.24.56.38l2.57-1.08c.23-.1.5 0 .63.21L21.769 9c.13.22.07.5-.13.65l-2.22 1.68c.02.12.02.23.02.34v.68c0 .11-.02.22-.05.34l2.22 1.68c.2.15.26.43.13.65l-2.31 3.99c-.13.22-.4.31-.63.21l-2.54-1.08c-.18.13-.37.26-.57.38q-.3.18-.6.3l-.35 2.76c-.03.25-.24.44-.5.44zm2.36-6.5c.97 0 1.79-.34 2.47-1.02a3.4 3.4 0 0 0 1.03-2.48c0-.97-.34-1.79-1.02-2.48-.68-.68-1.51-1.02-2.48-1.02s-1.81.34-2.49 1.02c-.67.68-1.01 1.51-1.01 2.48s.34 1.79 1.01 2.48c.68.68 1.5 1.02 2.49 1.02m0-2c-.42 0-.77-.15-1.06-.44s-.44-.65-.44-1.06.15-.77.44-1.06.65-.44 1.06-.44.77.15 1.06.44.44.65.44 1.06-.15.77-.44 1.06-.65.44-1.06.44m-1.05 6.5h1.98l.35-2.65c.52-.13 1-.33 1.44-.59s.85-.57 1.21-.94l2.48 1.02.98-1.7-2.15-1.62c.08-.23.14-.48.17-.74s.05-.52.05-.79-.02-.53-.05-.79-.09-.5-.17-.74l2.15-1.62-.98-1.7-2.48 1.05c-.37-.38-.77-.7-1.21-.96s-.92-.45-1.44-.59l-.33-2.65h-1.98l-.35 2.65c-.52.13-1 .33-1.44.59s-.85.57-1.21.94l-2.47-1.03-.97 1.7 2.15 1.6q-.12.375-.18.75c-.03.25-.05.52-.05.8 0 .27.02.52.05.77q.045.375.18.75l-2.15 1.62.97 1.7 2.47-1.05c.37.38.77.7 1.21.96s.92.45 1.44.59l.32 2.65z" })), bs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 80, height: 80, fill: "none", viewBox: "0 0 80 80", ...e }, /* @__PURE__ */ s.createElement("circle", { cx: 40, cy: 40, r: 40, fill: "currentColor", opacity: 0.1 }), /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M48 38a6 6 0 1 0-6-6 5.975 5.975 0 0 0 6 6m-16 0a6 6 0 1 0-6-6 5.975 5.975 0 0 0 6 6m0 4c-4.66 0-14 2.34-14 7v5h28v-5c0-4.66-9.34-7-14-7m16 0c-.58 0-1.24.04-1.94.1A8.44 8.44 0 0 1 50 49v5h12v-5c0-4.66-9.34-7-14-7" })), ws = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zM5 5v14h14V5h-2v7l-2.5-1.5L12 12V5z" })), ys = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M11.95 18C12.3 18 12.5958 17.8792 12.8375 17.6375C13.0792 17.3958 13.2 17.1 13.2 16.75C13.2 16.4 13.0792 16.1042 12.8375 15.8625C12.5958 15.6208 12.3 15.5 11.95 15.5C11.6 15.5 11.3042 15.6208 11.0625 15.8625C10.8208 16.1042 10.7 16.4 10.7 16.75C10.7 17.1 10.8208 17.3958 11.0625 17.6375C11.3042 17.8792 11.6 18 11.95 18ZM11.05 14.15H12.9C12.9 13.6 12.9625 13.1667 13.0875 12.85C13.2125 12.5333 13.5667 12.1 14.15 11.55C14.5833 11.1167 14.925 10.7042 15.175 10.3125C15.425 9.92083 15.55 9.45 15.55 8.9C15.55 7.96667 15.2083 7.25 14.525 6.75C13.8417 6.25 13.0333 6 12.1 6C11.15 6 10.3792 6.25 9.7875 6.75C9.19583 7.25 8.78333 7.85 8.55 8.55L10.2 9.2C10.2833 8.9 10.4708 8.575 10.7625 8.225C11.0542 7.875 11.5 7.7 12.1 7.7C12.6333 7.7 13.0333 7.84583 13.3 8.1375C13.5667 8.42917 13.7 8.75 13.7 9.1C13.7 9.43333 13.6 9.74583 13.4 10.0375C13.2 10.3292 12.95 10.6 12.65 10.85C11.9167 11.5 11.4667 11.9917 11.3 12.325C11.1333 12.6583 11.05 13.2667 11.05 14.15ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z", fill: "currentColor" })), ks = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12 21q-3.45 0-6.012-2.288Q3.424 16.426 3.05 13H5.1q.35 2.6 2.313 4.3Q9.375 19 12 19q2.925 0 4.962-2.038T19 12t-2.038-4.962T12 5a6.75 6.75 0 0 0-3.225.8A7.4 7.4 0 0 0 6.25 8H9v2H3V4h2v2.35a8.7 8.7 0 0 1 3.113-2.475A8.9 8.9 0 0 1 12 3q1.874 0 3.512.712a9.2 9.2 0 0 1 2.85 1.926 9.2 9.2 0 0 1 1.926 2.85A8.7 8.7 0 0 1 21 12q0 1.874-.712 3.512a9.2 9.2 0 0 1-1.925 2.85 9.2 9.2 0 0 1-2.85 1.926A8.7 8.7 0 0 1 12 21m2.8-4.8L11 12.4V7h2v4.6l3.2 3.2z" })), js = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, fill: "none", viewBox: "0 0 10 10", ...e }, /* @__PURE__ */ s.createElement("g", { fill: "currentColor", clipPath: "url(#ia_svg__a)" }, /* @__PURE__ */ s.createElement("path", { d: "M8.45 5q0-.167-.015-.333l.732-.49a4 4 0 0 0-.146-.548l-.88-.059a3.5 3.5 0 0 0-.333-.575l.387-.79a4 4 0 0 0-.401-.401l-.79.387a3.4 3.4 0 0 0-.575-.333l-.06-.88a4 4 0 0 0-.546-.145l-.49.732a3.7 3.7 0 0 0-.666 0l-.49-.732A4 4 0 0 0 3.63.98l-.06.879a3.4 3.4 0 0 0-.575.333l-.79-.387a4 4 0 0 0-.4.401l.388.789a3.5 3.5 0 0 0-.334.575l-.879.06q-.091.267-.146.547l.732.49a3.5 3.5 0 0 0 0 .666l-.732.49q.054.278.146.548l.88.059q.14.303.333.574l-.388.791q.188.215.403.403l.79-.388q.27.193.573.333l.06.88q.268.09.547.144l.49-.733a3.5 3.5 0 0 0 .666 0l.49.733q.279-.055.547-.146l.06-.88q.303-.14.575-.333l.79.387q.214-.187.4-.4l-.387-.792q.195-.272.334-.575l.878-.06q.092-.267.147-.545l-.732-.49Q8.45 5.167 8.45 5M5 7.595a2.595 2.595 0 1 1 0-5.19 2.595 2.595 0 0 1 0 5.19" }), /* @__PURE__ */ s.createElement("path", { d: "M6.625 5c0-.213-.917-1.59-.917-1.59-.073-.125-.306-.125-.521 0s-.33.328-.258.453l.102.175.284.492H3.463c-.145 0-.262.211-.263.471 0 .261.118.473.263.465l.496.008h1.359l-.284.492-.102.176c-.073.125.042.328.257.453.216.125.45.125.522 0 0 0 .917-1.377.917-1.59z" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "ia_svg__a" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M0 0h10v10H0z" })))), Ss = (e) => /* @__PURE__ */ s.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#clip0_1326_33139)" }, /* @__PURE__ */ s.createElement("path", { d: "M32.6666 27.2334C32.6655 26.9818 32.7391 26.7355 32.8781 26.5258C33.017 26.3161 33.2151 26.1523 33.4473 26.0553C33.6794 25.9583 33.9351 25.9324 34.182 25.9808C34.4288 26.0292 34.6558 26.1499 34.834 26.3274C35.0123 26.505 35.1338 26.7314 35.1832 26.9781C35.2326 27.2248 35.2077 27.4806 35.1116 27.7131C35.0155 27.9456 34.8525 28.1444 34.6434 28.2841C34.4342 28.4239 34.1882 28.4985 33.9366 28.4984C33.7698 28.5001 33.6043 28.4685 33.4498 28.4056C33.2953 28.3427 33.1548 28.2497 33.0366 28.1319C32.9184 28.0142 32.8249 27.8741 32.7613 27.7198C32.6978 27.5656 32.6656 27.4002 32.6666 27.2334ZM35.0113 27.2334C35.012 27.0206 34.9495 26.8124 34.8317 26.6352C34.714 26.458 34.5463 26.3197 34.3499 26.2378C34.1535 26.1559 33.9373 26.1342 33.7285 26.1753C33.5198 26.2164 33.3279 26.3186 33.1772 26.4688C33.0266 26.6191 32.9239 26.8106 32.8822 27.0193C32.8405 27.2279 32.8616 27.4443 32.9429 27.6409C33.0242 27.8375 33.1621 28.0056 33.339 28.1238C33.5159 28.242 33.7239 28.3051 33.9366 28.305C34.2209 28.3042 34.4933 28.1912 34.6946 27.9905C34.8959 27.7897 35.0097 27.5176 35.0113 27.2334ZM34.54 27.9187H34.3066L33.8927 27.2807H33.6593V27.9187H33.464V26.5334H34.0666C34.3173 26.5334 34.56 26.6 34.56 26.8974C34.56 27.17 34.3703 27.2714 34.123 27.2784L34.54 27.9187ZM33.8916 27.0854C34.0616 27.0854 34.364 27.1187 34.364 26.8964C34.364 26.7547 34.1763 26.7297 34.0263 26.7297H33.6596V27.0854H33.8916Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M32.9057 18C32.9057 17.5169 32.8834 17.0391 32.839 16.5667L36 14.4447C35.8436 13.6425 35.6331 12.8518 35.37 12.078L31.57 11.8207C31.1711 10.9495 30.69 10.1184 30.1333 9.33867L31.807 5.92833C31.2684 5.31179 30.6894 4.73183 30.0737 4.19233L26.66 5.86667C25.88 5.30872 25.0479 4.82748 24.1753 4.42967L23.918 0.629667C23.1452 0.366741 22.3555 0.156373 21.5543 0L19.4333 3.16167C18.9617 3.11667 18.482 3.095 18 3.095C17.518 3.095 17.0387 3.118 16.5667 3.16167L14.446 0C13.6429 0.156855 12.8515 0.36846 12.0773 0.633333L11.8207 4.43067C10.9479 4.82801 10.1157 5.30892 9.33567 5.86667L5.925 4.19233C5.30911 4.73165 4.73004 5.31162 4.19167 5.92833L5.86967 9.33867C5.31208 10.1184 4.83075 10.9498 4.43233 11.8217L0.632333 12.079C0.368288 12.8523 0.157025 13.6427 0 14.4447L3.16267 16.564C3.11767 17.0353 3.09133 17.515 3.09133 17.9997C3.09133 18.4843 3.11767 18.9607 3.16267 19.433L0 21.553C0.156442 22.3552 0.367035 23.1459 0.630333 23.9197L4.43033 24.175C4.82833 25.046 5.30968 25.8764 5.86767 26.6547L4.19067 30.0687C4.73075 30.6856 5.31126 31.266 5.92833 31.806L9.341 30.13C10.1197 30.6871 10.9501 31.1682 11.8207 31.5667L12.0773 35.3667C12.8511 35.6308 13.6418 35.8424 14.444 36L16.5667 32.8333C17.0397 32.8783 17.5153 32.9063 18 32.9063C18.4847 32.9063 18.9637 32.8783 19.4357 32.8333L21.559 35.9967C22.3585 35.8395 23.1466 35.6291 23.918 35.3667L24.1753 31.5667C25.0474 31.168 25.8794 30.6869 26.66 30.13L30.0717 31.806C30.6873 31.2674 31.2664 30.6883 31.805 30.0727L30.1333 26.6613C30.6908 25.881 31.172 25.049 31.5703 24.1767L35.3667 23.9213C35.6306 23.1475 35.8422 22.3569 36 21.5547L32.8373 19.4333C32.8827 18.9607 32.9057 18.4843 32.9057 18ZM18 29.2087C11.809 29.2087 6.79067 24.191 6.79067 18.0003C6.79067 11.8097 11.809 6.792 18 6.792C24.191 6.792 29.2093 11.81 29.2093 18C29.2093 24.19 24.191 29.2087 18 29.2087Z", fill: "#445C6D" }), /* @__PURE__ */ s.createElement("path", { d: "M25.0796 17.9971C25.0796 17.0727 21.1093 11.1001 21.1093 11.1001C20.794 10.5574 19.7813 10.5574 18.8486 11.0984C17.916 11.6394 17.4153 12.5197 17.7306 13.0627L18.1726 13.8234L19.406 15.9594H13.506H11.362C10.7333 15.9594 10.2243 16.8731 10.2223 18.0001V18.0041C10.2243 19.1311 10.7333 20.0454 11.362 20.0447H13.506H19.406L18.1726 22.1807L17.7306 22.9417C17.415 23.4851 17.9153 24.3647 18.8486 24.9084C19.782 25.4521 20.794 25.4484 21.1093 24.9057C21.1093 24.9057 25.0796 18.9327 25.0796 18.0084C25.0798 18.0075 25.0798 18.0066 25.0796 18.0057C25.0803 18.0029 25.0803 17.9999 25.0796 17.9971Z", fill: "#8DC63E" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "clip0_1326_33139" }, /* @__PURE__ */ s.createElement("rect", { width: 36, height: 36, fill: "white" })))), Ls = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 170, height: 48, fill: "none", viewBox: "0 0 170 48", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#inductiveAutomation_svg__a)" }, /* @__PURE__ */ s.createElement("path", { fill: "#fff", d: "M166.025 39.256a1.681 1.681 0 0 1 2.866-1.196 1.675 1.675 0 0 1 .366 1.832 1.68 1.68 0 0 1-1.554 1.037 1.66 1.66 0 0 1-1.553-1.03 1.7 1.7 0 0 1-.125-.643m3.1 0a1.42 1.42 0 0 0-1.696-1.4 1.43 1.43 0 0 0-1.12 1.116 1.42 1.42 0 0 0 2.397 1.285c.266-.265.417-.625.419-1.001m-.624.906h-.31l-.548-.843h-.306v.843h-.26v-1.829h.797c.324 0 .648.088.648.487 0 .36-.251.486-.579.504zm-.858-1.1c.226 0 .626.041.626-.25 0-.189-.248-.221-.447-.221h-.487v.47zM59.094 24.501V12.586h-1.925v-2.092h4.408V24.5zm1.36-19.297a1.54 1.54 0 0 1 1.544 1.53 1.537 1.537 0 1 1-2.63-1.084 1.48 1.48 0 0 1 1.086-.46zm12.97 19.298v-8.149q0-2.235-.673-3.131-.673-.897-2.256-.897a3.7 3.7 0 0 0-1.783.51 3.96 3.96 0 0 0-1.427 1.256V24.5h-2.48V10.495h1.701l.784 1.805q1.23-2.068 4.015-2.068 4.605 0 4.605 5.6v8.67zm14.363-.015v-1.033q-1.298 1.297-3.769 1.297-2.626 0-4.263-1.882-1.636-1.883-1.635-5.03 0-3.153 1.883-5.383 1.882-2.23 4.487-2.231 2.169 0 3.297 1.021V4.752h2.484v19.735zm0-10.751q-.943-1.41-2.579-1.411a4 4 0 0 0-3.243 1.49q-1.236 1.494-1.236 3.793 0 5.061 4.604 5.063a3.55 3.55 0 0 0 1.413-.373q.824-.372 1.034-.791zm8.262-3.242v8.932q0 3.243 2.812 3.243a3.86 3.86 0 0 0 2.254-.705q1.021-.705 1.347-1.635v-9.835h2.486v14.008h-2.491v-1.936q-.417.824-1.68 1.51a5.14 5.14 0 0 1-2.464.687q-2.305 0-3.526-1.32t-1.223-3.754v-9.195zm22.983 1.138-1.229 1.752q-.38-.38-1.341-.719a5.6 5.6 0 0 0-1.888-.34q-2.027 0-3.215 1.419-1.19 1.419-1.192 3.892 0 2.456 1.216 3.745 1.217 1.29 3.375 1.298 1.674 0 3.376-1.298l.981 2.087q-2.002 1.298-4.959 1.298-2.862 0-4.734-1.922-1.87-1.921-1.869-5.205 0-3.35 1.946-5.376t5.317-2.029a7 7 0 0 1 2.353.456q1.26.457 1.863.942m3.047.824h-1.621v-1.962h1.621v-2.93l2.484-.956V10.5h3.847v1.963h-3.847v6.956q0 1.766.597 2.512t1.917.746a4.6 4.6 0 0 0 1.973-.486l.367 2.184c-1.109.27-2.247.402-3.388.392a3.68 3.68 0 0 1-2.805-1.235q-1.143-1.236-1.145-3.119zm10.667 12.045V12.586h-1.923v-2.092h4.409V24.5zm1.361-19.297a1.5 1.5 0 0 1 1.093.45 1.54 1.54 0 0 1 .333 1.674 1.54 1.54 0 0 1-.834.833c-.188.077-.39.114-.592.11a1.54 1.54 0 0 1-1.533-1.544 1.53 1.53 0 0 1 .443-1.09 1.52 1.52 0 0 1 1.09-.447zm9.588 19.559h-.649l-6-14.308h2.712l3.7 9.816 3.78-9.81h2.603zm19.203-7.023h-10.104q0 2.46 1.347 3.78 1.191 1.15 3.06 1.15 2.131 0 3.558-1.242l1.046 1.784q-.575.578-1.766.996a9.5 9.5 0 0 1-3.321.548 6.2 6.2 0 0 1-4.487-1.784q-2.053-1.975-2.053-5.31 0-3.464 2.108-5.558a6.13 6.13 0 0 1 4.461-1.871q2.996 0 4.703 1.688 1.65 1.62 1.649 4.304a5.5 5.5 0 0 1-.201 1.514m-6.037-5.415a3.92 3.92 0 0 0-4.001 3.61h7.755a3.54 3.54 0 0 0-.941-2.513q-1.032-1.098-2.813-1.097M62.171 39.59q-.932 1.17-2.854 1.17a2.46 2.46 0 0 1-1.784-.75 2.5 2.5 0 0 1-.755-1.86q0-1.33 1.164-2.252 1.164-.923 2.972-.92c.38.01.756.083 1.113.215q0-2.128-1.897-2.126-1.46 0-2.24.785l-.648-1.298a3.9 3.9 0 0 1 1.222-.618 4.8 4.8 0 0 1 1.492-.257q1.907 0 2.768.867.861.868.863 2.757v3.13q0 1.152.688 1.537v.777q-.95 0-1.42-.27a1.53 1.53 0 0 1-.684-.886m-.147-3.295a5.7 5.7 0 0 0-1.03-.162q-1.177 0-1.922.607-.744.606-.744 1.428 0 1.367 1.61 1.367 1.18 0 2.086-1.12zm7.563-4.457v5.585q0 2.027 1.758 2.027a2.4 2.4 0 0 0 1.406-.441 2.13 2.13 0 0 0 .842-1.024V31.84h1.555v8.757h-1.555v-1.21q-.261.514-1.05.944c-.47.27-1 .419-1.542.43q-1.438 0-2.204-.826-.765-.825-.763-2.348V31.84zm10.745 1.228h-1.014v-1.228h1.014V30l1.553-.597v2.433h2.404v1.227h-2.404v4.35q0 1.1.373 1.57c.247.309.649.465 1.197.465a2.85 2.85 0 0 0 1.234-.304l.23 1.367a8.7 8.7 0 0 1-2.117.245 2.3 2.3 0 0 1-1.755-.773 2.76 2.76 0 0 1-.715-1.946zm7.688 3.132q0-2.03 1.091-3.276 1.091-1.247 2.876-1.247 1.881 0 2.918 1.198 1.038 1.199 1.038 3.325 0 2.108-1.062 3.338-1.062 1.231-2.893 1.223-1.876 0-2.919-1.234t-1.049-3.328m1.635 0q0 3.293 2.332 3.293a1.97 1.97 0 0 0 1.704-.882q.618-.882.616-2.411 0-3.255-2.32-3.255a2 2 0 0 0-1.698.866q-.633.869-.634 2.389m20.692 4.398v-5.542q0-2.07-1.784-2.07c-.38.002-.749.124-1.056.347a1.83 1.83 0 0 0-.669.79v6.475h-1.554V34.38a1.22 1.22 0 0 0-.486-1.018 2.07 2.07 0 0 0-1.288-.372 1.8 1.8 0 0 0-.994.36 2.2 2.2 0 0 0-.748.793v6.46h-1.553v-8.758h1.015l.514 1.014q.897-1.177 2.249-1.177 1.882 0 2.632 1.169a2 2 0 0 1 .973-.834 3.4 3.4 0 0 1 1.46-.335q1.353 0 2.1.81.746.811.744 2.261v5.854zm11.22-1.006q-.934 1.17-2.854 1.17a2.46 2.46 0 0 1-1.784-.75 2.5 2.5 0 0 1-.756-1.86q0-1.33 1.165-2.252 1.164-.923 2.972-.92c.38.01.756.083 1.112.215q0-2.128-1.897-2.126-1.46 0-2.241.785l-.649-1.298a3.8 3.8 0 0 1 1.223-.618c.48-.165.984-.252 1.492-.257q1.905 0 2.768.867.862.868.861 2.757v3.13q0 1.152.688 1.537v.777q-.949 0-1.418-.27a1.52 1.52 0 0 1-.682-.886m-.148-3.295a5.7 5.7 0 0 0-1.031-.162q-1.178 0-1.922.607-.744.606-.743 1.428 0 1.367 1.611 1.367 1.177 0 2.085-1.12zm6.897-3.229h-1.012v-1.228h1.012V30l1.555-.597v2.433h2.403v1.227h-2.403v4.35q0 1.1.371 1.57.373.464 1.198.465a2.9 2.9 0 0 0 1.235-.304l.228 1.367a8.6 8.6 0 0 1-2.113.248 2.3 2.3 0 0 1-1.753-.773 2.76 2.76 0 0 1-.717-1.946zm9.181 7.529v-7.448h-1.193v-1.31h2.756v8.758zm.85-12.068a.95.95 0 1 1-.013 1.9.95.95 0 0 1 .013-1.9m4.945 7.671q0-2.03 1.092-3.276 1.094-1.247 2.874-1.247 1.881 0 2.919 1.198 1.038 1.199 1.038 3.325 0 2.108-1.062 3.338-1.063 1.231-2.895 1.223-1.874 0-2.919-1.234-1.046-1.234-1.047-3.328m1.636 0q0 3.293 2.33 3.293a1.96 1.96 0 0 0 1.704-.882q.618-.882.618-2.411 0-3.255-2.322-3.255a2 2 0 0 0-1.696.866q-.634.869-.634 2.389m15.739 4.398v-5.094q0-1.398-.421-1.959-.423-.56-1.411-.56a2.3 2.3 0 0 0-1.113.325 2.46 2.46 0 0 0-.89.785v6.508h-1.555v-8.757h1.062l.487 1.135q.768-1.297 2.51-1.297 2.878 0 2.878 3.5v5.42z" }), /* @__PURE__ */ s.createElement("path", { fill: "#8DC63E", d: "M43.803 24q0-.958-.09-1.894l4.182-2.808a24 24 0 0 0-.832-3.128l-5.027-.341a20 20 0 0 0-1.894-3.284l2.212-4.511a24 24 0 0 0-2.293-2.295l-4.517 2.207a19.7 19.7 0 0 0-3.287-1.9l-.34-5.027A24 24 0 0 0 28.79.193L25.985 4.38a20 20 0 0 0-3.791 0L19.384.193a24 24 0 0 0-3.132.837l-.339 5.027a19.7 19.7 0 0 0-3.28 1.89l-4.51-2.208a24 24 0 0 0-2.295 2.295l2.22 4.511a20 20 0 0 0-1.9 3.284l-5.027.34a24 24 0 0 0-.834 3.129l4.179 2.804q-.092.934-.094 1.898c0 .642.034 1.27.094 1.896L.287 28.703a24 24 0 0 0 .834 3.131l5.027.34a19.7 19.7 0 0 0 1.9 3.275l-2.22 4.513a25 25 0 0 0 2.3 2.298l4.513-2.217a20 20 0 0 0 3.278 1.899l.34 5.027q1.534.524 3.126.838l2.809-4.185c.626.06 1.255.097 1.897.097s1.274-.037 1.897-.097l2.802 4.18q1.588-.312 3.12-.833l.34-5.027a20 20 0 0 0 3.288-1.899l4.511 2.217a24.5 24.5 0 0 0 2.293-2.293l-2.2-4.511a20 20 0 0 0 1.899-3.286l5.027-.339q.518-1.536.827-3.128l-4.186-2.807c.063-.626.094-1.247.094-1.896M24.088 38.825a14.824 14.824 0 1 1 .006-29.648 14.824 14.824 0 0 1-.006 29.648" }), /* @__PURE__ */ s.createElement("path", { fill: "#fff", d: "M33.454 24c0-1.223-5.25-9.123-5.25-9.123-.417-.719-1.757-.719-2.99 0-1.235.718-1.896 1.88-1.478 2.594l.584 1.006 1.621 2.825H15.313c-.832 0-1.505 1.208-1.508 2.698 0 1.49.676 2.7 1.508 2.698h10.635l-1.622 2.825-.584 1.006c-.418.72.244 1.882 1.478 2.594s2.573.715 2.99 0c0 0 5.25-7.9 5.25-9.123z" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "inductiveAutomation_svg__a" }, /* @__PURE__ */ s.createElement("path", { fill: "#fff", d: "M.25 0h169.5v48H.25z" })))), Ms = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M19.5598 15.175L17.1548 14.175C17.3215 13.1481 17.4117 12.1102 17.4248 11.07C17.4451 9.17122 17.0081 7.29548 16.151 5.60112C15.2938 3.90675 14.0415 2.44352 12.4998 1.33496V4.99996C12.4998 5.13257 12.4471 5.25975 12.3534 5.35351C12.2596 5.44728 12.1324 5.49996 11.9998 5.49996C11.8672 5.49996 11.74 5.44728 11.6463 5.35351C11.5525 5.25975 11.4998 5.13257 11.4998 4.99996V1.33496C9.95814 2.44352 8.70585 3.90675 7.84866 5.60112C6.99147 7.29548 6.55456 9.17122 6.57481 11.07C6.5879 12.1102 6.67815 13.1481 6.84481 14.175L4.43981 15.175C4.39855 15.1911 4.36311 15.2193 4.33813 15.2558C4.31315 15.2924 4.2998 15.3357 4.29981 15.38V22.78C4.29957 22.8213 4.31095 22.8618 4.33265 22.8969C4.35435 22.932 4.3855 22.9603 4.42253 22.9786C4.45956 22.9968 4.50099 23.0043 4.54206 23.0001C4.58314 22.996 4.62221 22.9803 4.65481 22.955L7.85481 20.555C7.30402 19.5926 6.87251 18.5667 6.56981 17.5C6.53202 17.3727 6.54634 17.2356 6.60963 17.1188C6.67293 17.0021 6.78 16.9153 6.90731 16.8775C7.03461 16.8397 7.17172 16.854 7.28846 16.9173C7.4052 16.9806 7.49202 17.0877 7.52981 17.215C7.89809 18.5488 8.49714 19.8078 9.29981 20.935H11.4998V14.405C11.4998 14.2724 11.5525 14.1452 11.6463 14.0514C11.74 13.9576 11.8672 13.905 11.9998 13.905C12.1324 13.905 12.2596 13.9576 12.3534 14.0514C12.4471 14.1452 12.4998 14.2724 12.4998 14.405V20.935H14.6998C15.5025 19.8078 16.1015 18.5488 16.4698 17.215C16.4885 17.1519 16.5195 17.0932 16.5609 17.0421C16.6023 16.991 16.6534 16.9486 16.7112 16.9173C16.769 16.8859 16.8324 16.8663 16.8978 16.8595C16.9632 16.8526 17.0293 16.8587 17.0923 16.8775C17.1553 16.8962 17.2141 16.9271 17.2651 16.9685C17.3162 17.0099 17.3586 17.061 17.39 17.1188C17.4213 17.1766 17.441 17.24 17.4478 17.3054C17.4546 17.3708 17.4485 17.4369 17.4298 17.5C17.1271 18.5667 16.6956 19.5926 16.1448 20.555L19.3448 22.955C19.3774 22.9803 19.4165 22.996 19.4576 23.0001C19.4986 23.0043 19.5401 22.9968 19.5771 22.9786C19.6141 22.9603 19.6453 22.932 19.667 22.8969C19.6887 22.8618 19.7001 22.8213 19.6998 22.78V15.38C19.6998 15.3357 19.6865 15.2924 19.6615 15.2558C19.6365 15.2193 19.6011 15.1911 19.5598 15.175ZM11.9998 12.56C11.4065 12.56 10.8264 12.384 10.3331 12.0544C9.83975 11.7247 9.45523 11.2562 9.22817 10.708C9.00111 10.1598 8.9417 9.55663 9.05745 8.97469C9.17321 8.39275 9.45893 7.8582 9.87849 7.43864C10.298 7.01908 10.8326 6.73336 11.4145 6.61761C11.9965 6.50185 12.5997 6.56126 13.1479 6.78832C13.696 7.01539 14.1646 7.3999 14.4942 7.89325C14.8239 8.3866 14.9998 8.96662 14.9998 9.55996C14.9998 10.3556 14.6837 11.1187 14.1211 11.6813C13.5585 12.2439 12.7955 12.56 11.9998 12.56Z", fill: "currentColor" })), Es = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M5.11983 7.75C5.12016 7.98202 5.05932 8.21003 4.94345 8.41105C4.82758 8.61206 4.66077 8.77899 4.45983 8.895C4.25947 8.77906 4.09313 8.61247 3.97748 8.41193C3.86184 8.2114 3.80096 7.98399 3.80096 7.7525C3.80096 7.52101 3.86184 7.2936 3.97748 7.09307C4.09313 6.89253 4.25947 6.72594 4.45983 6.61C4.66004 6.72559 4.82637 6.89172 4.9422 7.09179C5.05803 7.29185 5.11928 7.51883 5.11983 7.75ZM2.82983 10.335C2.99307 10.4981 3.19637 10.6154 3.41929 10.6751C3.64222 10.7348 3.87692 10.7348 4.09983 10.675C4.16052 10.4514 4.16104 10.2157 4.10133 9.99177C4.04163 9.76787 3.92382 9.56372 3.75983 9.4C3.59674 9.23982 3.39511 9.12438 3.1744 9.06483C2.9537 9.00527 2.72137 9.00361 2.49983 9.06C2.43789 9.28277 2.43578 9.51794 2.49371 9.74179C2.55165 9.96564 2.66759 10.1703 2.82983 10.335ZM2.82983 12.665C2.99301 12.8281 3.19652 12.9451 3.41962 13.0039C3.64271 13.0628 3.87743 13.0614 4.09983 13C4.15753 12.7785 4.15639 12.5457 4.09654 12.3248C4.03669 12.1038 3.92019 11.9023 3.75858 11.7402C3.59696 11.5781 3.39582 11.4609 3.17505 11.4004C2.95429 11.3399 2.72154 11.338 2.49983 11.395C2.43779 11.617 2.43564 11.8514 2.4936 12.0745C2.55157 12.2976 2.66758 12.5013 2.82983 12.665ZM2.82983 15C2.99307 15.1631 3.19637 15.2804 3.41929 15.3401C3.64222 15.3998 3.87692 15.3998 4.09983 15.34C4.15971 15.1178 4.16023 14.8838 4.10135 14.6614C4.04247 14.4389 3.92625 14.2358 3.7643 14.0723C3.60235 13.9089 3.40034 13.7908 3.17845 13.7298C2.95656 13.6689 2.72256 13.6672 2.49983 13.725C2.43789 13.9478 2.43578 14.1829 2.49371 14.4068C2.55165 14.6306 2.66759 14.8353 2.82983 15ZM6.42983 9.06C6.20683 9.00177 5.97252 9.0025 5.74988 9.0621C5.52724 9.12171 5.32392 9.23814 5.15983 9.4C4.99585 9.56372 4.87804 9.76787 4.81833 9.99177C4.75862 10.2157 4.75914 10.4514 4.81983 10.675C5.04322 10.735 5.27848 10.735 5.50187 10.675C5.72526 10.615 5.92888 10.4972 6.09218 10.3334C6.25548 10.1696 6.37269 9.96561 6.43197 9.74203C6.49125 9.51846 6.49052 9.2832 6.42983 9.06ZM6.42983 11.395C6.20747 11.3358 5.97347 11.336 5.75121 11.3956C5.52895 11.4552 5.32621 11.572 5.16325 11.7345C5.00029 11.8969 4.88281 12.0993 4.82255 12.3214C4.76228 12.5435 4.76135 12.7775 4.81983 13C5.04271 13.0596 5.27734 13.0595 5.50016 12.9997C5.72298 12.9399 5.92616 12.8226 6.08929 12.6595C6.25242 12.4963 6.36976 12.2931 6.42954 12.0703C6.48931 11.8475 6.48941 11.6129 6.42983 11.39V11.395ZM6.42983 13.725C6.20645 13.665 5.97119 13.665 5.7478 13.725C5.5244 13.785 5.32079 13.9028 5.15748 14.0666C4.99418 14.2304 4.87698 14.4344 4.81769 14.658C4.75841 14.8815 4.75915 15.1168 4.81983 15.34C5.04322 15.4 5.27848 15.4 5.50187 15.34C5.72526 15.28 5.92888 15.1622 6.09218 14.9984C6.25548 14.8346 6.37269 14.6306 6.43197 14.407C6.49125 14.1835 6.49052 13.9482 6.42983 13.725ZM4.95983 19V16.5C4.95983 16.3674 4.90715 16.2402 4.81339 16.1464C4.71962 16.0527 4.59244 16 4.45983 16C4.32722 16 4.20005 16.0527 4.10628 16.1464C4.01251 16.2402 3.95983 16.3674 3.95983 16.5V19C3.95983 19.1326 4.01251 19.2598 4.10628 19.3536C4.20005 19.4473 4.32722 19.5 4.45983 19.5C4.59244 19.5 4.71962 19.4473 4.81339 19.3536C4.90715 19.2598 4.95983 19.1326 4.95983 19ZM11.9998 0C11.5721 0.247116 11.2169 0.602453 10.9699 1.03031C10.723 1.45817 10.593 1.94349 10.593 2.4375C10.593 2.93151 10.723 3.41683 10.9699 3.84469C11.2169 4.27255 11.5721 4.62788 11.9998 4.875C12.4276 4.62788 12.7828 4.27255 13.0297 3.84469C13.2767 3.41683 13.4067 2.93151 13.4067 2.4375C13.4067 1.94349 13.2767 1.45817 13.0297 1.03031C12.7828 0.602453 12.4276 0.247116 11.9998 0ZM8.55983 7.37C8.90893 7.71852 9.34361 7.969 9.8202 8.09626C10.2968 8.22353 10.7985 8.22309 11.2748 8.095C11.4035 7.61797 11.4042 7.11543 11.2767 6.63807C11.1493 6.1607 10.8982 5.72538 10.5488 5.37601C10.1995 5.02663 9.76413 4.77555 9.28677 4.64809C8.8094 4.52063 8.30686 4.52129 7.82983 4.65C7.70143 5.12752 7.70131 5.63047 7.82948 6.10805C7.95766 6.58564 8.20959 7.02094 8.55983 7.37ZM8.55983 11.765C8.90732 12.1161 9.34151 12.3691 9.81834 12.4982C10.2952 12.6272 10.7977 12.6279 11.2748 12.5C11.4035 12.023 11.4042 11.5204 11.2767 11.0431C11.1493 10.5657 10.8982 10.1304 10.5488 9.78101C10.1995 9.43163 9.76413 9.18055 9.28677 9.05309C8.8094 8.92563 8.30686 8.92629 7.82983 9.055C7.70227 9.531 7.7026 10.0322 7.83077 10.5081C7.95895 10.9839 8.21044 11.4175 8.55983 11.765ZM8.55983 16.165C8.90841 16.5144 9.34286 16.7658 9.81947 16.894C10.2961 17.0221 10.798 17.0225 11.2748 16.895C11.403 16.4178 11.4034 15.9153 11.2758 15.438C11.1482 14.9606 10.8973 14.5252 10.5482 14.1756C10.199 13.826 9.76404 13.5744 9.28688 13.4461C8.80971 13.3179 8.3072 13.3175 7.82983 13.445C7.70143 13.9225 7.70131 14.4255 7.82948 14.9031C7.95766 15.3806 8.20959 15.8159 8.55983 16.165ZM16.1698 4.665C15.6928 4.53629 15.1903 4.53563 14.7129 4.66309C14.2355 4.79055 13.8002 5.04163 13.4508 5.39101C13.1015 5.74038 12.8504 6.1757 12.7229 6.65307C12.5955 7.13043 12.5961 7.63297 12.7248 8.11C13.2034 8.23997 13.7078 8.24097 14.1869 8.11291C14.666 7.98485 15.1027 7.73229 15.4526 7.38087C15.8025 7.02945 16.0531 6.5917 16.1791 6.11206C16.3051 5.63243 16.3019 5.128 16.1698 4.65V4.665ZM16.1698 9.065C15.6938 8.9371 15.1925 8.93666 14.7163 9.06373C14.2401 9.19079 13.8056 9.44088 13.4566 9.7889C13.1076 10.1369 12.8562 10.5706 12.7278 11.0465C12.5993 11.5223 12.5983 12.0236 12.7248 12.5C13.2017 12.6271 13.7036 12.6266 14.1802 12.4985C14.6568 12.3705 15.0913 12.1194 15.4403 11.7705C15.7892 11.4215 16.0403 10.9869 16.1684 10.5103C16.2964 10.0337 16.2969 9.53185 16.1698 9.055V9.065ZM16.1698 13.46C15.6925 13.3325 15.19 13.3329 14.7128 13.4611C14.2356 13.5894 13.8006 13.841 13.4515 14.1906C13.1024 14.5402 12.8514 14.9756 12.7239 15.453C12.5963 15.9303 12.5966 16.4328 12.7248 16.91C13.2022 17.0375 13.7047 17.0371 14.1819 16.9089C14.659 16.7806 15.094 16.529 15.4432 16.1794C15.7923 15.8298 16.0432 15.3944 16.1708 14.917C16.2984 14.4397 16.298 13.9372 16.1698 13.46ZM19.5398 6.625C19.3395 6.74094 19.1731 6.90753 19.0575 7.10807C18.9418 7.3086 18.881 7.53601 18.881 7.7675C18.881 7.99899 18.9418 8.2264 19.0575 8.42693C19.1731 8.62747 19.3395 8.79406 19.5398 8.91C19.7402 8.79406 19.9065 8.62747 20.0222 8.42693C20.1378 8.2264 20.1987 7.99899 20.1987 7.7675C20.1987 7.53601 20.1378 7.3086 20.0222 7.10807C19.9065 6.90753 19.7402 6.74094 19.5398 6.625ZM17.9098 10.35C18.0731 10.5131 18.2764 10.6304 18.4993 10.6901C18.7222 10.7498 18.9569 10.7498 19.1798 10.69C19.2405 10.4664 19.241 10.2307 19.1813 10.0068C19.1216 9.78287 19.0038 9.57872 18.8398 9.415C18.6757 9.25314 18.4724 9.13671 18.2498 9.0771C18.0271 9.0175 17.7928 9.01677 17.5698 9.075C17.5119 9.29645 17.5129 9.52917 17.5725 9.75015C17.6321 9.97114 17.7484 10.1727 17.9098 10.335V10.35ZM17.9098 12.68C18.0725 12.844 18.2758 12.9619 18.4989 13.0216C18.722 13.0813 18.957 13.0808 19.1798 13.02C19.2394 12.7971 19.2393 12.5625 19.1795 12.3397C19.1198 12.1169 19.0024 11.9137 18.8393 11.7505C18.6762 11.5874 18.473 11.4701 18.2502 11.4103C18.0273 11.3505 17.7927 11.3504 17.5698 11.41C17.5119 11.6307 17.5127 11.8627 17.5724 12.0829C17.6321 12.3031 17.7484 12.5038 17.9098 12.665V12.68ZM17.9098 15.015C18.0731 15.1781 18.2764 15.2954 18.4993 15.3551C18.7222 15.4148 18.9569 15.4148 19.1798 15.355C19.2405 15.1318 19.2413 14.8965 19.182 14.673C19.1227 14.4494 19.0055 14.2454 18.8422 14.0816C18.6789 13.9178 18.4753 13.8 18.2519 13.74C18.0285 13.68 17.7932 13.68 17.5698 13.74C17.5119 13.9614 17.5129 14.1942 17.5725 14.4152C17.6321 14.6361 17.7484 14.8377 17.9098 15V15.015ZM21.4998 9.06C21.2768 9.00177 21.0425 9.0025 20.8199 9.0621C20.5972 9.12171 20.3939 9.23814 20.2298 9.4C20.0658 9.56372 19.948 9.76787 19.8883 9.99177C19.8286 10.2157 19.8291 10.4514 19.8898 10.675C20.1132 10.735 20.3485 10.735 20.5719 10.675C20.7953 10.615 20.9989 10.4972 21.1622 10.3334C21.3255 10.1696 21.4427 9.96561 21.502 9.74203C21.5613 9.51846 21.5605 9.2832 21.4998 9.06ZM21.4998 11.395C21.2781 11.338 21.0454 11.3399 20.8246 11.4004C20.6038 11.4609 20.4027 11.5781 20.2411 11.7402C20.0795 11.9023 19.963 12.1038 19.9031 12.3248C19.8433 12.5457 19.8421 12.7785 19.8998 13C20.1215 13.057 20.3543 13.0551 20.5751 12.9946C20.7958 12.9341 20.997 12.8169 21.1586 12.6548C21.3202 12.4927 21.4367 12.2912 21.4965 12.0702C21.5564 11.8493 21.5575 11.6165 21.4998 11.395ZM21.4998 13.725C21.2764 13.665 21.0412 13.665 20.8178 13.725C20.5944 13.785 20.3908 13.9028 20.2275 14.0666C20.0642 14.2304 19.947 14.4344 19.8877 14.658C19.8284 14.8815 19.8291 15.1168 19.8898 15.34C20.1132 15.4 20.3485 15.4 20.5719 15.34C20.7953 15.28 20.9989 15.1622 21.1622 14.9984C21.3255 14.8346 21.4427 14.6306 21.502 14.407C21.5613 14.1835 21.5605 13.9482 21.4998 13.725ZM20.0398 19V16.5C20.0398 16.3674 19.9872 16.2402 19.8934 16.1464C19.7996 16.0527 19.6724 16 19.5398 16C19.4072 16 19.28 16.0527 19.1863 16.1464C19.0925 16.2402 19.0398 16.3674 19.0398 16.5V19C19.0398 19.1326 19.0925 19.2598 19.1863 19.3536C19.28 19.4473 19.4072 19.5 19.5398 19.5C19.6724 19.5 19.7996 19.4473 19.8934 19.3536C19.9872 19.2598 20.0398 19.1326 20.0398 19ZM12.7498 23V18.345C12.7498 18.1461 12.6708 17.9553 12.5302 17.8147C12.3895 17.674 12.1987 17.595 11.9998 17.595C11.8009 17.595 11.6102 17.674 11.4695 17.8147C11.3288 17.9553 11.2498 18.1461 11.2498 18.345V23C11.2498 23.1989 11.3288 23.3897 11.4695 23.5303C11.6102 23.671 11.8009 23.75 11.9998 23.75C12.1987 23.75 12.3895 23.671 12.5302 23.5303C12.6708 23.3897 12.7498 23.1989 12.7498 23Z", fill: "currentColor" })), Ns = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "#3A86FF", d: "M27 33H29V27H27V33ZM28 25C28.28 25 28.52 24.9 28.71 24.71C28.9 24.52 29 24.28 29 24C29 23.72 28.9 23.48 28.71 23.29C28.52 23.1 28.28 23 28 23C27.72 23 27.48 23.1 27.29 23.29C27.1 23.48 27 23.72 27 24C27 24.28 27.1 24.52 27.29 24.71C27.48 24.9 27.72 25 28 25ZM28 38C26.62 38 25.32 37.74 24.1 37.21C22.88 36.68 21.82 35.97 20.92 35.07C20.02 34.17 19.31 33.11 18.78 31.89C18.25 30.67 17.99 29.37 17.99 27.99C17.99 26.61 18.25 25.31 18.78 24.09C19.31 22.87 20.02 21.81 20.92 20.91C21.82 20.01 22.88 19.3 24.1 18.77C25.32 18.24 26.62 17.98 28 17.98C29.38 17.98 30.68 18.24 31.9 18.77C33.12 19.3 34.18 20.01 35.08 20.91C35.98 21.81 36.69 22.87 37.22 24.09C37.75 25.31 38.01 26.61 38.01 27.99C38.01 29.37 37.75 30.67 37.22 31.89C36.69 33.11 35.98 34.17 35.08 35.07C34.18 35.97 33.12 36.68 31.9 37.21C30.68 37.74 29.38 38 28 38Z" }))), Is = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M11.0002 17H13.0002V11H11.0002V17ZM12.0002 8.99998C12.2802 8.99998 12.5202 8.89998 12.7102 8.70998C12.9002 8.51998 13.0002 8.27998 13.0002 7.99998C13.0002 7.71998 12.9002 7.47998 12.7102 7.28998C12.5202 7.09998 12.2802 6.99998 12.0002 6.99998C11.7202 6.99998 11.4802 7.09998 11.2902 7.28998C11.1002 7.47998 11.0002 7.71998 11.0002 7.99998C11.0002 8.27998 11.1002 8.51998 11.2902 8.70998C11.4802 8.89998 11.7202 8.99998 12.0002 8.99998ZM12.0002 22C10.6202 22 9.32024 21.74 8.10023 21.21C6.88023 20.68 5.82023 19.97 4.92023 19.07C4.02023 18.17 3.31023 17.11 2.78023 15.89C2.25023 14.67 1.99023 13.37 1.99023 11.99C1.99023 10.61 2.25023 9.30998 2.78023 8.08998C3.31023 6.86998 4.02023 5.80998 4.92023 4.90998C5.82023 4.00998 6.88023 3.29998 8.10023 2.76998C9.32024 2.23998 10.6202 1.97998 12.0002 1.97998C13.3802 1.97998 14.6802 2.23998 15.9002 2.76998C17.1202 3.29998 18.1802 4.00998 19.0802 4.90998C19.9802 5.80998 20.6902 6.86998 21.2202 8.08998C21.7502 9.30998 22.0102 10.61 22.0102 11.99C22.0102 13.37 21.7502 14.67 21.2202 15.89C20.6902 17.11 19.9802 18.17 19.0802 19.07C18.1802 19.97 17.1202 20.68 15.9002 21.21C14.6802 21.74 13.3802 22 12.0002 22ZM12.0002 20C14.2302 20 16.1302 19.22 17.6802 17.67C19.2302 16.12 20.0102 14.23 20.0102 11.99C20.0102 9.74998 19.2302 7.85998 17.6802 6.30998C16.1302 4.75998 14.2402 3.97998 12.0002 3.97998C9.76023 3.97998 7.87023 4.75998 6.32023 6.30998C4.77023 7.85998 3.99023 9.74998 3.99023 11.99C3.99023 14.23 4.77023 16.12 6.32023 17.67C7.87023 19.22 9.76023 20 12.0002 20Z", fill: "#BDBDBD" })), $s = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -64)" }, /* @__PURE__ */ s.createElement("path", { fill: "#F2664C", d: "M28 81C28.28 81 28.52 80.9 28.71 80.71C28.9 80.52 29 80.28 29 80C29 79.72 28.9 79.48 28.71 79.29C28.52 79.1 28.28 79 28 79C27.72 79 27.48 79.1 27.29 79.29C27.1 79.48 27 79.72 27 80C27 80.28 27.1 80.52 27.29 80.71C27.48 80.9 27.72 81 28 81ZM27 77H29V71H27V77ZM28 86C26.62 86 25.32 85.74 24.1 85.21C22.88 84.68 21.82 83.97 20.92 83.07C20.02 82.17 19.31 81.11 18.78 79.89C18.25 78.67 17.99 77.37 17.99 75.99C17.99 74.61 18.25 73.31 18.78 72.09C19.31 70.87 20.02 69.81 20.92 68.91C21.82 68.01 22.88 67.3 24.1 66.77C25.32 66.24 26.62 65.98 28 65.98C29.38 65.98 30.68 66.24 31.9 66.77C33.12 67.3 34.18 68.01 35.08 68.91C35.98 69.81 36.69 70.87 37.22 72.09C37.75 73.31 38.01 74.61 38.01 75.99C38.01 77.37 37.75 78.67 37.22 79.89C36.69 81.11 35.98 82.17 35.08 83.07C34.18 83.97 33.12 84.68 31.9 85.21C30.68 85.74 29.38 86 28 86ZM28 84C30.23 84 32.13 83.22 33.68 81.67C35.23 80.12 36.01 78.23 36.01 75.99C36.01 73.75 35.23 71.86 33.68 70.31C32.13 68.76 30.24 67.98 28 67.98C25.76 67.98 23.87 68.76 22.32 70.31C20.77 71.86 19.99 73.75 19.99 75.99C19.99 78.23 20.77 80.12 22.32 81.67C23.87 83.22 25.76 84 28 84Z" }))), _s = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-64 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "#3A86FF", d: "M75 33H77V27H75V33ZM76 25C76.28 25 76.52 24.9 76.71 24.71C76.9 24.52 77 24.28 77 24C77 23.72 76.9 23.48 76.71 23.29C76.52 23.1 76.28 23 76 23C75.72 23 75.48 23.1 75.29 23.29C75.1 23.48 75 23.72 75 24C75 24.28 75.1 24.52 75.29 24.71C75.48 24.9 75.72 25 76 25ZM76 38C74.62 38 73.32 37.74 72.1 37.21C70.88 36.68 69.82 35.97 68.92 35.07C68.02 34.17 67.31 33.11 66.78 31.89C66.25 30.67 65.99 29.37 65.99 27.99C65.99 26.61 66.25 25.31 66.78 24.09C67.31 22.87 68.02 21.81 68.92 20.91C69.82 20.01 70.88 19.3 72.1 18.77C73.32 18.24 74.62 17.98 76 17.98C77.38 17.98 78.68 18.24 79.9 18.77C81.12 19.3 82.18 20.01 83.08 20.91C83.98 21.81 84.69 22.87 85.22 24.09C85.75 25.31 86.01 26.61 86.01 27.99C86.01 29.37 85.75 30.67 85.22 31.89C84.69 33.11 83.98 34.17 83.08 35.07C82.18 35.97 81.12 36.68 79.9 37.21C78.68 37.74 77.38 38 76 38ZM76 36C78.23 36 80.13 35.22 81.68 33.67C83.23 32.12 84.01 30.23 84.01 27.99C84.01 25.75 83.23 23.86 81.68 22.31C80.13 20.76 78.24 19.98 76 19.98C73.76 19.98 71.87 20.76 70.32 22.31C68.77 23.86 67.99 25.75 67.99 27.99C67.99 30.23 68.77 32.12 70.32 33.67C71.87 35.22 73.76 36 76 36Z" }))), Vs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M12.11 20H2v-2c0-2.66 5.33-4 8-4h.08c-.05.33-.08.66-.08 1s.03.67.08 1H10c-2.69 0-5.77 1.28-6 2h6.68c.36.75.84 1.43 1.42 2zM18 16h3v-2h-3v-3h-2v3h-3v2h3v3h2zm-4-8c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4m-2 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2" })), As = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -64)" }, /* @__PURE__ */ s.createElement("path", { fill: "#7BBA19", d: "M26.6 80.6L33.65 73.55L32.25 72.15L26.6 77.8L23.75 74.95L22.35 76.35L26.6 80.6ZM28 86C26.62 86 25.32 85.74 24.1 85.21C22.88 84.68 21.82 83.97 20.92 83.07C20.02 82.17 19.31 81.11 18.78 79.89C18.25 78.67 17.99 77.37 17.99 75.99C17.99 74.61 18.25 73.31 18.78 72.09C19.31 70.87 20.02 69.81 20.92 68.91C21.82 68.01 22.88 67.3 24.1 66.77C25.32 66.24 26.62 65.98 28 65.98C29.38 65.98 30.68 66.24 31.9 66.77C33.12 67.3 34.18 68.01 35.08 68.91C35.98 69.81 36.69 70.87 37.22 72.09C37.75 73.31 38.01 74.61 38.01 75.99C38.01 77.37 37.75 78.67 37.22 79.89C36.69 81.11 35.98 82.17 35.08 83.07C34.18 83.97 33.12 84.68 31.9 85.21C30.68 85.74 29.38 86 28 86ZM28 84C30.23 84 32.13 83.22 33.68 81.67C35.23 80.12 36.01 78.23 36.01 75.99C36.01 73.75 35.23 71.86 33.68 70.31C32.13 68.76 30.24 67.98 28 67.98C25.76 67.98 23.87 68.76 22.32 70.31C20.77 71.86 19.99 73.75 19.99 75.99C19.99 78.23 20.77 80.12 22.32 81.67C23.87 83.22 25.76 84 28 84Z" }))), Bs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -64)" }, /* @__PURE__ */ s.createElement("path", { fill: "#E9AF23", d: "M17.87 83.5L27.13 67.49C27.52 66.82 28.48 66.82 28.86 67.49L38.13 83.49C38.52 84.16 38.03 84.99 37.26 84.99H18.73C17.96 84.99 17.48 84.16 17.86 83.49L17.87 83.5ZM20.45 83H35.55L28 70L20.45 83ZM28 82C28.28 82 28.52 81.9 28.71 81.71C28.9 81.52 29 81.28 29 81C29 80.72 28.9 80.48 28.71 80.29C28.52 80.1 28.28 80 28 80C27.72 80 27.48 80.1 27.29 80.29C27.1 80.48 27 80.72 27 81C27 81.28 27.1 81.52 27.29 81.71C27.48 81.9 27.72 82 28 82ZM27 79H29V74H27V79Z" }))), Hs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#fff", d: "M10 16c0 1.49.47 2.87 1.26 4H2v-2c0-2.66 5.33-4 8-4h.29c-.19.63-.29 1.3-.29 1.99zm0-12C7.79 4 6 5.79 6 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8 10v-3h-2v3h-3v2h3v3h2v-3h3v-2z" })), Ds = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "m14.58 21.56-.08-.04-1.04-.58 1.03-.62.08-.05a2.32 2.32 0 0 1 2.07-.04l.08.04 1.04.58-1.03.62-.08.05c-.33.18-.7.27-1.08.26h-.05c-.33 0-.65-.08-.94-.23zm-6.16.23c-.38 0-.75-.08-1.08-.26l-.08-.05-1.03-.62 1.04-.58.08-.04c.66-.32 1.43-.3 2.07.04l.08.05 1.03.62-1.04.58-.08.04c-.29.15-.62.23-.95.23H8.4zm3.43-1.13-.65-.38a.34.34 0 0 1-.15-.26v-.75c0-.11.06-.2.15-.26l.65-.37c.1-.05.21-.05.3 0l.65.37c.09.06.14.16.15.26v.75c0 .11-.06.2-.15.26l-.65.37s-.1.03-.15.03-.1-.01-.15-.04zm2.31-2.05.02-.1c.18-.71.69-1.28 1.37-1.56l.09-.03 1.14-.39s-.1.53-.23 1.18l-.02.09c-.18.71-.69 1.29-1.37 1.56l-.1.03-1.14.38s.1-.52.23-1.17zm-5.22.79-.09-.03c-.68-.27-1.19-.85-1.37-1.56l-.02-.1c-.13-.64-.23-1.17-.23-1.17l1.14.39.09.03c.68.27 1.19.85 1.37 1.56l.02.1c.13.65.24 1.17.24 1.17l-1.14-.38zm9.19.19c-.24 0-.47-.04-.69-.14l-.06-.03-.86-.42.79-.54.07-.04c.5-.3 1.12-.35 1.66-.12l.06.03.86.42-.79.54-.07.04c-.28.17-.6.27-.92.27h-.04zM4.9 19.32l-.07-.04-.79-.54.86-.42.06-.03c.54-.22 1.15-.18 1.65.13l.07.04.79.54-.86.42-.07.03c-.22.1-.45.15-.69.14h-.04c-.33 0-.65-.09-.92-.26zm12.87-2.61v-.08c0-.58.27-1.13.74-1.48l.06-.04.8-.52s.03.43.06.96v.08c0 .58-.27 1.13-.74 1.48l-.06.04-.8.52-.05-.95zm-12.4.43-.06-.04c-.47-.35-.75-.9-.74-1.48v-.08c.04-.52.06-.96.06-.96l.8.52.06.04c.47.35.75.9.74 1.48v.08c-.04.52-.06.96-.06.96l-.8-.53zm14.85.22h-.06l-.76-.15.49-.58.04-.05c.32-.34.78-.51 1.25-.45h.05l.76.14-.49.59-.04.05c-.28.3-.66.47-1.07.47-.06 0-.12 0-.18-.01zm-17.69-.45-.04-.05-.49-.59.76-.13h.05c.46-.07.93.1 1.25.44l.04.05.49.58-.76.13h-.06q-.09.03-.18.03c-.41 0-.79-.17-1.07-.47zm17.65-2.07v-.06c-.05-.46.13-.92.48-1.23l.04-.04.6-.47.11.76v.06c.05.46-.13.92-.48 1.23l-.05.04-.6.47-.11-.76zm-17.07.29-.05-.04c-.35-.31-.53-.77-.49-1.23v-.06c.07-.42.12-.76.12-.76l.6.47.04.04c.35.31.53.77.49 1.23v.06c-.07.42-.12.76-.12.76l-.6-.48zM17.37 5.2l-4.92-2.88a.98.98 0 0 0-.91 0L6.61 5.2c-.25.15-.47.51-.47.8v5.75c0 .3.22.66.47.8l4.93 2.88c.25.15.67.15.92 0l4.91-2.88c.25-.15.44-.51.44-.8V6c0-.3-.19-.66-.44-.8m-7.14 6.43h-2v-.56l.49-.19V7.8l-.49-.2v-.55l2-.03v.59l-.49.19v3.08l.49.2v.56zm5.58-4.03-.49.2v1.97c0 1.27-.49 1.95-1.9 1.95-1.32 0-1.85-.58-1.85-1.85V7.81l-.48-.2v-.55l2.01-.03v.59l-.51.2v2.06c0 .75.22 1.05.86 1.05.7 0 .85-.37.85-1.15V7.82l-.51-.2v-.55l2.02-.03v.59z" })), Ts = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H20V8H4V19ZM10 6H14V4H10V6Z", fill: "currentColor" })), Rs = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M12 22C10.6333 22 9.34167 21.7373 8.125 21.212C6.90833 20.6873 5.846 19.9707 4.938 19.062C4.02933 18.154 3.31267 17.0917 2.788 15.875C2.26267 14.6583 2 13.3667 2 12C2 10.6167 2.26267 9.321 2.788 8.113C3.31267 6.90433 4.02933 5.846 4.938 4.938C5.846 4.02933 6.90833 3.31233 8.125 2.787C9.34167 2.26233 10.6333 2 12 2C13.3833 2 14.679 2.26233 15.887 2.787C17.0957 3.31233 18.154 4.02933 19.062 4.938C19.9707 5.846 20.6873 6.90433 21.212 8.113C21.7373 9.321 22 10.6167 22 12C22 13.3667 21.7373 14.6583 21.212 15.875C20.6873 17.0917 19.9707 18.154 19.062 19.062C18.154 19.9707 17.0957 20.6873 15.887 21.212C14.679 21.7373 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.83767 18.429 8.613 17.837C8.38767 17.2457 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.18733 17.5583 6.912 18.175C7.63733 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3623 18.7917 17.087 18.175C17.8123 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6127 17.2457 15.388 17.837C15.1627 18.429 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.56233 13.3373 7.537 13.012C7.51233 12.6873 7.5 12.35 7.5 12C7.5 11.65 7.51233 11.3127 7.537 10.988C7.56233 10.6627 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.104 10.6627 4.062 10.988C4.02067 11.3127 4 11.65 4 12C4 12.35 4.02067 12.6873 4.062 13.012C4.104 13.3373 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4377 13.3373 14.463 13.012C14.4877 12.6873 14.5 12.35 14.5 12C14.5 11.65 14.4877 11.3127 14.463 10.988C14.4377 10.6627 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.56267 10.6627 9.538 10.988C9.51267 11.3127 9.5 11.65 9.5 12C9.5 12.35 9.51267 12.6873 9.538 13.012C9.56267 13.3373 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.896 13.3373 19.938 13.012C19.9793 12.6873 20 12.35 20 12C20 11.65 19.9793 11.3127 19.938 10.988C19.896 10.6627 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4373 10.6627 16.462 10.988C16.4873 11.3127 16.5 11.65 16.5 12C16.5 12.35 16.4873 12.6873 16.462 13.012C16.4373 13.3373 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8123 6.44167 17.087 5.825C16.3623 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1627 5.57067 15.388 6.162C15.6127 6.754 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.38767 6.754 8.613 6.162C8.83767 5.57067 9.1 5 9.4 4.45C8.46667 4.75 7.63733 5.20833 6.912 5.825C6.18733 6.44167 5.58333 7.16667 5.1 8Z", fill: "currentColor" })), Fs = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M21.93,15.72l1.41,1.41-5.15,5.15-3.54-3.54,1.36-1.36,2.12,2.12,3.79-3.79ZM22,12c0,.22-.02.45-.03.67-.9-.42-1.9-.67-2.97-.67-3.87,0-7,3.13-7,7,0,1.06.24,2.06.67,2.97-.22.01-.44.03-.67.03-5.52,0-10-4.48-10-10S6.48,2,12,2c1.35,0,2.63.28,3.8.76l.06-.14c.29-.63.88-1.08,1.57-1.19h.03s.03,0,.03,0c.08,0,.16-.01.24-.01.41,0,.82.11,1.17.31.44.25.8.64,1.01,1.11l.02.03v.04c.23.61.14,1.29-.21,1.83-.06.1-.19.29-.35.53,1.63,1.78,2.62,4.14,2.62,6.73ZM16.71,3.18h0l-.21.44-.54,1.17c-.21.47-.46,1-.74,1.58-.28.58-.56,1.21-.82,1.85-.16.35-.58,1.21-.98,2.04-.4.83-.68,1.41-.82,1.71.31.08.59.23.82.44.25-.36.49-.74.75-1.14l.91-1.47c.63-.91,1.22-1.78,1.76-2.58l1.38-2.04c.09-.14.18-.26.25-.37.07-.1.12-.18.17-.26.13-.19.21-.32.24-.37.19-.29.24-.65.12-.97-.12-.27-.32-.49-.58-.63-.21-.12-.45-.18-.68-.18-.05,0-.09,0-.14,0-.36.06-.67.29-.82.63l-.06.13ZM9.43,10.41c.31.49.91,1.33,1.28,1.89.24-.18.51-.31.81-.38h0c-.14-.5-.4-1.37-.58-1.95l-.17-.58c-.07-.25-.13-.44-.18-.55-.03-.11-.08-.21-.12-.31-.1-.23-.29-.41-.53-.49-.24-.07-.5-.05-.73.07-.23.1-.41.29-.5.53-.09.23-.08.49.04.71.05.1.1.2.16.3.07.11.17.27.32.49l.2.29ZM13.25,14.29c-.05-.64-.56-1.14-1.19-1.19-.72-.06-1.34.48-1.4,1.19,0,.07,0,.14,0,.21.06.72.68,1.25,1.4,1.19.72-.06,1.25-.68,1.19-1.4Z" })), zs = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M14.4,8.22c.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.27-.57c.15-.33.46-.57.82-.63.29-.03.57.03.82.17.26.14.46.37.58.63.11.33.07.69-.12.97-.06.1-.27.43-.66,1l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04ZM11.51,11.91c-.14-.5-.4-1.37-.58-1.95l-.17-.58c-.07-.25-.13-.44-.18-.55-.03-.11-.08-.21-.12-.31-.1-.23-.29-.41-.53-.49-.24-.07-.5-.05-.73.07-.23.1-.41.29-.5.53-.09.23-.08.49.04.71.05.1.1.2.16.3.07.11.17.27.32.49l.2.29c.31.49.91,1.33,1.28,1.89.24-.18.52-.31.81-.38ZM12.06,15.69c.72-.06,1.25-.68,1.19-1.4-.05-.64-.56-1.14-1.19-1.19-.72-.06-1.34.48-1.4,1.19,0,.07,0,.14,0,.21.06.72.68,1.25,1.4,1.19ZM21.93,15.72l1.41,1.41-5.15,5.15-3.54-3.54,1.36-1.36,2.12,2.12,3.79-3.79ZM20,12.08c.7.1,1.36.3,1.97.59.01-.22.03-.44.03-.67,0-2.22-.73-4.27-1.96-5.93-.05.08-.11.16-.17.25l-1.04,1.53c.74,1.21,1.17,2.62,1.17,4.14,0,.03,0,.05,0,.08ZM12.08,20s-.05,0-.08,0c-4.41,0-8-3.59-8-8S7.59,4,12,4c.69,0,1.36.1,2,.26.05-.1.1-.21.14-.3l.55-1.19.17-.35c-.91-.27-1.87-.42-2.86-.42C6.48,2,2,6.48,2,12s4.48,10,10,10c.23,0,.45-.02.67-.03-.29-.61-.49-1.28-.59-1.97Z" })), Ws = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19.38,5.27c.16-.24.28-.43.35-.53.35-.54.43-1.22.22-1.83v-.04s-.03-.03-.03-.03c-.2-.47-.56-.86-1.01-1.11-.35-.2-.76-.31-1.17-.31-.08,0-.16,0-.24.01h-.03s-.03,0-.03,0c-.69.11-1.28.56-1.57,1.19l-.06.14c-1.17-.48-2.46-.76-3.8-.76C6.48,2,2,6.48,2,12s4.48,10,10,10,10-4.48,10-10c0-2.6-1-4.96-2.62-6.73ZM16.78,3.05c.15-.33.46-.57.82-.63.05,0,.09,0,.14,0,.24,0,.48.06.68.18.26.14.46.37.58.63.11.33.07.69-.12.97-.03.05-.11.18-.24.37-.05.08-.11.16-.17.26-.07.11-.16.23-.25.37l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.21-.44h0l.06-.13ZM9.23,10.12c-.15-.21-.26-.38-.32-.49-.06-.1-.12-.19-.16-.3-.12-.22-.14-.48-.04-.71.09-.24.27-.43.5-.53.22-.11.48-.14.73-.07.24.08.43.26.53.49.05.1.09.21.12.31.05.12.11.3.18.55l.17.58c.17.58.44,1.45.58,1.95h0c-.29.07-.57.2-.81.38-.36-.55-.96-1.4-1.28-1.89l-.2-.29ZM12.06,15.69c-.72.06-1.34-.48-1.4-1.19,0-.07,0-.14,0-.21.06-.72.68-1.25,1.4-1.19.64.05,1.14.56,1.19,1.19.06.72-.48,1.34-1.19,1.4Z" })), Os = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M14.4,8.22c.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.27-.57c.15-.33.46-.57.82-.63.29-.03.57.03.82.17.26.14.46.37.58.63.11.33.07.69-.12.97-.06.1-.27.43-.66,1l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04ZM11.51,11.91c-.14-.5-.4-1.37-.58-1.95l-.17-.58c-.07-.25-.13-.44-.18-.55-.03-.11-.08-.21-.12-.31-.1-.23-.29-.41-.53-.49-.24-.07-.5-.05-.73.07-.23.1-.41.29-.5.53-.09.23-.08.49.04.71.05.1.1.2.16.3.07.11.17.27.32.49l.2.29c.31.49.91,1.33,1.28,1.89.24-.18.52-.31.81-.38ZM12.06,15.69c.72-.06,1.25-.68,1.19-1.4-.05-.64-.56-1.14-1.19-1.19-.72-.06-1.34.48-1.4,1.19,0,.07,0,.14,0,.21.06.72.68,1.25,1.4,1.19ZM20.04,6.07c-.05.08-.11.16-.17.25l-1.04,1.53c.74,1.21,1.17,2.62,1.17,4.14,0,4.41-3.59,8-8,8s-8-3.59-8-8S7.59,4,12,4c.69,0,1.36.1,2,.26.05-.1.1-.21.14-.3l.55-1.19.17-.35c-.91-.27-1.87-.42-2.86-.42C6.48,2,2,6.48,2,12s4.48,10,10,10,10-4.48,10-10c0-2.22-.73-4.27-1.96-5.93Z" })), Zs = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M22.54,16.88l-1.41-1.41-2.12,2.12-2.12-2.12-1.41,1.41,2.12,2.12-2.12,2.12,1.41,1.41,2.12-2.12,2.12,2.12,1.41-1.41-2.12-2.12,2.12-2.12ZM19.38,5.27c.16-.24.29-.43.35-.53.35-.54.43-1.22.22-1.83v-.04s-.03-.03-.03-.03c-.2-.47-.56-.86-1.01-1.11-.35-.2-.76-.31-1.17-.31-.08,0-.16,0-.24.01h-.03s-.03,0-.03,0c-.69.11-1.28.56-1.57,1.19l-.06.14c-1.17-.48-2.46-.76-3.8-.76C6.48,2,2,6.48,2,12s4.48,10,10,10c.23,0,.45-.02.67-.03-.42-.9-.67-1.9-.67-2.97,0-3.87,3.13-7,7-7,1.06,0,2.06.24,2.97.67.01-.22.03-.44.03-.67,0-2.6-1-4.96-2.62-6.73ZM16.78,3.05c.15-.33.46-.57.82-.63.05,0,.09,0,.14,0,.24,0,.48.06.68.18.26.14.46.37.58.63.11.33.07.69-.12.97-.03.05-.11.18-.24.37-.05.08-.11.16-.17.26-.07.11-.16.23-.25.37l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.21-.44h0l.06-.13ZM9.23,10.12c-.15-.21-.26-.38-.32-.49-.06-.1-.12-.19-.16-.3-.12-.22-.14-.48-.04-.71.09-.24.27-.43.5-.53.22-.11.48-.14.73-.07.24.08.43.26.53.49.05.1.09.21.12.31.05.12.11.3.18.55l.17.58c.17.58.44,1.45.58,1.95h0c-.29.07-.57.2-.81.38-.36-.55-.96-1.4-1.28-1.89l-.2-.29ZM12.06,15.69c-.72.06-1.34-.48-1.4-1.19,0-.07,0-.14,0-.21.06-.72.68-1.25,1.4-1.19.64.05,1.14.56,1.19,1.19.06.72-.48,1.34-1.19,1.4Z" })), Ps = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M22.54,16.88l-1.41-1.41-2.12,2.12-2.12-2.12-1.41,1.41,2.12,2.12-2.12,2.12,1.41,1.41,2.12-2.12,2.12,2.12,1.41-1.41-2.12-2.12,2.12-2.12ZM14.4,8.22c.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.27-.57c.15-.33.46-.57.82-.63.29-.03.57.03.82.17.26.14.46.37.58.63.11.33.07.69-.12.97-.06.1-.27.43-.66,1l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04ZM11.51,11.91c-.14-.5-.4-1.37-.58-1.95l-.17-.58c-.07-.25-.13-.44-.18-.55-.03-.11-.08-.21-.12-.31-.1-.23-.29-.41-.53-.49-.24-.07-.5-.05-.73.07-.23.1-.41.29-.5.53-.09.23-.08.49.04.71.05.1.1.2.16.3.07.11.17.27.32.49l.2.29c.31.49.91,1.33,1.28,1.89.24-.18.52-.31.81-.38ZM12.06,15.69c.72-.06,1.25-.68,1.19-1.4-.05-.64-.56-1.14-1.19-1.19-.72-.06-1.34.48-1.4,1.19,0,.07,0,.14,0,.21.06.72.68,1.25,1.4,1.19ZM20,12.08c.7.1,1.36.3,1.97.59.01-.22.03-.44.03-.67,0-2.22-.73-4.27-1.96-5.93-.05.08-.11.16-.17.25l-1.04,1.53c.74,1.21,1.17,2.62,1.17,4.14,0,.03,0,.05,0,.08ZM12.08,20s-.05,0-.08,0c-4.41,0-8-3.59-8-8S7.59,4,12,4c.69,0,1.36.1,2,.26.05-.1.1-.21.14-.3l.55-1.19.17-.35c-.91-.27-1.87-.42-2.86-.42C6.48,2,2,6.48,2,12s4.48,10,10,10c.23,0,.45-.02.67-.03-.29-.61-.49-1.28-.59-1.97Z" })), qs = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M20 18H23V20H20V23H18V20H15V18H18V15H20V18ZM19.38 5.27C19.54 5.03 19.67 4.84 19.73 4.74C20.08 4.2 20.16 3.52 19.95 2.91V2.87L19.92 2.84C19.72 2.37 19.36 1.98 18.91 1.73C18.56 1.53 18.15 1.42 17.74 1.42C17.66 1.42 17.58 1.42 17.5 1.43H17.47H17.44C16.75 1.54 16.16 1.99 15.87 2.62L15.81 2.76C14.64 2.28 13.35 2 12.01 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C12.23 22 12.45 21.98 12.67 21.97C12.25 21.07 12 20.07 12 19C12 15.13 15.13 12 19 12C20.06 12 21.06 12.24 21.97 12.67C21.98 12.45 22 12.23 22 12C22 9.4 21 7.04 19.38 5.27ZM16.78 3.05C16.93 2.72 17.24 2.48 17.6 2.42C17.65 2.42 17.69 2.42 17.74 2.42C17.98 2.42 18.22 2.48 18.42 2.6C18.68 2.74 18.88 2.97 19 3.23C19.11 3.56 19.07 3.92 18.88 4.2C18.85 4.25 18.77 4.38 18.64 4.57C18.59 4.65 18.53 4.73 18.47 4.83C18.4 4.94 18.31 5.06 18.22 5.2L16.84 7.24C16.3 8.04 15.71 8.9 15.08 9.82L14.17 11.29C13.91 11.69 13.67 12.06 13.42 12.43C13.18 12.22 12.9 12.07 12.6 11.99C12.75 11.69 13.02 11.11 13.42 10.28C13.82 9.45 14.24 8.58 14.4 8.24C14.66 7.6 14.94 6.97 15.22 6.39C15.5 5.81 15.75 5.28 15.96 4.81L16.5 3.64L16.71 3.2L16.77 3.07L16.78 3.05ZM9.23 10.12C9.08 9.91 8.97 9.74 8.91 9.63C8.85 9.53 8.79 9.44 8.75 9.33C8.63 9.11 8.61 8.85 8.71 8.62C8.8 8.38 8.98 8.19 9.21 8.09C9.43 7.98 9.69 7.95 9.94 8.02C10.18 8.1 10.37 8.28 10.47 8.51C10.52 8.61 10.56 8.72 10.59 8.82C10.64 8.94 10.7 9.12 10.77 9.37L10.94 9.95C11.11 10.53 11.38 11.4 11.52 11.9C11.23 11.97 10.95 12.1 10.71 12.28C10.35 11.73 9.75 10.88 9.43 10.39L9.23 10.1V10.12ZM12.06 15.69C11.34 15.75 10.72 15.21 10.66 14.5C10.66 14.43 10.66 14.36 10.66 14.29C10.72 13.57 11.34 13.04 12.06 13.1C12.7 13.15 13.2 13.66 13.25 14.29C13.31 15.01 12.77 15.63 12.06 15.69Z" })), Us = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M20,18h3v2h-3s0,3,0,3h-2v-3s-3,0-3,0v-2h3s0-3,0-3h2v3ZM14.4,8.22c.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.27-.57c.15-.33.46-.57.82-.63.29-.03.57.03.82.17.26.14.46.37.58.63.11.33.07.69-.12.97-.06.1-.27.43-.66,1l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04ZM11.51,11.91c-.14-.5-.4-1.37-.58-1.95l-.17-.58c-.07-.25-.13-.44-.18-.55-.03-.11-.08-.21-.12-.31-.1-.23-.29-.41-.53-.49-.24-.07-.5-.05-.73.07-.23.1-.41.29-.5.53-.09.23-.08.49.04.71.05.1.1.2.16.3.07.11.17.27.32.49l.2.29c.31.49.91,1.33,1.28,1.89.24-.18.52-.31.81-.38ZM12.06,15.69c.72-.06,1.25-.68,1.19-1.4-.05-.64-.56-1.14-1.19-1.19-.72-.06-1.34.48-1.4,1.19,0,.07,0,.14,0,.21.06.72.68,1.25,1.4,1.19ZM20,12.08c.7.1,1.36.3,1.97.59.01-.22.03-.44.03-.67,0-2.22-.73-4.27-1.96-5.93-.05.08-.11.16-.17.25l-1.04,1.53c.74,1.21,1.17,2.62,1.17,4.14,0,.03,0,.05,0,.08ZM12.08,20s-.05,0-.08,0c-4.41,0-8-3.59-8-8S7.59,4,12,4c.69,0,1.36.1,2,.26.05-.1.1-.21.14-.3l.55-1.19.17-.35c-.91-.27-1.87-.42-2.86-.42C6.48,2,2,6.48,2,12s4.48,10,10,10c.23,0,.45-.02.67-.03-.29-.61-.49-1.28-.59-1.97Z" })), Gs = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19,15c-2.21,0-4,1.79-4,4h-1l2,2,2-2h-1c0-1.1.9-2,2-2s2,.9,2,2-.9,2-2,2v2c2.21,0,4-1.79,4-4s-1.79-4-4-4ZM19.38,5.27c.16-.24.29-.43.35-.53.35-.54.43-1.22.22-1.83v-.04s-.03-.03-.03-.03c-.2-.47-.56-.86-1.01-1.11-.35-.2-.76-.31-1.17-.31-.08,0-.16,0-.24.01h-.03s-.03,0-.03,0c-.69.11-1.28.56-1.57,1.19l-.06.14c-1.17-.48-2.46-.76-3.8-.76C6.48,2,2,6.48,2,12s4.48,10,10,10c.23,0,.45-.02.67-.03-.42-.9-.67-1.9-.67-2.97,0-3.87,3.13-7,7-7,1.06,0,2.06.24,2.97.67.01-.22.03-.44.03-.67,0-2.6-1-4.96-2.62-6.73ZM16.78,3.05c.15-.33.46-.57.82-.63.05,0,.09,0,.14,0,.24,0,.48.06.68.18.26.14.46.37.58.63.11.33.07.69-.12.97-.03.05-.11.18-.24.37-.05.08-.11.16-.17.26-.07.11-.16.23-.25.37l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.21-.44h0l.06-.13ZM9.23,10.12c-.15-.21-.26-.38-.32-.49-.06-.1-.12-.19-.16-.3-.12-.22-.14-.48-.04-.71.09-.24.27-.43.5-.53.22-.11.48-.14.73-.07.24.08.43.26.53.49.05.1.09.21.12.31.05.12.11.3.18.55l.17.58c.17.58.44,1.45.58,1.95h0c-.29.07-.57.2-.81.38-.36-.55-.96-1.4-1.28-1.89l-.2-.29ZM12.06,15.69c-.72.06-1.34-.48-1.4-1.19,0-.07,0-.14,0-.21.06-.72.68-1.25,1.4-1.19.64.05,1.14.56,1.19,1.19.06.72-.48,1.34-1.19,1.4Z" })), Ks = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19,15c-2.21,0-4,1.79-4,4h-1l2,2,2-2h-1c0-1.1.9-2,2-2s2,.9,2,2-.9,2-2,2v2c2.21,0,4-1.79,4-4s-1.79-4-4-4ZM14.4,8.22c.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.27-.57c.15-.33.46-.57.82-.63.29-.03.57.03.82.17.26.14.46.37.58.63.11.33.07.69-.12.97-.06.1-.27.43-.66,1l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04ZM11.51,11.91c-.14-.5-.4-1.37-.58-1.95l-.17-.58c-.07-.25-.13-.44-.18-.55-.03-.11-.08-.21-.12-.31-.1-.23-.29-.41-.53-.49-.24-.07-.5-.05-.73.07-.23.1-.41.29-.5.53-.09.23-.08.49.04.71.05.1.1.2.16.3.07.11.17.27.32.49l.2.29c.31.49.91,1.33,1.28,1.89.24-.18.52-.31.81-.38ZM12.06,15.69c.72-.06,1.25-.68,1.19-1.4-.05-.64-.56-1.14-1.19-1.19-.72-.06-1.34.48-1.4,1.19,0,.07,0,.14,0,.21.06.72.68,1.25,1.4,1.19ZM20,12.08c.7.1,1.36.3,1.97.59.01-.22.03-.44.03-.67,0-2.22-.73-4.27-1.96-5.93-.05.08-.11.16-.17.25l-1.04,1.53c.74,1.21,1.17,2.62,1.17,4.14,0,.03,0,.05,0,.08ZM12.08,20s-.05,0-.08,0c-4.41,0-8-3.59-8-8S7.59,4,12,4c.69,0,1.36.1,2,.26.05-.1.1-.21.14-.3l.55-1.19.17-.35c-.91-.27-1.87-.42-2.86-.42C6.48,2,2,6.48,2,12s4.48,10,10,10c.23,0,.45-.02.67-.03-.29-.61-.49-1.28-.59-1.97Z" })), Ys = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19,15l4,4-4,4-1.4-1.4,1.57-1.6h-4.17v-2h4.17l-1.57-1.6,1.4-1.4ZM19.38,5.27c.16-.24.29-.43.35-.53.35-.54.43-1.22.22-1.83v-.04s-.03-.03-.03-.03c-.2-.47-.56-.86-1.01-1.11-.35-.2-.76-.31-1.17-.31-.08,0-.16,0-.24.01h-.03s-.03,0-.03,0c-.69.11-1.28.56-1.57,1.19l-.06.14c-1.17-.48-2.46-.76-3.8-.76C6.48,2,2,6.48,2,12s4.48,10,10,10c.23,0,.45-.02.67-.03-.42-.9-.67-1.9-.67-2.97,0-3.87,3.13-7,7-7,1.06,0,2.06.24,2.97.67.01-.22.03-.44.03-.67,0-2.6-1-4.96-2.62-6.73ZM16.78,3.05c.15-.33.46-.57.82-.63.05,0,.09,0,.14,0,.24,0,.48.06.68.18.26.14.46.37.58.63.11.33.07.69-.12.97-.03.05-.11.18-.24.37-.05.08-.11.16-.17.26-.07.11-.16.23-.25.37l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.21-.44h0l.06-.13ZM9.23,10.12c-.15-.21-.26-.38-.32-.49-.06-.1-.12-.19-.16-.3-.12-.22-.14-.48-.04-.71.09-.24.27-.43.5-.53.22-.11.48-.14.73-.07.24.08.43.26.53.49.05.1.09.21.12.31.05.12.11.3.18.55l.17.58c.17.58.44,1.45.58,1.95h0c-.29.07-.57.2-.81.38-.36-.55-.96-1.4-1.28-1.89l-.2-.29ZM12.06,15.69c-.72.06-1.34-.48-1.4-1.19,0-.07,0-.14,0-.21.06-.72.68-1.25,1.4-1.19.64.05,1.14.56,1.19,1.19.06.72-.48,1.34-1.19,1.4Z" })), Qs = (e) => /* @__PURE__ */ s.createElement("svg", { id: "Icons", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19,15l4,4-4,4-1.4-1.4,1.57-1.6h-4.17v-2h4.17l-1.57-1.6,1.4-1.4ZM14.4,8.22c.26-.64.54-1.27.82-1.85.28-.58.53-1.11.74-1.58l.54-1.17.27-.57c.15-.33.46-.57.82-.63.29-.03.57.03.82.17.26.14.46.37.58.63.11.33.07.69-.12.97-.06.1-.27.43-.66,1l-1.38,2.04c-.54.8-1.13,1.66-1.76,2.58l-.91,1.47c-.26.4-.5.77-.75,1.14-.24-.21-.52-.36-.82-.44.15-.3.42-.88.82-1.71.4-.83.82-1.7.98-2.04ZM11.51,11.91c-.14-.5-.4-1.37-.58-1.95l-.17-.58c-.07-.25-.13-.44-.18-.55-.03-.11-.08-.21-.12-.31-.1-.23-.29-.41-.53-.49-.24-.07-.5-.05-.73.07-.23.1-.41.29-.5.53-.09.23-.08.49.04.71.05.1.1.2.16.3.07.11.17.27.32.49l.2.29c.31.49.91,1.33,1.28,1.89.24-.18.52-.31.81-.38ZM12.06,15.69c.72-.06,1.25-.68,1.19-1.4-.05-.64-.56-1.14-1.19-1.19-.72-.06-1.34.48-1.4,1.19,0,.07,0,.14,0,.21.06.72.68,1.25,1.4,1.19ZM20,12.08c.7.1,1.36.3,1.97.59.01-.22.03-.44.03-.67,0-2.22-.73-4.27-1.96-5.93-.05.08-.11.16-.17.25l-1.04,1.53c.74,1.21,1.17,2.62,1.17,4.14,0,.03,0,.05,0,.08ZM12.08,20s-.05,0-.08,0c-4.41,0-8-3.59-8-8S7.59,4,12,4c.69,0,1.36.1,2,.26.05-.1.1-.21.14-.3l.55-1.19.17-.35c-.91-.27-1.87-.42-2.86-.42C6.48,2,2,6.48,2,12s4.48,10,10,10c.23,0,.45-.02.67-.03-.29-.61-.49-1.28-.59-1.97Z" })), Xs = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M3.9 12A3.1 3.1 0 0 1 7 8.9h4V7H7a5 5 0 1 0 0 10h4v-1.9H7A3.1 3.1 0 0 1 3.9 12M8 13h8v-2H8zm9-6h-4v1.9h4a3.1 3.1 0 1 1 0 6.2h-4V17h4a5 5 0 1 0 0-10" })), Js = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M15.75 7.5V2.25h-7.5V7.5h-4.5V21h16.5V7.5zM9 18.75H6V15h3zm0-5.25H6V9.75h3zm4.5 5.25h-3V15h3zm0-5.25h-3V9.75h3zm0-5.25h-3V4.5h3zm4.5 10.5h-3V15h3zm0-5.25h-3V9.75h3z" })), e5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, fill: "none", viewBox: "0 0 48 48", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M36 16h-2v-4c0-5.52-4.48-10-10-10S14 6.48 14 12v4h-2c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V20c0-2.2-1.8-4-4-4M24 34c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4m6.2-18H17.8v-4c0-3.42 2.78-6.2 6.2-6.2s6.2 2.78 6.2 6.2z" })), t5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm8-7L4 8v10h16V8zm0-2 8-5H4zM4 8V6v12z" })), r5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, fill: "none", viewBox: "0 0 40 40", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#000682", d: "M21.457 35.366a20 20 0 0 1-2.2 3.783c-.2.27-.41.54-.631.8h1.38a20 20 0 0 0 7.904-1.62l-5.712-4.935q-.312 1.008-.74 1.972M10.422 2.415a20 20 0 0 0-2.64 1.732l-.521.41A20 20 0 0 0 4.56 7.28a19.9 19.9 0 0 1 9.524 3.193z" }), /* @__PURE__ */ s.createElement("path", { fill: "url(#maker_svg__a)", d: "m39.315 14.686-15.507 7.007a4.3 4.3 0 0 1-1.3.35c.447 1.685.672 3.422.67 5.165a20.1 20.1 0 0 1-1 6.196l5.712 4.934a20 20 0 0 0 10.395-10.28 20.03 20.03 0 0 0 1-13.412z" }), /* @__PURE__ */ s.createElement("path", { fill: "url(#maker_svg__b)", d: "M21.457 35.366q.426-.94.74-1.922c.656-2 .994-4.091 1.001-6.196a20 20 0 0 0-.67-5.165 4.22 4.22 0 0 1-4.272-2.452l-.68-1.491-3.492-7.667A19.9 19.9 0 0 0 4.56 7.28 20.025 20.025 0 0 0 5.7 33.994q.088.108.19.2A19.93 19.93 0 0 0 18.626 40c.22-.26.43-.53.63-.8a20 20 0 0 0 2.201-3.834" }), /* @__PURE__ */ s.createElement("path", { fill: "url(#maker_svg__c)", d: "m17.556 18.14.68 1.491a4.22 4.22 0 0 0 4.272 2.452 4.3 4.3 0 0 0 1.3-.35l15.507-7.007a19.6 19.6 0 0 0-2-4.774 20 20 0 0 0-2.212-3.083 9.5 9.5 0 0 0-1-1 20.005 20.005 0 0 0-23.68-3.454l3.661 8.058z" }), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "maker_svg__a", x1: 28.647, x2: 43.574, y1: 16.4, y2: 37.202, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { offset: 0.11, stopColor: "#000682" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.17, stopColor: "#122698" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.27, stopColor: "#325DBC" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.37, stopColor: "#4B88D9" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.46, stopColor: "#5CA7EE" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.54, stopColor: "#67BAFA" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.59, stopColor: "#6BC1FF" })), /* @__PURE__ */ s.createElement("linearGradient", { id: "maker_svg__b", x1: 15.287, x2: 1.945, y1: 30.969, y2: 13.152, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { offset: 0.09, stopColor: "#F03C34" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.16, stopColor: "#F14B35" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.45, stopColor: "#F58437" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.69, stopColor: "#F8AE39" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.88, stopColor: "#FAC83B" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#FBD13B" })), /* @__PURE__ */ s.createElement("linearGradient", { id: "maker_svg__c", x1: 27.238, x2: 25.153, y1: 25.974, y2: -11.929, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { offset: 0.38, stopColor: "#00A878" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.42, stopColor: "#00A078" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.48, stopColor: "#008C7A" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.55, stopColor: "#006A7C" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.64, stopColor: "#003B7F" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.72, stopColor: "#000682" })))), n5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M4 18h16v-2H4zm0-5h16v-2H4zm0-7v2h16V6z" })), o5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 36, height: 40, viewBox: "0 0 36 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M0.857422 10.0999V29.8954L18.0003 39.7955L35.1431 29.8954V10.0999L18.0003 0.20459L0.857422 10.0999Z", fill: "url(#paint0_linear_4376_81623)" }), /* @__PURE__ */ s.createElement("path", { d: "M18.0003 0.20459L0.857422 10.0999L18.0003 20L35.1431 10.0999L18.0003 0.20459Z", fill: "url(#paint1_linear_4376_81623)" }), /* @__PURE__ */ s.createElement("path", { d: "M18 20.0002V39.7957L35.1429 29.8955V10.1001L18 20.0002Z", fill: "url(#paint2_linear_4376_81623)" }), /* @__PURE__ */ s.createElement("path", { d: "M0.857422 10.1001L18.0003 20.0002V39.7957L0.857422 29.8955V10.1001Z", fill: "url(#paint3_linear_4376_81623)" }), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("linearGradient", { id: "paint0_linear_4376_81623", x1: 0.785993, y1: 30.1382, x2: 35.6957, y2: 9.57644, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#FCB81A" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.11, stopColor: "#F8A01D" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.22, stopColor: "#F68F1F" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.35, stopColor: "#F48520" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.5, stopColor: "#F48220" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.65, stopColor: "#F48520" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.78, stopColor: "#F68F1F" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.89, stopColor: "#F8A01D" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#FCB81A" })), /* @__PURE__ */ s.createElement("linearGradient", { id: "paint1_linear_4376_81623", x1: 9.3479, y1: 1.45222, x2: 26.8957, y2: 18.9951, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#F1C81E" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.54, stopColor: "#EF9120" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#ED5F22" })), /* @__PURE__ */ s.createElement("linearGradient", { id: "paint2_linear_4376_81623", x1: 26.5714, y1: 39.9337, x2: 26.5714, y2: 9.54295, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#ED5F22" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.24, stopColor: "#EE7421" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.74, stopColor: "#F0A91F" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#F1C81E" })), /* @__PURE__ */ s.createElement("linearGradient", { id: "paint3_linear_4376_81623", x1: 21.7669, y1: 35.3051, x2: -2.90946, y2: 14.5956, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ s.createElement("stop", { stopColor: "#F6901F" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.12, stopColor: "#F3801D" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.36, stopColor: "#EF6819" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.5, stopColor: "#ED5F18" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.64, stopColor: "#EF6819" }), /* @__PURE__ */ s.createElement("stop", { offset: 0.87, stopColor: "#F3801D" }), /* @__PURE__ */ s.createElement("stop", { offset: 1, stopColor: "#F6901F" })))), a5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 36, height: 40, viewBox: "0 0 36 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M35.1384 29.8952L18.0003 39.7904L0.857422 29.8952V10.1047L18.0003 0.209473L35.1384 10.1047V29.8952Z", fill: "white" }), /* @__PURE__ */ s.createElement("path", { d: "M18.2432 20.1427L34.9051 10.5142V29.757L18.2432 39.3808V20.1427Z", fill: "#E7E8E8" }), /* @__PURE__ */ s.createElement("path", { d: "M34.6667 10.9521V29.6235L18.4762 38.9664V20.2759L34.6667 10.9521ZM35.1429 10.1283L18 19.9997V39.7902L35.1429 29.895V10.1045V10.1283Z", fill: "#E7E8E8" }), /* @__PURE__ */ s.createElement("path", { d: "M18.0003 20.0045L0.857422 10.1045V29.8997L18.0003 39.7902V20.0045Z", fill: "#E3E3E0" }), /* @__PURE__ */ s.createElement("path", { d: "M18.0003 1.09995L34.3669 10.5523V29.4476L18.0003 38.8999L1.63361 29.4476V10.5523L18.0003 1.09995ZM18.0003 0.209473L0.857422 10.1047V29.8952L18.0003 39.7904L35.1431 29.8952V10.1047L18.0003 0.209473Z", fill: "#D1D2D2" })), i5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("g", { opacity: 0.4 }, /* @__PURE__ */ s.createElement("circle", { opacity: 0.1, cx: 20, cy: 20, r: 20, fill: "#464646" }), /* @__PURE__ */ s.createElement("path", { d: "M19 29.725L12 25.7C11.6833 25.5167 11.4375 25.275 11.2625 24.975C11.0875 24.675 11 24.3417 11 23.975V16.025C11 15.6583 11.0875 15.325 11.2625 15.025C11.4375 14.725 11.6833 14.4833 12 14.3L19 10.275C19.3167 10.0917 19.65 10 20 10C20.35 10 20.6833 10.0917 21 10.275L28 14.3C28.3167 14.4833 28.5625 14.725 28.7375 15.025C28.9125 15.325 29 15.6583 29 16.025V23.975C29 24.3417 28.9125 24.675 28.7375 24.975C28.5625 25.275 28.3167 25.5167 28 25.7L21 29.725C20.6833 29.9083 20.35 30 20 30C19.65 30 19.3167 29.9083 19 29.725ZM19 20.575V27.425L20 28L21 27.425V20.575L27 17.1V16.05L25.925 15.425L20 18.85L14.075 15.425L13 16.05V17.1L19 20.575Z", fill: "#BDBDBD" }))), l5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4" })), s5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4" })), c5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h11l5 5v11q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm0-2h14V9h-4V5H5zm2-2h10v-2H7zm0-8h5V7H7zm0 4h10v-2H7z" })), d5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h11l5 5v11q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm2-4h10v-2H7zm0-4h10v-2H7zm8-4h4l-4-4zM7 9h5V7H7z" })), u5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12.667 12.667H3.333V3.333H8V2H3.333C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.593 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V8h-1.333zM9.333 2v1.333h2.394L5.173 9.887l.94.94 6.554-6.554v2.394H14V2z" })), p5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M16.667 16.667H7.333V7.333H12V6H7.333C6.593 6 6 6.6 6 7.333v9.334C6 17.4 6.593 18 7.333 18h9.334C17.4 18 18 17.4 18 16.667V12h-1.333zM13.333 6v1.333h2.394l-6.554 6.554.94.94 6.554-6.554v2.394H18V6z" })), m5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M16.6667 16.6667H7.33333V7.33333H12V6H7.33333C6.59333 6 6 6.6 6 7.33333V16.6667C6 17.4 6.59333 18 7.33333 18H16.6667C17.4 18 18 17.4 18 16.6667V12H16.6667V16.6667ZM13.3333 6V7.33333H15.7267L9.17333 13.8867L10.1133 14.8267L16.6667 8.27333V10.6667H18V6H13.3333Z", fill: "#BDBDBD" })), h5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M13.5 13H13v-1h1.5c.55 0 1-.45 1-1s-.45-1-1-1H13c0-.55-.45-1-1-1s-1 .45-1 1h-.5a2.5 2.5 0 0 0 0 5h.5v1H9.5c-.55 0-1 .45-1 1s.45 1 1 1H11c0 .55.45 1 1 1s1-.45 1-1h.5a2.5 2.5 0 0 0 0-5M11 13h-.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h.5zm2.5 3H13v-1h.5c.28 0 .5.22.5.5s-.22.5-.5.5M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8zm.75 3.58.84.84.84.84h-1.67V5.59zM17.5 20h-11c-.28 0-.5-.22-.5-.5v-15c0-.28.22-.5.5-.5h6.25v4.25c0 .55.45 1 1 1H18V19.5c0 .28-.22.5-.5.5" })), g5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M10.5 12h.5v1h-.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5M20 8v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8zm-4 7.5a2.5 2.5 0 0 0-2.5-2.5H13v-1h1.5c.55 0 1-.45 1-1s-.45-1-1-1H13c0-.55-.45-1-1-1s-1 .45-1 1h-.5a2.5 2.5 0 0 0 0 5h.5v1H9.5c-.55 0-1 .45-1 1s.45 1 1 1H11c0 .55.45 1 1 1s1-.45 1-1h.5a2.5 2.5 0 0 0 2.5-2.5M18.17 8 14 3.83V7.5c0 .28.22.5.5.5zm-4.67 7H13v1h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5" })), C5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M21 2h-4l-1 8h-2V7L9 9V7L2 9.97V22h20V10zm-2.23 2h.47l.75 6h-1.97zM20 20H4v-8.7l3-1.27v1.93l2.74-1.1 2.26-.9v2.05h8v8zM8 14.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5m3.5-.5h1c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5m4.5 3.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5" })), v5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M21 2h-4l-.75 6h5.5z" }), /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M14 10V7L9 9V7L2 9.97V22h20V10zm-6 7.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5zm5 0c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5zm5 0c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5z" })), f5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M20.75 8h-5.5L16 2h4zM13 18c0 1.49.47 2.87 1.26 4H1V9.97L8 7v2l5-2v3h8v1.08c-.33-.05-.66-.08-1-.08-3.87 0-7 3.13-7 7m-6-3.5c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5zm5 0c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5zm9 2.5v-3h-2v3h-3v2h3v3h2v-3h3v-2z" })), x5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M11.5 14c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm-6 0c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zm7.79 6c.22.72.54 1.4.97 2H1V9.97L8 7v2l5-2v3h2l1-8h4l1 8v1.08c-.33-.05-.66-.08-1-.08-1.32 0-2.54.37-3.59 1H11V9.95l-2.26.9L6 11.95v-1.93l-3 1.27v8.7h10.29zm3.73-10h1.97l-.75-6h-.47zM21 17v-3h-2v3h-3v2h3v3h2v-3h3v-2z" })), b5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M2 9.97 9 7v4.15l-2 .8v-1.93l-3 1.27v8.7h5v2H2V9.96zM6.5 14c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zM22 10v12h-7v-2h5v-8h-5v-2h1l1-8h4zm-2.02 0-.75-6h-.47l-.75 6zm-2.48 8c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5zM11 5h2V1h-2zm0 6h2V7h-2zm0 12h2v-4h-2zm0-6h2v-4h-2z" })), w5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M4 20v-8.7l3-1.27v1.93l2.74-1.1 2.26-.9v2.05h4.41A6.97 6.97 0 0 1 22 11.3v-1.29l-1-8h-4l-1 8h-2v-3l-5 2v-2L2 9.98v12.03h12.26c-.42-.6-.75-1.28-.97-2H4zM18.77 4h.47l.75 6h-1.97zM12.5 14c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm-5 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zM24 18l-4 4-1.4-1.4 1.57-1.6H16v-2h4.17l-1.57-1.6L20 14z" })), y5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M6.5 14c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm4 0c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zm5.91-2H11V9.95l-2.26.9L6 11.95v-1.93l-3 1.27v8.7h10.29c.22.72.54 1.4.97 2H1V9.96l7-2.97v2l5-2v3h2l1-8h4l1 8v1.08c-.33-.05-.66-.08-1-.08-1.32 0-2.54.37-3.59 1zm.61-2h1.97l-.75-6h-.47zm6.52 5.88-1.41-1.41-2.12 2.12-2.12-2.12-1.41 1.41L18.6 18l-2.12 2.12 1.41 1.41 2.12-2.12 2.12 2.12 1.41-1.41L21.42 18z" })), k5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M16 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-2a3 3 0 1 0-.02 6A3 3 0 0 0 16 5m2.912 10.476A4.5 4.5 0 0 1 21 16.567V17h-2v-.5q0-.516-.088-1.024M16 13c-.29 0-.62.02-.97.05A4.22 4.22 0 0 1 17 16.5V19h6v-2.5c0-2.33-4.67-3.5-7-3.5M8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 8c2.134 0 4.622.962 5 1.567V17H3v-.433C3.378 15.962 5.866 15 8 15M8 5a3 3 0 1 0-.02 6A3 3 0 0 0 8 5m0 8c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5" })), j5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M16 11C16.5933 11 17.1734 10.8241 17.6667 10.4944C18.1601 10.1648 18.5446 9.69623 18.7716 9.14805C18.9987 8.59987 19.0581 7.99667 18.9424 7.41473C18.8266 6.83279 18.5409 6.29824 18.1213 5.87868C17.7018 5.45912 17.1672 5.1734 16.5853 5.05765C16.0033 4.94189 15.4001 5.0013 14.8519 5.22836C14.3038 5.45543 13.8352 5.83994 13.5056 6.33329C13.1759 6.82664 13 7.40666 13 8C12.9983 8.39445 13.0747 8.78533 13.2249 9.15008C13.375 9.51484 13.5959 9.84624 13.8748 10.1252C14.1538 10.4041 14.4852 10.625 14.8499 10.7751C15.2147 10.9253 15.6056 11.0017 16 11ZM8 11C8.59334 11 9.17336 10.8241 9.66671 10.4944C10.1601 10.1648 10.5446 9.69623 10.7716 9.14805C10.9987 8.59987 11.0581 7.99667 10.9424 7.41473C10.8266 6.83279 10.5409 6.29824 10.1213 5.87868C9.70176 5.45912 9.16721 5.1734 8.58527 5.05765C8.00333 4.94189 7.40013 5.0013 6.85195 5.22836C6.30377 5.45543 5.83524 5.83994 5.50559 6.33329C5.17595 6.82664 5 7.40666 5 8C4.99828 8.39445 5.0747 8.78533 5.22486 9.15008C5.37501 9.51484 5.59592 9.84624 5.87484 10.1252C6.15376 10.4041 6.48516 10.625 6.84992 10.7751C7.21467 10.9253 7.60555 11.0017 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C15.6164 13.4191 16.1028 13.927 16.4464 14.5287C16.79 15.1304 16.9801 15.8074 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z", fill: "currentColor" })), S5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4" })), L5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M10 16c0 1.49.47 2.87 1.26 4H2v-2c0-2.66 5.33-4 8-4h.29c-.19.63-.29 1.3-.29 1.99zm0-12C7.79 4 6 5.79 6 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8 10v-3h-2v3h-3v2h3v3h2v-3h3v-2z" })), M5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4" })), E5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#F2664C", d: "M12.11 20H2v-2c0-2.66 5.33-4 8-4h.08c-.05.33-.08.66-.08 1s.03.67.08 1H10c-2.69 0-5.77 1.28-6 2h6.68c.36.75.84 1.43 1.42 2zm6.3-5 2.12-2.12-1.41-1.41L17 13.59l-2.12-2.12-1.41 1.41L15.59 15l-2.12 2.12 1.41 1.41L17 16.41l2.12 2.12 1.41-1.41zM14 8c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4m-2 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2" })), N5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M10 15c0 1.96.81 3.73 2.11 5H2v-2c0-2.66 5.33-4 8-4h.08c-.05.33-.08.66-.08 1m0-3c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m12 3c0 1.38-.49 2.56-1.46 3.54S18.39 20 17 20s-2.56-.49-3.54-1.46S12 16.39 12 15s.49-2.56 1.46-3.54C14.44 10.49 15.61 10 17 10s2.56.49 3.54 1.46c.97.98 1.46 2.15 1.46 3.54m-2.62 1.67-1.88-1.88v-2.8h-1v3.2l2.17 2.17.7-.7z" })), I5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M17 20C16.3 20 15.65 19.87 15.05 19.61C14.44 19.35 13.91 18.99 13.46 18.54C13.01 18.09 12.65 17.56 12.39 16.95C12.13 16.34 12 15.69 12 14.99C12 14.29 12.13 13.64 12.39 13.04C12.65 12.44 13.01 11.91 13.46 11.46C13.91 11.01 14.44 10.65 15.05 10.39C15.66 10.13 16.31 10 17.01 10C17.71 10 18.36 10.13 18.96 10.39C19.56 10.65 20.09 11.01 20.54 11.46C20.99 11.91 21.35 12.44 21.61 13.05C21.87 13.65 22 14.3 22 15C22 15.7 21.87 16.35 21.61 16.95C21.35 17.56 20.99 18.09 20.54 18.54C20.09 18.99 19.56 19.35 18.95 19.61C18.35 19.87 17.7 20 17 20ZM17 18.59C17.8 18.59 18.51 18.37 19.12 17.93C19.74 17.49 20.19 16.92 20.47 16.22C20.47 16.28 20.47 16.33 20.47 16.39C20.47 16.45 20.47 16.5 20.47 16.54C20.34 16.47 20.26 16.4 20.21 16.34C20.16 16.28 20.13 16.24 20.11 16.24H18.47C18.19 16.24 17.96 16.14 17.76 15.94C17.56 15.74 17.46 15.51 17.46 15.23V14.58H15.16V13.38C15.16 13.1 15.26 12.86 15.46 12.66C15.66 12.46 15.89 12.36 16.17 12.36H16.82V12.07C16.82 11.91 16.85 11.76 16.91 11.63C16.97 11.5 17.05 11.42 17.14 11.39C17.12 11.39 17.09 11.39 17.04 11.39C16.99 11.39 16.97 11.39 16.98 11.39C15.98 11.39 15.13 11.74 14.43 12.43C13.73 13.12 13.39 13.97 13.39 14.98C13.39 15.02 13.39 15.06 13.39 15.1C13.39 15.14 13.39 15.18 13.39 15.22H15.24C15.81 15.22 16.28 15.41 16.67 15.8C17.06 16.19 17.25 16.66 17.25 17.22V17.87H15.31V18.2C15.56 18.32 15.82 18.41 16.1 18.47C16.38 18.53 16.67 18.56 16.96 18.56L17 18.59ZM12.11 20H2V18C2 15.34 7.33 14 10 14C10.02 14 10.05 14 10.08 14C10.03 14.33 10 14.66 10 15C10 16.96 10.81 18.73 12.11 20ZM6 8C6 5.79 7.79 4 10 4C12.21 4 14 5.79 14 8C14 10.21 12.21 12 10 12C7.79 12 6 10.21 6 8Z", fill: "currentColor" })), $5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M17 20C16.3 20 15.65 19.87 15.05 19.61C14.44 19.35 13.91 18.99 13.46 18.54C13.01 18.09 12.65 17.56 12.39 16.95C12.13 16.34 12 15.69 12 14.99C12 14.29 12.13 13.64 12.39 13.04C12.65 12.44 13.01 11.91 13.46 11.46C13.91 11.01 14.44 10.65 15.05 10.39C15.66 10.13 16.31 10 17.01 10C17.71 10 18.36 10.13 18.96 10.39C19.56 10.65 20.09 11.01 20.54 11.46C20.99 11.91 21.35 12.44 21.61 13.05C21.87 13.65 22 14.3 22 15C22 15.7 21.87 16.35 21.61 16.95C21.35 17.56 20.99 18.09 20.54 18.54C20.09 18.99 19.56 19.35 18.95 19.61C18.35 19.87 17.7 20 17 20ZM17 18.59C17.8 18.59 18.51 18.37 19.12 17.93C19.74 17.49 20.19 16.92 20.47 16.22C20.47 16.28 20.47 16.33 20.47 16.39C20.47 16.45 20.47 16.5 20.47 16.54C20.34 16.47 20.26 16.4 20.21 16.34C20.16 16.28 20.13 16.24 20.11 16.24H18.47C18.19 16.24 17.96 16.14 17.76 15.94C17.56 15.74 17.46 15.51 17.46 15.23V14.58H15.16V13.38C15.16 13.1 15.26 12.86 15.46 12.66C15.66 12.46 15.89 12.36 16.17 12.36H16.82V12.07C16.82 11.91 16.85 11.76 16.91 11.63C16.97 11.5 17.05 11.42 17.14 11.39C17.12 11.39 17.09 11.39 17.04 11.39C16.99 11.39 16.97 11.39 16.98 11.39C15.98 11.39 15.13 11.74 14.43 12.43C13.73 13.12 13.39 13.97 13.39 14.98C13.39 15.02 13.39 15.06 13.39 15.1C13.39 15.14 13.39 15.18 13.39 15.22H15.24C15.81 15.22 16.28 15.41 16.67 15.8C17.06 16.19 17.25 16.66 17.25 17.22V17.87H15.31V18.2C15.56 18.32 15.82 18.41 16.1 18.47C16.38 18.53 16.67 18.56 16.96 18.56L17 18.59ZM12.11 20H2V18C2 15.34 7.33 14 10 14C10.02 14 10.05 14 10.08 14C10.03 14.33 10 14.66 10 15C10 15.34 10.03 15.67 10.08 16C10.05 16 10.03 16 10 16C7.31 16 4.23 17.28 4 18H10.68C11.04 18.75 11.52 19.43 12.1 20H12.11ZM14 8C14 10.21 12.21 12 10 12C7.79 12 6 10.21 6 8C6 5.79 7.79 4 10 4C12.21 4 14 5.79 14 8ZM12 8C12 6.9 11.1 6 10 6C8.9 6 8 6.9 8 8C8 9.1 8.9 10 10 10C11.1 10 12 9.1 12 8Z", fill: "currentColor" })), _5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M19.95 21C17.8667 21 15.8083 20.5458 13.775 19.6375C11.7417 18.7292 9.89167 17.4417 8.225 15.775C6.55833 14.1083 5.27083 12.2583 4.3625 10.225C3.45417 8.19167 3 6.13333 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07917 8.725 3.2375C8.90833 3.39583 9.01667 3.58333 9.05 3.8L9.7 7.3C9.73333 7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.70417 12.1125 8.1625 12.6875C8.62083 13.2625 9.125 13.8167 9.675 14.35C10.1917 14.8667 10.7333 15.3458 11.3 15.7875C11.8667 16.2292 12.4667 16.6333 13.1 17L15.45 14.65C15.6 14.5 15.7958 14.3875 16.0375 14.3125C16.2792 14.2375 16.5167 14.2167 16.75 14.25L20.2 14.95C20.4333 15.0167 20.625 15.1375 20.775 15.3125C20.925 15.4875 21 15.6833 21 15.9V19.95C21 20.25 20.9 20.5 20.7 20.7C20.5 20.9 20.25 21 19.95 21ZM6.025 9L7.675 7.35L7.25 5H5.025C5.10833 5.68333 5.225 6.35833 5.375 7.025C5.525 7.69167 5.74167 8.35 6.025 9ZM14.975 17.95C15.625 18.2333 16.2875 18.4583 16.9625 18.625C17.6375 18.7917 18.3167 18.9 19 18.95V16.75L16.65 16.275L14.975 17.95Z", fill: "currentColor" })), V5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M5.63 19.69a9.95 9.95 0 0 0 5.32 2.21v-2.02a7.94 7.94 0 0 1-3.9-1.62zm-1.61-6.74H2c.2 2.01 1 3.84 2.21 5.32l1.43-1.42a7.94 7.94 0 0 1-1.62-3.9m1.62-5.9L4.21 5.62A10 10 0 0 0 2 10.94h2.02c.18-1.45.76-2.78 1.62-3.89m5.31-3.03V2c-2.01.2-3.84 1-5.32 2.21l1.43 1.43c1.1-.86 2.43-1.44 3.89-1.62m7.37.19A9.95 9.95 0 0 0 13 2v2.02c1.46.18 2.79.76 3.9 1.62zm1.61 6.74h2.02c-.2-2.01-1-3.84-2.21-5.32l-1.43 1.42a7.94 7.94 0 0 1 1.62 3.9m-1.62 5.9 1.43 1.43a10 10 0 0 0 2.21-5.32h-2.02a7.95 7.95 0 0 1-1.62 3.89M13 19.88v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62" })), A5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" })), B5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8zm.75 3.58.84.84.84.84h-1.67V5.59zM17.5 20h-11c-.28 0-.5-.22-.5-.5v-15c0-.28.22-.5.5-.5h6.25v4.25c0 .55.45 1 1 1H18V19.5c0 .28-.22.5-.5.5M16 11c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1m0 3c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1m0 3c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1" })), H5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM15 18H9C8.45 18 8 17.55 8 17C8 16.45 8.45 16 9 16H15C15.55 16 16 16.45 16 17C16 17.55 15.55 18 15 18ZM15 15H9C8.45 15 8 14.55 8 14C8 13.45 8.45 13 9 13H15C15.55 13 16 13.45 16 14C16 14.55 15.55 15 15 15ZM15 12H9C8.45 12 8 11.55 8 11C8 10.45 8.45 10 9 10H15C15.55 10 16 10.45 16 11C16 11.55 15.55 12 15 12ZM14 7.5V3.83L18.17 8H14.5C14.22 8 14 7.78 14 7.5Z", fill: "currentColor" })), D5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M5 19h1.425L16.2 9.225 14.775 7.8 5 17.575zm-2 2v-4.25L16.2 3.575q.3-.275.663-.425.362-.15.762-.15t.775.15.65.45L20.425 5q.3.275.438.65a2.17 2.17 0 0 1 0 1.512 1.9 1.9 0 0 1-.438.663L7.25 21zM15.475 8.525l-.7-.725L16.2 9.225zM22 21h-9l3-3h6z" })), T5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "m18 15 4 4-4 4-1.4-1.4 1.57-1.6H14v-2h4.17l-1.57-1.6zm4-9v7.26c-.6-.42-1.28-.75-2-.97V6.88l-8 6.4-8-6.4V17.5c0 .28.22.5.5.5h6.58c-.05.33-.08.66-.08 1s.03.67.08 1H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2m-4.1 0H6.1l5.9 4.72z" })), R5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12.06 19.88s-.04.02-.06.02c-.98-.32-1.85-.81-2.61-1.49-.76-.67-1.42-1.44-1.99-2.29a10.1 10.1 0 0 1 4.6-1.13c.4 0 .81.03 1.2.07a6.97 6.97 0 0 1 6.76-3c.02-.32.04-.64.04-.97v-6.1l-8-3-8 3v6.1c0 2.55.73 4.85 2.17 6.9 1.45 2.05 3.39 3.38 5.83 4 .2-.05.4-.12.6-.18a7 7 0 0 1-.54-1.95zM9.53 7.03C10.21 6.35 11.04 6 12 6s1.79.34 2.48 1.03S15.5 8.54 15.5 9.5s-.34 1.79-1.02 2.47A3.4 3.4 0 0 1 12 13c-.97 0-1.79-.34-2.47-1.03-.68-.68-1.03-1.51-1.03-2.47s.34-1.79 1.03-2.47M20 23h-2v-3h-3v-2h3v-3h2v3h3v2h-3z" })), F5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "-2.5 -1.5 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M8.6 19.82C8.4 19.88 8.21 19.95 8 20C5.68 19.42 3.77 18.09 2.26 16.01C0.75 13.93 0 11.63 0 9.1V3L8 0L16 3V9.1C16 9.43 15.99 9.75 15.96 10.07C15.65 10.03 15.33 10 15 10C14.64 10 14.28 10.04 13.93 10.09C13.96 9.76 14 9.43 14 9.1V4.38L8 2.13L2 4.38V9.1C2 10 2.12 10.88 2.38 11.72C2.63 12.57 2.97 13.37 3.41 14.12C4.11 13.77 4.84 13.5 5.61 13.29C6.38 13.08 7.18 12.99 8.01 12.99C8.42 12.99 8.82 13.02 9.21 13.06C8.81 13.65 8.5 14.3 8.29 15C8.19 15 8.1 14.98 8 14.98C7.4 14.98 6.82 15.05 6.25 15.18C5.68 15.31 5.14 15.5 4.63 15.73C5.11 16.23 5.64 16.66 6.21 17.03C6.78 17.4 7.38 17.68 8.01 17.88C8.03 17.88 8.05 17.86 8.07 17.86C8.16 18.54 8.34 19.2 8.61 19.81L8.6 19.82ZM10.49 5.01C11.17 5.68 11.5 6.51 11.5 7.5C11.5 8.49 11.16 9.31 10.49 9.99C9.82 10.66 8.99 11 8 11C7.01 11 6.19 10.66 5.51 9.99C4.83 9.32 4.5 8.49 4.5 7.5C4.5 6.51 4.84 5.69 5.51 5.01C6.18 4.33 7.01 4 8 4C8.99 4 9.81 4.34 10.49 5.01ZM9.5 7.5C9.5 7.07 9.36 6.71 9.08 6.42C8.8 6.13 8.44 6 8 6C7.56 6 7.21 6.14 6.92 6.42C6.64 6.7 6.5 7.06 6.5 7.5C6.5 7.94 6.64 8.29 6.92 8.58C7.2 8.86 7.56 9 8 9C8.44 9 8.79 8.86 9.08 8.58C9.37 8.3 9.5 7.94 9.5 7.5ZM19 16V18H16V21H14V18H11V16H14V13H16V16H19Z", fill: "#464646" })), z5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#ia-role-outlined_svg__a)" }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M23.14 19c0-.13 0-.27-.02-.4l.88-.59c-.04-.22-.1-.44-.17-.66l-1.06-.07c-.11-.24-.25-.47-.4-.69l.46-.95q-.225-.255-.48-.48l-.95.47c-.22-.15-.45-.29-.69-.4l-.07-1.06c-.21-.07-.43-.13-.66-.17l-.59.88c-.13-.01-.26-.02-.4-.02s-.27 0-.4.02L18 14c-.23.04-.44.1-.66.18l-.07 1.05c-.24.11-.47.24-.69.4l-.95-.47q-.255.225-.48.48l.47.95c-.15.22-.29.45-.4.69l-1.06.07q-.105.315-.18.66l.88.59c-.01.13-.02.26-.02.4s0 .27.02.4l-.88.59q.06.33.18.66l1.06.07c.11.24.24.47.4.69l-.47.95q.225.255.48.48l.95-.47c.22.15.45.29.69.4l.07 1.06q.315.105.66.18l.59-.88c.13.01.26.02.4.02s.27 0 .4-.02l.59.88q.33-.06.66-.18l.07-1.06c.24-.11.47-.25.69-.4l.95.47q.255-.225.48-.48l-.46-.95c.15-.22.29-.45.4-.69l1.05-.07q.105-.315.18-.66l-.88-.59c.01-.13.02-.26.02-.4M19 22.11c-1.72 0-3.11-1.39-3.11-3.11s1.39-3.11 3.11-3.11 3.11 1.39 3.11 3.11-1.39 3.11-3.11 3.11M20.97 19c0-.26-1.1-1.92-1.1-1.92-.09-.15-.37-.15-.63 0s-.4.39-.31.55l.12.21.34.68h-2.23c-.17-.08-.32.17-.32.48s.14.57.32.51h2.24l-.34.66-.12.21c-.09.15.05.4.31.55s.54.15.63 0c0 0 1.1-1.66 1.1-1.92zM12 6c-.98 0-1.81.34-2.49 1.01S8.5 8.51 8.5 9.5s.34 1.81 1.01 2.49S11.01 13 12 13s1.81-.34 2.49-1.01 1.01-1.5 1.01-2.49-.34-1.81-1.01-2.49C13.82 6.34 12.99 6 12 6m1.08 4.58Q12.66 11 12 11c-.44 0-.79-.14-1.08-.42q-.42-.42-.42-1.08c0-.44.14-.79.42-1.08Q11.34 8 12 8c.44 0 .79.14 1.08.42s.42.64.42 1.08-.14.79-.42 1.08m-.48 11.24c-.2.06-.39.13-.6.18-2.32-.58-4.23-1.91-5.74-3.99S4 13.63 4 11.1V5l8-3 8 3v6.1c0 .33-.01.65-.04.97-.31-.04-.63-.07-.96-.07-.36 0-.72.04-1.07.09.03-.33.07-.66.07-.99V6.38l-6-2.25-6 2.25v4.72c0 .9.12 1.78.38 2.62.25.85.59 1.65 1.03 2.4.7-.35 1.43-.62 2.2-.83s1.57-.3 2.4-.3c.41 0 .81.03 1.2.07-.4.59-.71 1.24-.92 1.94-.1 0-.19-.02-.29-.02-.6 0-1.18.07-1.75.2s-1.11.32-1.62.55c.48.5 1.01.93 1.58 1.3s1.17.65 1.8.85c.02 0 .04-.02.06-.02.09.68.27 1.34.54 1.95z" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "ia-role-outlined_svg__a" }, /* @__PURE__ */ s.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))), W5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12 13c.97 0 1.79-.34 2.48-1.03s1.03-1.51 1.03-2.48-.34-1.79-1.03-2.48S12.97 5.98 12 5.98s-1.79.34-2.48 1.03-1.03 1.51-1.03 2.48.34 1.79 1.03 2.48S11.03 13 12 13m0 9c-2.43-.62-4.38-1.95-5.83-4s-2.18-4.35-2.18-6.9V5L12 2l8 3v6.1c0 2.55-.73 4.85-2.18 6.9s-3.39 3.38-5.83 4zm0-2.1c.98-.32 1.85-.81 2.61-1.49s1.42-1.44 1.99-2.29a10.1 10.1 0 0 0-4.6-1.13c-.8 0-1.59.1-2.36.29s-1.52.47-2.24.84c.57.85 1.23 1.61 1.99 2.29s1.63 1.17 2.61 1.49" })), O5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#F2664C", d: "M12.6 21.82c-.2.06-.39.13-.6.18-2.32-.58-4.23-1.91-5.74-3.99S4 13.63 4 11.1V5l8-3 8 3v6.1c0 .33-.01.65-.04.97-.31-.04-.63-.07-.96-.07-.36 0-.72.04-1.07.09.03-.33.07-.66.07-.99V6.38l-6-2.25-6 2.25v4.72c0 .9.12 1.78.38 2.62.25.85.59 1.65 1.03 2.4.7-.35 1.43-.62 2.2-.83s1.57-.3 2.4-.3c.41 0 .81.03 1.2.07-.4.59-.71 1.24-.92 1.94-.1 0-.19-.02-.29-.02-.6 0-1.18.07-1.75.2s-1.11.32-1.62.55c.48.5 1.01.93 1.58 1.3s1.17.65 1.8.85c.02 0 .04-.02.06-.02.09.68.27 1.34.54 1.95zm1.89-14.81c.68.67 1.01 1.5 1.01 2.49s-.34 1.81-1.01 2.49c-.67.67-1.5 1.01-2.49 1.01s-1.81-.34-2.49-1.01S8.5 10.49 8.5 9.5s.34-1.81 1.01-2.49S11.01 6 12 6s1.81.34 2.49 1.01M13.5 9.5q0-.645-.42-1.08C12.8 8.13 12.44 8 12 8s-.79.14-1.08.42q-.42.42-.42 1.08c0 .44.14.79.42 1.08q.42.42 1.08.42c.44 0 .79-.14 1.08-.42s.42-.64.42-1.08m9.04 11.62-1.41 1.41-2.12-2.12-2.12 2.12-1.41-1.41L17.6 19l-2.12-2.12 1.41-1.41 2.12 2.12 2.12-2.12 1.41 1.41L20.42 19z" })), Z5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12.06 19.88s-.04.02-.06.02c-.98-.32-1.85-.81-2.61-1.49-.76-.67-1.42-1.44-1.99-2.29a10.1 10.1 0 0 1 4.6-1.13c.4 0 .81.03 1.2.07a6.97 6.97 0 0 1 6.76-3c.02-.32.04-.64.04-.97v-6.1l-8-3-8 3v6.1c0 2.55.73 4.85 2.17 6.9 1.45 2.05 3.39 3.38 5.83 4 .2-.05.4-.12.6-.18a7 7 0 0 1-.54-1.95zM9.53 7.03C10.21 6.35 11.04 6 12 6s1.79.34 2.48 1.03S15.5 8.54 15.5 9.5s-.34 1.79-1.02 2.47A3.4 3.4 0 0 1 12 13c-.97 0-1.79-.34-2.47-1.03-.68-.68-1.03-1.51-1.03-2.47s.34-1.79 1.03-2.47M23.14 19c0-.13 0-.27-.02-.4l.88-.59c-.04-.22-.1-.44-.17-.66l-1.06-.07c-.11-.24-.25-.47-.4-.69l.46-.95q-.225-.255-.48-.48l-.95.47c-.22-.15-.45-.29-.69-.4l-.07-1.06c-.21-.07-.43-.13-.66-.17l-.59.88c-.13-.01-.26-.02-.4-.02s-.27 0-.4.02L18 14c-.23.04-.44.1-.66.18l-.07 1.05c-.24.11-.47.24-.69.4l-.95-.47q-.255.225-.48.48l.47.95c-.15.22-.29.45-.4.69l-1.06.07q-.105.315-.18.66l.88.59c-.01.13-.02.26-.02.4s0 .27.02.4l-.88.59q.06.33.18.66l1.06.07c.11.24.24.47.4.69l-.47.95q.225.255.48.48l.95-.47c.22.15.45.29.69.4l.07 1.06q.315.105.66.18l.59-.88c.13.01.26.02.4.02s.27 0 .4-.02l.59.88q.33-.06.66-.18l.07-1.06c.24-.11.47-.25.69-.4l.95.47q.255-.225.48-.48l-.46-.95c.15-.22.29-.45.4-.69l1.05-.07q.105-.315.18-.66l-.88-.59c.01-.13.02-.26.02-.4M19 22.11c-1.72 0-3.11-1.39-3.11-3.11s1.39-3.11 3.11-3.11 3.11 1.39 3.11 3.11-1.39 3.11-3.11 3.11M20.97 19c0 .26-1.1 1.92-1.1 1.92-.09.15-.37.15-.63 0s-.4-.39-.31-.55l.12-.21.34-.66h-2.23c-.17.06-.32-.19-.32-.5s.14-.57.32-.48h2.23l-.34-.68-.12-.21c-.09-.15.05-.4.31-.55s.54-.15.63 0c0 0 1.1 1.66 1.1 1.92" })), P5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M12.0002 13C12.9702 13 13.7902 12.66 14.4802 11.97C15.1702 11.28 15.5102 10.46 15.5102 9.49C15.5102 8.52 15.1702 7.7 14.4802 7.01C13.7902 6.32 12.9702 5.98 12.0002 5.98C11.0302 5.98 10.2102 6.32 9.52024 7.01C8.83024 7.7 8.49023 8.52 8.49023 9.49C8.49023 10.46 8.83024 11.28 9.52024 11.97C10.2102 12.66 11.0302 13 12.0002 13ZM12.0002 22C9.57023 21.38 7.62023 20.05 6.17023 18C4.72023 15.95 3.99023 13.65 3.99023 11.1V5L12.0002 2L20.0002 5V11.1C20.0002 13.65 19.2702 15.95 17.8202 18C16.3702 20.05 14.4302 21.38 11.9902 22H12.0002ZM12.0002 19.9C12.9802 19.58 13.8502 19.09 14.6102 18.41C15.3702 17.73 16.0302 16.97 16.6002 16.12C15.8802 15.75 15.1402 15.47 14.3602 15.28C13.5802 15.09 12.8002 14.99 12.0002 14.99C11.2002 14.99 10.4102 15.09 9.64023 15.28C8.87023 15.47 8.12023 15.75 7.40023 16.12C7.97023 16.97 8.63023 17.73 9.39023 18.41C10.1502 19.09 11.0202 19.58 12.0002 19.9Z", fill: "currentColor" })), q5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12 13q-1.474 0-2.488-1.012Q8.5 10.975 8.5 9.5q0-1.474 1.012-2.487T12 6t2.488 1.013T15.5 9.5t-1.012 2.488Q13.475 13 12 13m0-2q.65 0 1.075-.425T13.5 9.5t-.425-1.075T12 8t-1.075.425T10.5 9.5t.425 1.075T12 11m0 11q-3.476-.875-5.737-3.988Q4 14.9 4 11.1V5l8-3 8 3v6.1q0 3.8-2.262 6.913Q15.475 21.124 12 22m0-17.875-6 2.25V11.1q0 1.35.375 2.625t1.025 2.4q1.05-.525 2.2-.825A9.5 9.5 0 0 1 12 15q1.25 0 2.4.3t2.2.825q.65-1.125 1.025-2.4T18 11.1V6.375zM12 17q-.9 0-1.75.2a9 9 0 0 0-1.625.55q.724.75 1.575 1.3.85.55 1.8.85a7.4 7.4 0 0 0 1.8-.85 9 9 0 0 0 1.575-1.3 9 9 0 0 0-1.625-.55A7.6 7.6 0 0 0 12 17" })), U5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M20.9996 15.9999V10.0999L12.4796 14.7399C12.1796 14.8999 11.8196 14.8999 11.5196 14.7399L1.79961 9.43989C1.44961 9.24989 1.44961 8.74989 1.79961 8.55989L11.5196 3.25989C11.8196 3.09989 12.1796 3.09989 12.4796 3.25989L22.4796 8.70989C22.7996 8.88989 22.9996 9.21989 22.9996 9.58989V15.9999C22.9996 16.5499 22.5496 16.9999 21.9996 16.9999C21.4496 16.9999 20.9996 16.5499 20.9996 15.9999ZM11.5196 20.7399L5.51961 17.4799C5.19961 17.3099 4.99961 16.9699 4.99961 16.5999V13.1899L11.5196 16.7299C11.8196 16.8899 12.1796 16.8899 12.4696 16.7299L18.9896 13.1899V16.5999C18.9896 16.9699 18.7896 17.2999 18.4696 17.4799L12.4696 20.7399C12.1696 20.8999 11.8096 20.8999 11.5196 20.7399Z", fill: "currentColor" })), G5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "m12 21-7-3.8v-6L1 9l11-6 11 6v8h-2v-6.9l-2 1.1v6zm0-8.3L18.85 9 12 5.3 5.15 9zm0 6.025 5-2.7V12.25L12 15l-5-2.75v3.775z" })), K5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12.06 19.88s-.04.02-.06.02c-.98-.32-1.85-.81-2.61-1.49-.76-.67-1.42-1.44-1.99-2.29a10.1 10.1 0 0 1 4.6-1.13c.4 0 .81.03 1.2.07a6.97 6.97 0 0 1 6.76-3c.02-.32.04-.64.04-.97v-6.1l-8-3-8 3v6.1c0 2.55.73 4.85 2.17 6.9 1.45 2.05 3.39 3.38 5.83 4 .2-.05.4-.12.6-.18a7 7 0 0 1-.54-1.95zM9.53 7.03C10.21 6.35 11.04 6 12 6s1.79.34 2.48 1.03S15.5 8.54 15.5 9.5s-.34 1.79-1.02 2.47A3.4 3.4 0 0 1 12 13c-.97 0-1.79-.34-2.47-1.03-.68-.68-1.03-1.51-1.03-2.47s.34-1.79 1.03-2.47m12.18 11.26A.97.97 0 0 0 21 18v-1c0-.55-.2-1.02-.59-1.41S19.55 15 19 15s-1.02.2-1.41.59S17 16.45 17 17v1c-.28 0-.52.1-.71.29s-.29.43-.29.71v3c0 .28.1.52.29.71s.43.29.71.29h4c.28 0 .52-.1.71-.29s.29-.43.29-.71v-3c0-.28-.1-.52-.29-.71M20 18h-2v-1c0-.28.1-.52.29-.71s.43-.29.71-.29.52.1.71.29.29.43.29.71z" })), Y5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M15.567 16.859a7.772 7.772 0 1 1 1.292-1.292l4.14 4.14L19.709 21zm-10.74-6.096a5.937 5.937 0 1 0 5.936-5.936 5.944 5.944 0 0 0-5.936 5.936" })), Q5 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M21.376 1.36A2.32 2.32 0 0 0 19.003.013a1.76 1.76 0 0 0-1.276 1.033c-.069.112-.234.488-.512 1.067l-1.052 2.261q-.634 1.364-1.462 3.08a129 129 0 0 0-1.666 3.595l-1.744 3.81-1.637 3.576q.375.162.701.41l3.41-4.98q1.809-2.64 3.411-5.009l2.685-3.966q1.11-1.631 1.267-1.91a1.77 1.77 0 0 0 .248-1.622M6.72 18.465a137 137 0 0 0-.818-3.235 67 67 0 0 0-.536-1.949 17 17 0 0 0-.331-1.057 6 6 0 0 0-.234-.575 1.35 1.35 0 0 0-.8-.74 1.46 1.46 0 0 0-1.125.116 1.46 1.46 0 0 0-.794.81 1.34 1.34 0 0 0 .073 1.086q.116.234.298.54c.121.205.33.488.618.926s.682.975 1.19 1.642c.506.668 1.183 1.584 2.026 2.704q.21-.147.434-.268m3.732 3.308a2.227 2.227 0 1 1-4.454 0 2.227 2.227 0 0 1 4.454 0" })), X5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M10.11 8.5001H19C19.55 8.5001 20 8.0501 20 7.5001C20 6.9501 19.55 6.5001 19 6.5001H10.11C9.59001 4.4901 7.57001 3.0901 5.30001 3.6101C3.86001 3.9401 2.69001 5.1101 2.36001 6.5501C1.75001 9.1701 3.73001 11.5001 6.25001 11.5001C8.11001 11.5001 9.66001 10.2201 10.11 8.5001Z", fill: "currentColor" }), /* @__PURE__ */ s.createElement("path", { d: "M21.64 15.5501C21.31 14.1101 20.14 12.9401 18.7 12.6101C16.43 12.0901 14.41 13.4901 13.89 15.5001H5.00001C4.45001 15.5001 4.00001 15.9501 4.00001 16.5001C4.00001 17.0501 4.45001 17.5001 5.00001 17.5001H13.89C14.34 19.2201 15.89 20.5001 17.75 20.5001C20.27 20.5001 22.25 18.1701 21.64 15.5501Z", fill: "currentColor" })), J5 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M10.11 8.5001H19C19.55 8.5001 20 8.0501 20 7.5001C20 6.9501 19.55 6.5001 19 6.5001H10.11C9.59001 4.4901 7.57001 3.0901 5.30001 3.6101C3.86001 3.9401 2.69001 5.1101 2.36001 6.5501C1.75001 9.1701 3.73001 11.5001 6.25001 11.5001C8.11001 11.5001 9.66001 10.2201 10.11 8.5001ZM4.25001 7.5001C4.25001 6.4001 5.15001 5.5001 6.25001 5.5001C7.35001 5.5001 8.25001 6.4001 8.25001 7.5001C8.25001 8.6001 7.35001 9.5001 6.25001 9.5001C5.15001 9.5001 4.25001 8.6001 4.25001 7.5001Z", fill: "currentColor" }), /* @__PURE__ */ s.createElement("path", { d: "M21.64 15.5501C21.31 14.1101 20.14 12.9401 18.7 12.6101C16.43 12.0901 14.41 13.4901 13.89 15.5001H5.00001C4.45001 15.5001 4.00001 15.9501 4.00001 16.5001C4.00001 17.0501 4.45001 17.5001 5.00001 17.5001H13.89C14.34 19.2201 15.89 20.5001 17.75 20.5001C20.27 20.5001 22.25 18.1701 21.64 15.5501ZM17.75 18.5001C16.65 18.5001 15.75 17.6001 15.75 16.5001C15.75 15.4001 16.65 14.5001 17.75 14.5001C18.85 14.5001 19.75 15.4001 19.75 16.5001C19.75 17.6001 18.85 18.5001 17.75 18.5001Z", fill: "currentColor" })), e3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12.92 8.453a1 1 0 0 0 .033-.226V7.78c0-.073 0-.147-.014-.227l1.48-1.12A.33.33 0 0 0 14.506 6l-1.54-2.66a.33.33 0 0 0-.42-.14l-1.713.72a7 7 0 0 0-.374-.253 2.3 2.3 0 0 0-.406-.2l-.234-1.84a.333.333 0 0 0-.333-.294h-3.08a.34.34 0 0 0-.333.294l-.234 1.84q-.2.08-.4.2c-.133.08-.26.16-.386.253L3.339 3.2a.34.34 0 0 0-.42.14L1.38 6a.33.33 0 0 0 .087.433l1.48 1.12q-.02.119-.02.227v.447c0 .073 0 .146.02.226l-1.48 1.12a.33.33 0 0 0-.087.434l1.54 2.66c.087.146.26.206.42.14l1.714-.72c.12.086.246.173.373.253a2.3 2.3 0 0 0 .407.2l.233 1.84c.02.167.16.293.333.293h3.08a.34.34 0 0 0 .334-.293l.233-1.84q.2-.08.4-.2c.133-.08.26-.16.387-.253l1.693.72c.153.066.333 0 .42-.14l1.54-2.66a.33.33 0 0 0-.087-.434zm-3.287 1.2a2.26 2.26 0 0 1-1.647.687 2.26 2.26 0 0 1-1.66-.687 2.27 2.27 0 0 1-.673-1.646c0-.64.226-1.194.673-1.654.453-.453 1-.68 1.66-.68s1.193.227 1.647.68a2.26 2.26 0 0 1 .686 1.654 2.22 2.22 0 0 1-.686 1.646" })), t3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "M5.648 21a2.65 2.65 0 0 1-2.644-2.5v-13A2.647 2.647 0 0 1 5.65 3h6.352v2H5.65a.65.65 0 0 0-.648.59v12.82a.646.646 0 0 0 .646.589h6.354v2zm9.646-5.707 2.295-2.295H9.002v-2h8.589l-2.295-2.295L16.71 7.29l4.708 4.708-4.708 4.707z" })), r3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M14 10h-4a.5.5 0 0 0-.4.8l2 2.667a.5.5 0 0 0 .8 0l2-2.667a.5.5 0 0 0-.4-.8" })), n3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M11 9.666h2a.5.5 0 0 0 .4-.8l-1-1.333a.5.5 0 0 0-.8 0l-1 1.333a.5.5 0 0 0 .4.8m2 4.667h-2a.5.5 0 0 0-.4.8l1 1.334a.5.5 0 0 0 .8 0l1-1.334a.5.5 0 0 0-.4-.8" })), o3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M11.5 6.775a.5.5 0 0 0 1 0v-2.22h4.175A15.94 15.94 0 0 1 18.5 11.5h-2.375v-3a.23.23 0 0 0-.33-.205l-4.05 2.035a.23.23 0 0 1-.335-.2V9.115a.23.23 0 0 0-.33-.205L8 10.455a.24.24 0 0 0-.125.205v.84H5.5a15.94 15.94 0 0 1 1.825-6.945H11.5zM11.5 1a10.6 10.6 0 0 0-1.875.245 16 16 0 0 0-1.73 2.295H11.5zm-3.64.81a11 11 0 0 0-2.91 1.745h1.78q.515-.903 1.14-1.735s0-.015-.01-.01m6.5-.55A10.5 10.5 0 0 0 12.5 1v2.555h3.605a16 16 0 0 0-1.73-2.295zM19.5 11.5H23a10.9 10.9 0 0 0-2.905-6.945h-2.3A17 17 0 0 1 19.5 11.5M6.205 4.555h-2.3A10.9 10.9 0 0 0 1 11.5h3.5a17 17 0 0 1 1.705-6.945m12.845-1a11 11 0 0 0-2.91-1.745 17 17 0 0 1 1.14 1.735zM9.625 22.74A10.5 10.5 0 0 0 11.5 23v-2.555H7.895a16 16 0 0 0 1.73 2.295m6.5-.55a11 11 0 0 0 2.91-1.745H17.27a17 17 0 0 1-1.14 1.735s0 .015.01.01zm1.655-2.745h2.3A10.9 10.9 0 0 0 23 12.5h-3.5a17 17 0 0 1-1.705 6.945zM12.5 23a10.6 10.6 0 0 0 1.875-.245 16 16 0 0 0 1.73-2.295H12.5zm0-3.54h4.175A15.94 15.94 0 0 0 18.5 12.5h-2.375v3.12a.235.235 0 0 1-.23.23h-7.79a.235.235 0 0 1-.23-.23V12.5H5.5a15.94 15.94 0 0 0 1.82 6.945h4.18V18a.5.5 0 0 1 1 0zm-8-6.96H1a10.9 10.9 0 0 0 2.905 6.945h2.3A17 17 0 0 1 4.5 12.5m.45 7.945a11 11 0 0 0 2.91 1.745 17 17 0 0 1-1.14-1.735zm7.965-6.08h.92a.23.23 0 0 0 .225-.23V12.5a.23.23 0 0 0-.225-.23h-.92a.235.235 0 0 0-.23.23v1.615a.236.236 0 0 0 .23.25m-2.75 0h.92a.23.23 0 0 0 .225-.23V12.5a.23.23 0 0 0-.225-.23h-.92a.235.235 0 0 0-.23.23v1.615a.235.235 0 0 0 .23.25" })), a3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M20.945 3.735 20.235 3a6.93 6.93 0 0 0-8.355-1.075 6.94 6.94 0 0 0-8.115 1.23l-.71.715A6.9 6.9 0 0 0 1.16 7.415a7 7 0 0 0 .71 4.65 6.935 6.935 0 0 0 1.255 8.07l.71.71a6.925 6.925 0 0 0 8.04 1.265 6.935 6.935 0 0 0 8.29-1.11l.71-.715a6.86 6.86 0 0 0 1.96-3.96h-.145a6.05 6.05 0 0 1-1.69 3.36l-.78.78a6.12 6.12 0 0 1-7.315 1q.243-.177.465-.38a5.58 5.58 0 0 0 6.46-1.025l.78-.78a5.53 5.53 0 0 0 1.55-3 5.68 5.68 0 0 0-.69-3.74c-.1-.165-.205-.325-.32-.5a6 6 0 0 0-.545-.635l-1.16-1.165-2.165-2.165-.055-.05-.33-.335-2.5-2.5-.655-.65q.273-.135.565-.22l.5.5 2.5 2.5.33.33.055.055 2 2 1.31 1.32q.269.264.5.56.181.231.34.5c.04.07.085.135.12.2a6.2 6.2 0 0 1 .765 4h.145a7 7 0 0 0-.79-4.235 6.925 6.925 0 0 0-1.135-8.315M1.74 7.47a6.16 6.16 0 0 1 1.76-3.7L4.28 3a6.14 6.14 0 0 1 7.42-.965 5 5 0 0 0-.5.35 5.575 5.575 0 0 0-6.5 1l-.81.78a5.6 5.6 0 0 0-1.6 3.36 5.6 5.6 0 0 0 .575 3.1c.181.356.401.692.655 1q.174.22.375.415l1.055 1.055 2.63 2.63.045.045.105.105L10.875 19q-.237.165-.5.29L7.23 16.145l-.045-.045-.15-.15-2.38-2.365-1.12-1.12-.035-.035a6.3 6.3 0 0 1-1-1.34 6.1 6.1 0 0 1-.76-3.62m2.605.25a3.7 3.7 0 0 1 .95-1.61L6 5.4a3.74 3.74 0 0 1 3.13-1.065L4.235 9.24a3.8 3.8 0 0 1 .11-1.52m-.06 7.165 2.07 2.065 2.73 2.73a3.75 3.75 0 0 1-3-1.075l-.71-.715a3.75 3.75 0 0 1-1.09-3.005m8.79 6.06a6.4 6.4 0 0 1-1.4 1.055 6.135 6.135 0 0 1-7.26-1.055l-.78-.78a6.135 6.135 0 0 1-1.135-7.12c.125.155.26.31.4.455a5.58 5.58 0 0 0 1.125 6.275l.78.78a5.59 5.59 0 0 0 6.34 1.08q.534-.258 1-.625.228-.176.435-.375l.09-.08 1.07-1.055 5.655-5.66q.128.281.205.58l-5.285 5.285zm4.85-2.21a3.73 3.73 0 0 1-3.245 1.045l5-5c.077.477.063.963-.04 1.435a3.8 3.8 0 0 1-1 1.81zm-2.35-9.065 2.365 2.37-6 6-3.295-3.29-2.715-2.72 6-6 .8.8zM17.87 7.5 15 4.585l-.345-.35A3.76 3.76 0 0 1 18 5.265l.705.735a3.75 3.75 0 0 1 1.025 3.37zm3.735 3.88a5.57 5.57 0 0 0-.885-6.74l-.78-.78a5.555 5.555 0 0 0-6.63-.93l-.275.155a5.5 5.5 0 0 0-.955.775l-1.175 1.18L4.935 11a3.3 3.3 0 0 1-.3-.5l5.77-5.765L11.67 3.47c.16-.155.32-.305.5-.44s.3-.23.46-.335l.23-.145a6.135 6.135 0 0 1 7.5.92l.75.78a6.115 6.115 0 0 1 .83 7.625 7 7 0 0 0-.335-.515z" })), i3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M1.93 11H5a4 4 0 0 1 4 4v1.07a.93.93 0 0 0 .93.93h4.14a.93.93 0 0 0 .93-.93v-2.14a.93.93 0 0 0-.93-.93H11a4 4 0 1 1 0-8h3.07a.93.93 0 0 0 .93-.93V1.93a.93.93 0 0 0-.93-.93H9.93a.93.93 0 0 0-.93.93V3a4 4 0 0 1-4 4H1.93a.93.93 0 0 0-.93.93v2.14a.93.93 0 0 0 .93.93" }), /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M22.07 13H19a4 4 0 0 1-4-4V7.93a.93.93 0 0 0-.93-.93H9.93a.93.93 0 0 0-.93.93v2.14a.93.93 0 0 0 .93.93H13a4 4 0 1 1 0 8H9.93a.93.93 0 0 0-.93.93v2.14a.93.93 0 0 0 .93.93h4.14a.93.93 0 0 0 .93-.93V21a4 4 0 0 1 4-4h3.07a.93.93 0 0 0 .93-.93v-2.14a.93.93 0 0 0-.93-.93" })), l3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#4A90AD", d: "M11.723 5a.99.99 0 0 0-.9.56L9.29 8.673l-3.433.5a1 1 0 0 0-.554 1.707L7.79 13.3l-.587 3.42c-.113.647.4 1.173.987 1.173a.94.94 0 0 0 .467-.12l3.073-1.613 3.073 1.613c.153.08.313.12.467.12.58 0 1.093-.526.986-1.173l-.586-3.42 2.487-2.42a1 1 0 0 0-.554-1.707l-3.433-.5-1.553-3.113a.99.99 0 0 0-.9-.56z" })), s3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "#464646", d: "m11.71 6.753 1.24 2.507c.193.393.567.667 1.007.727l2.766.4-2 1.953a1.34 1.34 0 0 0-.386 1.18l.473 2.754-2.473-1.3a1.35 1.35 0 0 0-.62-.154 1.35 1.35 0 0 0-.62.153l-2.474 1.3.474-2.753a1.32 1.32 0 0 0-.387-1.18l-2-1.953 2.767-.4a1.34 1.34 0 0 0 1.006-.727l1.24-2.507m0-1.753a.99.99 0 0 0-.9.56L9.29 8.673l-3.433.5a1 1 0 0 0-.554 1.707L7.79 13.3l-.587 3.42c-.113.647.4 1.174.987 1.174a.94.94 0 0 0 .467-.12l3.073-1.614 3.073 1.614c.154.08.314.12.467.12.58 0 1.093-.527.987-1.174l-.587-3.42 2.487-2.42a1 1 0 0 0-.553-1.707l-3.434-.5-1.567-3.113a.99.99 0 0 0-.9-.56z" })), c3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "#7BBA19", fillRule: "evenodd", d: "M28 38C26.62 38 25.32 37.74 24.1 37.21C22.88 36.68 21.82 35.97 20.92 35.07C20.02 34.17 19.31 33.11 18.78 31.89C18.25 30.67 17.99 29.37 17.99 27.99C17.99 26.61 18.25 25.31 18.78 24.09C19.31 22.87 20.02 21.81 20.92 20.91C21.82 20.01 22.88 19.3 24.1 18.77C25.32 18.24 26.62 17.98 28 17.98C29.38 17.98 30.68 18.24 31.9 18.77C33.12 19.3 34.18 20.01 35.08 20.91C35.98 21.81 36.69 22.87 37.22 24.09C37.75 25.31 38.01 26.61 38.01 27.99C38.01 29.37 37.75 30.67 37.22 31.89C36.69 33.11 35.98 34.17 35.08 35.07C34.18 35.97 33.12 36.68 31.9 37.21C30.68 37.74 29.38 38 28 38ZM26.6 32.6L33.65 25.55L32.25 24.15L26.6 29.8L23.75 26.95L22.35 28.35L26.6 32.6Z" }))), d3 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M9.50098 10C9.50098 10.2967 9.58895 10.5867 9.75378 10.8334C9.9186 11.0801 10.1529 11.2723 10.427 11.3858C10.701 11.4994 11.0026 11.5291 11.2936 11.4712C11.5846 11.4133 11.8519 11.2705 12.0616 11.0607C12.2714 10.8509 12.4143 10.5836 12.4722 10.2927C12.53 10.0017 12.5003 9.70009 12.3868 9.426C12.2733 9.15191 12.081 8.91764 11.8343 8.75282C11.5877 8.588 11.2977 8.50002 11.001 8.50002C10.6032 8.50002 10.2216 8.65806 9.94032 8.93936C9.65902 9.22067 9.50098 9.6022 9.50098 10Z", fill: "currentColor" }), /* @__PURE__ */ s.createElement("path", { d: "M21.151 12.504L18.411 7.71002C17.97 6.29372 17.1315 5.03391 15.9951 4.08049C14.8587 3.12707 13.4724 2.52017 12.001 2.33202V6.66302C12.7187 6.87139 13.3502 7.30545 13.8018 7.90089C14.2534 8.49632 14.5012 9.22142 14.5084 9.96873C14.5156 10.716 14.2818 11.4458 13.8417 12.0498C13.4016 12.6538 12.7786 13.0999 12.065 13.322C12.1299 13.5194 12.2552 13.6914 12.4231 13.8138C12.5911 13.9362 12.7932 14.0027 13.001 14.004H15.001C15.2662 14.004 15.5206 14.1094 15.7081 14.2969C15.8956 14.4845 16.001 14.7388 16.001 15.004C16.001 15.2692 15.8956 15.5236 15.7081 15.7111C15.5206 15.8987 15.2662 16.004 15.001 16.004H13.001C12.2679 16.0017 11.5612 15.7306 11.0147 15.242C10.4682 14.7534 10.12 14.0813 10.036 13.353C9.30748 13.1497 8.6651 12.7145 8.20621 12.1132C7.74732 11.512 7.49692 10.7776 7.49296 10.0212C7.489 9.2649 7.7317 8.52789 8.18428 7.92189C8.63686 7.3159 9.27464 6.87395 10.001 6.66302V2.32202C8.40696 2.52721 6.91636 3.22357 5.73611 4.31445C4.55586 5.40533 3.74452 6.8366 3.41471 8.40957C3.0849 9.98254 3.25299 11.6192 3.89564 13.0923C4.5383 14.5654 5.62363 15.8018 7.00098 16.63V21C7.00098 21.2652 7.10634 21.5196 7.29387 21.7071C7.48141 21.8947 7.73576 22 8.00098 22H14.001C14.2662 22 14.5206 21.8947 14.7081 21.7071C14.8956 21.5196 15.001 21.2652 15.001 21V19H17.001C17.5314 19 18.0401 18.7893 18.4152 18.4142C18.7903 18.0392 19.001 17.5305 19.001 17V14H20.278C20.4537 14.0004 20.6264 13.9544 20.7787 13.8668C20.931 13.7792 21.0575 13.653 21.1455 13.5009C21.2335 13.3488 21.2799 13.1762 21.28 13.0005C21.28 12.8248 21.2338 12.6522 21.146 12.5", fill: "currentColor" })), u3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "m20.812 12.268-2.74-4.795a7.75 7.75 0 1 0-11.4 8.92v4.37a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2h2a2 2 0 0 0 2-2v-3h1.277a1 1 0 0 0 .868-1.5zm-10.15-1.004a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m6 .5v4.5a.5.5 0 0 1-.5.5h-3.5v3h-4v-4.5l-.965-.583A5.74 5.74 0 0 1 9.662 4.107v2.319a3.478 3.478 0 0 0 .035 6.688 2.994 2.994 0 0 0 2.965 2.65h2a1 1 0 0 0 0-2h-2a.99.99 0 0 1-.936-.682 3.478 3.478 0 0 0-.064-6.656V4.105a5.71 5.71 0 0 1 4.494 3.958l.066.21.109.193 1.88 3.298z" })), p3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M20.22 5.54L19.45 5.16C19.57 4.97 19.67 4.83 19.72 4.74C20.07 4.2 20.15 3.52 19.94 2.91V2.87L19.91 2.84C19.71 2.37 19.35 1.98 18.9 1.73C18.55 1.53 18.14 1.42 17.73 1.42C17.65 1.42 17.57 1.42 17.49 1.43H17.46H17.43C16.74 1.54 16.15 1.99 15.86 2.62L15.59 3.18L15.57 3.22L15.06 2.97L12.96 2.15C12.33 1.9 11.63 1.91 11 2.15L5.01 4.49C4.01 4.88 3.37 5.8 3.37 6.84V9.53C3.37 16.26 8.37999 20.22 10.53 21.61C10.97 21.89 11.47 22.04 11.98 22.04C12.49 22.04 12.99 21.9 13.43 21.61C15.58 20.22 20.59 16.26 20.59 9.53V6.84C20.59 6.37 20.53 5.99 20.21 5.54H20.22ZM16.5 3.62L16.77 3.05C16.92 2.72 17.23 2.48 17.59 2.42C17.64 2.42 17.68 2.42 17.73 2.42C17.97 2.42 18.21 2.48 18.42 2.6C18.68 2.74 18.88 2.97 19 3.23C19.11 3.56 19.07 3.92 18.88 4.2C18.84 4.26 18.73 4.44 18.56 4.7C18.52 4.76 18.47 4.83 18.42 4.9C18.36 4.99 18.3 5.09 18.22 5.2L16.84 7.24C16.3 8.04 15.71 8.9 15.08 9.82L14.17 11.29C13.91 11.69 13.67 12.06 13.42 12.43C13.18 12.22 12.9 12.07 12.6 11.99C12.75 11.69 13.02 11.11 13.42 10.28C13.82 9.45 14.24 8.58 14.4 8.24C14.66 7.6 14.94 6.97 15.22 6.39C15.5 5.81 15.75 5.28 15.96 4.81L16.48 3.69L16.5 3.64V3.62ZM9.43 10.41L9.22999 10.12C9.07999 9.91 8.97 9.74 8.91 9.63C8.85 9.53 8.79 9.44 8.75 9.33C8.63 9.11 8.61 8.85 8.71 8.62C8.8 8.38 8.98 8.19 9.21 8.09C9.43 7.98 9.68999 7.95 9.93999 8.02C10.18 8.1 10.37 8.28 10.47 8.51C10.52 8.61 10.56 8.72 10.59 8.82C10.64 8.94 10.7 9.12 10.77 9.37L10.94 9.95C11.11 10.53 11.38 11.4 11.52 11.9C11.23 11.97 10.95 12.1 10.71 12.28C10.35 11.73 9.75 10.88 9.43 10.39V10.41ZM12.06 15.69C11.34 15.75 10.72 15.21 10.66 14.5C10.66 14.43 10.66 14.36 10.66 14.29C10.72 13.57 11.34 13.04 12.06 13.1C12.7 13.15 13.2 13.66 13.25 14.29C13.31 15.01 12.77 15.63 12.06 15.69Z" })), m3 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M22.54 15.46C21.57 14.49 20.39 14 19 14C17.61 14 16.44 14.49 15.46 15.46C14.48 16.44 14 17.61 14 19C14 20.39 14.49 21.56 15.46 22.54C16.43 23.52 17.61 24 19 24C20.39 24 21.56 23.51 22.54 22.54C23.52 21.56 24 20.39 24 19C24 17.61 23.51 16.44 22.54 15.46ZM21.7 20.89L21.03 21.56C20.95 21.64 20.85 21.68 20.74 21.69C20.28 21.72 19.05 21.64 17.74 20.33C16.43 19.02 16.35 17.8 16.38 17.33C16.38 17.22 16.43 17.12 16.51 17.04L17.18 16.37C17.25 16.3 17.36 16.3 17.43 16.37L18.42 17.36C18.49 17.43 18.49 17.54 18.42 17.61L17.62 18.41C17.62 18.41 17.6 18.45 17.6 18.47C17.6 18.5 17.6 19.15 18.26 19.81C18.93 20.48 19.58 20.47 19.6 20.47C19.62 20.47 19.64 20.47 19.66 20.45L20.46 19.65C20.53 19.58 20.64 19.58 20.71 19.65L21.7 20.64C21.77 20.71 21.77 20.82 21.7 20.89ZM18.91 12C19.4 12 19.87 12.05 20.33 12.15C20.5 11.33 20.6 10.46 20.6 9.53V6.84C20.6 6.37 20.54 5.99 20.22 5.54L19.45 5.16C19.57 4.97 19.67 4.83 19.72 4.74C20.07 4.2 20.15 3.52 19.94 2.91V2.87L19.91 2.84C19.71 2.37 19.35 1.98 18.9 1.73C18.55 1.53 18.14 1.42 17.73 1.42C17.65 1.42 17.57 1.42 17.49 1.43H17.46H17.43C16.74 1.54 16.15 1.99 15.86 2.62L15.59 3.18L15.57 3.22L15.06 2.97L12.96 2.15C12.33 1.9 11.63 1.91 11 2.15L5.02 4.49C4.02 4.88 3.38 5.8 3.38 6.84V9.53C3.38 16.26 8.39 20.22 10.54 21.61C10.98 21.89 11.48 22.04 11.99 22.04C12.18 22.04 12.37 22 12.56 21.96C12.14 21.06 11.9 20.06 11.9 19.01C11.9 15.14 15.03 12.01 18.9 12.01L18.91 12ZM9.43001 10.41L9.23 10.12C9.08 9.91 8.97 9.74 8.91 9.63C8.85 9.53 8.79 9.44 8.75 9.33C8.63 9.11 8.61 8.85 8.71 8.62C8.8 8.38 8.98 8.19 9.21 8.09C9.43 7.98 9.69 7.95 9.94 8.02C10.18 8.1 10.37 8.28 10.47 8.51C10.52 8.61 10.56 8.72 10.59 8.82C10.64 8.94 10.7 9.12 10.77 9.37L10.94 9.95C11.11 10.53 11.38 11.4 11.52 11.9C11.23 11.97 10.95 12.1 10.71 12.28C10.35 11.73 9.75001 10.88 9.43001 10.39V10.41ZM12.06 15.69C11.34 15.75 10.72 15.21 10.66 14.5C10.66 14.43 10.66 14.36 10.66 14.29C10.72 13.57 11.34 13.04 12.06 13.1C12.7 13.15 13.2 13.66 13.25 14.29C13.31 15.01 12.77 15.63 12.06 15.69ZM12.59 11.98C12.74 11.68 13.01 11.1 13.41 10.27C13.81 9.44 14.23 8.57 14.39 8.23C14.65 7.59 14.93 6.96 15.21 6.38C15.49 5.8 15.74 5.27 15.95 4.8L16.47 3.68L16.49 3.63L16.76 3.06C16.91 2.73 17.22 2.49 17.58 2.43C17.63 2.43 17.67 2.43 17.72 2.43C17.96 2.43 18.2 2.49 18.41 2.61C18.67 2.75 18.87 2.98 18.99 3.24C19.1 3.57 19.06 3.93 18.87 4.21C18.83 4.27 18.72 4.45 18.55 4.71C18.51 4.77 18.46 4.84 18.41 4.91C18.35 5 18.29 5.1 18.21 5.21L16.83 7.25C16.29 8.05 15.7 8.91 15.07 9.83L14.16 11.3C13.9 11.7 13.66 12.07 13.41 12.44C13.17 12.23 12.89 12.08 12.59 12V11.98Z" })), h3 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M18.89 11.58C19.38 11.58 19.85 11.63 20.31 11.73C20.48 10.91 20.58 10.04 20.58 9.11V6.42C20.58 5.95 20.52 5.57 20.2 5.12L19.43 4.74C19.55 4.55 19.65 4.41 19.7 4.32C20.05 3.78 20.13 3.1 19.92 2.49V2.45L19.89 2.42C19.69 1.95 19.33 1.56 18.88 1.31C18.53 1.11 18.12 1 17.71 1C17.63 1 17.55 1 17.47 1.01H17.41C16.72 1.12 16.13 1.57 15.84 2.2L15.57 2.76L15.55 2.8L15.04 2.55L12.94 1.73C12.31 1.48 11.61 1.49 10.98 1.73L5.02 4.06C4.02 4.45 3.38 5.37 3.38 6.41V9.1C3.38 15.83 8.39 19.79 10.54 21.18C10.98 21.46 11.48 21.61 11.99 21.61C12.18 21.61 12.37 21.57 12.56 21.53C12.14 20.63 11.9 19.63 11.9 18.58C11.9 14.71 15.03 11.58 18.9 11.58H18.89ZM9.41001 9.98L9.21 9.69C9.06 9.48 8.95001 9.31 8.89001 9.2C8.83001 9.1 8.77 9.01 8.73 8.9C8.61 8.68 8.59 8.42 8.69 8.19C8.78 7.95 8.96 7.76 9.19 7.66C9.41 7.55 9.67 7.52 9.92 7.59C10.16 7.67 10.35 7.85 10.45 8.08C10.5 8.18 10.54 8.29 10.57 8.39C10.62 8.51 10.68 8.69 10.75 8.94L10.92 9.52C11.09 10.1 11.36 10.97 11.5 11.47C11.21 11.54 10.93 11.67 10.69 11.85C10.33 11.3 9.73001 10.45 9.41001 9.96V9.98ZM12.04 15.26C11.32 15.32 10.7 14.78 10.64 14.07C10.64 14 10.64 13.93 10.64 13.86C10.7 13.14 11.32 12.61 12.04 12.67C12.68 12.72 13.18 13.23 13.23 13.86C13.29 14.58 12.75 15.2 12.04 15.26ZM12.58 11.55C12.73 11.25 13 10.67 13.4 9.84C13.8 9.01 14.22 8.14 14.38 7.8C14.64 7.16 14.92 6.53 15.2 5.95C15.48 5.37 15.73 4.84 15.94 4.37L16.46 3.25L16.48 3.2L16.75 2.63C16.9 2.3 17.21 2.06 17.57 2C17.62 2 17.66 2 17.71 2C17.95 2 18.19 2.06 18.4 2.18C18.66 2.32 18.86 2.55 18.98 2.81C19.09 3.14 19.05 3.5 18.86 3.78C18.82 3.84 18.71 4.02 18.54 4.28C18.5 4.34 18.45 4.41 18.4 4.48C18.34 4.57 18.28 4.67 18.2 4.78L16.82 6.82C16.28 7.62 15.69 8.48 15.06 9.4L14.15 10.87C13.89 11.27 13.65 11.64 13.4 12.01C13.16 11.8 12.88 11.65 12.58 11.57V11.55Z" }), /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M22.52 15.04C21.54 14.07 20.37 13.58 18.98 13.58C17.59 13.58 16.42 14.07 15.44 15.04C14.46 16.01 13.98 17.19 13.98 18.58C13.98 19.97 14.47 21.14 15.44 22.12C16.41 23.1 17.59 23.58 18.98 23.58C20.37 23.58 21.54 23.09 22.52 22.12C23.49 21.14 23.98 19.97 23.98 18.58C23.98 17.19 23.49 16.02 22.52 15.04ZM18.63 22.03V19.29H17.06L19.3 15.06V17.8H20.79L18.63 22.03Z" })), g3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M18.5 2h-13c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8.26 4.59 1.11 1.03 2.38-2.38 1.41 1.41-3.74 3.74-2.53-2.33 1.36-1.47zM15.5 18h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1m0-4h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1" })), C3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M2 22V4q0-.824.587-1.412A1.93 1.93 0 0 1 4 2h16q.824 0 1.413.587Q22 3.176 22 4v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18H6zm7.075-7.75L12 12.475l2.925 1.775-.775-3.325 2.6-2.25-3.425-.275L12 5.25 10.675 8.4l-3.425.275 2.6 2.25z" })), v3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M16.5 17c0 .55-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1m-1-5h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1m5-8v16c0 1.1-.9 2-2 2h-13c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h13c1.1 0 2 .9 2 2m-2 15.5v-15c0-.28-.22-.5-.5-.5H6c-.28 0-.5.22-.5.5v15c0 .28.22.5.5.5h12c.28 0 .5-.22.5-.5M15.14 6.65l-1.41-1.41-2.38 2.38-1.11-1.03-1.36 1.47 2.53 2.33 3.74-3.74z" })), f3 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M7 18C5.33333 18 3.91667 17.4167 2.75 16.25C1.58333 15.0833 1 13.6667 1 12C1 10.3333 1.58333 8.91667 2.75 7.75C3.91667 6.58333 5.33333 6 7 6H17C18.6667 6 20.0833 6.58333 21.25 7.75C22.4167 8.91667 23 10.3333 23 12C23 13.6667 22.4167 15.0833 21.25 16.25C20.0833 17.4167 18.6667 18 17 18H7ZM7 16H17C18.1 16 19.0417 15.6083 19.825 14.825C20.6083 14.0417 21 13.1 21 12C21 10.9 20.6083 9.95833 19.825 9.175C19.0417 8.39167 18.1 8 17 8H7C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16ZM7 15C7.83333 15 8.54167 14.7083 9.125 14.125C9.70833 13.5417 10 12.8333 10 12C10 11.1667 9.70833 10.4583 9.125 9.875C8.54167 9.29167 7.83333 9 7 9C6.16667 9 5.45833 9.29167 4.875 9.875C4.29167 10.4583 4 11.1667 4 12C4 12.8333 4.29167 13.5417 4.875 14.125C5.45833 14.7083 6.16667 15 7 15Z", fill: "currentColor" })), x3 = (e) => /* @__PURE__ */ s.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ s.createElement("path", { d: "M7 18C5.33333 18 3.91667 17.4167 2.75 16.25C1.58333 15.0833 1 13.6667 1 12C1 10.3333 1.58333 8.91667 2.75 7.75C3.91667 6.58333 5.33333 6 7 6H17C18.6667 6 20.0833 6.58333 21.25 7.75C22.4167 8.91667 23 10.3333 23 12C23 13.6667 22.4167 15.0833 21.25 16.25C20.0833 17.4167 18.6667 18 17 18H7ZM7 16H17C18.1 16 19.0417 15.6083 19.825 14.825C20.6083 14.0417 21 13.1 21 12C21 10.9 20.6083 9.95833 19.825 9.175C19.0417 8.39167 18.1 8 17 8H7C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16ZM17 15C17.8333 15 18.5417 14.7083 19.125 14.125C19.7083 13.5417 20 12.8333 20 12C20 11.1667 19.7083 10.4583 19.125 9.875C18.5417 9.29167 17.8333 9 17 9C16.1667 9 15.4583 9.29167 14.875 9.875C14.2917 10.4583 14 11.1667 14 12C14 12.8333 14.2917 13.5417 14.875 14.125C15.4583 14.7083 16.1667 15 17 15Z", fill: "currentColor" })), b3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M9 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m3-7.5h-2v5H8v-5H6V9h6zm8.25-6.75L23 5l-2.75 1.25L19 9l-1.25-2.75L15 5l2.75-1.25L19 1zm0 14L23 19l-2.75 1.25L19 23l-1.25-2.75L15 19l2.75-1.25L19 15z" })), w3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 18, fill: "none", viewBox: "0 0 20 18", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M17.393 6.609 19.5 9l-2.107 2.391.293 3.163-3.117.703-1.633 2.734L10 16.74 7.064 18 5.43 15.266l-3.117-.703.293-3.172L.5 9l2.107-2.4-.293-3.171 3.117-.695L7.064 0 10 1.251 12.936 0l1.633 2.743 3.117.703z" }), /* @__PURE__ */ s.createElement("path", { fill: "#F2F8E8", d: "m6.25 9.597 2.533 2.54 4.887-4.9-.987-.987-3.9 3.913L7.237 8.61z" })), y3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("path", { fill: "currentColor", d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 13A9.77 9.77 0 0 1 3.18 12 9.76 9.76 0 0 1 12 6.5c3.8 0 7.17 2.13 8.82 5.5A9.76 9.76 0 0 1 12 17.5m0-10c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5m0 7a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5" })), k3 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ s.createElement("g", { transform: "translate(-16 -16)" }, /* @__PURE__ */ s.createElement("path", { fill: "#E9AF23", d: "M17.87 35.5L27.13 19.49C27.52 18.82 28.48 18.82 28.86 19.49L38.13 35.49C38.52 36.16 38.03 36.99 37.26 36.99H18.73C17.96 36.99 17.48 36.16 17.86 35.49L17.87 35.5ZM28 34C28.28 34 28.52 33.9 28.71 33.71C28.9 33.52 29 33.28 29 33C29 32.72 28.9 32.48 28.71 32.29C28.52 32.1 28.28 32 28 32C27.72 32 27.48 32.1 27.29 32.29C27.1 32.48 27 32.72 27 33C27 33.28 27.1 33.52 27.29 33.71C27.48 33.9 27.72 34 28 34ZM27 31H29V26H27V31Z" }))), Yt = {
  access: tl,
  "access-add": rl,
  "access-outlined": nl,
  "access-lock": ol,
  address: al,
  "address-outlined": il,
  "address-add": ll,
  "address-add-outlined": sl,
  "address-remove": cl,
  "address-remove-outlined": dl,
  "address-billing": ul,
  "address-billing-outlined": pl,
  apps: ml,
  "arrow-back": hl,
  "arrow-down": gl,
  "arrow-up": Cl,
  attach: vl,
  "authorized-distributor": fl,
  backup: xl,
  "badge-empty": bl,
  "breadcrumb-chevron": wl,
  calendar: kl,
  copy: yl,
  caret: jl,
  certification: Ll,
  "certification-outlined": Sl,
  course: Bl,
  "course-outlined": Al,
  "course-elective": Hl,
  "course-employee": Dl,
  credential: Rl,
  "credential-outlined": Tl,
  "checkbox-check": Ml,
  "checkbox-dash": El,
  "chevron-right": Nl,
  "chevron-thick": Il,
  chevron: $l,
  "chevron-small": _l,
  "cloud-upload": Vl,
  cross: Fl,
  "currency-dollar": zl,
  "currency-euro": Wl,
  "currency-franc": Ol,
  "currency-lira": Zl,
  "currency-pound": Pl,
  "currency-ruble": ql,
  "currency-rupee": Ul,
  "currency-yen": Gl,
  "currency-yuan": Kl,
  dashboard: Ql,
  "dashboard-outlined": Yl,
  "delete-outlined": Xl,
  delete: Jl,
  document: es,
  "document-outlined": ts,
  download: rs,
  "edit-outlined": ns,
  edit: os,
  "email-arrow": as,
  email: is,
  "email-outlined-check": ls,
  "email-outlined-notification": ss,
  "email-outlined-remove": cs,
  "email-outlined": ds,
  engineer: us,
  "engineer-filled": ps,
  error: ms,
  exchange: hs,
  feedback: gs,
  filter: Cs,
  forums: vs,
  gear: fs,
  "gear-outlined": xs,
  group: bs,
  "guide-outlined": ws,
  "help-outlined": ys,
  history: ks,
  ia: js,
  "ia-gear-public-profile": Ss,
  "inductive-automation": Ls,
  "industry-aerospace": Ms,
  "industry-agriculture": Es,
  info: Ns,
  "light-inverted-info": Is,
  "inverted-error": $s,
  "inverted-info": _s,
  "inverted-invite": Vs,
  "inverted-success": As,
  "inverted-warning": Bs,
  invite: Hs,
  iu: Ds,
  "job-title-outlined": Ts,
  language: Rs,
  license: Ws,
  "license-outlined": Os,
  "license-activate": Fs,
  "license-activate-outlined": zs,
  "license-invalidate": Zs,
  "license-invalidate-outlined": Ps,
  "license-new": qs,
  "license-new-outlined": Us,
  "license-reset": Gs,
  "license-reset-outlined": Ks,
  "license-transfer": Ys,
  "license-transfer-outlined": Qs,
  link: Xs,
  "location-office": Js,
  lock: e5,
  mail: t5,
  maker: r5,
  menu: n5,
  "module-ia": o5,
  "module-other": a5,
  "module-avatar": i5,
  money: l5,
  more: s5,
  "note-outlined": c5,
  note: d5,
  open: u5,
  "open-small": p5,
  "open-small-inverted": m5,
  "order-outlined": h5,
  order: g5,
  "organization-inverse": C5,
  organization: v5,
  "organization-add": f5,
  "organization-add-outlined": x5,
  "organization-merge-outlined": b5,
  "organization-move-outlined": w5,
  "organization-remove-outlined": y5,
  people: j5,
  "people-outlined": k5,
  person: M5,
  "person-add": L5,
  "person-outlined": S5,
  "person-leave": E5,
  "person-pending": N5,
  "person-public": I5,
  "person-public-outlined": $5,
  "phone-outlined": _5,
  placeholder: V5,
  plus: A5,
  quote: H5,
  "quote-outlined": B5,
  "rename-outlined": D5,
  "resend-mail": T5,
  "role-add": R5,
  "role-add-outlined": F5,
  "role-default": W5,
  "role-ia": Z5,
  "role-ia-outlined": z5,
  "role-lock": K5,
  role: P5,
  "role-outlined": q5,
  school: U5,
  "school-outlined": G5,
  "role-remove": O5,
  search: Y5,
  session: Q5,
  "settings-filled": X5,
  "settings-outlined": J5,
  "settings-small": e3,
  signout: t3,
  "small-caret": r3,
  sort: n3,
  "specialization-enterprise-integrator": o3,
  "specialization-iiot": a3,
  "specialization-mes-integrator": i3,
  star: l3,
  "star-outlined": s3,
  success: c3,
  support: d3,
  "support-outlined": u3,
  "support-plan-basic": p3,
  "support-plan-total": m3,
  "support-plan-priority": h3,
  test: g3,
  testimonial: C3,
  "test-outlined": v3,
  "toggle-off-outlined": f3,
  "toggle-on-outlined": x3,
  token: b3,
  verified: w3,
  visibility: y3,
  warning: k3,
  "course-placeholder": Oi,
  "course-databases": Zi,
  "course-ignition-basics": Pi,
  "course-ignition-designer": qi,
  "course-ignition-gateway": Ui,
  "course-opc-ua-and-devices": Gi,
  "course-building-in-perspective": Ki,
  "course-design-fundamentals": Yi,
  "course-ia-101": Qi,
  "course-software-tutorials": Xi,
  "course-advanced-styling-in-perspective": Ji,
  "course-ignition-with-docker": el
}, te = ({
  name: e,
  className: t,
  width: n,
  height: o,
  style: a,
  alt: i = e
}) => {
  const l = Z1(e);
  return /* @__PURE__ */ r.jsx(
    l,
    {
      className: t,
      style: {
        ...a,
        width: n ?? o,
        height: o ?? n
      },
      title: i
    }
  );
}, Z1 = (e) => Yt[e] ? Yt[e] : Yt.placeholder, j3 = R()(
  (e, { disabled: t }) => ({
    // Mirrors the SwitchCard surface (white, neutral[30] border, 4px radius, 1.5rem
    // padding) so the card reads as the same family as the toggle cards. border-box
    // keeps the padding inclusive of any explicit sizing. Children stack in a
    // column: the copy/button row, then any optional bottom content.
    card: {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      background: e.palette.neutral.white,
      padding: "1.5rem",
      border: `1px solid ${e.palette.neutral[30]}`,
      borderRadius: "4px",
      // An interactive card shows the pointer (hand) cursor and moderately
      // darkens its border on hover, matching the neutral[40] hover border on
      // the radio/switch cards. Hovering the card also puts the button in its
      // hover state, casting the shared basic-hover shadow (theme.hover.basic),
      // so the whole surface reads as one hoverable target. A disabled (no-href)
      // card is inert, so it keeps its resting border and default cursor.
      ...t ? {} : {
        cursor: "pointer",
        "&:hover": {
          borderColor: e.palette.neutral[40],
          "& .MuiButton-root": {
            boxShadow: e.hover.basic
          }
        },
        // Pressing the card deepens the hover cues: the border darkens
        // further to neutral[50] (as on the radio/switch cards' :active) and
        // the button takes its own pressed background (primary[70], #3B738A),
        // keeping the shared basic-hover shadow.
        "&:active": {
          borderColor: e.palette.neutral[50],
          "& .MuiButton-root": {
            backgroundColor: e.palette.primary[70],
            boxShadow: e.hover.basic
          }
        },
        // Keyboard-focus mirrors the sibling cards: the ring is drawn by the
        // button's own :focus-visible (primary[60-key] outline + basic-hover
        // shadow), and — like the SwitchCard — the card border darkens to
        // neutral[50]. Gating on the button's :focus-visible keeps this
        // keyboard-only, matching how the other cards use :focus-visible.
        "&:has(.MuiButton-root:focus-visible)": {
          borderColor: e.palette.neutral[50]
        }
      }
    },
    // The copy column and the button sit in a row; the 1rem (16px) gap is the
    // minimum space between them.
    mainRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "1rem"
    },
    // The copy column holds the label, description, and helper text stacked
    // vertically. flex: 1 + min-width: 0 lets long copy wrap and grow downward
    // within this column, so it never runs past the 16px gap into the button.
    copyContainer: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minWidth: 0
    },
    // Keeps the label and its trailing icon together so the icon sits directly
    // after the label text.
    labelGroup: {
      display: "flex",
      alignItems: "center",
      gap: "0.5rem"
    },
    label: {
      ...e.typography.h3,
      color: e.palette.neutral[80]
    },
    labelIcon: {
      display: "block",
      flexShrink: 0,
      width: "1.25rem",
      height: "1.25rem"
    },
    // When disabled the card is inert, so the label drops to the disabled text
    // color to match the disabled button.
    labelDisabled: {
      color: e.palette.text.disabled
    },
    description: {
      ...e.typography.body2,
      marginTop: "0.25rem"
    },
    helperMessage: {
      ...Re(e),
      marginTop: "0.25rem"
    },
    // Dims the description/helper text when the card is disabled, matching the
    // radio/checkbox/switch cards.
    disabledExtraInfo: {
      opacity: 0.4
    },
    // Keeps the button at its natural size. The button (2rem) is taller than the
    // label line (h3, 1.25rem); the symmetric negative margins center it on that
    // first line — so the label text lines up with the button text — without
    // expanding the row, which keeps the label/description spacing intact.
    buttonContainer: {
      flexShrink: 0,
      marginTop: "-0.375rem",
      marginBottom: "-0.375rem"
    },
    // Optional bottom content, sitting a total of 1rem (16px) below the row above.
    content: {
      marginTop: "1rem"
    }
  })
), S3 = ({
  label: e,
  buttonLabel: t,
  href: n,
  description: o,
  helperMessage: a,
  labelIcon: i,
  endIcon: l,
  testId: c,
  className: d,
  children: u
}) => {
  const p = !n, { classes: m, cx: g } = j3({ disabled: p }), h = () => {
    p || window.open(n, "_blank", "noopener,noreferrer");
  };
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: g(m.card, d),
      onClick: p ? void 0 : h,
      children: [
        /* @__PURE__ */ r.jsxs("div", { className: m.mainRow, children: [
          /* @__PURE__ */ r.jsxs("div", { className: m.copyContainer, children: [
            /* @__PURE__ */ r.jsxs("div", { className: m.labelGroup, children: [
              /* @__PURE__ */ r.jsx(
                W,
                {
                  className: g(m.label, {
                    [m.labelDisabled]: p
                  }),
                  children: e
                }
              ),
              i && /* @__PURE__ */ r.jsx(
                te,
                {
                  name: i,
                  className: g(m.labelIcon, {
                    [m.disabledExtraInfo]: p
                  })
                }
              )
            ] }),
            o && /* @__PURE__ */ r.jsx(
              "div",
              {
                className: g(m.description, {
                  [m.disabledExtraInfo]: p
                }),
                children: o
              }
            ),
            a && /* @__PURE__ */ r.jsx(
              "div",
              {
                className: g(m.helperMessage, {
                  [m.disabledExtraInfo]: p
                }),
                children: a
              }
            )
          ] }),
          /* @__PURE__ */ r.jsx(
            "div",
            {
              className: m.buttonContainer,
              onClick: (C) => C.stopPropagation(),
              children: /* @__PURE__ */ r.jsx(
                St,
                {
                  buttonVariant: "primary",
                  disabled: p,
                  label: t,
                  href: n,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  endIcon: l,
                  testId: c
                }
              )
            }
          )
        ] }),
        u && // The bottom content may hold its own interactive elements (radios,
        // inputs, links). Stopping propagation here keeps clicks inside it from
        // bubbling up and opening the card's link.
        /* @__PURE__ */ r.jsx(
          "div",
          {
            className: m.content,
            onClick: (C) => C.stopPropagation(),
            children: u
          }
        )
      ]
    }
  );
}, L3 = (e) => {
  if (e.inputType === "link") {
    const t = o2(e, "inputType", "id");
    return /* @__PURE__ */ r.jsx(S3, { ...t });
  } else if (e.inputType === "checkbox") {
    const t = o2(e, "inputType");
    return /* @__PURE__ */ r.jsx(
      $i,
      {
        ...t,
        helperMessage: e.helperMessage ?? "",
        onValueChange: ({ id: n, value: o }) => e.onValueChange(n, o)
      }
    );
  } else return e.inputType === "radio" ? /* @__PURE__ */ r.jsx(
    Ti,
    {
      ...e,
      helperMessage: e.helperMessage ?? "",
      testId: e.testId ?? e.id,
      onValueChange: (t) => e.onValueChange(e.id, t)
    }
  ) : /* @__PURE__ */ r.jsx(
    Wi,
    {
      ...e,
      helperMessage: e.helperMessage ?? "",
      onChange: ({ id: t, value: n }) => e.onValueChange(t, n)
    }
  );
}, M3 = X.create(({ theme: e }) => ({
  label: {
    ...e.typography.label,
    color: e.palette.neutral[80],
    marginBottom: "0.75rem"
  },
  error: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    marginTop: "0.75rem"
  },
  helper: {
    ...Re(e),
    marginTop: "0.375rem"
  }
})), E3 = ({
  label: e,
  cards: t,
  errorMessage: n,
  helperMessage: o
}) => {
  const { classes: a } = M3();
  return /* @__PURE__ */ r.jsxs("div", { children: [
    e ? /* @__PURE__ */ r.jsx(W, { className: a.label, children: e }) : null,
    /* @__PURE__ */ r.jsx(Le, { gap: "0.5rem", children: t.map((i) => /* @__PURE__ */ r.jsx(L3, { ...i, testId: i.testId }, i.id)) }),
    n ? /* @__PURE__ */ r.jsx(W, { className: a.error, children: n }) : null,
    o ? /* @__PURE__ */ r.jsx(W, { className: a.helper, children: o }) : null
  ] });
}, N3 = R()((e) => ({
  groupOptionLabel: {
    ...e.typography.label,
    marginBottom: "0.125rem"
  },
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem"
  },
  helperMessage: {
    ...Re(e)
  },
  checkBoxContainer: {
    marginLeft: "-0.45rem",
    marginBottom: "-0.25rem"
  },
  extraInfo: {
    marginTop: "0.5rem"
  }
})), Qu = ({
  groupOptionLabel: e,
  items: t,
  errorMessage: n,
  helperMessage: o,
  onValueChange: a
}) => {
  const { classes: i } = N3();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("div", { className: i.groupOptionLabel, children: e }),
    t.map(
      ({ id: l, checked: c = !1, label: d, disabled: u, type: p, ...m }, g) => /* @__PURE__ */ r.jsx("div", { className: i.checkBoxContainer, children: /* @__PURE__ */ r.jsx(
        p1,
        {
          testId: `checkbox-group-item-${g}`,
          ...m,
          id: l,
          checked: c,
          label: d,
          disabled: u,
          type: p,
          onValueChange: a
        }
      ) }, l)
    ),
    /* @__PURE__ */ r.jsxs("div", { className: i.extraInfo, children: [
      n && /* @__PURE__ */ r.jsx("div", { className: i.errorMessage, children: n }),
      o && /* @__PURE__ */ r.jsx("div", { className: i.helperMessage, children: o })
    ] })
  ] });
}, I3 = R()((e) => ({
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem"
  },
  helperMessage: {
    ...Re(e)
  },
  extraInfo: {
    marginLeft: "2.25rem"
  },
  label: {
    ...e.typography.body1
  }
})), $3 = ({
  id: e,
  label: t,
  checked: n = !1,
  disabled: o,
  type: a = "check",
  errorMessage: i,
  helperMessage: l,
  onValueChange: c,
  testId: d,
  ...u
}) => {
  const { classes: p } = I3();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ e1(
      p1,
      {
        testId: d,
        ...u,
        id: e,
        checked: n,
        label: t,
        disabled: o,
        key: e,
        type: a,
        onValueChange: c
      }
    ),
    /* @__PURE__ */ r.jsxs("div", { className: p.extraInfo, children: [
      i && /* @__PURE__ */ r.jsx("div", { className: p.errorMessage, children: i }),
      l && /* @__PURE__ */ r.jsx("div", { className: p.helperMessage, children: l })
    ] })
  ] });
}, m1 = R()((e) => ({
  basic: {
    ...e.typography.body2,
    border: `1px solid ${e.palette.neutral[30]}`,
    backgroundColor: e.palette.neutral.white,
    color: e.palette.neutral[80],
    cursor: "pointer",
    ".MuiChip-avatar": {
      marginLeft: "0.25rem"
    },
    "&:focus-visible": {
      outline: `1px solid ${e.palette.primary["60-key"]}`,
      backgroundColor: e.palette.neutral.white,
      borderColor: e.palette.neutral[40],
      outlineOffset: "0.063rem"
    },
    "&.Mui-focusVisible": {
      backgroundColor: e.palette.neutral.white,
      "&:has(.Mui-focusVisible)": {
        backgroundColor: e.palette.neutral.white
      }
    },
    "&:hover": {
      backgroundColor: e.palette.neutral.white,
      border: `1px solid ${e.palette.neutral[40]}`
    },
    "&:active": {
      boxShadow: "none"
    }
  },
  basicNonInteractable: {
    cursor: "default",
    "&:hover": {
      border: `1px solid ${e.palette.neutral[30]}`,
      backgroundColor: e.palette.neutral.white,
      color: e.palette.neutral[80]
    },
    "&:focus-visible": {
      outline: "none",
      border: `1px solid ${e.palette.neutral[30]}`,
      backgroundColor: e.palette.neutral.white
    },
    "&.Mui-focusVisible": {
      backgroundColor: e.palette.neutral.white
    }
  },
  disabled: {
    border: `1px solid ${e.palette.neutral[30]}`,
    backgroundColor: e.palette.neutral[20],
    color: e.palette.neutral[50],
    pointerEvents: "none",
    opacity: "1 !important"
  },
  avatarText: {
    background: e.palette.avatar[1],
    color: `${e.palette.neutral[10]} !important`
  },
  disabledOpacity: {
    opacity: 0.4,
    pointerEvents: "none"
  },
  input: {
    ...e.typography.body2,
    border: `1px solid ${e.palette.neutral[30]}`,
    backgroundColor: e.palette.neutral[10],
    height: "1.5rem",
    ".MuiChip-label": {
      paddingLeft: "0.5rem",
      paddingRight: "0.5rem"
    },
    ".MuiChip-avatar": {
      marginLeft: "0.125rem",
      marginRight: "-0.125rem",
      height: "1.25rem",
      width: "1.25rem"
    },
    "&:hover, &.Mui-focusVisible": {
      backgroundColor: e.palette.neutral[20],
      border: `1px solid ${e.palette.neutral[30]}`
    },
    "&:active": {
      boxShadow: "none"
    }
  },
  inputNonInteractable: {
    cursor: "default",
    "&:hover": {
      border: `1px solid ${e.palette.neutral[30]}`,
      backgroundColor: e.palette.neutral[10]
    }
  },
  small: {
    ...e.typography.caps,
    height: "1rem",
    padding: "0.188rem 0.25rem",
    border: "0 !important",
    ".MuiChip-label": {
      padding: "0rem",
      [e.breakpoints.down(480)]: {
        paddingTop: "2px"
      }
    }
  },
  smallNeutralLight: {
    backgroundColor: e.palette.neutral[20],
    color: e.palette.neutral[80]
  },
  smallNeutralDark: {
    backgroundColor: e.palette.neutral[80],
    color: e.palette.neutral.white
  },
  smallPrimaryLight: {
    backgroundColor: e.palette.primary[10],
    color: e.palette.primary["60-key"]
  },
  smallPrimaryDark: {
    backgroundColor: e.palette.primary["60-key"],
    color: e.palette.neutral.white
  },
  smallInfoLight: {
    backgroundColor: e.palette.info[10],
    color: e.palette.info["60-key"]
  },
  smallInfoDark: {
    backgroundColor: e.palette.info["60-key"],
    color: e.palette.neutral.white
  },
  smallSuccessLight: {
    backgroundColor: e.palette.success[10],
    color: e.palette.success["60-key"]
  },
  smallSuccessDark: {
    backgroundColor: e.palette.success["60-key"],
    color: e.palette.neutral.white
  },
  smallWarningLight: {
    backgroundColor: e.palette.warning[10],
    color: e.palette.warning["60-key"]
  },
  smallWarningDark: {
    backgroundColor: e.palette.warning["60-key"],
    color: e.palette.neutral.white
  },
  smallErrorLight: {
    backgroundColor: e.palette.error[10],
    color: e.palette.error["60-key"]
  },
  smallErrorDark: {
    backgroundColor: e.palette.error["60-key"],
    color: e.palette.neutral.white
  },
  smallNonInteractable: {
    cursor: "default"
  },
  filter: {
    height: "unset",
    padding: "0.25rem 0 0.25rem 0",
    ...e.typography.body2,
    border: `1px solid ${e.palette.neutral[30]}`,
    backgroundColor: "inherit",
    "&:hover": {
      border: `1px solid ${e.palette.neutral[40]}`,
      backgroundColor: "inherit"
    },
    "&:active": {
      border: `1px solid ${e.palette.neutral[40]}`,
      backgroundColor: e.palette.neutral[20],
      boxShadow: "none"
    },
    "&:focus-visible": {
      outline: `1px solid ${e.palette.primary["60-key"]}`,
      outlineOffset: "1px",
      backgroundColor: "inherit",
      border: `1px solid ${e.palette.neutral[40]}`
    }
  },
  selected: {
    backgroundColor: e.palette.primary["60-key"],
    // for keeping the height constant between selected/unselected
    border: `1px solid ${e.palette.primary["60-key"]}`,
    color: e.palette.neutral.white,
    "&:hover, &.Mui-focusVisible": {
      color: e.palette.neutral.white,
      border: `1px solid ${e.palette.primary[70]}`,
      backgroundColor: e.palette.primary[70]
    },
    "&:active": {
      color: e.palette.neutral.white,
      border: `1px solid ${e.palette.primary[80]}`,
      backgroundColor: e.palette.primary[80],
      boxShadow: "none"
    }
  },
  error: {
    backgroundColor: e.palette.error[10],
    border: `1px solid ${e.palette.error["60-key"]}`,
    color: e.palette.error["60-key"],
    "&:hover, &.Mui-focusVisible": {
      color: e.palette.error["60-key"],
      border: `1px solid ${e.palette.error["60-key"]}`,
      backgroundColor: e.palette.error[20]
    },
    button: {
      svg: {
        fill: `${e.palette.error["60-key"]} !important`
      }
    }
  },
  errorSelected: {
    backgroundColor: e.palette.error["60-key"],
    border: `1px solid ${e.palette.error["60-key"]}`,
    color: e.palette.neutral.white,
    "&:hover, &.Mui-focusVisible": {
      color: e.palette.neutral.white,
      border: `1px solid ${e.palette.error[70]}`,
      backgroundColor: e.palette.error[70]
    },
    button: {
      svg: {
        fill: `${e.palette.neutral.white} !important`
      }
    }
  },
  filterNonInteractable: {
    cursor: "default"
  },
  filterMenuNonInteractable: {
    cursor: "default"
  },
  filterMenu: {
    // TODO: Included here to exhaustively define the values for Typescript
  },
  status: {
    ...e.typography.body2,
    pointerEvents: "none"
  },
  statusNeutral: {
    backgroundColor: e.palette.neutral[20],
    color: e.palette.neutral[80]
  },
  statusPrimary: {
    backgroundColor: e.palette.primary[10],
    color: e.palette.primary["60-key"]
  },
  statusInfo: {
    backgroundColor: e.palette.info[10],
    color: e.palette.info["60-key"]
  },
  statusSuccess: {
    backgroundColor: e.palette.success[10],
    color: e.palette.success["60-key"]
  },
  statusWarning: {
    backgroundColor: e.palette.warning[10],
    color: e.palette.warning["60-key"]
  },
  statusError: {
    backgroundColor: e.palette.error[10],
    color: e.palette.error["60-key"]
  },
  statusNonInteractable: {
    cursor: "default"
  },
  badge: {
    height: "0.5rem",
    width: "0.5rem",
    borderRadius: "100%",
    marginRight: "0.313rem",
    verticalAlign: "0.0313rem"
  },
  badgeNeutral: {
    backgroundColor: e.palette.neutral[80]
  },
  badgePrimary: {
    backgroundColor: e.palette.primary["60-key"]
  },
  badgeInfo: {
    backgroundColor: e.palette.info["60-key"]
  },
  badgeSuccess: {
    backgroundColor: e.palette.success["60-key"]
  },
  badgeWarning: {
    backgroundColor: e.palette.warning["60-key"]
  },
  badgeError: {
    backgroundColor: e.palette.error["60-key"]
  },
  statusMenu: {
    ...e.typography.body2,
    backgroundColor: e.palette.neutral.white,
    border: `1px solid ${e.palette.neutral[30]}`,
    cursor: "pointer",
    "> .MuiChip-label": {
      paddingRight: "0.5rem"
    },
    "&:hover": {
      backgroundColor: e.palette.neutral.white,
      border: `1px solid ${e.palette.neutral[40]}`
    },
    "&:active": {
      backgroundColor: e.palette.neutral[20],
      border: `1px solid ${e.palette.neutral[40]}`
    },
    "&:focus-visible": {
      outlineOffset: "0.063rem",
      outline: `1px solid ${e.palette.primary["60-key"]}`,
      border: `1px solid ${e.palette.neutral[40]}`,
      backgroundColor: e.palette.neutral.white
    }
  },
  statusMenuNonInteractable: {
    cursor: "default"
  },
  labelNeutral: {
    color: e.palette.neutral[80]
  },
  labelPrimary: {
    color: e.palette.primary["60-key"]
  },
  labelInfo: {
    color: e.palette.info["60-key"]
  },
  labelSuccess: {
    color: e.palette.success["60-key"]
  },
  labelWarning: {
    color: e.palette.warning["60-key"]
  },
  labelError: {
    color: e.palette.error["60-key"]
  },
  caret: {
    verticalAlign: "-0.438rem",
    marginLeft: "0.375rem"
  },
  filterMenuCaret: {
    path: {
      fill: e.palette.neutral[80]
    }
  },
  filterMenuCaratDisabled: {
    path: {
      fill: e.palette.neutral[80],
      opacity: 0.4
    }
  },
  filterMenuCaretSelected: {
    path: {
      fill: e.palette.neutral.white
    }
  },
  deleteButtonLabelSpacing: {
    ".MuiChip-label": {
      paddingRight: "0.5rem"
    }
  },
  arraySpacing: {
    marginLeft: "0.25rem"
  },
  // Would/could have used disableRipple as a prop, but this would have eventually issues
  // see: https://github.com/mui/material-ui/issues/23041
  disableRipple: {
    ".MuiTouchRipple-root": {
      display: "none"
    }
  },
  smallNotificationBadge: {
    marginLeft: "-0.5rem"
  },
  mediumNotificationBadge: {
    marginTop: "-0.25rem",
    marginLeft: "-0.75rem"
  },
  largeNotificationBadge: {
    marginTop: "-0.25rem",
    marginLeft: "-0.75rem"
  },
  clearAllButton: {
    margin: "0.5rem"
  },
  filterMenuLabelSpacing: {
    paddingRight: "0"
  },
  menuListContainer: {
    position: "absolute"
  },
  filterMenuList: {
    position: "absolute",
    top: "1.25rem",
    minWidth: "12.5rem"
  },
  statusMenuList: {
    position: "absolute",
    top: "2.188rem"
  }
})), _3 = ({
  chipsArr: e,
  onClick: t,
  testId: n,
  onClearAll: o
}) => {
  const { cx: a, classes: i } = m1();
  return /* @__PURE__ */ r.jsx(Le, { alignItems: "center", "data-testid": n, direction: "row", children: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    e.map(({ id: l, label: c, selected: d, disabled: u }, p) => /* @__PURE__ */ r.jsx(
      u1,
      {
        "data-testid": `${n}-${p}`,
        label: c,
        className: a(i.filter, {
          [i.selected]: d && !u,
          [i.disabled]: u,
          [i.arraySpacing]: p != 0,
          [i.disableRipple]: !0
        }),
        onClick: () => t && t(l)
      },
      l
    )),
    e.length > 1 && /* @__PURE__ */ r.jsx(
      G,
      {
        className: i.clearAllButton,
        buttonVariant: "text",
        size: "small",
        label: "Clear All",
        onClick: o
      }
    )
  ] }) });
}, vr = `${x["neutral-80"]}0C`, V3 = `${x["neutral-80"]}19`, U1 = (e, t) => {
  if (!e) return "";
  const o = Math.floor(t * 255).toString(16);
  return o.length === 1 ? `${e}0${o}` : `${e}${o}`;
}, A3 = X.create(({ theme: e }) => ({
  base: {
    ...e.typography.button2,
    borderRadius: "50%",
    padding: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "-6px",
    marginRight: "0.25rem",
    "> svg": {
      fill: "currentcolor"
    },
    color: "inherit !important",
    // alpha % values to add to end of hex values
    // https://stackoverflow.com/a/8254129
    "&:hover, &:focus-visible": {
      backgroundColor: U1(x["primary-60-key"], 0.05)
    },
    "&:active": {
      backgroundColor: U1(x["primary-60-key"], 0.1)
    }
  },
  selected: {
    "> svg": {
      fill: e.palette.neutral.white
    }
  },
  inputChip: {
    marginRight: 0
  },
  disabled: {
    // This class overrides the default disabled styles for the Button component.
    color: "rgba(0, 0, 0, 0.26) !important",
    opacity: "1 !important"
  }
})), B3 = ({
  testId: e,
  disabled: t,
  error: n,
  selected: o,
  input: a = !1,
  onClick: i
}) => {
  const { translations: l } = Q(), { cx: c, classes: d } = A3(), { classes: u } = V1({});
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      title: l.common.delete,
      "data-testid": e,
      onClick: i,
      className: c(d.base, u.iconSmall, {
        [d.inputChip]: a,
        [d.disabled]: t,
        [d.selected]: o,
        [u.iconNeutral]: !n,
        [u.iconNeutralSelected]: !n && o,
        [u.iconDestructive]: n,
        [u.iconDestructiveSelected]: n && o
      }),
      children: /* @__PURE__ */ r.jsx(te, { name: "cross" })
    }
  );
}, H3 = ({
  chipsArr: e,
  onClick: t,
  onDelete: n,
  variant: o,
  className: a = "",
  testId: i
}) => {
  const { cx: l, classes: c } = m1(), d = ({
    avatarImg: u,
    avatarText: p,
    avatarIcon: m,
    disabled: g,
    selected: h,
    error: C
  }) => {
    if (u)
      return /* @__PURE__ */ r.jsx(
        ar,
        {
          className: l({ [c.disabledOpacity]: g }),
          alt: p,
          src: u
        }
      );
    if (p)
      return /* @__PURE__ */ r.jsx(
        ar,
        {
          className: l(c.avatarText, {
            [c.disabledOpacity]: g
          }),
          children: p
        }
      );
    if (m) {
      const v = h ? "inverse" : C ? "error" : "primary";
      return /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(
        we,
        {
          size: o === "basic" ? "small" : "tiny",
          icon: m,
          iconAvatarColor: v
        }
      ) });
    }
  };
  return /* @__PURE__ */ r.jsx(
    Le,
    {
      "data-testid": i,
      direction: "row",
      flexWrap: "wrap",
      rowGap: "0.5rem",
      columnGap: "0.25rem",
      children: e.map(
        ({
          id: u,
          label: p,
          avatarImg: m,
          avatarText: g,
          avatarIcon: h,
          disabled: C = !1,
          isRemovable: v = !1,
          showAvatar: b = !1,
          isInteractable: f = !1,
          selected: y = !1,
          error: w = !1
        }) => {
          const k = v && n, M = f || !!k, L = /* @__PURE__ */ r.jsx(
            B3,
            {
              testId: `${i}-${Pe(p)}-delete-button`,
              disabled: C,
              error: w,
              selected: y,
              input: o === "input",
              onClick: (j) => n == null ? void 0 : n(u, j)
            }
          );
          return /* @__PURE__ */ r.jsx(
            u1,
            {
              "data-testid": `${i}-${Pe(p)}`,
              avatar: b ? d({
                avatarImg: m,
                avatarText: g,
                avatarIcon: h,
                disabled: C,
                selected: y,
                error: w
              }) : void 0,
              label: p,
              disabled: C,
              className: l(
                c[o],
                {
                  [c.disabled]: C,
                  [c.deleteButtonLabelSpacing]: v,
                  [c[`${o}NonInteractable`]]: !M,
                  [c.disableRipple]: !0,
                  [c.selected]: o === "input" && y && !C,
                  [c.error]: w && !C,
                  [c.errorSelected]: w && y && !C
                },
                a
              ),
              onClick: t ? (j) => t(u, j) : void 0,
              deleteIcon: L,
              onDelete: k ? (j) => n(u, j) : void 0
            },
            u
          );
        }
      )
    }
  );
}, D3 = ({
  chipsArr: e,
  state: t = "neutral",
  style: n = "light",
  testId: o
}) => {
  const { cx: a, classes: i } = m1(), l = `small${Ze(t)}${Ze(n)}`;
  return /* @__PURE__ */ r.jsx(Le, { "data-testid": o, direction: "row", children: e.map(({ label: c, disabled: d }, u) => /* @__PURE__ */ r.jsx(
    u1,
    {
      "data-testid": `${o}-${u}`,
      label: c,
      className: a(i.small, i[l], {
        [i.disabled]: d,
        [i.arraySpacing]: u != 0,
        [i.disableRipple]: !0
      })
    },
    u
  )) });
}, T3 = ({
  chipsArr: e,
  state: t = "neutral",
  showBadge: n = !1,
  testId: o
}) => {
  const { cx: a, classes: i } = m1(), l = `status${Ze(t)}`, c = `badge${Ze(t)}`, d = (u) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    n && /* @__PURE__ */ r.jsx(
      Ur,
      {
        variant: "dot",
        className: a(i.badge, i[c])
      }
    ),
    /* @__PURE__ */ r.jsx("span", { children: u })
  ] });
  return /* @__PURE__ */ r.jsx(Le, { "data-testid": o, direction: "row", children: e.map(({ id: u, label: p, notification: m }, g) => /* @__PURE__ */ r.jsxs(qe.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      u1,
      {
        "data-testid": `${o}-${Pe(p)}`,
        label: d(p),
        className: a(i.status, i[l], {
          [i.arraySpacing]: g != 0,
          [i.disableRipple]: !0
        })
      }
    ),
    !!m && /* @__PURE__ */ r.jsx(
      et,
      {
        className: i[`${m.size}NotificationBadge`],
        type: "primary",
        style: "dark",
        ...m
      }
    )
  ] }, u)) });
}, R3 = ({
  chipsArr: e,
  state: t = "neutral",
  showBadge: n = !1,
  onClick: o,
  testId: a
}) => {
  const { cx: i, classes: l } = m1(), [c, d] = V(!1), u = `label${Ze(t)}`, p = `badge${Ze(t)}`, m = (g) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    n && /* @__PURE__ */ r.jsx(
      Ur,
      {
        variant: "dot",
        className: i(l.badge, l[p])
      }
    ),
    /* @__PURE__ */ r.jsx("span", { className: l[u], children: g }),
    /* @__PURE__ */ r.jsx(te, { name: "caret", className: l.caret })
  ] });
  return /* @__PURE__ */ r.jsx(Le, { "data-testid": a, direction: "row", children: e.map(({ id: g, label: h, listItems: C = [] }, v) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      u1,
      {
        "data-testid": `${a}-${v}`,
        label: m(h),
        className: i(l.statusMenu, {
          [l.arraySpacing]: v != 0,
          [l.disableRipple]: !0
        }),
        onClick: () => d(!c)
      },
      g
    ),
    c && /* @__PURE__ */ r.jsx("div", { className: l.menuListContainer, children: /* @__PURE__ */ r.jsx("div", { className: l.statusMenuList, children: /* @__PURE__ */ r.jsx(
      l1,
      {
        onSelection: ({ id: b }) => {
          d(!1), o == null || o(g, void 0, b);
        },
        items: C,
        itemComponent: Se
      }
    ) }) })
  ] })) });
}, Cn = async (e) => {
  try {
    await navigator.clipboard.writeText(e);
  } catch (t) {
    console.error(t.message);
  }
}, F3 = {
  date_and_time: "MMMM dd, yyyy • hh:mm aa z",
  date: "MMMM dd, yyyy",
  time: "hh:mm aa z",
  short_date: "MM/dd/yyyy"
}, j1 = (e, t = "short_date", n = "-") => {
  if (!e) return n;
  const o = typeof e == "string" ? new Date(e) : e;
  return Number.isNaN(o.getTime()) ? "" : Xe(o, F3[t]);
}, z3 = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
], Xu = (e) => {
  const t = ["CU", "IR", "KP", "SY"], n = z3.reduce((o, a) => {
    const i = e(a, { ns: "countries" });
    return i && !t.includes(a) && (o[i] = a), o;
  }, {});
  return Object.keys(n).sort().map((o) => ({
    label: o,
    value: n[o] ?? ""
  })).filter((o) => o.value);
}, W3 = (e) => {
  const t = e.stateOrProvince ? `${e.stateOrProvince}, ` : "", n = `${e.streetAddressLine1}, ${e.city}, ${t}${e.zipcodeOrPostalCode}, ${e.country}`;
  return e.recipientName ? e.recipientName + `
` + n : n;
}, O3 = (e) => {
  const t = e.stateOrProvince ? `${e.stateOrProvince} ` : "", n = [
    e.recipientName,
    e.streetAddressLine1,
    e.streetAddressLine2,
    `${e.city}, ${t}${e.zipcodeOrPostalCode}`,
    e.country
  ];
  return rt(n).join(`
`);
}, Ju = (e, t = "compact") => t === "compact" ? W3(e) : O3(e), ep = ({
  firstName: e,
  lastName: t,
  emailAddress: n
}) => e && t ? `${e} ${t}` : n || "", L2 = (e) => e.firstName && e.lastName ? `${e.firstName[0]}${e.lastName[0]}` : "primaryEmailAddress" in e ? e.primaryEmailAddress[0] : e.membershipEmail[0], tp = (e) => "addressLine1" in e ? {
  ...e,
  streetAddressLine1: e.addressLine1,
  streetAddressLine2: e.addressLine2 || "",
  stateOrProvince: e.stateProvince,
  zipcodeOrPostalCode: e.postalCode || "",
  country: e.countryCode || e.country || ""
} : {
  ...e,
  streetAddressLine2: e.streetAddressLine2 || ""
}, A1 = (e, t) => e.includes(t) ? e.filter((o) => o !== t) : [...e, t], rp = (e, t, n) => n ? [...e, t] : e.filter((o) => o !== t), np = (e) => /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(e), op = (e) => e.replace(/https?:\/\/www\./, ""), ap = (e) => e.endsWith("/") ? e.slice(0, -1) : e, vn = (e) => !!(e && !e.includes("s.gravatar.com/avatar/")), ip = (e) => {
  const t = da(e);
  return {
    accountId: t["https://data.ia.io/ia_acct_uuid"],
    isSso: t["https://data.ia.io/isSso"],
    crmContactId: t["https://data.ia.io/crm_contact_id"] ?? ""
  };
}, lp = (e, t) => ({
  id: e.id,
  firstName: e.firstName,
  lastName: e.lastName,
  primaryEmailAddress: e.primaryEmailAddress,
  // 3/26/2025 - TODO: This should be handled by the backend. Consult note on canUseAvatarUrl
  // anything we create will come from AWS
  avatarUrl: vn(e.avatarUrl) ? e.avatarUrl : "",
  claims: t
}), fn = (e) => !!(Array.isArray(e) && e.every((t) => typeof t == "string")), Z3 = (e) => typeof e == "string", G1 = (e) => e ? "from" in e : !1, ut = "150ms", xn = 1199, M2 = 1199, E2 = 1999, bn = 2e3, N2 = 2e3, wn = 2001, yn = 2002, kn = 2100, I2 = 2101, jn = 2200, Sn = 3e3, sp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  APP_BAR_Z_INDEX: M2,
  BACKDROP_Z_INDEX: E2,
  BOTTOM_DRAWER_Z_INDEX: kn,
  DATA_GRID_HEADER_Z_INDEX: xn,
  DIALOG_Z_INDEX: N2,
  ENVIRONMENT_BANNER_Z_INDEX: Sn,
  POPUP_MENU_Z_INDEX: I2,
  SNACKBAR_Z_INDEX: yn,
  STACKED_BACKDROP_Z_INDEX: bn,
  STACKED_DIALOG_Z_INDEX: wn,
  TOOLTIP_Z_INDEX: jn
}, Symbol.toStringTag, { value: "Module" })), P3 = (e, t) => Gr(o2(e, ["id", "recipientName"])).some(
  (o) => o == null ? void 0 : o.toLowerCase().includes(t.toLowerCase())
), q3 = (e, t) => {
  const n = [
    e.firstName,
    e.lastName,
    e.primaryEmailAddress
  ], o = t.toLowerCase();
  return n.some((a) => a.toLowerCase().includes(o));
}, cp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addressMatches: P3,
  personMatches: q3
}, Symbol.toStringTag, { value: "Module" })), $2 = (e) => Math.floor(Math.random() * e), dp = (e = 4) => {
  const o = () => $2(42) + 48, a = () => String.fromCharCode(o());
  return Array.from({ length: e }, a).join("");
}, U3 = 50, G3 = 100, up = (e, t = { behavior: {} }) => {
  const {
    initial: n = void 0,
    margin: o = "smooth"
  } = t.behavior ?? {};
  setTimeout(() => {
    var i;
    const a = n ? { behavior: n } : {};
    (i = document.querySelector(e)) == null || i.scrollIntoView(a);
  }, U3), setTimeout(() => {
    const a = document.querySelector("#review-container"), i = a == null ? void 0 : a.parentElement, l = i == null ? void 0 : i.parentElement;
    l == null || l.scrollBy({ top: -24, behavior: o });
  }, G3);
}, K3 = (e, t) => e.findIndex((o) => o.id === t.id) === e.length - 1, E1 = (e) => {
  const t = [];
  return e && e.forEach((n) => {
    const o = K3(e, n), a = !!o;
    t.push([a]);
    const i = o ? null : !1, c = E1(n.childItems).map((d) => [i, ...d]);
    c.length > 0 && c.forEach((d) => t.push(d));
  }), t;
}, Y3 = (e, t) => {
  if (t === 0) return !0;
  const n = e[t], o = e[t - 1];
  return !o || !n ? !1 : o.length < n.length;
};
function B1(e) {
  return e.flatMap((t) => Ln(t));
}
function Ln(e, t) {
  let n = [{ ...e, parentId: t }];
  return e.childItems.forEach((o) => {
    const a = Ln(
      o,
      e.id
    );
    n = n.concat(a);
  }), n;
}
function Q3(e, t) {
  const n = [];
  function o(a, i, l) {
    const c = i.find((d) => d.id === a);
    c && (l || n.push(c), c.childItems.forEach((d) => {
      o(d.id, i, !1);
    }));
  }
  return o(e, t, !0), n;
}
const Mn = (e) => {
  const t = [...e];
  return t.shift(), t;
}, X3 = {
  csv: "text/csv;charset=utf8;",
  plaintext: "text/plain"
}, En = ({
  data: e,
  filename: t,
  kind: n = "plaintext"
}) => {
  const o = e instanceof Blob ? e : new Blob([e], { type: X3[n] }), a = URL.createObjectURL(o), i = document.createElement("a");
  i.setAttribute("href", a), i.setAttribute("download", t), i.style.visibility = "hidden", document.body.appendChild(i), i.click(), document.body.removeChild(i), URL.revokeObjectURL(a);
}, J3 = () => CSS.supports("grid-template-columns", "subgrid"), e4 = 73, t4 = 10 ** 9 + 9, _2 = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    t += e.charCodeAt(n) * e4 ** n;
  return t % t4;
}, P1 = (e) => e * 16, r4 = (e) => ({
  paddingTop: P1(e.top),
  paddingRight: P1(e.right),
  paddingBottom: P1(e.bottom),
  paddingLeft: P1(e.left)
}), fr = (e, t) => e instanceof SVGElement ? !1 : e.className.includes(t), Nn = (e, t) => {
  if (!e || !t || fr(e, "os-size-observer") || fr(e, "os-scrollbar-handle"))
    return !1;
  if (e.clientHeight > t.clientHeight || e.clientWidth > t.clientWidth) return !0;
  for (let o = 0; o < e.children.length; o++)
    if (Nn(e.children[o] ?? null, t))
      return !0;
  return !1;
}, n4 = () => {
  const e = document.createElement("iframe");
  return e.setAttribute(
    "src",
    "https://www.googletagmanager.com/ns.html?id=GTM-WFQ6ZBN4"
  ), e.setAttribute("height", "0"), e.setAttribute("width", "0"), e.style.display = "none", e.style.visibility = "hidden", e;
}, pp = () => {
  var a;
  const e = document.createElement("script");
  e.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-WFQ6ZBN4');`, (a = document.getElementsByTagName("head")[0]) == null || a.appendChild(e);
  const t = document.createElement("noscript"), n = n4();
  t.appendChild(n);
  const o = document.getElementsByTagName("body")[0];
  o == null || o.after(t);
}, o4 = [
  {
    name: "apple-touch-icon.png",
    size: "180x180",
    rel: "apple-touch-icon"
  },
  {
    name: "favicon-32x32.png",
    size: "32x32",
    rel: "icon"
  },
  {
    name: "favicon-194x194.png",
    size: "194x194",
    rel: "icon"
  },
  {
    name: "android-chrome-192x192.png",
    size: "192x192",
    rel: "icon"
  },
  {
    name: "favicon-16x16.png",
    size: "16x16",
    rel: "icon"
  }
], mp = (e) => {
  o4.forEach(({ name: t, size: n, rel: o }) => {
    var i;
    const a = document.createElement("link");
    a.setAttribute("rel", o), a.setAttribute("type", "image/png"), a.setAttribute("sizes", n), a.href = `${e}img/favicons/${t}`, (i = document.getElementsByTagName("head")[0]) == null || i.appendChild(a);
  });
}, a4 = ({
  listItems: e,
  listType: t = "basic",
  hideFooter: n = !1,
  onClose: o,
  onSelection: a
}) => {
  const i = e.filter((u) => u.selected).map((u) => u.id), l = ({ id: u }) => {
    if (t === "advanced") {
      const p = A1(i, u);
      a(p);
    } else
      a(u);
  }, c = () => t === "basic" ? e : e.map((u) => ({
    ...u,
    selected: i.includes(u.id)
  })), d = () => {
    if (!(t === "basic" || n))
      return {
        kind: "button",
        props: {
          onFooterDone: () => {
            o(), a(i);
          },
          onFooterClearAll: () => {
            a([]);
          }
        }
      };
  };
  return /* @__PURE__ */ r.jsx(
    Ie,
    {
      lists: [
        {
          onSelection: l,
          items: c(),
          itemComponent: Se
        }
      ],
      footerProps: d()
    }
  );
}, i4 = ({
  chipsArr: e,
  onClick: t,
  testId: n,
  onClearAll: o
}) => {
  const { cx: a, classes: i } = m1(), [l, c] = V(null), [d, u] = V(null), p = Ve(), m = $e(
    p.breakpoints.down(_1)
  ), g = (h, C = !1, v = !1) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("span", { className: i.filterMenuLabelSpacing, children: h }),
    /* @__PURE__ */ r.jsx(
      te,
      {
        name: "caret",
        className: a(i.caret, {
          [i.filterMenuCaretSelected]: C,
          [i.filterMenuCaret]: !C,
          [i.filterMenuCaratDisabled]: v
        })
      }
    )
  ] });
  return /* @__PURE__ */ r.jsx(Le, { alignItems: "center", "data-testid": n, direction: "row", children: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    e.map(
      ({ id: h, label: C, selected: v, disabled: b, listType: f, listItems: y = [] }, w) => /* @__PURE__ */ r.jsxs(qe.Fragment, { children: [
        /* @__PURE__ */ r.jsx(
          u1,
          {
            "data-testid": `${n}-${w}`,
            label: g(C, v, b),
            className: a(i.filter, {
              [i.selected]: v && !b,
              [i.disabled]: b,
              [i.arraySpacing]: w != 0,
              [i.disableRipple]: !0
            }),
            onClick: (k) => {
              y.length > 0 ? l ? c(null) : (c(k.currentTarget), u(h), k.type === "keydown" && setTimeout(() => {
                const L = document.querySelector('.MuiPopover-root [data-list="true"] button:first-of-type');
                L == null || L.focus();
              }, 200)) : t == null || t(h, k);
            }
          },
          h
        ),
        /* @__PURE__ */ r.jsx(
          ze,
          {
            anchor: l,
            open: h === d && !!l,
            onClose: () => {
              c(null);
            },
            leftAligned: !0,
            bottomDrawerProps: f === "advanced" ? {
              variant: "modal",
              contentSpacing: "fullWidth",
              footerProps: {
                kind: "button",
                props: {
                  onFooterDone: () => {
                    c(null);
                  },
                  onFooterClearAll: () => {
                    t == null || t(h, void 0, []);
                  }
                }
              }
            } : void 0,
            children: /* @__PURE__ */ r.jsx(
              a4,
              {
                listItems: y,
                listType: f,
                hideFooter: m,
                onClose: () => c(null),
                onSelection: (k) => {
                  t == null || t(h, void 0, k);
                }
              }
            )
          }
        )
      ] }, h)
    ),
    e.length > 1 && !!o && /* @__PURE__ */ r.jsx(
      G,
      {
        className: i.clearAllButton,
        buttonVariant: "text",
        size: "small",
        label: "Clear All",
        onClick: o
      }
    )
  ] }) });
}, _e = ({
  items: e,
  variant: t,
  style: n,
  state: o = "neutral",
  onDelete: a,
  onClick: i,
  showBadge: l = !1,
  ...c
}) => {
  const d = Array.isArray(e) ? e : [e];
  return t === "filter" ? /* @__PURE__ */ r.jsx(_3, { ...c, chipsArr: d, onClick: i }) : t === "filterMenu" ? /* @__PURE__ */ r.jsx(i4, { ...c, chipsArr: d, onClick: i }) : t === "small" ? /* @__PURE__ */ r.jsx(
    D3,
    {
      ...c,
      chipsArr: d,
      style: n,
      state: o
    }
  ) : t === "status" ? /* @__PURE__ */ r.jsx(
    T3,
    {
      ...c,
      state: o,
      chipsArr: d,
      showBadge: l
    }
  ) : t === "statusMenu" ? /* @__PURE__ */ r.jsx(
    R3,
    {
      ...c,
      state: o,
      chipsArr: d,
      showBadge: l,
      onClick: i
    }
  ) : /* @__PURE__ */ r.jsx(
    H3,
    {
      ...c,
      chipsArr: d,
      onClick: i,
      onDelete: a,
      variant: t
    }
  );
}, l4 = ({
  testId: e,
  state: t = "neutral",
  label: n,
  notification: o
}) => /* @__PURE__ */ r.jsx(
  _e,
  {
    testId: `${e}-container`,
    state: t,
    items: [
      {
        id: e,
        label: n,
        notification: o
      }
    ],
    variant: "status"
  }
), hp = (e) => ["EXPIRES_SOON", "INVALID"].includes(e) ? "warning" : e === "EXPIRED" ? "error" : [
  "IN_PROGRESS",
  "IN_PROGRESS_WITH_TRAINING",
  "IN_PROGRESS_FAILED_PENDING_RETRY",
  "UPDATE_AVAILABLE"
].includes(e) ? "info" : "neutral", s4 = {
  withinDrawer: !1
}, In = nt(s4), H1 = () => $1(In), V2 = ({
  withinDrawer: e,
  drawerVariant: t,
  children: n
}) => /* @__PURE__ */ r.jsx(In, { value: { withinDrawer: e, drawerVariant: t }, children: n }), c4 = R()((e, { showingCalendar: t, pickerHeight: n }) => ({
  rootWithinDrawer: {
    // This prevents the fixed-positioned footer buttons from overlapping the date picker content.
    paddingBottom: "2.5rem"
  },
  calendarRoot: {
    margin: "0.5rem 1rem 1rem 1rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ...t ? {} : { marginBottom: 0 }
  },
  calendarMonth: {
    position: "relative",
    width: "100%"
  },
  calendarTable: {
    margin: "1rem 0 0 0",
    borderCollapse: "collapse",
    ...t ? {} : {
      margin: "0 0 0 0",
      height: `${n}px`,
      width: "100%"
    }
  },
  calendarCell: {
    width: "2.5rem",
    height: "2.5rem",
    padding: "0 0 0.25rem 0"
  },
  weekdayHeader: {
    width: "2.5rem",
    padding: "0.5rem",
    ...e.typography.body1,
    color: e.palette.neutral[70],
    display: "grid",
    placeItems: "center"
  }
})), A2 = R()((e, t, n) => ({
  dayButton: {
    position: "relative",
    zIndex: 10,
    width: "2.5rem",
    height: "2.5rem",
    borderRadius: "2rem",
    ...e.typography.body1,
    backgroundColor: "transparent",
    borderColor: "transparent",
    color: "inherit",
    cursor: "pointer",
    // These styles counter the shifting of the text that occurs when adding a 1px border to the div that wraps
    // this button (div.day).
    top: -1,
    left: -1,
    "&:focus": {
      outline: 0
    }
  },
  day: {
    width: "2.5rem",
    height: "2.5rem",
    border: "1px solid transparent",
    borderRadius: "2rem",
    boxSizing: "border-box",
    margin: "auto",
    position: "relative",
    zIndex: 10,
    "&:hover": {
      backgroundColor: e.palette.neutral[10],
      border: `1px solid ${e.palette.neutral[70]}`,
      outline: 0
    },
    "&:focus, &:focus-visible": {
      border: `1px solid ${e.palette.neutral[70]}`,
      outline: 0
    },
    "&:active:hover": {
      backgroundColor: e.palette.neutral[30],
      border: `1px solid ${e.palette.neutral[70]}`,
      color: e.palette.neutral[80]
    },
    ":has(:focus)": {
      backgroundColor: e.palette.neutral[10],
      border: `1px solid ${e.palette.neutral[70]}`
    }
  },
  // dayForRangePicker: {
  //   "&:active:hover": {
  //     backgroundColor: theme.palette.primary[80],
  //   },
  // },
  dayDisabled: {
    color: e.palette.neutral[70],
    "&:hover": {
      border: `1px solid ${e.palette.neutral[40]}`,
      color: e.palette.neutral[70],
      opacity: 1
    }
  },
  daySelected: {
    color: e.palette.neutral.white,
    "&:hover, &:focus, &:focus-visible": {
      backgroundColor: `${e.palette.primary[70]}`,
      border: "1px solid transparent",
      borderRadius: "2rem",
      color: e.palette.neutral.white
    },
    "&:focus, &:focus-visible": {
      border: `1px solid ${e.palette.neutral[70]}`,
      outline: 0
    },
    "&&:active": {
      backgroundColor: `${e.palette.primary[80]}`,
      border: "1px solid transparent",
      color: e.palette.neutral.white
    },
    ":has(:focus)": {
      border: "1px solid transparent",
      backgroundColor: e.palette.primary[70]
    }
  },
  singleModeDaySelected: {
    backgroundColor: e.palette.primary["60-key"],
    borderRadius: "2rem",
    color: e.palette.neutral.white
  },
  dayOutsideMonth: {
    color: e.palette.neutral[70],
    ":hover": {
      backgroundColor: e.palette.neutral[10]
    },
    [`&.${n.daySelected}`]: {
      color: `${x["neutral-white"]}80`
    },
    [`&.${n.daySelected}:hover`]: {
      backgroundColor: e.palette.primary[70],
      color: e.palette.primary[60]
    },
    [`&.${n.daySelected}:active:hover`]: {
      backgroundColor: e.palette.primary[80],
      color: `${x["neutral-white"]}80`
    }
  },
  dayToday: {
    backgroundColor: e.palette.neutral[30],
    borderRadius: "2rem",
    color: e.palette.neutral[80],
    fontWeight: 400,
    [`&.${n.daySelected}`]: {
      backgroundColor: e.palette.primary[70],
      color: e.palette.neutral.white
    },
    "&:hover": {
      backgroundColor: e.palette.neutral[30],
      border: `1px solid ${e.palette.neutral[70]}`,
      color: e.palette.neutral[80]
    },
    "&:focus, &:focus-visible": {
      border: `1px solid ${e.palette.neutral[70]}`
    }
  }
})), d4 = R()((e) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
    height: "2.5rem",
    width: 294
  },
  buttonGroup: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    flex: "1 0 0",
    width: "7.75rem",
    minWidth: "7.75rem"
  },
  smallIconButton: {
    "> svg": {
      height: "24px !important",
      width: "24px !important"
    }
  },
  hiddenButton: {
    visibility: "hidden"
  },
  listButton: {
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: "0.5rem",
    height: "100%",
    "&:hover": {
      textDecoration: "none",
      svg: {
        fill: e.palette.neutral[80]
      }
    },
    "&:disabled p": {
      color: "inherit"
    }
  },
  listButtonText: {
    ...e.typography.body2,
    minWidth: "2rem",
    width: "2rem"
  },
  caret: {
    fill: e.palette.neutral[50],
    width: "1.5rem",
    height: "1.5rem"
  },
  caretActive: {
    fill: e.palette.neutral[80]
  },
  caretHidden: {
    visibility: "hidden"
  },
  leftButton: {
    transform: "rotate(90deg)"
  },
  rightButton: {
    transform: "rotate(270deg)"
  },
  divider: {
    marginLeft: "-1rem",
    marginRight: "-1rem"
  }
})), $n = R()(
  (e, { height: t }) => ({
    container: {
      height: t,
      marginLeft: "-1rem",
      marginRight: "-1rem"
    },
    listContainer: {
      maxHeight: "100%",
      borderRadius: 0
    }
  })
), u4 = R()((e) => ({
  selection: {
    position: "absolute",
    height: "2.5rem",
    backgroundColor: e.palette.primary["60-key"],
    borderRadius: "2rem",
    pointerEvents: "none"
  },
  hovered: {
    position: "absolute",
    height: "2.5rem",
    backgroundColor: e.palette.neutral[10],
    borderWidth: "2px",
    borderStyle: "dashed",
    borderColor: e.palette.neutral[50],
    borderRadius: "2rem",
    pointerEvents: "none"
  }
})), p4 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], m4 = ({ height: e, value: t, onSelection: n }) => {
  const { classes: o } = $n({ height: e }), a = p4.map((i) => ({
    id: `${i}`,
    testId: `month-${i + 1}`,
    label: Xe(Kr(t, i), "MMMM"),
    selected: y2(t) === i
  }));
  return /* @__PURE__ */ r.jsx(ue, { className: o.container, children: /* @__PURE__ */ r.jsx(
    l1,
    {
      items: a,
      itemComponent: Se,
      onSelection: n,
      containerClassName: o.listContainer
    }
  ) });
}, h4 = 9, g4 = 0, C4 = ({ height: e, value: t, onSelection: n, fromDate: o, toDate: a }) => {
  const { classes: i } = $n({ height: e }), l = dt(/* @__PURE__ */ new Date()), c = o ? dt(o) : l - h4, d = a ? dt(a) : l + g4, u = [];
  for (let p = d; p >= c; p--)
    u.push({
      id: `${p}`,
      testId: `year-${p}`,
      label: `${p}`,
      selected: dt(t) === p
    });
  return /* @__PURE__ */ r.jsx(ue, { className: i.container, children: /* @__PURE__ */ r.jsx(
    l1,
    {
      items: u,
      itemComponent: Se,
      onSelection: n,
      containerClassName: i.listContainer
    }
  ) });
}, xr = ({
  currentMonth: e,
  view: t,
  onSelectYear: n,
  onSelectMonth: o
}) => {
  const { select: a, goToMonth: i } = ua(), l = (p, m) => {
    a == null || a(p, {}, m), i(p);
  }, { cx: c, classes: d } = d4(), { translations: u } = Q();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: d.root, children: [
      /* @__PURE__ */ r.jsxs("div", { className: d.buttonGroup, children: [
        /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "icon",
            iconVariant: "neutral",
            icon: "chevron-thick",
            className: c(d.leftButton, d.smallIconButton, {
              [d.hiddenButton]: t !== "day"
            }),
            title: u.date_picker.previous_month,
            testId: "date-picker-previous-month",
            onClick: () => i(pa(e, 1))
          }
        ),
        /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "menuTextBorderless",
            size: "small",
            className: d.listButton,
            onClick: () => o(),
            disabled: t === "year",
            title: u.date_picker.select_month,
            testId: "date-picker-select-month",
            children: /* @__PURE__ */ r.jsx(W, { className: d.listButtonText, children: Xe(e, "MMM") })
          }
        ),
        /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "icon",
            iconVariant: "neutral",
            icon: "chevron-thick",
            className: c(d.rightButton, d.smallIconButton, {
              [d.hiddenButton]: t !== "day"
            }),
            title: u.date_picker.next_month,
            onClick: () => i(ma(e, 1)),
            testId: "date-picker-next-month"
          }
        )
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: d.buttonGroup, children: [
        /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "icon",
            iconVariant: "neutral",
            icon: "chevron-thick",
            className: c(d.leftButton, d.smallIconButton, {
              [d.hiddenButton]: t !== "day"
            }),
            title: u.date_picker.previous_year,
            onClick: (p) => l(ha(e, 1), p),
            testId: "date-picker-previous-year"
          }
        ),
        /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "menuTextBorderless",
            size: "small",
            className: d.listButton,
            onClick: () => n(),
            disabled: t === "month",
            title: u.date_picker.select_year,
            testId: "date-picker-select-year",
            children: /* @__PURE__ */ r.jsx(W, { className: d.listButtonText, children: Xe(e, "yyyy") })
          }
        ),
        /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "icon",
            iconVariant: "neutral",
            icon: "chevron-thick",
            className: c(d.rightButton, d.smallIconButton, {
              [d.hiddenButton]: t !== "day"
            }),
            title: u.date_picker.next_year,
            onClick: (p) => l(ga(e, 1), p),
            testId: "date-picker-next-year"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ r.jsx(Ce, { className: d.divider })
  ] });
}, v4 = (e) => e ? {
  startMonth: e,
  hidden: [{ before: e }]
} : {}, f4 = (e) => e ? {
  endMonth: e,
  hidden: [{ after: e }]
} : {}, _n = (e, t) => {
  var a, i;
  const n = v4(e), o = f4(t);
  return {
    startMonth: n.startMonth,
    endMonth: o.endMonth,
    hidden: rt([(a = n.hidden) == null ? void 0 : a[0], (i = o.hidden) == null ? void 0 : i[0]])
  };
}, x4 = ({
  id: e,
  classes: t,
  selected: n,
  month: o,
  onMonthChange: a,
  onSelect: i,
  fromDate: l,
  toDate: c,
  components: d
}) => {
  const { classes: u } = A2({});
  return /* @__PURE__ */ r.jsx(
    Yr,
    {
      id: e,
      mode: "single",
      classNames: {
        ...Qr,
        root: t.calendarRoot,
        month: t.calendarMonth,
        month_grid: t.calendarTable,
        day: t.calendarCell,
        day_button: u.dayButton
      },
      selected: n,
      month: o,
      onMonthChange: a,
      onSelect: i,
      ..._n(l, c),
      formatters: {
        formatWeekdayName: (p, m) => Xe(p, "EEEEE", m)
      },
      showOutsideDays: !0,
      hideNavigation: !0,
      components: d
    }
  );
}, Qt = (e, t) => {
  if (!e) return;
  const n = t[0];
  if (!n) return;
  const o = Xr(e, n);
  if (o >= 0 && o <= 6)
    return o;
}, bt = (e, t) => !e || !t[0] ? !1 : o1(e, t[0]) || Jr(e, t[0]), br = (e, t) => !e || !t[0] ? !1 : q1(e, t[0]), wt = (e, t) => {
  const n = e[e.length - 1];
  return !n || !t ? !1 : o1(n, t);
}, wr = (e, t, n, o) => e instanceof Date ? new Date(
  Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    t,
    n,
    o
  )
) : (console.error("Invalid date object passed to utcDate:", e), /* @__PURE__ */ new Date()), Lt = (e, t = !1) => {
  if (!(e instanceof Date)) {
    console.error("Invalid date object passed to withUTCComponents:", e);
    return;
  }
  return t ? wr(e, 23, 59, 59) : wr(e, 0, 0, 0);
}, b4 = (e, t) => {
  const n = e != null && e.from ? Lt(e.from) : void 0, o = e != null && e.to ? Lt(e.to, !0) : void 0;
  return !!n && !!o && bt(n, t) && wt(t, o);
}, w4 = (e, t, n) => {
  if (!t) return !1;
  const o = e != null && e.from ? Lt(e.from) : void 0, a = e != null && e.to ? Lt(e.to, !0) : void 0, i = !!o && bt(t, n) && wt(n, o), l = !!a && (bt(a, n) || br(a, n)) && wt(n, t), c = o && !a && (bt(o, n) || br(o, n)) && wt(n, t);
  return !!i || !!l || !!c;
}, Oe = 43, y4 = (e, t, n) => {
  if (!n && e !== void 0)
    return {
      left: e * Oe,
      right: (6 - e) * Oe
    };
  if (e === t && e !== void 0 && t !== void 0) {
    let o = e * Oe + 1, a = (6 - t) * Oe;
    return e == 0 && (o = 5), t == 6 && (a = 5), { left: o, right: a };
  }
  if (e !== void 0 || t !== void 0) {
    let o = e !== void 0 ? e * Oe : 0, a = t !== void 0 ? (6 - t) * Oe - 1 : 0;
    return e === 0 && (o = 1), t === 6 && (a = 1), e === void 0 && (o = 1), t === void 0 && (a = 1), e === void 0 && t === 0 && (o = 5), t === void 0 && e === 6 && (a = 5), { left: o, right: a };
  }
}, k4 = (e, t, n, o, a) => {
  if (e !== void 0 && t)
    return {
      left: e === 0 ? 1 : e * Oe,
      right: n !== void 0 ? n === 6 ? 5 : (6 - n) * Oe : 5
    };
  if (t && n && e === void 0)
    return {
      left: 5,
      right: (6 - n) * Oe
    };
  if (o && a && e === void 0)
    return {
      left: a * Oe,
      right: 0
    };
  if (o && n && a === void 0 && e === void 0)
    return {
      left: n * Oe,
      right: 5
    };
  if (e !== void 0 && o)
    return {
      left: n !== void 0 ? n * Oe : 5,
      right: e === 6 ? 5 : (6 - e) * Oe
    };
}, j4 = ({
  week: { days: e },
  selected: t,
  hoveredDate: n,
  ...o
}) => {
  const { classes: a } = u4(), i = e.map((f) => f.date), l = Qt(t == null ? void 0 : t.from, i), c = Qt(t == null ? void 0 : t.to, i), d = b4(t, i), u = Qt(n, i), p = n && (t == null ? void 0 : t.from) && o1(n, t.from), m = !!n && !!(t != null && t.to) && o1(t.to, n) || n && !(t != null && t.to) && (t == null ? void 0 : t.from) && o1(t.from, n), g = w4(t, n, i), h = k4(
    u,
    p,
    l,
    m,
    c
  ), C = y4(
    l,
    c,
    t == null ? void 0 : t.to
  ), v = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    h !== void 0 ? /* @__PURE__ */ r.jsx(
      "td",
      {
        className: a.hovered,
        style: {
          left: h.left,
          right: h.right
        }
      }
    ) : null,
    g ? /* @__PURE__ */ r.jsx("td", { className: a.hovered, style: { left: 1, right: 1 } }) : null
  ] }), b = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    C !== void 0 ? /* @__PURE__ */ r.jsx(
      "td",
      {
        className: a.selection,
        style: {
          left: C.left,
          right: C.right
        }
      }
    ) : null,
    d ? /* @__PURE__ */ r.jsx(
      "td",
      {
        className: a.selection,
        style: {
          left: 1,
          right: 1
        }
      }
    ) : null
  ] });
  return /* @__PURE__ */ r.jsxs("tr", { style: { position: "relative" }, ...o, children: [
    o.children,
    v,
    b
  ] });
}, Vn = ({
  day: e,
  modifiers: t,
  range: n,
  // Whether the day button is rendered in a range picker
  ...o
}) => {
  const a = Z(null), { cx: i, classes: l } = A2({}), c = `date-picker-${Xe(e.date, "MMM-dd").toLowerCase()}`;
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      className: i(l.day, {
        [l.daySelected]: t.selected,
        [l.singleModeDaySelected]: t.selected,
        [l.dayToday]: t.today,
        [l.dayDisabled]: t.disabled,
        [l.dayOutsideMonth]: t.outside
        //[classes.dayForRangePicker]: range,
      }),
      children: /* @__PURE__ */ r.jsx(
        "button",
        {
          "data-testid": c,
          name: "day",
          ref: a,
          ...o
        }
      )
    }
  );
}, S4 = ({
  id: e,
  classes: t,
  selected: n,
  month: o,
  onMonthChange: a,
  onSelect: i,
  fromDate: l,
  toDate: c,
  components: d,
  view: u
}) => {
  const [p, m] = V(), { classes: g } = A2({});
  return /* @__PURE__ */ r.jsx("div", { onMouseLeave: () => m(void 0), children: /* @__PURE__ */ r.jsx(
    Yr,
    {
      id: e,
      mode: "range",
      classNames: {
        ...Qr,
        root: t.calendarRoot,
        month: t.calendarMonth,
        month_grid: t.calendarTable,
        day: t.calendarCell,
        day_button: g.dayButton
      },
      selected: n,
      month: o,
      onMonthChange: a,
      onSelect: i,
      onDayMouseEnter: (h) => {
        (!p || Xr(h, p) !== 0) && m(h);
      },
      ..._n(l, c),
      formatters: {
        formatWeekdayName: (h, C) => Xe(h, "EEEEE", C)
      },
      showOutsideDays: !0,
      hideNavigation: !0,
      components: {
        ...d,
        Week: (h) => u === "day" ? /* @__PURE__ */ r.jsx(
          j4,
          {
            ...h,
            selected: n,
            hoveredDate: p
          }
        ) : /* @__PURE__ */ r.jsx(r.Fragment, {}),
        DayButton: (h) => /* @__PURE__ */ r.jsx(Vn, { ...h, range: !0 })
      }
    }
  ) });
}, L4 = 304, M4 = 16, E4 = 16, N4 = (e) => {
  const t = document.querySelector(`table#${e}-grid-0`);
  return t ? t.clientHeight + M4 + E4 : L4;
}, I4 = (e) => {
  if (!(!e || Object.keys(e).length === 0))
    return G1(e) ? e.from : e;
}, $4 = (e, t) => {
  const n = I4(t) ?? /* @__PURE__ */ new Date();
  return G1(e) ? e.from ?? n : e && a2(e) ? va(e, 1) : n;
}, yr = I0(
  ({
    testId: e,
    mode: t = "single",
    defaultValue: n,
    onChange: o,
    onSelect: a,
    onClear: i,
    fromDate: l,
    toDate: c
  }, d) => {
    const [u, p] = V("day"), m = N4(e), { withinDrawer: g } = H1(), { cx: h, classes: C } = c4({
      showingCalendar: u === "day",
      pickerHeight: m
    }), [v, b] = V(n), [f, y] = V(
      $4(n, v)
    ), w = () => p(u === "year" ? "day" : "year"), k = () => p(u === "month" ? "day" : "month"), M = /* @__PURE__ */ r.jsx(
      C4,
      {
        height: m,
        value: f,
        onSelection: ({ id: A }) => {
          y(ba(f, parseInt(A))), p("day");
        },
        fromDate: l,
        toDate: c
      }
    ), L = /* @__PURE__ */ r.jsx(
      m4,
      {
        height: m,
        value: f,
        onSelection: ({ id: A }) => {
          y(Kr(f, parseInt(A))), p("day");
        }
      }
    ), j = {
      MonthCaption: (A) => {
        const F = xr;
        return /* @__PURE__ */ r.jsx(
          F,
          {
            ...A,
            currentMonth: f,
            view: u,
            onSelectYear: w,
            onSelectMonth: k
          }
        );
      },
      Weekdays: (A) => u === "day" ? /* @__PURE__ */ r.jsx(fa, { ...A }) : /* @__PURE__ */ r.jsx("thead", { children: /* @__PURE__ */ r.jsx("tr", { children: /* @__PURE__ */ r.jsx("td", { colSpan: 7, style: { padding: 0 }, children: u === "month" ? L : M }) }) }),
      Week: (A) => u === "day" ? /* @__PURE__ */ r.jsx(xa, { ...A }) : /* @__PURE__ */ r.jsx(r.Fragment, {}),
      Weekday: (A) => {
        const { role: F, ...z } = A;
        return /* @__PURE__ */ r.jsx("td", { role: F, children: /* @__PURE__ */ r.jsx("div", { ...z, className: C.weekdayHeader }) });
      },
      DayButton: Vn
    }, N = {
      id: e,
      classes: C,
      month: a2(f) ? f : /* @__PURE__ */ new Date(),
      onMonthChange: y,
      components: j
    }, $ = G1(v) && v.from && v.to && Ca(v.from, v.to) ? { from: v.to, to: v.from } : v, S = Te(() => {
      b(void 0), i();
    }, [b, i]), _ = Te(() => {
      v ? v instanceof Date ? o(v) : o(v.from, v.to) : o();
    }, [v, o]), B = {
      anySelected: !!v,
      onFooterClearAll: S,
      onFooterDone: _
    };
    k2(d, () => ({
      clear: S,
      done: _
    }), [S, _]);
    const O = (A) => {
      a == null || a(A), b(A);
    };
    return /* @__PURE__ */ r.jsxs(
      "div",
      {
        "data-testid": e,
        className: h({
          [C.rootWithinDrawer]: g
        }),
        children: [
          t === "single" ? /* @__PURE__ */ r.jsx(
            x4,
            {
              ...N,
              mode: "single",
              selected: !G1(v) && a2(v) ? v : void 0,
              onSelect: O
            }
          ) : null,
          t === "range" ? /* @__PURE__ */ r.jsx(
            S4,
            {
              ...N,
              mode: "range",
              selected: G1($) ? $ : void 0,
              onSelect: O,
              view: u
            }
          ) : null,
          g ? null : /* @__PURE__ */ r.jsx(K2, { ...B })
        ]
      }
    );
  }
), _4 = ({
  parentTestId: e,
  menuAnchor: t,
  setMenuAnchor: n,
  mode: o,
  defaultValue: a,
  setValue: i,
  fromDate: l,
  toDate: c
}) => {
  const d = Z(null), u = {
    ref: d,
    testId: `${e}-date-picker`,
    fromDate: l,
    toDate: c
  }, [p, m] = V(!!a);
  return /* @__PURE__ */ r.jsx(
    ze,
    {
      "data-testid": `${e}-menu`,
      anchor: t,
      onClose: () => {
        n(null);
      },
      leftAligned: !0,
      bottomDrawerProps: {
        variant: "modal",
        maintainSpaceForFooter: !1,
        footerProps: {
          kind: "button",
          props: {
            anySelected: p,
            onFooterClearAll: () => {
              var g;
              return (g = d.current) == null ? void 0 : g.clear();
            },
            onFooterDone: () => {
              var g;
              return (g = d.current) == null ? void 0 : g.done();
            }
          }
        }
      },
      children: o === "single" ? /* @__PURE__ */ r.jsx(
        yr,
        {
          ...u,
          mode: "single",
          defaultValue: a,
          onChange: (g) => {
            i(g), n(null);
          },
          onSelect: (g) => m(!!g),
          onClear: () => {
            i(void 0), m(!1);
          }
        }
      ) : /* @__PURE__ */ r.jsx(
        yr,
        {
          ...u,
          mode: "range",
          defaultValue: a,
          onChange: (g, h) => {
            i(g, h), n(null);
          },
          onSelect: (g) => m(!!g),
          onClear: () => {
            i(void 0), m(!1);
          }
        }
      )
    }
  );
}, V4 = ({
  id: e,
  testId: t = e,
  label: n,
  value: o,
  setValue: a,
  disabled: i,
  selected: l,
  fromDate: c,
  toDate: d
}) => {
  const { translations: u } = Q(), { cx: p, classes: m } = m1(), [g, h] = V(null), C = o != null && o.from && o.to ? `${j1(o.from, "date")} - ${j1(o.to, "date")}` : o != null && o.from ? j1(o.from, "date") : u.common.select_date, v = (b, f = !1, y = !1) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("span", { className: m.filterMenuLabelSpacing, children: b }),
    /* @__PURE__ */ r.jsx(
      te,
      {
        name: "caret",
        className: p(m.caret, {
          [m.filterMenuCaretSelected]: f,
          [m.filterMenuCaret]: !f,
          [m.filterMenuCaratDisabled]: y
        })
      }
    )
  ] });
  return /* @__PURE__ */ r.jsxs("div", { id: e, children: [
    /* @__PURE__ */ r.jsx(he, { testId: `${t}-tooltip`, title: C, children: /* @__PURE__ */ r.jsx(
      u1,
      {
        "data-testid": t,
        label: v(n, l, i),
        disabled: i,
        className: p(m.filter, {
          [m.selected]: l && !i,
          [m.disabled]: i,
          [m.disableRipple]: !0
        }),
        onClick: (b) => {
          b.stopPropagation(), h(b.currentTarget);
        }
      }
    ) }),
    /* @__PURE__ */ r.jsx(
      _4,
      {
        parentTestId: t,
        menuAnchor: g,
        setMenuAnchor: h,
        mode: "range",
        defaultValue: o,
        setValue: a,
        fromDate: c,
        toDate: d
      }
    )
  ] });
}, A4 = X.create(({ theme: e }) => ({
  label: {
    ...e.typography.label,
    display: "block",
    marginBottom: "0.75rem"
  },
  disabledLabel: {
    color: e.palette.neutral[50]
  },
  visuallyHidden: ot
})), a1 = ({
  htmlFor: e,
  disabled: t,
  hidden: n,
  children: o,
  ...a
}) => {
  const { cx: i, classes: l } = A4();
  return /* @__PURE__ */ r.jsx(
    "label",
    {
      ...a,
      htmlFor: e,
      className: i(l.label, {
        [l.disabledLabel]: t,
        [l.visuallyHidden]: n
      }),
      children: o
    }
  );
}, An = (e) => ({
  position: "absolute",
  top: "0.0625rem",
  right: "0.0625rem",
  fill: e.palette.neutral[50]
}), K1 = (e, t, n) => ({
  borderWidth: "2px",
  borderColor: n ? e.palette.error["60-key"] : e.palette.primary["60-key"],
  "& input": {
    color: e.palette.neutral[80]
  },
  [`.${t.button}`]: {
    top: 0,
    right: 0
  }
}), Mt = {
  borderWidth: 0
}, Bt = (e) => ({
  extraInfo: {
    marginTop: "0.5rem"
  },
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem"
  }
});
R()((e, { disabled: t, hasError: n }, o) => ({
  container: {
    position: "relative",
    backgroundColor: "white",
    border: `1px solid ${e.palette.neutral[30]}`,
    borderRadius: "0.25rem",
    "& label": { display: "none" },
    "& fieldset": { display: "none" },
    "& input": {
      color: e.palette.neutral[80],
      padding: "0.40625rem 0.625rem"
    },
    "&:hover, &:has(input:hover)": {
      ...n ? {} : {
        borderColor: t ? e.palette.neutral[30] : e.palette.neutral[40]
      },
      "& input": {
        color: e.palette.neutral[80]
      }
    },
    "&:has(input:active), &:has(input:focus-visible)": {
      ...t ? {} : K1(e, o)
    }
  },
  containerWithMenuOpen: {
    ...K1(e, o)
  },
  button: {
    ...An(e)
  },
  buttonWithMenuOpen: {
    backgroundColor: `${x["neutral-80"]}0C`,
    fill: e.palette.neutral[80]
  },
  dateField: {
    border: "1px solid transparent",
    "&:has(input:active), &:has(input:focus-visible)": {
      ...t ? {} : Mt
    }
  },
  dateFieldWithMenuOpen: {
    ...Mt
  },
  error: {
    borderColor: e.palette.error["60-key"],
    "& .MuiTextField-root": {
      borderColor: e.palette.error["60-key"],
      borderRadius: "0.185rem"
    }
  },
  ...Bt(e)
}));
R()((e) => ({
  ...Bt(e)
}));
R()((e, { disabled: t }, n) => ({
  container: {
    display: "flex",
    alignItems: "center",
    paddingRight: "1.5rem",
    maxWidth: "18.5rem",
    "&:has(input:active), &:has(input:focus-visible)": {
      ...t ? {} : K1(e, n)
    }
  },
  containerWithMenuOpen: {
    ...K1(e, n)
  },
  containerWithError: {
    ...K1(e, n, !0)
  },
  doubledBorderContainer: {
    border: "1px solid transparent",
    display: "flex",
    alignItems: "center",
    "&:has(input:active), &:has(input:focus-visible)": {
      ...t ? {} : Mt
    }
  },
  doubledBorderContainerWithMenuOpen: {
    ...Mt
  },
  doubledBorderContainerWithError: {
    borderWidth: 0
  },
  inputField: {
    ...e.typography.body1,
    padding: 0,
    border: 0,
    "& .MuiInputBase-root": {
      padding: 0,
      "& input": {
        maxWidth: "7.5rem",
        paddingRight: 0
      }
    }
  },
  toDateInputField: {
    "& .MuiInputBase-root": {
      "& input": {
        paddingLeft: "0.25rem",
        paddingRight: 0
      }
    }
  },
  button: {
    ...An(e)
  },
  ...Bt(e)
}));
R()((e) => ({
  fieldContainer: {
    display: "flex",
    gap: "1.125rem"
  },
  stackedContainer: {
    flexDirection: "column",
    gap: "0.25rem"
  },
  ...Bt(e)
}));
const B4 = (e) => e.inputType === "radio", H4 = (e) => e.inputType === "link", D4 = (e, t) => {
  const n = t.map(
    (a) => e.findIndex((i) => i.id === a)
  );
  return n.sort()[n.length - 1];
}, gp = ({
  cards: e,
  onSelection: t,
  checkedIds: n,
  isReadOnly: o = !1,
  ...a
}) => {
  const i = D4(e, n) ?? -1, l = e.map((c, d) => {
    if (H4(c))
      return c;
    const u = d < i, p = {
      checked: n.includes(c.id),
      disabled: o || u
    };
    return B4(c) ? {
      ...p,
      ...c,
      onValueChange: (m, g) => t({ id: m, value: g })
    } : {
      ...p,
      ...c,
      onValueChange: (m, g) => {
        if (!g)
          t({ id: m, value: g });
        else {
          const h = e.findIndex((v) => v.id === m);
          e.slice(0, h + 1).forEach(({ id: v }) => {
            t({ id: v, value: !0 });
          });
        }
      }
    };
  });
  return /* @__PURE__ */ r.jsx(E3, { ...a, cards: l });
}, T4 = R()((e, { isDragActive: t, uploadState: n }) => {
  let o = "inherit";
  return t ? o = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect transform='scale(0.98)' transform-origin='50% 50%' width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%234A90ADFF' stroke-width='2' stroke-dasharray='6%2c10' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e");` : n === "uploading" && (o = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect transform='scale(0.98)' transform-origin='50% 50%' width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23BDBDBDFF' stroke-width='2' stroke-dasharray='6%2c10' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e");`), {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%"
    },
    dropzoneContainer: {
      height: "10.5rem",
      borderRadius: "0.25rem",
      border: n !== "error" ? `1px solid ${e.palette.neutral[30]}` : `1px solid ${e.palette.error["60-key"]}`
    },
    dropzone: {
      height: "7.5rem",
      margin: "1.5rem",
      borderRadius: "0.25rem",
      backgroundColor: t || n === "uploading" ? e.palette.neutral[10] : "inherit",
      background: o,
      backgroundPosition: "center",
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer"
    },
    link: {
      color: e.palette.primary["60-key"],
      cursor: "pointer",
      ":hover": {
        textDecoration: "underline"
      }
    },
    subtitle: {
      ...e.typography.subtitle,
      marginTop: "-0.5rem",
      color: e.palette.neutral[70]
    },
    retryButton: {
      color: e.palette.primary["60-key"],
      marginTop: "-0.5rem"
    },
    errorMessage: {
      ...e.typography.subtitle,
      color: e.palette.error["60-key"],
      marginTop: "0.5rem"
    },
    helperMessage: {
      ...Re(e),
      marginTop: "0.375rem"
    },
    fileContainer: {
      boxShadow: "none",
      border: `1px solid ${e.palette.neutral[30]}`,
      maxHeight: "10.5rem",
      marginTop: "0.5rem"
    },
    fileContainerWithoutTopMargin: {
      marginTop: 0
    },
    deleteAction: {
      borderTop: `1px solid ${e.palette.neutral[30]}`,
      width: "12.5rem"
    }
  };
}), Cp = ({
  id: e,
  testId: t,
  files: n = [],
  label: o,
  labelHidden: a = !1,
  includeUploadIcon: i = !0,
  accept: l,
  maxSize: c,
  onFileAccepted: d,
  onRemoveFile: u,
  onViewFile: p,
  onDownloadFile: m,
  errorMessage: g,
  helperMessage: h,
  uploadRulesMessage: C,
  onError: v,
  dropzoneError: b,
  uploadState: f = "idle",
  onRetry: y,
  multiple: w = !0,
  isReadOnly: k = !1
}) => {
  const { locale: M, translations: L } = Q(), j = (A) => {
    v(A);
  }, N = (A) => {
    const F = [
      ...new Set(
        A.flatMap(
          (z) => z.errors.map((I) => I.message)
        )
      )
    ].join(", ");
    v(new Error(F));
  }, { getRootProps: E, getInputProps: $, isDragActive: S } = wa({
    accept: l,
    maxSize: c,
    onError: j,
    onDropAccepted: d,
    onDropRejected: N,
    noClick: f === "uploading" || f === "error",
    multiple: w
  }), { cx: _, classes: B } = T4({ uploadState: f, isDragActive: S });
  let O = "";
  return S ? O = w ? L.file_upload.drop_files : L.file_upload.drop_file : O = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    w ? L.file_upload.drag_files : n.length ? L.file_upload.replace_file : L.file_upload.drag_file,
    " ",
    /* @__PURE__ */ r.jsx("span", { className: B.link, children: w ? L.file_upload.choose_files : n.length ? L.file_upload.choose_new_file : L.file_upload.choose_file })
  ] }), /* @__PURE__ */ r.jsxs("div", { className: B.root, children: [
    /* @__PURE__ */ r.jsx(a1, { htmlFor: e ?? "", hidden: a, children: o }),
    k ? null : /* @__PURE__ */ r.jsx("div", { className: B.dropzoneContainer, children: /* @__PURE__ */ r.jsxs(
      "div",
      {
        ...E({ className: B.dropzone }),
        "data-testid": `${t}-dropzone`,
        ...f === "error" && { onClick: y },
        children: [
          f === "uploading" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
            /* @__PURE__ */ r.jsx(mn, { size: "small", testId: `${t}-progress` }),
            /* @__PURE__ */ r.jsx(W, { variant: "body1", children: L.file_upload.uploading })
          ] }),
          f === "error" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
            i && /* @__PURE__ */ r.jsx(te, { name: "inverted-error" }),
            /* @__PURE__ */ r.jsx(W, { variant: "body1", align: "center", children: b ?? L.file_upload.error }),
            /* @__PURE__ */ r.jsx(
              G,
              {
                testId: `${t}-retry`,
                className: B.retryButton,
                buttonVariant: "text",
                label: L.file_upload.retry
              }
            )
          ] }),
          f === "idle" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
            i && /* @__PURE__ */ r.jsx(te, { name: "cloud-upload" }),
            /* @__PURE__ */ r.jsx(W, { variant: "body1", align: "center", children: O }),
            C ? /* @__PURE__ */ r.jsx(
              W,
              {
                variant: "subtitle1",
                align: "center",
                className: B.subtitle,
                children: C
              }
            ) : null,
            /* @__PURE__ */ r.jsx("input", { id: e, ...$() })
          ] })
        ]
      }
    ) }),
    n.length > 0 && /* @__PURE__ */ r.jsx(
      l1,
      {
        itemComponent: Je,
        containerClassName: _(B.fileContainer, {
          [B.fileContainerWithoutTopMargin]: k
        }),
        items: n.map((A) => ({
          id: A.id,
          testId: A.testId,
          heading: A.name,
          subtext: `${new Intl.NumberFormat(M, { maximumFractionDigits: 2 }).format(A.size / 1048576)} MB`,
          density: "condensed",
          avatar: /* @__PURE__ */ r.jsx(we, { icon: "attach", iconAvatarColor: "primary" }),
          actionLists: [
            [
              {
                id: `file-upload-${t}-${A.testId}-view`,
                iconLeft: "visibility",
                iconLeftVariant: "neutral",
                iconRight: "open-small",
                iconRightVariant: "neutralLight",
                label: L.file_upload.view,
                onClick: () => p(A.id)
              },
              {
                id: `file-upload-${t}-${A.testId}-download`,
                iconLeft: "download",
                iconLeftVariant: "neutral",
                label: L.file_upload.download,
                onClick: () => m(A.id)
              }
            ],
            k ? [] : [
              {
                id: `file-upload-${t}-${A.testId}-delete`,
                iconLeft: "delete-outlined",
                iconLeftVariant: "destructive",
                label: L.common.delete,
                onClick: () => u(A.id)
              }
            ]
          ]
        })),
        onSelection: () => {
        }
      }
    ),
    g && /* @__PURE__ */ r.jsx(W, { className: B.errorMessage, children: g }),
    h && /* @__PURE__ */ r.jsx(W, { className: B.helperMessage, children: h })
  ] });
}, Ht = (e, t) => {
  const [n, o] = V(!1);
  return K(() => {
    const a = e.current, i = () => o(!0), l = () => o(!1);
    return a == null || a.addEventListener("focus", i), a == null || a.addEventListener("blur", l), () => {
      a == null || a.removeEventListener("focus", i), a == null || a.removeEventListener("blur", l);
    };
  }, [e, t, o]), K(() => {
    const a = (i) => {
      var l;
      (l = t == null ? void 0 : t.current) != null && l.contains(i.target) || o(!1);
    };
    return window.addEventListener("mousedown", a), () => window.removeEventListener("mousedown", a);
  }, [t, o]), [n, o];
}, Dt = (e, t) => {
  K(() => {
    const n = (o) => {
      !e.current || e.current.contains(o.target) || t(o);
    };
    return document.addEventListener("mousedown", n), document.addEventListener("touchstart", n), () => {
      document.removeEventListener("mousedown", n), document.removeEventListener("touchstart", n);
    };
  }, [e, t]);
}, Tt = (e, t) => {
  const [n, o] = V();
  return K(() => {
    const a = () => {
      e.current && (o(e.current.clientWidth), t == null || t(e.current));
    };
    return setTimeout(() => {
      a();
    }, 200), window.addEventListener("resize", a), () => window.removeEventListener("resize", a);
  }, [e, t]), n;
}, R4 = R()((e, { isReadOnly: t, phoneError: n, fullWidth: o, divWidth: a }) => ({
  inputContainer: {
    backgroundColor: t ? "transparent" : e.palette.neutral.white,
    borderRadius: "4px",
    border: `1px solid ${e.palette.neutral[30]}`,
    height: "2.5rem",
    display: "flex",
    position: "relative",
    top: t ? "-8px" : void 0
  },
  scrollableContainer: {
    display: "flex",
    alignItems: "center !important",
    position: "relative",
    width: "100%"
  },
  phoneInputWrapper: {
    display: o ? "flex" : "inline-block",
    flex: o ? "1" : "none",
    alignItems: "center",
    width: "100%",
    input: {
      paddingRight: "10px",
      backgroundColor: t ? "transparent" : void 0,
      top: o && t ? "7px" : "0px",
      background: "transparent",
      width: "calc(max(135px, 100%))"
    }
  },
  baseStates: {
    "&:hover": {
      border: n ? void 0 : `1px solid ${e.palette.neutral[40]}`
    },
    "&:active": {
      border: n ? void 0 : `1px solid ${e.palette.primary["60-key"]}`
    },
    "&:focus-visible": {
      outline: "none",
      border: `1px solid ${e.palette.primary["60-key"]}`,
      ">ul": {
        borderColor: `${e.palette.primary["60-key"]}`
      }
    }
  },
  isPlaceholder: {
    input: {
      "::placeholder": {
        color: e.palette.neutral[50]
      }
    },
    "&:hover": {
      borderColor: n ? e.palette.error["60-key"] : e.palette.neutral[40]
    }
  },
  errorBorder: {
    border: `1px solid ${e.palette.error["60-key"]}`
  },
  isActive: {
    border: n ? `1px solid ${e.palette.error["60-key"]}` : `1px solid ${e.palette.primary["60-key"]}`,
    outline: n ? `2px solid ${e.palette.error["60-key"]}` : `2px solid ${e.palette.primary["60-key"]}`,
    outlineOffset: "-2px"
  },
  disabled: {
    pointerEvents: "none",
    backgroundColor: t ? "inherit" : e.palette.neutral[20],
    input: {
      backgroundColor: t ? "inherit" : e.palette.neutral[20],
      overflow: "hidden",
      color: e.palette.neutral[50]
    }
  },
  isReadOnly: {
    border: "none",
    pointerEvents: "none",
    marginBottom: "0px",
    ">div": {
      border: "none",
      padding: "0px",
      ">div": {
        padding: "0px"
      }
    },
    "& + div": {
      marginTop: "0px",
      "> div": {
        margin: "0px"
      }
    },
    input: {
      overflow: "hidden"
    }
  },
  label: {
    ...e.typography.label,
    display: "block",
    marginBottom: "0.75rem"
  },
  disabledLabel: {
    color: e.palette.neutral[50]
  },
  visuallyHidden: ot,
  button: {
    position: "relative",
    padding: t ? 0 : void 0,
    fontSize: t ? "1rem" : void 0,
    fontWeight: t ? 400 : void 0
  },
  dropdown: {
    width: o ? "calc(min(202px, 100%))" : `calc(${a} + 2px)`,
    zIndex: 1,
    [e.breakpoints.down(_1)]: {
      width: "100%"
    }
  },
  extraInfo: {
    marginTop: "0.5rem"
  },
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem",
    position: "relative",
    top: t ? o ? "-0.5px" : "-8px" : void 0
  },
  helperMessage: {
    ...Re(e),
    position: "relative",
    top: t ? o ? "-0.5px" : "-8px" : void 0
  }
})), w1 = R()((e, { isReadOnly: t, showBorder: n }) => ({
  leftIcon: {
    flexShrink: "0",
    position: "relative",
    top: "-0.063rem"
  },
  rightIcon: {
    flexShrink: "0",
    position: "relative",
    top: "-0.063rem"
  },
  crossIcon: {
    flexShrink: "0",
    position: "relative",
    top: "-0.4375rem",
    cursor: "pointer"
  },
  disabledIcon: {
    color: e.palette.neutral[50]
  },
  inputContainer: {
    backgroundColor: t ? "transparent" : e.palette.neutral.white,
    borderRadius: "4px",
    border: `1px solid ${e.palette.neutral[30]}`,
    height: "2.5rem",
    width: "100%",
    input: {
      backgroundColor: t ? "transparent" : void 0
    }
  },
  inputContainerFullWidth: {
    width: "100%"
  },
  baseStates: {
    "&:hover": {
      border: `1px solid ${e.palette.neutral[40]}`
    },
    "&:active": {
      border: `1px solid ${e.palette.primary["60-key"]}`,
      ">div": {
        border: `1px solid ${e.palette.primary["60-key"]}`
      }
    },
    "&:focus-visible": {
      outline: "none",
      border: `1px solid ${e.palette.primary["60-key"]}`,
      ">div": {
        border: `1px solid ${e.palette.primary["60-key"]}`
      }
    }
  },
  isPlaceholder: {
    input: {
      "::placeholder": {
        color: e.palette.neutral[50]
      }
    },
    "&:hover": {
      borderColor: e.palette.neutral[40]
    }
  },
  isActive: {
    border: `1px solid ${e.palette.primary["60-key"]}`,
    outline: `2px solid ${e.palette.primary["60-key"]}`,
    outlineOffset: "-2px",
    ">div": {
      borderColor: e.palette.primary["60-key"]
    },
    "&:hover": {
      borderColor: e.palette.primary["60-key"]
    }
  },
  disabled: {
    pointerEvents: "none",
    backgroundColor: t ? "inherit" : e.palette.neutral[20],
    input: {
      backgroundColor: t ? "inherit" : e.palette.neutral[20],
      overflow: "hidden",
      color: e.palette.neutral[50]
    }
  },
  isReadOnly: {
    border: n ? `1px solid ${e.palette.neutral[30]}` : "none",
    backgroundColor: "transparent",
    pointerEvents: "none",
    height: n ? void 0 : "1.5rem",
    marginBottom: "0px",
    outline: "none",
    ">div": {
      border: "none",
      padding: n ? "0.5rem 0.75rem 0.5rem 0.8125rem" : "0px",
      ">div": {
        padding: n ? void 0 : "0px"
      }
    },
    "& + div": {
      marginTop: n ? void 0 : "0px",
      "> div": {
        margin: n ? void 0 : "0px"
      }
    },
    input: {
      backgroundColor: "transparent",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    "&:hover, &:active, &:focus-visible": {
      border: n ? `1px solid ${e.palette.neutral[30]}` : "none",
      ">div": {
        border: "0"
      }
    }
  },
  toggleInputContainer: {
    width: "12.5rem"
  },
  errorBorder: {
    border: `1px solid ${e.palette.error["60-key"]}`,
    "&:hover": {
      borderColor: e.palette.error["60-key"]
    },
    "&:active": {
      borderColor: e.palette.error["60-key"],
      ">div": {
        borderColor: e.palette.error["60-key"]
      }
    }
  },
  errorBorderActive: {
    border: `1px solid ${e.palette.error["60-key"]}`,
    outline: `2px solid ${e.palette.error["60-key"]}`,
    outlineOffset: "-2px",
    ">div": {
      borderColor: e.palette.error["60-key"]
    },
    "&:hover": {
      borderColor: e.palette.error["60-key"]
    }
  },
  doubledBorder: {
    borderRadius: "3px",
    border: "1px solid transparent",
    height: "100%",
    width: "100%",
    display: "flex",
    padding: "0.5rem 0.75rem",
    paddingTop: "0.438rem"
  },
  doubledBorderStripeContainer: {
    borderRadius: "3px",
    height: "100%",
    width: "100%",
    padding: "0.5rem 0.75rem",
    paddingTop: "0.438rem"
  },
  doubledBorderClearButton: {
    paddingRight: "0.375rem"
  },
  doubledBorderChips: {
    height: "2.375rem",
    gap: "0.25rem"
  },
  input: {
    ...e.typography.body1,
    outline: "none",
    border: "none",
    borderRadius: "4px",
    padding: "0px",
    width: "7.5rem",
    height: "1.5rem",
    position: "relative",
    top: "-0.063rem",
    flexGrow: "1",
    flexShrink: "0"
  },
  inputLeftOffset: {
    paddingLeft: "0.375rem"
  },
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "auto",
    marginBottom: "0.375rem"
  },
  helperMessage: {
    ...Re(e)
  },
  extraInfo: {
    marginTop: "0.5rem"
  },
  button: {
    alignSelf: "center"
  },
  toggleButton: {
    position: "relative",
    top: "0.313rem"
  }
})), D1 = ({
  autoComplete: e,
  ref: t,
  placeholderText: n,
  testId: o,
  value: a,
  handleOnChange: i,
  id: l,
  name: c,
  useInputLeftOffset: d = !1,
  isPasswordInput: u = !1,
  onBlur: p,
  onFocus: m,
  onKeyDown: g = () => {
  },
  className: h,
  autoFocus: C,
  disabled: v = !1,
  isReadOnly: b = !1,
  inputProps: f
}) => {
  const { cx: y, classes: w } = w1({ isReadOnly: !1 }), k = Te(
    (M) => {
      const L = M.target.value;
      i(l, L);
    },
    [i, l]
  );
  return K(() => {
    var M;
    C && typeof t != "function" && ((M = t == null ? void 0 : t.current) == null || M.focus());
  }, [t, C]), /* @__PURE__ */ r.jsx(
    "input",
    {
      ...f,
      autoComplete: e,
      ref: t,
      id: l,
      name: c,
      placeholder: n,
      "data-testid": o,
      tabIndex: b ? -1 : void 0,
      readOnly: b,
      disabled: v,
      value: a,
      type: u ? "password" : "text",
      className: y(w.input, h, {
        [w.inputLeftOffset]: d
      }),
      onKeyDown: g,
      onChange: k,
      autoFocus: C,
      onFocus: m,
      onBlur: p
    }
  );
}, F4 = /[A-Za-z]+$/, z4 = () => ya().map((t) => ({
  country: t,
  callingCode: en(t)
})), Bn = z4(), W4 = (e) => Bn.find(
  (n) => n.country === e
) ?? { country: "US", callingCode: "1" }, O4 = ({
  id: e,
  testId: t,
  className: n,
  isReadOnly: o,
  isPlaceholder: a,
  value: i = "",
  hasError: l = !1,
  isActive: c = !1,
  disabled: d,
  label: u,
  labelHidden: p,
  selectedCountry: m = "US",
  fullWidth: g = !1,
  errorMessage: h,
  helperMessage: C,
  handleOnChange: v,
  onCountryChange: b,
  ...f
}) => {
  const [y, w] = V(!1), k = () => w(!y), [M, L] = V(m), j = Z(null), N = Z(null), E = Z(null), [$, S] = Ht(E), _ = W4(M), B = (H) => {
    var T;
    L(H), w(!1), (T = E.current) == null || T.focus(), b == null || b(H);
  }, O = new ir(M).input(i), A = (H, T) => {
    var ve, ye;
    w(!1);
    const ne = (ve = E.current) == null ? void 0 : ve.selectionStart, de = new ir(M);
    de.input(T);
    const q = (ye = de.getNumber()) == null ? void 0 : ye.nationalNumber.toString(), se = !q || !!F4.exec(T) ? T : q;
    v(e, se), requestAnimationFrame(() => {
      var Me;
      if (ne && ((Me = E.current) != null && Me.selectionStart)) {
        let Ee = T.substring(0, ne).split("").filter((Ae) => !isNaN(parseInt(Ae))).join("").length, ke = 0;
        for (ke; Ee > 0 && ke <= de.formattedOutput.length; ke++) {
          const Ae = de.formattedOutput[ke];
          Ae && !isNaN(parseInt(Ae)) && Ee--;
        }
        E.current.selectionStart = ke, E.current.selectionEnd = ke;
      }
    });
  };
  Dt(N, (H) => {
    const T = H.target, ne = T == null ? void 0 : T.closest(".MuiPopover-root"), de = T == null ? void 0 : T.closest("[data-vaul-drawer]");
    ne || de || (w(!1), S(!1));
  });
  const F = Tt(N), { cx: z, classes: I } = R4({
    isReadOnly: o,
    phoneError: l,
    fullWidth: g,
    divWidth: `${F}px`
  }), { translations: D } = Q();
  return /* @__PURE__ */ r.jsxs("div", { ref: j, children: [
    /* @__PURE__ */ r.jsx(
      "label",
      {
        htmlFor: e,
        className: z(I.label, {
          [I.disabledLabel]: d,
          [I.visuallyHidden]: p
        }),
        onClick: (H) => {
          var T;
          H.preventDefault(), !(d || o) && ((T = E.current) == null || T.focus());
        },
        children: u || D.common.inputs.phone.label
      }
    ),
    /* @__PURE__ */ r.jsxs(
      "div",
      {
        ref: N,
        className: z(I.inputContainer, {
          [I.baseStates]: !a,
          [I.isPlaceholder]: a,
          [I.errorBorder]: l,
          [I.isActive]: $ || c,
          [I.disabled]: d,
          [I.isReadOnly]: o
        }),
        children: [
          /* @__PURE__ */ r.jsx(
            G,
            {
              testId: t ? `${t}-country` : `${e}-country`,
              buttonVariant: "menuTextBorderless",
              className: z(I.button),
              label: `${_.country} +${_.callingCode}`,
              onClick: (H) => {
                H.preventDefault(), S(!0), k(), setTimeout(() => {
                  var ne;
                  const T = (ne = N.current) == null ? void 0 : ne.querySelector(
                    "[data-list='true'] [data-listitem='true'] > button"
                  );
                  T == null || T.focus();
                }, 100);
              },
              disabled: d,
              isReadOnly: o
            }
          ),
          y && /* @__PURE__ */ r.jsx(
            ze,
            {
              anchorRef: j,
              open: y,
              leftAligned: !0,
              onClose: () => w(!1),
              children: /* @__PURE__ */ r.jsx(
                Ie,
                {
                  minWidth: 0,
                  maxHeight: 224,
                  autoFocus: !0,
                  className: z(I.dropdown),
                  lists: [
                    {
                      removeFromTabOrder: !0,
                      items: Bn.map(
                        ({ country: H, callingCode: T }) => ({
                          id: H,
                          label: `${H} +${T}`,
                          selected: H === m
                        })
                      ),
                      itemComponent: Se,
                      fullHeight: !0,
                      onSelection: ({ id: H }) => {
                        B(H);
                      }
                    }
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ r.jsx(
            ue,
            {
              disableVerticalScroll: !0,
              removeFromTabOrder: !0,
              theme: "os-theme-hidden",
              className: I.scrollableContainer,
              children: /* @__PURE__ */ r.jsx("div", { className: z(I.phoneInputWrapper), children: /* @__PURE__ */ r.jsx(
                D1,
                {
                  id: e,
                  testId: t ?? e,
                  placeholderText: f.placeholderText ?? "",
                  ...f,
                  isReadOnly: o,
                  className: z(n),
                  value: O,
                  handleOnChange: A,
                  inputProps: {
                    onMouseDown: () => w(!1),
                    disabled: d,
                    "aria-invalid": l
                  },
                  ref: E
                }
              ) })
            }
          )
        ]
      }
    ),
    (!!h || !!C) && /* @__PURE__ */ r.jsxs("div", { className: I.extraInfo, children: [
      h && /* @__PURE__ */ r.jsx("div", { className: I.errorMessage, children: h }),
      C && /* @__PURE__ */ r.jsx("div", { className: I.helperMessage, children: C })
    ] })
  ] });
}, vp = (e) => en(e), Z4 = R()((e) => ({
  groupOptionLabel: {
    ...e.typography.label,
    marginBottom: "0.125rem"
  },
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem"
  },
  helperMessage: {
    ...Re(e)
  },
  radioContainer: {
    paddingLeft: ".25rem",
    marginBottom: "-0.25rem"
  },
  extraInfo: {
    marginTop: "0.5rem"
  }
})), fp = ({
  groupOptionLabel: e,
  items: t,
  errorMessage: n,
  helperMessage: o,
  onValueChange: a,
  selectedValue: i,
  disabled: l = !1
}) => {
  const { classes: c } = Z4();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("div", { className: c.groupOptionLabel, children: e }),
    t.map(({ label: d, value: u }, p) => /* @__PURE__ */ r.jsx("div", { className: c.radioContainer, children: /* @__PURE__ */ r.jsx(
      at,
      {
        testId: `radio-group-item-${p}`,
        checked: u == i,
        label: d,
        disabled: l,
        value: u,
        onValueChange: a
      }
    ) }, _2(u))),
    /* @__PURE__ */ r.jsxs("div", { className: c.extraInfo, children: [
      n && /* @__PURE__ */ r.jsx("div", { className: c.errorMessage, children: n }),
      o && /* @__PURE__ */ r.jsx("div", { className: c.helperMessage, children: o })
    ] })
  ] });
}, P4 = R()((e) => ({
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem"
  },
  helperMessage: {
    ...Re(e)
  },
  extraInfo: {
    marginLeft: "1.563rem"
  },
  label: {
    ...e.typography.body1
  }
})), xp = ({
  label: e,
  checked: t,
  disabled: n,
  value: o,
  errorMessage: a,
  helperMessage: i,
  onValueChange: l,
  testId: c
}) => {
  const { classes: d } = P4();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      at,
      {
        testId: c,
        checked: t,
        label: e,
        disabled: n,
        value: o,
        onValueChange: l
      }
    ),
    /* @__PURE__ */ r.jsxs("div", { className: d.extraInfo, children: [
      a && /* @__PURE__ */ r.jsx("div", { className: d.errorMessage, children: a }),
      i && /* @__PURE__ */ r.jsx("div", { className: d.helperMessage, children: i })
    ] })
  ] });
}, q4 = ".MuiList-root [data-listitem='true']", U4 = "[data-list='true'] [data-listitem='true']", B2 = (e) => document.querySelectorAll(
  e ? U4 : q4
), Et = (e) => (t) => t.style.backgroundColor = e, G4 = (e, t) => Array.from(B2(e)).find((n) => n.innerText.trim().toLowerCase().startsWith(t.trim().toLowerCase())), K4 = (e, t) => {
  var o, a, i;
  if (B2(e).forEach(Et("transparent")), t.length === 0) return;
  const n = G4(e, t);
  n && (Et("var(--neutral-20, #f4f4f4)")(n), (o = n.querySelector("input")) == null || o.focus(), (a = n.querySelector("button")) == null || a.focus(), (i = n.querySelector("button")) == null || i.scrollIntoView());
}, Y4 = (e, t) => t === "Backspace" ? e.slice(0, e.length - 1) : `${e}${t}`, Q4 = (e, t) => {
  var l, c, d, u;
  const n = B2(e), o = (l = document.activeElement) == null ? void 0 : l.closest(
    "[data-listitem='true']"
  ), a = Array.from(n).findIndex(
    (p) => p === o
  );
  let i;
  t === "ArrowUp" ? i = n[a - 1] : t === "ArrowDown" && (i = n[a + 1]), n.forEach(Et("transparent")), i && (Et("var(--neutral-20, #f4f4f4)")(i), (c = i.querySelector("input")) == null || c.focus(), (d = i.querySelector("button")) == null || d.focus(), (u = i.querySelector("button")) == null || u.scrollIntoView());
}, X4 = [
  "Enter",
  "ArrowLeft",
  "ArrowRight",
  "Tab",
  "Shift"
], J4 = ["Escape", "Control"], Rt = ({
  kind: e,
  isOpen: t = !0,
  setIsOpen: n = () => {
  }
}) => {
  const [o, a] = V("");
  return K(() => {
    K4(e === "list", o);
  }, [e, o]), {
    clearQuery: () => a(""),
    onKeyDown: (l) => {
      var d;
      if (["ArrowUp", "ArrowDown", "Enter", "Tab"].includes(l.key) && (l.stopPropagation(), l.preventDefault()), ["ArrowUp", "ArrowDown"].includes(l.key))
        Q4(e === "list", l.key);
      else if (l.key === "Enter")
        t && ((d = document.activeElement) == null || d.click(), n(!1));
      else if (l.key === "Tab") {
        const u = document.activeElement, p = u == null ? void 0 : u.closest("[data-list-advanced='true']"), m = u == null ? void 0 : u.closest("[data-list='true']"), g = p ?? m, h = l.shiftKey ? g == null ? void 0 : g.previousElementSibling : g == null ? void 0 : g.nextElementSibling;
        h == null || h.focus();
      } else {
        if (X4.includes(l.key) || l.metaKey) return;
        const u = J4.includes(l.key);
        a((p) => u ? "" : Y4(p, l.key)), t || n(!0);
      }
    }
  };
}, e6 = R()((e) => ({
  chip: {
    minWidth: 0,
    flex: 1,
    ".MuiChip-root": {
      textOverflow: "ellipsis"
    }
  },
  doubledBorder: {
    border: "1px solid transparent",
    borderRadius: "6px",
    "&:has(button:focus-visible)": {
      borderColor: e.palette.primary["60-key"]
    }
  },
  doubledBorderIsOpen: {
    borderColor: e.palette.primary["60-key"]
  },
  wrapperButton: {
    background: e.palette.neutral.white,
    border: `1px solid ${e.palette.neutral[30]}`,
    borderRadius: "4px",
    width: "100%",
    padding: "0.5rem 0.5rem 0.5rem 0.75rem",
    display: "flex",
    "&:focus-visible": {
      outline: "none",
      borderColor: e.palette.primary["60-key"]
    }
  },
  isOpen: {
    borderColor: e.palette.primary["60-key"],
    ".chevronThickIcon": {
      position: "relative",
      left: "0.0625rem",
      top: "0.125rem"
    }
  }
})), t6 = ({
  id: e,
  testId: t,
  label: n,
  selectedId: o,
  setSelectedId: a,
  lists: i,
  chipOptions: l,
  isReadOnly: c = !1
}) => {
  const [d, u] = V(!1), p = Z(null), m = Tt(p), { cx: g, classes: h } = e6(), { onKeyDown: C, clearQuery: v } = Rt({
    kind: "custom_select",
    isOpen: d,
    setIsOpen: u
  }), b = () => {
    u(!1), v();
  }, f = {
    testId: "input-chip",
    items: [
      {
        id: "input-chip-item",
        showAvatar: !0,
        avatarIcon: l.icon,
        label: l.label ?? n
      }
    ]
  };
  return c ? o ? /* @__PURE__ */ r.jsx(_e, { ...f, variant: "basic" }) : /* @__PURE__ */ r.jsx(W, { children: "–" }) : /* @__PURE__ */ r.jsxs("div", { id: e, "data-testid": t, ref: p, onKeyDown: C, children: [
    /* @__PURE__ */ r.jsx("label", { onClick: () => u(!0), children: /* @__PURE__ */ r.jsx(
      "div",
      {
        className: g({
          [h.doubledBorder]: !0,
          [h.doubledBorderIsOpen]: d
        }),
        children: /* @__PURE__ */ r.jsxs(
          "button",
          {
            className: g(h.wrapperButton, { [h.isOpen]: d }),
            children: [
              /* @__PURE__ */ r.jsx("div", { className: h.chip, children: /* @__PURE__ */ r.jsx(_e, { ...f, variant: "input" }) }),
              /* @__PURE__ */ r.jsx(
                te,
                {
                  name: "chevron-thick",
                  className: "chevronThickIcon",
                  style: {
                    transform: d ? "rotate(180deg)" : "rotate(0deg)"
                  }
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ r.jsx(
      ze,
      {
        onClose: b,
        anchorRef: p,
        open: d,
        leftAligned: !0,
        menuProps: {
          topOffset: "-0.0625rem",
          width: m
        },
        children: /* @__PURE__ */ r.jsx(
          Ie,
          {
            minWidth: 202,
            navigateWithArrowKeys: !1,
            lists: i.map((y, w) => ({
              subheader: y.subheader,
              subheaderVariant: "spacious",
              itemComponent: Je,
              items: y.items.map((k) => ({
                ...k,
                selected: k.id === o
              })),
              onSelection: ({ id: k }) => {
                a(k), b();
              },
              roundBottom: w !== i.length - 1
            }))
          }
        )
      }
    )
  ] });
}, Hn = R()(
  (e, { buttonVariant: t, disabled: n, hasButton: o, hasMenu: a, inputLength: i, isMulti: l }) => ({
    textInput: {
      minWidth: "3rem",
      ...l ? {
        maxWidth: "7.5rem"
      } : {},
      width: `${i.toString()}ch`,
      top: 0,
      marginRight: "0.063rem"
    },
    doubledBorder: {
      borderRadius: "4px",
      border: "1px solid transparent !important",
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      padding: o ? "0" : "0.375rem 0",
      paddingLeft: "0.75rem"
    },
    doubleBorderScrollingChipContainer: {
      paddingLeft: 0
    },
    doubledBorderChips: {
      height: "2.5rem",
      gap: "0.25rem",
      overflowY: "hidden",
      overflowX: "auto",
      "&::-webkit-scrollbar": {
        height: "2px"
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent"
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: e.palette.neutral[40],
        borderRadius: "2px"
      }
    },
    inputButton: {
      position: "relative"
    },
    multiLineChipsInput: {
      minWidth: "12.5rem",
      flexWrap: "wrap",
      maxHeight: "5.875rem",
      overflowX: "hidden"
    },
    inputContainerChipsMultiline: {
      height: "100%",
      width: "fit-content"
    },
    textFieldContainer: {
      display: "inline-flex",
      gap: "0.5rem",
      width: "100%"
    },
    doubledBorderContainer: {
      width: "100%",
      display: "inline-flex",
      justifyContent: "space-between",
      minHeight: l ? 0 : "2.25rem"
    },
    doubledBorderContainerChipsMultilineHeightUnset: {
      height: "unset"
    },
    disabled: {
      pointerEvents: "none",
      backgroundColor: e.palette.neutral[20],
      input: {
        backgroundColor: e.palette.neutral[20],
        overflow: "hidden",
        color: e.palette.neutral[50]
      }
    },
    isReadOnly: {
      ...e.typography.body1,
      color: e.palette.neutral[80],
      width: "100%"
    },
    isReadOnlyContents: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: "0.25rem",
      flexWrap: "wrap",
      width: "100%"
    },
    textFieldButtonContainer: {
      marginRight: t === "text" ? "0.625rem" : "0.125rem",
      marginTop: t === "text" ? "0.625rem" : 0,
      display: "flex",
      gap: "0.5rem"
    },
    textFieldButton: {
      border: "none",
      outline: "none"
    },
    textFieldButtonNotReadOnly: {
      "&:disabled": {
        opacity: 1,
        border: "none",
        backgroundColor: n ? e.palette.neutral[20] : e.palette.neutral.white,
        color: e.palette.neutral[50]
      }
    },
    menuButtonContainer: {
      marginRight: "0.25rem",
      width: "100%",
      whiteSpace: "nowrap",
      position: "sticky",
      top: n ? "0.3125rem" : "0.125rem"
    },
    menuButton: {
      height: "100%",
      margin: 0,
      border: "none",
      outline: "none",
      paddingRight: 0,
      "&:hover": {
        boxShadow: "none"
      },
      "&:disabled": {
        border: "none",
        background: "transparent"
      }
    },
    optionList: {
      position: "absolute",
      backgroundColor: "white",
      boxShadow: e.namedShadows["depth-2"],
      zIndex: 1,
      top: "36px",
      right: "0rem",
      width: "12.5rem",
      paddingInlineStart: "0px"
    },
    chipContainer: {
      maxWidth: a ? "8rem" : "14rem",
      width: "100%",
      ">div": {
        display: "flex",
        flexWrap: "wrap",
        gap: "0.25rem"
      },
      marginTop: o ? "0.375rem" : 0,
      marginBottom: o ? "0.375rem" : 0,
      overflow: "auto"
    },
    disabledInputContainer: {
      overflow: "hidden"
    },
    textFieldChipsContainer: {
      display: "flex",
      gap: "0.25rem",
      width: "100%",
      ">div": {
        display: "inline-flex",
        gap: "0.25rem"
      },
      overflow: "auto",
      ...o && {
        marginRight: "0.5rem",
        marginTop: "0.375rem"
      }
    }
  })
), H2 = R()((e) => ({
  focusedChip: {
    color: e.palette.neutral.white,
    border: "1px solid transparent",
    backgroundColor: e.palette.primary["60-key"],
    ".MuiChip-deleteIconFilledColorDefault": {
      "> svg": {
        fill: e.palette.neutral.white
      }
    },
    "&:hover": {
      color: e.palette.neutral.white,
      border: `1px solid ${e.palette.primary[70]}`,
      backgroundColor: e.palette.primary[70]
    },
    "&:active": {
      color: e.palette.neutral.white,
      border: `1px solid ${e.palette.primary[80]}`,
      backgroundColor: e.palette.primary[80],
      boxShadow: "none"
    }
  },
  wrappedChip: {
    // position: "relative",
    // bottom: "0.25rem",
    maxWidth: "100%"
  },
  belowChipsContainer: {
    marginTop: "0.375rem"
  },
  belowChips: {
    display: "inline-flex",
    marginRight: "0.25rem",
    marginTop: "0.25rem"
  },
  chipBelow: {
    backgroundColor: e.palette.primary[10],
    color: e.palette.primary["60-key"],
    borderColor: e.palette.primary["60-key"],
    ".MuiChip-deleteIconFilledColorDefault": {
      ">svg": {
        fill: e.palette.primary["60-key"]
      }
    }
  }
})), r6 = R()(
  (e, { height: t = 0, inputLength: n, isMulti: o, removeLeftPadding: a, hasLeftIcon: i }) => ({
    rootContainer: {
      width: "15rem",
      ".MuiChip-deleteIconFilledColorDefault": {
        zIndex: 2
      },
      ".MuiAutocomplete-popper": {
        width: "12.5rem !important",
        position: "relative",
        left: "-0.5rem",
        transform: `translate(16px,${t}px ) !important`,
        inset: "auto 0px !important"
      },
      ".MuiTextField-root": {
        width: "auto",
        paddingLeft: "0.3rem",
        paddingRight: "0.5rem !important",
        height: "24px"
      },
      ".MuiOutlinedInput-root": {
        paddingRight: "0.5rem !important"
      },
      ".MuiAutocomplete-root": {
        paddingLeft: a ? 0 : "0.5rem",
        paddingRight: o ? "0" : "0.5rem",
        marginRight: "-0.25rem"
      }
    },
    backgroundContainer: {
      background: e.palette.neutral.white
    },
    multiSelectContainer: {
      border: `1px solid ${e.palette.neutral[30]}`,
      borderRadius: "4px",
      minHeight: "2.5rem"
    },
    multiSelectSingleContainer: {
      height: "2.5rem"
    },
    multiSelectContainerEvents: {
      padding: "1px",
      "&:hover": {
        border: `1px solid ${e.palette.neutral[40]}`
      },
      "&:active": {
        padding: 0,
        border: `2px solid ${e.palette.primary["60-key"]}`,
        ">div": {
          borderColor: e.palette.primary["60-key"],
          borderRadius: "3px"
        }
      },
      "&:focus-visible": {
        border: `2px solid ${e.palette.primary["60-key"]}`,
        outline: "none",
        ">div": {
          borderColor: e.palette.primary["60-key"],
          borderRadius: "3px"
        }
      }
    },
    multiSelectPlaceholderEvents: {
      "&:hover": {
        border: `1px solid ${e.palette.neutral[40]}`
      },
      "&:focus-visible": {
        outline: "none"
      }
    },
    isOpen: {
      padding: 0,
      border: `2px solid ${e.palette.primary["60-key"]}`,
      outline: "none",
      ">div": {
        borderColor: e.palette.primary["60-key"],
        borderRadius: "3px"
      },
      "&:hover": {
        border: `2px solid ${e.palette.primary["60-key"]}`
      }
    },
    errorBorder: {
      border: `1px solid ${e.palette.error["60-key"]}`
    },
    paddingLeftIcon: {
      padding: "0.375rem 0.188rem 0.375rem 2.25rem"
    },
    borderContainer: {
      display: "flex",
      padding: "0.375rem 0.188rem 0.375rem 0rem"
    },
    autocomplete: {
      ...e.typography.body1,
      flex: 1,
      ".MuiOutlinedInput-notchedOutline": {
        border: "none"
      },
      ".MuiAutocomplete-endAdornment > button.MuiIconButton-root": {
        right: "-0.375rem"
      },
      // for disabling the ripple on the autocomplete's icon, "disableRipple" will not work here
      // because we don't have access to the root button the icon node is being passed to
      // loosely based on this comment here: https://stackoverflow.com/a/68008906
      ".MuiAutocomplete-endAdornment > .MuiButtonBase-root": {
        backgroundColor: "unset",
        "> .MuiTouchRipple-root": {
          display: "none"
        }
      }
    },
    placeholder: {
      ...e.typography.body1
    },
    disabled: {
      pointerEvents: "none",
      backgroundColor: e.palette.neutral[20],
      ".MuiAutocomplete-inputRoot": {
        "input::placeholder": {
          opacity: 0.4
        }
      },
      "> div > div": {
        "::-webkit-scrollbar": {
          backgroundColor: "transparent"
        }
      },
      ".MuiAutocomplete-endAdornment > button.MuiIconButton-root": {
        color: e.palette.neutral[50]
      }
    },
    controlContainer: {
      display: "flex",
      justifyContent: "space-between"
    },
    hiddenLabelPlaceholder: {
      height: "1.625rem"
    },
    clearButton: {
      ...e.typography.label,
      color: e.palette.neutral[50],
      background: "none",
      border: "none",
      cursor: "pointer",
      "&:disabled": {
        display: "none"
      }
    },
    errorMessage: {
      ...e.typography.subtitle,
      color: e.palette.error["60-key"],
      height: "1rem",
      marginBottom: "0.375rem"
    },
    helperMessage: {
      ...Re(e)
    },
    extraInfo: {
      marginTop: "0.5rem"
    },
    chipContainer: {
      overflowY: "hidden"
    },
    multiSelectChipHeightContainer: {
      maxHeight: "6rem",
      overflowY: "scroll"
    },
    multiSelectChipWidthContainer: {
      overflowX: "scroll"
    },
    chipContainerSingleLine: {
      width: i ? "10rem" : a ? "12.625rem" : "12.25rem",
      display: "flex",
      gap: "0.25rem",
      ">div": {
        display: "flex",
        gap: "0.25rem"
      },
      "> div.MuiStack-root": {
        marginBottom: 0
      }
    },
    chipContainerMultiLine: {
      maxWidth: "10rem",
      overflowX: "hidden",
      ">div": {
        display: "flex",
        flexWrap: "wrap",
        gap: "0.25rem"
      },
      display: "flex",
      flexWrap: "wrap",
      gap: "0.25rem"
    },
    chipContainerYScroll: {
      overflowY: "scroll"
    },
    textInput: {
      ".MuiAutocomplete-inputRoot": {
        minWidth: "3.125rem",
        ...o ? {
          maxWidth: "10rem"
        } : {},
        width: `${n + 2}ch`,
        padding: "0px",
        "input.MuiAutocomplete-input": {
          padding: "0px"
        },
        "input::placeholder": {
          ...e.typography.body1,
          opacity: 1
        }
      }
    },
    disablePointerEvents: {
      pointerEvents: "none"
    },
    leftIcon: {
      position: "absolute",
      top: "2.15rem",
      left: "0.75rem"
    },
    leftIconDisabled: {
      color: e.palette.neutral[50]
    },
    dropdownIcon: {
      position: "absolute",
      right: "0.5rem",
      zIndex: 1,
      overflow: "visible",
      "> svg": {
        position: "relative",
        top: "-0.05rem",
        color: e.palette.neutral[80]
      }
    },
    dropdownIconOpen: {
      transform: "rotate(180deg)"
    },
    dropdownIconSingleLine: {
      position: "relative"
    },
    dropdownIconDisabled: {
      color: e.palette.neutral[50]
    }
  })
), n6 = (e) => /* @__PURE__ */ r.jsx(ka, { ref: e.ref, ...e, children: /* @__PURE__ */ r.jsx(
  ue,
  {
    style: {
      maxHeight: "40vh"
    },
    children: e.children
  }
) }), Xt = (e, t, n) => {
  if (!n) return e;
  const o = t.reduce(
    (a, i) => (a[i] = !0, a),
    {}
  );
  return e.filter(
    (a) => !o[a.value]
  );
}, kr = 96, D2 = ({
  options: e,
  selectedValues: t = [],
  hasError: n = !1,
  disabled: o = !1,
  isPlaceholder: a = !1,
  isSingleLine: i = !1,
  label: l,
  labelHidden: c = !1,
  errorMessage: d,
  helperMessage: u,
  handleOnChange: p,
  leftIcon: m,
  rightIcon: g = /* @__PURE__ */ r.jsx(te, { name: "chevron-thick" }),
  testId: h,
  disablePortal: C = !0,
  hideSelectedOptions: v = !0,
  rotateRightIconOnOpen: b = !0,
  ...f
}) => {
  var ie, be;
  const y = M1(() => e.reduce((P, ee) => (P[ee.value] = ee.label, P), {}), [e]), w = Z(null), k = Z(null), M = Z(null), [L, j] = V(""), [N, E] = V(t), [$, S] = V([]), [_, B] = V(
    null
  );
  K(() => {
    E(t);
  }, [t]);
  const [O, A] = V(!1), [F, z] = V(
    Xt(e, t, v)
  ), [I, D] = V(!1), [H, T] = V(!1), [ne, de] = V(!1), { cx: q, classes: U } = r6({
    height: ne ? kr : ((ie = w.current) == null ? void 0 : ie.scrollHeight) ?? 0,
    inputLength: L.length,
    isMulti: !i,
    removeLeftPadding: !m && O,
    hasLeftIcon: !!m
  }), { classes: se } = H2(), ve = Z(null);
  Dt(ve, () => {
    D(!1);
  }), K(() => {
    w.current && (w.current.scrollTop = w.current.scrollHeight, de(
      w.current.scrollHeight > kr
    ));
  }, [N, w]);
  const ye = (P, ee) => {
    E(P), z(
      Xt(e, ee, v)
    ), p(P, "selectOption", void 0);
  }, Me = () => {
    a || o || (j(""), ye([], t));
  }, Ee = (P) => {
    if (a || o) return;
    const ee = N.filter((oe) => oe != P);
    ye(ee, ee);
  }, ke = (P) => {
    if ($.includes(P)) {
      const ee = $.filter((oe) => oe !== P);
      S(ee), ee.length === 0 && B(!1);
    } else
      S([...$, P]), B(!0);
  }, Ae = (P) => {
    if (P.key === "Backspace" && !L) {
      if (_) {
        const ee = N.filter(
          (oe) => !$.includes(oe)
        );
        ye(ee, ee), S([]), B(!1);
      } else {
        B(!0);
        const ee = N[N.length - 1];
        ee && S([...$, ee]);
      }
      return;
    }
    B(!1);
  }, Fe = (P) => {
    P.target.scrollLeft > 0 ? A(!0) : A(!1);
  }, J = (P, ee, oe, fe) => {
    if (a || o) return;
    const xe = ee instanceof Array ? [...N, ...ee.map((Be) => Be.value)] : [...N, ee.value];
    j(""), E(xe), z(
      Xt(e, xe, v)
    ), p(xe, oe, fe);
  };
  return /* @__PURE__ */ r.jsxs(i2, { className: U.rootContainer, ref: ve, children: [
    /* @__PURE__ */ r.jsxs("div", { className: U.controlContainer, children: [
      /* @__PURE__ */ r.jsx(
        a1,
        {
          htmlFor: ((be = M.current) == null ? void 0 : be.id) ?? "",
          disabled: o,
          hidden: c,
          children: l
        }
      ),
      c ? /* @__PURE__ */ r.jsx("div", { className: U.hiddenLabelPlaceholder }) : null,
      /* @__PURE__ */ r.jsx(
        G,
        {
          disabled: o || a,
          className: U.clearButton,
          label: "clear",
          buttonVariant: "textSecondary",
          onClick: Me
        }
      )
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: U.backgroundContainer, children: [
      m ? /* @__PURE__ */ r.jsx(
        lr,
        {
          className: q(U.leftIcon, {
            [U.leftIconDisabled]: o
          }),
          children: m
        }
      ) : null,
      /* @__PURE__ */ r.jsx(
        "div",
        {
          className: q(U.multiSelectContainer, {
            [U.multiSelectContainerEvents]: !a,
            [U.multiSelectPlaceholderEvents]: a,
            [U.errorBorder]: n,
            [U.disabled]: o,
            [U.isOpen]: I || H,
            [U.multiSelectSingleContainer]: i
          }),
          children: /* @__PURE__ */ r.jsxs(
            "div",
            {
              className: q(U.borderContainer, {
                [U.paddingLeftIcon]: !!m
              }),
              children: [
                /* @__PURE__ */ r.jsx(
                  ja,
                  {
                    onChange: J,
                    onInputChange: (P, ee, oe) => {
                      var fe;
                      if (!["reset", "blur"].includes(oe))
                        if (oe === "selectOption") {
                          const Be = {
                            value: (fe = e.find(
                              (Ye) => Ye.label === ee
                            )) == null ? void 0 : fe.value
                          };
                          J(P, Be, oe, void 0);
                        } else
                          j(ee);
                    },
                    onFocus: () => T(!0),
                    onBlur: () => T(!1),
                    className: U.autocomplete,
                    disabled: o || a,
                    value: void 0,
                    inputValue: L,
                    slots: {
                      paper: n6
                    },
                    slotProps: {
                      listbox: {
                        style: {
                          maxHeight: "unset"
                        }
                      }
                    },
                    disableClearable: !0,
                    disablePortal: !0,
                    options: F,
                    renderInput: (P) => /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx(
                      ue,
                      {
                        removeFromTabOrder: !0,
                        className: q({
                          [U.multiSelectChipHeightContainer]: !i
                        }),
                        children: /* @__PURE__ */ r.jsx(
                          ue,
                          {
                            removeFromTabOrder: !0,
                            className: q({
                              [U.multiSelectChipWidthContainer]: !i
                            }),
                            children: /* @__PURE__ */ r.jsx(
                              "div",
                              {
                                ref: w,
                                onClick: () => D(!0),
                                className: q(U.chipContainer, {
                                  [U.disablePointerEvents]: a,
                                  [U.chipContainerYScroll]: ne
                                }),
                                children: /* @__PURE__ */ r.jsxs(
                                  ue,
                                  {
                                    onScroll: (ee, oe) => Fe(oe),
                                    theme: "os-theme-hidden",
                                    removeFromTabOrder: !0,
                                    className: q(U.chipContainer, {
                                      [U.chipContainerSingleLine]: i,
                                      [U.chipContainerMultiLine]: !i
                                    }),
                                    children: [
                                      N.sort(
                                        (ee, oe) => (y[ee] ?? "") < (y[oe] ?? "") ? -1 : 1
                                      ).map((ee, oe) => /* @__PURE__ */ r.jsx(
                                        _e,
                                        {
                                          items: {
                                            id: ee,
                                            label: y[ee] ?? "",
                                            isRemovable: !0,
                                            disabled: o,
                                            isInteractable: !0
                                          },
                                          className: q({
                                            [se.focusedChip]: $.includes(ee) && _
                                          }),
                                          onClick: () => {
                                            var fe;
                                            ke(ee), (fe = M.current) == null || fe.focus({
                                              preventScroll: !0
                                            });
                                          },
                                          variant: "input",
                                          onDelete: Ee,
                                          testId: `${h}-chip-${oe}`
                                        },
                                        oe
                                      )),
                                      /* @__PURE__ */ r.jsx(
                                        Sa,
                                        {
                                          "data-testid": `${h}-autocomplete-input`,
                                          onKeyDown: Ae,
                                          ref: k,
                                          inputRef: M,
                                          onFocus: () => D(!0),
                                          ...P,
                                          className: U.textInput,
                                          slotProps: {
                                            htmlInput: {
                                              "aria-label": l,
                                              ...P.inputProps
                                            }
                                          }
                                        }
                                      )
                                    ]
                                  }
                                )
                              }
                            )
                          }
                        )
                      }
                    ) }),
                    popupIcon: null,
                    open: I,
                    onOpen: () => D(!0),
                    onClose: () => D(!1),
                    ...f
                  }
                ),
                /* @__PURE__ */ r.jsx(
                  lr,
                  {
                    "aria-hidden": !1,
                    className: q(U.dropdownIcon, {
                      [U.dropdownIconOpen]: I && b,
                      [U.dropdownIconSingleLine]: i,
                      [U.dropdownIconDisabled]: o
                    }),
                    onClick: () => D(!I),
                    children: g
                  }
                )
              ]
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: U.extraInfo, children: [
      d && /* @__PURE__ */ r.jsx("div", { className: U.errorMessage, children: d }),
      u && /* @__PURE__ */ r.jsx("div", { className: U.helperMessage, children: u })
    ] })
  ] });
}, c2 = [
  {
    value: "aerospace",
    label: "Aerospace Product and Parts Manufacturing"
  },
  {
    value: "agriculture-animals",
    label: "Animal Production and Aquaculture"
  },
  {
    value: "agriculture-crops",
    label: "Crop Production"
  },
  {
    value: "agriculture-hunting",
    label: "Fishing, Hunting, and Trapping"
  },
  {
    value: "agriculture-forestry",
    label: "Forestry and Logging"
  },
  {
    value: "agriculture-nurseries",
    label: "Nurseries"
  },
  {
    value: "agriculture-timber",
    label: "Timber"
  }
], o6 = (e) => e.value.startsWith("aerospace") ? "Aerospace and Defense" : e.value.startsWith("agriculture") ? "Agriculture and Forestry" : "No group", jr = (e) => e.startsWith("aerospace") ? "industry-aerospace" : e.startsWith("agriculture") ? "industry-agriculture" : "placeholder", a6 = X.withParams().create(({ theme: e, displayAbove: t, width: n }) => ({
  root: {
    // Remove width constraints
    ".MuiFormControl-root": {
      width: "100%"
    },
    ".MuiAutocomplete-root > div > div > div > div > div > div": {
      // This is the div described by `chipContainerSingleLine` in the <MultipleSelect> component.
      width: "100%"
    },
    // Give the autocomplete root a width so that the above `chipContainerSingleLine` can fit to its width.
    ".MuiAutocomplete-root": {
      width: "95%"
    },
    //".MuiFormControl-root .MuiPopper-root"
    ".MuiFormControl-root .MuiAutocomplete-popper": {
      top: t ? "-193px !important" : "42px !important",
      left: "-1rem !important",
      width: "100% !important"
    },
    // Set a background color
    ".MuiFormControl-root > div:nth-of-type(2) > div:first-of-type": {
      backgroundColor: e.palette.neutral.white
    },
    // Style group headers and options
    ".MuiListSubheader-root": {
      ...e.typography.overline,
      padding: "1.5rem 1rem 0.5rem 1rem"
    },
    ".MuiAutocomplete-groupUl": {
      margin: 0
    },
    ".MuiAutocomplete-option": {
      padding: "0 !important"
    },
    ".MuiOutlinedInput-root": {
      padding: "0 !important"
    }
  },
  addButton: {
    cursor: "pointer",
    border: 0,
    background: "transparent",
    padding: 0,
    position: "relative",
    top: "-0.375rem",
    right: "1px"
  },
  inactiveIcon: {
    color: e.palette.neutral[50]
  },
  activeIcon: {
    color: e.palette.primary["60-key"]
  },
  popper: {
    width: n ? `${n}px !important` : void 0,
    // Style group headers and options
    ".MuiListSubheader-root": {
      ...e.typography.overline,
      padding: "1rem 0.5rem 0.25rem 0.5rem"
    },
    ".MuiAutocomplete-option": {
      padding: "0 !important"
    }
  }
})), d2 = ({
  chips: e,
  focusToBeDeleted: t,
  isChipsBelow: n,
  handleDelete: o,
  parentTestId: a,
  chipsToBeDeleted: i = [],
  onClick: l
}) => {
  const { classes: c, cx: d } = H2();
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx("div", { className: c.belowChipsContainer, children: e.map((u, p) => /* @__PURE__ */ r.jsx("span", { className: c.belowChips, children: /* @__PURE__ */ r.jsx(
    _e,
    {
      testId: `${a ?? ""}-basic-${p.toString()}`,
      variant: "basic",
      onDelete: o,
      items: u,
      onClick: l,
      className: d({
        [c.focusedChip]: i.includes(u.id) && t
      })
    }
  ) }, p)) }) : e.map((u, p) => {
    const m = i.includes(u.id) && t;
    return /* @__PURE__ */ r.jsx("span", { className: c.wrappedChip, children: /* @__PURE__ */ r.jsx(
      _e,
      {
        testId: `${a ?? ""}-input-${p.toString()}`,
        variant: "input",
        onDelete: o,
        items: { ...u, selected: m },
        onClick: l,
        className: d({
          [c.focusedChip]: m && !u.error
        })
      }
    ) }, p);
  }) });
}, i6 = (e, t, n, o, a) => {
  if (a && e.length > 0) {
    const i = e[e.length - 1];
    if (i)
      return [i];
  } else {
    if (e.length === 0)
      return e;
    if (["selectOption", "removeOption"].includes(t)) {
      const i = n == null ? void 0 : n.option.value;
      return A1(o, i ?? "");
    }
  }
  return o;
}, l6 = ({
  disabled: e,
  singleValue: t = !1,
  pendingValues: n,
  selectedValues: o,
  setPendingValues: a,
  ...i
}) => /* @__PURE__ */ r.jsx(
  D2,
  {
    ...i,
    multiple: !0,
    disabled: !!e || t && o.length > 0,
    isPlaceholder: !1,
    options: c2,
    selectedValues: n,
    disableCloseOnSelect: !0,
    renderTags: () => null,
    limitTags: 0,
    handleOnChange: (l, c, d) => {
      a(
        i6(
          l,
          c,
          d,
          n,
          t
        )
      );
    }
  }
), s6 = ({
  id: e,
  testId: t = e,
  label: n,
  disabled: o = !1,
  singleValue: a = !1,
  variant: i = "default",
  selectedValues: l,
  externallySelectedValues: c = [],
  handleOnChange: d,
  multiple: u = !1,
  hasError: p = !1,
  errorMessage: m = "",
  helperMessage: g = "",
  readOnly: h = !1,
  labelHidden: C = !1
}) => {
  const v = Z(null), [b, f] = V(!1), y = Tt(v, (_) => {
    window.innerHeight - _.offsetTop < 150 && f(!0);
  }), { cx: w, classes: k } = a6({
    displayAbove: b,
    width: y
  }), [M, L] = V([]), j = M.length > 0;
  K(() => {
    const _ = M.filter(
      (B) => !c.includes(B)
    );
    M.length !== _.length && L(_);
  }, [M, c]);
  const N = {
    id: e,
    testId: t,
    disabled: o || a && l.length > 0,
    isPlaceholder: !1,
    //options: industryOptions,
    selectedValues: M,
    //disablePortal={false}
    label: n,
    isSingleLine: !0,
    hideSelectedOptions: !1,
    hasError: p,
    errorMessage: m,
    helperMessage: g,
    readOnly: h,
    labelHidden: C,
    rightIcon: /* @__PURE__ */ r.jsx(
      G,
      {
        buttonVariant: "icon",
        iconVariant: "primary",
        size: "medium",
        icon: "plus",
        title: "Add industries",
        onClick: (_) => {
          _.stopPropagation(), d(l.concat(M)), L([]);
        },
        className: w(k.addButton, {
          [k.inactiveIcon]: !j,
          [k.activeIcon]: j
        })
      }
    ),
    groupBy: o6,
    getOptionDisabled: (_) => c.includes(_.value) || l.includes(_.value),
    rotateRightIconOnOpen: !1,
    renderOption: (_, B) => {
      const { key: O, ...A } = _;
      return /* @__PURE__ */ r.jsx("li", { ...A, children: /* @__PURE__ */ r.jsx(
        Je,
        {
          id: O,
          avatar: /* @__PURE__ */ r.jsx(
            we,
            {
              icon: jr(B.value),
              iconAvatarColor: "primary"
            }
          ),
          heading: B.label,
          density: "default",
          variant: i,
          selected: c.includes(B.value) || l.includes(B.value) || M.includes(B.value)
        }
      ) }, O);
    }
  }, E = u ? /* @__PURE__ */ r.jsx(
    l6,
    {
      ...N,
      pendingValues: M,
      setPendingValues: L
    }
  ) : /* @__PURE__ */ r.jsx(
    D2,
    {
      ...N,
      options: c2,
      value: void 0,
      handleOnChange: (_) => {
        if (a && _.length > 0) {
          const B = _[_.length - 1];
          B && L([B]);
        } else
          L(_);
      }
    }
  ), $ = h && l.length === 0, S = /* @__PURE__ */ r.jsx(
    d2,
    {
      chips: rt(
        l.map((_) => {
          const B = c2.find(
            (O) => O.value === _
          );
          if (B)
            return {
              id: B.value,
              label: B.label,
              isRemovable: !0,
              showAvatar: !0,
              avatarIcon: jr(B.value)
            };
        })
      ),
      isChipsBelow: !0,
      focusToBeDeleted: !1,
      handleDelete: h ? void 0 : (_) => {
        const B = l.filter(
          (O) => O !== _
        );
        d(B);
      }
    }
  );
  return /* @__PURE__ */ r.jsxs("div", { ref: v, className: k.root, children: [
    h ? /* @__PURE__ */ r.jsx(a1, { htmlFor: "", disabled: o, hidden: C, children: n }) : E,
    $ ? /* @__PURE__ */ r.jsx(W, { children: "–" }) : S
  ] });
}, c6 = R()((e, { isExpanded: t, maintainSpaceForFooter: n }) => ({
  root: {
    ".MuiBackdrop-root": {
      backgroundColor: e.palette.overlay.primary
    },
    position: "fixed",
    inset: 0,
    zIndex: kn,
    backgroundColor: e.palette.neutral.white,
    boxShadow: e.namedShadows["depth-2"],
    maxWidth: "40rem",
    margin: "0 auto",
    marginTop: t ? "2rem !important" : "0",
    transition: "all 0.25s ease-in-out",
    borderTopLeftRadius: "0.5rem",
    borderTopRightRadius: "0.5rem",
    ":focus-visible": {
      outline: "none"
    }
  },
  rootClosing: {
    transform: "translate3d(0px, 100vh, 0px) !important"
  },
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  handle: {
    zIndex: 1,
    width: "2rem",
    height: "0.25rem",
    backgroundColor: e.palette.neutral[30],
    borderRadius: "0.25rem",
    top: "1rem"
  },
  headerPadding: {
    paddingTop: t ? "1rem" : "2rem"
  },
  headerPaddingLarge: {
    paddingTop: t ? "1.5rem" : "2rem"
  },
  headerPaddingSmall: {
    paddingTop: t ? "0.5rem" : "2rem"
  },
  headerContainer: {
    display: "flex",
    gap: "1rem",
    alignItems: "end",
    width: "100%",
    padding: "0 1.5rem 1rem 1.5rem"
  },
  headerContainerLarge: {
    padding: "0 1.5rem 1.5rem 1.5rem"
  },
  headerContainerSmall: {
    padding: t ? "0.5rem 1.5rem 0.5rem 1.5rem" : "0 1.5rem 0.5rem 1.5rem"
  },
  textContainer: {
    alignSelf: "center"
  },
  closeButton: {
    marginLeft: "auto"
  },
  listHeaderContainer: {
    padding: "1rem 1.5rem"
  },
  scrollView: {
    height: "100%",
    // This allows room for content to not be hidden beneath the footer.
    "& div[data-overlayscrollbars-contents]": {
      marginBottom: n ? "calc(41px + var(--snap-point-height)) !important" : void 0
    }
  },
  alertContainer: {
    padding: "1rem 1.5rem"
  },
  contentContainer: {
    height: "100%",
    padding: "1rem 1.5rem"
  },
  fullWidthContentContainer: {
    height: "100%",
    padding: "0"
  },
  footerContainer: {
    backgroundColor: e.palette.neutral.white,
    position: "absolute",
    left: 0,
    right: 0,
    bottom: "var(--snap-point-height)"
  },
  footerContents: {
    padding: "0.625rem 1.5rem"
  },
  backdrop: {
    position: "fixed",
    inset: 0,
    zIndex: E2,
    backgroundColor: e.palette.overlay.primary
  },
  visuallyHidden: ot
})), Sr = 30, d6 = 250, yt = "320px", u2 = 1, u6 = [yt, u2], T2 = ({
  open: e,
  onClose: t,
  children: n,
  headerProps: o,
  maintainSpaceForFooter: a = !1,
  footerProps: i,
  alertProps: l,
  listHeaderProps: c,
  contentSpacing: d = "default",
  variant: u = "standard",
  testId: p,
  closeThreshold: m = 0.35
}) => {
  const [g, h] = V(0), [C, v] = V(!1), [b, f] = V(yt), y = u === "standard", w = b === u2, k = !!i, { cx: M, classes: L } = c6({
    isExpanded: w,
    maintainSpaceForFooter: k && a
  });
  K(() => {
    e && (v(($) => $ && !1), f(yt));
  }, [e]);
  const j = () => {
    v(!0), t();
  }, N = ($) => {
    const S = +Date.now();
    S - g < d6 || (h(S), $.deltaY > 0 && $.deltaY > Sr ? f(u2) : $.deltaY < 0 && $.deltaY < -Sr && (w ? f(yt) : j()));
  }, E = (o == null ? void 0 : o.variant) ?? "default";
  return /* @__PURE__ */ r.jsxs(
    C1.Root,
    {
      snapPoints: u6,
      activeSnapPoint: b,
      setActiveSnapPoint: f,
      fadeFromIndex: 0,
      open: e,
      onOpenChange: ($) => {
        $ ? v(!1) : j();
      },
      closeThreshold: m,
      children: [
        /* @__PURE__ */ r.jsx(C1.Title, { className: L.visuallyHidden, children: (o == null ? void 0 : o.heading) ?? p }),
        /* @__PURE__ */ r.jsx(C1.Portal, { children: /* @__PURE__ */ r.jsxs(V2, { withinDrawer: !0, drawerVariant: "bottom", children: [
          /* @__PURE__ */ r.jsx(
            C1.Content,
            {
              className: M(L.root, {
                [L.rootClosing]: C
              }),
              children: /* @__PURE__ */ r.jsxs(
                "div",
                {
                  onWheel: ($) => N($),
                  "data-testid": p,
                  className: L.container,
                  children: [
                    !w && /* @__PURE__ */ r.jsx(
                      C1.Handle,
                      {
                        "data-testid": `${p ?? ""}-handle`,
                        className: L.handle
                      }
                    ),
                    /* @__PURE__ */ r.jsx(
                      "div",
                      {
                        className: M(L.headerPadding, {
                          [L.headerPaddingLarge]: E === "large",
                          [L.headerPaddingSmall]: E === "small" || !w && E === "default"
                        })
                      }
                    ),
                    o ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
                      /* @__PURE__ */ r.jsxs(
                        "div",
                        {
                          className: M(L.headerContainer, {
                            [L.headerContainerLarge]: E === "large",
                            [L.headerContainerSmall]: E === "small" || !w && E === "default"
                          }),
                          children: [
                            o.icon && /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(te, { name: o.icon }) }),
                            /* @__PURE__ */ r.jsxs("div", { className: L.textContainer, children: [
                              /* @__PURE__ */ r.jsx(W, { variant: "overline", children: o.overline }),
                              /* @__PURE__ */ r.jsx(W, { variant: "h3", children: o.heading })
                            ] }),
                            /* @__PURE__ */ r.jsx("div", { className: L.closeButton, children: o.showCloseButton && /* @__PURE__ */ r.jsx(C1.Close, { asChild: !0, children: /* @__PURE__ */ r.jsx(
                              G,
                              {
                                buttonVariant: "icon",
                                iconVariant: "neutral",
                                label: "close",
                                icon: "cross",
                                testId: `${p ?? ""}-close-button`
                              }
                            ) }) })
                          ]
                        }
                      ),
                      /* @__PURE__ */ r.jsx(Ce, {})
                    ] }) : null,
                    c && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
                      /* @__PURE__ */ r.jsx("div", { className: L.listHeaderContainer, children: /* @__PURE__ */ r.jsx(T1, { ...c }) }),
                      /* @__PURE__ */ r.jsx(Ce, {})
                    ] }),
                    /* @__PURE__ */ r.jsxs(ue, { className: L.scrollView, children: [
                      l && /* @__PURE__ */ r.jsx("div", { className: L.alertContainer, children: /* @__PURE__ */ r.jsx(Ke, { ...l }) }),
                      /* @__PURE__ */ r.jsx(
                        "div",
                        {
                          className: d === "fullWidth" ? L.fullWidthContentContainer : L.contentContainer,
                          "data-maintain-drawer": !0,
                          children: n
                        }
                      )
                    ] }),
                    (i == null ? void 0 : i.kind) === "breadcrumbs" ? /* @__PURE__ */ r.jsxs("div", { className: L.footerContainer, children: [
                      /* @__PURE__ */ r.jsx(Ce, {}),
                      /* @__PURE__ */ r.jsx("div", { className: L.footerContents, children: /* @__PURE__ */ r.jsx(Y2, { ...i.props, variant: "small" }) })
                    ] }) : null,
                    (i == null ? void 0 : i.kind) === "button" ? /* @__PURE__ */ r.jsx("div", { className: L.footerContainer, children: /* @__PURE__ */ r.jsx(
                      K2,
                      {
                        anySelected: i.props.anySelected,
                        onFooterClearAll: i.props.onFooterClearAll,
                        onFooterDone: i.props.onFooterDone
                      }
                    ) }) : null
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ r.jsx(
            C1.Overlay,
            {
              className: y ? void 0 : L.backdrop
            }
          )
        ] }) })
      ]
    }
  );
}, bp = ({
  requiredPermission: e,
  usersPermissions: t,
  children: n
}) => {
  const { translations: o } = Q();
  return t.includes(e) ? n : /* @__PURE__ */ r.jsx(
    ro,
    {
      icon: "lock",
      heading: o.restricted_access.heading,
      description: o.restricted_access.description
    }
  );
}, p6 = R()((e, { variant: t, selected: n }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.5rem",
    borderLeft: "0.25rem solid transparent",
    borderRadius: "0.25rem",
    ...t === "dark" && {
      backgroundColor: e.palette.brand["ia-gray"],
      "@media(hover: hover) and (pointer: fine)": {
        ":hover": {
          backgroundColor: e.palette.brand["ia-gray-shade-1"],
          borderLeft: `0.25rem solid ${e.palette.primary["60-key"]}`
        },
        ":active": {
          backgroundColor: e.palette.brand["ia-gray-shade-2"],
          borderLeft: `0.25rem solid ${e.palette.primary["60-key"]}`
        }
      }
    },
    ...t === "light" && {
      "@media(hover: hover) and (pointer: fine)": {
        ":hover": {
          backgroundColor: e.palette.neutral[20],
          borderLeft: `0.25rem solid ${e.palette.primary["60-key"]}`
        },
        ":active": {
          backgroundColor: e.palette.neutral[30],
          borderLeft: `0.25rem solid ${e.palette.primary["60-key"]}`
        }
      }
    }
  },
  rail: {
    width: "3.5rem"
  },
  badge: {
    position: "absolute",
    top: "0.5rem",
    right: "1rem",
    ">span": {
      display: "block"
    }
  },
  selected: {
    borderLeft: `0.25rem solid ${e.palette.primary["60-key"]}`,
    ...t === "dark" && {
      backgroundColor: e.palette.brand["ia-gray-shade-1"],
      ":hover": {
        backgroundColor: e.palette.brand["ia-gray-shade-2"]
      }
    },
    ...t === "light" && {
      backgroundColor: e.palette.primary[10],
      ":hover": {
        backgroundColor: e.palette.primary[30]
      }
    }
  },
  content: {
    ...t === "dark" && {
      color: e.palette.common.white
    },
    ...t === "light" && n && {
      color: e.palette.primary["60-key"]
    },
    gap: "0.5rem",
    display: "flex",
    alignItems: "center",
    textWrap: "nowrap",
    paddingLeft: "4px"
  },
  externalLinkIcon: {
    color: e.palette.neutral[50]
  }
})), m6 = ({
  icon: e,
  iconSelected: t,
  label: n,
  selected: o,
  onClick: a,
  to: i,
  chip: l,
  variant: c,
  railBadge: d,
  rail: u,
  externalLink: p,
  id: m,
  testId: g = m,
  linkComponent: h,
  ...C
}) => {
  const { cx: v, classes: b } = p6({ variant: c, selected: o }), f = Ve();
  return /* @__PURE__ */ r.jsx(
    tn,
    {
      ...C,
      ...a && { onClick: () => a(m) },
      ...i && {
        component: h,
        to: i,
        target: p ? "_blank" : void 0
      },
      title: u ? n : void 0,
      "data-testid": g,
      disableRipple: !0,
      className: v(b.root, {
        [b.selected]: o,
        [b.rail]: u
      }),
      children: u ? /* @__PURE__ */ r.jsxs("div", { className: v(b.content), children: [
        d && /* @__PURE__ */ r.jsx("div", { className: b.badge, children: /* @__PURE__ */ r.jsx(et, { size: "small", type: "primary", style: "dark" }) }),
        /* @__PURE__ */ r.jsx(te, { name: o && t ? t : e })
      ] }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        /* @__PURE__ */ r.jsxs("div", { className: v(b.content), children: [
          /* @__PURE__ */ r.jsx(te, { name: o && t ? t : e }),
          /* @__PURE__ */ r.jsx(
            W,
            {
              color: c === "dark" ? f.palette.neutral.white : "inherit",
              variant: "body1",
              children: n
            }
          )
        ] }),
        /* @__PURE__ */ r.jsxs("div", { className: b.content, children: [
          l && /* @__PURE__ */ r.jsx(
            _e,
            {
              testId: `${g}-chip`,
              items: { id: m, label: l },
              variant: "small",
              state: "primary",
              style: "dark"
            }
          ),
          p && /* @__PURE__ */ r.jsx(te, { name: "open", className: b.externalLinkIcon })
        ] })
      ] })
    }
  );
}, h6 = R()((e, { variant: t }) => ({
  paper: {
    overflow: "hidden",
    border: 0,
    padding: "0",
    ...t === "dark" && {
      backgroundColor: e.palette.brand["ia-gray"]
    },
    boxShadow: e.namedShadows["depth-2"]
  },
  root: {
    "& .MuiBackdrop-root": {
      backgroundColor: e.palette.overlay.primary
    }
  },
  permanent: {
    width: "16rem"
  },
  rail: {
    overflow: "hidden",
    transition: "width 0.15s ease-in",
    width: "4.5rem",
    "@media(hover: hover) and (pointer: fine)": {
      ":hover": {
        width: "16rem"
      }
    }
  },
  hidden: {
    display: "none"
  },
  modal: {
    borderTopRightRadius: "0.25rem",
    borderBottomRightRadius: "0.25rem"
  },
  nav: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    padding: "1rem 0.5rem 1rem 0.5rem"
  },
  sectionDivider: {
    padding: "0.5rem 0"
  },
  overline: {
    ...t === "dark" && {
      color: e.palette.common.white
    },
    ...t === "light" && {
      color: e.palette.neutral[80]
    },
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: "0.875rem",
    letterSpacing: "0.0375rem",
    textTransform: "uppercase",
    padding: "var(--overline-default-padding-top, 1rem) var(--overline-default-padding-right, 0.5rem) var(--overline-default-padding-bottom, 0.25rem) 1rem"
  },
  divider: {
    borderColor: t === "dark" ? e.palette.brand["ia-gray-shade-3"] : e.palette.neutral[30]
  },
  bottomContainer: {
    marginTop: "auto"
  },
  bottomLinksInnerContainer: {
    padding: "0.5rem"
  }
})), Dn = 1344, Tn = 840, wp = ({
  variant: e,
  sections: t,
  renderHeader: n,
  selectedId: o,
  withinMenu: a,
  isOpen: i,
  onClose: l,
  linkComponent: c,
  testId: d,
  drawerBottomItems: u
}) => {
  const { classes: p, cx: m } = h6({ variant: e }), g = Ve(), [h, C] = V(!1), v = $e(g.breakpoints.down(Dn)), b = $e(g.breakpoints.down(Tn)), f = v && !b && !a, y = f && h || !f, w = pn(), k = !b && w === "touch", M = Z(null);
  K(() => {
    if (!f || !h || k) return;
    const N = (E) => {
      var O;
      const $ = E.target, S = (O = M.current) == null ? void 0 : O.querySelector(".MuiDrawer-paper");
      if (S != null && S.contains($)) return;
      const _ = S == null ? void 0 : S.getBoundingClientRect();
      _ && E.clientX >= _.left && E.clientX <= _.right && E.clientY >= _.top && E.clientY <= _.bottom || !($ != null && $.closest(".MuiBackdrop-root")) && ($ != null && $.closest("[data-maintain-drawer]")) || C(!1);
    };
    return document.addEventListener("mousedown", N), () => document.removeEventListener("mousedown", N);
  }, [f, h, k]);
  const L = [
    ...t.flatMap((N) => N.items),
    ...u ?? []
  ].find((N) => N.id === o), j = (N) => N.map(({ id: E, to: $, onClick: S, ..._ }) => /* @__PURE__ */ r.jsx(
    m6,
    {
      linkComponent: c,
      ..._,
      id: E,
      to: (
        // Remove destination for React Router to prevent navigation when navigation is closed on mobile.
        k && !h ? void 0 : $
      ),
      rail: f && !h,
      selected: (L == null ? void 0 : L.id) === E,
      variant: e,
      ...k ? {
        onTouchEnd: (B) => {
          h ? (S == null || S(E), setTimeout(() => {
            C(!1);
          }, 200)) : (B.preventDefault(), C(!0));
        }
      } : w === "touch" ? {
        onTouchEnd: () => {
          S == null || S(E), setTimeout(() => {
            l == null || l();
          }, 100);
        }
      } : {
        onClick: (B, O) => {
          h && (S == null || S(B, O));
        }
      }
    },
    E
  ));
  return /* @__PURE__ */ r.jsx(
    rn,
    {
      ref: M,
      onClose: l,
      classes: {
        root: p.root,
        paper: m(p.paper, {
          [p.permanent]: !f || h,
          [p.rail]: f && !h,
          // intention here is if under a certain breakpoint and not within a menu, hide the navigation
          // so a button can appear elsewhere to show it in a menu
          [p.hidden]: b && !a,
          [p.modal]: !!a || h && f
        })
      },
      "data-testid": d,
      variant: a ? "temporary" : "permanent",
      open: a ? i : !0,
      ...k ? {
        onTouchEnd: () => {
          h || C(!0);
        }
      } : {
        onMouseEnter: () => C(!0),
        onMouseLeave: () => C(!1)
      },
      children: /* @__PURE__ */ r.jsxs("nav", { "aria-label": `Navigation for ${d}`, className: p.nav, children: [
        /* @__PURE__ */ r.jsx("header", { children: n({ isExpanded: y, setIsHovering: C }) }),
        /* @__PURE__ */ r.jsx(xt, { className: p.divider }),
        /* @__PURE__ */ r.jsx(ue, { children: /* @__PURE__ */ r.jsx("div", { className: p.section, children: t.map(({ items: N, showDivider: E = !0, label: $ }, S) => /* @__PURE__ */ r.jsxs(j2, { children: [
          y && $ && /* @__PURE__ */ r.jsx("span", { className: m(p.overline), children: $ }),
          j(N),
          E && !y && /* @__PURE__ */ r.jsx("div", { className: p.sectionDivider, children: /* @__PURE__ */ r.jsx(xt, { className: p.divider }) })
        ] }, S)) }) }),
        u && /* @__PURE__ */ r.jsxs("div", { className: p.bottomContainer, children: [
          /* @__PURE__ */ r.jsx(xt, { className: p.divider }),
          /* @__PURE__ */ r.jsx("div", { className: p.bottomLinksInnerContainer, children: j(u) })
        ] })
      ] })
    }
  );
}, Rn = X.create(({ theme: e }) => ({
  emailText: {
    ...e.typography.body3,
    color: e.palette.neutral[70]
  },
  loadingContainer: {
    width: "100%",
    position: "relative",
    top: "-1px"
  },
  nameLoading: {
    // NOTE: (2024-09-26) Noah Settersten => Reduce the height of the loading container by 2px to match the height of
    // the name and email text when loaded.
    marginBottom: "-2px"
  }
})), g6 = X.create({
  header: {
    display: "flex",
    alignItems: "center",
    padding: "1rem",
    gap: "0.5rem",
    textWrap: "nowrap",
    width: "100%"
  },
  headerText: {
    width: "11rem"
  }
}), C6 = ({ text: e }) => /* @__PURE__ */ r.jsx(
  Ot,
  {
    text: e,
    visibleLength: 25,
    tooltipTestId: "navigation-user-name-tooltip",
    typographyProps: {
      variant: "h4"
    }
  }
), v6 = ({ user: e }) => {
  const { classes: t } = Rn();
  return /* @__PURE__ */ r.jsx(
    Ot,
    {
      text: e.primaryEmailAddress,
      visibleLength: 29,
      tooltipTestId: "navigation-user-email-tooltip",
      typographyProps: {
        className: t.emailText
      }
    }
  );
}, f6 = ({ user: e }) => {
  const { classes: t } = Rn();
  if (!e)
    return /* @__PURE__ */ r.jsxs("div", { className: t.loadingContainer, children: [
      /* @__PURE__ */ r.jsx(me, { variant: "text", className: t.nameLoading }),
      /* @__PURE__ */ r.jsx(me, { variant: "text", className: t.emailText })
    ] });
  const n = !(e.firstName && e.lastName), o = n ? e.primaryEmailAddress : `${e.firstName} ${e.lastName}`;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(C6, { text: o }),
    n ? null : /* @__PURE__ */ r.jsx(v6, { user: e })
  ] });
}, yp = ({
  user: e,
  isExpanded: t
}) => {
  const { classes: n } = g6(), o = e !== void 0;
  return /* @__PURE__ */ r.jsxs("div", { className: n.header, children: [
    o ? /* @__PURE__ */ r.jsx(we, { ...zn(e) }) : /* @__PURE__ */ r.jsx(R1, { variant: "avatar" }),
    t && /* @__PURE__ */ r.jsx("div", { className: n.headerText, children: /* @__PURE__ */ r.jsx(f6, { user: e }) })
  ] });
}, x6 = X.create(({ theme: e }) => ({
  label: {
    ...e.typography.label,
    marginBottom: "0.75rem"
  }
})), Fn = {
  headings: {
    height: "1.5rem",
    marginBottom: "0.5rem"
  }
}, b6 = X.create(() => ({
  ...Fn
})), w6 = X.create(() => ({
  root: {
    paddingTop: "1rem"
  },
  actionBar: {
    marginBottom: "1rem"
  },
  ...Fn
})), R2 = X.create(() => ({
  sizeTiny: {
    width: "1.25rem",
    height: "1.25rem"
  },
  sizeSmall: {
    width: "1.5rem",
    height: "1.5rem"
  },
  sizeMedium: {
    width: "2.5rem",
    height: "2.5rem"
  },
  sizeLarge: {
    width: "5rem",
    height: "5rem"
  }
})), y6 = X.create(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
    height: "100%",
    padding: "1rem"
  },
  avatarContainer: {
    position: "relative",
    height: "100%",
    marginRight: "1rem"
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minHeight: "2.5rem",
    justifyContent: "center",
    gap: "0.375rem"
  }
}));
X.create(() => ({
  root: {
    "& .MuiPaper-root": {
      position: "relative"
    }
  }
}));
const zn = (e) => e == null ? {
  variant: "icon",
  icon: "person-outlined"
} : vn(e.avatarUrl) ? {
  variant: "image",
  imageUrl: e.avatarUrl
} : {
  variant: "text",
  text: L2(e),
  textForAvatarColor: e.id
}, Lr = [
  "first",
  "second",
  "third",
  "fourth",
  "fifth",
  "sixth"
], k6 = (e) => {
  if (!e) return "neutral";
  const n = _2(e) % Lr.length;
  return Lr[n] ?? "first";
}, kp = {
  default: "4.5rem",
  sm: "3.5rem"
}, j6 = R()((e) => ({
  root: {
    position: "sticky",
    top: 0,
    width: "100%",
    backgroundColor: e.palette.background.paper,
    zIndex: M2,
    height: "var(--app-bar-height, 3.5rem)"
  },
  scrolling: {
    boxShadow: e.namedShadows["depth-down"]
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 1.5rem",
    height: "4.5rem",
    [e.breakpoints.down("sm")]: {
      padding: "10px 1rem 10px 1rem",
      height: "var(--app-bar-height, 3.5rem)"
    }
  },
  content: {
    display: "flex",
    alignItems: "center"
  },
  title: {
    flex: 1,
    overflow: "hidden"
  },
  publicFacingLogo: {
    display: "grid",
    placeItems: "center",
    marginRight: "0.375rem",
    [e.breakpoints.down("sm")]: {
      " > svg": {
        width: "2rem",
        height: "2rem"
      }
    }
  },
  signInButton: {
    height: "2.25rem"
  },
  avatarSkeleton: {
    display: "inline-flex",
    width: "2.25rem",
    height: "2.25rem",
    alignItems: "center",
    justifyContent: "center"
  },
  menuList: {
    paddingTop: 0,
    paddingBottom: 0
  }
})), Ft = R()(
  (e, { withinDrawer: t }) => ({
    list: {
      boxShadow: "none"
    },
    spacing: {
      ...!t && {
        width: "20rem"
      },
      ...t && {
        minWidth: "20rem",
        maxWidth: "unset !important"
      }
    },
    accountHeader: {
      display: "flex",
      gap: "1rem",
      padding: "1.5rem"
    },
    email: {
      ...e.typography.body3,
      color: e.palette.neutral[70]
    },
    openSvg: {
      position: "relative",
      right: "-0.275rem"
    },
    userNameContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: "216px"
    },
    loadingUserNameContainer: {
      position: "relative",
      top: "-2px"
    }
  })
), S6 = {
  "help-center": "https://support.inductiveautomation.com/hc/en-us"
}, pt = (e, t, n, o) => ({
  id: e,
  size: "spacious",
  label: t,
  iconLeft: n,
  ...o
}), Mr = (e, t) => ({
  variant: "spacious",
  items: e,
  itemComponent: Se,
  onSelection: t
}), Er = ({ text: e }) => /* @__PURE__ */ r.jsx(
  Ot,
  {
    text: e,
    visibleLength: 26,
    tooltipTestId: "user-name-tooltip",
    typographyProps: {
      variant: "h3"
    }
  }
), L6 = ({ user: e }) => {
  const { classes: t } = Ft({ withinDrawer: !1 });
  return /* @__PURE__ */ r.jsx(
    Ot,
    {
      text: e.primaryEmailAddress,
      visibleLength: 35,
      tooltipTestId: "user-email-tooltip",
      typographyProps: {
        className: t.email
      }
    }
  );
}, M6 = ({ user: e }) => {
  const { classes: t } = Ft({ withinDrawer: !1 });
  return e === void 0 ? /* @__PURE__ */ r.jsxs("div", { className: t.loadingUserNameContainer, children: [
    /* @__PURE__ */ r.jsx(me, { variant: "text" }),
    /* @__PURE__ */ r.jsx(me, { variant: "text", className: t.email })
  ] }) : !e.firstName || !e.lastName ? /* @__PURE__ */ r.jsx(Er, { text: e.primaryEmailAddress }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(Er, { text: `${e.firstName} ${e.lastName}` }),
    /* @__PURE__ */ r.jsx(L6, { user: e })
  ] });
}, E6 = ({
  avatar: e,
  user: t,
  translations: n,
  actions: { onManageAccount: o, onViewProfile: a, onSignOut: i }
}) => {
  const { withinDrawer: l } = H1(), { cx: c, classes: d } = Ft({ withinDrawer: l }), { manageAccount: u, viewProfile: p, helpCenter: m, signOut: g } = n, h = ({ id: f }) => {
    if (f === "manage-account")
      o();
    else if (f === "view-profile")
      a();
    else if (f === "sign-out")
      i();
    else {
      const y = S6[f];
      typeof window < "u" && y && window.open(y, "_blank");
    }
  }, C = {
    iconRight: "open-small",
    iconRightVariant: "neutralLight",
    iconRightClassName: d.openSvg
  }, v = [
    pt("manage-account", u, "person-outlined"),
    ...t != null && t.publicProfileEnabled ? [pt("view-profile", p, "person-public-outlined")] : []
  ], b = [
    pt("help-center", m, "help-outlined", C),
    pt("sign-out", g, "signout")
  ];
  return /* @__PURE__ */ r.jsxs("div", { className: d.spacing, children: [
    /* @__PURE__ */ r.jsxs("div", { className: d.accountHeader, children: [
      /* @__PURE__ */ r.jsx(we, { ...e }),
      /* @__PURE__ */ r.jsx("div", { className: d.userNameContainer, children: /* @__PURE__ */ r.jsx(M6, { user: t }) })
    ] }),
    /* @__PURE__ */ r.jsx(Ce, {}),
    /* @__PURE__ */ r.jsx(
      Ie,
      {
        className: c(d.list, d.spacing),
        variant: "spacious",
        lists: [
          Mr(v, h),
          Mr(b, h)
        ]
      }
    )
  ] });
}, N6 = ({
  workspacesUrl: e,
  workspaceFeatureFlag: t,
  translations: n
}) => {
  const { withinDrawer: o } = H1(), { cx: a, classes: i } = Ft({ withinDrawer: o }), l = (d) => {
    var p;
    const u = (p = c.find((m) => m.id === d.id)) == null ? void 0 : p.href;
    typeof window < "u" && u && window.open(u, "_blank");
  }, c = [
    {
      id: "community-forums",
      label: n.community_forums,
      iconLeft: "forums",
      iconRight: "open-small",
      iconRightVariant: "neutralLight",
      iconRightClassName: i.openSvg,
      size: "spacious",
      href: "https://forum.inductiveautomation.com/"
    },
    {
      id: "customer-feedback",
      label: n.customer_feedback,
      iconLeft: "feedback",
      iconRight: "open-small",
      iconRightVariant: "neutralLight",
      iconRightClassName: i.openSvg,
      size: "spacious",
      href: "https://ideas.inductiveautomation.com/"
    },
    {
      id: "inductive-automation",
      label: n.inductive_automation,
      iconLeft: "ia",
      iconRight: "open-small",
      iconRightVariant: "neutralLight",
      iconRightClassName: i.openSvg,
      size: "spacious",
      href: "https://inductiveautomation.com/"
    },
    {
      id: "inductive-university",
      label: n.inductive_university,
      iconLeft: "iu",
      iconRight: "open-small",
      iconRightVariant: "neutralLight",
      iconRightClassName: i.openSvg,
      size: "spacious",
      href: "https://www.inductiveuniversity.com/"
    },
    {
      id: "integrator-account",
      label: n.integrator_account,
      iconLeft: "engineer",
      iconRight: "open-small",
      iconRightVariant: "neutralLight",
      iconRightClassName: i.openSvg,
      size: "spacious",
      href: "https://inductiveautomation.com/integrators/home"
    },
    {
      id: "ignition-exchange",
      label: n.ignition_exchange,
      iconLeft: "exchange",
      iconRight: "open-small",
      iconRightVariant: "neutralLight",
      iconRightClassName: i.openSvg,
      size: "spacious",
      href: "https://inductiveautomation.com/exchange/"
    },
    ...t ? [
      {
        id: "workspaces",
        label: n.workspaces,
        iconLeft: "organization-inverse",
        iconRight: "open-small",
        iconRightVariant: "neutralLight",
        iconRightClassName: i.openSvg,
        size: "spacious",
        href: e
      }
    ] : []
  ];
  return /* @__PURE__ */ r.jsx("div", { className: i.spacing, children: /* @__PURE__ */ r.jsx(
    l1,
    {
      items: c,
      itemComponent: Se,
      variant: "spacious",
      onSelection: l,
      containerClassName: a(i.list),
      fullHeight: !0
    }
  ) });
}, jp = ({
  title: e,
  user: t,
  onNavigationMenuClick: n,
  translations: o,
  actions: a,
  workspacesUrl: i,
  workspaceFeatureFlag: l,
  publicFacing: c = !1,
  loading: d
}) => {
  const { cx: u, classes: p } = j6(), { classes: m } = R2(), [g, h] = V(!1), [C, v] = V("initial"), [b, f] = V(null), y = Z(null), w = Z(null), k = Ve(), M = $e(k.breakpoints.down(840));
  K(() => {
    if (typeof window < "u") {
      const j = () => {
        h(window.scrollY > 0);
      };
      return window.addEventListener("scroll", j), () => window.removeEventListener("scroll", j);
    }
  }, []);
  const L = zn(
    d ? void 0 : t
  );
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: u(p.root, { [p.scrolling]: g }),
      children: [
        /* @__PURE__ */ r.jsxs("div", { className: p.container, children: [
          /* @__PURE__ */ r.jsxs("div", { className: u(p.content, p.title), children: [
            c ? /* @__PURE__ */ r.jsx("div", { className: p.publicFacingLogo, children: /* @__PURE__ */ r.jsx(te, { name: "ia-gear-public-profile" }) }) : null,
            M && !c && /* @__PURE__ */ r.jsx(
              G,
              {
                testId: "app-bar-nav-button",
                buttonVariant: "icon",
                icon: "menu",
                iconVariant: "neutral",
                onClick: n
              }
            ),
            /* @__PURE__ */ r.jsx("div", { className: p.title, children: /* @__PURE__ */ r.jsx(Y2, { testId: "app-bar-title", items: e }) })
          ] }),
          /* @__PURE__ */ r.jsxs("div", { className: p.content, children: [
            /* @__PURE__ */ r.jsx("div", { ref: y, children: /* @__PURE__ */ r.jsx(
              he,
              {
                title: o.appServicesTooltip,
                testId: "app-bar-app-services-tooltip",
                placement: "bottom",
                children: /* @__PURE__ */ r.jsx(
                  G,
                  {
                    testId: "app-bar-app-services-button",
                    buttonVariant: "icon",
                    "aria-label": o.appServicesTooltip,
                    icon: "apps",
                    iconVariant: "neutral",
                    onClick: () => {
                      v("appServices"), f(y.current);
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ r.jsx("div", { ref: w, children: d ? /* @__PURE__ */ r.jsx("span", { className: p.avatarSkeleton, children: /* @__PURE__ */ r.jsx(
              me,
              {
                variant: "circular",
                className: m.sizeSmall
              }
            ) }) : t ? /* @__PURE__ */ r.jsx(
              he,
              {
                title: o.accountTooltip,
                testId: "app-bar-account-tooltip",
                placement: "bottom",
                children: /* @__PURE__ */ r.jsx(
                  G,
                  {
                    testId: "app-bar-account-button",
                    buttonVariant: "avatar",
                    "aria-label": o.accountTooltip,
                    iconVariant: "neutral",
                    onClick: () => {
                      v("account"), f(w.current);
                    },
                    children: /* @__PURE__ */ r.jsx(we, { ...L, size: "small" })
                  }
                )
              }
            ) : /* @__PURE__ */ r.jsx(
              G,
              {
                testId: "app-bar-sign-in-button",
                buttonVariant: "tertiary",
                label: o.signIn,
                className: p.signInButton,
                onClick: a.onSignIn
              }
            ) })
          ] }),
          /* @__PURE__ */ r.jsx(
            ze,
            {
              anchor: C !== "initial" ? b : null,
              onClose: () => {
                f(null), v("initial");
              },
              children: /* @__PURE__ */ r.jsxs("div", { children: [
                C === "appServices" && /* @__PURE__ */ r.jsx(
                  N6,
                  {
                    workspacesUrl: i,
                    workspaceFeatureFlag: l,
                    translations: o.services
                  }
                ),
                C === "account" && /* @__PURE__ */ r.jsx(
                  E6,
                  {
                    avatar: L,
                    user: t,
                    actions: a,
                    translations: o.account
                  }
                )
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ r.jsx(Ce, {})
      ]
    }
  );
}, Wn = qe.createContext({
  withinScrollView: !1
}), I6 = X.create(({ theme: e }) => ({
  root: {
    "&:focus-visible": {
      outline: `1px solid ${e.palette.primary["60-key"]}`
    }
  }
})), ue = ({
  ref: e,
  children: t,
  className: n,
  style: o,
  theme: a,
  onScroll: i,
  onInitialized: l,
  disableVerticalScroll: c,
  removeFromTabOrder: d = !1
}) => {
  const { cx: u, classes: p } = I6();
  return /* @__PURE__ */ r.jsx(
    La,
    {
      ref: e,
      tabIndex: d ? -1 : 0,
      events: { scroll: i, initialized: l },
      options: {
        scrollbars: {
          autoHide: "leave",
          autoHideDelay: 650,
          // Default is 1300
          //autoHideSuspend: true,
          theme: a ?? null
        },
        overflow: {
          y: c ? "hidden" : "scroll"
        }
      },
      className: u(p.root, n),
      style: o,
      defer: !0,
      children: /* @__PURE__ */ r.jsx(Wn.Provider, { value: { withinScrollView: !0 }, children: t })
    }
  );
}, $6 = R()((e) => ({
  root: {
    borderBottom: `1px solid ${e.palette.neutral[30]}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "0.5rem"
  },
  tabBarRoot: {
    width: "100%"
  },
  indicator: {
    backgroundColor: e.palette.primary["60-key"],
    height: "0.25rem",
    borderRadius: "0.25rem 0.25rem 0 0"
  },
  tabRoot: {
    ...e.typography.h3,
    minWidth: 0,
    textTransform: "none",
    padding: "0.75rem 0px",
    height: "3.438rem",
    paddingLeft: "0.125rem",
    paddingRight: "0.125rem",
    border: "2px solid transparent",
    position: "relative",
    overflow: "visible",
    ":hover:after": {
      content: '""',
      display: "block",
      position: "absolute",
      bottom: "-2px",
      left: 0,
      right: 0,
      height: "0.25rem",
      backgroundColor: e.palette.neutral[50],
      borderRadius: "0.25rem 0.25rem 0 0"
    },
    ":focus-visible": {
      border: `2px solid ${e.palette.primary["60-key"]}`,
      backgroundColor: e.palette.primary[10],
      borderRadius: "0.25rem"
    }
  },
  firstTab: {
    marginLeft: "1.5rem"
  },
  lastTab: {
    paddingRight: "1.5rem"
  },
  flexContainer: {
    gap: "1.5rem"
  },
  scroller: {
    width: "100%",
    marginLeft: "-2.5rem",
    marginRight: "-2.5rem"
  },
  selectedTab: {
    color: `${e.palette.primary["60-key"]} !important`
  },
  disabledTab: {
    color: `${e.palette.neutral[50]} !important`
  },
  hoverIndicator: {
    backgroundColor: e.palette.neutral[50],
    height: "0.25rem",
    borderRadius: "0.25rem 0.25rem 0 0"
  },
  // hover and active state hex codes are solid-color versions
  // of the standard icon-primary color at different opacities
  // these need to be non-transparent to prevent content
  // from showing through during hover / active states
  scrollButtons: {
    zIndex: 2,
    opacity: "1",
    height: "2.25rem",
    width: "2.25rem",
    position: "relative",
    top: "0.563rem",
    borderRadius: "100%",
    marginRight: "-0.063rem",
    marginLeft: "-0.063rem",
    "&:hover": {
      backgroundColor: "#F7F7F7",
      opacity: 1
    },
    "&:active": {
      backgroundColor: "#EBEBEB"
    },
    "&:focus-visible": {
      outline: `1px solid ${e.palette.primary["60-key"]}`,
      backgroundColor: "#EBEBEB",
      outlineOffset: "1px"
    },
    "&:disabled": {
      color: e.palette.neutral[80],
      opacity: "0.4"
    },
    // disables the ripple effect on the scroll buttons
    "> span": {
      height: 0,
      width: 0
    }
  },
  scrollButtonIcon: {
    borderRadius: "100%",
    height: "2.25rem",
    width: "2.25rem",
    "&:hover": {
      backgroundColor: "#F7F7F7",
      background: "transparent"
    },
    "&:active": {
      backgroundColor: "#EBEBEB"
    },
    "&:focus-visible": {
      outline: `1px solid ${e.palette.primary["60-key"]}`,
      backgroundColor: "#EBEBEB",
      outlineOffset: "1px"
    },
    "&:disabled": {
      color: e.palette.neutral[80],
      opacity: "0.4"
    },
    svg: {
      height: "1.5rem",
      width: "1.5rem"
    }
  },
  scrollLeft: {
    background: "linear-gradient(to left, transparent 0%, white 50%)",
    opacity: 1,
    height: "100%",
    overflow: "visible"
  },
  scrollRight: {
    background: "linear-gradient(to right, transparent 0%, white 50%)",
    opacity: 1,
    height: "100%",
    overflow: "visible"
  },
  labelContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.25rem"
  },
  closeButton: {
    marginRight: "1rem"
  }
})), On = ({
  items: e,
  value: t,
  onChange: n,
  testId: o,
  onClose: a,
  scrollButtons: i
}) => {
  const { translations: l } = Q(), { classes: c, cx: d } = $6(), [u, p] = V(!1), m = i ?? (e.length <= 3 ? !1 : "auto"), g = Te(
    (h) => {
      h != null && h.current ? p(!0) : p(!1);
    },
    []
  );
  return /* @__PURE__ */ r.jsxs("div", { className: c.root, children: [
    /* @__PURE__ */ r.jsx(
      Ma,
      {
        value: t,
        "data-testid": o,
        onChange: (h, C) => {
          n(C);
        },
        variant: "scrollable",
        scrollButtons: m,
        classes: {
          root: c.tabBarRoot,
          indicator: c.indicator,
          scroller: u ? c.scroller : void 0,
          scrollButtons: c.scrollButtons,
          flexContainer: c.flexContainer
        },
        slots: {
          StartScrollButtonIcon: (h) => /* @__PURE__ */ r.jsx(
            sr,
            {
              disableRipple: !0,
              ref: g,
              direction: "left",
              orientation: "horizontal",
              className: d(c.scrollLeft, c.scrollButtonIcon),
              ...h
            }
          ),
          EndScrollButtonIcon: (h) => /* @__PURE__ */ r.jsx(
            sr,
            {
              disableRipple: !0,
              ref: g,
              direction: "right",
              orientation: "horizontal",
              className: d(c.scrollRight, c.scrollButtonIcon),
              ...h
            }
          )
        },
        children: e.map((h, C) => /* @__PURE__ */ r.jsx(
          Ea,
          {
            disableRipple: !0,
            classes: {
              selected: c.selectedTab,
              root: c.tabRoot,
              disabled: c.disabledTab
            },
            className: d({
              [c.firstTab]: C === 0,
              [c.lastTab]: C === e.length - 1 && u
            }),
            "data-testid": h.testId,
            value: h.value,
            label: /* @__PURE__ */ r.jsxs("div", { className: c.labelContainer, children: [
              h.label,
              h.chipLabel ? /* @__PURE__ */ r.jsx(
                _e,
                {
                  testId: `${h.testId ?? ""}-chip`,
                  variant: "small",
                  state: h.chipState,
                  items: [{ id: h.chipLabel, label: h.chipLabel }]
                }
              ) : void 0,
              h.badgeProps ? /* @__PURE__ */ r.jsx(et, { ...h.badgeProps, size: "medium" }) : void 0
            ] }),
            disabled: h.disabled
          },
          h.value
        ))
      }
    ),
    a && /* @__PURE__ */ r.jsx(
      G,
      {
        className: c.closeButton,
        buttonVariant: "icon",
        iconVariant: "neutral",
        label: l.common.close,
        onClick: a,
        testId: `${o ?? ""}-close-button`,
        icon: "cross"
      }
    )
  ] });
}, X1 = 320, S1 = [];
let Nt = !1;
const Zn = (e) => {
  if (e.key !== "Escape") return;
  const t = S1[S1.length - 1], n = t == null ? void 0 : t.getHandler();
  n && (e.stopPropagation(), e.preventDefault(), n());
}, _6 = () => {
  Nt || (window.addEventListener("keydown", Zn, { capture: !0 }), Nt = !0);
}, V6 = () => {
  S1.length > 0 || !Nt || (window.removeEventListener("keydown", Zn, { capture: !0 }), Nt = !1);
}, Pn = (e, t) => {
  const n = Z(t);
  K(() => {
    n.current = t;
  }), K(() => {
    if (!e) return;
    const o = { getHandler: () => n.current };
    return S1.push(o), _6(), () => {
      const a = S1.lastIndexOf(o);
      a !== -1 && S1.splice(a, 1), V6();
    };
  }, [e]);
}, zt = 480, A6 = R()((e, { hasAlert: t, minWidth: n, maxWidth: o, open: a }) => ({
  root: {
    position: "relative",
    overflow: "hidden",
    pointerEvents: a ? void 0 : "none"
  },
  paper: {
    minWidth: n
  },
  paperModal: {
    maxWidth: o,
    borderTopLeftRadius: "0.25rem",
    borderBottomLeftRadius: "0.25rem",
    boxShadow: e.namedShadows["depth-2"],
    [e.breakpoints.down(zt)]: {
      minWidth: "100%",
      maxWidth: "100%",
      borderRadius: 0,
      boxShadow: "unset"
    }
  },
  paperStandard: {
    position: "static",
    height: "100%",
    maxWidth: o,
    borderLeft: `1px solid ${e.palette.neutral[30]}`,
    borderRadius: 0,
    boxShadow: "unset"
  },
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column"
  },
  listHeaderContainer: {
    padding: "1rem 1.5rem"
  },
  scrollView: {
    height: "100%",
    "[data-overlayscrollbars-contents]": {
      overscrollBehavior: "contain"
    }
  },
  scrollViewWithFooter: {},
  alertContainer: {
    padding: "1.5rem"
  },
  fullWidthContentContainer: {
    height: "100%",
    padding: 0
  },
  contentContainer: {
    minHeight: "100%",
    height: "100%",
    padding: t ? "0 1.5rem 1.5rem 1.5rem" : "1.5rem"
  },
  footerContainer: {
    marginTop: "auto"
  }
})), B6 = R()((e) => ({
  root: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
    width: "100%",
    padding: "1.5rem 1rem 1.5rem 1.5rem",
    [e.breakpoints.down(zt)]: {
      padding: "1rem 1rem 1rem 1.5rem"
    }
  },
  textContainer: {
    alignSelf: "center"
  },
  closeButton: {
    marginLeft: "auto"
  }
})), H6 = R()((e) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1.5rem 1rem 1.5rem 1rem",
    [e.breakpoints.down(zt)]: {
      padding: "1rem"
    }
  },
  rootWithoutActions: {
    justifyContent: "right"
  },
  actionMenuPlaceholder: {
    visibility: "hidden"
  }
})), Sp = R()(() => ({
  contentSectionContainer: {
    padding: "0 1.5rem",
    "&:last-child": {
      paddingBottom: "1.5rem"
    }
  }
})), D6 = ({
  parentTestId: e,
  icon: t,
  iconComponent: n,
  avatarProps: o,
  overline: a,
  heading: i,
  showCloseButton: l,
  onClose: c
}) => {
  const { translations: d } = Q(), { classes: u } = B6();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: u.root, children: [
      n || (t ? /* @__PURE__ */ r.jsx(we, { iconAvatarColor: "neutral", ...o, icon: t }) : /* @__PURE__ */ r.jsx(we, { variant: "image", ...o })),
      /* @__PURE__ */ r.jsxs("div", { className: u.textContainer, children: [
        /* @__PURE__ */ r.jsx(W, { variant: "overline", component: "div", children: a }),
        /* @__PURE__ */ r.jsx(W, { variant: "h3", children: i })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: u.closeButton, children: l ? /* @__PURE__ */ r.jsx(
        G,
        {
          testId: `${e ?? ""}-close-button`,
          buttonVariant: "icon",
          iconVariant: "neutral",
          label: d.common.close,
          onClick: c,
          icon: "cross"
        }
      ) : null })
    ] }),
    /* @__PURE__ */ r.jsx(Ce, {})
  ] });
}, T6 = (e) => {
  if (e.iconLeftVariant === "destructive" || e.iconRightVariant === "destructive")
    return "destructive";
  if (e.iconLeftVariant === "documentation" || e.iconRightVariant === "documentation")
    return "documentation";
}, F2 = (e) => e.map((t) => ({
  ...t,
  variant: T6(t)
})), R6 = ({
  parentTestId: e,
  actionsLabel: t,
  actions: n = [],
  chip: o
}) => {
  const { cx: a, classes: i } = H6(), [l, c] = V(null), d = t && n.length > 0, u = n.map((g) => ({
    items: F2(g),
    itemComponent: Se,
    onSelection: ({ id: h }, C) => {
      const v = g.find((b) => b.id === h);
      v == null || v.onClick(v.id, [h]), C == null || C.stopPropagation(), c(null);
    }
  })), p = o ? /* @__PURE__ */ r.jsx(
    _e,
    {
      testId: o.testId ?? o.id,
      state: o.state,
      variant: o.variant,
      items: [o]
    }
  ) : null, m = n.flat().length > 0 ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      G,
      {
        testId: `${e ?? ""}-footer-actions`,
        buttonVariant: "menuTertiary",
        label: t,
        onClick: (g) => c(g.currentTarget)
      }
    ),
    /* @__PURE__ */ r.jsx(
      ze,
      {
        anchor: l,
        onClose: () => c(null),
        leftAligned: !0,
        menuProps: {
          anchorToTop: !0
        },
        children: /* @__PURE__ */ r.jsx(
          Ie,
          {
            lists: u,
            testId: `${e ?? ""}-actions`
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ r.jsx(
    G,
    {
      disabled: !0,
      testId: `${e ?? ""}-footer-actions`,
      buttonVariant: "menuTertiary",
      label: t
    }
  );
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: a(i.root, {
        [i.rootWithoutActions]: !d
      }),
      children: [
        t && n.length > 0 ? m : /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "menuTertiary",
            className: i.actionMenuPlaceholder
          }
        ),
        o && o.tooltipText ? /* @__PURE__ */ r.jsx(he, { testId: `${o.testId}-tooltip`, title: o.tooltipText, children: p }) : p
      ]
    }
  );
}, F6 = 1024, z6 = () => {
  const e = Ve();
  return $e(
    e.breakpoints.down(F6)
  );
}, qn = 1024, W6 = 480, O6 = (e) => {
  var n;
  if (!e) return;
  const t = !!e.closest(".MuiMenu-root");
  return !!e.dataset.maintainDrawer || !!((n = e.parentElement) != null && n.dataset.maintainDrawer) || !!e.closest("[data-maintain-drawer]") || t;
}, Un = ({
  testId: e,
  variant: t = "standard",
  hideBackdrop: n,
  open: o,
  onClose: a,
  children: i,
  minWidth: l = zt,
  maxWidth: c = W6,
  headerProps: d,
  tabBarProps: u,
  listHeaderProps: p,
  alertProps: m,
  contentSpacing: g,
  footerProps: h
}) => {
  const { cx: C, classes: v } = A6({
    hasAlert: !!m,
    minWidth: l,
    maxWidth: c,
    open: o
  }), f = z6() ? "modal" : t, y = !!d && f === "modal", w = Z(null), k = () => {
    if (w.current) {
      const j = w.current.getElement();
      j && cr(j);
    }
    a();
  };
  Pn(o && f === "modal", k);
  const M = Z(null), L = Z(null);
  return K(() => {
    var j;
    if (o) {
      L.current = document.activeElement;
      const N = requestAnimationFrame(() => {
        var E, $;
        ($ = (E = M.current) == null ? void 0 : E.querySelector(".MuiDrawer-paper")) == null || $.focus({ preventScroll: !0 });
      });
      return () => cancelAnimationFrame(N);
    }
    (j = L.current) == null || j.focus({ preventScroll: !0 }), L.current = null;
  }, [o]), Dt(M, (j) => {
    if (t === "modal") {
      const N = j.target;
      O6(N) || k();
    }
  }), /* @__PURE__ */ r.jsx(V2, { withinDrawer: !0, drawerVariant: "side", children: /* @__PURE__ */ r.jsxs(
    rn,
    {
      "data-testid": e,
      ref: M,
      ModalProps: {
        disableScrollLock: !0,
        disableEscapeKeyDown: !0,
        disableAutoFocus: !0,
        disableRestoreFocus: !0
        // NOTE: (2024-10-19) Noah Settersten => We can achieve the same visual effect as the hideBackdrop prop by
        // using the below. This resolves an issue where the page content has aria-hidden set to true but is still
        // focusable, at the expense of removing the ability to select another item without first closing the drawer.
        // slotProps: {
        //   backdrop: {
        //     invisible: true,
        //   },
        // },
      },
      classes: {
        root: v.root,
        paper: C(v.paper, {
          [v.paperModal]: f === "modal",
          [v.paperStandard]: f === "standard"
        })
      },
      anchor: "right",
      open: o,
      hideBackdrop: f === "standard" || n,
      variant: f === "standard" ? "persistent" : "temporary",
      onMouseOver: () => {
        if (w.current) {
          const j = w.current.getElement();
          j && Na(j);
        }
      },
      onMouseOut: () => {
        if (w.current) {
          const j = w.current.getElement();
          j && cr(j);
        }
      },
      onClose: k,
      children: [
        y ? /* @__PURE__ */ r.jsx(
          D6,
          {
            ...d,
            parentTestId: e,
            onClose: k
          }
        ) : null,
        u ? /* @__PURE__ */ r.jsx(
          On,
          {
            ...u,
            testId: `${e}-tab-bar`,
            onClose: y ? void 0 : k
          }
        ) : null,
        p ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx("div", { className: v.listHeaderContainer, children: /* @__PURE__ */ r.jsx(T1, { ...p }) }),
          /* @__PURE__ */ r.jsx(Ce, {})
        ] }) : null,
        /* @__PURE__ */ r.jsxs(
          ue,
          {
            ref: w,
            removeFromTabOrder: !0,
            className: C(v.scrollView, {
              [v.scrollViewWithFooter]: !!h
            }),
            children: [
              m ? /* @__PURE__ */ r.jsx("div", { className: v.alertContainer, children: /* @__PURE__ */ r.jsx(Ke, { ...m }) }) : null,
              /* @__PURE__ */ r.jsx(
                "div",
                {
                  className: g === "fullWidth" ? v.fullWidthContentContainer : v.contentContainer,
                  children: i
                }
              )
            ]
          }
        ),
        h ? /* @__PURE__ */ r.jsxs("div", { className: v.footerContainer, children: [
          /* @__PURE__ */ r.jsx(Ce, {}),
          /* @__PURE__ */ r.jsx(R6, { parentTestId: e, ...h })
        ] }) : null
      ]
    }
  ) });
}, Z6 = X.withParams().create(({ theme: e, drawerWidth: t, drawerOpen: n }) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    height: "100%",
    width: "100%",
    overflow: "hidden"
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flexGrow: 1,
    transition: e.transitions.create("margin", {
      easing: e.transitions.easing.sharp,
      duration: e.transitions.duration.leavingScreen
    }),
    marginRight: `-${t}px`,
    [e.breakpoints.down(qn)]: {
      marginRight: 0
    },
    ...n && {
      transition: e.transitions.create("margin", {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.enteringScreen
      }),
      marginRight: 0
    },
    width: "100%",
    overflowX: "scroll",
    position: "relative",
    zIndex: 10
  },
  scrollViewContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.25rem",
    width: "100%"
  },
  fab: {
    position: "fixed",
    bottom: "1.5rem",
    right: n ? "20rem" : 0,
    zIndex: 10,
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem"
  },
  tabBarContainer: {
    position: "sticky",
    top: 0,
    zIndex: N2,
    background: e.palette.neutral.white,
    width: "100%"
  }
})), P6 = X.create(() => ({
  fabContainerWithDrawerOpen: {
    transition: "all 200ms ease-in-out",
    marginRight: "20rem"
  }
})), q6 = ({
  open: e,
  setDrawerOpen: t,
  primaryFabProps: n,
  showOpenDrawerButton: o = !0
}) => {
  const { classes: a } = P6();
  return n ? /* @__PURE__ */ r.jsx(
    Cr,
    {
      testId: n.testId ?? "primary-fab-button",
      icon: n.icon,
      label: n.label,
      containerClassName: e ? a.fabContainerWithDrawerOpen : void 0,
      onClick: n.onClick,
      additionalButtons: [
        !e && o ? /* @__PURE__ */ r.jsx(
          G,
          {
            testId: "open-drawer-button",
            buttonVariant: "fabSecondary",
            icon: "inverted-info",
            onClick: () => t == null ? void 0 : t(!0)
          }
        ) : null
      ]
    }
  ) : !e && o ? /* @__PURE__ */ r.jsx(
    Cr,
    {
      testId: "open-drawer-button",
      icon: "inverted-info",
      secondary: !0,
      onClick: () => t == null ? void 0 : t(!0)
    }
  ) : null;
}, U6 = (e) => {
  const t = Ia(), n = nn(
    t.breakpoints.down(qn)
  ), [o, a] = V(!1);
  K(() => {
    n && !o ? (e(), a(!0)) : n || a(!1);
  }, [n, o, e]);
}, Lp = ({
  scrollViewRef: e,
  open: t,
  primaryFabProps: n,
  setDrawerOpen: o,
  showOpenDrawerButton: a,
  minWidth: i,
  drawer: l,
  contentClassName: c,
  tabBarProps: d,
  children: u
}) => {
  const { cx: p, classes: m } = Z6({
    drawerWidth: i ?? X1,
    drawerOpen: t
  });
  return U6(() => o == null ? void 0 : o(!1)), /* @__PURE__ */ r.jsxs("div", { className: m.container, children: [
    /* @__PURE__ */ r.jsxs("div", { className: m.content, children: [
      d ? /* @__PURE__ */ r.jsx("div", { className: m.tabBarContainer, children: /* @__PURE__ */ r.jsx(On, { ...d }) }) : null,
      /* @__PURE__ */ r.jsx(
        ue,
        {
          ref: e,
          className: p(m.scrollViewContent, c),
          children: u
        }
      )
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: m.fab, children: /* @__PURE__ */ r.jsx(
      q6,
      {
        open: t,
        setDrawerOpen: o,
        primaryFabProps: n,
        showOpenDrawerButton: a
      }
    ) }),
    l
  ] });
}, G6 = ({
  testId: e,
  open: t,
  onClose: n,
  renderContents: o
}) => {
  const { translations: a } = Q(), [i, l] = V("info");
  return /* @__PURE__ */ r.jsx(
    Un,
    {
      testId: e,
      open: t,
      onClose: n,
      minWidth: X1,
      maxWidth: X1,
      contentSpacing: "fullWidth",
      tabBarProps: {
        testId: `${e ?? ""}-tab-bar`,
        items: [
          {
            testId: `${e ?? ""}-tab-info`,
            label: a.item_drawer.info_tab_label,
            value: "info"
          },
          {
            testId: `${e ?? ""}-tab-activity`,
            label: a.item_drawer.activity_tab_label,
            value: "activity"
          }
        ],
        value: i,
        onChange: (c) => l(c)
      },
      children: o(i)
    }
  );
}, Gn = X.withParams().create(({ theme: e, fullWidth: t }) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  rootExpanded: {},
  contents: {
    display: "flex",
    flexDirection: "column",
    padding: t ? 0 : "0 1.5rem 1.5rem 1.5rem"
  },
  alertContainer: {
    padding: "1.5rem 1.5rem 0 1.5rem"
  },
  contentWhenNoHeading: {
    paddingTop: t ? 0 : "1.5rem"
  },
  heading: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    background: "none",
    border: 0,
    cursor: "pointer",
    padding: "0.875rem 0.875rem 0.875rem 1.375rem",
    margin: "2px",
    //height: "2rem",
    height: "52px",
    zIndex: 10,
    "&:focus-visible": {
      borderRadius: "0.25rem",
      outline: `2px solid ${e.palette.primary["60-key"]}`
    }
  },
  headingExpanded: {
    //marginBottom: fullWidth ? 0 : "1rem",
  },
  headingText: {
    color: e.palette.neutral[70]
  },
  expandButton: {
    display: "grid",
    placeItems: "center",
    height: "2.25rem",
    width: "2.25rem",
    borderRadius: "100%",
    color: e.palette.neutral[80],
    transform: "rotate(180deg)",
    "&:hover": {
      backgroundColor: U1(x["neutral-80"], 0.05)
    },
    "&:active": {
      backgroundColor: U1(x["neutral-80"], 0.1)
    },
    "&:focus-visible": {
      outline: `1px solid ${e.palette.primary["60-key"]}`,
      backgroundColor: U1(x["neutral-80"], 0.05),
      outlineOffset: "1px"
    }
  },
  expandButtonCollapsed: {
    transform: "rotate(0deg)"
  }
})), Kn = X.create(() => ({
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem"
  },
  container: {
    padding: "1.5rem 1.5rem 1rem",
    // For instances where there are multiple accordions stacked we only want 1rem of spacing.
    "& ~ &": {
      paddingTop: 0
    },
    "&:last-child": {
      paddingBottom: "1.5rem"
    }
  }
})), K6 = X.create(({ theme: e }) => ({
  listHeaderContainer: {
    padding: "1.5rem"
  },
  accordionContainer: {
    padding: "1.5rem 1.5rem 1.5rem 1.5rem"
  },
  activity: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  activityContainer: {
    flex: 1
  },
  activitySectionHeading: {
    padding: "1.5rem 1.5rem 0.5rem 1.5rem",
    width: "100%"
  },
  activitySectionHeadingText: {
    color: e.palette.neutral[70]
  },
  footer: {},
  addNoteField: {
    padding: "1rem 1.5rem 1rem 1.5rem"
  }
})), Y6 = X.create(({ theme: e }) => ({
  item: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    padding: "1rem 1.5rem",
    "&:hover": {
      backgroundColor: e.palette.neutral[10]
    }
  },
  icon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem"
  },
  iconContainer: {
    width: "1.5rem",
    height: "1.5rem"
  },
  timeline: {
    width: "1px",
    height: "100%",
    backgroundColor: e.palette.neutral[30],
    marginBottom: "-1rem"
  },
  contents: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.5rem",
    paddingRight: "1.5rem",
    flexGrow: 1
  },
  contentsExpanded: {
    paddingRight: 0
  },
  title: {
    ...e.typography.h4,
    color: e.palette.neutral[80],
    marginTop: "0.1875rem",
    marginBottom: "0.1875rem"
  },
  highlightedTitle: {
    background: e.palette.warning[10],
    borderRadius: "0.25rem",
    border: `1px solid ${e.palette.warning["60-key"]}`,
    padding: "0.1875rem",
    margin: "-0.0625rem -0.25rem -0.0625rem -0.25rem"
  },
  noteButtons: {
    display: "flex",
    flexDirection: "row",
    gap: "1rem"
  },
  note: {
    ...e.typography.body1,
    color: e.palette.neutral[80],
    wordBreak: "break-word"
  },
  details: {
    ...e.typography.body3,
    color: e.palette.neutral[70]
  },
  moreContainer: {
    position: "absolute",
    top: "1rem",
    right: "1rem"
  },
  hidden: {
    visibility: "hidden"
  }
})), Q6 = ({
  heading: e,
  parentTestId: t,
  fields: n,
  disabled: o = !1,
  accessIcon: a,
  rootClassName: i
}) => {
  const { classes: l } = Kn();
  return /* @__PURE__ */ r.jsx("div", { className: i ?? l.container, children: /* @__PURE__ */ r.jsx(
    I1,
    {
      overline: e ?? "",
      resourceId: `${t}-accordion`,
      open: !0,
      accessIcon: a,
      children: /* @__PURE__ */ r.jsx("div", { className: l.fields, children: n.map(({ label: c, value: d, subtext: u, onCopy: p }, m) => /* @__PURE__ */ r.jsxs("div", { children: [
        typeof d == "string" ? /* @__PURE__ */ r.jsx(
          y1,
          {
            id: `${t ?? ""}-meta-${c}`,
            variant: p && !o ? "BUTTON" : "BASIC",
            buttonProps: p && !o ? {
              buttonVariant: "icon",
              icon: "copy",
              iconVariant: "primary",
              onClick: () => {
                p();
              }
            } : void 0,
            label: c,
            value: d,
            handleOnChange: () => {
            },
            disabled: o,
            isReadOnly: !0
          }
        ) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(a1, { htmlFor: `info-drawer-field-${m.toString()}`, children: c }),
          /* @__PURE__ */ r.jsx("div", { id: `info-drawer-field-${m.toString()}`, children: d })
        ] }),
        u ? /* @__PURE__ */ r.jsx(W, { variant: "subtitle1", component: "p", children: u }) : null
      ] }, `${c}-${m.toString()}`)) })
    }
  ) });
}, X6 = ({
  heading: e,
  hasDivider: t = !0,
  children: n,
  fullWidth: o = !1,
  gap: a = "0.875rem"
}) => {
  const [i, l] = V(!0), { cx: c, classes: d } = Gn({ fullWidth: o });
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: c(d.root, {
          [d.rootExpanded]: i
        }),
        children: [
          e ? /* @__PURE__ */ r.jsxs(
            "button",
            {
              className: c(d.heading, {
                [d.headingExpanded]: i
              }),
              onClick: () => l(!i),
              children: [
                /* @__PURE__ */ r.jsx(W, { variant: "overline", className: d.headingText, children: e }),
                /* @__PURE__ */ r.jsx(
                  "div",
                  {
                    className: c(d.expandButton, {
                      [d.expandButtonCollapsed]: !i
                    }),
                    children: /* @__PURE__ */ r.jsx(te, { name: "chevron-thick", width: 24 })
                  }
                )
              ]
            }
          ) : null,
          i ? /* @__PURE__ */ r.jsx(
            "div",
            {
              className: c(d.contents, {
                [d.contentWhenNoHeading]: !e
              }),
              style: { gap: a },
              children: n
            }
          ) : null
        ]
      }
    ),
    t && /* @__PURE__ */ r.jsx(Ce, {})
  ] });
}, It = (e, t) => e.some((n) => n.label === t), z2 = (e) => e.includes(" "), J6 = (e) => ({
  id: on(),
  label: e,
  disabled: !1,
  isRemovable: !0,
  isInteractable: !0
}), ec = (e) => {
  if (z2(e))
    return "invalid_tag";
}, tc = (e, t, n) => {
  if (It(t, e) || It(n, e))
    return "tag_already_in_use";
  if (z2(e))
    return "invalid_tag";
}, rc = (e, t) => {
  for (let n = 0; n < e.length; n++) {
    const o = e[n], a = e.slice(0, n);
    if (o) {
      if (It(t, o.label) || It(a, o.label))
        return "tag_already_in_use";
      if (z2(o.label))
        return "invalid_tag";
    }
  }
}, nc = (e, t) => {
  if (e === "invalid_tag") return t.invalid_tag;
  if (e === "tag_already_in_use") return t.tag_already_in_use;
}, Mp = ({
  parentTestId: e,
  tags: t,
  onAddChips: n,
  onDeleteChip: o,
  isReadOnly: a = !0
}) => {
  const { translations: i } = Q(), [l, c] = V([]), [d, u] = V(""), [p, m] = V(
    void 0
  ), g = t.map((f) => ({
    ...f,
    isRemovable: !a,
    isInteractable: !a
  })), h = (f) => {
    const y = nc(
      f,
      i.item_drawer.tag_validation_errors
    );
    m(y);
  }, C = (f) => {
    const y = rc(f, g);
    y ? h(y) : (c(f), f.length > l.length && u(""));
  }, v = (f) => {
    u(f);
    const y = ec(f);
    h(y);
  }, b = (f) => {
    if (f.length > 0) {
      const y = tc(f, g, l);
      y ? h(y) : (n([...l, J6(f)]), u(""), c([]));
    } else
      n(l), c([]);
  };
  return /* @__PURE__ */ r.jsxs(
    X6,
    {
      heading: i.item_drawer.tag_heading,
      hasDivider: !1,
      children: [
        a ? null : /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(
          O2,
          {
            id: `${e ?? ""}-tags`,
            items: l,
            label: i.item_drawer.tag_heading,
            labelHidden: !0,
            value: d,
            onChipChange: C,
            onChange: v,
            helperMessage: i.item_drawer.tag_helper_message,
            hasError: !!p,
            errorMessage: p,
            buttonVariant: "icon",
            buttonIcon: "plus",
            buttonsAction: b,
            buttonLabel: i.item_drawer.tag_add_button_label,
            noMinWidth: !0
          }
        ) }),
        /* @__PURE__ */ r.jsx(Le, { direction: "row", flexWrap: "wrap", gap: "0.25rem", children: /* @__PURE__ */ r.jsx(
          _e,
          {
            testId: `${e ?? ""}-tags-chips`,
            variant: "basic",
            items: g,
            onDelete: o
          }
        ) })
      ]
    }
  );
}, W2 = ({ count: e }) => {
  const { classes: t } = x6();
  return /* @__PURE__ */ r.jsx(Le, { gap: "1rem", children: Array.from({ length: e }, (n, o) => /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsx(me, { variant: "text", className: t.label }),
    /* @__PURE__ */ r.jsx(me, { variant: "rounded", height: 40 })
  ] }, `skeleton-form-field-${o}`)) });
}, Jt = ({
  id: e,
  testId: t,
  eventType: n,
  title: o,
  description: a,
  timestamp: i,
  user: l,
  pinned: c,
  searchQuery: d,
  showNoteUI: u,
  showTimeline: p = !0,
  canManage: m = !1,
  onAction: g,
  onCancelEdit: h
}) => {
  const { translations: C } = Q(), { translations: v } = Q(), { cx: b, classes: f } = Y6(), [y, w] = V(!1), [k, M] = V(null), [L, j] = V(!1), [N, E] = V(a), [$, S] = V(!0);
  K(() => {
    $ && S(!1);
  }, [$]);
  const _ = Z(null);
  Dt(_, () => {
    L && (N !== a ? h(
      () => {
        S(!0);
      },
      () => {
        E(a), j(!1);
      }
    ) : j(!1));
  });
  const B = () => n === "NOTE" ? c ? C.item_drawer.activity_items.unpin_note : C.item_drawer.activity_items.pin_note : c ? C.item_drawer.activity_items.unpin_event : C.item_drawer.activity_items.pin_event, O = {
    id: "edit-note",
    label: a ? C.item_drawer.activity_items.edit_note : C.item_drawer.activity_items.add_note
  }, A = {
    id: "toggle-event-pin",
    label: B()
  }, F = m ? [O, A] : [A], z = n === "NOTE" || a && a.length > 0, I = m && z ? [
    {
      id: "delete-note",
      label: C.item_drawer.activity_items.delete_note,
      variant: "destructive"
    }
  ] : [], D = () => {
    M(null), w(!1);
  };
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      ref: _,
      "data-testid": t,
      className: f.item,
      onMouseOver: () => w(!0),
      onMouseOut: () => w(!1),
      children: [
        /* @__PURE__ */ r.jsxs("div", { className: f.icon, children: [
          /* @__PURE__ */ r.jsx("div", { className: f.iconContainer, children: /* @__PURE__ */ r.jsx(
            we,
            {
              size: "small",
              text: L2(l),
              textAvatarColor: "first",
              variant: l.avatarUrl ? "image" : "text",
              imageUrl: l.avatarUrl
            }
          ) }),
          p ? /* @__PURE__ */ r.jsx("div", { className: f.timeline }) : null
        ] }),
        /* @__PURE__ */ r.jsxs(
          "div",
          {
            className: b(f.contents, {
              [f.contentsExpanded]: L
            }),
            children: [
              o ? /* @__PURE__ */ r.jsx(W, { className: f.title, children: d ? /* @__PURE__ */ r.jsx($t, { value: o, query: d }) : o }) : null,
              u && (L ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
                /* @__PURE__ */ r.jsx(
                  Xn,
                  {
                    id: `${e}-note-text-area`,
                    label: "New Note Text",
                    labelHidden: !0,
                    value: N,
                    handleOnChange: (H, T) => E(T),
                    autoFocus: $
                  }
                ),
                /* @__PURE__ */ r.jsxs("div", { className: f.noteButtons, children: [
                  /* @__PURE__ */ r.jsx(
                    G,
                    {
                      buttonVariant: "text",
                      label: v.common.cancel,
                      onClick: () => {
                        E(a), j(!1), w(!1);
                      }
                    }
                  ),
                  /* @__PURE__ */ r.jsx(
                    G,
                    {
                      buttonVariant: "text",
                      label: v.common.save,
                      onClick: () => {
                        g("update-note", e, N), j(!1), w(!1);
                      }
                    }
                  )
                ] })
              ] }) : a ? /* @__PURE__ */ r.jsx(W, { className: f.note, children: a.split(`
`).map((H, T, ne) => /* @__PURE__ */ r.jsxs(qe.Fragment, { children: [
                H,
                T !== ne.length - 1 ? /* @__PURE__ */ r.jsx("br", {}) : null
              ] }, T)) }) : null),
              /* @__PURE__ */ r.jsxs("div", { children: [
                /* @__PURE__ */ r.jsx(W, { className: f.details, children: j1(i, "date_and_time") }),
                /* @__PURE__ */ r.jsxs(W, { className: f.details, children: [
                  l.firstName,
                  " ",
                  l.lastName
                ] })
              ] })
            ]
          }
        ),
        u && /* @__PURE__ */ r.jsxs("div", { className: f.moreContainer, children: [
          /* @__PURE__ */ r.jsx(
            G,
            {
              buttonVariant: "icon",
              icon: "more",
              iconVariant: "neutral",
              testId: `${t}-menu`,
              className: b({ [f.hidden]: !y || L }),
              onClick: (H) => M(H.currentTarget)
            }
          ),
          /* @__PURE__ */ r.jsx(ze, { anchor: k, onClose: D, children: /* @__PURE__ */ r.jsx(
            Ie,
            {
              lists: [
                {
                  items: F,
                  itemComponent: Se,
                  onSelection: ({ id: H }) => {
                    D(), H === "edit-note" ? (E(a), j(!0), S(!0)) : g(H, e);
                  }
                },
                {
                  items: I,
                  itemComponent: Se,
                  onSelection: ({ id: H }) => {
                    D(), g(H, e);
                  }
                }
              ]
            }
          ) })
        ] })
      ]
    },
    e
  );
}, oc = (e, t, n, o) => {
  const a = e.some(
    (i) => t.includes(`${n}-${i ?? ""}`)
  );
  return {
    id: `activity-filter-${n}`,
    label: o,
    variant: "filterMenu",
    selected: a,
    listType: "advanced",
    listItems: e.map((i) => ({
      id: `${n}-${i ?? ""}`,
      label: i ?? "",
      selected: t.includes(`${n}-${i ?? ""}`),
      variant: "checkbox"
    }))
  };
}, ac = (e, t, n, o) => {
  const a = e.some((i) => i.selected);
  return {
    id: `activity-filter-${n}`,
    label: o,
    variant: "list_advanced",
    selected: a,
    searchable: !0,
    minWidth: 320,
    value: t,
    listItems: [
      e.map((i) => ({
        ...i,
        variant: "checkbox"
      }))
    ]
  };
}, ic = (e, t, n) => ({
  id: "activity-filter-date",
  variant: "date_range_picker",
  value: e,
  selected: !!e && !!e.from,
  fromDate: t,
  toDate: n
});
function lc(e, t) {
  return e.reduce((n, o) => {
    const a = t(o);
    return n.includes(a) || !a ? n : [...n, a];
  }, []);
}
const sc = (e, t) => {
  const { id: n, avatarUrl: o, firstName: a, lastName: i, primaryEmailAddress: l } = e;
  return {
    id: `${Y1}-${n}`,
    testId: Pe(`${a} ${i}`),
    heading: `${a} ${i}`,
    subtext: l,
    avatar: o ? /* @__PURE__ */ r.jsx(we, { variant: "image", imageUrl: o }) : /* @__PURE__ */ r.jsx(we, { variant: "text", text: L2(e) }),
    selected: t.includes(`${Y1}-${n}`)
  };
}, e2 = "event", Y1 = "people", mt = !1, cc = ({
  parentTestId: e,
  activityItems: t,
  onAddNote: n,
  onActivityAction: o,
  onCancelEdit: a,
  canManageActivity: i,
  isActivityLoading: l
}) => {
  const { translations: c } = Q(), { classes: d } = K6(), [u, p] = V("");
  V("");
  const [m, g] = V([]), [h, C] = V([]), [v, b] = V(void 0), f = Z(null), [y, w] = V(!1);
  if (K(() => {
    var I;
    if (y) {
      const D = (I = f.current) == null ? void 0 : I.osInstance();
      if (D) {
        const { viewport: H } = D.elements();
        H.scrollTo({ top: H.scrollHeight });
      }
      w(!1);
    }
  }, [t]), l)
    return /* @__PURE__ */ r.jsx("div", { className: d.activity, children: /* @__PURE__ */ r.jsx(ue, { className: d.activityContainer, children: /* @__PURE__ */ r.jsx("div", { className: d.accordionContainer, children: /* @__PURE__ */ r.jsx(
      I1,
      {
        overline: c.item_drawer.all_heading,
        open: !0,
        fullWidth: !0,
        resourceId: "activity",
        children: /* @__PURE__ */ r.jsx(R1, { variant: "complex_list_item", count: 1, avatarSize: "small" })
      }
    ) }) }) });
  const k = (I) => u.length > 0 && (I == null ? void 0 : I.toLowerCase().includes(u.toLowerCase())), M = lc(
    t,
    (I) => I.eventCategory ?? I.title
  ), L = $a(
    t,
    (I) => I.user.id
  ).map((I) => sc(I.user, h)), j = t.map((I) => I.timestamp), N = j.length > 0 ? new Date(Math.min(...j.map((I) => I.getTime()))) : void 0, E = j.length > 0 ? new Date(Math.max(...j.map((I) => I.getTime()))) : void 0, $ = [
    oc(
      M,
      m,
      e2,
      c.item_drawer.activity_event_filter
    ),
    ac(
      L,
      h,
      Y1,
      c.item_drawer.activity_people_filter
    ),
    ic(v, N, E)
  ], S = (I, D) => {
    I === `activity-filter-${e2}` ? g(D ?? []) : I === `activity-filter-${Y1}` ? C(D ?? []) : I === "activity-filter-date" && b(D);
  }, _ = (I) => !!((v == null ? void 0 : v.from) === void 0 || v.to === void 0 && q1(v.from, I) || v.to !== void 0 && (q1(v.from, I) || o1(v.from, I)) && (q1(I, v.to) || o1(I, v.to))), B = (I) => {
    const D = u === "" || k(I.title), H = m.length === 0 || m.includes(
      `${e2}-${I.eventCategory ?? I.title}`
    ), T = h.length === 0 || h.includes(`${Y1}-${I.user.id}`), ne = _(I.timestamp);
    return D && H && T && ne;
  }, O = t.filter((I) => I.pinned), A = t.filter(B), F = u !== "" || m.length > 0 || h.length > 0 || !!v && !!v.from, z = t.length === 0;
  return /* @__PURE__ */ r.jsxs("div", { className: d.activity, children: [
    z ? null : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsx("div", { className: d.listHeaderContainer, children: /* @__PURE__ */ r.jsx(
        T1,
        {
          testId: `${e}-header`,
          inputValue: u,
          onInputChange: (I, D) => p(D),
          onFilterChipSelected: S,
          filterChips: $
        }
      ) }),
      /* @__PURE__ */ r.jsx(Ce, {})
    ] }),
    /* @__PURE__ */ r.jsx(ue, { ref: f, className: d.activityContainer, children: /* @__PURE__ */ r.jsx("div", { className: d.accordionContainer, children: /* @__PURE__ */ r.jsxs(
      I1,
      {
        overline: c.item_drawer.all_heading,
        open: !0,
        fullWidth: !0,
        resourceId: "activity",
        children: [
          F ? A.map((I) => /* @__PURE__ */ r.jsx(
            Jt,
            {
              testId: `${e ?? ""}-activity-${I.id}`,
              searchQuery: u,
              showNoteUI: mt,
              showTimeline: !1,
              onAction: o,
              onCancelEdit: a,
              ...I
            },
            I.id
          )) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
            O.length > 0 ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
              /* @__PURE__ */ r.jsx("div", { className: d.activitySectionHeading, children: /* @__PURE__ */ r.jsx(
                W,
                {
                  variant: "overline",
                  className: d.activitySectionHeadingText,
                  children: c.item_drawer.pinned_heading
                }
              ) }),
              O.map((I, D) => /* @__PURE__ */ r.jsx(
                Jt,
                {
                  testId: `${e ?? ""}-activity-${I.id}`,
                  canManage: i,
                  showNoteUI: mt,
                  showTimeline: D !== O.length - 1,
                  onAction: o,
                  onCancelEdit: a,
                  ...I
                },
                I.id
              )),
              /* @__PURE__ */ r.jsx(Ce, {}),
              /* @__PURE__ */ r.jsx("div", { className: d.activitySectionHeading, children: /* @__PURE__ */ r.jsx(
                W,
                {
                  variant: "overline",
                  className: d.activitySectionHeadingText,
                  children: c.item_drawer.all_heading
                }
              ) })
            ] }) : null,
            t.map((I, D) => /* @__PURE__ */ r.jsx(
              Jt,
              {
                testId: `${e ?? ""}-activity-${I.id}`,
                canManage: i,
                showNoteUI: mt,
                showTimeline: D !== t.length - 1,
                onAction: o,
                onCancelEdit: a,
                ...I
              },
              I.id
            ))
          ] }),
          z || A.length === 0 ? /* @__PURE__ */ r.jsx(
            b1,
            {
              icon: F ? "search" : "history",
              heading: F ? c.item_drawer.no_results : c.item_drawer.no_activity,
              description: F ? c.item_drawer.no_results_match_search : c.item_drawer.no_activity_for_item
            }
          ) : null
        ]
      }
    ) }) }),
    mt
  ] });
}, Ep = ({
  fields: e,
  // tags, (2025-07-21) Eric N - comment back in after how the tags should work is settled
  onAddChips: t,
  onDeleteChip: n,
  onAddNote: o,
  areTagsReadOnly: a,
  activityItems: i,
  onActivityAction: l,
  canManageActivity: c,
  isActivityLoading: d,
  isInfoLoading: u,
  alertProps: p,
  infoTabContents: m,
  ...g
}) => {
  const { translations: h } = Q(), [C, v] = V(!1), { classes: b } = Gn({ fullWidth: !1 }), { classes: f } = Kn(), y = Z(void 0), w = Z(void 0), k = (N, E) => {
    v(!0), setTimeout(() => {
      var $;
      ($ = document.getSelection()) == null || $.removeAllRanges();
    }), y.current = N, w.current = E;
  }, M = () => {
    var N;
    (N = y.current) == null || N.call(y), v(!1), y.current = void 0;
  }, L = () => {
    var N;
    (N = w.current) == null || N.call(w), v(!1), w.current = void 0;
  }, j = m ?? (u ? /* @__PURE__ */ r.jsx("div", { className: f.container, children: /* @__PURE__ */ r.jsx(
    I1,
    {
      overline: h.item_drawer.meta_heading,
      resourceId: `${g.testId ?? ""}-info-loading`,
      open: !0,
      children: /* @__PURE__ */ r.jsx(W2, { count: 3 })
    }
  ) }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    p ? /* @__PURE__ */ r.jsx("div", { className: b.alertContainer, children: /* @__PURE__ */ r.jsx(Ke, { ...p }) }) : null,
    /* @__PURE__ */ r.jsx(
      Q6,
      {
        heading: h.item_drawer.meta_heading,
        parentTestId: g.testId,
        fields: e,
        hasDivider: !1
      }
    )
  ] }));
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      G6,
      {
        ...g,
        renderContents: (N) => N === "info" ? j : /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx(
          cc,
          {
            parentTestId: g.testId,
            activityItems: i,
            onAddNote: o,
            onActivityAction: l,
            onCancelEdit: k,
            canManageActivity: c,
            isActivityLoading: d
          }
        ) })
      }
    ),
    /* @__PURE__ */ r.jsx(
      Q2,
      {
        isOpen: C,
        testId: `${g.testId ?? ""}-cancel-editing-dialog`,
        headline: h.unsaved_warning.heading,
        supportingText: h.unsaved_warning.description,
        onClose: () => {
          v(!1);
        },
        actions: [
          {
            type: "cancel",
            label: h.unsaved_warning.cancel_label,
            onClick: () => M()
          },
          {
            type: "submit",
            label: h.unsaved_warning.submit_label,
            onClick: () => L()
          }
        ]
      }
    )
  ] });
}, Np = ({
  testId: e,
  open: t,
  onClose: n,
  icon: o = "lock",
  translations: { itemLabel: a, itemDescription: i }
}) => {
  const { translations: l } = Q();
  return /* @__PURE__ */ r.jsx(
    Un,
    {
      testId: e,
      open: t,
      onClose: n,
      minWidth: X1,
      maxWidth: X1,
      contentSpacing: "fullWidth",
      tabBarProps: {
        testId: `${e ?? ""}-tab-bar`,
        items: [
          {
            testId: `${e ?? ""}-tab-info`,
            label: l.item_drawer.info_tab_label,
            value: "info"
          }
        ],
        value: "info",
        onChange: () => {
        }
      },
      children: /* @__PURE__ */ r.jsx(
        b1,
        {
          icon: o,
          heading: a,
          description: i
        }
      )
    }
  );
}, dc = R()({
  root: {
    maxHeight: "unset",
    borderRadius: 0
  },
  heading: {
    width: "8.25rem",
    display: "block",
    overflow: "visible"
  },
  subheading: {
    width: "9rem",
    display: "block"
  },
  expandButton: {
    "&:not(:hover)": {
      backgroundColor: "transparent",
      border: "none",
      outline: "none",
      color: "inherit"
    },
    "&:hover": {
      padding: "0 4px",
      lineHeight: "calc(1rem - 3px)",
      cursor: "pointer"
    }
  },
  info: {
    display: "flex"
  },
  subheader: {
    margin: "0 1rem"
  }
}), N1 = (e) => {
  const t = e.reduce((n, o) => (n.has(o.orgId) || (n.set(o.orgId, o), o.children && N1(o.children).forEach((i) => {
    n.has(i.orgId) || n.set(i.orgId, i);
  })), n), /* @__PURE__ */ new Map());
  return Array.from(t.values());
}, J1 = (e, t) => {
  var n;
  for (const o of e) {
    if ((n = o.children) != null && n.find((a) => a.orgId === t))
      return o.orgId;
    if (o.children) {
      const a = J1(o.children, t);
      if (a)
        return a;
    }
  }
}, Yn = (e, t, n) => {
  const o = N1(e), a = o.find((d) => d.orgId === t);
  if (!a) return [];
  const i = n ? [a] : [];
  let l = t, c = J1(e, l);
  for (; c; ) {
    const d = o.find(
      (u) => u.orgId === c
    );
    d ? (i.unshift(d), l = d.orgId, c = J1(e, l)) : c = void 0;
  }
  return i;
}, uc = (e) => {
  const t = (o) => {
    const a = /* @__PURE__ */ new Set(), i = (l) => {
      l.forEach((c) => {
        a.add(c.orgId), c.children.length > 0 && i(c.children);
      });
    };
    return o.children.length > 0 && i(o.children), a;
  }, n = /* @__PURE__ */ new Set();
  return e.forEach((o) => {
    t(o).forEach((i) => n.add(i));
  }), e.filter((o) => !n.has(o.orgId));
}, pc = (e) => e.length === 0 ? "" : e.length === 1 ? e[0] : e.length === 2 ? `${e[0]} › ${e[1]}` : e.map(
  (t, n) => `${t}${n + 1 === e.length ? "" : " › "}`
), Ip = {
  flatten: N1,
  findParentById: J1,
  getLineage: Yn,
  dedupeOrgUnitTree: uc
}, mc = (e) => ({
  id: e,
  heading: ""
  // Required by ComplexListItemProps
}), hc = (e) => /* @__PURE__ */ r.jsx(R1, { variant: "complex_list_item" }), ht = (e, t) => e.orgName.localeCompare(t.orgName), gc = ({
  onStarClick: e,
  onUnstarClick: t,
  onWorkspaceClick: n,
  testId: o = "",
  workspaces: a,
  starredWorkspaces: i,
  selectedWorkspaceId: l,
  setSelectedWorkspaceId: c,
  breadcrumbItems: d,
  translations: u,
  getWorkspaceHref: p,
  isLoading: m = !1,
  searchValue: g,
  onSearchChange: h,
  isSearchLoading: C = !1,
  highlightQuery: v
}) => {
  const [b, f] = V(""), y = h !== void 0, w = y ? g ?? "" : b, k = w === "" ? "" : v ?? w, { withinDrawer: M } = H1(), { translations: L } = Q(), { classes: j, cx: N } = dc(), E = (P) => {
    y ? h(P) : f(P);
  }, $ = (P) => O({ workspace: P, isStarred: F(P.orgId) }), S = (P) => {
    E(""), c(P);
  }, _ = (P) => {
    c(J1(a, P));
  }, B = (P, ee) => {
    E(ee);
  }, O = ({
    workspace: P,
    isStarred: ee,
    highlight: oe
  }) => {
    var xe;
    const fe = Pe(P.orgName);
    return {
      id: P.orgId,
      href: p == null ? void 0 : p(P.orgId),
      testId: fe,
      heading: /* @__PURE__ */ r.jsx("span", { className: j.heading, children: /* @__PURE__ */ r.jsx($t, { value: P.orgName, query: k }) }),
      subtext: /* @__PURE__ */ r.jsx("span", { className: N(j.subheading), children: /* @__PURE__ */ r.jsx(
        $t,
        {
          value: oe ? (() => {
            const Be = pc(P.orgPath);
            return Array.isArray(Be) ? Be.join("") : Be ?? "";
          })() : ((xe = P.businessAddress) == null ? void 0 : xe.streetAddressLine1) ?? "",
          query: k
        }
      ) }),
      avatar: /* @__PURE__ */ r.jsx(we, { icon: "organization", iconAvatarColor: "primary" }),
      renderInfo: ({ isHovering: Be }) => {
        var Ye;
        return /* @__PURE__ */ r.jsxs("div", { className: j.info, children: [
          Be ? /* @__PURE__ */ r.jsx(
            he,
            {
              testId: ee ? `${o}-${fe}-unstar-tooltip` : `${o}-${fe}-star-tooltip`,
              title: ee ? u.unstar : u.star,
              children: /* @__PURE__ */ r.jsx(
                G,
                {
                  buttonVariant: "icon",
                  iconVariant: "neutral",
                  icon: ee ? "star" : "star-outlined",
                  testId: ee ? `${o}-${fe}-unstar` : `${o}-${fe}-star`,
                  onClick: () => ee ? t(P.orgId) : e(P.orgId)
                }
              )
            }
          ) : null,
          (Ye = P.children) != null && Ye.length ? /* @__PURE__ */ r.jsx(
            he,
            {
              testId: `${o}-${fe}-view-children-tooltip`,
              title: u.viewChildren,
              children: /* @__PURE__ */ r.jsx(
                G,
                {
                  buttonVariant: "icon",
                  iconVariant: "neutral",
                  icon: "chevron-right",
                  testId: `${o}-${fe}-view-children`,
                  onClick: () => S(P.orgId)
                }
              )
            }
          ) : null
        ] });
      }
    };
  }, A = i.map((P) => P.orgId), F = (P) => A.includes(P), z = je.cloneDeep(i).sort(ht).map($), I = je.cloneDeep(a).sort(ht).map($), D = N1(a).find(
    (P) => P.orgId === l
  ), H = (D == null ? void 0 : D.children) ?? [], T = je.cloneDeep(H).sort(ht).map($), ne = N1(a), de = (P) => {
    if (P.orgName.toLowerCase().includes(w.toLowerCase()))
      return P;
  }, q = y ? ne : ne.filter(de), U = je.cloneDeep(q).sort(ht).map(
    (P) => O({
      workspace: P,
      isStarred: F(P.orgId),
      highlight: !0
    })
  ), se = {
    id: "workspace-switcher-breadcrumb-all",
    testId: "wworkspace-switcher-breadcrumb-all",
    label: L.common.all,
    onClick: () => {
      c(void 0), E("");
    }
  }, ve = {
    showBottomDivider: !1,
    innerListClassName: j.root,
    testId: o,
    maxWidth: M ? _1 : 320,
    minWidth: 320,
    maxHeight: M ? void 0 : 608,
    variant: M ? "spacious" : "default",
    footerProps: M ? void 0 : {
      kind: "breadcrumbs",
      props: {
        items: w ? [se] : d
      }
    }
  }, ye = {
    testId: `${o}-header`,
    onInputChange: B,
    inputValue: w
  }, Me = (P) => ({
    testId: `${o}-list`,
    items: P,
    variant: M ? "spacious" : "default",
    itemComponent: Je,
    onSelection: n
  }), Ee = l && !w ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      he,
      {
        testId: `workspace-switcher-${o}-back-tooltip`,
        title: u.back,
        children: /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "icon",
            iconVariant: "neutral",
            icon: "arrow-back",
            testId: `workspace-switcher-${o}-back`,
            onClick: () => _(l)
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsx(W, { variant: "body1", children: D == null ? void 0 : D.orgName })
  ] }) : null, ke = l && T.length > 0, Ae = ke ? { ...ye, children: Ee } : ye, Fe = (P, ee, oe) => ({
    testId: `${o}-list-${P.toLowerCase()}`,
    items: ee.map((fe) => mc(fe)),
    itemComponent: hc,
    onSelection: n,
    ...oe
  }), J = (P, ee, oe) => ({
    ...Me(P),
    testId: `${o}-list-${ee}`,
    ...oe && { subheader: oe, subheaderClassName: j.subheader }
  }), be = w ? C || v !== void 0 && v !== w ? [
    Fe("search", [
      "skeleton-search-1",
      "skeleton-search-2",
      "skeleton-search-3",
      "skeleton-search-4"
    ])
  ] : [Me(U)] : ke ? [Me(T)] : m ? [
    Fe("all", [
      "skeleton-all-1",
      "skeleton-all-2",
      "skeleton-all-3",
      "skeleton-all-4"
    ])
  ] : [
    ...z.length ? [J(z, "starred", "Starred")] : [],
    ...I.length ? [
      J(
        I,
        "all",
        z.length ? "All" : void 0
      )
    ] : []
  ];
  return /* @__PURE__ */ r.jsx(
    Ie,
    {
      ...ve,
      showHeaderDivider: !0,
      headerProps: Ae,
      lists: be
    }
  );
}, Cc = R()((e) => ({
  header: {
    display: "flex",
    alignItems: "center",
    padding: "1rem",
    gap: "0.5rem",
    textWrap: "nowrap",
    width: "100%",
    justifyContent: "space-between",
    background: "inherit",
    border: 0,
    cursor: "pointer",
    ":hover": {
      background: e.palette.brand["ia-gray-shade-1"]
    },
    ":active": {
      background: e.palette.brand["ia-gray-shade-2"]
    },
    // Inset focus ring — the default outline gets clipped by the rail edge,
    // which is what produced the "weird artifact" after closing the menu via ESC.
    ":focus-visible": {
      outline: "none",
      boxShadow: `inset 0 0 0 2px ${e.palette.primary["60-key"]}`
    }
  },
  iconAndLabelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem"
  },
  label: {
    textAlign: "left",
    whiteSpace: "initial"
  },
  white: {
    color: e.palette.neutral.white
  },
  avatar: {
    color: e.palette.neutral.white,
    height: "1.5rem",
    width: "1.5rem"
  },
  avatarContainer: {
    background: e.palette.brand["ia-gray-shade-1"]
  }
})), $p = ({
  isExpanded: e,
  activeWorkspaceId: t,
  selectedWorkspaceId: n,
  setSelectedWorkspaceId: o,
  translations: a,
  workspaceSwitcherProps: i,
  isLoading: l = !1,
  onSwitcherOpen: c
}) => {
  var w;
  const { translations: d } = Q(), { cx: u, classes: p } = Cc(), { workspaces: m, onWorkspaceClick: g, activeWorkspace: h } = i, [C, v] = V(null), b = ((w = N1(m).find((k) => k.orgId === t)) == null ? void 0 : w.orgName) ?? (h == null ? void 0 : h.orgName), f = n ? Yn(m, n, !0) : [], y = [
    {
      id: "workspace-switcher-breadcrumb-all",
      testId: "wworkspace-switcher-breadcrumb-all",
      label: d.common.all,
      onClick: () => o(void 0)
    },
    ...f.map((k) => ({
      id: k.orgId,
      testId: `workspace-switcher-${i.testId}-breadcrumb-${k.orgId}`,
      label: k.orgName,
      onClick: () => o(k.orgId)
    }))
  ];
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      "button",
      {
        "data-testid": "navigation-workspaces-switcher-button",
        className: p.header,
        onClick: (k) => {
          c == null || c(), o(void 0), v(k.currentTarget);
        },
        children: [
          /* @__PURE__ */ r.jsx("div", { className: p.iconAndLabelContainer, children: l ? /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx(R1, { variant: "workspace_header" }) }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
            /* @__PURE__ */ r.jsx(
              we,
              {
                iconClassName: p.avatar,
                className: p.avatarContainer,
                icon: "organization"
              }
            ),
            e && /* @__PURE__ */ r.jsx(
              W,
              {
                variant: "h4",
                className: u(p.white, p.label),
                children: b
              }
            )
          ] }) }),
          e && /* @__PURE__ */ r.jsx(
            he,
            {
              testId: "workspace-switcher-arrow-tooltip",
              title: a.openWorkspaceSwitcher,
              children: /* @__PURE__ */ r.jsx(
                G,
                {
                  testId: "navigation-workspaces-switcher-button-arrow",
                  component: "div",
                  role: "presentation",
                  tabIndex: -1,
                  className: p.white,
                  buttonVariant: "icon",
                  icon: "chevron-thick",
                  iconVariant: "inverse"
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r.jsx(
      ze,
      {
        anchor: C,
        onClose: () => {
          v(null);
        },
        testId: "navigation-workspaces-switcher-menu",
        bottomDrawerProps: {
          variant: "modal",
          contentSpacing: "fullWidth",
          footerProps: {
            kind: "breadcrumbs",
            props: {
              items: y
            }
          }
        },
        children: /* @__PURE__ */ r.jsx(
          gc,
          {
            ...i,
            selectedWorkspaceId: n,
            setSelectedWorkspaceId: o,
            breadcrumbItems: y,
            testId: "navigation-workspaces-switcher",
            onWorkspaceClick: (k) => {
              g(k), v(null);
            }
          }
        )
      }
    )
  ] });
}, _p = ({
  heading: e,
  supportingText: t,
  buttonLabel: n,
  testId: o,
  onClick: a
}) => /* @__PURE__ */ r.jsx(
  So,
  {
    testId: o,
    heading: e,
    supportingText: t,
    actions: [
      {
        id: "button",
        testId: `${o}-button`,
        label: n,
        onClick: a,
        buttonVariant: "primary"
      }
    ]
  }
), vc = (e) => /* @__PURE__ */ r.jsx(
  _a,
  {
    ref: e.ref,
    ...e,
    style: {
      ...e.style,
      // These are brought over from MUI's implementation of MenuPaper.
      // See https://github.com/mui/material-ui/blob/f37458b4e247928032fbf9979696769635260ad7/packages/mui-material/src/Menu/Menu.js#L51
      maxHeight: "calc(100% - 96px)",
      WebkitOverflowScrolling: "touch",
      overflow: "hidden",
      maxWidth: "528px"
    },
    children: /* @__PURE__ */ r.jsx(
      ue,
      {
        onInitialized: (t) => {
          var a;
          const n = t.elements().host, o = (a = n.parentElement) == null ? void 0 : a.clientHeight;
          n.style.height = `${o}px`;
        },
        children: e.children
      }
    )
  }
), fc = R()((e, { isSmall: t, hasMinWidth: n = !0 }) => ({
  formControl: {
    width: "100%"
  },
  small: {
    ...e.typography.body3,
    height: "1.5rem",
    minWidth: n ? "12.5rem" : void 0,
    "> div.MuiSelect-select": {
      paddingLeft: "0.5rem",
      paddingRight: "1.5rem !important"
    },
    "> svg": {
      right: "0px",
      color: e.palette.neutral[50]
    }
  },
  medium: {
    ...e.typography.body1,
    height: "2.5rem",
    minWidth: n ? "12.5rem" : void 0,
    "> div.MuiSelect-select": {
      paddingLeft: "0.75rem",
      textAlign: "left"
    }
  },
  select: {
    backgroundColor: e.palette.neutral.white,
    "&.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${e.palette.neutral[30]}`
    },
    "&:hover": {
      "&.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline": {
        borderColor: e.palette.neutral[40]
      }
    },
    "&:active": {
      ".MuiOutlinedInput-notchedOutline": {
        border: `2px solid ${e.palette.primary["60-key"]}`
      }
    },
    "> svg": {
      top: "unset",
      color: e.palette.neutral[80]
    }
  },
  selectFocus: {
    "&:focus-visible": {
      outline: "none",
      "~ .MuiOutlinedInput-notchedOutline": {
        border: `2px solid ${e.palette.primary["60-key"]}`
      }
    },
    "&:focus-visible:hover": {
      "~ .MuiOutlinedInput-notchedOutline": {
        // Keep border the same for focus even when hovered.
        border: `2px solid ${e.palette.primary["60-key"]}`
      }
    }
  },
  focused: {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `2px solid ${e.palette.primary["60-key"]}`
    }
  },
  borderless: {
    backgroundColor: "transparent",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline": {
      border: "1px solid transparent"
    },
    "&:hover": {
      "&.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent"
      }
    },
    "&:active": {
      ".MuiOutlinedInput-notchedOutline": {
        border: "2px solid transparent"
      }
    },
    "&:focus-visible": {
      outline: "none",
      ".MuiOutlinedInput-notchedOutline": {
        border: `2px solid ${e.palette.primary["60-key"]}`
      }
    },
    "> svg": {
      top: "unset"
    }
  },
  isOpen: {
    "& .MuiOutlinedInput-notchedOutline": {
      border: `2px solid ${e.palette.primary["60-key"]}`
    },
    "> svg": {
      color: t ? e.palette.primary["60-key"] : "unset"
    }
  },
  error: {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline": {
      borderColor: e.palette.error["60-key"]
    },
    "> svg": {
      color: t ? e.palette.error["60-key"] : "unset"
    }
  },
  placeholder: {
    ...e.typography.body1,
    height: "2.5rem",
    minWidth: n ? "12.5rem" : void 0,
    "> div.MuiSelect-select": {
      paddingLeft: "0.75rem"
    },
    color: e.palette.neutral[50],
    "&.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${e.palette.neutral[30]}`
    },
    "&:hover, &:active": {
      ".MuiOutlinedInput-notchedOutline": {
        borderColor: e.palette.neutral[40]
      }
    },
    "&:focus-visible": {
      outline: "none"
    },
    "> svg": {
      top: "unset"
    }
  },
  disabled: {
    pointerEvents: "none",
    color: e.palette.neutral[50],
    backgroundColor: e.palette.neutral[20],
    "> svg": {
      color: e.palette.neutral[50]
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: e.palette.neutral[30]
    }
  },
  labelInside: {
    ...e.typography.label,
    paddingRight: "0.25rem",
    verticalAlign: "0.063rem"
  },
  disabledLabel: {
    color: e.palette.neutral[50]
  },
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem"
  },
  helperMessage: {
    ...Re(e)
  },
  checkBoxContainer: {
    paddingLeft: ".25rem",
    marginBottom: "-0.25rem"
  },
  extraInfo: {
    marginTop: "0.5rem"
  },
  smallStates: {
    "&:hover": {
      "> svg": {
        color: e.palette.neutral[80]
      }
    },
    "&:focus-visible": {
      "> svg": {
        color: e.palette.primary["60-key"]
      }
    },
    "&:active": {
      "> svg": {
        color: e.palette.primary["60-key"]
      }
    }
  },
  listAdvanced: {
    boxShadow: "none"
  },
  visuallyHidden: ot,
  menuRoot: {
    zIndex: I2
  },
  selectedItem: {
    backgroundColor: `${e.palette.primary[10]} !important`,
    color: e.palette.primary["60-key"]
  }
})), xc = ({
  labelPosition: e = "none",
  options: t,
  hasError: n = !1,
  disabled: o = !1,
  isPlaceholder: a = !1,
  label: i,
  labelHidden: l = !1,
  errorMessage: c,
  helperMessage: d,
  handleOnSelect: u,
  selected: p,
  size: m = "medium",
  hasMinWidth: g = !0,
  borderless: h = !1,
  renderValue: C,
  id: v,
  testId: b,
  isReadOnly: f = !1,
  autoFocus: y = !1
}) => {
  var F;
  const w = t.find((z) => z.value === p), [k, M] = V(!1), L = Ve(), j = $e(
    L.breakpoints.down(_1)
  ), { cx: N, classes: E } = fc({
    isSmall: m === "small",
    hasMinWidth: g
  });
  if (f)
    return /* @__PURE__ */ r.jsxs(i2, { className: E.formControl, "data-testid": b, children: [
      e === "top" && /* @__PURE__ */ r.jsx(
        a1,
        {
          htmlFor: `${v}-input`,
          disabled: o,
          hidden: l,
          children: i
        }
      ),
      /* @__PURE__ */ r.jsxs(W, { children: [
        e === "inside" ? /* @__PURE__ */ r.jsxs(
          "label",
          {
            htmlFor: `${v}-input`,
            className: N(E.labelInside, {
              [E.disabledLabel]: o,
              [E.visuallyHidden]: l
            }),
            children: [
              i,
              ":"
            ]
          }
        ) : null,
        w == null ? void 0 : w.label
      ] })
    ] });
  const $ = (z) => {
    u(z == null ? void 0 : z.value);
  }, S = (z) => {
    const I = t.find((D) => D.value === z.target.value);
    $(I);
  }, _ = (z) => {
    const I = t.find((D) => D.value === z);
    $(I);
  }, B = () => C ? C(w) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    e === "inside" ? /* @__PURE__ */ r.jsxs(
      "label",
      {
        htmlFor: `${v}-input`,
        className: N(E.labelInside, {
          [E.disabledLabel]: o,
          [E.visuallyHidden]: l
        }),
        children: [
          i,
          ":"
        ]
      }
    ) : /* @__PURE__ */ r.jsx(r.Fragment, {}),
    w ? /* @__PURE__ */ r.jsx(r.Fragment, { children: w.label }) : /* @__PURE__ */ r.jsx("span", { children: "Select..." })
  ] }), O = a ? {
    className: N(E.placeholder, {
      [E.small]: m === "small",
      [E.medium]: m === "medium"
    }),
    open: !1,
    displayEmpty: !0,
    // We need to provide a defaultValue to avoid a MUI warning:
    // See https://github.com/mui/material-ui/issues/18494#issuecomment-830266017 and
    // https://github.com/mui/material-ui/issues/18494#issuecomment-557470150
    defaultValue: (w == null ? void 0 : w.value) ?? "",
    value: (w == null ? void 0 : w.value) ?? "",
    renderValue: B,
    IconComponent: Z1(m === "small" ? "small-caret" : "chevron-thick"),
    disabled: o
  } : {
    id: v,
    inputProps: {
      id: `${v}-input`
    },
    onChange: S,
    className: N(
      E.select,
      {
        [E.small]: m === "small",
        [E.medium]: m === "medium",
        [E.smallStates]: m === "small",
        [E.disabled]: o,
        [E.borderless]: h,
        [E.error]: n,
        [E.isOpen]: k
      },
      E.focused
    ),
    classes: {
      select: E.selectFocus
    },
    open: k && !j,
    onOpen: () => M(!0),
    onClose: () => M(!1),
    displayEmpty: !0,
    defaultValue: (w == null ? void 0 : w.value) ?? "",
    value: (w == null ? void 0 : w.value) ?? "",
    renderValue: B,
    IconComponent: Z1(m === "small" ? "small-caret" : "chevron-thick"),
    MenuProps: {
      slots: {
        paper: vc
      },
      classes: {
        root: E.menuRoot
      }
    },
    slotProps: {
      input: {
        "aria-label": i
      }
    },
    SelectDisplayProps: {
      // NOTE: (2024-09-18) Noah Settersten => This allows opening a focused select field by starting to type.
      // Checking for Escape prevents opening and then closing the select field in quick succession.
      onKeyDown: (z) => {
        ["Escape", "Tab"].includes(z.key) || M(!0);
      }
    },
    disabled: o,
    autoFocus: y
  }, A = !!((F = t[0]) != null && F.subtext);
  return /* @__PURE__ */ r.jsxs(i2, { className: E.formControl, "data-testid": b, children: [
    e === "top" && /* @__PURE__ */ r.jsx(
      a1,
      {
        htmlFor: `${v}-input`,
        disabled: o,
        hidden: l,
        onClick: () => M((z) => !z),
        children: i
      }
    ),
    /* @__PURE__ */ r.jsx(Va, { ...O, children: t.map(({ label: z, value: I, subtext: D, accessIconName: H }, T) => /* @__PURE__ */ r.jsx(
      Aa,
      {
        value: I,
        classes: { selected: E.selectedItem },
        disableGutters: A,
        sx: {
          padding: A ? "0px" : "default",
          whiteSpace: "normal"
        },
        children: A ? /* @__PURE__ */ r.jsx(
          Je,
          {
            heading: z,
            subtext: D,
            id: `${T}`,
            ...H ? { accessIcon: { name: H } } : {}
          }
        ) : z
      },
      `${I}-${T}`
    )) }),
    m === "medium" && (c || d) ? /* @__PURE__ */ r.jsxs("div", { className: E.extraInfo, children: [
      c && /* @__PURE__ */ r.jsx("div", { className: E.errorMessage, children: c }),
      d && /* @__PURE__ */ r.jsx("div", { className: E.helperMessage, children: d })
    ] }) : null,
    k && j ? /* @__PURE__ */ r.jsx(
      T2,
      {
        open: !0,
        contentSpacing: "fullWidth",
        onClose: () => M(!1),
        variant: "modal",
        children: A ? /* @__PURE__ */ r.jsx(
          Ie,
          {
            lists: [
              {
                items: t.map(
                  ({ label: z, value: I, subtext: D, accessIconName: H }) => ({
                    id: I,
                    label: z,
                    heading: z,
                    subtext: D,
                    ...H ? { accessIcon: { name: H } } : {}
                  })
                ),
                itemComponent: Je,
                onSelection: ({ id: z }) => {
                  _(z), M(!1);
                }
              }
            ]
          }
        ) : /* @__PURE__ */ r.jsx(
          Ie,
          {
            lists: [
              {
                items: t.map(({ label: z, value: I }) => ({
                  id: I,
                  label: z
                })),
                itemComponent: Se,
                onSelection: ({ id: z }) => {
                  _(z), M(!1);
                }
              }
            ]
          }
        )
      }
    ) : null
  ] });
}, bc = R()((e, { fullWidth: t }) => ({
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    ...t && { minWidth: "0", flex: "1 1 auto" },
    height: "unset",
    input: {
      top: 0
    }
  },
  doubleBorderContainer: {
    position: "relative",
    width: "100%",
    paddingLeft: "2.7rem",
    paddingBottom: "0.3rem",
    paddingRight: "2rem",
    height: "unset",
    flexWrap: "wrap",
    ...t && { overflowX: "hidden" }
  },
  scrollView: {
    ...t && { minWidth: "unset" },
    width: "100%",
    margin: "0.0625rem 0 0.0625rem 0"
  },
  leftIcon: {
    position: "absolute",
    top: "0.4rem",
    left: "0.7rem"
  },
  wrappedChip: {
    position: "relative",
    bottom: "0.075rem",
    maxWidth: "100%"
  },
  crossIcon: {
    position: "absolute",
    top: "0rem",
    right: "0.2rem"
  }
})), wc = (e) => e.type === "keyup", yc = ({
  id: e,
  testId: t = e,
  value: n,
  chips: o = [],
  handleOnChange: a,
  onChipUpdate: i,
  placeholderText: l = "",
  disabled: c = !1,
  showClearButton: d = !1,
  leftIcon: u,
  leftIconStyle: p,
  fullWidth: m = !1
}) => {
  const { translations: g } = Q(), h = !0, C = !1, { cx: v, classes: b } = w1({}), f = Z(null), { classes: y } = Hn({
    disabled: c,
    inputLength: n.length
  }), { classes: w } = H2(), { classes: k } = bc({ fullWidth: m }), [M, L] = V([]), [j, N] = V(!1), E = Z(null);
  K(() => {
    const I = o.map((H) => H.id), D = M.filter(
      (H) => I.includes(H)
    );
    D.length < M.length && L(D);
  }, [o, M]);
  const $ = (I) => {
    const D = o.find((H) => H.id === I);
    if (D != null && D.isRemovable)
      if (M.includes(I)) {
        const H = M.filter((T) => T !== I);
        L(H), H.length === 0 && N(!1);
      } else
        L([...M, I]), N(!0);
  }, S = (I) => {
    if (I.key === "Backspace" && !n) {
      const D = o[o.length - 1];
      if (!(D != null && D.isRemovable)) return;
      if (!j)
        N(!0), L([...M, D.id]);
      else {
        const H = o.filter(
          (T) => !M.includes(T.id)
        );
        i(H), L([]), N(!1);
      }
    } else
      N(!1);
  }, _ = (I, D) => {
    if (wc(D))
      S(D);
    else {
      const H = o.filter((T) => T.id != I);
      i(H);
    }
  }, B = n.length === 0, [O, A] = Ht(E, f), F = Te(() => {
    A(!0);
  }, [A]), z = Te(() => {
    var I;
    (I = E.current) == null || I.focus();
  }, []);
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      ref: f,
      className: v(
        b.inputContainer,
        {
          [b.isPlaceholder]: B,
          [b.isActive]: O
        },
        k.inputContainer
      ),
      onMouseDown: F,
      onClick: z,
      children: /* @__PURE__ */ r.jsx(
        ue,
        {
          removeFromTabOrder: !0,
          className: v(
            {
              [y.multiLineChipsInput]: h
            },
            k.scrollView
          ),
          children: /* @__PURE__ */ r.jsxs(
            "div",
            {
              className: v(
                b.doubledBorder,
                y.doubledBorderChips,
                k.doubleBorderContainer
              ),
              children: [
                u && /* @__PURE__ */ r.jsx(
                  te,
                  {
                    name: u,
                    style: p,
                    className: v(
                      b.leftIcon,
                      k.leftIcon,
                      {
                        [b.disabledIcon]: c
                      }
                    )
                  }
                ),
                o.map((I, D) => /* @__PURE__ */ r.jsx(
                  "span",
                  {
                    className: k.wrappedChip,
                    children: /* @__PURE__ */ r.jsx(
                      _e,
                      {
                        testId: `input-${D}`,
                        variant: "input",
                        onDelete: _,
                        items: I,
                        onClick: (H, T) => {
                          $(H), T == null || T.stopPropagation();
                        },
                        className: v({
                          [w.focusedChip]: M.includes(I.id) && j
                        })
                      }
                    )
                  },
                  I.id
                )),
                /* @__PURE__ */ r.jsx(
                  D1,
                  {
                    ref: E,
                    placeholderText: l,
                    testId: t,
                    value: n,
                    handleOnChange: a,
                    id: e,
                    onKeyDown: S
                  }
                ),
                d && !C && n.length > 0 && /* @__PURE__ */ r.jsx(
                  G,
                  {
                    icon: "cross",
                    iconVariant: "neutral",
                    className: v(
                      b.crossIcon,
                      k.crossIcon
                    ),
                    disabled: c,
                    id: `${e}-clear-button`,
                    testId: `${t}-clear-button`,
                    title: g.common.clear,
                    buttonVariant: "icon",
                    onClick: () => {
                      var I;
                      n && ((I = E.current) == null || I.focus(), a(e, ""));
                    }
                  }
                )
              ]
            }
          )
        }
      )
    }
  );
}, kc = R()((e) => ({
  root: {
    ".MuiSlider-rail": {
      color: e.palette.neutral[30],
      opacity: 1,
      height: "0.5rem"
    },
    ".MuiSlider-track": {
      color: e.palette.primary["60-key"],
      height: "0.375rem"
    },
    ".MuiSlider-thumb": {
      color: e.palette.neutral.white,
      border: `1px solid ${e.palette.neutral[30]}`,
      height: "1.5rem",
      width: "1.5rem",
      boxShadow: "none",
      "&.Mui-focusVisible": {
        boxShadow: "none"
      },
      "&:hover, &:focus-visible, &:has(input:focus)": {
        boxShadow: "0px 0px 0px 8px #4646460C"
      },
      "&:active": {
        boxShadow: "0px 0px 0px 8px #46464619"
      }
    },
    ".MuiSlider-markLabel": {
      ...e.typography.body3,
      marginTop: "0.188rem"
    },
    ".MuiSlider-markLabelActive": {
      color: e.palette.neutral[80]
    },
    ".MuiSlider-mark": {
      display: "none"
    }
  },
  disabled: {
    ".MuiSlider-rail": {
      color: e.palette.neutral[20],
      opacity: 1,
      height: "0.5rem"
    },
    ".MuiSlider-track": {
      color: e.palette.neutral[40],
      height: "0.375rem"
    },
    ".MuiSlider-thumb": {
      color: e.palette.neutral[20],
      border: `1px solid ${e.palette.neutral[30]}`,
      height: "1.5rem",
      width: "1.5rem"
    },
    ".MuiSlider-markLabel": {
      ...e.typography.body3,
      color: e.palette.neutral[50],
      marginTop: "0.188rem"
    },
    ".MuiSlider-markLabelActive": {
      color: e.palette.neutral[50]
    }
  },
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem"
  },
  helperMessage: {
    ...Re(e)
  },
  extraInfo: {
    marginTop: "0.2rem"
  },
  label: {
    ...e.typography.label,
    marginBottom: "0.125rem"
  },
  disabledLabel: {
    color: e.palette.neutral[50]
  }
})), Vp = ({
  id: e,
  testId: t,
  type: n = "DISCRETE",
  marks: o,
  min: a = 0,
  max: i = 20,
  step: l = 5,
  defaultValue: c,
  helperMessage: d,
  errorMessage: u,
  label: p,
  disabled: m,
  onChange: g
}) => {
  const { cx: h, classes: C } = kc(), v = n === "DISCRETE" ? {
    marks: o,
    defaultValue: c,
    className: h(C.root, { [C.disabled]: m }),
    step: l,
    max: i,
    min: a,
    disabled: m
  } : {
    marks: o,
    className: h(C.root, { [C.disabled]: m }),
    disabled: m
  }, [b, f] = V(c), y = (w, k) => {
    f(k), g({ id: e, value: k });
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      "label",
      {
        className: h(C.label, { [C.disabledLabel]: m }),
        children: [
          p,
          /* @__PURE__ */ r.jsx(
            Ba,
            {
              ...v,
              onChange: y,
              value: b,
              id: e,
              "data-testid": t
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r.jsxs("div", { className: C.extraInfo, children: [
      u && /* @__PURE__ */ r.jsx("div", { className: C.errorMessage, children: u }),
      d && /* @__PURE__ */ r.jsx("div", { className: C.helperMessage, children: d })
    ] })
  ] });
}, Qn = 11, kt = (e) => Qn + e * 25, jc = (e) => (e - Qn) / 25, Sc = R()(
  (e, { visibleLines: t }) => ({
    textAreaContainer: {
      width: "100%",
      height: "fit-content",
      backgroundColor: e.palette.neutral.white,
      border: `1px solid ${e.palette.neutral[30]}`,
      borderRadius: "0.25rem",
      lineHeight: "0px"
    },
    baseStates: {
      "&:hover": {
        borderColor: e.palette.neutral[40]
      },
      "&:active": {
        border: `1px solid ${e.palette.primary["60-key"]}`,
        ">div": {
          borderColor: e.palette.primary["60-key"]
        }
      },
      "&:focus-visible": {
        outline: "none",
        border: `1px solid ${e.palette.primary["60-key"]}`,
        ">div": {
          borderColor: e.palette.primary["60-key"]
        }
      }
    },
    scrollView: {
      ...t === 1 ? {
        "& [data-overlayscrollbars-contents]": {
          overflowY: "hidden !important"
        }
      } : {}
    },
    doubledBorder: {
      border: "1px solid transparent !important",
      borderRadius: "0.188rem"
    },
    errorBorder: {
      border: `1px solid ${e.palette.error["60-key"]}`
    },
    isActive: {
      outline: `2px solid ${e.palette.primary["60-key"]}`,
      outlineOffset: "-1px",
      border: `1px solid ${e.palette.primary["60-key"]}`,
      ">div": {
        borderColor: e.palette.primary["60-key"]
      },
      "&:hover": {
        borderColor: e.palette.primary["60-key"]
      }
    },
    disabled: {
      pointerEvents: "none",
      backgroundColor: e.palette.neutral[20],
      textarea: {
        backgroundColor: e.palette.neutral[20],
        overflow: "hidden",
        color: e.palette.neutral[50]
      }
    },
    textArea: {
      ...e.typography.body1,
      paddingLeft: "0.5rem",
      paddingTop: "0.375rem",
      height: kt(t),
      width: "100%",
      outline: "transparent",
      border: "transparent",
      resize: "none",
      paddingBottom: "0px"
    },
    isPlaceholder: {
      textarea: {
        overflow: "hidden",
        "::placeholder": {
          color: e.palette.neutral[50]
        }
      },
      "&:hover": {
        borderColor: e.palette.neutral[40]
      }
    },
    isReadOnly: {
      ...e.typography.body1,
      color: e.palette.neutral[80]
    },
    textAreaWithButton: {
      paddingRight: "1.75rem"
    },
    iconButtonContainer: {
      position: "absolute",
      top: 0,
      right: 0
    },
    extraInfo: {
      marginTop: "0.5rem"
    },
    errorMessage: {
      ...e.typography.subtitle,
      color: e.palette.error["60-key"],
      height: "auto",
      marginBottom: "0.375rem"
    },
    helperMessage: {
      ...Re(e)
    }
  })
), Lc = 3.16, Mc = 6, Xn = ({
  id: e,
  name: t,
  value: n = "",
  label: o,
  labelHidden: a = !1,
  hasError: i = !1,
  disabled: l = !1,
  isReadOnly: c = !1,
  errorMessage: d = "",
  helperMessage: u = "",
  handleOnChange: p = () => {
  },
  testId: m = e,
  placeholderText: g = "",
  visibleLines: h = Lc,
  growToMaxHeightInPixels: C,
  autoFocus: v = !1,
  buttonIcon: b,
  onButtonClick: f,
  submitOnEnter: y = !1,
  onBlur: w
}) => {
  const [k, M] = V(h), L = Z(null), j = Z(null), [N, E] = Ht(j, L), $ = n.length === 0, S = `${m}-textArea-doubledBorder`, { cx: _, classes: B } = Sc({ visibleLines: k });
  K(() => {
    v && j.current && j.current.focus();
  }, [v, j]), K(() => {
    if (j.current && C) {
      const H = j.current.scrollHeight, T = kt(k), ne = kt(2) - kt(1), de = H > T, q = T + ne <= C;
      if (de && q)
        M((U) => U + 1);
      else if (de && T < C) {
        const U = jc(
          C - Mc
        );
        M(U);
      }
    }
  }, [j, n, k, C]), K(() => {
    if (j.current) {
      const H = j.current, T = () => {
        M(h);
      };
      return H.addEventListener("blur", T), () => H.removeEventListener("blur", T);
    }
  }, [j, h]);
  const O = Te(
    (H) => {
      p(e, H.target.value);
    },
    [e, p]
  ), A = Te(() => {
    $ || (setTimeout(() => {
      var H;
      return (H = j.current) == null ? void 0 : H.focus();
    }, 200), E(!0));
  }, [E, $]), F = !!b && !!f, z = n.length === 0, I = () => {
    F && (f(), setTimeout(() => M(h), 200));
  }, D = (H) => {
    y && !H.shiftKey && H.key == "Enter" && (H.preventDefault(), I());
  };
  return /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsx(a1, { htmlFor: e, disabled: l, hidden: a, children: o }),
    c ? /* @__PURE__ */ r.jsx(W, { className: B.isReadOnly, children: n }) : /* @__PURE__ */ r.jsx(
      "div",
      {
        ref: L,
        className: _(B.textAreaContainer, {
          [B.baseStates]: !$,
          [B.isPlaceholder]: $,
          [B.errorBorder]: i,
          [B.isActive]: N,
          [B.disabled]: l
        }),
        onMouseDown: A,
        children: /* @__PURE__ */ r.jsx("div", { id: S, className: B.doubledBorder, children: /* @__PURE__ */ r.jsxs(
          ue,
          {
            className: B.scrollView,
            removeFromTabOrder: !0,
            children: [
              /* @__PURE__ */ r.jsx(
                "textarea",
                {
                  ref: j,
                  placeholder: g,
                  "data-testid": m,
                  "aria-label": a ? o : void 0,
                  className: _(B.textArea, {
                    [B.textAreaWithButton]: F
                  }),
                  value: n,
                  onChange: O,
                  onBlur: w,
                  rows: k === 1 ? 1 : void 0,
                  id: e,
                  name: t,
                  autoFocus: v,
                  onKeyDown: D,
                  disabled: l
                }
              ),
              F ? /* @__PURE__ */ r.jsx("div", { className: B.iconButtonContainer, children: /* @__PURE__ */ r.jsx(
                G,
                {
                  buttonVariant: "icon",
                  icon: b,
                  testId: `${m}-button`,
                  iconVariant: z ? "neutral" : "primary",
                  disabled: z,
                  onClick: I
                }
              ) }) : null
            ]
          }
        ) })
      }
    ),
    d || u ? /* @__PURE__ */ r.jsxs("div", { className: B.extraInfo, children: [
      d && /* @__PURE__ */ r.jsx("div", { className: B.errorMessage, children: d }),
      u && /* @__PURE__ */ r.jsx("div", { className: B.helperMessage, children: u })
    ] }) : null
  ] });
}, Ec = {
  snackbars: [],
  addSnackbar: () => {
  },
  removeSnackbar: () => {
  }
}, Jn = nt(Ec), eo = () => (/* @__PURE__ */ new Date()).getTime().toString(), Nc = () => ({
  type: "success",
  id: eo()
}), Ap = ({ children: e }) => {
  const [t, n] = V([]), o = (i, l = Nc()) => {
    const {
      type: c = "success",
      id: d = eo(),
      ...u
    } = l;
    n((p) => {
      if (p.find((g) => g.id === d))
        return p;
      const m = {
        id: d,
        testId: `message-${d}`,
        message: i,
        variant: c,
        className: "",
        closeButtonEventHandler: () => {
        },
        // This will be overridden by SnackbarList
        ...u
      };
      return [...p, m];
    });
  }, a = (i) => {
    n(
      (l) => l.filter((c) => c.id !== i)
    );
  };
  return /* @__PURE__ */ r.jsx(
    Jn.Provider,
    {
      value: {
        snackbars: t,
        addSnackbar: o,
        removeSnackbar: a
      },
      children: e
    }
  );
}, Wt = () => $1(Jn), Ic = ({
  testId: e,
  autoComplete: t,
  id: n,
  name: o,
  leftIcon: a,
  leftIconStyle: i,
  rightIcon: l,
  rightIconStyle: c,
  handleOnChange: d,
  handleOnFocus: u,
  handleOnBlur: p,
  onKeyDown: m,
  value: g,
  placeholderText: h,
  showClearButton: C,
  disabled: v,
  isReadOnly: b = !1,
  autoFocus: f,
  inputRef: y
}) => {
  const w = Z(null), { cx: k, classes: M } = w1({ isReadOnly: b }), L = y || w;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    a && /* @__PURE__ */ r.jsx(
      te,
      {
        name: a,
        style: i,
        className: k(M.leftIcon, { [M.disabledIcon]: v })
      }
    ),
    /* @__PURE__ */ r.jsx(
      D1,
      {
        autoComplete: t,
        ref: L,
        placeholderText: h,
        testId: e,
        value: g,
        handleOnChange: d,
        onFocus: u,
        onBlur: p,
        onKeyDown: m,
        id: n,
        useInputLeftOffset: !!a,
        autoFocus: f,
        name: o,
        isReadOnly: b,
        disabled: v
      }
    ),
    C && !b && !v && g.length > 0 && /* @__PURE__ */ r.jsx(
      G,
      {
        icon: "cross",
        iconVariant: "neutral",
        className: k(M.crossIcon),
        disabled: v,
        id: `${n}-clear-button`,
        testId: `${e}-clear-button`,
        buttonVariant: "icon",
        onClick: () => {
          var j;
          g && ((j = L.current) == null || j.focus(), d(n, ""));
        }
      }
    ),
    l && /* @__PURE__ */ r.jsx(
      te,
      {
        name: l,
        style: c,
        className: k(M.rightIcon, {
          [M.disabledIcon]: v
        })
      }
    )
  ] });
}, $c = ({
  testId: e,
  id: t,
  name: n,
  handleOnChange: o,
  value: a,
  buttonProps: i,
  placeholderText: l,
  disabled: c = !1,
  inputRef: d,
  isReadOnly: u = !1
}) => {
  const { classes: p } = w1({ isReadOnly: !1 }), { label: m, onClick: g, ...h } = i;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      D1,
      {
        ref: d,
        name: n,
        placeholderText: l,
        testId: e,
        value: a,
        handleOnChange: o,
        id: t,
        disabled: c,
        isReadOnly: u
      }
    ),
    /* @__PURE__ */ r.jsx(
      G,
      {
        testId: `${e}-button`,
        buttonVariant: "text",
        className: p.button,
        ...h,
        disabled: c,
        onClick: (C) => g(t, C),
        children: m
      }
    )
  ] });
}, _c = ({
  testId: e,
  id: t,
  handleOnChange: n,
  value: o,
  placeholderText: a,
  isPasswordInput: i = !1,
  name: l,
  disabled: c = !1,
  inputRef: d
}) => {
  const { classes: u } = w1({ isReadOnly: !1 }), [p, m] = V(i);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      D1,
      {
        ref: d,
        placeholderText: a,
        testId: e,
        value: o,
        handleOnChange: n,
        id: t,
        isPasswordInput: p,
        name: l,
        disabled: c
      }
    ),
    /* @__PURE__ */ r.jsx(
      G,
      {
        testId: `${e}-toggle-button`,
        className: u.toggleButton,
        size: "small",
        buttonVariant: "textSecondary",
        label: p ? "SHOW" : "HIDE",
        disabled: c,
        onClick: () => m(!p)
      }
    )
  ] });
}, Vc = process.env.NODE_ENV === "test", Ac = (e) => {
  const t = Te(() => {
    setTimeout(() => {
      var n;
      return (n = e.current) == null ? void 0 : n.focus();
    }, 200);
  }, [e]);
  return Vc ? () => {
  } : t;
}, y1 = ({
  variant: e = "BASIC",
  id: t,
  testId: n = t,
  label: o,
  labelHidden: a = !1,
  errorMessage: i = "",
  helperMessage: l = "",
  leftIcon: c,
  leftIconStyle: d,
  rightIcon: u,
  rightIconStyle: p,
  handleOnChange: m,
  handleOnFocus: g,
  handleOnBlur: h,
  onKeyDown: C,
  value: v,
  hasError: b,
  disabled: f = !1,
  isReadOnly: y = !1,
  showClearButton: w = !1,
  buttonProps: k = {
    label: "Button",
    onClick: () => {
    }
  },
  placeholderText: M = "",
  isPasswordInput: L = !1,
  fullWidth: j = !1,
  autoFocus: N,
  name: E,
  defaultValue: $,
  showBorder: S = !1
}) => {
  const _ = Z(null), B = Z(null), { cx: O, classes: A } = w1({ isReadOnly: y, showBorder: S }), [F, z] = Ht(B, _);
  K(() => {
    N && z(!0);
  }, [N, z]);
  const I = v.length === 0 && !$, D = Ac(B), H = Te(() => {
    D(), z(!0);
  }, [D, z]), T = v.trim() !== "" ? v : $ ?? "", ne = {
    inputRef: B,
    placeholderText: M,
    testId: n,
    value: T,
    handleOnFocus: g,
    handleOnBlur: h,
    handleOnChange: m,
    id: t,
    name: E,
    disabled: f
  }, de = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    e === "BASIC" && /* @__PURE__ */ r.jsx(
      Ic,
      {
        ...ne,
        onKeyDown: C,
        leftIcon: y ? void 0 : c,
        leftIconStyle: d,
        rightIcon: y ? void 0 : u,
        rightIconStyle: p,
        showClearButton: w,
        isReadOnly: y,
        autoFocus: N
      }
    ),
    e === "BUTTON" && /* @__PURE__ */ r.jsx(
      $c,
      {
        ...ne,
        buttonProps: k,
        isReadOnly: y
      }
    ),
    e === "TOGGLE" && /* @__PURE__ */ r.jsx(_c, { ...ne, isPasswordInput: L })
  ] });
  return /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsx(a1, { htmlFor: t, hidden: a, disabled: f, children: o }),
    /* @__PURE__ */ r.jsx(
      "div",
      {
        ref: _,
        className: O(A.inputContainer, {
          [A.baseStates]: !I,
          [A.isPlaceholder]: I,
          [A.isActive]: F && !b,
          [A.errorBorder]: b,
          [A.errorBorderActive]: F && b,
          [A.disabled]: f,
          [A.isReadOnly]: ["BASIC", "BUTTON"].includes(e) && y,
          [A.toggleInputContainer]: e === "TOGGLE",
          [A.inputContainerFullWidth]: j
        }),
        onMouseDown: H,
        children: /* @__PURE__ */ r.jsx(
          "div",
          {
            className: O(A.doubledBorder, {
              [A.doubledBorderClearButton]: w
            }),
            children: de
          }
        )
      }
    ),
    i || l ? /* @__PURE__ */ r.jsxs("div", { className: A.extraInfo, children: [
      i && /* @__PURE__ */ r.jsx("div", { className: A.errorMessage, children: i }),
      l && /* @__PURE__ */ r.jsx("div", { className: A.helperMessage, children: l })
    ] }) : null
  ] });
}, Bp = ({ id: e, label: t, value: n }) => {
  const { translations: o } = Q(), { addSnackbar: a } = Wt();
  return /* @__PURE__ */ r.jsx(
    y1,
    {
      id: e,
      label: t,
      value: n,
      variant: "BUTTON",
      placeholderText: "",
      handleOnChange: () => {
      },
      isReadOnly: !0,
      showBorder: !0,
      buttonProps: {
        label: o.common.copy,
        icon: "copy",
        buttonVariant: "icon",
        iconVariant: "primary",
        onClick: () => {
          Cn(n), a(
            o.common.copy_message.replace("{{data}}", t)
          );
        }
      }
    }
  );
}, to = ({
  id: e,
  testId: t = e,
  label: n = "",
  labelHidden: o = !1,
  errorMessage: a = "",
  helperMessage: i = "",
  onChipChange: l,
  value: c = "",
  onChange: d,
  hasError: u,
  placeholderText: p = "",
  showMultilineChipsInput: m = !1,
  items: g,
  className: h = "",
  disabled: C = !1,
  isReadOnly: v = !1,
  isChipsBelow: b = !1,
  buttonVariant: f = "primary",
  buttonIcon: y,
  buttonLabel: w,
  buttonsAction: k,
  secondaryButtonAction: M,
  secondaryButtonLabel: L,
  options: j,
  hasButton: N,
  autoFocus: E = !1,
  buttonDisabled: $ = g.length === 0 && !c || C
}) => {
  const { cx: S, classes: _ } = w1({ isReadOnly: v }), B = Z(null), O = Z(null), A = () => {
    O.current && O.current.focus({ preventScroll: !0 });
  }, { classes: F } = Hn({
    buttonVariant: f,
    disabled: C,
    hasButton: N,
    hasMenu: j && j.length > 0,
    inputLength: c.length || p.length,
    isMulti: m
  }), [z, I] = V(!1), [D, H] = V([]), [T, ne] = V(!1), de = Z(null), [q, U] = V(!1), [se, ve] = V(!1), ye = (le, ce) => {
    ce.includes(",") || d(ce), P(!1);
  }, Me = (le) => {
    const ce = g.find((ge) => ge.id === le);
    if (ce != null && ce.isRemovable)
      if (D.includes(le)) {
        const ge = D.filter((Ge) => Ge !== le);
        H(ge), ge.length === 0 && ne(!1);
      } else
        H([...D, le]), ne(!0);
  }, Ee = (le) => {
    if (le.key === "," && c) {
      const ce = on(), ge = [
        ...g,
        {
          id: ce,
          label: le.target.value,
          disabled: !1,
          isRemovable: !0,
          isInteractable: !0
        }
      ];
      l(ge), d("");
      return;
    }
    if (le.key === "Backspace" && !c) {
      const ce = g[g.length - 1];
      if (!(ce != null && ce.isRemovable)) return;
      if (!T)
        ne(!0), H([...D, ce.id]);
      else {
        const ge = g.filter(
          (Ge) => !D.includes(Ge.id)
        );
        H([]), l(ge), ne(!1);
      }
      return;
    }
    le.key === "Enter" && !$ && (k == null || k(c)), H([]), ne(!1);
  }, ke = (le, ce) => {
    if (ce.type === "click") {
      const ge = g.filter((Ge) => Ge.id != le);
      l(ge);
    } else {
      const ge = g.filter(
        (Ge) => !D.includes(Ge.id)
      );
      H([]), l(ge), ne(!1);
    }
  }, Ae = c.length === 0;
  K(() => {
    const le = (ce) => {
      var ge;
      (ge = B.current) != null && ge.contains(ce.target) || (I(!1), P(!1));
    };
    return window.addEventListener("mousedown", le), () => window.removeEventListener("mousedown", le);
  }, [I]), K(() => {
    var ce;
    const le = (ce = de.current) == null ? void 0 : ce.scrollHeight;
    le && U(le > 44);
  }, [U, g.length]);
  const Fe = (le) => {
    le.target.scrollLeft > 0 ? ve(!0) : ve(!1);
  }, J = Te(() => {
    I(!0);
  }, [I]), ie = $ ? "neutral" : "primary", [be, P] = V(!1), [ee, oe] = V(
    j != null && j[0] ? j[0].label : ""
  ), fe = /* @__PURE__ */ r.jsxs("div", { children: [
    N && (!!y || !!w) && f !== "primary" && /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: S(F.textFieldButtonContainer),
        children: [
          L && f === "text" && /* @__PURE__ */ r.jsx(
            G,
            {
              className: S(F.textFieldButton, {
                [F.textFieldButtonNotReadOnly]: !v
              }),
              buttonVariant: "textSecondary",
              label: L,
              onClick: C ? void 0 : M,
              disabled: C
            }
          ),
          /* @__PURE__ */ r.jsx(
            G,
            {
              testId: `${t}-button`,
              className: S(F.textFieldButton),
              buttonVariant: f,
              icon: y,
              iconVariant: ie,
              title: w,
              label: w,
              onClick: C ? void 0 : () => k == null ? void 0 : k(c),
              disabled: $
            }
          )
        ]
      }
    ),
    j && j.length > 0 && N && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsx("div", { className: S(F.menuButtonContainer), children: /* @__PURE__ */ r.jsx(
        G,
        {
          className: S(F.menuButton),
          buttonVariant: "menuTextBorderless",
          label: ee,
          onClick: () => {
            P(!be);
          },
          disabled: C
        }
      ) }),
      be && /* @__PURE__ */ r.jsx("div", { className: F.optionList, children: /* @__PURE__ */ r.jsx(
        l1,
        {
          items: j,
          itemComponent: Se,
          onSelection: (le) => {
            var ce;
            oe(
              ((ce = j.find((ge) => ge.id === le.id)) == null ? void 0 : ce.label) ?? ""
            ), P(!1);
          }
        }
      ) })
    ] })
  ] }), xe = N && w && f === "primary" && /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(
    G,
    {
      testId: `${t}-button`,
      buttonVariant: f,
      label: w,
      onClick: C ? void 0 : () => k == null ? void 0 : k(c),
      disabled: $
    }
  ) }), Be = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    !b && /* @__PURE__ */ r.jsx(
      d2,
      {
        parentTestId: t,
        chips: g.map(
          (le) => C ? { ...le, disabled: !0, isRemovable: !1 } : le
        ),
        onClick: Me,
        chipsToBeDeleted: D,
        focusToBeDeleted: T,
        isChipsBelow: b,
        handleDelete: ke
      }
    ),
    /* @__PURE__ */ r.jsx(
      D1,
      {
        ref: O,
        className: F.textInput,
        placeholderText: p,
        testId: t,
        value: c,
        handleOnChange: ye,
        id: e,
        onKeyDown: Ee,
        inputProps: {
          "aria-label": o ? n : void 0
        },
        onFocus: () => I(!0),
        onBlur: () => I(!1),
        disabled: C,
        autoFocus: E
      }
    )
  ] }), Ye = /* @__PURE__ */ r.jsxs("div", { className: S(F.textFieldContainer), children: [
    /* @__PURE__ */ r.jsx(
      "div",
      {
        ref: B,
        onClick: A,
        className: S(
          _.inputContainer,
          F.inputButton,
          {
            [_.baseStates]: !Ae,
            [_.isPlaceholder]: Ae,
            [_.errorBorder]: u,
            [_.isActive]: z,
            [_.disabled]: C,
            [F.inputContainerChipsMultiline]: m && q
          },
          h
        ),
        onMouseDown: J,
        children: /* @__PURE__ */ r.jsx(
          "div",
          {
            tabIndex: -1,
            ref: de,
            className: S(F.doubledBorder, {
              [F.multiLineChipsInput]: m,
              [F.doubledBorderContainerChipsMultilineHeightUnset]: q,
              [F.doubledBorderChips]: !N && !m,
              [F.doubleBorderScrollingChipContainer]: se
            }),
            children: /* @__PURE__ */ r.jsxs("div", { className: S(F.doubledBorderContainer), children: [
              C ? /* @__PURE__ */ r.jsx(
                "div",
                {
                  className: S(
                    {
                      [F.chipContainer]: m,
                      [F.textFieldChipsContainer]: !m
                    },
                    F.disabledInputContainer
                  ),
                  children: Be
                }
              ) : /* @__PURE__ */ r.jsx(
                ue,
                {
                  removeFromTabOrder: !0,
                  theme: "os-theme-hidden",
                  className: S({
                    [F.chipContainer]: m,
                    [F.textFieldChipsContainer]: !m
                  }),
                  onScroll: (le, ce) => Fe(ce),
                  children: Be
                }
              ),
              fe
            ] })
          }
        )
      }
    ),
    xe
  ] });
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: v ? F.isReadOnly : void 0,
      children: [
        /* @__PURE__ */ r.jsx(
          a1,
          {
            htmlFor: e,
            disabled: C && !v,
            hidden: o,
            children: n
          }
        ),
        v ? /* @__PURE__ */ r.jsxs("div", { className: F.isReadOnlyContents, children: [
          g.map((le, ce) => /* @__PURE__ */ r.jsx("span", { children: /* @__PURE__ */ r.jsx(
            _e,
            {
              testId: `${le.id}-${ce}`,
              variant: "basic",
              state: "neutral",
              items: le
            }
          ) }, le.id)),
          /* @__PURE__ */ r.jsx(W, { className: _.isReadOnly, children: c }),
          fe,
          xe
        ] }) : Ye,
        /* @__PURE__ */ r.jsxs("div", { className: _.extraInfo, children: [
          a && /* @__PURE__ */ r.jsx("div", { className: _.errorMessage, children: a }),
          i && /* @__PURE__ */ r.jsx("div", { className: _.helperMessage, children: i })
        ] }),
        !v && b && /* @__PURE__ */ r.jsx(
          d2,
          {
            parentTestId: t,
            chips: g.map(
              (le) => C ? { ...le, disabled: !0, isRemovable: !1 } : le
            ),
            onClick: Me,
            chipsToBeDeleted: D,
            focusToBeDeleted: T,
            isChipsBelow: b,
            handleDelete: ke
          }
        )
      ]
    }
  );
}, Bc = R()((e, { buttonVariant: t, noMinWidth: n }) => ({
  textFieldContainer: {},
  textField: {
    maxWidth: t === "primary" ? "14.875rem" : "20rem",
    minWidth: n ? "unset" : t === "primary" ? "14.875rem" : "20rem"
  }
})), O2 = ({
  id: e,
  testId: t = e,
  label: n,
  labelHidden: o,
  errorMessage: a,
  helperMessage: i,
  onChipChange: l,
  value: c,
  onChange: d,
  hasError: u,
  placeholderText: p,
  showMultilineChipsInput: m = !1,
  items: g,
  className: h = "",
  disabled: C,
  isReadOnly: v = !1,
  isChipsBelow: b = !1,
  buttonVariant: f = "primary",
  buttonIcon: y,
  buttonLabel: w,
  buttonsAction: k,
  secondaryButtonAction: M,
  secondaryButtonLabel: L,
  options: j,
  hasButton: N = !0,
  noMinWidth: E = !1
}) => {
  const { cx: $, classes: S } = Bc({
    buttonVariant: f,
    noMinWidth: E
  });
  return /* @__PURE__ */ r.jsx("div", { className: $(S.textFieldContainer, h), children: /* @__PURE__ */ r.jsx(
    to,
    {
      testId: t,
      id: e,
      label: n,
      labelHidden: o,
      errorMessage: a,
      helperMessage: i,
      onChipChange: l,
      items: g,
      value: c,
      onChange: d,
      hasError: u,
      placeholderText: g.length === 0 ? p : "",
      showMultilineChipsInput: m,
      disabled: C,
      className: $(S.textField),
      isReadOnly: v,
      isChipsBelow: b,
      buttonVariant: f,
      buttonIcon: y,
      buttonLabel: w,
      buttonsAction: k,
      secondaryButtonAction: M,
      secondaryButtonLabel: L,
      options: j,
      hasButton: N
    }
  ) });
}, Hc = R()((e) => ({
  buttonAlert: {
    ...e.typography.button1,
    height: "2rem",
    minHeight: "2rem",
    maxHeight: "2rem",
    padding: e.spacing(1, 1.5),
    minWidth: "fit-content",
    color: e.palette.neutral[80],
    backgroundColor: "var(--background-color)",
    border: "1px solid transparent",
    gap: "4px",
    "&:hover": {
      backgroundColor: "var(--background-color-hover)",
      borderColor: "transparent",
      boxShadow: "none"
    },
    "&:active": {
      backgroundColor: "var(--background-color-active)",
      borderColor: "transparent !important",
      boxShadow: "none"
    },
    "&:focus-visible": {
      outline: "1px solid var(--primary-60-key)",
      outlineOffset: "1px",
      boxShadow: "none"
    },
    "&:disabled": {
      color: "var(--text-disabled)"
    },
    "& > svg path": {
      fill: "currentColor"
    }
  },
  outlined: {
    border: "1px solid var(--border-color)",
    backgroundColor: "transparent",
    "&:disabled": {
      backgroundColor: "transparent"
    }
  },
  neutral: {
    "--background-color": e.palette.neutral["80-10"],
    "--background-color-hover": e.palette.neutral["80-20"],
    "--background-color-active": e.palette.neutral["80-25"],
    "--border-color": e.palette.neutral["80-10"]
  },
  info: {
    "--background-color": e.palette.info["60-10"],
    "--background-color-hover": e.palette.info["60-20"],
    "--background-color-active": e.palette.info["60-25"],
    "--border-color": e.palette.info["60-10"]
  },
  success: {
    "--background-color": e.palette.success["60-10"],
    "--background-color-hover": e.palette.success["60-20"],
    "--background-color-active": e.palette.success["60-25"],
    "--border-color": e.palette.success["60-10"]
  },
  warning: {
    "--background-color": e.palette.warning["60-10"],
    "--background-color-hover": e.palette.warning["60-20"],
    "--background-color-active": e.palette.warning["60-25"],
    "--border-color": e.palette.warning["60-10"]
  },
  error: {
    "--background-color": e.palette.error["60-10"],
    "--background-color-hover": e.palette.error["60-20"],
    "--background-color-active": e.palette.error["60-25"],
    "--border-color": e.palette.error["60-10"]
  },
  icon: {
    width: "16px",
    height: "16px"
  }
})), Dc = ({
  buttonVariant: e = "neutral",
  label: t,
  disabled: n,
  tabIndex: o,
  href: a,
  onClick: i,
  testId: l,
  className: c,
  children: d,
  outlined: u = !1,
  icon: p,
  ...m
}) => {
  const { classes: g, cx: h } = V1({ size: "medium" }), { classes: C } = Hc(), v = l ?? `${e}-alert-${t}`;
  return /* @__PURE__ */ r.jsxs(
    Q1,
    {
      ...m,
      tabIndex: o,
      "data-testid": v,
      className: h(
        g.base,
        C[e],
        C.buttonAlert,
        u ? C.outlined : void 0,
        c
      ),
      disabled: n,
      disableRipple: !0,
      href: n ? void 0 : a,
      onClick: i,
      variant: u ? "outlined" : "contained",
      children: [
        t ?? d,
        p && (qe.isValidElement(p) ? /* @__PURE__ */ r.jsx(r.Fragment, { children: qe.cloneElement(p, {
          className: h(C.icon, p.props.className),
          width: 16,
          height: 16
        }) }) : /* @__PURE__ */ r.jsx(te, { name: p, className: C.icon }))
      ]
    }
  );
}, Tc = {
  neutral: "inverted-info",
  info: "inverted-info",
  success: "inverted-success",
  warning: "inverted-warning",
  error: "inverted-error"
}, Rc = {
  neutral: "neutral",
  info: "info",
  success: "success",
  warning: "warning",
  error: "destructive"
}, Ke = ({
  id: e,
  testId: t = e,
  title: n,
  description: o,
  actions: a = [],
  hasCloseButton: i = !1,
  closeButtonEventHandler: l,
  variant: c,
  hideIcon: d = !1,
  className: u = ""
}) => {
  const { translations: p } = Q(), { cx: m, classes: g } = H0({ variant: c, hasCloseButton: i });
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: m(
        g.root,
        g[`root${Ze(c.toLowerCase())}`],
        u
      ),
      "data-testid": t,
      id: e,
      children: [
        !d && /* @__PURE__ */ r.jsx("div", { className: g.iconContainer, children: /* @__PURE__ */ r.jsx(te, { name: Tc[c] }) }),
        /* @__PURE__ */ r.jsxs("div", { className: g.contentContainer, children: [
          /* @__PURE__ */ r.jsxs("div", { className: g.content, children: [
            n && /* @__PURE__ */ r.jsx(
              "div",
              {
                className: m(
                  g.title,
                  g[`title${Ze(c.toLowerCase())}`]
                ),
                children: n
              }
            ),
            /* @__PURE__ */ r.jsx("div", { className: m(g.description), children: o })
          ] }),
          a.length > 0 ? /* @__PURE__ */ r.jsx("div", { className: g.actionButtonContainer, children: a.map((h, C) => /* @__PURE__ */ r.jsx(
            Dc,
            {
              ...h,
              id: `${e}-button-${Pe(h.label)}`,
              testId: `${t}-button-${Pe(h.label)}`,
              buttonVariant: c,
              outlined: C > 0
            },
            `${e}-button-${Pe(h.label)}`
          )) }) : null
        ] }),
        i && /* @__PURE__ */ r.jsx("div", { className: g.closeButtonContainer, children: /* @__PURE__ */ r.jsx(
          G,
          {
            icon: "cross",
            iconVariant: Rc[c],
            className: m(g.crossIcon),
            id: `${e}-close-button`,
            testId: `${t}-close-button`,
            title: p.common.close,
            buttonVariant: "icon",
            onClick: () => {
              l(e);
            }
          }
        ) })
      ]
    }
  );
}, Fc = X.create(({ theme: e }) => ({
  root: {
    display: "grid",
    flexGrow: 1,
    placeItems: "center",
    width: "100%",
    minHeight: "100%",
    padding: "2rem"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  heading: {
    ...e.typography.h3,
    marginTop: "1.5rem",
    marginBottom: "0.5rem"
  },
  description: {
    ...e.typography.body1,
    textAlign: "center"
  },
  actions: {
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",
    flexWrap: "wrap",
    justifyContent: "center"
  },
  actionIcon: {
    display: "inline-block",
    marginLeft: "0.125rem"
  }
})), ro = ({
  icon: e,
  iconAvatarColor: t,
  imageUrl: n,
  heading: o,
  description: a,
  actions: i
}) => {
  const { classes: l } = Fc();
  return /* @__PURE__ */ r.jsx("div", { className: l.root, children: /* @__PURE__ */ r.jsxs("div", { className: l.container, children: [
    n ? /* @__PURE__ */ r.jsx(
      we,
      {
        size: "large",
        variant: "image",
        iconAvatarColor: t ?? "empty",
        imageUrl: n
      }
    ) : e ? /* @__PURE__ */ r.jsx(
      we,
      {
        size: "large",
        iconAvatarColor: t ?? "empty",
        icon: e
      }
    ) : null,
    /* @__PURE__ */ r.jsx(W, { variant: "h3", className: l.heading, children: o }),
    /* @__PURE__ */ r.jsx(W, { variant: "body1", className: l.description, children: a }),
    i && i.length > 0 ? /* @__PURE__ */ r.jsx("div", { className: l.actions, children: i.map((c) => /* @__PURE__ */ r.jsx(
      G,
      {
        testId: c.testId ?? c.id,
        buttonVariant: "text",
        endIcon: c.icon ? /* @__PURE__ */ r.jsx("span", { className: l.actionIcon, children: c.icon }) : null,
        label: c.label,
        onClick: c.onClick
      },
      c.id
    )) }) : null
  ] }) });
}, zc = X.create(() => ({
  root: {
    position: "fixed",
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: Sn,
    maxWidth: "360px",
    display: "flex",
    justifyContent: "center",
    padding: "0.5rem",
    margin: "0 auto",
    backgroundColor: x["warning-10"],
    backgroundImage: `repeating-linear-gradient(-45deg,
                                   ${x["warning-10"]},
                                   #77777733 2px,
                                   ${x["warning-10"]} 2px,
                                   ${x["warning-10"]} 6px)`,
    "@media print": {
      display: "none"
    }
  },
  environmentText: {
    fontWeight: "bold"
  },
  closeButton: {
    position: "absolute",
    height: "100%",
    display: "grid",
    placeItems: "center",
    top: 0,
    right: 6.25
  }
})), Wc = (e) => e !== "production", Hp = ({ environment: e }) => {
  const { showEnvironmentBanner: t, closeEnvironmentBanner: n } = Q(), { classes: o } = zc();
  return !Wc(e) || !t ? null : /* @__PURE__ */ r.jsxs("div", { "data-testid": "environment-banner", className: o.root, children: [
    /* @__PURE__ */ r.jsxs(W, { variant: "body2", children: [
      "You're viewing the",
      " ",
      /* @__PURE__ */ r.jsxs("span", { className: o.environmentText, children: [
        e,
        " environment"
      ] }),
      ". Take care entering email addresses as live emails will be sent."
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: o.closeButton, children: /* @__PURE__ */ r.jsx(
      G,
      {
        buttonVariant: "icon",
        iconVariant: "neutral",
        size: "small",
        icon: "cross",
        onClick: n
      }
    ) })
  ] });
}, Oc = X.create(() => ({
  stacktrace: {
    backgroundColor: "#EEE",
    borderRadius: "0.5rem",
    marginTop: 0,
    padding: "1.5rem 1.5rem 1.5rem 2rem"
  }
})), Zc = ({ error: e }) => {
  const { classes: t } = Oc(), n = rt((e.stack ?? "").split(`
`));
  return /* @__PURE__ */ r.jsx("ul", { className: t.stacktrace, children: n.map((o, a) => /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(W, { variant: "body2", children: o }) }, o ? _2(o) : a)) });
}, Pc = process.env.NODE_ENV === "development", t2 = (e, t, n) => /* @__PURE__ */ r.jsx(
  So,
  {
    testId: e,
    heading: "An error occurred.",
    supportingText: t,
    children: n
  }
), Dp = ({
  error: e,
  notFound: t
}) => {
  console.error(e);
  const n = e instanceof Error && Pc;
  return _0(e) ? e.status === 404 ? /* @__PURE__ */ r.jsx(t, {}) : t2("router-error", `Error ${e.status}`) : n ? t2("error", e.message, /* @__PURE__ */ r.jsx(Zc, { error: e })) : t2("unknown-error");
}, b1 = ({ icon: e, heading: t, description: n, onClearFilters: o }) => {
  const { translations: a } = Q();
  return /* @__PURE__ */ r.jsx(
    ro,
    {
      icon: e ?? "search",
      heading: t ?? a.common.no_results,
      description: n ?? a.common.no_results_match_your_search,
      actions: o ? [
        {
          id: "clear-filters",
          label: a.common.clear_all_filters,
          onClick: o
        }
      ] : void 0
    }
  );
}, qc = R()((e, { topOffset: t, width: n, anchorToTop: o }) => ({
  menuList: {
    paddingTop: 0,
    paddingBottom: 0
  },
  menuPaper: {
    width: n ? `${n}px` : void 0,
    marginTop: o ? void 0 : t,
    marginBottom: o ? t : void 0,
    boxShadow: e.namedShadows["depth-2"],
    "& > ul > div": {
      // Remove the box-shadow from a contained list
      boxShadow: "none"
    }
  },
  root: {
    "& .MuiBackdrop-root": {
      background: "inherit"
    },
    zIndex: I2
  }
})), Uc = ({
  testId: e,
  anchor: t,
  anchorRef: n,
  open: o,
  onClose: a,
  children: i,
  leftAligned: l = !1,
  topOffset: c = "0.25rem",
  width: d,
  anchorToTop: u = !1
}) => {
  const { classes: p } = qc({ topOffset: c, width: d, anchorToTop: u }), m = o ?? !!t;
  return /* @__PURE__ */ r.jsx(
    Ha,
    {
      "data-testid": e,
      anchorEl: (n == null ? void 0 : n.current) ?? t,
      open: m,
      "data-maintain-drawer": !0,
      onClose: (g) => {
        g.stopPropagation(), a();
      },
      anchorOrigin: {
        vertical: u ? "top" : "bottom",
        horizontal: l ? "left" : "right"
      },
      transformOrigin: {
        vertical: u ? "bottom" : "top",
        horizontal: l ? "left" : "right"
      },
      classes: {
        root: p.root,
        list: p.menuList,
        paper: p.menuPaper
      },
      children: i
    }
  );
}, Gc = R()((e, { variant: t }) => ({
  container: {
    width: "100%",
    borderTop: `0.25rem solid ${{
      neutral: e.palette.neutral[30],
      primary: e.palette.primary["60-key"],
      information: e.palette.info["60-key"],
      success: e.palette.success["60-key"],
      warning: e.palette.warning["60-key"],
      error: e.palette.error["60-key"]
    }[t]}`,
    position: "relative"
  },
  contentContainer: {
    padding: "0.5rem 0rem"
  },
  content: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between"
  },
  divider: {
    width: "100%",
    position: "absolute",
    bottom: 1
  },
  descriptionContainer: {
    display: "flex",
    gap: "0.5rem"
  },
  numberContainer: {
    paddingTop: "0.125rem"
  }
})), p2 = ({
  number: e,
  currency: t,
  locale: n
}) => {
  let o = e.toString();
  try {
    o = new Intl.NumberFormat(n, {
      style: "currency",
      currency: t.toUpperCase()
    }).format(e);
  } catch {
    console.warn(`Unrecognized currency %{currency} for ${e}`);
  }
  return o;
}, Kc = ({
  subTotal: e,
  tax: t,
  currency: n,
  locale: o
}) => {
  const a = e + (t || 0);
  return p2({ number: a, currency: n, locale: o });
}, no = ({
  testId: e,
  showDivider: t,
  subTotalDescription: n,
  subTotal: o,
  subTotalLoading: a,
  currency: i = "USD",
  variant: l = "neutral",
  className: c,
  tax: d,
  taxDescription: u,
  totalDescription: p
}) => {
  const { cx: m, classes: g } = Gc({ variant: l }), { locale: h } = Q(), C = o !== void 0 ? p2({ number: o, currency: i, locale: h }) : "-", v = d !== void 0 ? p2({ number: d, currency: i, locale: h }) : "-", b = d !== void 0 && o !== void 0 ? Kc({ subTotal: o, tax: d, currency: i, locale: h }) : "-";
  return /* @__PURE__ */ r.jsxs("div", { "data-testid": e, className: m(g.container, c), children: [
    /* @__PURE__ */ r.jsxs("div", { className: g.contentContainer, children: [
      /* @__PURE__ */ r.jsxs("div", { className: g.content, children: [
        /* @__PURE__ */ r.jsx("div", { className: g.descriptionContainer, children: /* @__PURE__ */ r.jsx(W, { variant: "body1", children: n }) }),
        /* @__PURE__ */ r.jsx("div", { className: g.numberContainer, children: a ? /* @__PURE__ */ r.jsx(me, { variant: "text", width: "4em" }) : o !== void 0 && /* @__PURE__ */ r.jsx(W, { variant: "h3", children: C }) })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: g.content, children: [
        /* @__PURE__ */ r.jsx("div", { className: g.descriptionContainer, children: /* @__PURE__ */ r.jsx(W, { variant: "body1", children: u }) }),
        /* @__PURE__ */ r.jsx("div", { className: g.numberContainer, children: a ? /* @__PURE__ */ r.jsx(me, { variant: "text", width: "4em" }) : o !== void 0 && /* @__PURE__ */ r.jsx(W, { variant: "h3", children: v }) })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: g.content, children: [
        /* @__PURE__ */ r.jsx("div", { className: g.descriptionContainer, children: /* @__PURE__ */ r.jsx(W, { variant: "body1", children: p }) }),
        /* @__PURE__ */ r.jsx("div", { className: g.numberContainer, children: a ? /* @__PURE__ */ r.jsx(me, { variant: "text", width: "4em" }) : o !== void 0 && /* @__PURE__ */ r.jsx(W, { variant: "h3", children: b }) })
      ] })
    ] }),
    t && /* @__PURE__ */ r.jsx(Ce, { className: g.divider })
  ] });
}, Yc = X.create(({ theme: e }) => ({
  root: {
    minWidth: "40rem",
    [e.breakpoints.down("md")]: {
      minWidth: "30rem"
    },
    [e.breakpoints.down("sm")]: {
      minWidth: "100%"
    }
  },
  refreshIcon: {
    width: "1rem",
    height: "1rem",
    svg: {
      position: "relative",
      left: "0.25rem",
      width: "100%",
      height: "100%"
    }
  }
})), Tp = ({ id: e, error: t }) => {
  const { translations: n } = Q(), { classes: o } = Yc();
  return t ? /* @__PURE__ */ r.jsx("div", { className: o.root, children: /* @__PURE__ */ r.jsx(
    Ke,
    {
      id: e,
      closeButtonEventHandler: () => {
      },
      variant: "error",
      description: n.errors.request_failed,
      actions: [
        {
          label: n.errors.reload_page,
          onClick: () => window.location.reload()
        },
        {
          icon: /* @__PURE__ */ r.jsx("div", { className: o.refreshIcon, children: /* @__PURE__ */ r.jsx(te, { name: "open" }) }),
          label: n.errors.help_center,
          onClick: () => window.open("https://support.inductiveautomation.com/hc/en-us")
        }
      ]
    }
  ) }) : null;
}, ze = ({
  testId: e,
  breakpoint: t = _1,
  open: n,
  anchor: o,
  anchorRef: a,
  onClose: i,
  children: l,
  menuProps: c,
  leftAligned: d,
  bottomDrawerProps: u = { variant: "modal", contentSpacing: "fullWidth" }
}) => {
  const p = Ve(), m = $e(p.breakpoints.down(t)), h = {
    testId: e,
    open: n ?? !!o,
    onClose: i
  }, C = m ? /* @__PURE__ */ r.jsx(T2, { ...u, ...h, children: l }) : /* @__PURE__ */ r.jsx(
    Uc,
    {
      ...c,
      ...h,
      anchorRef: a,
      anchor: o,
      leftAligned: d,
      children: l
    }
  );
  return /* @__PURE__ */ r.jsx(
    V2,
    {
      withinDrawer: m,
      drawerVariant: m ? "bottom" : void 0,
      children: C
    }
  );
}, Qc = R()(
  (e, { updateInterval: t }) => ({
    root: {
      background: e.palette.neutral.white,
      borderRadius: "4px",
      boxShadow: e.namedShadows["depth-2"],
      maxWidth: "25rem",
      width: "fit-content"
    },
    contentContainer: {
      padding: "0.5rem 1rem",
      display: "flex"
    },
    crossIcon: {
      flexShrink: "0",
      position: "relative",
      top: "-0.375rem",
      cursor: "pointer",
      marginLeft: "0.5rem"
    },
    closeButtonContainer: {
      position: "relative",
      height: "1.5rem",
      top: "0.313rem"
    },
    iconContainer: {
      position: "relative",
      top: "0.313rem",
      marginRight: "0.5rem"
    },
    iconColorInformation: {
      color: e.palette.info["60-key"]
    },
    iconColorSuccess: {
      color: e.palette.success["60-key"]
    },
    iconColorWarning: {
      color: e.palette.warning["60-key"]
    },
    iconColorError: {
      color: e.palette.error["60-key"]
    },
    messageContainer: {
      ...e.typography.body1,
      marginTop: "0.375rem",
      marginBottom: "0.375rem",
      overflow: "hidden",
      maxHeight: "3rem",
      flex: 1
    },
    actionButtonContainer: {
      paddingTop: "0.625rem",
      paddingLeft: "0.5rem",
      paddingRight: "0.5rem",
      display: "flex",
      gap: "0.5rem",
      height: "2.25rem"
    },
    progressBar: {
      height: "0.25rem",
      borderBottomLeftRadius: "4px",
      transition: `width ${t}ms linear`
    },
    progressBarEnd: {
      borderBottomRightRadius: "4px"
    },
    progressBarInformation: {
      backgroundColor: e.palette.info["60-key"]
    },
    progressBarSuccess: {
      backgroundColor: e.palette.success["60-key"]
    },
    progressBarWarning: {
      backgroundColor: e.palette.warning["60-key"]
    },
    progressBarError: {
      backgroundColor: e.palette.error["60-key"]
    }
  })
), r2 = 200, Xc = {
  information: "inverted-info",
  success: "inverted-success",
  warning: "inverted-warning",
  error: "inverted-error"
}, Jc = ({
  id: e,
  testId: t,
  message: n,
  variant: o,
  buttonLeftLabel: a = "",
  buttonLeftOnClick: i,
  buttonRightLabel: l = "",
  buttonRightOnClick: c,
  closeButtonEventHandler: d,
  timeToClose: u = 3e3,
  className: p = ""
}) => {
  const { translations: m } = Q(), { cx: g, classes: h } = Qc({
    updateInterval: r2
  }), [C, v] = V(100), b = `iconColor${Ze(o.toLowerCase())}`;
  K(() => {
    const y = setInterval(() => {
      const w = C - r2 / u * 100;
      v(w < 0 ? 0 : w);
    }, r2);
    if (C == 0) {
      clearInterval(y);
      const w = setTimeout(() => {
        d(e), clearTimeout(w);
      }, 300);
    }
    return () => clearInterval(y);
  }, [C, d, e, u]);
  const f = () => {
    const y = a && i, w = l && c;
    return y || w ? /* @__PURE__ */ r.jsxs("div", { className: h.actionButtonContainer, children: [
      y && /* @__PURE__ */ r.jsx(
        G,
        {
          label: a,
          id: `${e}-right-button`,
          testId: `${t}-left-button`,
          buttonVariant: "text",
          onClick: () => {
            i(e);
          }
        }
      ),
      w && /* @__PURE__ */ r.jsx(
        G,
        {
          label: l,
          id: `${e}-right-button`,
          testId: `${t}-right-button`,
          buttonVariant: "text",
          onClick: () => {
            c(e);
          }
        }
      )
    ] }) : null;
  };
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      id: e,
      "data-testid": t,
      "data-snackbar-type": o.toLowerCase(),
      className: g(h.root, p),
      children: [
        /* @__PURE__ */ r.jsxs("div", { className: h.contentContainer, children: [
          /* @__PURE__ */ r.jsx("div", { className: g(h.iconContainer, h[b]), children: /* @__PURE__ */ r.jsx(te, { name: Xc[o] }) }),
          /* @__PURE__ */ r.jsx("div", { className: h.messageContainer, children: n }),
          f(),
          /* @__PURE__ */ r.jsx("div", { className: h.closeButtonContainer, children: /* @__PURE__ */ r.jsx(
            G,
            {
              icon: "cross",
              iconVariant: "neutral",
              className: g(h.crossIcon),
              id: `${e}-close-button`,
              testId: `${t}-close-button`,
              title: m.common.close,
              buttonVariant: "icon",
              onClick: () => d(e)
            }
          ) })
        ] }),
        /* @__PURE__ */ r.jsx(
          "div",
          {
            className: g(
              h.progressBar,
              h[`progressBar${Ze(o.toLowerCase())}`],
              { [h.progressBarEnd]: C === 100 }
            ),
            style: { width: `${C}%` }
          }
        )
      ]
    }
  );
}, e8 = an`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(0%);
    }
`, t8 = an`
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0%);
    }
`, r8 = R()((e) => ({
  root: {
    position: "fixed",
    bottom: "0",
    left: "0",
    padding: "2rem",
    [e.breakpoints.down(s2)]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "1rem",
      right: "0"
    }
  },
  snackbar: {
    marginTop: "0.5rem",
    maxHeight: "5rem",
    animation: `${e8} ${ut} ease-in-out`,
    [e.breakpoints.down(s2)]: {
      animation: `${t8} ${ut} ease-in-out`
    }
  },
  snackbarDesktopExit: {
    opacity: "0",
    transition: `opacity ${ut} ease-in-out`
  },
  snackbarMobileExit: {
    opacity: "0",
    transition: `opacity ${ut} ease-in-out`
  }
})), n8 = 2, o8 = 5e3, Nr = 400, Ir = 300, a8 = ({
  snackbars: e,
  removeSnackbar: t,
  maxSnackbarCount: n = n8
}) => {
  const { classes: o } = r8(), a = Z({}), i = Ve(), l = $e(
    i.breakpoints.down(s2)
  ), c = Z(/* @__PURE__ */ new Set()), d = Te((p) => {
    if (a.current[p]) {
      a.current[p].forEach(clearTimeout);
      const { [p]: m, ...g } = a.current;
      a.current = g, c.current.delete(p);
    }
  }, []);
  K(() => {
    const p = { ...a.current };
    return () => {
      Object.values(p).forEach((m) => {
        m.forEach(clearTimeout);
      });
    };
  }, []);
  const u = Te(
    (p) => {
      if (c.current.has(p)) return;
      const m = document.getElementById(p);
      if (!m) return;
      c.current.add(p), d(p);
      const g = l ? o.snackbarMobileExit : o.snackbarDesktopExit;
      m.classList.add(g);
      const h = [];
      h.push(
        setTimeout(() => {
          m.style.maxHeight = "0px", m.style.transition = `max-height ${Ir}ms ease-in-out`;
        }, Nr)
      ), h.push(
        setTimeout(() => {
          t(p);
        }, Nr + Ir)
      ), a.current[p] = h;
    },
    [
      o.snackbarMobileExit,
      o.snackbarDesktopExit,
      l,
      t,
      d
    ]
  );
  return K(() => {
    e.forEach((p) => {
      if (!a.current[p.id]) {
        const m = setTimeout(() => {
          u(p.id);
        }, o8);
        a.current[p.id] = [m];
      }
    });
  }, [e, u]), K(() => {
    const p = e.filter(
      (m) => !c.current.has(m.id)
    );
    p.length > n && p.slice(
      0,
      p.length - n
    ).forEach((g) => {
      u(g.id);
    });
  }, [e, n, u]), /* @__PURE__ */ r.jsx("div", { className: o.root, children: e.filter((p) => !c.current.has(p.id)).map((p) => /* @__PURE__ */ r.jsx(
    Jc,
    {
      ...p,
      closeButtonEventHandler: u,
      className: o.snackbar
    },
    `${p.id}-snackbar`
  )) });
}, i8 = (e) => ({
  small: void 0,
  large: "18.75rem",
  auto: "auto"
})[e], oo = R()(
  (e, { size: t }) => ({
    tooltipContainer: {
      width: "min-content"
    },
    arrow: {
      fill: e.palette.neutral[90]
    },
    floating: {
      zIndex: jn,
      // See https://stackoverflow.com/questions/11387805/media-query-to-detect-if-device-is-touchscreen/11387852#11387852
      "@media (hover: none)": {
        display: "none"
      }
    },
    tooltip: {
      ...e.typography.subtitle,
      color: e.palette.neutral[10],
      backgroundColor: e.palette.neutral[90],
      maxWidth: t == "small" ? "10.125rem" : void 0,
      width: i8(t),
      borderRadius: "0.25rem",
      padding: "0.4375rem 0.5rem 0.4375rem 0.5rem",
      wordWrap: "break-word"
    }
  })
), $r = 12, v1 = 6, l8 = 4, he = ({
  id: e,
  testId: t,
  title: n,
  placement: o = "top",
  size: a = "small",
  children: i,
  open: l,
  arrow: c = !1,
  className: d,
  delayOverride: u
}) => {
  var z, I;
  const { cx: p, classes: m } = oo({ size: a }), g = Z(null), [h, C] = V(!1), v = l8 + (c ? v1 : 0), { refs: b, floatingStyles: f, context: y, middlewareData: w } = Da({
    open: l ?? h,
    onOpenChange: C,
    middleware: [
      Ua(v),
      Ga(),
      Ka({ padding: 5 }),
      // eslint-disable-next-line react-compiler/react-compiler
      Ya({ element: g, padding: 5 })
    ],
    whileElementsMounted: Qa,
    placement: o,
    strategy: "fixed"
  }), k = ((z = w.arrow) == null ? void 0 : z.x) ?? 0, M = ((I = w.arrow) == null ? void 0 : I.x) ?? 0, L = k + $r / 2, j = M + v1, { delay: N } = Ta(y), E = Ra(y, {
    move: !1,
    delay: u ?? N
  }), $ = Fa(y), S = za(y), _ = Wa(y, { role: "tooltip" }), { isMounted: B, styles: O } = Oa(y, {
    duration: {
      open: 250,
      close: 0
    },
    initial: {
      opacity: 0
    },
    open: {
      opacity: 0.9
    },
    common: ({ side: D }) => ({
      // For an implementation example, see this demo: https://codesandbox.io/s/floating-ui-react-scale-transform-origin-qv0t1c?file=/src/App.tsx
      transformOrigin: {
        top: `${L}px calc(100% + ${v1}px)`,
        bottom: `${L}px ${-v1}px`,
        left: `calc(100% + ${v1}px) ${j}px`,
        right: `${-v1}px ${j}px`
      }[D]
    })
  }), { getReferenceProps: A, getFloatingProps: F } = Za([
    E,
    $,
    S,
    _
  ]);
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      id: e,
      "data-testid": t,
      className: p(m.tooltipContainer, d),
      children: [
        /* @__PURE__ */ r.jsx(
          "div",
          {
            "data-testid": `${t}-children`,
            ref: b.setReference,
            ...A(),
            children: i
          }
        ),
        B && /* @__PURE__ */ r.jsx(Pa, { children: /* @__PURE__ */ r.jsx(
          "div",
          {
            "data-testid": `${t}-tooltip`,
            ref: b.setFloating,
            style: f,
            className: m.floating,
            ...F(),
            children: /* @__PURE__ */ r.jsxs("div", { className: m.tooltip, style: O, children: [
              c ? /* @__PURE__ */ r.jsx(
                qa,
                {
                  ref: g,
                  context: y,
                  width: $r,
                  height: v1,
                  className: m.arrow
                }
              ) : null,
              n
            ] })
          }
        ) })
      ]
    }
  );
}, Z2 = ({
  parentTestId: e,
  kind: t,
  children: n
}) => {
  const { translations: o } = Q(), a = Z(null);
  return /* @__PURE__ */ r.jsx(
    he,
    {
      testId: `${e}-tooltip`,
      title: o.common[`${t}_tooltip`],
      placement: "top",
      children: /* @__PURE__ */ r.jsx("div", { className: "tooltip-container", ref: a, children: n })
    }
  );
}, s8 = X.create({
  truncateText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  },
  tooltip: {
    width: "100%"
  }
}), Ot = ({
  text: e,
  visibleLength: t,
  tooltipTestId: n,
  typographyProps: o
}) => {
  const { cx: a, classes: i } = s8(), l = /* @__PURE__ */ r.jsx(
    W,
    {
      variant: o == null ? void 0 : o.variant,
      className: a(i.truncateText, o == null ? void 0 : o.className),
      children: e
    }
  );
  return e.length <= t ? l : /* @__PURE__ */ r.jsx(he, { testId: n, title: e, className: i.tooltip, children: l });
}, c8 = X.create(({ theme: e }) => ({
  tooltip: {
    "& svg": {
      display: "block"
    }
  },
  icon: {
    width: "1rem",
    height: "1rem",
    color: e.palette.neutral[50]
  }
})), Zt = ({
  icon: e = "access-outlined",
  name: t,
  testId: n,
  className: o
}) => {
  const { classes: a, cx: i } = c8(), l = n || `${e}-tooltip`;
  return /* @__PURE__ */ r.jsx(
    he,
    {
      className: i(a.tooltip, o),
      size: "auto",
      testId: l,
      title: t,
      children: /* @__PURE__ */ r.jsx(te, { name: e, className: a.icon })
    }
  );
}, d8 = R()((e) => ({
  small: {
    height: "0.5rem",
    width: "0.5rem",
    borderRadius: "900px",
    display: "inline-block",
    flexShrink: "0"
  },
  medium: {
    height: "1rem",
    minWidth: "1rem",
    borderRadius: "900px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
    padding: "0.188rem 0.25rem"
  },
  large: {
    height: "1.5rem",
    minWidth: "1.5rem",
    borderRadius: "900px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0"
  },
  largeText: {
    padding: "0.438rem 0.5rem"
  },
  neutralDark: {
    ...e.typography.caps,
    backgroundColor: e.palette.neutral[80],
    color: e.palette.neutral.white
  },
  neutralLight: {
    ...e.typography.caps,
    backgroundColor: e.palette.neutral[20],
    color: e.palette.neutral[80]
  },
  primaryDark: {
    ...e.typography.caps,
    backgroundColor: e.palette.primary["60-key"],
    color: e.palette.neutral.white
  },
  primaryLight: {
    ...e.typography.caps,
    backgroundColor: e.palette.primary[10],
    color: e.palette.primary["60-key"]
  },
  informationDark: {
    ...e.typography.caps,
    backgroundColor: e.palette.info["60-key"],
    color: e.palette.neutral.white
  },
  informationLight: {
    ...e.typography.caps,
    backgroundColor: e.palette.info[10],
    color: e.palette.info["60-key"]
  },
  successDark: {
    ...e.typography.caps,
    backgroundColor: e.palette.success["60-key"],
    color: e.palette.neutral.white
  },
  successLight: {
    ...e.typography.caps,
    backgroundColor: e.palette.success[10],
    color: e.palette.success["60-key"]
  },
  warningDark: {
    ...e.typography.caps,
    backgroundColor: e.palette.warning["60-key"],
    color: e.palette.neutral.white
  },
  warningLight: {
    ...e.typography.caps,
    backgroundColor: e.palette.warning[10],
    color: e.palette.warning["60-key"]
  },
  errorDark: {
    ...e.typography.caps,
    backgroundColor: e.palette.error["60-key"],
    color: e.palette.neutral.white
  },
  errorLight: {
    ...e.typography.caps,
    backgroundColor: e.palette.error[10],
    color: e.palette.error["60-key"]
  },
  customSmall: {
    height: "0.5rem",
    width: "0.5rem",
    svg: {
      height: "0.5rem",
      width: "0.5rem"
    }
  },
  customMedium: {
    svg: {
      height: "1rem",
      width: "1rem"
    }
  },
  customLarge: {
    svg: {
      height: "1.5rem",
      width: "1.5rem"
    }
  },
  customNeutral: {
    color: e.palette.neutral[50]
  },
  customPrimary: {
    color: e.palette.primary["60-key"]
  },
  customInformation: {
    color: e.palette.info["60-key"]
  },
  customSuccess: {
    color: e.palette.success["60-key"]
  },
  customWarning: {
    color: e.palette.warning["60-key"]
  },
  customError: {
    color: e.palette.error["60-key"]
  },
  iconMedium: {
    height: "1rem",
    width: "1rem",
    minWidth: "unset",
    ">svg": {
      width: "0.5rem",
      height: "0.5rem"
    }
  },
  iconLarge: {
    height: "1.5rem",
    width: "1.5rem",
    minWidth: "unset",
    "&& > svg": {
      width: "0.875rem",
      height: "0.875rem"
    }
  }
})), et = ({
  style: e = "light",
  size: t = "small",
  icon: n,
  label: o,
  type: a = "neutral",
  custom: i,
  className: l = ""
}) => {
  const { cx: c, classes: d } = d8(), u = `${a.toLowerCase()}${Ze(e)}`;
  return i ? /* @__PURE__ */ r.jsx(
    "span",
    {
      className: c(
        d[`custom${Ze(t)}`],
        l
      ),
      children: i === "verified" && /* @__PURE__ */ r.jsx(
        te,
        {
          name: "verified",
          className: d[`custom${Ze(a.toLowerCase())}`]
        }
      )
    }
  ) : /* @__PURE__ */ r.jsxs(
    "span",
    {
      className: c(d[t], d[u], l, {
        [d.iconLarge]: t === "large" && !!n,
        [d.iconMedium]: t === "medium" && !!n,
        [d.largeText]: t === "large" && !!o
      }),
      children: [
        t !== "small" && o,
        t !== "small" && n && /* @__PURE__ */ r.jsx(te, { name: n })
      ]
    }
  );
}, u8 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='40'%20height='40'%20fill='none'%20viewBox='0%200%2040%2040'%3e%3cpath%20fill='%23000682'%20d='M21.457%2035.366a20%2020%200%200%201-2.2%203.783c-.2.27-.41.54-.631.8h1.38a20%2020%200%200%200%207.904-1.62l-5.712-4.935q-.312%201.008-.74%201.972M10.422%202.415a20%2020%200%200%200-2.64%201.732l-.521.41A20%2020%200%200%200%204.56%207.28a19.9%2019.9%200%200%201%209.524%203.193z'/%3e%3cpath%20fill='url(%23maker_svg__a)'%20d='m39.315%2014.686-15.507%207.007a4.3%204.3%200%200%201-1.3.35c.447%201.685.672%203.422.67%205.165a20.1%2020.1%200%200%201-1%206.196l5.712%204.934a20%2020%200%200%200%2010.395-10.28%2020.03%2020.03%200%200%200%201-13.412z'/%3e%3cpath%20fill='url(%23maker_svg__b)'%20d='M21.457%2035.366q.426-.94.74-1.922c.656-2%20.994-4.091%201.001-6.196a20%2020%200%200%200-.67-5.165%204.22%204.22%200%200%201-4.272-2.452l-.68-1.491-3.492-7.667A19.9%2019.9%200%200%200%204.56%207.28%2020.025%2020.025%200%200%200%205.7%2033.994q.088.108.19.2A19.93%2019.93%200%200%200%2018.626%2040c.22-.26.43-.53.63-.8a20%2020%200%200%200%202.201-3.834'/%3e%3cpath%20fill='url(%23maker_svg__c)'%20d='m17.556%2018.14.68%201.491a4.22%204.22%200%200%200%204.272%202.452%204.3%204.3%200%200%200%201.3-.35l15.507-7.007a19.6%2019.6%200%200%200-2-4.774%2020%2020%200%200%200-2.212-3.083%209.5%209.5%200%200%200-1-1%2020.005%2020.005%200%200%200-23.68-3.454l3.661%208.058z'/%3e%3cdefs%3e%3clinearGradient%20id='maker_svg__a'%20x1='28.647'%20x2='43.574'%20y1='16.4'%20y2='37.202'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='.11'%20stop-color='%23000682'/%3e%3cstop%20offset='.17'%20stop-color='%23122698'/%3e%3cstop%20offset='.27'%20stop-color='%23325DBC'/%3e%3cstop%20offset='.37'%20stop-color='%234B88D9'/%3e%3cstop%20offset='.46'%20stop-color='%235CA7EE'/%3e%3cstop%20offset='.54'%20stop-color='%2367BAFA'/%3e%3cstop%20offset='.59'%20stop-color='%236BC1FF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='maker_svg__b'%20x1='15.287'%20x2='1.945'%20y1='30.969'%20y2='13.152'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='.09'%20stop-color='%23F03C34'/%3e%3cstop%20offset='.16'%20stop-color='%23F14B35'/%3e%3cstop%20offset='.45'%20stop-color='%23F58437'/%3e%3cstop%20offset='.69'%20stop-color='%23F8AE39'/%3e%3cstop%20offset='.88'%20stop-color='%23FAC83B'/%3e%3cstop%20offset='1'%20stop-color='%23FBD13B'/%3e%3c/linearGradient%3e%3clinearGradient%20id='maker_svg__c'%20x1='27.238'%20x2='25.153'%20y1='25.974'%20y2='-11.929'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='.38'%20stop-color='%2300A878'/%3e%3cstop%20offset='.42'%20stop-color='%2300A078'/%3e%3cstop%20offset='.48'%20stop-color='%23008C7A'/%3e%3cstop%20offset='.55'%20stop-color='%23006A7C'/%3e%3cstop%20offset='.64'%20stop-color='%23003B7F'/%3e%3cstop%20offset='.72'%20stop-color='%23000682'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", p8 = R()((e, { variant: t }) => ({
  root: {
    borderRadius: "50%",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    flexShrink: "0",
    position: "relative"
  },
  avatarSizeTiny: {
    ...e.typography.avatarTiny,
    width: "1.25rem",
    height: "1.25rem",
    svg: {
      height: "0.75rem",
      width: "0.75rem"
    }
  },
  avatarSizeSmall: {
    ...e.typography.avatarSmall,
    width: "1.5rem",
    height: "1.5rem",
    svg: {
      height: "0.875rem",
      width: "0.875rem"
    }
  },
  avatarSizeMedium: {
    ...e.typography.avatarMedium,
    width: "2.5rem",
    height: "2.5rem",
    svg: {
      height: "1.5rem",
      width: "1.5rem"
    }
  },
  avatarSizeLarge: {
    ...e.typography.avatarLarge,
    width: "5rem",
    height: "5rem",
    "> svg": {
      height: "3rem",
      width: "3rem"
    }
  },
  avatarSizeExtraLarge: {
    ...e.typography.avatarExtraLarge,
    width: "6rem",
    height: "6rem",
    "> svg": {
      width: "3.5rem",
      height: "3.5rem"
    }
  },
  textAvatarColorNeutral: {
    backgroundColor: e.palette.neutral[20],
    color: e.palette.neutral[80]
  },
  textAvatarColorFirst: {
    background: e.palette.avatar[1],
    color: e.palette.neutral[10]
  },
  textAvatarColorSecond: {
    background: e.palette.avatar[2],
    color: e.palette.neutral[10]
  },
  textAvatarColorThird: {
    background: e.palette.avatar[3],
    color: e.palette.neutral[10]
  },
  textAvatarColorFourth: {
    background: e.palette.avatar[4],
    color: e.palette.neutral[10]
  },
  textAvatarColorFifth: {
    background: e.palette.avatar[5],
    color: e.palette.neutral[10]
  },
  textAvatarColorSixth: {
    background: e.palette.avatar[6],
    color: e.palette.neutral[10]
  },
  textAvatarColorEmpty: {
    backgroundColor: e.palette.neutral[10],
    color: e.palette.neutral[50]
  },
  iconAvatarColorNeutral: {
    backgroundColor: `${x["neutral-80-15"]}`,
    color: e.palette.neutral[80]
  },
  iconAvatarColorPrimary: {
    backgroundColor: `${x["primary-60-15"]}`,
    color: `${x["primary-60-key"]}`
  },
  iconAvatarColorInfo: {
    backgroundColor: `${x["information-60-15"]}`,
    color: e.palette.info[60]
  },
  iconAvatarColorSuccess: {
    backgroundColor: `${x["success-60-15"]}`,
    color: e.palette.success["60-key"]
  },
  iconAvatarColorWarning: {
    backgroundColor: `${x["warning-60-15"]}`,
    color: e.palette.warning["60-key"]
  },
  iconAvatarColorError: {
    backgroundColor: `${x["error-60-15"]}`,
    color: e.palette.error["60-key"]
  },
  iconAvatarColorMaker: {
    background: `no-repeat center/100% url("${u8}")`,
    color: e.palette.neutral.white
  },
  iconAvatarColorInverse: {
    backgroundColor: `${x["neutral-white-15"]}`,
    color: e.palette.neutral.white
  },
  iconAvatarColorEmpty: {
    backgroundColor: `${x["neutral-50-10"]}`,
    color: e.palette.neutral[50]
  },
  tinyAvatarSmallBadgeTop: {
    position: "absolute",
    top: t === "image_logo" ? "-0.125rem" : "-0.063rem",
    right: t === "image_logo" ? "-0.125rem" : "-0.063rem"
  },
  smallAvatarSmallBadgeTop: {
    position: "absolute",
    top: t === "image_logo" ? "-0.125rem" : "0px",
    right: t === "image_logo" ? "-0.125rem" : "0px"
  },
  mediumAvatarSmallBadgeTop: {
    position: "absolute",
    ...t === "image_logo" ? {
      top: "0rem",
      right: "0rem"
    } : {
      top: "0.125rem",
      left: "1.875rem"
    }
  },
  mediumAvatarMediumBadgeTop: {
    position: "absolute",
    top: t === "image_logo" ? "-0.25rem" : "-0.125rem",
    right: t === "image_logo" ? "-0.25rem" : "-0.125rem"
  },
  largeAvatarSmallBadgeTop: {
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem"
  },
  largeAvatarMediumBadgeTop: {
    position: "absolute",
    top: "0.25rem",
    right: "0.25rem"
  },
  largeAvatarLargeBadgeTop: {
    position: "absolute",
    top: t === "image_logo" ? "-0.375rem" : "0",
    right: t === "image_logo" ? "-0.375rem" : "0"
  },
  extraLargeAvatarLargeBadgeTop: {
    position: "absolute",
    top: t === "image_logo" ? "-0.375rem" : "0",
    right: t === "image_logo" ? "-0.375rem" : "0"
  },
  tinyAvatarSmallBadgeBottom: {
    position: "absolute",
    bottom: "-0.063rem",
    right: "-0.063rem"
  },
  smallAvatarSmallBadgeBottom: {
    position: "absolute",
    bottom: "0px",
    right: "0px"
  },
  mediumAvatarSmallBadgeBottom: {
    position: "absolute",
    bottom: "0.125rem",
    left: "1.875rem"
  },
  mediumAvatarMediumBadgeBottom: {
    position: "absolute",
    bottom: t === "image_logo" ? "-0.25rem" : "-0.125rem",
    right: t === "image_logo" ? "-0.25rem" : "-0.125rem"
  },
  largeAvatarSmallBadgeBottom: {
    position: "absolute",
    bottom: "0.5rem",
    right: "0.5rem"
  },
  largeAvatarMediumBadgeBottom: {
    position: "absolute",
    bottom: "0.25rem",
    right: "0.25rem"
  },
  largeAvatarLargeBadgeBottom: {
    position: "absolute",
    bottom: t === "image_logo" ? "-0.375rem" : "0",
    right: t === "image_logo" ? "-0.375rem" : "0"
  },
  extraLargeAvatarLargeBadgeBottom: {
    position: "absolute",
    bottom: t === "image_logo" ? "-0.375rem" : "0",
    right: t === "image_logo" ? "-0.375rem" : "0"
  },
  iconRoot: {
    display: "grid",
    placeItems: "center"
  },
  iconContainer: {
    overflow: "hidden",
    width: "100%",
    height: "100%"
  }
})), _r = ({
  avatarSize: e,
  badgeSize: t,
  orientation: n
}) => e === "extra_large" ? `extraLargeAvatarLargeBadge${Qe(n)}` : `${e.toLowerCase()}Avatar${Qe(t)}Badge${Qe(n)}`, m8 = (e) => ({
  tiny: "0.156rem",
  small: "0.188rem",
  medium: "0.25rem",
  large: "0.625rem",
  extra_large: "0.75rem"
})[e], we = ({
  size: e = "medium",
  text: t,
  imageUrl: n,
  icon: o,
  variant: a = "icon",
  textAvatarColor: i,
  iconAvatarColor: l = "neutral",
  className: c = "",
  iconClassName: d = "",
  topBadgeProps: u,
  bottomBadgeProps: p,
  textForAvatarColor: m,
  imageUrlRemoveBorderRadius: g = !1
}) => {
  const { cx: h, classes: C } = p8({ variant: a }), v = i ?? k6(m ?? t), b = u ? /* @__PURE__ */ r.jsx(
    et,
    {
      ...u,
      className: C[_r({
        avatarSize: e,
        badgeSize: u.size,
        orientation: "top"
      })]
    }
  ) : null, f = p ? /* @__PURE__ */ r.jsx(
    et,
    {
      ...p,
      className: C[_r({
        avatarSize: e,
        badgeSize: p.size,
        orientation: "bottom"
      })]
    }
  ) : null;
  return a === "text" ? /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: h(
        C.root,
        C[`avatarSize${Qe(Gt(e.toLowerCase()))}`],
        C[`textAvatarColor${Qe(v.toLowerCase())}`],
        c
      ),
      children: [
        t,
        b,
        f
      ]
    }
  ) : a === "icon" ? /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: h(
        C.root,
        C[`avatarSize${Qe(Gt(e.toLowerCase()))}`],
        C[`iconAvatarColor${Qe(l.toLowerCase())}`],
        C.iconRoot,
        c
      ),
      children: [
        o ? /* @__PURE__ */ r.jsx(
          te,
          {
            name: o,
            className: h(C.iconContainer, d)
          }
        ) : null,
        b,
        f
      ]
    }
  ) : /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: h(
        C.root,
        C[`avatarSize${Qe(Gt(e.toLowerCase()))}`],
        c
      ),
      style: {
        background: `no-repeat center/cover url(${n})`,
        ...g ? { borderRadius: "0%" } : {},
        ...a === "image_logo" ? { borderRadius: m8(e) } : {}
      },
      children: [
        b,
        f
      ]
    }
  ) });
}, h8 = R()(
  (e, { isStackedBackdrop: t }) => ({
    root: {
      backgroundColor: e.palette.overlay.primary,
      // This places the backdrop above the App Bar and Navigation components.
      // Instantiation of dialogs also instantiate a new backdrop
      // A dialog (and its bakdrop) that rests on top of the other must be cover the content below it
      zIndex: t ? bn : E2,
      "@media print": {
        background: "#fff",
        opacity: 1,
        height: "100vh"
      }
    }
  })
), g8 = ({
  open: e,
  onClick: t,
  isStackedBackdrop: n = !1,
  children: o
}) => {
  const { classes: a } = h8({ isStackedBackdrop: n });
  return /* @__PURE__ */ r.jsx(
    Xa,
    {
      open: e,
      onClick: t,
      classes: {
        root: a.root
      },
      children: o
    }
  );
}, it = R()((e, { variant: t = "large" }) => ({
  scrollView: { borderRadius: "0.25rem" },
  container: {
    marginLeft: t === "small" ? "0.25rem" : 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: t === "small" ? "0.125rem" : 0,
    padding: "0.1875rem 0 0.1875rem 0",
    "& > div:last-of-type": {
      paddingRight: t === "small" ? "0.25rem" : 0
    }
  },
  breadcrumbAndChevronContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  breadcrumb: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "max-content"
  },
  breadcrumbLarge: {
    border: 0,
    backgroundColor: "inherit",
    borderRadius: "0.375rem",
    padding: 0
  },
  breadcrumbLargeInteractive: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: `${x["neutral-80"]}0D`
    },
    "&:active": {
      backgroundColor: `${x["neutral-80"]}1A`
    },
    "&:focus-visible": {
      backgroundColor: `${x["neutral-80"]}0D`,
      outline: 0
    },
    "&:disabled": {}
  },
  breadcrumbSmall: {
    color: e.palette.neutral[60],
    whiteSpace: "nowrap"
  },
  breadcrumbSmallNonInteractive: {
    cursor: "default",
    "&:hover": {
      textDecoration: "none"
    },
    "&:active": {
      outline: 0
    }
  },
  breadcrumbWithMenuOpen: {
    backgroundColor: `${x["neutral-80"]}1A`
  },
  label: {
    ...t === "small" ? e.typography.button2 : e.typography.h1,
    color: t === "small" ? e.palette.neutral[60] : e.palette.neutral[80],
    padding: t === "small" ? 0 : "0.25rem 0.5rem 0.25rem 0.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.25rem"
  },
  labelWithMenu: {
    paddingRight: "0.25rem"
  },
  menuIcon: {
    color: e.palette.neutral[80]
  },
  chevronContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "1.5rem",
    height: "1.5rem"
  },
  chevron: {
    width: "0.5rem",
    height: "0.75rem"
  },
  chevronContainerSmall: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "0.75rem",
    minWidth: "0.75rem",
    height: "0.75rem"
  },
  chevronSmall: {
    width: "0.25rem",
    height: "0.375rem"
  },
  smallScreenBackButton: {
    width: "2rem",
    height: "2rem"
  }
})), C8 = ({
  id: e,
  testId: t,
  label: n,
  loading: o,
  onClick: a,
  last: i
}) => {
  const { cx: l, classes: c } = it({ variant: "small" });
  if (o) return /* @__PURE__ */ r.jsx(me, { variant: "rounded", width: 72, height: 16 });
  const d = !i;
  return /* @__PURE__ */ r.jsx(
    G,
    {
      buttonVariant: "text",
      size: "small",
      testId: t,
      className: l(c.breadcrumb, c.breadcrumbSmall, {
        [c.breadcrumbSmallNonInteractive]: !d
      }),
      onClick: () => a(e),
      children: /* @__PURE__ */ r.jsx(W, { component: "div", className: c.label, children: n })
    }
  );
}, v8 = ({
  parentTestId: e,
  breadcrumbs: t,
  onClick: n
}) => {
  const { cx: o, classes: a } = it({ variant: "small" }), i = /* @__PURE__ */ r.jsx(
    G,
    {
      buttonVariant: "text",
      size: "small",
      testId: `${e}-overflow`,
      className: o(a.breadcrumb, a.breadcrumbSmall),
      onClick: n,
      children: /* @__PURE__ */ r.jsx(W, { component: "div", className: a.label, children: "..." })
    }
  ), l = `${e}-overflow-tooltip`, c = t.map((d) => d.label).join(" › ");
  return /* @__PURE__ */ r.jsx(he, { id: l, testId: l, title: c, children: i });
}, f8 = R()((e, { selected: t, variant: n, disabled: o, containerHeight: a }) => {
  const i = n !== "checkbox" && n !== "radio", l = t && n !== "destructive";
  return {
    root: {
      listStyle: "none"
    },
    listItemButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      border: "none",
      cursor: o ? "default" : "pointer",
      width: "100%",
      height: "100%",
      // minHeight: "2.5rem",
      paddingTop: i ? "0.344rem" : "0.125rem",
      paddingBottom: i ? "0.344rem" : "0.125rem",
      backgroundColor: l ? e.palette.primary[10] : "initial",
      "&:hover": {
        backgroundColor: l ? e.palette.primary[20] : e.palette.neutral[20]
      },
      "&:active": {
        backgroundColor: l ? e.palette.primary[30] : e.palette.neutral[30]
      },
      "&:disabled": {
        backgroundColor: t && o ? e.palette.neutral[20] : "initial !important"
      },
      "&:focus-visible": {
        outline: "none",
        backgroundColor: l ? e.palette.primary[20] : e.palette.neutral[20]
      }
    },
    gap: {
      marginRight: "0.5rem"
    },
    default: {
      paddingLeft: i ? "0.5rem" : "0.125rem",
      paddingRight: "0.5rem"
    },
    spacious: {
      paddingLeft: i ? "1.5rem" : "1.125rem",
      paddingRight: "1.5rem"
    },
    icon: {
      height: "1.5rem",
      width: "1.5rem",
      alignItems: "center",
      color: e.palette.neutral[80],
      marginTop: i ? "0.125rem" : "0.375rem"
    },
    iconDisabled: {
      opacity: "0.40"
    },
    iconSelected: {
      color: e.palette.primary["60-key"]
    },
    iconVariantDestructive: {
      color: e.palette.error["60-key"]
    },
    iconVariantNeutralLight: {
      color: e.palette.neutral[50]
    },
    label: {
      color: e.palette.neutral[80],
      overflow: "hidden",
      wordWrap: "break-word",
      margin: 0,
      fontSize: "1rem",
      fontStyle: "normal",
      fontFamily: "Proxima Nova",
      fontWeight: 400,
      lineHeight: "1.5rem",
      letterSpacing: "normal",
      flex: 1,
      textAlign: "start",
      marginLeft: "0rem",
      marginTop: i ? "0.125rem" : "0.375rem",
      marginBottom: i ? "0.125rem" : "0.375rem"
    },
    listItemCheckBox: {
      marginLeft: "0rem",
      marginRight: "0rem"
    },
    labelDisabled: {
      color: e.palette.neutral[50]
    },
    labelSelected: {
      color: e.palette.primary["60-key"]
    },
    labelVariantDestructive: {
      color: e.palette.error["60-key"]
    },
    labelVariantDestructiveDisabled: {
      opacity: 0.4,
      color: e.palette.error["60-key"]
    },
    labelVariantDocumentation: {
      color: e.palette.info.documentation
    },
    chipWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.375rem",
      marginBottom: "0.375rem",
      minHeight: "1.5rem",
      marginTop: i ? "0.188rem" : "0.375rem"
    },
    listItemRadio: {
      marginLeft: "0rem",
      marginRight: "0rem"
    },
    collapsibleContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      ...i ? {
        height: "1.813rem",
        marginLeft: "0.5rem",
        marginRight: "0.5rem"
      } : {
        height: "2.25rem",
        marginLeft: "0.875rem",
        marginRight: "0"
      }
    },
    leftContentContainer: {
      position: "relative"
    },
    treeLine: {
      position: "absolute",
      backgroundColor: e.palette.neutral[30],
      height: `calc(${a}px - 2.25rem)`,
      width: "0.094rem",
      left: "1.066rem",
      top: "2rem"
    },
    treeLineIcon: {
      left: "0.672rem",
      top: "1.75rem"
    }
  };
}), n2 = ({ bottomLine: e }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    preserveAspectRatio: "none",
    viewBox: "0 0 16 72",
    fill: "none",
    style: {
      width: "100%",
      height: "100%"
    },
    xmlns: "http://www.w3.org/2000/svg",
    children: e ? /* @__PURE__ */ r.jsx("path", { d: "M8.5 0L8.5 72", stroke: "#E6E6E6" }) : /* @__PURE__ */ r.jsx("path", { d: "M8.5 0L8.5 14", stroke: "#E6E6E6" })
  }
), x8 = () => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    preserveAspectRatio: "none",
    viewBox: "0 0 16 40",
    fill: "none",
    style: {
      width: "100%",
      height: "100%"
    },
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r.jsx("path", { d: "M8.5 0L8.5 16", stroke: "#E6E6E6" }),
      /* @__PURE__ */ r.jsx("path", { d: "M12.5 20C10.2909 20 8.5 18.2091 8.5 16", stroke: "#E6E6E6" }),
      /* @__PURE__ */ r.jsx("path", { d: "M16 20H12.5", stroke: "#E6E6E6" })
    ]
  }
), b8 = R()((e, { size: t, selectable: n }) => ({
  root: {
    display: "flex",
    height: `calc(100% + ${n ? "0.25rem" : "1rem"})`
  },
  lineContainer: {
    position: "relative",
    width: "1.25rem",
    height: "100%",
    left: n ? "7px" : "1px",
    marginRight: "0.25rem",
    ...n ? {} : { top: "0.25rem" }
  },
  internalLineContainer: {
    // This allows the line to position beyond the bounds of its container, inspired by
    // http://engineering.hackerearth.com/2021/08/12/how-to-set-a-react-component-as-a-background-image/.
    position: "absolute",
    height: "100%",
    ...n ? { top: "-1rem" } : { top: "-1.25rem" },
    right: 0,
    ...n ? { bottom: t === "spacious" ? "-3.5rem" : "unset" } : { bottom: t === "spacious" ? "-3rem" : "unset" },
    left: 0
  },
  iconFixedToTopTree: {
    position: "absolute",
    top: n ? "0.5rem" : "0.25rem",
    left: 0,
    right: 0,
    height: "100%"
  },
  iconFixedToTop: {
    position: "absolute",
    top: n ? "0.5rem" : "0.25rem",
    left: 0,
    right: 0
  },
  iconExtendingAboveTop: {
    position: "absolute",
    top: "-0.5rem"
  }
})), w8 = (e, t, n, o) => {
  if (t === null) return null;
  if (!n) return /* @__PURE__ */ r.jsx(n2, { bottomLine: !0 });
  const a = t === !0;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    a && !o && /* @__PURE__ */ r.jsx("div", { className: e.iconExtendingAboveTop, children: /* @__PURE__ */ r.jsx(n2, {}) }),
    /* @__PURE__ */ r.jsx("div", { className: e.iconFixedToTopTree, children: /* @__PURE__ */ r.jsx(n2, { bottomLine: !a }) }),
    /* @__PURE__ */ r.jsx("div", { className: e.iconFixedToTop, children: /* @__PURE__ */ r.jsx(x8, {}) })
  ] });
}, y8 = ({
  parentId: e,
  hierarchySpec: t,
  size: n,
  variant: o,
  isFirstChild: a
}) => {
  const i = ["checkbox", "radio"].includes(o), { classes: l } = b8({ size: n, selectable: i }), c = Mn(t), d = c.map((u, p) => w8(l, u, p === c.length - 1, a));
  return /* @__PURE__ */ r.jsx("div", { className: l.root, children: d.map((u, p) => /* @__PURE__ */ r.jsx(
    "div",
    {
      className: l.lineContainer,
      children: /* @__PURE__ */ r.jsx("div", { className: l.internalLineContainer, children: u })
    },
    `${e}-tree-line-${p}`
  )) });
}, gt = 40, Se = ({
  label: e,
  size: t = "default",
  variant: n = "default",
  iconRight: o,
  iconRightClassName: a,
  iconRightVariant: i,
  chipLabel: l,
  chipState: c = "neutral",
  onSelection: d,
  selected: u = !1,
  id: p,
  disabled: m = !1,
  iconLeft: g,
  iconLeftClassName: h,
  className: C = "",
  testId: v = p,
  hierarchySpec: b = [],
  isFirstChild: f = !1,
  collapsible: y,
  hasChildren: w,
  isCollapsed: k,
  onCollapse: M,
  accessIcon: L
}) => {
  const { translations: j } = Q(), [N, E] = V(0), { cx: $, classes: S } = f8({
    selected: u,
    variant: n,
    disabled: m,
    containerHeight: N
  });
  let _;
  y ? _ = "collapse" : n === "radio" ? _ = "radio" : n === "checkbox" ? _ = "checkbox" : g && (_ = "icon");
  const B = n === "radio" || n === "checkbox", O = qe.useRef(null), A = n === "destructive", F = n === "documentation", z = (T) => {
    d == null || d({ id: p, value: !u }, T);
  };
  K(() => {
    const T = () => {
      O.current && (O.current.style.height = "auto", O.current.style.height = `${O.current.clientHeight}px`, E(O.current.clientHeight));
    };
    return T(), setTimeout(T, 100), window.addEventListener("resize", T), () => window.removeEventListener("resize", T);
  }, [
    t,
    n,
    e,
    g,
    o,
    l,
    y,
    l,
    C
  ]);
  const I = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      y8,
      {
        parentId: p,
        hierarchySpec: b,
        size: t,
        variant: n,
        isFirstChild: f
      }
    ),
    y && w && /* @__PURE__ */ r.jsxs("div", { className: S.leftContentContainer, children: [
      _ === "collapse" && !k && N > gt && /* @__PURE__ */ r.jsx(
        "div",
        {
          className: $(
            S.treeLine,
            B ? "" : S.treeLineIcon
          )
        }
      ),
      /* @__PURE__ */ r.jsx("div", { className: $(S.collapsibleContainer), children: /* @__PURE__ */ r.jsx(
        Ja,
        {
          "data-testid": v,
          disableRipple: !0,
          onClick: () => M && M(p),
          children: /* @__PURE__ */ r.jsx("div", { style: k ? { transform: "rotate(270deg)" } : {}, children: /* @__PURE__ */ r.jsx(te, { name: "caret" }) })
        }
      ) })
    ] }),
    n === "checkbox" && /* @__PURE__ */ r.jsxs("div", { className: S.leftContentContainer, children: [
      w && _ === "checkbox" && N > gt && /* @__PURE__ */ r.jsx("div", { className: $(S.treeLine) }),
      /* @__PURE__ */ r.jsx(
        p1,
        {
          className: S.listItemCheckBox,
          testId: "list-item-checkbox",
          id: `${p}-checkbox`,
          label: `${j.common.checkbox_tooltip} ${e}`,
          labelHidden: !0,
          disabled: m,
          checked: u,
          onValueChange: () => z()
        }
      )
    ] }),
    n === "radio" && /* @__PURE__ */ r.jsxs("div", { className: S.leftContentContainer, children: [
      w && _ === "radio" && N > gt && /* @__PURE__ */ r.jsx("div", { className: $(S.treeLine) }),
      /* @__PURE__ */ r.jsx(
        at,
        {
          testId: "list-item-radio",
          id: `${p}-radio`,
          disabled: m,
          className: S.listItemRadio,
          label: `${j.common.radio_tooltip} ${e}`,
          labelHidden: !0,
          value: "",
          checked: u,
          onValueChange: () => z()
        }
      )
    ] }),
    g && /* @__PURE__ */ r.jsxs("div", { className: $(S.leftContentContainer, S.gap), children: [
      w && _ === "icon" && N > gt && /* @__PURE__ */ r.jsx("div", { className: $(S.treeLine, S.treeLineIcon) }),
      /* @__PURE__ */ r.jsx(
        te,
        {
          name: g,
          className: $(
            S.icon,
            {
              [S.iconSelected]: u,
              [S.iconVariantDestructive]: A,
              [S.labelVariantDocumentation]: F,
              [S.iconDisabled]: m
            },
            h
          )
        }
      )
    ] }),
    /* @__PURE__ */ r.jsx(
      "p",
      {
        className: $(S.label, S.gap, {
          [S.labelSelected]: u,
          [S.labelVariantDestructive]: A,
          [S.labelVariantDocumentation]: F,
          [S.labelDisabled]: m,
          [S.labelVariantDestructiveDisabled]: A && m
        }),
        children: e
      }
    ),
    l && /* @__PURE__ */ r.jsx("div", { className: $(S.chipWrapper, S.gap), children: /* @__PURE__ */ r.jsx(
      _e,
      {
        items: {
          id: `${p}-chip`,
          label: l,
          disabled: m
        },
        testId: "list-item-chip",
        variant: "small",
        state: c
      }
    ) }),
    L && /* @__PURE__ */ r.jsx("div", { className: $(S.chipWrapper, S.gap), children: /* @__PURE__ */ r.jsx(Zt, { name: L.name }) }),
    o && /* @__PURE__ */ r.jsx(
      te,
      {
        name: o,
        className: $(
          S.icon,
          {
            [S.iconSelected]: u,
            [S.iconVariantDestructive]: A,
            [S.iconDisabled]: m,
            [S.iconVariantNeutralLight]: i === "neutralLight"
          },
          a
        )
      }
    )
  ] }), D = ["default", "destructive", "documentation"].includes(n), H = {
    className: $(S.listItemButton, [S[t]])
  };
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      "data-listitem": !0,
      id: p,
      "data-testid": v,
      className: $(S.root, C),
      ref: O,
      children: D ? /* @__PURE__ */ r.jsx("button", { ...H, disabled: m, onClick: z, children: I }) : /* @__PURE__ */ r.jsx("label", { ...H, children: I })
    }
  );
}, k8 = R()(() => ({
  root: {
    borderColor: "var(--border-rest)",
    borderBottomWidth: "1px"
  }
})), Ce = ({ testId: e, variant: t, className: n }) => {
  const { classes: o } = k8();
  return /* @__PURE__ */ r.jsx(
    xt,
    {
      "data-testid": e,
      className: n,
      classes: o,
      variant: t
    }
  );
}, j8 = R()(
  (e, { fullHeight: t }) => ({
    listContainer: {
      width: "100%",
      height: "100%",
      overflowY: "auto",
      overflowX: "hidden",
      backgroundColor: "white",
      maxHeight: t ? "unset" : "14rem",
      "&:focus-visible": {
        outline: `1px solid ${e.palette.primary["60-key"]}`
      }
    },
    roundTop: {
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px"
    },
    roundBottom: {
      borderBottomLeftRadius: "4px",
      borderBottomRightRadius: "4px"
    },
    listContainerShadow: {
      boxShadow: e.namedShadows["depth-2"]
    },
    scrollView: {
      maxHeight: "100%"
    },
    list: {
      margin: 0,
      padding: e.spacing(0, 0)
    },
    listSubheader: {
      ...e.typography.overline,
      padding: e.spacing(2, 1, 0.5, 1),
      wordWrap: "break-word"
    },
    spacious: {
      display: "flex",
      flexDirection: "column",
      gap: e.spacing(1)
    },
    spaciousPadding: {
      padding: e.spacing(2, 0)
    },
    subheaderSpacious: {
      padding: e.spacing(3, 2, 1, 2)
    },
    subheaderDialog: {
      padding: "1.5rem 3.5rem 0.5rem 3.5rem"
    },
    listItemSpacious: {
      marginBottom: e.spacing(1)
    },
    listContainerSpacious: {
      maxHeight: t ? "unset" : "17.25rem"
    }
  })
), S8 = (e) => "hasDivider" in e, L8 = (e) => !("hasDivider" in e), l1 = ({
  testId: e,
  variant: t,
  subheader: n,
  items: o,
  onSelection: a,
  itemComponent: i,
  minWidth: l = 200,
  maxWidth: c,
  containerClassName: d,
  subheaderVariant: u = "default",
  subheaderClassName: p,
  fullHeight: m = !1,
  showNoResults: g = !0,
  showShadow: h = !0,
  roundTop: C = !0,
  roundBottom: v = !0,
  removeFromTabOrder: b = !1,
  navigateWithArrowKeys: f = !0,
  hideLastDivider: y = !0
}) => {
  const { withinDrawer: w, drawerVariant: k } = H1(), M = t === "spacious" || !t && w, { cx: L, classes: j } = j8({
    fullHeight: m || w
  }), { onKeyDown: N } = Rt({ kind: "list" }), E = ($, S) => {
    if (L8($))
      return {
        size: w ? "spacious" : $.size
      };
    if (S8($)) {
      const _ = S === o.length - 1;
      return {
        hasDivider: y && _ ? !1 : $.hasDivider
      };
    }
  };
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      tabIndex: b ? -1 : 0,
      "data-list": !0,
      "data-testid": e ?? `list-${t}`,
      style: {
        minWidth: l,
        maxWidth: c
      },
      className: L(
        j.listContainer,
        {
          [j.listContainerShadow]: h,
          [j.listContainerSpacious]: M,
          [j.roundTop]: C,
          [j.roundBottom]: v
        },
        d
      ),
      children: /* @__PURE__ */ r.jsx(ue, { removeFromTabOrder: !0, className: j.scrollView, children: /* @__PURE__ */ r.jsxs(
        "div",
        {
          className: L(j.list, {
            [j.spacious]: M,
            [j.spaciousPadding]: M && k !== "side"
          }),
          onKeyDown: f ? N : void 0,
          children: [
            n ? /* @__PURE__ */ r.jsx(
              "div",
              {
                className: L(
                  j.listSubheader,
                  {
                    [j.subheaderSpacious]: M || u === "spacious",
                    [j.subheaderDialog]: u === "dialog"
                  },
                  p
                ),
                children: n
              }
            ) : null,
            !o.length && g && /* @__PURE__ */ r.jsx(b1, {}),
            o.map(($, S) => /* @__PURE__ */ r.jsx(
              i,
              {
                ...$,
                testId: `${e ?? "list-item"}-${$.testId ?? $.id}`,
                onSelection: a,
                className: L(d, $.className),
                ...E($, S)
              },
              $.id
            ))
          ]
        }
      ) })
    }
  );
}, M8 = R()((e) => ({
  container: {
    display: "flex",
    justifyContent: "space-between"
  },
  filterIcon: {
    marginLeft: "0.5rem",
    alignSelf: "center"
  },
  selectAllContainer: {
    paddingTop: "0.1rem",
    marginLeft: "-0.5625rem",
    marginRight: "0.5rem"
  },
  filterItemsWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
    paddingLeft: "0.125rem",
    height: 0,
    overflow: "hidden",
    paddingTop: 0,
    paddingBottom: 0
  },
  filterItemsWrapperOpen: {
    minHeight: "3rem",
    height: "auto",
    overflow: "visible",
    paddingTop: "0.875rem",
    paddingBottom: "0.125rem"
  },
  filterItemsContainer: {
    flex: "0 1 auto",
    minWidth: 0,
    ">div": {
      display: "flex",
      flexWrap: "nowrap",
      gap: "0.25rem",
      maxWidth: "100%",
      overflowX: "auto",
      alignItems: "center"
    }
  },
  filterItemsContainerMasked: {
    maskImage: "linear-gradient(to right, black calc(100% - 1.5rem), transparent 100%)",
    ">div": {
      paddingRight: "1.5rem"
    }
  },
  clearAllButton: {
    flexShrink: 0
  },
  childrenContainer: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    padding: "0.5rem 1rem 0 1rem",
    margin: "0.5rem -0.5rem 0 -0.5rem",
    borderTop: `1px solid ${e.palette.neutral[30]}`
  }
})), E8 = { top: 1, right: 1, bottom: 1, left: 1 }, m2 = {
  default: E8,
  condensed: { top: 0.5, right: 1, bottom: 0.5, left: 1 },
  spacious: { top: 1.5, right: 1.5, bottom: 1.5, left: 1.5 },
  dialog: { top: 1, right: 3.5, bottom: 1, left: 3.5 },
  drawer: { top: 1, left: 1.5, bottom: 1, right: 1.5 }
}, N8 = 3.25, I8 = (e, t) => t ? { ...e, right: e.right + N8 } : e, $8 = (e = "default", t) => {
  const n = m2[e], o = I8(n, t);
  return r4(o);
}, _8 = (e) => e === "condensed" ? "0.5rem" : e === "spacious" ? "1.5rem" : "1rem", V8 = (e) => e === "spacious" ? "1.5rem" : e === "dialog" ? "3.5rem" : "1rem", Vr = 460, ao = R()(
  (e, {
    disabled: t,
    selected: n,
    density: o,
    withinTree: a,
    hasActions: i,
    infoWidth: l = 0,
    interactive: c = !0,
    hideInfo: d = !0
  }) => ({
    container: {
      position: "relative",
      width: "100%"
    },
    button: {
      position: "relative",
      border: 0,
      backgroundColor: "transparent",
      textDecoration: "none",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "start",
      ...$8(o, i),
      cursor: t ? "default" : "pointer",
      pointerEvents: t || !c ? "none" : void 0,
      width: "100%",
      minHeight: "4.5rem",
      minWidth: a ? "31rem" : void 0,
      [e.breakpoints.down("sm")]: o === "dialog" ? {
        minWidth: a ? "31rem" : void 0,
        padding: "1rem"
      } : {},
      "&:disabled": {
        ".MuiCheckbox-root span": {
          backgroundColor: n ? e.palette.neutral[30] : "",
          opacity: 1
        }
      },
      "&:hover": {
        backgroundColor: e.palette.neutral[20],
        ".MuiCheckbox-root, .MuiRadio-root": {
          backgroundColor: t ? "" : `${x["neutral-80"]}0C`
        },
        ".MuiCheckbox-root > span": {
          border: !n && !t ? `2px solid ${e.palette.neutral[40]}` : ""
        },
        ".MuiRadio-root circle.emptyIcon": {
          stroke: t ? "" : e.palette.neutral[40]
        }
      },
      "&:active": {
        backgroundColor: e.palette.neutral[30],
        ".MuiCheckbox-root, .MuiRadio-root": {
          backgroundColor: t ? "" : `${x["neutral-80"]}19`
        },
        ".MuiCheckbox-root > span": {
          border: !n && !t ? `2px solid ${e.palette.neutral[50]}` : ""
        },
        ".MuiRadio-root circle.emptyIcon": {
          stroke: t ? "" : e.palette.neutral[50]
        }
      },
      "&:focus-visible": {
        backgroundColor: e.palette.neutral[20],
        outline: 0,
        ".MuiCheckbox-root, .MuiRadio-root": {
          backgroundColor: t ? "" : `${x["neutral-80"]}0C`
        },
        ".MuiCheckbox-root > span": {
          border: !n && !t ? `2px solid ${e.palette.neutral[40]}` : ""
        },
        ".MuiRadio-root circle.emptyIcon": {
          stroke: t ? "" : e.palette.neutral[40]
        }
      }
    },
    leftContainer: {
      display: "flex",
      flexDirection: "row",
      marginRight: `calc(1rem + ${l}px)`,
      alignItems: "start",
      height: "100%",
      [e.breakpoints.down(Vr)]: d ? {
        marginRight: 0
      } : void 0
    },
    avatarContainer: {
      position: "relative",
      height: "100%",
      marginRight: "1rem",
      opacity: t ? "0.4" : "1"
    },
    hasChildrenLine: {
      position: "absolute",
      top: "2.75rem",
      width: "2.5rem",
      height: "100%"
    },
    hasChildrenLineWithNoAvatar: {
      position: "absolute",
      top: "3.5rem",
      width: "2.5rem",
      height: "100%"
    },
    leftInnerContainer: {
      display: "flex",
      flexDirection: "column",
      opacity: t ? "0.4" : "1",
      minHeight: "2.5rem",
      justifyContent: "center",
      gap: "0.125rem"
    },
    textAndChipContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "0.375rem"
    },
    heading: {
      textAlign: "left",
      [e.breakpoints.down("sm")]: {
        overflow: "hidden",
        wordBreak: o === "dialog" ? "break-word" : "normal"
      }
    },
    chip: {
      position: "relative",
      top: "-0.0625rem",
      ".MuiStack-root": {
        display: "inline-flex"
      }
    },
    subtext: {
      ...e.typography.subtitle,
      color: e.palette.neutral[70],
      paddingRight: "2.5rem",
      textAlign: "left",
      overflow: "hidden",
      [e.breakpoints.down("md")]: o === "dialog" ? {
        paddingRight: 0
      } : {},
      [e.breakpoints.down("sm")]: {
        wordBreak: o === "dialog" ? "break-word" : "normal",
        paddingRight: 0
      }
    },
    rightContainer: {
      position: "absolute",
      top: "1rem",
      right: i ? m2[o ?? "default"].right * 16 + 52 : m2[o ?? "default"].right * 16,
      // TODO: Add right space to left container when hasInfo === true
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
      minHeight: "2.5rem"
    },
    rightContinerOpacity: {
      opacity: t ? "0.4" : "1"
    },
    infoContainer: {
      // NOTE: (2024-02-15) Noah Settersten => We don't constrain aa maximum height here so that the complex list item
      // can grow vertically when needed. Unfortunately, this means that some components need to have a height of 2.5rem
      // set so that they don't cause the complex list item to grow (e.g. Select, TextField).
      maxWidth: "12.5rem",
      [e.breakpoints.down("sm")]: {
        maxWidth: "5rem"
      },
      [e.breakpoints.down(Vr)]: d ? {
        display: "none"
      } : void 0
    },
    menuContainer: {
      position: "absolute",
      top: _8(o),
      right: V8(o),
      alignSelf: "start",
      marginLeft: "1rem",
      marginTop: "0.125rem"
    },
    listItemCheckBox: {
      marginLeft: "-0.5625rem",
      marginRight: "0.4375rem",
      ".MuiCheckbox-root": {
        marginTop: "0.0625rem"
      }
    },
    listItemRadio: {
      marginLeft: "-0.5625rem",
      marginRight: "0.4375rem",
      ".MuiRadio-root": {
        marginTop: "0.0925rem"
      }
    },
    fullHeightInput: {
      height: "100%"
    },
    dividerContainer: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0
    }
  })
), io = ({
  id: e,
  testId: t,
  labelSuffix: n,
  variant: o,
  disabled: a = !1,
  selected: i,
  onSelection: l,
  fullHeight: c = !1
}) => {
  const { translations: d } = Q(), { cx: u, classes: p } = ao({}), m = (g) => {
    l && l(g);
  };
  if (o === "checkbox")
    return /* @__PURE__ */ r.jsx(
      p1,
      {
        testId: t,
        id: `${e}-checkbox`,
        className: u(p.listItemCheckBox, {
          [p.fullHeightInput]: c
        }),
        label: `${d.common.checkbox_tooltip} ${n}`,
        labelHidden: !0,
        disabled: a,
        checked: i,
        onValueChange: m
      }
    );
  if (o === "radio")
    return /* @__PURE__ */ r.jsx(
      at,
      {
        testId: t,
        id: `${e}-radio`,
        className: u(p.listItemRadio, {
          [p.fullHeightInput]: c
        }),
        label: `${d.common.radio_tooltip} ${n}`,
        labelHidden: !0,
        value: "",
        disabled: a,
        checked: i,
        onValueChange: () => m({ id: `${e}-radio`, value: !i })
      }
    );
}, A8 = R()((e, { density: t }) => ({
  root: {
    display: "flex",
    height: "100%"
  },
  lineContainer: {
    position: "relative",
    width: "2.5rem",
    height: "100%",
    marginRight: "0.25rem"
  },
  internalLineContainer: {
    // This allows the line to position beyond the bounds of its container, inspired by
    // http://engineering.hackerearth.com/2021/08/12/how-to-set-a-react-component-as-a-background-image/.
    position: "absolute",
    top: t === "condensed" ? "-0.75rem" : t === "spacious" ? "-1.5rem" : "-1rem",
    right: 0,
    bottom: t === "condensed" ? "-0.75rem" : t === "spacious" ? "-1.5rem" : "-1rem",
    left: 0
  },
  iconFixedToTop: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: t === "condensed" ? "4rem" : t === "spacious" ? "5.5rem" : "4.5rem"
  },
  iconExtendingAboveTop: {
    position: "absolute",
    top: t === "spacious" ? "-1.25rem" : "-0.75rem",
    ...t === "condensed" ? {
      display: "none"
    } : {}
  }
})), f1 = ({ bottomLine: e }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    preserveAspectRatio: "none",
    viewBox: "0 0 40 72",
    fill: "none",
    style: {
      width: "100%",
      height: "100%"
    },
    xmlns: "http://www.w3.org/2000/svg",
    children: e ? /* @__PURE__ */ r.jsx("path", { d: "M20.5 0V72", stroke: "#E6E6E6" }) : /* @__PURE__ */ r.jsx("path", { d: "M20.5 0L20.5 28", stroke: "#E6E6E6" })
  }
), B8 = () => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    preserveAspectRatio: "none",
    viewBox: "0 0 40 72",
    fill: "none",
    style: {
      width: "100%",
      height: "100%"
    },
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r.jsx("path", { d: "M20.5 0L20.5 28", stroke: "#E6E6E6" }),
      /* @__PURE__ */ r.jsx("path", { d: "M28.5 36C24.0817 36 20.5 32.4183 20.5 28", stroke: "#E6E6E6" }),
      /* @__PURE__ */ r.jsx("path", { d: "M40 36H28.5", stroke: "#E6E6E6" })
    ]
  }
), H8 = (e, t, n) => {
  if (t === null) return null;
  if (!n) return /* @__PURE__ */ r.jsx(f1, { bottomLine: !0 });
  const o = t === !0;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("div", { className: e.iconExtendingAboveTop, children: /* @__PURE__ */ r.jsx(f1, {}) }),
    o ? /* @__PURE__ */ r.jsx("div", { className: e.iconFixedToTop, children: /* @__PURE__ */ r.jsx(f1, {}) }) : /* @__PURE__ */ r.jsx(f1, { bottomLine: !0 }),
    /* @__PURE__ */ r.jsx("div", { className: e.iconFixedToTop, children: /* @__PURE__ */ r.jsx(B8, {}) })
  ] });
}, lo = ({
  parentId: e,
  hierarchySpec: t,
  density: n
}) => {
  const { classes: o } = A8({ density: n }), a = Mn(t), i = a.map((l, c) => H8(o, l, c === a.length - 1));
  return /* @__PURE__ */ r.jsx("div", { className: o.root, children: i.map((l, c) => /* @__PURE__ */ r.jsx(
    "div",
    {
      className: o.lineContainer,
      children: /* @__PURE__ */ r.jsx("div", { className: o.internalLineContainer, children: l })
    },
    `${e}-tree-line-${c}`
  )) });
}, Ar = (e, t) => {
  K(() => {
    const n = () => {
      e.current && (e.current.style.height = "auto", e.current.style.height = `${e.current.clientHeight}px`);
    };
    return n(), window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, [e, ...t]);
}, D8 = R()(() => ({
  actionMenuContainer: {
    width: "min-content"
  },
  menuList: {
    paddingTop: 0,
    paddingBottom: 0
  },
  menuPaper: {
    marginTop: "0.25rem"
  },
  noninteractive: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "2.25rem",
    width: "2.25rem"
  },
  disabled: {
    opacity: 0.4
  }
})), T8 = (e) => Array.isArray(e[0]), Pt = ({
  objectIds: e,
  objectTestId: t,
  actionLists: n,
  noninteractive: o = !1,
  setOpen: a,
  showDisabledMenuTrigger: i = !1
}) => {
  const { cx: l, classes: c } = D8(), d = Z(null), [u, p] = V(!1), { translations: m } = Q(), { classes: g } = V1({
    size: "medium"
  }), h = u ? g.iconNeutralSelected : void 0;
  if (o || i)
    return /* @__PURE__ */ r.jsx(
      "div",
      {
        className: l({
          [c.noninteractive]: !0,
          [c.disabled]: i
        }),
        children: /* @__PURE__ */ r.jsx(te, { name: "more" })
      }
    );
  if (!n || n.length === 0) return null;
  const v = (T8(n) ? n : [n]).map((y) => ({
    fullHeight: !0,
    items: F2(y),
    itemComponent: Se,
    onSelection: ({ id: w }, k) => {
      const M = y.find((L) => L.id === w);
      M == null || M.onClick(M.id, e), k == null || k.stopPropagation(), p(!1), a == null || a(!1);
    }
  })), b = v.every((y) => y.items.length === 0), f = /* @__PURE__ */ r.jsx(
    G,
    {
      testId: `${t}-menu-button`,
      buttonVariant: "icon",
      iconVariant: "neutral",
      onClick: (y) => {
        y.stopPropagation(), p(!0), a == null || a(!0);
      },
      className: h,
      icon: "more",
      "aria-label": m.common.actions,
      disabled: b
    }
  );
  return /* @__PURE__ */ r.jsxs("div", { ref: d, className: c.actionMenuContainer, children: [
    b ? f : /* @__PURE__ */ r.jsx(
      he,
      {
        id: `${e[0]}-menu-button-tooltip`,
        testId: `${t}-menu-button-tooltip`,
        title: m.common.actions,
        children: f
      }
    ),
    /* @__PURE__ */ r.jsx(
      ze,
      {
        anchorRef: d,
        open: u,
        onClose: () => {
          p(!1), a == null || a(!1);
        },
        children: /* @__PURE__ */ r.jsx(Ie, { testId: `${t}-menu`, lists: v })
      }
    )
  ] });
}, R8 = (e, t, n) => typeof e == "string" ? /* @__PURE__ */ r.jsx(W, { "data-testid": `${t}-subtext`, className: n, children: e }) : /* @__PURE__ */ r.jsx("div", { className: n, children: e }), Je = ({
  id: e,
  testId: t = e,
  avatar: n,
  heading: o,
  chip: a,
  accessIcon: i,
  info: l,
  keepInfoOpaqueWhenDisabled: c = !1,
  renderInfo: d,
  actionLists: u,
  subtext: p,
  hasDivider: m = !1,
  density: g = "default",
  hierarchySpec: h = [],
  hasChildren: C = !1,
  variant: v = "default",
  disabled: b = !1,
  selected: f = !1,
  onSelection: y = void 0,
  interactive: w = !0,
  href: k,
  hideInfo: M = !0
}) => {
  const L = Z(null), j = Z(null), N = Z(null), E = !!(u != null && u.length), $ = !!l || !!d, [S, _] = V(!1), [B, O] = V();
  K(() => {
    var H;
    O($ ? (H = N.current) == null ? void 0 : H.clientWidth : 0);
  }, [$]);
  const { cx: A, classes: F } = ao({
    disabled: b,
    selected: f,
    density: g,
    withinTree: h.length > 0,
    hasActions: E,
    infoWidth: B,
    interactive: w,
    hideInfo: M
  }), z = [
    S,
    h,
    g,
    l,
    o,
    p
  ];
  Ar(L, z), Ar(j, z);
  const I = {
    id: e,
    "data-testid": t,
    className: F.button
  }, D = ({ children: H }) => k ? /* @__PURE__ */ r.jsx(
    "a",
    {
      href: k,
      onClick: (T) => {
        !T.metaKey && !T.ctrlKey && (T.preventDefault(), y == null || y({ id: e, value: !f }, T));
      },
      ...I,
      children: H
    }
  ) : v === "default" ? /* @__PURE__ */ r.jsx(
    "button",
    {
      ref: L,
      type: "button",
      disabled: b,
      onClick: (T) => y == null ? void 0 : y({ id: e, value: !f }, T),
      ...I,
      children: H
    }
  ) : /* @__PURE__ */ r.jsx("label", { ref: j, "data-listitem": !0, ...I, children: H });
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: F.container,
      onMouseEnter: w ? () => _(!0) : void 0,
      onMouseLeave: w ? () => _(!1) : void 0,
      children: [
        /* @__PURE__ */ r.jsxs(D, { children: [
          /* @__PURE__ */ r.jsxs("div", { className: F.leftContainer, children: [
            /* @__PURE__ */ r.jsx(
              io,
              {
                id: e,
                testId: `${t}-input`,
                labelSuffix: typeof o == "string" ? o : e,
                variant: v,
                selected: f,
                onSelection: ({ value: H }) => y == null ? void 0 : y({ id: e, value: H })
              }
            ),
            /* @__PURE__ */ r.jsx(
              lo,
              {
                parentId: e,
                hierarchySpec: h,
                density: g
              }
            ),
            n && /* @__PURE__ */ r.jsxs(
              "div",
              {
                "data-testid": `${t}-avatar`,
                className: F.avatarContainer,
                children: [
                  C ? /* @__PURE__ */ r.jsx("div", { className: F.hasChildrenLine, children: /* @__PURE__ */ r.jsx(f1, { bottomLine: !0 }) }) : null,
                  n
                ]
              }
            ),
            /* @__PURE__ */ r.jsxs("div", { className: F.leftInnerContainer, children: [
              !n && C ? /* @__PURE__ */ r.jsx("div", { className: F.hasChildrenLineWithNoAvatar, children: /* @__PURE__ */ r.jsx(f1, { bottomLine: !0 }) }) : null,
              /* @__PURE__ */ r.jsxs("div", { className: F.textAndChipContainer, children: [
                /* @__PURE__ */ r.jsx(
                  W,
                  {
                    "data-testid": `${t}-heading`,
                    component: "span",
                    className: F.heading,
                    variant: "h3",
                    children: o
                  }
                ),
                a && /* @__PURE__ */ r.jsx("span", { className: F.chip, children: a }),
                i && /* @__PURE__ */ r.jsx("div", { className: F.textAndChipContainer, children: /* @__PURE__ */ r.jsx(Zt, { name: i.name }) })
              ] }),
              p && p !== "" && R8(p, t, F.subtext)
            ] })
          ] }),
          m && /* @__PURE__ */ r.jsx("div", { className: F.dividerContainer, children: /* @__PURE__ */ r.jsx(Ce, {}) })
        ] }),
        /* @__PURE__ */ r.jsx(
          "div",
          {
            ref: N,
            className: A(F.rightContainer, {
              [F.rightContinerOpacity]: !c
            }),
            children: /* @__PURE__ */ r.jsx(
              "div",
              {
                "data-testid": `${t}-info`,
                className: F.infoContainer,
                onClick: (H) => H.stopPropagation(),
                children: l ?? (d == null ? void 0 : d({ isHovering: S }))
              }
            )
          }
        ),
        E ? /* @__PURE__ */ r.jsx("div", { className: F.menuContainer, children: /* @__PURE__ */ r.jsx(
          Pt,
          {
            objectIds: [e],
            objectTestId: t,
            actionLists: u
          }
        ) }) : null
      ]
    }
  );
}, so = (e) => e.variant === "date_range_picker", F8 = (e) => e.variant === "list_advanced", P2 = (e) => e.variant === "list_advanced_tree", q2 = (e) => e.variant !== "date_range_picker" && e.variant !== "list_advanced" && e.variant !== "list_advanced_tree", U2 = (e) => (e && e.length > 0 && e[0] && "heading" in e[0]) ?? !1, z8 = (e) => e.every((t) => U2(t)), W8 = (e) => (t) => typeof t.heading == "string" ? t.heading.toLowerCase().includes(e) : !1, O8 = (e) => (t) => t.label.toLowerCase().includes(e), Z8 = (e, t, n) => {
  if (U2(t)) {
    const o = W8(e);
    return t.filter(o).map((a) => ({
      ...a,
      selected: n.includes(a.id)
    }));
  } else {
    const o = O8(e);
    return t.filter(o).map((a) => ({
      ...a,
      selected: n.includes(a.id)
    }));
  }
}, co = (e, t) => e.map((n) => ({
  ...n,
  selected: t.includes(n.id),
  childItems: co(n.childItems, t)
})), Br = ({
  id: e,
  testId: t,
  label: n,
  disabled: o = !1,
  value: a = [],
  itemLists: i,
  subheaders: l = [],
  searchable: c,
  setValue: d,
  minWidth: u,
  listVariant: p = "list",
  treeProps: m
}) => {
  const { cx: g, classes: h } = m1(), { translations: C } = Q(), [v, b] = V(null), [f, y] = V(""), w = p === "tree" ? ((m == null ? void 0 : m.items.length) ?? 0) === 0 : (i ?? []).every((I) => I.length === 0), k = a.length > 0, M = p === "tree" && f;
  let L = [];
  M && (m != null && m.items) && (L = m.items.reduce(
    (I, D) => [...I, ...D.childItems],
    m.items
  ));
  const N = (p === "tree" ? [L] : i ?? []).map(
    (I) => Z8(f, I, a)
  ), E = (I, D = !1, H = !1) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("span", { className: h.filterMenuLabelSpacing, children: I }),
    /* @__PURE__ */ r.jsx(
      te,
      {
        name: "caret",
        className: g(h.caret, {
          [h.filterMenuCaretSelected]: D,
          [h.filterMenuCaret]: !D,
          [h.filterMenuCaratDisabled]: H
        })
      }
    )
  ] }), $ = Ve(), S = $e(
    $.breakpoints.down(_1)
  ), _ = {
    kind: "button",
    props: {
      anySelected: a.length > 0,
      onFooterClearAll: () => {
        d([]);
      },
      onFooterDone: () => {
        b(null);
      }
    }
  }, B = {
    testId: `${t}-list-advanced`,
    minWidth: u,
    headerProps: c ? {
      inputValue: f,
      onInputChange: (I, D) => y(D.toLowerCase())
    } : void 0,
    footerProps: S ? void 0 : _
  }, O = ({ id: I }) => {
    const D = A1(a, I);
    d(D);
  }, A = {
    testId: `${t}-list`,
    onSelection: O
  }, F = (I, D, H) => ({
    ...A,
    items: I,
    itemComponent: D ? Je : Se,
    subheader: l[H] ?? ""
  }), z = () => w ? /* @__PURE__ */ r.jsx(
    W,
    {
      variant: "body1",
      align: "center",
      sx: { padding: 4, maxWidth: 200 },
      children: C.common.no_data_available_to_filter
    }
  ) : p === "tree" && !M && m ? /* @__PURE__ */ r.jsx(
    Ie,
    {
      ...B,
      listVariant: "tree",
      lists: [],
      treeProps: {
        items: co(m.items, a),
        selectedIds: a,
        onSelection: O,
        collapsible: m.collapsible
      }
    }
  ) : U2(N[0]) ? /* @__PURE__ */ r.jsx(
    Ie,
    {
      ...B,
      lists: N.map(
        (I, D) => F(I, !0, D)
      )
    }
  ) : /* @__PURE__ */ r.jsx(
    Ie,
    {
      ...B,
      lists: N.map(
        (I, D) => F(I, !1, D)
      )
    }
  );
  return /* @__PURE__ */ r.jsxs("div", { id: e, children: [
    /* @__PURE__ */ r.jsx(
      u1,
      {
        "data-testid": t,
        label: E(n, k, o),
        className: g(h.filter, {
          [h.selected]: k && !o,
          [h.disabled]: o,
          [h.disableRipple]: !0
        }),
        onClick: (I) => {
          I.stopPropagation(), b(I.currentTarget);
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      ze,
      {
        "data-testid": `${t}-menu`,
        anchor: v,
        onClose: () => b(null),
        leftAligned: !0,
        bottomDrawerProps: {
          variant: "modal",
          contentSpacing: "fullWidth",
          footerProps: w ? void 0 : _
        },
        children: z()
      }
    )
  ] });
}, uo = ({
  index: e,
  parentTestId: t,
  filterChip: n,
  onSelected: o
}) => {
  const { translations: a } = Q();
  return so(n) ? /* @__PURE__ */ r.jsx(
    V4,
    {
      id: n.id,
      testId: n.testId ?? n.id,
      label: n.label ?? a.common.date,
      value: n.value,
      selected: n.selected,
      fromDate: n.fromDate,
      toDate: n.toDate,
      setValue: (i, l) => o(n.testId ?? n.id, {
        from: i,
        to: l
      })
    }
  ) : F8(n) ? /* @__PURE__ */ r.jsx(
    Br,
    {
      ...n,
      id: n.id,
      testId: n.testId ?? n.id,
      label: n.label,
      value: n.value,
      itemLists: n.listItems,
      subheaders: n.subheaders,
      searchable: n.searchable,
      setValue: (i) => o(n.id, i),
      listVariant: "list"
    }
  ) : P2(n) ? /* @__PURE__ */ r.jsx(
    Br,
    {
      id: n.id,
      testId: n.testId ?? n.id,
      label: n.label,
      value: n.value,
      treeProps: {
        items: n.listItems,
        collapsible: n.collapsible
      },
      searchable: n.searchable ?? !1,
      setValue: (i) => o(n.id, i),
      listVariant: "tree"
    }
  ) : /* @__PURE__ */ r.jsx(
    _e,
    {
      onClick: (i, l, c) => o(i, c),
      variant: n.variant,
      items: n,
      testId: n.testId ?? `${t}-filter-items-${e}`
    }
  );
}, T1 = ({
  testId: e,
  filterChips: t,
  onSelectAll: n,
  allItemsSelected: o,
  onFilterChipSelected: a,
  onInputChange: i,
  inputValue: l,
  showHideFilterChipsButton: c = !0,
  inputChips: d = [],
  onInputChipUpdate: u = () => {
  },
  children: p
}) => {
  const { translations: m } = Q(), { cx: g, classes: h } = M8(), C = Ve(), v = t && t.length > 0 && a, [b, f] = V(!0), y = n && o !== void 0, w = t == null ? void 0 : t.some((M) => M.selected), k = () => {
    t == null || t.forEach((M) => {
      a == null || a(M.id, void 0);
    });
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: h.container, children: [
      y && /* @__PURE__ */ r.jsx("div", { className: h.selectAllContainer, children: /* @__PURE__ */ r.jsx(
        p1,
        {
          label: m.common.select_all,
          labelHidden: !0,
          id: `${e}-select-all`,
          testId: `${e}-select-all`,
          onValueChange: (M) => n(M.value),
          checked: o
        }
      ) }),
      /* @__PURE__ */ r.jsx(
        yc,
        {
          value: l,
          chips: d,
          handleOnChange: i,
          onChipUpdate: u,
          id: `${e}-input`,
          leftIcon: "search",
          leftIconStyle: l === "" ? { color: C.palette.neutral[50] } : {},
          placeholderText: "Search",
          showClearButton: !0,
          fullWidth: !0
        }
      ),
      v && c && /* @__PURE__ */ r.jsx(
        G,
        {
          className: h.filterIcon,
          buttonVariant: "icon",
          icon: "filter",
          testId: `${e}-filter-icon`,
          title: m.common.filter,
          iconVariant: "neutral",
          onClick: () => f((M) => !M)
        }
      )
    ] }),
    v && /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: g(h.filterItemsWrapper, {
          [h.filterItemsWrapperOpen]: b
        }),
        children: [
          /* @__PURE__ */ r.jsx(
            ue,
            {
              removeFromTabOrder: !0,
              theme: "os-theme-hidden",
              className: g(h.filterItemsContainer, {
                [h.filterItemsContainerMasked]: w
              }),
              children: t.map((M, L) => /* @__PURE__ */ r.jsx(
                uo,
                {
                  index: L,
                  parentTestId: e,
                  filterChip: M,
                  onSelected: a
                },
                L
              ))
            }
          ),
          w ? /* @__PURE__ */ r.jsx(
            G,
            {
              className: h.clearAllButton,
              buttonVariant: "basicText",
              size: "small",
              label: m.common.clear_all,
              onClick: k
            }
          ) : null
        ]
      }
    ),
    p && /* @__PURE__ */ r.jsx("div", { className: h.childrenContainer, children: p })
  ] });
}, P8 = R()(() => ({
  collapsed: {
    display: "none"
  }
})), q8 = ({
  items: e,
  selectedIds: t,
  onSelection: n,
  collapsible: o
}) => {
  const [a, i] = V([]), l = E1(e), c = B1(e), { classes: d } = P8(), { onKeyDown: u } = Rt({ kind: "list" }), p = (g) => {
    a.includes(g) ? i(a.filter((h) => h !== g)) : i([...a, g]);
  }, m = a.map((g) => Q3(g, c)).flat().map((g) => g.id);
  return /* @__PURE__ */ r.jsx(Le, { "data-list": !0, onKeyDown: u, children: c.map((g, h) => /* @__PURE__ */ e1(
    Se,
    {
      ...g,
      hasChildren: g.childItems.length > 0,
      collapsible: o,
      isFirstChild: h === 0 || Y3(l, h),
      key: `complex-list-tree-${g.id}`,
      hierarchySpec: l[h],
      selected: t == null ? void 0 : t.includes(g.id),
      onSelection: n,
      isCollapsed: a.includes(g.id),
      onCollapse: (C) => p(C),
      className: m.includes(g.id) ? d.collapsed : ""
    }
  )) });
}, U8 = (e) => B1(e).some((n) => n.selected), G2 = R()((e, { minWidth: t = 200, maxWidth: n = 510 }) => ({
  container: {
    backgroundColor: "white",
    borderRadius: "4px",
    overflow: "hidden",
    width: "max-content",
    maxWidth: n,
    minWidth: t
  },
  containerShadow: {
    boxShadow: e.namedShadows["depth-2"]
  },
  containerWithinDrawer: {
    boxShadow: "unset",
    maxWidth: "unset",
    width: "100%",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  },
  containerWithinBottomDrawer: {
    paddingBottom: "2.5rem"
  },
  footerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.5rem"
  },
  breadcrumbsContainer: {
    display: "block",
    padding: "0.5rem 1rem",
    height: "2.5rem"
  },
  headerContainer: {
    padding: "0.5rem"
  },
  innerListContainer: {
    maxWidth: "100%",
    width: "100%",
    boxShadow: "none",
    borderRadius: 0,
    "&:focus-visible": {
      outline: 0
    }
  }
})), K2 = ({
  anySelected: e,
  disableDoneButton: t = !1,
  onFooterClearAll: n,
  onFooterDone: o
}) => {
  const { classes: a } = G2({}), { translations: i } = Q();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(Ce, {}),
    /* @__PURE__ */ r.jsxs("div", { className: a.footerContainer, children: [
      /* @__PURE__ */ r.jsx(
        St,
        {
          buttonVariant: "tertiary",
          disabled: !e,
          onClick: n,
          label: i.common.clear_all
        }
      ),
      /* @__PURE__ */ r.jsx(
        St,
        {
          buttonVariant: "primary",
          disabled: t,
          onClick: o,
          label: i.common.done
        }
      )
    ] })
  ] });
}, G8 = ({
  items: e
}) => {
  const { cx: t, classes: n } = G2({});
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(Ce, {}),
    /* @__PURE__ */ r.jsx("div", { className: t(n.breadcrumbsContainer), children: /* @__PURE__ */ r.jsx(Y2, { items: e, variant: "small" }) })
  ] });
}, K8 = 48, Y8 = 52, Q8 = (e, { withinDrawer: t, showHeader: n, showFooter: o }) => {
  if (!t && e)
    return e - (n ? K8 : 0) - (o ? Y8 : 0);
}, Ie = ({
  lists: e,
  treeProps: t,
  headerProps: n,
  footerProps: o,
  minWidth: a = 200,
  maxHeight: i = 448,
  maxWidth: l = 510,
  variant: c = "default",
  testId: d,
  className: u,
  innerListClassName: p,
  showBottomDivider: m = !0,
  showHeaderDivider: g = !0,
  showNoResults: h = !0,
  listVariant: C = "list",
  showShadow: v = !0,
  navigateWithArrowKeys: b = !0,
  autoFocus: f
}) => {
  const y = !!n, w = !!o, { withinDrawer: k, drawerVariant: M } = H1(), { onKeyDown: L } = Rt({
    kind: "list"
  }), j = Z(null), N = Q8(i, {
    withinDrawer: k,
    showHeader: y,
    showFooter: w
  }), E = e.length > 1 || !i, { cx: $, classes: S } = G2({
    minWidth: a,
    maxWidth: l
  }), _ = e.flatMap((A) => "items" in A ? A.items : []), B = _.length === 0, O = _.some((A) => A.selected) || t && U8(t.items);
  return qe.useEffect(() => {
    f && j.current && j.current.focus();
  }, [f, j]), /* @__PURE__ */ r.jsxs(
    "div",
    {
      "data-testid": d,
      "data-list-advanced": !0,
      className: $(
        S.container,
        {
          [S.containerShadow]: v,
          [S.containerWithinDrawer]: k,
          [S.containerWithinBottomDrawer]: M === "bottom"
        },
        u
      ),
      children: [
        n && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx("div", { className: S.headerContainer, children: /* @__PURE__ */ r.jsx(T1, { ...n }) }),
          g && /* @__PURE__ */ r.jsx(Ce, {})
        ] }),
        /* @__PURE__ */ r.jsx(ue, { removeFromTabOrder: !0, style: { maxHeight: N }, children: /* @__PURE__ */ r.jsxs("div", { role: "listbox", ref: j, tabIndex: 0, onKeyDown: L, children: [
          B && h && C === "list" && /* @__PURE__ */ r.jsx(b1, {}),
          C === "list" && e.map((A, F) => /* @__PURE__ */ r.jsxs(qe.Fragment, { children: [
            /* @__PURE__ */ r.jsx(
              l1,
              {
                ...A,
                variant: k ? "spacious" : c,
                itemComponent: A.itemComponent,
                containerClassName: $(
                  S.innerListContainer,
                  p
                ),
                showNoResults: !1,
                onSelection: A.onSelection,
                fullHeight: E || A.fullHeight,
                navigateWithArrowKeys: b
              },
              F
            ),
            F < e.length - 1 && m && /* @__PURE__ */ r.jsx(Ce, {})
          ] }, F)),
          C === "tree" && t && /* @__PURE__ */ r.jsx(
            q8,
            {
              items: t.items,
              selectedIds: t.selectedIds,
              onSelection: t.onSelection,
              collapsible: t.collapsible
            }
          )
        ] }) }),
        w && o.kind === "button" && /* @__PURE__ */ r.jsx(
          K2,
          {
            anySelected: O,
            onFooterClearAll: o.props.onFooterClearAll,
            onFooterDone: o.props.onFooterDone
          }
        ),
        w && o.kind === "breadcrumbs" && /* @__PURE__ */ r.jsx(G8, { items: o.props.items })
      ]
    }
  );
}, po = ({
  actionLists: e,
  menuAnchorRef: t,
  open: n,
  setMenuOpen: o
}) => /* @__PURE__ */ r.jsx(
  ze,
  {
    anchorRef: t,
    open: n,
    onClose: () => o(!1),
    leftAligned: !0,
    children: /* @__PURE__ */ r.jsx(
      Ie,
      {
        lists: e.map((a) => ({
          items: F2(a),
          itemComponent: Se,
          fullHeight: !0,
          onSelection: ({ id: i }) => {
            const l = e.flat().find((c) => c.id === i);
            l && l.onClick(l.id, []), o(!1);
          }
        }))
      }
    )
  }
), X8 = ({
  id: e,
  testId: t = e,
  label: n,
  loading: o,
  onClick: a,
  chip: i,
  actionLists: l,
  last: c
}) => {
  const { cx: d, classes: u } = it({ variant: "large" }), p = Z(null), [m, g] = V(!1);
  if (o)
    return /* @__PURE__ */ r.jsx(
      me,
      {
        variant: "rounded",
        width: 72,
        height: 24,
        sx: { margin: "0.25rem 0.5rem" }
      }
    );
  const h = l && l.length > 0, C = !c || h, v = i ? {
    ...typeof i == "string" ? {
      testId: `${t}-chip`,
      variant: "small",
      items: [{ id: `${e}-chip`, label: i }]
    } : { ...i, testId: `${t}-chip`, variant: "small" }
  } : void 0;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      "button",
      {
        type: "button",
        ref: p,
        onClick: () => h ? g(!0) : a(e),
        "data-testid": t,
        className: d(u.breadcrumb, u.breadcrumbLarge, {
          [u.breadcrumbLargeInteractive]: C,
          [u.breadcrumbWithMenuOpen]: m
        }),
        children: [
          /* @__PURE__ */ r.jsxs(
            W,
            {
              component: "div",
              className: d(u.label, {
                [u.labelWithMenu]: h
              }),
              children: [
                n,
                v ? /* @__PURE__ */ r.jsx(_e, { ...v }) : null
              ]
            }
          ),
          h ? /* @__PURE__ */ r.jsx(te, { name: "small-caret", className: u.menuIcon }) : null
        ]
      }
    ),
    h ? /* @__PURE__ */ r.jsx(
      po,
      {
        actionLists: l,
        menuAnchorRef: p,
        open: m,
        setMenuOpen: g
      }
    ) : null
  ] });
}, J8 = ({
  parentTestId: e,
  breadcrumbs: t
}) => {
  const { cx: n, classes: o } = it({ variant: "large" }), a = Z(null), [i, l] = V(!1), c = `${e}-overflow-tooltip`, d = t.map((u) => u.label).join(" › ");
  return /* @__PURE__ */ r.jsxs("div", { ref: a, children: [
    /* @__PURE__ */ r.jsx(he, { id: c, testId: c, title: d, children: /* @__PURE__ */ r.jsx(
      "button",
      {
        type: "button",
        onClick: () => {
          l(!0);
        },
        "data-testid": `${e}-overflow`,
        className: n(o.breadcrumb, o.breadcrumbLarge, {
          [o.breadcrumbWithMenuOpen]: i
        }),
        children: /* @__PURE__ */ r.jsx(W, { component: "div", className: n(o.label), children: "..." })
      }
    ) }),
    /* @__PURE__ */ r.jsx(
      po,
      {
        actionLists: [t],
        menuAnchorRef: a,
        open: i,
        setMenuOpen: l
      }
    )
  ] });
}, Y2 = ({
  testId: e,
  items: t,
  variant: n = "large",
  collapse: o = !0
}) => {
  const a = $e(
    (N) => N.breakpoints.down(480)
  ), { cx: i, classes: l } = it({ variant: n }), c = Z(null), d = Z(null), u = Z(null), [p, m] = V(null), [g, h] = V(!1), [C, v] = V(
    t.length
  ), [b, f] = V(null), y = n === "large" ? X8 : C8, w = n === "large" ? J8 : v8, k = /* @__PURE__ */ r.jsx(
    "div",
    {
      className: i(l.chevronContainer, {
        [l.chevronContainerSmall]: n === "small"
      }),
      children: /* @__PURE__ */ r.jsx(
        te,
        {
          name: "breadcrumb-chevron",
          className: i(l.chevron, {
            [l.chevronSmall]: n === "small"
          })
        }
      )
    }
  );
  K(() => {
    const N = () => {
      const E = c.current;
      E && E.clientWidth !== b && (f(E.clientWidth), m(null)), t.length !== C && (v(t.length), m(null));
    };
    return window.addEventListener("resize", N), N(), () => window.removeEventListener("resize", N);
  }, [t, b, C]), K(() => {
    const N = () => {
      var $, S;
      if (t.length <= 2) {
        m("none");
        return;
      }
      const E = c.current;
      if (E)
        if (E.scrollWidth > E.clientWidth) {
          const _ = n === "large" ? 54 : 30, B = ((($ = d.current) == null ? void 0 : $.clientWidth) ?? 0) + _ + (((S = u.current) == null ? void 0 : S.clientWidth) ?? 0);
          E.clientWidth >= B ? m("middle-ellipsis") : m("leading-ellipsis");
        } else p === null && m("none");
    };
    return window.addEventListener("resize", N), N(), () => window.removeEventListener("resize", N);
  }, [t, n, p]);
  const M = t.map((N, E) => {
    const $ = E === t.length - 1;
    return /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: l.breadcrumbAndChevronContainer,
        ref: (S) => {
          E === 0 && (d.current = S), E === t.length - 1 && (u.current = S);
        },
        children: [
          /* @__PURE__ */ r.jsx(y, { ...N, last: $ }),
          $ ? null : k
        ]
      },
      N.id
    );
  }), L = p === "none" || !o || g, j = t[t.length - 1];
  return /* @__PURE__ */ r.jsx(ue, { theme: "os-theme-hidden", className: l.scrollView, children: /* @__PURE__ */ r.jsx(
    "div",
    {
      ref: c,
      "data-testid": e,
      className: l.container,
      children: L ? M : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        p === "middle-ellipsis" && !a && t[0] ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(y, { ...t[0], last: !1 }),
          k
        ] }) : null,
        a && n === "large" ? /* @__PURE__ */ r.jsx(
          G,
          {
            buttonVariant: "icon",
            icon: "arrow-back",
            iconVariant: "neutral",
            className: l.smallScreenBackButton,
            onClick: () => {
              const N = t[t.length - 2];
              N == null || N.onClick(N.id);
            }
          }
        ) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(
            w,
            {
              parentTestId: e,
              breadcrumbs: p === "middle-ellipsis" ? t.slice(1, t.length - 1) : t.slice(0, t.length - 1),
              onClick: () => h(!0)
            }
          ),
          k
        ] }),
        j ? /* @__PURE__ */ r.jsx(y, { ...j, last: !0 }) : null
      ] })
    }
  ) });
}, Hr = {
  "> div:first-child": {
    paddingTop: "0.75em"
  },
  "> div:last-child": {
    paddingBottom: "0.75em"
  }
}, e9 = X.withParams().create(({ theme: e, previewHeight: t }) => ({
  label: {
    ...e.typography.label,
    marginBottom: "0.75rem",
    marginTop: "0"
  },
  codeBlockWrapper: {
    position: "relative",
    borderBottomLeftRadius: "0.5rem",
    borderBottomRightRadius: "0.5rem",
    border: `1px solid ${e.palette.neutral[30]}`,
    height: "204px",
    overflow: "clip"
  },
  pre: {
    ...e.typography.pre,
    margin: 0,
    position: "relative",
    display: "block",
    lineHeight: "1.75rem",
    "@supports (line-height: 1lh)": {
      lineHeight: "1.25lh"
    }
  },
  code: {
    ...Hr,
    display: "block"
  },
  codeWrapper: {
    display: "flex",
    width: "100%",
    overflow: "auto"
  },
  lineNumbersColumn: {
    ...Hr,
    position: "sticky",
    left: 0,
    backgroundColor: e.palette.neutral[20],
    display: "flex",
    flexDirection: "column",
    userSelect: "none"
  },
  lineNumber: {
    padding: "0 0.75em",
    textAlign: "right"
  },
  codeContent: {
    flexGrow: 1,
    overflow: "auto"
  },
  lineContent: {
    whiteSpace: "pre",
    padding: "0 0.75em"
  },
  contentPreview: {
    maxHeight: t,
    "::after": {
      content: '""',
      display: "block",
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "100%",
      maxHeight: "100px",
      background: "linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)"
    }
  },
  showButton: {
    position: "absolute",
    bottom: "0.5rem",
    right: "0.5rem",
    zIndex: "1",
    visibility: "hidden"
  },
  errorMessage: {
    ...e.typography.subtitle,
    color: e.palette.error["60-key"],
    height: "1rem",
    marginBottom: "0.375rem",
    position: "relative",
    top: "0.75rem"
  },
  helperMessage: {
    ...Re(e),
    position: "relative",
    top: "0.75rem"
  },
  codeBlockContent: {
    "&:hover button": {
      visibility: "visible"
    }
  }
})), t9 = X.create(({ theme: e }) => ({
  accordionContainer: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.25rem",
    border: `1px solid ${e.palette.neutral[30]}`,
    background: `${e.palette.neutral.white}`,
    overflow: "hidden"
  },
  overline: {
    ...e.typography.overline,
    color: e.palette.neutral[70],
    fontSize: "0.75rem",
    fontWeight: "700",
    lineHeight: "0.875rem",
    letterSpacing: "0.0375rem",
    textTransform: "uppercase",
    margin: "0",
    padding: "0"
  },
  summary: {
    display: "block"
  },
  header: {
    display: "flex",
    padding: "0.375rem 0.5rem 0.375rem 1.5rem",
    alignItems: "center",
    gap: "0.375rem",
    background: `${e.palette.neutral.white}`,
    border: "none",
    cursor: "pointer",
    "&:hover, &:focus": {
      background: `${e.palette.neutral[20]}`
    },
    "&:active": {
      background: `${e.palette.neutral[30]}`
    }
  },
  chip: {},
  toggleButton: {
    marginLeft: "auto"
  },
  actionsContainerRoot: {
    display: "block",
    flex: "1 1 auto",
    minWidth: "36px",
    overflow: "visible"
  },
  actionsContainer: {
    display: "block",
    minWidth: "max-content"
  },
  actionsList: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "0.5rem",
    marginLeft: "auto",
    width: "max-content",
    flexWrap: "nowrap"
  },
  content: {
    borderTop: `1px solid ${e.palette.neutral[30]}`,
    padding: "1.5rem",
    boxSizing: "border-box",
    position: "relative"
  },
  fullWidthContainer: {
    padding: "0"
  }
})), mo = (e, t, n = void 0) => {
  const o = Ve(), [a, i] = V(!1), [l, c] = V(0), d = $e(
    o.breakpoints.up(l)
  ), u = $e(o.breakpoints.down(768)), p = $e(o.breakpoints.down(500));
  return K(() => {
    if (t.current) {
      const m = (h) => {
        h.forEach((C) => {
          const v = C.intersectionRatio < 1;
          i(v), c(window.innerWidth + 24), v && g.disconnect();
        });
      }, g = new IntersectionObserver(
        m,
        {
          threshold: [0, 0.9, 1],
          root: e.current
        }
      );
      return g.observe(t.current), () => g.disconnect();
    }
  }, [
    t,
    e,
    d,
    p,
    u,
    n
  ]), a;
}, I1 = ({
  resourceId: e,
  children: t,
  overline: n,
  open: o,
  onToggle: a,
  onClose: i,
  onOpen: l,
  chipItems: c,
  actions: d,
  fullWidth: u = !1,
  accessIcon: p,
  groupName: m,
  contentClassName: g
}) => {
  const { translations: h } = Q(), [C, v] = qe.useState(o), { classes: b } = t9(), f = "accordion", y = "accordion", w = Z(null), k = Z(null), M = Z(null), L = Z(null), j = mo(
    w,
    k
  ), N = `${b.content} ${u ? b.fullWidthContainer : ""} ${g ?? ""}`, E = () => {
    var _;
    const S = ((_ = L.current) == null ? void 0 : _.getAttribute("open")) === null;
    L.current && (S ? L.current.setAttribute("open", "") : L.current.removeAttribute("open"));
  }, $ = () => {
    var _;
    const S = ((_ = L.current) == null ? void 0 : _.getAttribute("open")) != null;
    v(S), M.current && M.current.blur(), a && a(S), S ? l && l(e) : i && i(e);
  };
  return /* @__PURE__ */ r.jsxs(
    "details",
    {
      ref: L,
      className: b.accordionContainer,
      onToggle: $,
      open: C,
      name: m,
      "data-testid": y,
      children: [
        /* @__PURE__ */ r.jsx("summary", { ref: M, className: b.summary, children: /* @__PURE__ */ r.jsxs("div", { className: b.header, children: [
          /* @__PURE__ */ r.jsx("h5", { className: b.overline, children: n }),
          c && /* @__PURE__ */ r.jsx("div", { className: b.chip, children: /* @__PURE__ */ r.jsx(
            _e,
            {
              items: c,
              state: "neutral",
              style: "light",
              variant: "small",
              testId: `${y}-chip`
            }
          ) }),
          p && /* @__PURE__ */ r.jsx(Zt, { icon: p.icon, name: p.name }),
          d && d.length > 0 && /* @__PURE__ */ r.jsx(
            "div",
            {
              className: b.actionsContainerRoot,
              ref: w,
              children: /* @__PURE__ */ r.jsx(
                "div",
                {
                  className: b.actionsContainer,
                  ref: k,
                  children: j ? /* @__PURE__ */ r.jsx(
                    Pt,
                    {
                      objectIds: [f],
                      objectTestId: y,
                      actionLists: d
                    }
                  ) : /* @__PURE__ */ r.jsx("div", { className: b.actionsList, children: d.map((S) => {
                    const _ = S.iconLeft || S.iconRight ? "icon" : "text", B = () => /* @__PURE__ */ r.jsx(
                      G,
                      {
                        buttonVariant: _,
                        label: S.label,
                        icon: S.iconLeft,
                        testId: `${S.testId ?? S.id}-button`,
                        iconVariant: S.iconLeftVariant ?? "neutral",
                        onClick: (O) => {
                          O.stopPropagation(), S.onClick(S.id, [e]);
                        }
                      }
                    );
                    return /* @__PURE__ */ r.jsx(r.Fragment, { children: _ === "icon" ? /* @__PURE__ */ r.jsx(
                      he,
                      {
                        testId: `${S.testId ?? S.id}-tooltip`,
                        title: S.label,
                        children: B()
                      },
                      S.id
                    ) : B() });
                  }) })
                }
              )
            }
          ),
          /* @__PURE__ */ r.jsx(
            he,
            {
              title: C ? h.common.hide_contents : h.common.show_contents,
              className: b.toggleButton,
              testId: "content-section-chevron-tooltip",
              children: /* @__PURE__ */ r.jsx(
                G,
                {
                  buttonVariant: "icon",
                  iconVariant: "neutral",
                  icon: "chevron-thick",
                  title: "Show contents",
                  onClick: E,
                  style: C ? {
                    transform: "rotate(180deg)"
                  } : void 0
                }
              )
            }
          )
        ] }) }),
        /* @__PURE__ */ r.jsx("div", { className: N, children: t })
      ]
    }
  );
}, Rp = ({
  overline: e,
  label: t,
  code: n,
  language: o,
  resourceId: a,
  actions: i,
  open: l,
  maxPreviewHeight: c = 200,
  errorMessage: d,
  helperText: u,
  className: p
}) => {
  const { addSnackbar: g } = Wt(), [h, C] = V(l), [v, b] = qe.useState(!1), f = Ve(), { cx: y, classes: w } = e9({
    theme: f,
    previewHeight: c
  }), { translations: k } = Q(), M = t || k.common.code_block.label, L = o ?? k.common.code_block.code, j = Z(null);
  K(() => {
    let _ = 0;
    if (j.current) {
      _ = j.current.scrollHeight;
      const B = _ < c + 24;
      b(B), C(B);
    }
  }, [c]);
  const N = () => {
    Cn(n), g(k.common.code_block.copy_message, {
      id: "code-copied"
    });
  }, E = () => {
    const _ = `${Pe(M)}.${L}`;
    En({ data: n, filename: _ });
  }, $ = (_, B) => {
    const O = B.toString().length;
    return e0(_, O, " ");
  }, S = () => /* @__PURE__ */ r.jsx(
    "pre",
    {
      className: y(
        w.pre,
        !v && !h && w.contentPreview
      ),
      ref: j,
      children: /* @__PURE__ */ r.jsxs("div", { className: w.codeWrapper, children: [
        /* @__PURE__ */ r.jsx("div", { className: w.lineNumbersColumn, children: n.split(`
`).map((_, B, O) => /* @__PURE__ */ r.jsx("div", { className: w.lineNumber, children: $(`${B + 1}`, O.length) }, `line-number-${B}`)) }),
        /* @__PURE__ */ r.jsx("code", { className: y(w.code, w.codeContent), children: n.split(`
`).map((_, B) => /* @__PURE__ */ r.jsx("div", { className: w.lineContent, children: _ }, `line-content-${B}`)) })
      ] })
    }
  );
  return /* @__PURE__ */ r.jsxs("div", { className: p, children: [
    t && /* @__PURE__ */ r.jsx("h5", { className: w.label, children: t }),
    /* @__PURE__ */ r.jsxs(
      I1,
      {
        resourceId: a ?? "",
        overline: e,
        fullWidth: !0,
        open: !0,
        contentClassName: w.codeBlockContent,
        actions: [
          ...i ?? [],
          {
            id: "copy",
            label: k.common.copy,
            iconLeft: "copy",
            iconLeftVariant: "neutral",
            testId: "copy-button",
            onClick: () => N()
          },
          {
            id: "download",
            label: k.common.download,
            iconLeft: "download",
            iconLeftVariant: "neutral",
            testId: "download-button",
            onClick: () => E()
          }
        ],
        children: [
          S(),
          !v && /* @__PURE__ */ r.jsx(
            St,
            {
              className: w.showButton,
              buttonVariant: "tertiary",
              label: `${h ? k.common.hide : k.common.show} ${L}`,
              onClick: () => C(!h)
            }
          )
        ]
      }
    ),
    d && /* @__PURE__ */ r.jsx("div", { className: w.errorMessage, children: /* @__PURE__ */ r.jsx("span", { children: d }) }),
    u && /* @__PURE__ */ r.jsx("div", { className: w.helperMessage, children: /* @__PURE__ */ r.jsx("span", { children: u }) })
  ] });
}, r9 = (e, t, n) => {
  const o = t.includes(e.id), a = [n9(e, o, n)];
  return o ? a.concat(e.childItems) : a;
}, n9 = (e, t, n) => ({
  ...e,
  info: /* @__PURE__ */ r.jsxs(Le, { direction: "row", alignItems: "center", gap: "1rem", children: [
    e.info,
    /* @__PURE__ */ r.jsx(
      G,
      {
        buttonVariant: "icon",
        iconVariant: "neutral",
        icon: "chevron-thick",
        style: t ? {
          transform: "rotate(180deg)"
        } : void 0,
        title: "Show topics",
        onClick: () => n(e.id)
      }
    )
  ] }),
  // We don't want to hide the info column on smaller screens so that the arrow is always visible.
  hideInfo: !1
}), o9 = X.create({
  innerListContainer: {
    borderRadius: 0
  }
}), Fp = ({
  groupItems: e,
  ...t
}) => {
  const { classes: n } = o9(), [o, a] = V([]), i = (l) => {
    a(A1(o, l));
  };
  return /* @__PURE__ */ r.jsx(
    Ie,
    {
      ...t,
      className: n.innerListContainer,
      innerListClassName: n.innerListContainer,
      showBottomDivider: !1,
      lists: e.map((l) => ({
        fullHeight: !0,
        hideLastDivider: !1,
        items: r9(l, o, i),
        itemComponent: Je,
        onSelection: ({ id: c }) => {
          i(c);
        }
      }))
    }
  );
}, Dr = (e) => e ? e.closest("[data-overlayscrollbars-contents]") : null, a9 = (e, t) => {
  const n = M1(() => {
    const o = Dr(e.current);
    return o == null ? void 0 : o.scrollTop;
  }, [e, ...t]);
  cn(() => {
    const o = Dr(e.current);
    n && (o == null || o.scrollTo({ top: n }));
  }, [n, e, ...t]);
}, zp = ({
  items: e,
  selectedId: t,
  onSelection: n,
  hideLastDivider: o = !0
}) => {
  const a = Z(null), i = E1(e), l = B1(e);
  return a9(a, [t]), /* @__PURE__ */ r.jsx(Le, { ref: a, children: l.map((c, d) => {
    const u = d === l.length - 1;
    return /* @__PURE__ */ e1(
      Je,
      {
        ...c,
        hasDivider: o && u ? !1 : c.hasDivider,
        hasChildren: c.childItems.length > 0,
        key: `complex-list-item-tree-${d}`,
        hierarchySpec: i[d],
        selected: t === c.id,
        onSelection: n
      }
    );
  }) });
}, i9 = ({ gap: e, style: t, ...n }) => /* @__PURE__ */ r.jsx(
  "div",
  {
    style: { ...t, display: "flex", flexDirection: "column", gap: e },
    ...n
  }
), Wp = ({ date: e, testId: t }) => {
  if (!e) return /* @__PURE__ */ r.jsx(W, { variant: "body2", children: "–" });
  const n = j1(e, "date"), o = j1(e, "time");
  return /* @__PURE__ */ r.jsxs(i9, { "data-testid": t, children: [
    /* @__PURE__ */ r.jsx(W, { variant: "body2", children: n }),
    /* @__PURE__ */ r.jsx(W, { variant: "body2", children: o })
  ] });
}, l9 = R()(() => ({
  dialogCloseButton: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
    cursor: "pointer",
    "@media print": {
      display: "none"
    }
  }
})), s9 = R()((e, { isStackedDialog: t, size: n }) => {
  const o = n === "large", a = o ? 834 : 654;
  return {
    dialogContainer: {
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(calc(-50% - 1rem), calc(-50% - 1rem))",
      transformBox: "border-box",
      transformOrigin: "center",
      background: e.palette.neutral.white,
      boxShadow: e.namedShadows["depth-3"],
      // Without dialog stacking, the backdrop component has a z-index of 1999. This allows the dialog to appear above it.
      // With dialog stacking, the backdrop component has z-index of 2000.
      zIndex: t ? wn : N2,
      width: o ? "50rem" : "38.875rem",
      maxHeight: "43.03125rem",
      borderRadius: "0.625rem",
      alignSelf: "stretch",
      margin: "1rem",
      padding: "3.5rem 0 2rem 0",
      [e.breakpoints.down("md")]: {
        maxHeight: "min(100vh, 43rem)"
      },
      [e.breakpoints.down(480)]: {
        padding: "3.5rem 0 1.5rem 0"
      },
      [e.breakpoints.down(a)]: {
        // When the dialog can no longer fill its width + 2x 1rem spacing on its sides, switch to fill
        // the entire screen width with the dialog.
        top: "50%",
        left: 0,
        right: 0,
        transform: "translate(0%, calc(-50% - 1rem))",
        minWidth: "unset",
        width: "calc(100% - 2rem)",
        maxHeight: "min(calc(100vh - 2rem), 43rem)"
      }
    },
    dialogContainerWithoutActionsOrContent: {
      paddingBottom: "2rem"
    }
  };
}), c9 = R()((e, { collapse: t }) => ({
  dialogFooter: {
    width: "100%",
    paddingTop: t ? 0 : "2rem",
    [e.breakpoints.down(480)]: {
      paddingTop: t ? 0 : "1.5rem"
    }
  },
  dialogFooterInnerContent: {
    width: "100%",
    padding: "0 3.5rem 0 3.5rem",
    flexDirection: "column",
    textAlign: "center",
    alignContent: "center",
    gap: "2rem",
    display: "inline-flex",
    [e.breakpoints.down(480)]: {
      padding: "0 1.5rem 0 1.5rem "
    }
  },
  dialogFooterWhenNoContent: {
    padding: "0rem 3.5rem 0 3.5rem",
    [e.breakpoints.down(480)]: {
      padding: "0rem 1.5rem 0 1.5rem "
    }
  },
  purchaseBar: {
    marginBottom: "2rem",
    ">div": {
      paddingLeft: "3.5rem",
      paddingRight: "3.5rem"
    },
    [e.breakpoints.down(480)]: {
      marginBottom: "1.5rem",
      ">div": {
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem"
      }
    }
  }
})), d9 = R()((e) => ({
  dialogHeader: {
    width: "100%",
    textAlign: "center",
    wordWrap: "break-word",
    padding: "0 3.5rem 1.5rem 3.5rem",
    [e.breakpoints.down(480)]: {
      padding: "0 1.5rem 1.5rem 1.5rem"
    }
  },
  dialogOverline: {
    color: e.palette.neutral[70],
    textTransform: "uppercase",
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: "0.875rem",
    letterSpacing: "0.038rem"
  },
  dialogHead: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    gap: "1rem"
  },
  dialogHeadline: {
    display: "flex",
    fontSize: "1.125rem",
    color: e.palette.neutral[80],
    fontWeight: 600,
    lineHeight: "1.5rem",
    wordWrap: "break-word",
    alignItems: "center"
  },
  dialogHeadlineTooltip: {
    paddingLeft: "0.25rem",
    position: "relative",
    top: "1px"
  },
  dialogHeadlineInfoIcon: {
    width: "0.875rem",
    height: "0.875rem",
    "& path": {
      fill: e.palette.neutral[80]
    }
  },
  dialogSupportingText: {
    color: e.palette.neutral[80],
    fontSize: "1rem",
    fontWeight: 400,
    [e.breakpoints.down("sm")]: {
      width: "80%",
      margin: "auto"
    }
  },
  listHeaderContainer: {
    paddingTop: "2rem"
  }
})), ho = R()((e, { fullWidthContentArea: t, collapseAlertPadding: n, collapseContentScrollGutter: o }) => ({
  hugContent: {
    flex: 1,
    overflow: "hidden"
  },
  bottomDivider: {
    position: "relative"
  },
  shiftBottomDividerForBasic: {
    top: "-2px"
  },
  dialogMainContent: {
    width: "100%",
    height: "100%",
    overflowY: o ? "auto" : "scroll"
  },
  scrollView: {
    minHeight: "100%",
    height: "100%"
  },
  alertContainer: {
    paddingTop: "1.5rem",
    paddingRight: "3.5rem",
    paddingBottom: t && !n ? "1.5rem" : "0rem",
    paddingLeft: "3.5rem",
    [e.breakpoints.down(480)]: {
      padding: "1.5rem",
      paddingBottom: t && !n ? "1.5rem" : "0rem"
    }
  },
  alertContainerWithoutScroll: {
    paddingTop: 0,
    paddingBottom: n ? 0 : "1.5rem"
  },
  alertContainerWithoutContentArea: {
    paddingBottom: n ? 0 : "1.5rem"
  },
  alertContainerWithoutContentAreaOrActions: {
    paddingBottom: 0
  },
  dialogContentContainer: {
    // height: "100%",
    padding: t ? "0rem 0rem 0rem 0rem" : "0rem 3.5rem 0rem 3.5rem",
    [e.breakpoints.down(480)]: {
      padding: t ? "0rem 0rem 1rem 0rem" : "0rem 1.5rem 1rem 1.5rem"
    }
  },
  dialogContentContainerScrolling: {
    padding: t ? "0rem 0rem 0rem 0rem" : "1.5rem 3.5rem 2rem 3.5rem",
    [e.breakpoints.down(480)]: {
      padding: t ? "0rem 0 0rem 0" : "1.5rem 1.5rem 2rem 1.5rem"
    }
  },
  dialogContentLoading: {
    "> div": {
      display: "flex",
      justifyContent: "center"
    }
  }
})), u9 = R()((e) => ({
  dialogFooterButtons: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    gap: "1rem",
    [e.breakpoints.down(480)]: {
      flexDirection: "column"
    }
  },
  dialogButtons: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    [e.breakpoints.down(480)]: {
      flexDirection: "column-reverse",
      width: "100%"
    }
  },
  dialogFooterSkipButton: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    gap: "1rem"
  }
})), p9 = R()((e) => ({
  dialogButton: {
    whiteSpace: "nowrap",
    [e.breakpoints.down(480)]: {
      width: "100%"
    }
  }
})), m9 = R()((e) => ({
  dialogHelperText: {
    color: e.palette.neutral[80],
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    wordWrap: "break-word",
    textAlign: "center"
  },
  dialogHelperConfirm: {
    color: e.palette.neutral[80],
    display: "flex",
    fontSize: "1rem",
    fontWeight: 400,
    wordBreak: "break-word",
    // minHeight (not a fixed height) so a confirmation label that wraps to multiple
    // lines grows the box instead of overflowing into the gap above the buttons.
    minHeight: "1.5rem",
    justifyContent: "flex-start",
    alignItems: "center",
    textAlign: "left"
  },
  dialogHelperConfirmLabel: {
    textAlign: "left"
  }
})), h9 = R()((e) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    margin: "0rem 2rem"
  },
  buttonContainer: {
    marginTop: "1.5rem",
    display: "flex",
    gap: "0.5rem",
    [e.breakpoints.down(640)]: {
      flexDirection: "column-reverse",
      width: "100%"
    }
  },
  header: {
    marginBottom: "1rem"
  }
})), g9 = R()(() => ({
  warning: {
    width: "unset"
  }
})), C9 = R()(() => ({
  reviewTextFieldContainer: {
    padding: "1rem 1.5rem"
  }
})), go = ({
  showCloseButton: e = !1,
  onClose: t
}) => {
  const { translations: n } = Q(), { cx: o, classes: a } = l9();
  return e ? /* @__PURE__ */ r.jsx(
    G,
    {
      buttonVariant: "icon",
      iconVariant: "neutral",
      label: n.common.close,
      title: n.common.close,
      onClick: t,
      icon: "cross",
      className: o(a.dialogCloseButton),
      testId: "dialog-close-button"
    }
  ) : null;
}, v9 = (e) => {
  K(() => (e ? document.body.style.overflow = "hidden" : document.body.style.overflow = "unset", () => {
    document.body.style.overflow = "unset";
  }), [e]);
}, Co = ({
  contentArea: e,
  actionsEmpty: t,
  className: n,
  testId: o,
  isOpen: a = !1,
  onClose: i,
  children: l,
  dialogRef: c,
  isStackedDialog: d = !1,
  size: u = "small"
}) => {
  const { cx: p, classes: m } = s9({ isStackedDialog: d, size: u });
  return v9(a), Pn(a, i), a ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      g8,
      {
        open: a,
        onClick: i,
        isStackedBackdrop: d
      }
    ),
    /* @__PURE__ */ r.jsx(
      "div",
      {
        "data-testid": o,
        ref: c,
        className: p(m.dialogContainer, n, {
          [m.dialogContainerWithoutActionsOrContent]: !e && t
        }),
        children: l
      }
    )
  ] }) : null;
}, f9 = ({
  alert: e,
  contentArea: t,
  fullWidthContentArea: n = !1,
  actionsEmpty: o,
  hugContentRef: a,
  contentRef: i,
  contentAreaClassName: l,
  hideBottomDividerWhenScrollable: c,
  className: d,
  collapseAlertPadding: u = !1,
  collapseContentScrollGutter: p = !1
}) => {
  const { cx: m, classes: g } = ho({
    fullWidthContentArea: n,
    collapseAlertPadding: u,
    collapseContentScrollGutter: p
  }), [h, C] = V(!1);
  return e || t ? /* @__PURE__ */ r.jsxs("div", { ref: a, className: m(g.hugContent), children: [
    h && /* @__PURE__ */ r.jsx(Ce, {}),
    /* @__PURE__ */ r.jsx(
      "div",
      {
        ref: i,
        className: m(g.dialogMainContent, d),
        children: /* @__PURE__ */ r.jsx(
          ue,
          {
            className: g.scrollView,
            disableVerticalScroll: p,
            onInitialized: () => {
              !p && Nn(i.current, a.current) && C(!0);
            },
            children: /* @__PURE__ */ r.jsxs("div", { children: [
              e && /* @__PURE__ */ r.jsx(
                "div",
                {
                  className: m(g.alertContainer, {
                    [g.alertContainerWithoutScroll]: !h,
                    [g.alertContainerWithoutContentArea]: !t,
                    [g.alertContainerWithoutContentAreaOrActions]: !h && !t && o
                  }),
                  children: /* @__PURE__ */ r.jsx(
                    Ke,
                    {
                      id: "dialog-alert-id",
                      testId: "dialog-alert-test-id",
                      description: e.description,
                      title: e.title,
                      hasCloseButton: e.hasCloseButton,
                      variant: e.variant,
                      closeButtonEventHandler: e.closeButtonEventHandler,
                      hideIcon: e.hideIcon
                    }
                  )
                }
              ),
              t ? /* @__PURE__ */ r.jsx(
                "div",
                {
                  className: m(
                    g.dialogContentContainer,
                    {
                      [g.dialogContentContainerScrolling]: h
                    },
                    l
                  ),
                  children: t
                }
              ) : null
            ] })
          }
        )
      }
    ),
    h && !c && /* @__PURE__ */ r.jsx(
      Ce,
      {
        className: m(
          g.bottomDivider,
          g.shiftBottomDividerForBasic
        )
      }
    )
  ] }) : null;
}, vo = ({
  overline: e,
  headline: t,
  headlineTooltip: n,
  supportingText: o,
  headerProps: a,
  parentTestId: i,
  headerRef: l,
  className: c
}) => {
  const { cx: d, classes: u } = d9();
  return /* @__PURE__ */ r.jsxs("div", { ref: l, className: d(u.dialogHeader, c), children: [
    e && /* @__PURE__ */ r.jsx("div", { className: d(u.dialogOverline), children: e }),
    /* @__PURE__ */ r.jsxs("div", { className: d(u.dialogHead), children: [
      /* @__PURE__ */ r.jsxs("div", { className: d(u.dialogHeadline), children: [
        t,
        n && /* @__PURE__ */ r.jsx("div", { className: u.dialogHeadlineTooltip, children: /* @__PURE__ */ r.jsx(
          he,
          {
            testId: `${i}-headline-tooltip`,
            title: n,
            children: /* @__PURE__ */ r.jsx(
              te,
              {
                name: "inverted-info",
                className: u.dialogHeadlineInfoIcon
              }
            )
          }
        ) })
      ] }),
      o && /* @__PURE__ */ r.jsx("div", { className: d(u.dialogSupportingText), children: o })
    ] }),
    a && /* @__PURE__ */ r.jsx("div", { className: u.listHeaderContainer, children: /* @__PURE__ */ r.jsx(T1, { ...a }) })
  ] });
}, fo = ({
  onCancel: e,
  onConfirm: t,
  className: n
}) => {
  const { translations: o } = Q(), { cx: a, classes: i } = h9(), l = Ve(), c = $e(l.breakpoints.down(640));
  return /* @__PURE__ */ r.jsxs("div", { className: a(i.container, n), children: [
    /* @__PURE__ */ r.jsx(W, { variant: "h1", className: i.header, children: o.unsaved_warning.heading }),
    /* @__PURE__ */ r.jsx(W, { variant: "body1", align: "center", children: o.unsaved_warning.dialog_description }),
    /* @__PURE__ */ r.jsxs("div", { className: i.buttonContainer, children: [
      /* @__PURE__ */ r.jsx(
        G,
        {
          fullWidth: c,
          onClick: e,
          buttonVariant: "secondary",
          label: o.unsaved_warning.cancel_label
        }
      ),
      /* @__PURE__ */ r.jsx(
        G,
        {
          fullWidth: c,
          onClick: t,
          buttonVariant: "primary",
          label: o.unsaved_warning.submit_label
        }
      )
    ] })
  ] });
}, Tr = (e, t) => {
  if (!e) return 0;
  const n = window.getComputedStyle(e).getPropertyValue(t), o = n.substring(0, n.length - 2);
  return parseInt(o);
}, x9 = 32, xo = ({
  maintainHeight: e,
  headline: t,
  supportingText: n,
  alert: o,
  contentArea: a,
  helper: i,
  actions: l,
  isShowingWarning: c,
  actionsEmpty: d,
  currentStepIndex: u,
  purchaseBarProps: p,
  headerProps: m,
  // Fixed pixel height the dialog is constrained to (base Dialog 688px; multi-step dialog 800px).
  dialogMaxHeight: g = 688
}) => {
  const h = Z(null), C = Z(null), v = Z(null), b = Z(null), f = Z(null), y = Z(null);
  return K(() => {
    const w = () => {
      var S, _;
      const k = C.current ? Tr(C.current, "padding-top") + Tr(C.current, "padding-bottom") : 88, M = Math.max(((S = v.current) == null ? void 0 : S.clientHeight) ?? 0, 56), L = Math.max(((_ = f.current) == null ? void 0 : _.clientHeight) ?? 0, 16), j = M + L + k, N = g - j, E = window.innerHeight - x9 - j, $ = Math.min(N, E);
      if (b.current) {
        b.current.style.minHeight = "", h.current && (h.current.style.height = ""), y.current = b.current.clientHeight, b.current.style.maxHeight = `${$}px`;
        const B = b.current.querySelector(
          "[data-overlayscrollbars-initialize]"
        );
        if (B && (B.style.maxHeight = `${$}px`), !e)
          return;
        const O = Math.min(y.current, $);
        b.current.style.minHeight = `${O}px`, h.current && (h.current.style.height = `${b.current.clientHeight}px`);
      }
    };
    return w(), window.addEventListener("resize", w), () => window.removeEventListener("resize", w);
  }, [
    e,
    l,
    a,
    t,
    n,
    o,
    i,
    c,
    d,
    u,
    p,
    m,
    g
  ]), {
    dialogRef: C,
    headerRef: v,
    hugContentRef: b,
    footerRef: f,
    contentRef: h
  };
}, bo = ({
  text: e,
  helperConfirmLabel: t,
  textClassName: n,
  checked: o,
  onCheckboxChange: a
}) => {
  const { cx: i, classes: l } = m9(), [c, d] = V(o), u = (p) => {
    d(p), a == null || a(p);
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    e && /* @__PURE__ */ r.jsx("div", { className: i(l.dialogHelperText, n), children: e }),
    t && /* @__PURE__ */ r.jsx("div", { className: i(l.dialogHelperConfirm), children: /* @__PURE__ */ r.jsx(
      $3,
      {
        errorMessage: "",
        helperMessage: "",
        id: "dialog-checkbox-item",
        label: t,
        labelClassName: l.dialogHelperConfirmLabel,
        onValueChange: () => u(!c),
        checked: c,
        testId: "dialog-checkbox-item"
      }
    ) })
  ] });
}, b9 = {
  submit: "primary",
  cancel: "secondary",
  skip: "textSecondary",
  print: "secondary"
}, d1 = ({
  testIdPrefix: e,
  action: t,
  className: n,
  disabled: o,
  loading: a
}) => {
  const { cx: i, classes: l } = p9(), { type: c = "submit", disabled: d } = t, u = t.destructive ? "destructive" : b9[c], p = t.testId ? `${e}-${t.testId}` : `${e}-${c}`;
  return /* @__PURE__ */ r.jsx(
    G,
    {
      type: c === "submit" ? "submit" : "button",
      disabled: !!o || d,
      loading: a,
      buttonVariant: u,
      label: t.label,
      onClick: t.onClick,
      className: i(l.dialogButton, n),
      testId: p
    }
  );
}, w9 = ({
  testIdPrefix: e,
  actions: t,
  onClose: n
}) => {
  const { cx: o, classes: a } = u9();
  if ((t == null ? void 0 : t.length) === 0)
    return null;
  const i = t == null ? void 0 : t.filter((u) => u.type === "submit"), l = t == null ? void 0 : t.filter((u) => u.type === "cancel"), c = t == null ? void 0 : t.find((u) => u.type === "skip"), d = t == null ? void 0 : t.find((u) => u.type === "print");
  return /* @__PURE__ */ r.jsxs("div", { className: o(a.dialogFooterButtons), children: [
    /* @__PURE__ */ r.jsxs("div", { className: o(a.dialogButtons), children: [
      l && l.length > 0 ? l.map((u) => /* @__PURE__ */ r.jsx(
        d1,
        {
          testIdPrefix: e,
          action: {
            ...u,
            // NOTE: (2024-10-07) Noah Settersten => When the cancel button does not have an individual onClick
            // provided, we want to call the dialog's top-level onClose to ensure that the confirmation logic
            // runs.
            onClick: u.onClick ? u.onClick : n
          }
        },
        u.label
      )) : null,
      i && i.length > 0 ? i.map((u) => /* @__PURE__ */ r.jsx(
        d1,
        {
          testIdPrefix: e,
          action: u
        },
        u.label
      )) : null,
      d && /* @__PURE__ */ r.jsx(d1, { testIdPrefix: e, action: d })
    ] }),
    c && /* @__PURE__ */ r.jsx("div", { className: o(a.dialogFooterSkipButton), children: /* @__PURE__ */ r.jsx(d1, { testIdPrefix: e, action: c }) })
  ] });
}, y9 = ({
  contentArea: e,
  helper: t,
  actions: n,
  testId: o,
  footerRef: a,
  purchaseBarProps: i,
  collapseHelper: l,
  onClose: c
}) => {
  const d = n && n.length > 0, { cx: u, classes: p } = c9({
    collapse: !!i || l
  });
  return t != null && t.text || d || i ? /* @__PURE__ */ r.jsxs(
    "div",
    {
      ref: a,
      className: u(p.dialogFooter, {
        [p.dialogFooterWhenNoContent]: !e
      }),
      children: [
        i && /* @__PURE__ */ r.jsx(no, { ...i, className: p.purchaseBar }),
        /* @__PURE__ */ r.jsxs("div", { className: p.dialogFooterInnerContent, children: [
          t && /* @__PURE__ */ r.jsx(
            bo,
            {
              text: t.text,
              helperConfirmLabel: t.helperConfirmLabel,
              onCheckboxChange: t.onCheckboxChange
            }
          ),
          n && /* @__PURE__ */ r.jsx(
            w9,
            {
              testIdPrefix: o,
              actions: n,
              onClose: c
            }
          )
        ] })
      ]
    }
  ) : null;
}, Q2 = ({
  showCloseButton: e = !1,
  overline: t,
  headline: n,
  headlineTooltip: o,
  supportingText: a,
  alert: i,
  contentArea: l,
  fullWidthContentArea: c = !1,
  helper: d,
  collapseHelper: u,
  headerProps: p,
  actions: m,
  className: g,
  testId: h,
  isOpen: C = !1,
  onClose: v,
  purchaseBarProps: b,
  maintainHeight: f = !1,
  confirmOnClose: y,
  contentClassName: w,
  isStackedDialog: k = !1,
  collapseAlertPadding: M = !1,
  collapseContentScrollGutter: L = !1,
  size: j = "small"
}) => {
  const [N, E] = V(!1), { classes: $ } = g9(), S = () => {
    y ? E(!0) : v == null || v();
  }, { contentRef: _, dialogRef: B, headerRef: O, hugContentRef: A, footerRef: F } = xo({
    maintainHeight: f,
    headline: n,
    supportingText: a,
    alert: i,
    contentArea: l,
    helper: d,
    actions: m,
    purchaseBarProps: b
  }), z = !m || m.length === 0, I = /* @__PURE__ */ r.jsx(
    Co,
    {
      testId: h,
      contentArea: l,
      actionsEmpty: z,
      className: g,
      isOpen: C,
      onClose: S,
      dialogRef: B,
      isStackedDialog: k,
      size: j,
      children: N ? /* @__PURE__ */ r.jsx(
        fo,
        {
          className: $.warning,
          onCancel: () => E(!1),
          onConfirm: () => {
            E(!1), v == null || v();
          }
        }
      ) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        /* @__PURE__ */ r.jsx(
          go,
          {
            onClose: S,
            showCloseButton: e
          }
        ),
        /* @__PURE__ */ r.jsx(
          vo,
          {
            overline: t,
            headline: n,
            headlineTooltip: o,
            supportingText: a,
            headerProps: p,
            parentTestId: h,
            headerRef: O
          }
        ),
        /* @__PURE__ */ r.jsx(
          f9,
          {
            alert: i,
            contentArea: l,
            fullWidthContentArea: c,
            actionsEmpty: z,
            hugContentRef: A,
            contentRef: _,
            hideBottomDividerWhenScrollable: !!b,
            className: w,
            collapseAlertPadding: M,
            collapseContentScrollGutter: L
          },
          `${JSON.stringify(h)}-${JSON.stringify(i)}`
        ),
        /* @__PURE__ */ r.jsx(
          y9,
          {
            purchaseBarProps: b,
            contentArea: l,
            helper: d,
            collapseHelper: u,
            actions: m,
            testId: h,
            footerRef: F,
            onClose: S
          }
        )
      ] })
    }
  );
  return ln.createPortal(I, document.body);
}, h2 = 50, k9 = P1(h2), j9 = R()((e) => ({
  multiStepDialogContainer: {
    width: "60rem",
    height: String(h2) + "rem",
    maxHeight: "calc(100vh - 2rem)",
    padding: "0 !important",
    // Collapse to full-width before the viewport is narrower than the 960px dialog + margins,
    // so the sides aren't clipped.
    [e.breakpoints.down(994)]: {
      top: "50%",
      left: 0,
      right: 0,
      transform: "translate(0%, calc(-50% - 1rem))",
      minWidth: "unset",
      width: "calc(100% - 2rem)",
      maxHeight: "min(calc(100vh - 2rem), " + String(h2) + "rem)"
    },
    "@media print": {
      transform: "none",
      top: 0,
      left: 0,
      margin: 0,
      width: "100%",
      boxShadow: "none"
    }
  },
  multiStepDialogHeader: {
    paddingTop: "3.5rem"
  },
  multiStepDialogContent: {
    display: "flex",
    height: "100%",
    [e.breakpoints.down(674)]: {
      justifyContent: "center"
    },
    "@media print": {
      top: 0,
      left: 0,
      width: "100%",
      height: "auto",
      position: "absolute",
      background: "#fff"
    }
  },
  mainContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0
  }
})), S9 = R()(() => ({
  root: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    minHeight: 0
  },
  scrollArea: {
    flex: 1,
    minHeight: 0
  }
})), L9 = ({
  alert: e,
  contentArea: t,
  fullWidthContentArea: n = !1,
  contentAreaClassName: o,
  hideBottomDividerWhenScrollable: a,
  hugContentRef: i
}) => {
  const { cx: l, classes: c } = S9(), { classes: d } = ho({
    fullWidthContentArea: n
  });
  return e || t ? /* @__PURE__ */ r.jsxs("div", { ref: i, className: l(c.root, o), children: [
    /* @__PURE__ */ r.jsx(Ce, {}),
    /* @__PURE__ */ r.jsxs(ue, { className: c.scrollArea, children: [
      e && /* @__PURE__ */ r.jsx(
        "div",
        {
          className: l(d.alertContainer, {
            [d.alertContainerWithoutContentArea]: !t
          }),
          children: /* @__PURE__ */ r.jsx(
            Ke,
            {
              id: "dialog-alert-id",
              testId: "dialog-alert-test-id",
              description: e.description,
              title: e.title,
              variant: e.variant,
              closeButtonEventHandler: e.closeButtonEventHandler,
              hideIcon: e.hideIcon
            }
          )
        }
      ),
      t ? /* @__PURE__ */ r.jsx(
        "div",
        {
          className: l(
            d.dialogContentContainer,
            d.dialogContentContainerScrolling
          ),
          children: t
        }
      ) : null
    ] }),
    !a && /* @__PURE__ */ r.jsx(Ce, { className: d.bottomDivider })
  ] }) : null;
}, M9 = R()((e) => ({
  dialogFooter: {
    width: "100%",
    marginTop: "auto",
    "@media print": {
      left: 0,
      bottom: 0
    }
  },
  dialogFooterInnerContent: {
    width: "100%",
    padding: "1rem 3.5rem",
    flexDirection: "column",
    textAlign: "center",
    alignContent: "center",
    gap: "1rem",
    display: "inline-flex",
    [e.breakpoints.down(480)]: {
      padding: "1rem 1.5rem 1rem 1.5rem "
    }
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    [e.breakpoints.down(674)]: {
      "&:not(:has(button + *))": {
        justifyContent: "stretch",
        "*": {
          width: "100%"
        }
      }
    }
  },
  rightActionsContainer: {
    display: "flex",
    gap: "1rem",
    alignItems: "center"
  },
  button: {
    "@media print": {
      display: "none"
    }
  },
  helperText: {
    textAlign: "left"
  },
  purchaseBar: {
    ">div": {
      paddingLeft: "3.5rem",
      paddingRight: "3.5rem"
    },
    [e.breakpoints.down(480)]: {
      ">div": {
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem"
      }
    }
  }
})), E9 = ({
  dialogTestId: e,
  step: t,
  isFirstStep: n,
  isLastStep: o,
  helper: a,
  footerRef: i,
  cancelLabel: l,
  finishLabel: c,
  nextLabel: d,
  skipLabel: u,
  onBack: p,
  onNext: m,
  onSkip: g,
  isReviewing: h = !1,
  printButton: C,
  purchaseBarProps: v
}) => {
  const { cx: b, classes: f } = M9(), y = Ve(), w = $e(y.breakpoints.down(480)), { translations: k } = Q(), M = Pe(t.label), L = `${e}-${M}`, j = d ?? (o ? c ?? k.common.finish : k.common.next), N = () => h ? !1 : !C, E = () => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    N() && /* @__PURE__ */ r.jsx(
      d1,
      {
        className: f.button,
        testIdPrefix: L,
        action: {
          type: "cancel",
          label: l || n ? k.common.cancel : k.common.back,
          onClick: p
        }
      }
    ),
    C && /* @__PURE__ */ r.jsx(
      d1,
      {
        className: f.button,
        testIdPrefix: L,
        action: {
          type: "print",
          label: k.common.print_receipt,
          onClick: () => {
            try {
              document.execCommand("print", !1, void 0) || window.print();
            } catch {
              window.print();
            }
          }
        }
      }
    )
  ] }), $ = () => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    t.optional && !h && /* @__PURE__ */ r.jsx(
      d1,
      {
        className: f.button,
        testIdPrefix: L,
        action: {
          type: "skip",
          label: u ?? k.common.skip_step,
          onClick: g
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      d1,
      {
        className: f.button,
        testIdPrefix: L,
        disabled: (t.shouldDisableNext ? t.shouldDisableNext({ isReviewing: h, isFirstStep: n, isLastStep: o }) : t.nextDisabled) || t.nextLoading,
        action: {
          type: "submit",
          label: h ? k.common.save_and_review : j,
          onClick: m
        }
      }
    )
  ] });
  return /* @__PURE__ */ r.jsxs("div", { ref: i, className: b(f.dialogFooter), children: [
    v && /* @__PURE__ */ r.jsx(no, { ...v, className: f.purchaseBar }),
    /* @__PURE__ */ r.jsxs("div", { className: f.dialogFooterInnerContent, children: [
      a && /* @__PURE__ */ r.jsx(bo, { textClassName: f.helperText, ...a }),
      /* @__PURE__ */ r.jsxs("div", { className: f.buttons, children: [
        E(),
        w ? $() : /* @__PURE__ */ r.jsx("div", { className: f.rightActionsContainer, children: $() })
      ] })
    ] })
  ] });
}, N9 = R()((e) => ({
  sidebar: {
    width: "10rem",
    minWidth: "10rem",
    maxWidth: "10rem",
    borderTopLeftRadius: "0.625rem",
    borderBottomLeftRadius: "0.625rem",
    backgroundColor: e.palette.neutral[20],
    [e.breakpoints.down(674)]: {
      display: "none"
    },
    "@media print": {
      display: "none"
    }
  },
  sidebarContent: {
    marginTop: "2rem",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxHeight: "calc(100% - 2rem)"
  },
  scrollContainer: {
    marginTop: "2rem",
    maxHeight: "calc(100% - 7rem)",
    width: "100%"
  },
  stepContainer: {
    marginLeft: "1.5rem",
    marginRight: "1.5rem",
    marginBottom: "1.5rem"
  },
  sectionHeading: {
    display: "block",
    paddingTop: "1rem",
    paddingBottom: "0.5rem"
  },
  step: {
    pointerEvents: "none",
    width: "100%",
    padding: "0.5rem 0.75rem",
    borderLeft: `0.25rem solid ${e.palette.neutral[50]}`,
    opacity: "1 !important",
    scrollMarginBottom: "2rem"
  },
  stepText: {
    textAlign: "left",
    display: "flex",
    flexDirection: "row",
    gap: "0.25rem"
  },
  activeStepText: {
    color: e.typography.body1.color
  },
  activeStep: {
    borderLeft: `0.25rem solid ${e.palette.primary["60-key"]}`
  },
  incompleteStep: {
    borderLeft: `1px solid ${e.palette.neutral[50]}`,
    paddingLeft: "0.938rem"
  }
})), I9 = R()((e) => ({
  mobileSidebar: {
    position: "absolute",
    top: "1.375rem",
    [e.breakpoints.up(674)]: {
      display: "none"
    }
  },
  mobileSidebarText: {
    ...e.typography.body3
  },
  mobileSidebarButtonContainer: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center"
  },
  mobileSidebarMenu: {
    position: "absolute"
  }
})), $9 = (e, t) => {
  const n = (i, l) => {
    var d, u;
    const c = t[i];
    return !!(c != null && c.includes(l)) || !!((u = (d = e[i]) == null ? void 0 : d.substeps[l]) != null && u.completed);
  }, o = (i) => {
    var l;
    return !!((l = e[i]) != null && l.completed);
  };
  return {
    isInteractibleSubstep: n,
    showSubstep: (i, l) => o(i) || n(i, l)
  };
}, _9 = (e, t) => e < t ? -1 : e > t ? 1 : 0, V9 = ({
  steps: e,
  sectionHeadings: t = [],
  icon: n,
  currentStepIndex: o,
  currentSubstepIndex: a,
  testId: i,
  touchedSteps: l,
  touchedSubsteps: c,
  overrideStepIndex: d
}) => {
  var L;
  const { cx: u, classes: p } = N9(), { isInteractibleSubstep: m, showSubstep: g } = $9(
    e,
    c
  ), h = d ?? o, C = je.cloneDeep(t);
  C.sort((j, N) => j.index - N.index);
  const v = (j) => {
    var _;
    const N = l.sort(_9), E = N[N.length - 1], $ = !!E && j <= E, S = j <= h;
    return $ || S || ((_ = e[j]) == null ? void 0 : _.completed);
  }, b = (j) => {
    const N = t.find((E) => E.index === j);
    return N == null ? void 0 : N.label;
  }, f = Te(
    (j) => C.find((N, E) => {
      var S;
      const $ = (S = C[E + 1]) == null ? void 0 : S.index;
      return j >= N.index && ($ === void 0 || j < $);
    }),
    [C]
  ), y = M1(
    () => f(h),
    [h, f]
  ), w = (j) => {
    var N;
    return ((N = f(j)) == null ? void 0 : N.index) === (y == null ? void 0 : y.index);
  }, k = (L = e[h]) == null ? void 0 : L.hideSidebar, M = (j, N, E) => {
    if (!w(N))
      return null;
    const $ = E !== void 0 && E > -1;
    if ($ && !g(N, E))
      return null;
    const S = $ ? (
      // since the steps no longer act as nav buttons, this variable is only used to track completeness
      m(N, E)
    ) : v(N), _ = $ ? N === h && E === a : N === h && a === -1;
    return /* @__PURE__ */ r.jsx(
      tn,
      {
        "data-testid": `${i}-step-${N}-${E}`,
        disableRipple: !0,
        disabled: !S,
        className: u(p.step, {
          [p.incompleteStep]: !S && !_,
          [p.activeStep]: _
        }),
        children: /* @__PURE__ */ r.jsxs(
          W,
          {
            color: "textSecondary",
            className: u(p.stepText, {
              [p.activeStepText]: _
            }),
            variant: "body1",
            children: [
              $ ? /* @__PURE__ */ r.jsx("span", { children: "•" }) : null,
              j.label
            ]
          }
        )
      },
      `${N}-${E}`
    );
  };
  return /* @__PURE__ */ r.jsx("div", { className: p.sidebar, "data-testid": i, children: /* @__PURE__ */ r.jsxs("div", { className: p.sidebarContent, children: [
    /* @__PURE__ */ r.jsx(we, { size: "large", icon: n, iconAvatarColor: "primary" }),
    /* @__PURE__ */ r.jsx(ue, { className: p.scrollContainer, children: /* @__PURE__ */ r.jsx("nav", { className: p.stepContainer, children: k ? null : e.map(
      (j, N) => j.hideSidebar ? null : /* @__PURE__ */ r.jsxs(qe.Fragment, { children: [
        b(N) ? /* @__PURE__ */ r.jsx(
          W,
          {
            variant: "overline",
            className: p.sectionHeading,
            children: b(N)
          }
        ) : null,
        M(j, N),
        j.substeps.map(
          (E, $) => E.hideSidebar ? null : M(E, N, $)
        )
      ] }, `${N}-${j.label}`)
    ) }) })
  ] }) });
}, A9 = ({
  steps: e,
  currentStepIndex: t,
  currentSubstepIndex: n,
  overrideStepIndex: o
}) => {
  var d;
  const { classes: a } = I9(), i = o ?? t, l = n !== -1 ? (d = e[i]) == null ? void 0 : d.substeps[n] : e[i], c = l == null ? void 0 : l.label;
  return /* @__PURE__ */ r.jsx("div", { className: a.mobileSidebar, children: /* @__PURE__ */ r.jsx("span", { className: a.mobileSidebarText, children: c }) });
}, B9 = ({
  steps: e,
  sectionHeadings: t,
  icon: n,
  currentStepIndex: o,
  currentSubstepIndex: a,
  onStepChange: i,
  testId: l,
  touchedSteps: c,
  touchedSubsteps: d,
  overrideStepIndex: u,
  isReviewStep: p
}) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(
    A9,
    {
      steps: e,
      touchedSubsteps: d,
      sectionHeadings: t,
      currentStepIndex: o,
      currentSubstepIndex: a,
      onStepChange: i,
      testId: l,
      overrideStepIndex: u
    }
  ),
  /* @__PURE__ */ r.jsx(
    V9,
    {
      touchedSteps: c,
      touchedSubsteps: d,
      steps: e,
      sectionHeadings: t,
      icon: n,
      currentStepIndex: o,
      currentSubstepIndex: a,
      onStepChange: i,
      testId: l,
      overrideStepIndex: u,
      isReviewStep: p
    }
  )
] }), H9 = (e, t, n) => {
  let o = t, a = n, i = !1;
  const l = e[t - 1];
  return n >= 0 ? a = n - 1 : l && l.substeps.length > 0 ? (o = t - 1, a = l.substeps.length - 1) : t > 0 ? (o = t - 1, a = -1) : i = !0, {
    nextStepIndex: o,
    nextSubstepIndex: a,
    shouldClose: i
  };
}, D9 = ({
  steps: e,
  skip: t,
  isReviewing: n = !1,
  customReviewStepIndex: o,
  currentStepIndex: a,
  currentSubstepIndex: i,
  onSubstepVisited: l
}) => {
  let c = a, d = i, u = {}, p = !1;
  const m = e[a], g = (m == null ? void 0 : m.substeps) && m.substeps.length > 0 && i + 1 < m.substeps.length;
  return n ? {
    nextStepIndex: o ?? e.length - 1,
    nextSubstepIndex: -1,
    onNextOptions: { fromReview: !0 },
    shouldClose: !1
  } : (g ? (d = i + 1, l == null || l()) : a !== e.length - 1 ? (d = -1, c = a + 1, u = { skipped: t }) : (p = !0, u = { skipped: t }), {
    nextStepIndex: c,
    nextSubstepIndex: d,
    onNextOptions: u,
    shouldClose: p
  });
}, T9 = (e) => e.reduce((t, n, o) => n.completed ? [...t, o] : t, []), Op = ({
  steps: e,
  sectionHeadings: t,
  icon: n,
  initialStep: o = 0,
  testId: a,
  finishLabel: i,
  reviewStepIndex: l,
  confirmOnClose: c = !0,
  customFirstSectionLabel: d,
  customLastSectionLabel: u,
  size: p = "small"
}) => {
  const { cx: m, classes: g } = j9(), [h, C] = V(o), [v, b] = V(-1), [f, y] = V(!1), { translations: w } = Q(), k = d ?? w.common.start, M = u ?? w.common.finish, L = M1(() => {
    if (t) {
      const Y = je.cloneDeep(t), ae = Y[0], pe = Y[Y.length - 1];
      return ae && (ae.label = k), pe && (pe.label = M), Y;
    }
  }, [k, M, t]), [j, N] = V([]), [E, $] = V({}), [S, _] = V(!1), B = l === h;
  K(() => {
    const Y = T9(e);
    N((ae) => je.uniq([...ae, ...Y]));
  }, [e]), K(() => {
    N((Y) => Y.includes(h) ? Y : [...Y, h]);
  }, [h]);
  const O = (Y, ae) => {
    const pe = e[Y];
    return (ae !== void 0 ? pe == null ? void 0 : pe.substeps[ae] : void 0) ?? pe;
  }, A = O(h, v), { dialogRef: F, headerRef: z, hugContentRef: I, footerRef: D } = xo({
    maintainHeight: !1,
    isShowingWarning: f,
    currentStepIndex: h,
    dialogMaxHeight: k9,
    headline: A == null ? void 0 : A.dialogProps.headline,
    supportingText: A == null ? void 0 : A.dialogProps.supportingText,
    alert: A == null ? void 0 : A.dialogProps.alert,
    contentArea: A == null ? void 0 : A.dialogProps.contentArea,
    helper: A == null ? void 0 : A.dialogProps.helper,
    headerProps: A == null ? void 0 : A.dialogProps.headerProps,
    purchaseBarProps: A == null ? void 0 : A.dialogProps.purchaseBarProps
  });
  if (!A) return null;
  const {
    dialogProps: {
      testId: H,
      contentArea: T,
      contentClassName: ne,
      renderContent: de,
      className: q,
      isOpen: U,
      onClose: se,
      showCloseButton: ve,
      overline: ye,
      headline: Me,
      headlineTooltip: Ee,
      supportingText: ke,
      headerProps: Ae,
      alert: Fe,
      helper: J,
      onBack: ie,
      onNext: be,
      skipCurrentStepIndexUpdate: P = !1,
      preNext: ee,
      onScrollAway: oe,
      skipStep: fe,
      printButton: xe,
      purchaseBarProps: Be
    },
    variant: Ye = "default",
    nextLabel: le
  } = A, ce = !1, ge = (Y) => {
    c && Y ? y(!0) : (C(o), b(-1), N([]), $({}), se == null || se());
  }, Ge = () => {
    var He, Ne, De;
    oe == null || oe();
    const { nextStepIndex: Y, nextSubstepIndex: ae, shouldClose: pe } = H9(e, h, v);
    (De = (He = O(Y, ae)) == null ? void 0 : (Ne = He.dialogProps).onScrollTo) == null || De.call(Ne), pe ? ge(!0) : (ie == null || ie(), C(Y), b(ae), st(Y, ae));
  }, lt = `${a}-sidebar`, st = (Y, ae) => {
    const pe = ae && ae >= 0 ? ae : "undefined", He = `${lt}-step-${Y}-${pe}`;
    setTimeout(() => {
      var Ne;
      (Ne = document.querySelector(`[data-testid="${He}"]`)) == null || Ne.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
      });
    }, 200);
  }, F1 = (Y) => {
    var t1, h1, g1;
    oe == null || oe();
    const ae = () => {
      $((r1) => {
        const n1 = r1[h] ?? [];
        return n1.push(v + 1), {
          ...r1,
          [h]: n1
        };
      });
    }, { nextStepIndex: pe, nextSubstepIndex: He, onNextOptions: Ne, shouldClose: De } = D9({
      steps: e,
      skip: Y,
      isReviewing: S,
      customReviewStepIndex: l,
      currentStepIndex: h,
      currentSubstepIndex: v,
      onSubstepVisited: ae
    });
    (g1 = (t1 = O(pe, He)) == null ? void 0 : (h1 = t1.dialogProps).onScrollTo) == null || g1.call(h1), De ? (ge(!1), be == null || be(Ne)) : (P || (C(pe), b(He)), _(!1), be == null || be(Ne)), S || st(pe, He);
  }, z1 = (Y) => {
    if (ee)
      ee().then(() => F1(Y)).catch((pe) => {
        console.error("operation unsuccessful", pe);
      });
    else
      return F1(Y);
  }, W1 = (Y, ae, pe = !1) => {
    var He, Ne, De;
    if (Y <= e.length - 1) {
      oe == null || oe(), (De = (He = O(Y, ae)) == null ? void 0 : (Ne = He.dialogProps).onScrollTo) == null || De.call(Ne), C(Y);
      const t1 = e[Y];
      t1 && ae !== void 0 && ae >= 0 && ae < t1.substeps.length ? b(ae) : b(-1), pe && _(!0);
    }
  }, ct = () => {
    W1(h + 1);
  }, re = l ?? e.length - 1;
  return fe && z1(), /* @__PURE__ */ r.jsx(
    Co,
    {
      testId: `${a}-${H}`,
      contentArea: T,
      actionsEmpty: ce,
      className: m(g.multiStepDialogContainer, q),
      isOpen: U,
      onClose: () => ge(!0),
      dialogRef: F,
      children: /* @__PURE__ */ r.jsx("div", { className: g.multiStepDialogContent, "data-size": p, children: f ? /* @__PURE__ */ r.jsx(
        fo,
        {
          onCancel: () => y(!1),
          onConfirm: () => {
            y(!1), ge(!1);
          }
        }
      ) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        /* @__PURE__ */ r.jsx(
          B9,
          {
            touchedSteps: j,
            touchedSubsteps: E,
            testId: lt,
            icon: n,
            steps: e,
            isReviewStep: B,
            sectionHeadings: L,
            currentStepIndex: h,
            currentSubstepIndex: v,
            onStepChange: (Y, ae) => W1(Y, ae),
            overrideStepIndex: S ? re : void 0
          }
        ),
        /* @__PURE__ */ r.jsxs("div", { className: m(g.mainContent), children: [
          /* @__PURE__ */ r.jsx(
            go,
            {
              onClose: () => ge(!0),
              showCloseButton: ve
            }
          ),
          /* @__PURE__ */ r.jsx(
            vo,
            {
              className: g.multiStepDialogHeader,
              overline: ye,
              headline: Me,
              headlineTooltip: Ee,
              supportingText: ke,
              headerProps: Ae,
              parentTestId: `${a}-${H}`,
              headerRef: z
            }
          ),
          /* @__PURE__ */ r.jsx(
            L9,
            {
              alert: Fe,
              contentArea: de ? de(W1, ct) : T,
              fullWidthContentArea: Ye === "fullWidth",
              hideBottomDividerWhenScrollable: !!Be,
              contentAreaClassName: ne,
              hugContentRef: I
            },
            `${A.dialogProps.testId}-${JSON.stringify(Fe)}`
          ),
          /* @__PURE__ */ r.jsx(
            E9,
            {
              step: A,
              isFirstStep: h === 0,
              isLastStep: h === e.length - 1,
              helper: J,
              footerRef: D,
              dialogTestId: a,
              onBack: Ge,
              onNext: z1,
              onSkip: z1,
              isReviewing: S,
              purchaseBarProps: Be,
              finishLabel: i,
              nextLabel: le,
              printButton: xe
            }
          )
        ] })
      ] }) })
    }
  );
}, R9 = ({
  step: e,
  overline: t,
  onReview: n,
  fields: o
}) => {
  const { translations: a } = Q(), { classes: i } = C9();
  return /* @__PURE__ */ r.jsx(
    I1,
    {
      resourceId: `review-step-${e}`,
      overline: t ?? "",
      open: !0,
      fullWidth: !0,
      actions: n ? [
        {
          id: "review-organization-edit",
          label: a.common.edit,
          onClick: n
        }
      ] : [],
      children: o.map(
        ({
          heading: l,
          value: c,
          items: d,
          avatar: u,
          listItemProps: p,
          fieldDisplayType: m
        }) => {
          if (m === "splitTextField" || d) {
            const g = (d == null ? void 0 : d.length) === 0 && !c ? "-" : c;
            return /* @__PURE__ */ r.jsx(
              "div",
              {
                className: i.reviewTextFieldContainer,
                children: /* @__PURE__ */ r.jsx(
                  O2,
                  {
                    id: `review-${e}-${je.snakeCase(l)}-field`,
                    items: d || [],
                    label: l ?? "",
                    isReadOnly: !0,
                    value: g,
                    onChange: () => 0,
                    onChipChange: () => 0
                  },
                  `review-field-${je.snakeCase(l)}`
                )
              },
              `review-field-${je.snakeCase(l)}`
            );
          }
          if (m === "complexListItem" || p)
            return /* @__PURE__ */ r.jsx(
              Je,
              {
                ...p || {
                  id: `review-${e}-${je.snakeCase(l)}-field`,
                  testId: `review-${e}-${je.snakeCase(l)}-field`,
                  heading: l,
                  subtext: !c || c === "" ? "-" : c,
                  avatar: u
                },
                variant: "default",
                density: "drawer",
                interactive: !1
              },
              `review-field-${je.snakeCase(l)}`
            );
          if (m === "text" || typeof c == "string" || typeof c == "number")
            return /* @__PURE__ */ r.jsx(
              "div",
              {
                className: i.reviewTextFieldContainer,
                children: /* @__PURE__ */ r.jsx(
                  y1,
                  {
                    id: `review-${e}-${je.snakeCase(l)}-field`,
                    name: je.snakeCase(l),
                    value: c || "-",
                    label: l ?? "",
                    isReadOnly: !0,
                    handleOnChange: () => 0
                  },
                  `review-${e}-${je.snakeCase(l)}-field`
                )
              },
              `review-field-${je.snakeCase(l)}`
            );
        }
      )
    },
    `review-step-${e}-accordion`
  );
}, Zp = ({
  step: e,
  overline: t,
  heading: n,
  value: o,
  items: a,
  avatar: i,
  onReview: l,
  listItemProps: c,
  fieldDisplayType: d
}) => /* @__PURE__ */ r.jsx(
  R9,
  {
    step: e,
    onReview: l,
    overline: t ?? n ?? "",
    fields: [
      {
        heading: n,
        value: o,
        avatar: i,
        listItemProps: c,
        items: a,
        fieldDisplayType: d
      }
    ]
  },
  `review-fieldset-${e}-${n || t}`
), F9 = X.create(({ theme: e }) => ({
  link: {
    textDecoration: "underline",
    color: e.palette.primary["60-key"]
  }
})), Pp = ({ href: e, children: t }) => {
  const { classes: n } = F9();
  return /* @__PURE__ */ r.jsx("a", { className: n.link, href: e, target: "_blank", children: t });
}, z9 = ({ count: e }) => {
  const { classes: t } = w6();
  return /* @__PURE__ */ r.jsxs("div", { className: t.root, children: [
    /* @__PURE__ */ r.jsx(
      me,
      {
        variant: "rounded",
        className: t.actionBar,
        height: 40
      }
    ),
    /* @__PURE__ */ r.jsxs(Le, { gap: "0.5rem", children: [
      /* @__PURE__ */ r.jsx(me, { variant: "text", className: t.headings }),
      Array.from({ length: e }, (n, o) => /* @__PURE__ */ r.jsx(
        me,
        {
          variant: "rounded",
          height: 72
        },
        `skeleton-data-card-${o}`
      ))
    ] })
  ] });
}, wo = ({ count: e }) => {
  const { classes: t } = b6();
  return /* @__PURE__ */ r.jsxs(Le, { gap: "0.5rem", children: [
    /* @__PURE__ */ r.jsx(me, { variant: "text", className: t.headings }),
    Array.from({ length: e }, (n, o) => /* @__PURE__ */ r.jsx(
      me,
      {
        variant: "rounded",
        height: 72
      },
      `skeleton-data-card-${o}`
    ))
  ] });
}, yo = ({ count: e }) => /* @__PURE__ */ r.jsx(Le, { gap: "0.5rem", children: Array.from({ length: e }, (t, n) => /* @__PURE__ */ r.jsx(
  me,
  {
    variant: "rounded",
    height: 116
  },
  `skeleton-card-${n}`
)) }), W9 = ({ count: e, gap: t }) => /* @__PURE__ */ r.jsx(Le, { gap: t, children: Array.from({ length: e }, (n, o) => /* @__PURE__ */ r.jsx(
  me,
  {
    variant: "rounded",
    height: 72
  },
  `skeleton-data-card-${o}`
)) }), O9 = ({
  avatarSize: e = "medium"
}) => {
  const { cx: t, classes: n } = R2(), { classes: o } = y6();
  return /* @__PURE__ */ r.jsxs("div", { className: o.container, children: [
    /* @__PURE__ */ r.jsx("div", { className: o.avatarContainer, children: /* @__PURE__ */ r.jsx(
      me,
      {
        variant: "circular",
        className: t({
          [n.sizeSmall]: e === "small",
          [n.sizeMedium]: e === "medium",
          [n.sizeLarge]: e === "large"
        })
      }
    ) }),
    /* @__PURE__ */ r.jsxs("div", { className: o.textContainer, children: [
      /* @__PURE__ */ r.jsx(me, { variant: "rounded", height: 16 }),
      /* @__PURE__ */ r.jsx(me, { variant: "rounded", height: 12 })
    ] })
  ] });
}, Z9 = () => /* @__PURE__ */ r.jsxs(Le, { gap: "1rem", direction: "row", alignItems: "center", children: [
  /* @__PURE__ */ r.jsx(R1, { variant: "avatar" }),
  /* @__PURE__ */ r.jsx(me, { variant: "rounded", width: 132, height: 20 })
] }), P9 = {
  card_group: yo,
  data_card: W9,
  basic_data_grid: wo,
  advanced_data_grid: z9,
  form_field: W2,
  complex_list_item: O9,
  workspace_header: Z9
}, q9 = ({ size: e = "medium" }) => {
  const { cx: t, classes: n } = R2();
  return /* @__PURE__ */ r.jsx(
    me,
    {
      variant: "circular",
      className: t({
        [n.sizeTiny]: e === "tiny",
        [n.sizeSmall]: e === "small",
        [n.sizeMedium]: e === "medium",
        [n.sizeLarge]: e === "large"
      })
    }
  );
}, U9 = (e) => e.variant === "avatar", G9 = (e) => {
  if (U9(e)) return /* @__PURE__ */ r.jsx(q9, { ...e });
  const t = P9[e.variant];
  if (!t) throw new Error("Invalid Skeleton variant");
  return /* @__PURE__ */ r.jsx(t, { count: e.count ?? 3, ...e });
}, R1 = (e) => /* @__PURE__ */ r.jsx("div", { "data-testid": "loading-skeleton", children: /* @__PURE__ */ r.jsx(G9, { ...e }) }), k1 = 480, K9 = R()((e) => ({
  root: {
    position: "relative",
    height: "12rem",
    background: e.palette.neutral[30],
    [e.breakpoints.down(k1)]: {
      height: "7rem"
    }
  },
  gradient: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "6rem",
    [e.breakpoints.down(k1)]: {
      height: "4.5rem"
    },
    background: `linear-gradient(0deg, ${e.palette.neutral[30]} 0%, ${e.palette.neutral[20]} 100%)`
  },
  bottomBackground: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height: "6rem",
    [e.breakpoints.down(k1)]: {
      height: "2.5rem"
    },
    background: e.palette.neutral[20],
    borderTopLeftRadius: "1rem",
    borderTopRightRadius: "1rem"
  },
  avatarContainer: {
    position: "absolute",
    inset: 0,
    [e.breakpoints.down(k1)]: {
      top: "unset"
    },
    display: "grid",
    placeItems: "center"
  },
  avatarBackground: {
    width: "5rem",
    height: "5rem",
    backgroundColor: e.palette.neutral[20],
    borderRadius: "100%",
    boxShadow: e.namedShadows["depth-1"]
  }
})), Y9 = (e) => {
  const t = {
    ...e,
    size: e.size ?? "large",
    variant: e.variant ?? "icon"
  };
  return /* @__PURE__ */ r.jsx(we, { ...t });
}, Q9 = ({
  avatarProps: e,
  avatarUrl: t,
  onAvatarUploaded: n,
  onAvatarRemoval: o,
  readOnly: a = !1
}) => {
  const { classes: i } = K9();
  return /* @__PURE__ */ r.jsxs("div", { className: i.root, children: [
    /* @__PURE__ */ r.jsx("div", { className: i.gradient }),
    /* @__PURE__ */ r.jsx("div", { className: i.bottomBackground }),
    /* @__PURE__ */ r.jsx("div", { className: i.avatarContainer, children: /* @__PURE__ */ r.jsx("div", { className: i.avatarBackground, children: e === "loading" ? /* @__PURE__ */ r.jsx(R1, { variant: "avatar", size: "large" }) : a ? /* @__PURE__ */ r.jsx(Y9, { ...e }) : /* @__PURE__ */ r.jsx(
      Si,
      {
        testId: "item-banner-avatar-upload",
        defaultAvatarProps: {
          variant: "icon",
          ...e
        },
        url: t,
        onImageSelected: (l, c) => {
          c();
        },
        onImageUploaded: (l) => {
          n == null || n(l);
        },
        onImageRemoval: () => o == null ? void 0 : o()
      }
    ) }) })
  ] });
};
class X9 extends $0 {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0 };
  }
  componentDidCatch(t, n) {
    console.error(t, n.componentStack);
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
const J9 = X.create({
  root: {
    margin: "auto",
    maxWidth: "34rem"
  },
  refreshIcon: {
    width: "1rem",
    height: "1rem",
    svg: {
      position: "relative",
      left: "0.25rem",
      width: "100%",
      height: "100%"
    }
  }
}), e7 = () => {
  const { translations: e } = Q(), { classes: t } = J9();
  return /* @__PURE__ */ r.jsx("div", { className: t.root, children: /* @__PURE__ */ r.jsx(
    Ke,
    {
      id: "page-error",
      testId: "page-error",
      closeButtonEventHandler: () => {
      },
      variant: "error",
      description: e.errors.general_message,
      actions: [
        {
          label: e.errors.reload_page,
          onClick: () => window.location.reload()
        },
        {
          icon: /* @__PURE__ */ r.jsx("div", { className: t.refreshIcon, children: /* @__PURE__ */ r.jsx(te, { name: "open" }) }),
          label: e.errors.help_center,
          onClick: () => window.open("https://support.inductiveautomation.com/hc/en-us")
        }
      ]
    }
  ) });
}, t7 = X.withParams().create(({ theme: e, fixedHeight: t }) => ({
  root: {
    display: "flex",
    minHeight: "100dvh",
    "@media print": {
      minHeight: "unset"
    }
  },
  content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: e.palette.neutral[20],
    ...t ? {
      height: "100dvh",
      "@media print": { height: "unset" }
    } : {
      minHeight: "100dvh",
      "@media print": {
        minHeight: "unset"
      },
      height: "fit-content"
    },
    marginLeft: "16rem",
    maxWidth: "calc(100% - 16rem)",
    [e.breakpoints.down(Dn)]: {
      marginLeft: "4.5rem",
      maxWidth: "calc(100% - 4.5rem)"
    },
    [e.breakpoints.down(Tn)]: {
      marginLeft: "0",
      maxWidth: "unset"
    }
  },
  snackbarPortal: {
    position: "relative",
    zIndex: yn,
    pointerEvents: "none"
  }
})), qp = ({ navigation: e, children: t, fixedHeight: n = !1 }) => {
  const { classes: o } = t7({ fixedHeight: n }), { snackbars: a, removeSnackbar: i } = Wt();
  return /* @__PURE__ */ r.jsx(jt, { className: o.root, children: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    e,
    /* @__PURE__ */ r.jsx(jt, { component: "main", className: o.content, children: /* @__PURE__ */ r.jsx(X9, { fallback: /* @__PURE__ */ r.jsx(e7, {}), children: t }) }),
    ln.createPortal(
      /* @__PURE__ */ r.jsx("div", { className: o.snackbarPortal, children: /* @__PURE__ */ r.jsx(
        a8,
        {
          snackbars: a,
          removeSnackbar: i
        }
      ) }),
      document.body
    )
  ] }) });
}, r7 = (e, t) => {
  const n = t.map(
    (a) => e.findIndex((i) => i.id === a)
  );
  return n.sort()[n.length - 1] ?? -1;
}, Up = ({
  lists: e,
  onSelection: t,
  checkedIds: n,
  ...o
}) => {
  const a = (l) => ({ id: c, value: d }) => {
    if (!d)
      t({ id: c, value: d });
    else {
      const u = l.items.findIndex((m) => m.id === c);
      l.items.slice(0, u + 1).forEach(({ id: m }) => {
        t({ id: m, value: !0 });
      });
    }
  }, i = e.map((l) => {
    if ("items" in l) {
      const c = r7(
        l.items,
        n
      ), d = a(l);
      return {
        ...l,
        onSelection: d,
        items: l.items.map((u, p) => {
          const m = p < c;
          return {
            ...u,
            selected: n.includes(u.id),
            disabled: !!u.disabled || m
          };
        })
      };
    }
    return l;
  });
  return /* @__PURE__ */ r.jsx(Ie, { lists: i, ...o });
}, n7 = (e) => /* @__PURE__ */ s.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 170 48", fill: "none", ...e }, /* @__PURE__ */ s.createElement("g", { clipPath: "url(#brand-animated_svg__a)" }, /* @__PURE__ */ s.createElement("path", { fill: "#fff", d: "M166.025 39.256a1.681 1.681 0 0 1 2.866-1.196 1.675 1.675 0 0 1 .366 1.832 1.68 1.68 0 0 1-1.554 1.037 1.66 1.66 0 0 1-1.553-1.03 1.7 1.7 0 0 1-.125-.643m3.1 0a1.42 1.42 0 0 0-1.696-1.4 1.43 1.43 0 0 0-1.12 1.116 1.42 1.42 0 0 0 2.397 1.285c.266-.265.417-.625.419-1.001m-.624.906h-.31l-.548-.843h-.306v.843h-.26v-1.829h.797c.324 0 .648.088.648.487 0 .36-.251.486-.579.504zm-.858-1.1c.226 0 .626.041.626-.25 0-.189-.248-.221-.447-.221h-.487v.47zM59.094 24.501V12.586h-1.925v-2.092h4.408V24.5zm1.36-19.297a1.54 1.54 0 0 1 1.544 1.53 1.537 1.537 0 1 1-2.63-1.084 1.48 1.48 0 0 1 1.086-.46zm12.97 19.298v-8.149q0-2.235-.673-3.131-.673-.897-2.256-.897a3.7 3.7 0 0 0-1.783.51 3.96 3.96 0 0 0-1.427 1.256V24.5h-2.48V10.495h1.701l.784 1.805q1.23-2.068 4.015-2.068 4.605 0 4.605 5.6v8.67zm14.363-.015v-1.033q-1.298 1.297-3.769 1.297-2.626 0-4.263-1.882-1.636-1.883-1.635-5.03 0-3.153 1.883-5.383 1.882-2.23 4.487-2.231 2.169 0 3.297 1.021V4.752h2.484v19.735zm0-10.751q-.943-1.41-2.579-1.411a4 4 0 0 0-3.243 1.49q-1.236 1.494-1.236 3.793 0 5.061 4.604 5.063a3.55 3.55 0 0 0 1.413-.373q.824-.372 1.034-.791zm8.262-3.242v8.932q0 3.243 2.812 3.243a3.86 3.86 0 0 0 2.254-.705q1.021-.705 1.347-1.635v-9.835h2.486v14.008h-2.491v-1.936q-.417.824-1.68 1.51a5.14 5.14 0 0 1-2.464.687q-2.305 0-3.526-1.32t-1.223-3.754v-9.195zm22.983 1.138-1.229 1.752q-.38-.38-1.341-.719a5.6 5.6 0 0 0-1.888-.34q-2.027 0-3.215 1.419-1.19 1.419-1.192 3.892 0 2.456 1.216 3.745 1.217 1.29 3.375 1.298 1.674 0 3.376-1.298l.981 2.087q-2.002 1.298-4.959 1.298-2.862 0-4.734-1.922-1.87-1.921-1.869-5.205 0-3.35 1.946-5.376t5.317-2.029a7 7 0 0 1 2.353.456q1.26.457 1.863.942m3.047.824h-1.621v-1.962h1.621v-2.93l2.484-.956V10.5h3.847v1.963h-3.847v6.956q0 1.766.597 2.512t1.917.746a4.6 4.6 0 0 0 1.973-.486l.367 2.184c-1.109.27-2.247.402-3.388.392a3.68 3.68 0 0 1-2.805-1.235q-1.143-1.236-1.145-3.119zm10.667 12.045V12.586h-1.923v-2.092h4.409V24.5zm1.361-19.297a1.5 1.5 0 0 1 1.093.45 1.54 1.54 0 0 1 .333 1.674 1.54 1.54 0 0 1-.834.833c-.188.077-.39.114-.592.11a1.54 1.54 0 0 1-1.533-1.544 1.53 1.53 0 0 1 .443-1.09 1.52 1.52 0 0 1 1.09-.447zm9.588 19.559h-.649l-6-14.308h2.712l3.7 9.816 3.78-9.81h2.603zm19.203-7.023h-10.104q0 2.46 1.347 3.78 1.191 1.15 3.06 1.15 2.131 0 3.558-1.242l1.046 1.784q-.575.578-1.766.996a9.5 9.5 0 0 1-3.321.548 6.2 6.2 0 0 1-4.487-1.784q-2.053-1.975-2.053-5.31 0-3.464 2.108-5.558a6.13 6.13 0 0 1 4.461-1.871q2.996 0 4.703 1.688 1.65 1.62 1.649 4.304a5.5 5.5 0 0 1-.201 1.514m-6.037-5.415a3.92 3.92 0 0 0-4.001 3.61h7.755a3.54 3.54 0 0 0-.941-2.513q-1.032-1.098-2.813-1.097M62.171 39.59q-.932 1.17-2.854 1.17a2.46 2.46 0 0 1-1.784-.75 2.5 2.5 0 0 1-.755-1.86q0-1.33 1.164-2.252 1.164-.923 2.972-.92c.38.01.756.083 1.113.215q0-2.128-1.897-2.126-1.46 0-2.24.785l-.648-1.298a3.9 3.9 0 0 1 1.222-.618 4.8 4.8 0 0 1 1.492-.257q1.907 0 2.768.867.861.868.863 2.757v3.13q0 1.152.688 1.537v.777q-.95 0-1.42-.27a1.53 1.53 0 0 1-.684-.886m-.147-3.295a5.7 5.7 0 0 0-1.03-.162q-1.177 0-1.922.607-.744.606-.744 1.428 0 1.367 1.61 1.367 1.18 0 2.086-1.12zm7.563-4.457v5.585q0 2.027 1.758 2.027a2.4 2.4 0 0 0 1.406-.441 2.13 2.13 0 0 0 .842-1.024V31.84h1.555v8.757h-1.555v-1.21q-.261.514-1.05.944c-.47.27-1 .419-1.542.43q-1.438 0-2.204-.826-.765-.825-.763-2.348V31.84zm10.745 1.228h-1.014v-1.228h1.014V30l1.553-.597v2.433h2.404v1.227h-2.404v4.35q0 1.1.373 1.57c.247.309.649.465 1.197.465a2.85 2.85 0 0 0 1.234-.304l.23 1.367a8.7 8.7 0 0 1-2.117.245 2.3 2.3 0 0 1-1.755-.773 2.76 2.76 0 0 1-.715-1.946zm7.688 3.132q0-2.03 1.091-3.276 1.091-1.247 2.876-1.247 1.881 0 2.918 1.198 1.038 1.199 1.038 3.325 0 2.108-1.062 3.338-1.062 1.231-2.893 1.223-1.876 0-2.919-1.234t-1.049-3.328m1.635 0q0 3.293 2.332 3.293a1.97 1.97 0 0 0 1.704-.882q.618-.882.616-2.411 0-3.255-2.32-3.255a2 2 0 0 0-1.698.866q-.633.869-.634 2.389m20.692 4.398v-5.542q0-2.07-1.784-2.07c-.38.002-.749.124-1.056.347a1.83 1.83 0 0 0-.669.79v6.475h-1.554V34.38a1.22 1.22 0 0 0-.486-1.018 2.07 2.07 0 0 0-1.288-.372 1.8 1.8 0 0 0-.994.36 2.2 2.2 0 0 0-.748.793v6.46h-1.553v-8.758h1.015l.514 1.014q.897-1.177 2.249-1.177 1.882 0 2.632 1.169a2 2 0 0 1 .973-.834 3.4 3.4 0 0 1 1.46-.335q1.353 0 2.1.81.746.811.744 2.261v5.854zm11.22-1.006q-.934 1.17-2.854 1.17a2.46 2.46 0 0 1-1.784-.75 2.5 2.5 0 0 1-.756-1.86q0-1.33 1.165-2.252 1.164-.923 2.972-.92c.38.01.756.083 1.112.215q0-2.128-1.897-2.126-1.46 0-2.241.785l-.649-1.298a3.8 3.8 0 0 1 1.223-.618c.48-.165.984-.252 1.492-.257q1.905 0 2.768.867.862.868.861 2.757v3.13q0 1.152.688 1.537v.777q-.949 0-1.418-.27a1.52 1.52 0 0 1-.682-.886m-.148-3.295a5.7 5.7 0 0 0-1.031-.162q-1.178 0-1.922.607-.744.606-.743 1.428 0 1.367 1.611 1.367 1.177 0 2.085-1.12zm6.897-3.229h-1.012v-1.228h1.012V30l1.555-.597v2.433h2.403v1.227h-2.403v4.35q0 1.1.371 1.57.373.464 1.198.465a2.9 2.9 0 0 0 1.235-.304l.228 1.367a8.6 8.6 0 0 1-2.113.248 2.3 2.3 0 0 1-1.753-.773 2.76 2.76 0 0 1-.717-1.946zm9.181 7.529v-7.448h-1.193v-1.31h2.756v8.758zm.85-12.068a.95.95 0 1 1-.013 1.9.95.95 0 0 1 .013-1.9m4.945 7.671q0-2.03 1.092-3.276 1.094-1.247 2.874-1.247 1.881 0 2.919 1.198 1.038 1.199 1.038 3.325 0 2.108-1.062 3.338-1.063 1.231-2.895 1.223-1.874 0-2.919-1.234-1.046-1.234-1.047-3.328m1.636 0q0 3.293 2.33 3.293a1.96 1.96 0 0 0 1.704-.882q.618-.882.618-2.411 0-3.255-2.322-3.255a2 2 0 0 0-1.696.866q-.634.869-.634 2.389m15.739 4.398v-5.094q0-1.398-.421-1.959-.423-.56-1.411-.56a2.3 2.3 0 0 0-1.113.325 2.46 2.46 0 0 0-.89.785v6.508h-1.555v-8.757h1.062l.487 1.135q.768-1.297 2.51-1.297 2.878 0 2.878 3.5v5.42z" }), /* @__PURE__ */ s.createElement("path", { fill: "#8DC63E", d: "M43.803 24q0-.958-.09-1.894l4.182-2.808a24 24 0 0 0-.832-3.128l-5.027-.341a20 20 0 0 0-1.894-3.284l2.212-4.511a24 24 0 0 0-2.293-2.295l-4.517 2.207a19.7 19.7 0 0 0-3.287-1.9l-.34-5.027A24 24 0 0 0 28.79.193L25.985 4.38a20 20 0 0 0-3.791 0L19.384.193a24 24 0 0 0-3.132.837l-.339 5.027a19.7 19.7 0 0 0-3.28 1.89l-4.51-2.208a24 24 0 0 0-2.295 2.295l2.22 4.511a20 20 0 0 0-1.9 3.284l-5.027.34a24 24 0 0 0-.834 3.129l4.179 2.804q-.092.934-.094 1.898c0 .642.034 1.27.094 1.896L.287 28.703a24 24 0 0 0 .834 3.131l5.027.34a19.7 19.7 0 0 0 1.9 3.275l-2.22 4.513a25 25 0 0 0 2.3 2.298l4.513-2.217a20 20 0 0 0 3.278 1.899l.34 5.027q1.534.524 3.126.838l2.809-4.185c.626.06 1.255.097 1.897.097s1.274-.037 1.897-.097l2.802 4.18q1.588-.312 3.12-.833l.34-5.027a20 20 0 0 0 3.288-1.899l4.511 2.217a24.5 24.5 0 0 0 2.293-2.293l-2.2-4.511a20 20 0 0 0 1.899-3.286l5.027-.339q.518-1.536.827-3.128l-4.186-2.807c.063-.626.094-1.247.094-1.896M24.088 38.825a14.824 14.824 0 1 1 .006-29.648 14.824 14.824 0 0 1-.006 29.648" }, /* @__PURE__ */ s.createElement("animateTransform", { attributeName: "transform", dur: 3, from: "0 24 24", repeatCount: "indefinite", to: "360 24 24", type: "rotate" })), /* @__PURE__ */ s.createElement("path", { fill: "#fff", d: "M33.454 24c0-1.223-5.25-9.123-5.25-9.123-.417-.719-1.757-.719-2.99 0-1.235.718-1.896 1.88-1.478 2.594l.584 1.006 1.621 2.825H15.313c-.832 0-1.505 1.208-1.508 2.698 0 1.49.676 2.7 1.508 2.698h10.635l-1.622 2.825-.584 1.006c-.418.72.244 1.882 1.478 2.594s2.573.715 2.99 0c0 0 5.25-7.9 5.25-9.123z" })), /* @__PURE__ */ s.createElement("defs", null, /* @__PURE__ */ s.createElement("clipPath", { id: "brand-animated_svg__a" }, /* @__PURE__ */ s.createElement("path", { fill: "#fff", d: "M.25 0h169.5v48H.25z" })))), o7 = X.create(({ theme: e }) => ({
  root: {
    position: "absolute",
    inset: 0,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "grid",
    placeItems: "center"
  },
  brand: {
    width: 340,
    height: 96,
    [e.breakpoints.down(1536)]: {
      width: 170,
      height: 48
    }
  }
})), a7 = (e) => `${e}img/authentication_bg.jpg`, ko = ({ baseAssetUrl: e }) => {
  const { classes: t } = o7();
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      className: t.root,
      style: {
        backgroundImage: `url(${a7(e)})`
      },
      children: /* @__PURE__ */ r.jsx(n7, { className: t.brand })
    }
  );
}, X2 = R()((e) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%"
  },
  rootScrollView: {
    maxHeight: "calc(100vh - 4.5rem)",
    [e.breakpoints.down("sm")]: {
      maxHeight: "calc(100vh - 3.5rem)"
    }
  },
  content: {
    margin: "0 auto 3.5rem auto",
    padding: "0 1.5rem 0 1.5rem",
    maxWidth: "calc(min(48rem, 100%))"
  },
  contentFullWidth: {
    [e.breakpoints.up(720)]: {
      minWidth: "calc(min(48rem, 100%))"
    },
    [e.breakpoints.down(720)]: {
      width: "100%"
    }
  },
  topPadding: {
    paddingTop: "3.5rem",
    [e.breakpoints.down(k1)]: {
      paddingTop: "2rem"
    }
  },
  divider: {
    margin: "3.5rem 0",
    [e.breakpoints.down(k1)]: {
      margin: "2rem 0"
    }
  },
  alert: {
    paddingBottom: "3.5rem"
  },
  hideForPrint: {
    "@media print": {
      display: "none"
    }
  }
})), i7 = R()((e) => ({
  section: {
    scrollMarginTop: "1rem"
  },
  heading: {
    ...e.typography.h1,
    color: e.palette.brand["ia-gray"]
  },
  headingContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.375rem",
    marginBottom: "0.25rem"
  }
})), Gp = ({
  result: e,
  endpointUrl: t
}) => window.dispatchEvent(
  new CustomEvent("base-api-error", {
    detail: {
      ...e,
      url: t
    }
  })
), l7 = (e) => e.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9\s-]/g, "").replace(/[\s-]+/g, "-").replace(/^-+|-+$/g, ""), s7 = ({
  heading: e,
  accessIcon: t,
  headingLevel: n = "h2",
  description: o,
  gap: a = "2rem",
  children: i,
  id: l
}) => {
  const { hash: c } = V0(), d = Z(null), { classes: u } = i7(), p = !!e, m = !!o, g = Array.isArray(o) ? o : [o], h = l || (e ? l7(e.toString()) : void 0);
  return K(() => {
    c === `#${h}` && d.current && setTimeout(() => {
      var C;
      (C = d.current) == null || C.scrollIntoView({ behavior: "smooth" });
    }, 500);
  }, [c, h]), /* @__PURE__ */ r.jsxs(Le, { gap: a, ref: d, id: h, className: u.section, children: [
    p || m ? /* @__PURE__ */ r.jsxs("div", { children: [
      p ? /* @__PURE__ */ r.jsxs("div", { className: u.headingContainer, children: [
        /* @__PURE__ */ r.jsx(W, { component: n, className: u.heading, children: e }),
        t && /* @__PURE__ */ r.jsx(Zt, { name: t.name })
      ] }) : null,
      m ? g.map((C, v) => /* @__PURE__ */ r.jsx(W, { variant: "body1", children: C }, v)) : null
    ] }) : null,
    i
  ] });
}, c7 = X.create(({ theme: e }) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem"
  },
  welcomeBlock: {
    maxWidth: "32rem"
  },
  welcomeLabel: {
    color: e.palette.text.secondary,
    letterSpacing: "0.08em"
  },
  widget: {
    width: "100%"
  }
})), d7 = X.create(({ theme: e }) => ({
  heading: {
    ...e.typography.h1,
    color: e.palette.brand["ia-gray"],
    marginBottom: "0.25rem"
  }
})), u7 = () => {
  const { classes: e } = c7();
  return /* @__PURE__ */ r.jsxs("div", { "data-testid": "loading-skeleton", className: e.root, children: [
    /* @__PURE__ */ r.jsxs(Le, { gap: "0.75rem", className: e.welcomeBlock, children: [
      /* @__PURE__ */ r.jsx(W, { variant: "overline", className: e.welcomeLabel, children: "WELCOME BACK," }),
      /* @__PURE__ */ r.jsx(me, { variant: "rounded", height: 24, width: "40%" }),
      /* @__PURE__ */ r.jsx(me, { variant: "rounded", height: 16, width: "25%" })
    ] }),
    /* @__PURE__ */ r.jsx(me, { variant: "rounded", height: 220, className: e.widget })
  ] });
}, p7 = 2, m7 = 24, h7 = 3, g7 = 72, C7 = () => /* @__PURE__ */ r.jsxs(Le, { gap: "0.5rem", "data-testid": "loading-skeleton", children: [
  Array.from({ length: p7 }, (e, t) => /* @__PURE__ */ r.jsx(
    me,
    {
      variant: "rounded",
      height: m7
    },
    `data-grid-loading-header-${t}`
  )),
  Array.from({ length: h7 }, (e, t) => /* @__PURE__ */ r.jsx(
    me,
    {
      variant: "rounded",
      height: g7
    },
    `data-grid-loading-row-${t}`
  ))
] }), v7 = 3, f7 = ({
  sections: e = []
}) => {
  const { classes: t } = d7(), { classes: n } = X2();
  return /* @__PURE__ */ r.jsx("div", { "data-testid": "loading-skeleton", children: e.map((o, a) => {
    const i = o.fieldCount ?? v7, l = Array.isArray(o.description) ? o.description : [o.description], c = a === e.length - 1;
    return /* @__PURE__ */ r.jsxs(j2, { children: [
      /* @__PURE__ */ r.jsxs(Le, { gap: o.gap ?? "2rem", children: [
        (o.heading || o.description) && /* @__PURE__ */ r.jsxs("div", { children: [
          o.heading ? /* @__PURE__ */ r.jsx(
            W,
            {
              component: o.headingLevel ?? "h2",
              className: t.heading,
              children: o.heading
            }
          ) : null,
          o.description ? l.map((d, u) => /* @__PURE__ */ r.jsx(W, { variant: "body1", children: d }, u)) : null
        ] }),
        o.loadingVariant === "basic_data_grid" ? /* @__PURE__ */ r.jsx(wo, { count: i }) : o.loadingVariant === "card_group" ? /* @__PURE__ */ r.jsx(yo, { count: i }) : /* @__PURE__ */ r.jsx(W2, { count: i })
      ] }),
      c ? null : /* @__PURE__ */ r.jsx(Ce, { className: n.divider })
    ] }, o.heading || `content-page-loading-${a}`);
  }) });
}, x7 = ({
  children: e,
  className: t
}) => {
  const { cx: n, classes: o } = X2(), { withinScrollView: a } = $1(Wn);
  return a ? /* @__PURE__ */ r.jsx("div", { className: o.root, children: e }) : /* @__PURE__ */ r.jsx(ue, { className: n(o.root, o.rootScrollView, t), children: e });
}, b7 = (e, t) => {
  switch (e) {
    case "dashboard":
      return /* @__PURE__ */ r.jsx(u7, {});
    case "data_grid":
      return /* @__PURE__ */ r.jsx(C7, {});
    case "content_page":
      return /* @__PURE__ */ r.jsx(f7, { sections: t });
  }
}, Kp = ({
  itemBannerProps: e,
  sections: t,
  fullWidth: n = !1,
  alertProps: o,
  children: a,
  className: i,
  layout: l,
  isLoading: c = !1
}) => {
  const { cx: d, classes: u } = X2(), p = c && !!l;
  return /* @__PURE__ */ r.jsxs(x7, { className: i, children: [
    e ? /* @__PURE__ */ r.jsx(Q9, { ...e }) : /* @__PURE__ */ r.jsx("div", { className: u.topPadding }),
    /* @__PURE__ */ r.jsxs(
      jt,
      {
        className: d(u.content, {
          [u.contentFullWidth]: n
        }),
        children: [
          !!o && /* @__PURE__ */ r.jsx("div", { className: u.alert, children: /* @__PURE__ */ r.jsx(Ke, { ...o }) }),
          p ? b7(l, t) : t == null ? void 0 : t.map((m, g) => /* @__PURE__ */ r.jsxs(j2, { children: [
            /* @__PURE__ */ r.jsx(s7, { ...m }),
            g !== t.length - 1 ? /* @__PURE__ */ r.jsx(Ce, { className: u.divider }) : null
          ] }, m.heading))
        ]
      }
    ),
    !p && a
  ] });
}, w7 = 6, Yp = () => $2(w7), y7 = R()(
  (e, { sidebarBackground: t }) => ({
    root: {
      background: x["neutral-20"],
      display: "flex",
      minHeight: "100vh",
      [e.breakpoints.down(768)]: {
        flexDirection: "column"
      }
    },
    contentRoot: {
      margin: "13rem auto 13rem auto",
      padding: "0 3.5rem 0 3.5rem",
      width: "48rem",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "2rem",
      maxWidth: "100%",
      [e.breakpoints.down(768)]: {
        alignItems: "center",
        margin: "3.5rem auto 0rem auto",
        padding: "3.5rem 1.5rem 3.5rem 1.5rem"
      },
      [e.breakpoints.down(480)]: {
        marginTop: "2rem"
      }
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5rem",
      width: "100%"
    },
    headlineContainer: {
      textAlign: "left",
      [e.breakpoints.down(768)]: {
        textAlign: "center"
      }
    },
    headline: {
      ...e.typography.h1Title,
      color: x["brand-ia-gray"]
    },
    headlineIcon: {
      height: "1rem",
      width: "1rem",
      position: "relative",
      top: "0.125rem"
    },
    headlineTooltip: {
      display: "inline-block"
    },
    supportingText: {
      marginTop: "1rem"
    },
    supplementalButton: {
      paddingTop: "1.5rem"
    },
    helperText: {
      ...e.typography.body3
    },
    supplementalText: {
      ...e.typography.subtitle,
      color: x["neutral-60"]
    },
    sidebar: {
      backgroundColor: x["brand-ia-gray"],
      background: `url(${t}) no-repeat`,
      objectFit: "contain",
      backgroundSize: "cover",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      position: "fixed",
      top: 0,
      [e.breakpoints.down(768)]: {
        background: "none",
        backgroundColor: x["brand-ia-gray"],
        width: "100%",
        justifyContent: "flex-start",
        height: "3.5rem",
        zIndex: M2
      }
    },
    sidebarRoot: {
      width: "26.5rem",
      minWidth: "14rem",
      display: "flex",
      position: "relative",
      backgroundColor: x["brand-ia-gray"],
      [e.breakpoints.down(768)]: {
        width: "100% !important"
      }
    },
    brand: {
      height: "3.5rem",
      width: "100%",
      [e.breakpoints.down(1536)]: {
        height: "3rem"
      },
      [e.breakpoints.down(768)]: {
        height: "2rem",
        width: "unset",
        marginLeft: "1rem"
      }
    }
  })
), k7 = X.withParams().create(({ theme: e, actionsLayout: t }) => ({
  actions: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
    justifyContent: t === "space_between" ? "space-between" : "flex-start",
    [e.breakpoints.down(768)]: {
      width: "100%",
      justifyContent: "center",
      flexDirection: t === "space_between" ? "column-reverse" : "column",
      button: {
        width: "100%"
      }
    }
  },
  actionsRight: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
    [e.breakpoints.down(768)]: {
      width: "100%",
      justifyContent: "center",
      flexDirection: "column",
      button: {
        width: "100%"
      }
    }
  },
  textButton: {
    marginLeft: "0.5rem",
    [e.breakpoints.down(768)]: {
      marginLeft: 0,
      marginTop: "0.5rem",
      width: "fit-content !important",
      display: t === "space_between" ? "none" : void 0
    }
  },
  textButtonBottom: {
    display: "none",
    [e.breakpoints.down(768)]: {
      marginTop: "0.5rem",
      display: t === "space_between" ? "block" : "none"
    }
  }
})), O1 = (e) => /* @__PURE__ */ e1(
  G,
  {
    ...e,
    key: e.id,
    testId: e.testId ?? e.id,
    disabled: e.disabled ?? !1,
    className: e.className
  }
), j7 = ({
  actions: e = [],
  actionsLayout: t
}) => {
  const { classes: n } = k7({ actionsLayout: t });
  if (!e.length) return null;
  if (t === "left_aligned")
    return /* @__PURE__ */ r.jsx("div", { className: n.actions, children: e.map((c) => /* @__PURE__ */ e1(
      O1,
      {
        ...c,
        key: c.id,
        className: c.buttonVariant === "textSecondary" ? n.textButton : ""
      }
    )) });
  const o = (c) => e.find((d) => d.buttonVariant === c), a = o("secondary"), i = o("textSecondary"), l = o("primary");
  return /* @__PURE__ */ r.jsxs("div", { className: n.actions, children: [
    i ? /* @__PURE__ */ r.jsx(O1, { ...i, className: n.textButtonBottom }) : null,
    a ? /* @__PURE__ */ r.jsx(O1, { ...a }) : null,
    /* @__PURE__ */ r.jsxs("div", { className: n.actionsRight, children: [
      i ? /* @__PURE__ */ r.jsx(O1, { ...i, className: n.textButton }) : null,
      l ? /* @__PURE__ */ r.jsx(O1, { ...l }) : null
    ] })
  ] });
}, jo = [
  "sidebarbg1.png",
  "sidebarbg2.png",
  "sidebarbg3.png",
  "sidebarbg4.png",
  "sidebarbg5.png",
  "sidebarbg6.png"
], S7 = (e, t) => `${e}img/${jo[t]}`, L7 = (e, t) => S7(e, t ?? $2(jo.length)), So = ({
  children: e,
  heading: t,
  overline: n,
  headlineTooltip: o,
  supportingText: a,
  alertProps: i,
  listHeaderProps: l,
  testId: c,
  helperText: d,
  actions: u = [],
  actionsLayout: p = "left_aligned",
  supplementalText: m,
  supplementalButton: g,
  sidebarImage: h
}) => {
  const { baseAssetUrl: C } = Q(), [v] = V(
    L7(C, h)
  ), { classes: b } = y7({
    sidebarBackground: v
  }), f = Z(null), [y, w] = V(0);
  K(() => {
    const M = () => {
      f.current && w(f.current.offsetWidth);
    };
    return M(), window.addEventListener("resize", M), () => window.removeEventListener("resize", M);
  }, [f]);
  const k = !!e || !!i || !!l;
  return /* @__PURE__ */ r.jsxs("div", { className: b.root, children: [
    /* @__PURE__ */ r.jsx("div", { className: b.sidebarRoot, ref: f, children: /* @__PURE__ */ r.jsx("div", { className: b.sidebar, style: { width: y }, children: /* @__PURE__ */ r.jsx(te, { name: "inductive-automation", className: b.brand }) }) }),
    /* @__PURE__ */ r.jsxs("div", { className: b.contentRoot, "data-testid": c, children: [
      n || t || a ? /* @__PURE__ */ r.jsxs("div", { className: b.headlineContainer, children: [
        n && /* @__PURE__ */ r.jsx(W, { variant: "overline", children: n }),
        /* @__PURE__ */ r.jsxs(W, { variant: "h1", className: b.headline, children: [
          t,
          " ",
          o && /* @__PURE__ */ r.jsx("div", { className: b.headlineTooltip, children: /* @__PURE__ */ r.jsx(
            he,
            {
              size: "large",
              testId: `${c}-headline-tooltip`,
              title: o,
              children: /* @__PURE__ */ r.jsx(
                te,
                {
                  name: "inverted-info",
                  className: b.headlineIcon
                }
              )
            }
          ) })
        ] }),
        a && /* @__PURE__ */ r.jsx(W, { className: b.supportingText, variant: "body1", children: a })
      ] }) : null,
      k && /* @__PURE__ */ r.jsxs("div", { className: b.content, children: [
        i && /* @__PURE__ */ r.jsx(Ke, { ...i }),
        l && /* @__PURE__ */ r.jsx(T1, { ...l }),
        e
      ] }),
      d && /* @__PURE__ */ r.jsx(W, { component: "div", className: b.helperText, children: d }),
      /* @__PURE__ */ r.jsx(j7, { actions: u, actionsLayout: p }),
      m && /* @__PURE__ */ r.jsx(
        W,
        {
          variant: "subtitle1",
          component: "p",
          className: b.supplementalText,
          children: m
        }
      ),
      g && /* @__PURE__ */ r.jsx("div", { className: b.supplementalButton, children: /* @__PURE__ */ r.jsx(
        G,
        {
          buttonVariant: "text",
          size: "small",
          id: g.id,
          label: g.label,
          testId: g.testId,
          onClick: g.onClick
        }
      ) })
    ] })
  ] });
}, Qp = (e) => {
  const { onScroll: t, ref: n, ...o } = e, a = (i) => {
    const l = i.elements().viewport;
    return l.addEventListener("scroll", t), () => l.removeEventListener("scroll", t);
  };
  return /* @__PURE__ */ r.jsx(
    ue,
    {
      onInitialized: a,
      ref: (i) => {
        typeof n == "function" ? n((i == null ? void 0 : i.getElement()) ?? null) : n && (n.current = (i == null ? void 0 : i.getElement()) ?? null);
      },
      ...o,
      style: {
        ...o.style,
        borderRadius: "0.25rem"
      }
    }
  );
}, Xp = (e) => {
  const t = Z(null);
  return K(() => {
    var n, o, a;
    (a = (o = (n = t.current) == null ? void 0 : n.getElement()) == null ? void 0 : o.querySelector("[data-overlayscrollbars-contents]")) == null || a.scrollTo({ top: 0 });
  }, [e]), t;
}, M7 = (e, t) => {
  const n = e.toLowerCase().indexOf(t.toLowerCase());
  if (n === -1) return { pre: e, match: "", post: "" };
  const o = e.substring(0, n), a = e.substring(n, n + t.length), i = e.substring(n + t.length);
  return {
    pre: o,
    match: a,
    post: i
  };
}, E7 = X.create(({ theme: e }) => ({
  searchMatch: {
    display: "inline-block",
    backgroundColor: e.palette.warning[10],
    boxShadow: `inset 0 0 0 1px ${e.palette.warning["60-key"]}`,
    borderRadius: "0.25rem"
  },
  searchNonMatch: {
    position: "relative",
    zIndex: 10
  },
  blankSpace: {
    opacity: 0
  }
})), $t = ({ value: e, query: t }) => {
  const { classes: n } = E7(), { pre: o, match: a, post: i } = M7(e, t);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("span", { className: n.searchNonMatch, children: o }),
    a ? /* @__PURE__ */ r.jsx("span", { className: n.searchMatch, children: a.endsWith(" ") ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      a.substring(0, a.length - 1),
      /* @__PURE__ */ r.jsx("span", { className: n.blankSpace, children: "l" })
    ] }) : a }) : null,
    /* @__PURE__ */ r.jsx("span", { className: n.searchNonMatch, children: i })
  ] });
}, N7 = R()((e) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    [e.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  leftContent: {
    display: "flex",
    flexDirection: "column",
    padding: "1.5rem",
    gap: "0.5rem",
    alignItems: "center",
    justifyContent: "center",
    borderRight: `1px solid ${e.palette.neutral[30]}`,
    [e.breakpoints.down("sm")]: {
      borderRight: 0,
      borderBottom: `1px solid ${e.palette.neutral[30]}`
    }
  },
  leftContentOnly: {
    flex: 1,
    borderRight: 0,
    [e.breakpoints.down("sm")]: {
      borderRight: 0,
      borderBottom: 0
    }
  },
  rightContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }
})), Jp = ({
  leftContent: e,
  rightContent: t,
  useOnlyLeftContent: n = !1,
  ...o
}) => {
  const { cx: a, classes: i } = N7();
  return /* @__PURE__ */ r.jsx(No, { ...o, scrollableContent: !1, children: /* @__PURE__ */ r.jsxs("div", { className: i.container, children: [
    e ? /* @__PURE__ */ r.jsx(
      "div",
      {
        className: a(i.leftContent, {
          [i.leftContentOnly]: n
        }),
        children: e
      }
    ) : null,
    !n && /* @__PURE__ */ r.jsx("div", { className: i.rightContent, children: t })
  ] }) });
}, I7 = (e, t) => Math.max(e, t.activity.length), $7 = (e) => e.reduce((t, n) => {
  const o = L1(n.date);
  return o > t ? o : t;
}, 1), _7 = (e, t) => {
  const n = $7(e);
  return t === n ? e.find(
    (o) => L1(o.date) === 1 && We(o.date) === 0 && y2(o.date) === 11
  ) : e.find(
    (o) => L1(o.date) === t + 1 && We(o.date) === 0
  );
}, Ct = (e, t) => {
  const n = e.filter(
    (a) => L1(a.date) === t && We(a.date) !== 0
  ), o = _7(e, t);
  return je.compact([...n, o]);
}, qt = ["#F4F4F4", "#DBE9EF", "#C9DEE6", "#80B1C6", "#4A90AD"], V7 = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
], A7 = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], B7 = X.create({
  scrollView: { marginBottom: "-1rem", borderRadius: "0.25rem" },
  heatMapContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "1rem"
  },
  headerAndDateColumns: {
    display: "flex",
    flexDirection: "column"
  },
  dateColumns: {
    display: "flex",
    flexDirection: "row"
  }
}), Lo = X.create({
  root: {
    display: "flex",
    flexDirection: "column"
  }
}), J2 = X.withParams().create(({ theme: e, level: t }) => {
  const n = {
    border: `2px solid ${e.palette.primary[t === 5 ? "70" : "60-key"]}`,
    cursor: "pointer",
    outline: "none"
  };
  return {
    cell: {
      borderBottomWidth: 0,
      padding: "2px !important"
    },
    coloredSquare: {
      width: "1rem",
      height: "1rem",
      borderRadius: "0.25rem",
      border: 0,
      // NOTE: (2024-11-20) Noah Settersten => This is necessary to consistently size the activity days on iOS Safari.
      padding: 0,
      display: "grid",
      placeItems: "center",
      "&:hover": t === 1 ? {} : n,
      "&:focus-visible": n
    },
    coloredSquareSelected: {
      border: `2px solid ${e.palette.primary[t === 5 ? "70" : "60-key"]}`
    }
  };
}), H7 = X.create(({ theme: e }) => ({
  weekdayColumn: {
    display: "flex",
    flexDirection: "column",
    position: "sticky",
    left: 0,
    top: 1
  },
  topSpacer: {
    background: e.palette.neutral.white,
    height: "2.375rem"
  },
  weekdayCell: {
    background: e.palette.neutral.white,
    display: "grid",
    placeItems: "center",
    padding: "2px 1rem 2px 1rem !important",
    boxSizing: "content-box",
    width: "1rem",
    height: "1rem"
  }
})), D7 = X.create({
  root: {
    display: "flex",
    flexDirection: "row",
    paddingTop: "1rem",
    paddingBottom: "0.5rem"
  },
  monthHeader: {
    display: "inline-flex",
    paddingLeft: "4px !important"
  }
}), T7 = X.create({
  legend: {
    display: "flex",
    gap: "0.5rem",
    marginTop: "1rem",
    marginBottom: "1rem",
    justifyContent: "center"
  },
  legendColors: {
    display: "flex",
    gap: "0.25rem"
  },
  legendColorSwatch: {
    width: "1rem",
    height: "1rem",
    borderRadius: "0.25rem"
  }
}), R7 = [5, 4, 5, 4, 4, 5, 4, 5, 4, 4, 5, 4], F7 = [6, 4, 4, 4, 5, 4, 4, 5, 4, 5, 4, 4], z7 = [6, 4, 4, 4, 5, 4, 5, 4, 4, 5, 4, 4], W7 = (e) => e === 0 ? z7 : e === 6 ? F7 : R7, Rr = 4, O7 = (e, t) => 18 * (e[t] ?? Rr) + 2 * (e[t] ?? Rr), Z7 = ({ startingDayOfYear: e }) => {
  const { classes: t } = D7(), n = W7(e);
  return /* @__PURE__ */ r.jsx("div", { className: t.root, children: V7.map((o, a) => /* @__PURE__ */ r.jsx(
    "span",
    {
      className: t.monthHeader,
      style: {
        minWidth: O7(n, a)
      },
      children: /* @__PURE__ */ r.jsx(W, { variant: "overline", children: o })
    },
    `month-header-${o}`
  )) });
}, P7 = () => {
  const { classes: e } = T7();
  return /* @__PURE__ */ r.jsxs("div", { className: e.legend, children: [
    /* @__PURE__ */ r.jsx(W, { variant: "subtitle1", children: "Less" }),
    /* @__PURE__ */ r.jsx("div", { className: e.legendColors, children: qt.map((t) => /* @__PURE__ */ r.jsx(
      "div",
      {
        className: e.legendColorSwatch,
        style: {
          backgroundColor: t
        }
      },
      `activity-legend-${t}`
    )) }),
    /* @__PURE__ */ r.jsx(W, { variant: "subtitle1", children: "More" })
  ] });
}, q7 = ["M", "T", "W", "R", "F", "S", "S"], U7 = () => {
  const { classes: e } = H7();
  return /* @__PURE__ */ r.jsxs("div", { className: e.weekdayColumn, children: [
    /* @__PURE__ */ r.jsx("div", { className: e.topSpacer }),
    q7.map((t, n) => /* @__PURE__ */ r.jsx(
      "div",
      {
        className: e.weekdayCell,
        children: /* @__PURE__ */ r.jsx(W, { variant: "overline", component: "p", children: t })
      },
      `activity-weekday-${t}-${n}`
    ))
  ] });
}, Mo = (e) => Xe(e, "yyyy-MM-dd"), G7 = (e) => {
  const [, t] = e.split("--");
  return t ? t0(t, "yyyy-MM-dd", /* @__PURE__ */ new Date()) : /* @__PURE__ */ new Date();
}, K7 = (e, t) => {
  if (t === "ArrowUp")
    return We(e) === 1 ? void 0 : r0(e, 1);
  if (t === "ArrowRight")
    return L1(e) === 52 ? void 0 : n0(e, 1);
  if (t === "ArrowDown")
    return We(e) === 0 ? void 0 : o0(e, 1);
  if (t === "ArrowLeft")
    return L1(e) === 1 ? void 0 : a0(e, 1);
}, Y7 = ({
  idPrefix: e,
  testIdPrefix: t,
  datum: { date: n, activity: o },
  bucketSize: a,
  selectedDate: i,
  setSelectedDate: l
}) => {
  const c = o.length, d = `${c} - ${A7[y2(n)]} ${i0(n)}`, u = Math.floor(c / a), p = qt[u], m = i ? Jr(n, i) : !1, g = Mo(n), { cx: h, classes: C } = J2({
    level: u + 1
  }), v = /* @__PURE__ */ r.jsx(
    "button",
    {
      id: `${e}-day--${g}`,
      "data-testid": `${t}-day--${g}`,
      "aria-label": d,
      onClick: () => {
        l(n);
      },
      className: h(C.coloredSquare, {
        [C.coloredSquareSelected]: m
      }),
      style: { backgroundColor: p }
    }
  );
  return u === 0 ? /* @__PURE__ */ r.jsx("div", { className: C.cell, children: v }) : /* @__PURE__ */ r.jsx("div", { className: C.cell, children: /* @__PURE__ */ r.jsx(he, { testId: "heat-map-day-tooltip", title: d, delayOverride: 0, children: v }) });
}, vt = ({
  idPrefix: e,
  testIdPrefix: t,
  data: n,
  bucketSize: o,
  selectedDate: a,
  setSelectedDate: i
}) => {
  const { classes: l } = Lo(), { classes: c } = J2({ level: 1 }), d = [
    n.find((u) => We(u.date) === 1),
    n.find((u) => We(u.date) === 2),
    n.find((u) => We(u.date) === 3),
    n.find((u) => We(u.date) === 4),
    n.find((u) => We(u.date) === 5),
    n.find((u) => We(u.date) === 6),
    n.find((u) => We(u.date) === 0)
  ];
  return d.every((u) => u === void 0) ? null : /* @__PURE__ */ r.jsx("div", { className: l.root, children: d.map(
    (u, p) => u ? /* @__PURE__ */ r.jsx(
      Y7,
      {
        idPrefix: e,
        testIdPrefix: t,
        datum: u,
        bucketSize: o,
        selectedDate: a,
        setSelectedDate: i
      },
      `activity-day-${u.date.toString()}`
    ) : /* @__PURE__ */ r.jsx("div", { className: c.cell, children: /* @__PURE__ */ r.jsx(
      "div",
      {
        className: c.coloredSquare,
        style: { backgroundColor: qt[0] }
      }
    ) }, `activity-day-${p}`)
  ) });
}, Q7 = () => {
  const { classes: e } = Lo(), { classes: t } = J2({ level: 1 });
  return /* @__PURE__ */ r.jsx("div", { className: e.root, children: Array.from({ length: 7 }, (n, o) => /* @__PURE__ */ r.jsx("div", { className: t.cell, children: /* @__PURE__ */ r.jsx("div", { className: t.coloredSquare }) }, `empty-column-${o}`)) });
}, X7 = (e, t) => ({ onKeyDown: (o) => {
  var d;
  const a = document.activeElement.id, i = G7(a), l = K7(i, o.key);
  if (!l) return;
  const c = `#${e}-day--${Mo(l)}`;
  (d = document.querySelector(c)) == null || d.focus(), t(l), o.stopPropagation(), o.preventDefault();
} }), em = ({
  id: e,
  testId: t = e,
  data: n,
  selectedDate: o,
  setSelectedDate: a
}) => {
  const { classes: i } = B7(), d = (n.reduce(I7, 0) - 0 + 1) / qt.length, u = (g) => ({
    idPrefix: e,
    testIdPrefix: t,
    data: Ct(n, g),
    bucketSize: d,
    selectedDate: o,
    setSelectedDate: a
  }), { onKeyDown: p } = X7(e, a);
  if (!n[0]) return null;
  const m = We(n[0].date);
  return /* @__PURE__ */ r.jsxs("div", { id: e, "data-testid": t, children: [
    /* @__PURE__ */ r.jsxs("div", { className: i.heatMapContainer, children: [
      /* @__PURE__ */ r.jsx(U7, {}),
      /* @__PURE__ */ r.jsx(ue, { className: i.scrollView, children: /* @__PURE__ */ r.jsxs("div", { className: i.headerAndDateColumns, children: [
        /* @__PURE__ */ r.jsx(Z7, { startingDayOfYear: m }),
        /* @__PURE__ */ r.jsxs("div", { className: i.dateColumns, onKeyDown: p, children: [
          /* @__PURE__ */ r.jsx(
            vt,
            {
              ...u(0),
              data: Ct(n, 0).filter(
                (g) => g.date.getMonth() === 0
              )
            }
          ),
          /* @__PURE__ */ r.jsx(
            vt,
            {
              ...u(1),
              data: Ct(n, 1).filter(
                (g) => g.date.getMonth() === 0
              )
            }
          ),
          Array.from({ length: 52 }, (g, h) => /* @__PURE__ */ r.jsx(
            vt,
            {
              ...u(h + 2)
            },
            `activity-column-${h + 2}`
          )),
          /* @__PURE__ */ r.jsx(
            vt,
            {
              ...u(1),
              data: Ct(n, 1).filter(
                (g) => g.date.getMonth() === 11
              )
            }
          ),
          /* @__PURE__ */ r.jsx(Q7, {})
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ r.jsx(P7, {})
  ] });
}, J7 = X.create(({ theme: e }) => ({
  root: {
    margin: "1.375rem 3rem"
  },
  container: {
    position: "relative",
    width: "9rem",
    height: "9rem"
  },
  circle: {
    position: "absolute",
    inset: 0,
    borderRadius: "0.5rem",
    "svg > circle": {
      strokeLinecap: "round"
    }
  },
  empty: {
    color: e.palette.neutral[20]
  },
  filled: {
    color: e.palette.primary["60-key"]
  },
  textContainer: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    justifyContent: "center",
    alignItems: "center"
  },
  label: {
    ...e.typography.caps,
    maxWidth: "5rem",
    textAlign: "center"
  }
})), tm = ({ label: e, value: t }) => {
  const { cx: n, classes: o } = J7(), a = (i, l, c) => /* @__PURE__ */ r.jsx("div", { className: n(o.circle, l), children: /* @__PURE__ */ r.jsx(
    qr,
    {
      title: `${e}-${i}`,
      variant: "determinate",
      value: c,
      size: "9rem",
      color: "inherit",
      thickness: 2.4
    }
  ) });
  return /* @__PURE__ */ r.jsx("div", { className: o.root, children: /* @__PURE__ */ r.jsxs("div", { className: o.container, children: [
    a("empty", o.empty, 100),
    a("filled", o.filled, t),
    /* @__PURE__ */ r.jsxs("div", { className: o.textContainer, children: [
      /* @__PURE__ */ r.jsx(W, { className: o.label, children: e }),
      /* @__PURE__ */ r.jsx(W, { variant: "h1", component: "p", children: t })
    ] })
  ] }) });
}, ed = X.withParams().create(({ theme: e, width: t }) => ({
  root: {
    padding: "1.5rem 2rem 1.5rem 2rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  },
  labelContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  label: {
    color: e.palette.neutral[80]
  },
  barContainer: {
    backgroundColor: e.palette.neutral[30],
    height: "0.5rem",
    borderRadius: "0.25rem"
  },
  barFilled: {
    backgroundColor: e.palette.primary["60-key"],
    width: `${t}%`,
    height: "100%",
    borderRadius: "0.25rem"
  }
})), td = ({
  value: e,
  minimum: t = 0,
  maximum: n
}) => {
  const o = n - t, i = l0(e, t, n) - t;
  return i === 0 ? 0 : i / o * 100;
}, rm = ({
  label: e,
  value: t,
  minimum: n,
  maximum: o
}) => {
  const a = td({ value: t, minimum: n, maximum: o }), { classes: i } = ed({ width: a });
  return /* @__PURE__ */ r.jsxs("div", { className: i.root, children: [
    /* @__PURE__ */ r.jsxs("div", { className: i.labelContainer, children: [
      /* @__PURE__ */ r.jsx(W, { variant: "overline", className: i.label, children: e }),
      /* @__PURE__ */ r.jsx(W, { variant: "overline", className: i.label, children: t })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: i.barContainer, children: /* @__PURE__ */ r.jsx("div", { className: i.barFilled }) })
  ] });
}, rd = X.create(({ theme: e }) => ({
  graph: {
    borderBottom: `1px solid ${e.palette.neutral[30]}`,
    padding: "1rem"
  },
  axisLabel: {
    tspan: {
      ...e.typography.overline,
      fill: `${e.palette.neutral[70]} !important`
    }
  }
})), nm = ({ xAxis: e, yAxis: t, series: n }) => {
  const { classes: o } = rd(), a = Ve();
  return /* @__PURE__ */ r.jsx("div", { className: o.graph, children: /* @__PURE__ */ r.jsx(
    s0,
    {
      margin: {
        top: 20,
        right: 20,
        bottom: 20,
        left: 20
      },
      xAxis: e.map(({ min: i, data: l, tickMinStep: c }) => ({
        min: i ?? 1,
        data: l,
        tickMinStep: c ?? 2,
        disableLine: !0,
        disableTicks: !0
      })),
      yAxis: t.map(({ min: i, tickMinStep: l }) => ({
        min: i ?? 1,
        tickMinStep: l ?? 1,
        disableLine: !0,
        disableTicks: !0
      })),
      series: n.map(({ data: i }) => ({
        data: i,
        color: a.palette.primary["60-key"],
        showMark: !1
      })),
      height: 160,
      slotProps: {
        axisTickLabel: {
          className: o.axisLabel
        }
      }
    }
  ) });
}, Eo = X.create({
  root: {
    position: "relative",
    width: "144px",
    height: "144px"
  },
  centered: {
    position: "absolute",
    inset: 0,
    display: "grid",
    placeItems: "center"
  },
  tooltip: {
    opacity: "90%",
    position: "relative",
    top: 10,
    left: 10
  }
}), nd = (e) => {
  const { classes: t } = oo({ size: "small" }), { cx: n, classes: o } = Eo(), { series: a, itemData: i } = e, l = a.data[i.dataIndex], c = `${l == null ? void 0 : l.value} ${l == null ? void 0 : l.label}`;
  return /* @__PURE__ */ r.jsx("div", { className: n(t.tooltip, o.tooltip), children: c });
}, od = ({ testId: e, data: t = [] }) => {
  const { classes: n } = Eo(), o = t.reduce((a, i) => a + i.value, 0);
  return /* @__PURE__ */ r.jsxs("div", { className: n.root, children: [
    /* @__PURE__ */ r.jsx("div", { className: n.centered, children: /* @__PURE__ */ r.jsx(W, { variant: "h3", "data-testid": `${e}-total-value`, children: o }) }),
    /* @__PURE__ */ r.jsx("div", { className: n.centered, children: /* @__PURE__ */ r.jsx(
      c0,
      {
        margin: { top: 24, right: 24, bottom: 24, left: 24 },
        slotProps: { legend: { hidden: !0 } },
        slots: { itemContent: nd },
        series: [
          {
            data: t,
            innerRadius: "80%",
            cornerRadius: 16,
            highlightScope: { highlight: "item" },
            highlighted: { innerRadius: 36, additionalRadius: 1 }
          }
        ]
      }
    ) })
  ] });
}, x1 = 476, ad = X.withParams().create(({ theme: e, variant: t, spacing: n, disabled: o }) => ({
  root: {
    backgroundColor: e.palette.neutral.white,
    borderRadius: "0.5rem",
    padding: t === "contained" ? "1.5rem" : void 0
  },
  header: {
    padding: t === "contained" ? "0 0 1.5rem 0" : "1.5rem",
    display: "flex",
    gap: "1rem",
    justifyContent: "space-between"
  },
  headerDivider: {
    borderBottom: `1px solid ${e.palette.neutral[30]}`
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0.125rem",
    flex: 1,
    justifyContent: "center",
    maxWidth: "calc(100% - 6.75rem)"
  },
  heading: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "calc(100vw - 20rem)",
    [e.breakpoints.down(x1)]: {
      maxWidth: "unset"
    },
    color: o ? e.palette.neutral[50] : e.palette.neutral[80]
  },
  subtitle: {
    color: o ? e.palette.neutral[50] : e.palette.neutral[70],
    // NOTE: (2024-11-07) Noah Settersten => This allows three lines of text to be shown before truncating.
    // See https://www.geeksforgeeks.org/how-to-apply-an-ellipsis-to-multiline-text-in-css/
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  },
  arrowButton: {
    transform: "rotate(180deg)"
  },
  contents: {
    padding: n === "default" ? t === "contained" ? "1rem" : "1.5rem" : void 0,
    ...t === "contained" ? {
      //margin: "0 1.5rem 1.5rem 1.5rem",
      border: `1px solid ${e.palette.neutral[30]}`,
      borderRadius: "0.25rem"
    } : {}
  },
  footer: {
    borderTop: t !== "contained" ? `1px solid ${e.palette.neutral[30]}` : void 0,
    padding: "1.5rem 1rem 1.5rem 1rem"
  }
})), id = X.create(({ theme: e }) => ({
  headerActions: {},
  largeScreenHeaderActions: {
    display: "flex",
    gap: "0.5rem",
    [e.breakpoints.down(x1)]: {
      display: "none"
    }
  },
  smallScreenHeaderActions: {
    display: "none",
    [e.breakpoints.down(x1)]: {
      display: "block"
    }
  },
  neutralLightIcon: {
    color: e.palette.neutral[50]
  }
})), Fr = ["id", "testId", "label", "selected"], ld = ({ actions: e }) => {
  if (e.length === 1 && e[0]) {
    const { listItems: t } = e[0];
    if (t && t.length > 0)
      return t.flat().map((n) => dr(n, Fr));
  }
  return e.map(
    (t) => d0(dr(t, Fr), {
      testId: t.id,
      iconLeft: t.icon ? t.icon : t.menuIcon,
      iconRight: t.iconRight ? t.iconRight : void 0
    })
  );
}, sd = ({
  testId: e,
  actions: t
}) => {
  const { translations: n } = Q(), { classes: o } = id(), a = Z(null), [i, l] = V(!1);
  return t ? /* @__PURE__ */ r.jsxs("div", { className: o.headerActions, children: [
    /* @__PURE__ */ r.jsx("div", { className: o.largeScreenHeaderActions, children: t.map(
      (c) => c.actions.map(({ id: d, icon: u, iconRight: p, ...m }) => /* @__PURE__ */ e1(
        G,
        {
          ...je.omit(m, "menuIcon"),
          key: d,
          startIcon: u ? /* @__PURE__ */ r.jsx(te, { name: u }) : null,
          endIcon: p ? /* @__PURE__ */ r.jsx(
            te,
            {
              name: p,
              className: m.iconRightVariant === "neutralLight" ? o.neutralLightIcon : void 0
            }
          ) : null
        }
      ))
    ) }),
    /* @__PURE__ */ r.jsxs("div", { ref: a, className: o.smallScreenHeaderActions, children: [
      /* @__PURE__ */ r.jsx(
        G,
        {
          testId: `${e}-menu`,
          title: n.common.actions,
          buttonVariant: "icon",
          iconVariant: "neutral",
          icon: "more",
          onClick: () => l(!0)
        }
      ),
      /* @__PURE__ */ r.jsx(
        ze,
        {
          anchorRef: a,
          open: i,
          onClose: () => l(!1),
          children: /* @__PURE__ */ r.jsx(
            Ie,
            {
              lists: t.map((c) => ({
                subheader: c.header,
                itemComponent: Se,
                items: ld(c),
                onSelection: ({ id: d, value: u }) => {
                  var m;
                  const p = c.actions.find((g) => g.id === d);
                  if (p)
                    p.onClick();
                  else {
                    const g = c.actions.flatMap((h) => h.listItems).flatMap((h) => h).find((h) => (h == null ? void 0 : h.id) === d);
                    (m = g == null ? void 0 : g.onSelection) == null || m.call(g, { id: d, value: u });
                  }
                  l(!1);
                }
              }))
            }
          )
        }
      )
    ] })
  ] }) : null;
}, No = ({
  testId: e,
  icon: t,
  variant: n = "contained",
  spacing: o = "full_width",
  disabled: a = !1,
  heading: i,
  subtitle: l,
  children: c,
  contentMaxHeight: d = "15.75rem",
  scrollableContent: u = !0,
  headerActions: p = [],
  showHeaderDivider: m
}) => {
  const g = m ?? n !== "contained", { cx: h, classes: C } = ad({
    variant: n,
    spacing: o,
    disabled: a
  }), v = {
    style: {
      maxHeight: d
    },
    className: C.contents,
    children: c
  };
  return /* @__PURE__ */ r.jsxs("div", { "data-testid": e, className: C.root, children: [
    /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: h(C.header, {
          [C.headerDivider]: g
        }),
        children: [
          t ? /* @__PURE__ */ r.jsx(
            we,
            {
              icon: t,
              iconAvatarColor: a ? "empty" : "primary"
            }
          ) : null,
          /* @__PURE__ */ r.jsxs("div", { className: C.textContainer, children: [
            /* @__PURE__ */ r.jsx(
              W,
              {
                variant: "h3",
                className: C.heading,
                "data-testid": "widget-heading",
                children: i
              }
            ),
            l ? /* @__PURE__ */ r.jsx(
              W,
              {
                variant: "subtitle1",
                component: "p",
                className: C.subtitle,
                "data-testid": "widget-subtitle",
                children: l
              }
            ) : null
          ] }),
          /* @__PURE__ */ r.jsx(sd, { testId: `${e}-actions`, actions: p })
        ]
      }
    ),
    u ? /* @__PURE__ */ r.jsx(ue, { ...v }) : /* @__PURE__ */ r.jsx("div", { ...v })
  ] });
}, cd = X.withParams().create(({ theme: e, count: t }) => ({
  root: {
    display: "flex",
    [e.breakpoints.down(x1)]: {
      flexDirection: "column"
    }
  },
  radialChartContainer: {
    width: "144px",
    height: "144px",
    borderRight: `1px solid ${e.palette.neutral[30]}`,
    [e.breakpoints.down(x1)]: {
      width: "100%",
      display: "grid",
      placeItems: "center",
      borderRight: 0,
      borderBottom: `1px solid ${e.palette.neutral[30]}`
    }
  },
  statisticScrollView: {
    flex: 1,
    borderRadius: "0.25rem"
  },
  statisticContainer: {
    // For a total of 28rem for five items.
    minWidth: t * 80 + 48,
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    [e.breakpoints.down(x1)]: {
      minWidth: "unset"
    }
  },
  statistic: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    textDecoration: "none",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
    "&:hover, &:focus-visible": {
      backgroundColor: e.palette.neutral[20],
      outline: "none"
    },
    [e.breakpoints.down(x1)]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem"
    }
  }
})), dd = {
  error: "#f2664c",
  warning: "#e9af23",
  success: "#7bba19",
  neutral: "#e6e6e6",
  primary: "#dfe4e7",
  info: "#3a86ff"
}, ud = (e) => e.map((t) => ({
  ...t,
  color: t.color ? dd[t.color] : "#e6e6e6"
})), om = ({
  testId: e,
  icon: t,
  heading: n,
  headerActions: o,
  linkComponent: a,
  statistics: i
}) => {
  const { classes: l } = cd({ count: i.length });
  return /* @__PURE__ */ r.jsx(
    No,
    {
      testId: `${e}-widget`,
      icon: t,
      heading: n,
      headerActions: o,
      scrollableContent: !1,
      children: /* @__PURE__ */ r.jsxs("div", { className: l.root, children: [
        /* @__PURE__ */ r.jsx("div", { className: l.radialChartContainer, children: /* @__PURE__ */ r.jsx(
          od,
          {
            testId: `${e}-chart`,
            data: ud(i)
          }
        ) }),
        /* @__PURE__ */ r.jsx(ue, { className: l.statisticScrollView, children: /* @__PURE__ */ r.jsx("div", { className: l.statisticContainer, children: i.map((c) => /* @__PURE__ */ r.jsxs(
          a,
          {
            to: c.path,
            "data-testid": `${e}-${je.snakeCase(c.label)}`,
            className: l.statistic,
            children: [
              /* @__PURE__ */ r.jsx(
                W,
                {
                  variant: "h3",
                  "data-testid": `${e}-${je.snakeCase(c.label)}-value`,
                  children: c.value
                }
              ),
              /* @__PURE__ */ r.jsx(
                l4,
                {
                  testId: `chip-${c.label}`,
                  state: c.color ?? "neutral",
                  label: c.label
                }
              )
            ]
          },
          c.label
        )) }) })
      ] })
    }
  );
}, pd = X.create(({ theme: e }) => ({
  root: {
    position: "relative",
    display: "flex"
  },
  card: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    height: "12.5rem",
    width: "20rem",
    backgroundColor: "#ffffff",
    padding: "1.5rem",
    borderRadius: "0.5rem",
    border: 0,
    textAlign: "left",
    cursor: "pointer"
  },
  cardShadow: {
    "&:hover, &:focus-visible": {
      boxShadow: e.namedShadows["depth-1"],
      outline: "none"
    },
    "&:active": {
      boxShadow: e.namedShadows["depth-2"]
    }
  },
  topBar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1.5rem"
  },
  closeButton: {
    position: "absolute",
    top: 26,
    right: 16
  },
  textContainer: {
    flex: 1
  },
  heading: {
    marginBottom: "2px",
    [e.breakpoints.down(400)]: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "max(140px, calc(100vw - 10rem))"
    }
  },
  description: {
    marginBottom: "1.25rem",
    height: "2rem",
    maxHeight: "2rem"
  },
  bottomBar: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  getStartedText: {
    ...e.typography.button1
  }
})), md = ({
  lines: e,
  children: t,
  ...n
}) => /* @__PURE__ */ r.jsx(
  W,
  {
    sx: {
      overflow: "hidden",
      WebkitBoxOrient: "vertical",
      boxOrient: "vertical",
      WebkitLineClamp: `${e}`,
      lineClamp: `${e}`,
      display: "-webkit-box"
    },
    ...n,
    children: t
  }
), hd = ({
  testId: e,
  icon: t,
  heading: n,
  description: o,
  showNewChip: a,
  hideShadow: i = !1
}) => {
  const { translations: l } = Q(), { cx: c, classes: d } = pd();
  return /* @__PURE__ */ r.jsxs("div", { "data-card": !0, "data-testid": e, className: d.root, children: [
    /* @__PURE__ */ r.jsxs(
      "button",
      {
        className: c(d.card, {
          [d.cardShadow]: !i
        }),
        children: [
          /* @__PURE__ */ r.jsx("div", { className: d.topBar, children: /* @__PURE__ */ r.jsx(we, { icon: t, iconAvatarColor: "primary" }) }),
          /* @__PURE__ */ r.jsxs("div", { className: d.textContainer, children: [
            /* @__PURE__ */ r.jsx(W, { variant: "h3", className: d.heading, children: n }),
            /* @__PURE__ */ r.jsx(
              md,
              {
                variant: "subtitle1",
                component: "p",
                lines: 2,
                className: d.description,
                children: o
              }
            )
          ] }),
          /* @__PURE__ */ r.jsxs("div", { className: d.bottomBar, children: [
            /* @__PURE__ */ r.jsx(W, { className: d.getStartedText, children: "Get Started" }),
            a ? /* @__PURE__ */ r.jsx(
              _e,
              {
                testId: "suggestion-card-chip",
                state: "info",
                variant: "small",
                items: [
                  {
                    id: "suggestion-card-chip-new",
                    label: "New"
                  }
                ]
              }
            ) : null
          ] })
        ]
      }
    ),
    /* @__PURE__ */ r.jsx(
      G,
      {
        buttonVariant: "icon",
        label: l.common.close,
        icon: "cross",
        title: l.common.close,
        onClick: () => {
        },
        iconVariant: "neutral",
        className: d.closeButton
      }
    )
  ] });
}, gd = 24, Cd = (e) => e > 1 ? "100vw - 7rem" : "100vw - 3rem", vd = X.withParams().create(({ theme: e, count: t }) => ({
  scrollView: {
    marginBottom: "0.5rem",
    // NOTE: (2024-10-22) Noah Settersten => Along with the top & left margin on the `container` class below, this
    // allows for space to show the box shadow while not impacting the rest of the layout.
    position: "relative",
    top: "-1rem",
    borderRadius: "0.25rem"
  },
  container: {
    display: "flex",
    gap: gd,
    //width: widthForCards(count),
    marginBottom: "1rem",
    marginTop: "1rem"
    // [theme.breakpoints.down(400)]: {
    //   // NOTE: (2024-11-15) Noah Settersten =>
    //   // See note below for .cardContainer on card widths on smaller screens. This rule here updates the overall
    //   // container size for the modified card widths.
    //   width: widthForCards(cardWidth(count)),
    //   minWidth: 188,
    // },
  },
  shadowContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    width: "100%"
  },
  shadowCard: {
    position: "absolute",
    width: 320,
    height: 190,
    top: 0,
    boxShadow: e.namedShadows["depth-1"],
    borderRadius: "0.5rem",
    outline: "none"
  },
  leftShadowCard: { left: 0 },
  rightShadowCard: { right: 0 },
  activeShadowCard: { boxShadow: e.namedShadows["depth-2"] },
  cardContainer: {
    borderRadius: "0.5rem",
    [e.breakpoints.down(400)]: {
      // NOTE: (2024-11-13) Noah Settersten =>
      // On smaller screens, we adjust the width to allow an entire card to be visible at once. If there is more than
      // one card, we shrink the cards more to show that there are more to view beyond the first card.
      width: `calc(max(188px, ${Cd(t)}))`
    }
  }
})), fd = (e, t) => {
  const [n, o] = V(), [a, i] = V("none"), [l, c] = V("none"), d = u0(() => {
    var v;
    const C = (v = e.current) == null ? void 0 : v.getElement();
    o(C == null ? void 0 : C.getBoundingClientRect());
  });
  K(() => {
    d();
  }, [d]);
  const u = (C, v) => {
    const b = C == null ? void 0 : C.getBoundingClientRect();
    if (b) {
      if (v === 0) {
        const f = n == null ? void 0 : n.left, y = f ? f - b.left === 0 : !1;
        i(y ? "hover" : "none");
      } else if (v === t - 1) {
        const f = n == null ? void 0 : n.right, y = f ? b.right - f - 1 <= 0 : !1;
        c(y ? "hover" : "none");
      }
    }
  }, p = (C, v) => {
    const f = C.target.closest("[data-card]");
    u(f, v);
  }, m = (C) => {
    C === 0 && a === "hover" && i("active"), C === t - 1 && l === "hover" && c("active");
  }, g = () => {
    i("none"), c("none");
  }, h = () => {
    i(a === "active" ? "hover" : "none"), c(l === "active" ? "hover" : "none");
  };
  return {
    firstShadow: a,
    lastShadow: l,
    updateScrollValues: d,
    cardEvents: (C) => ({
      onMouseOver: (v) => p(v, C),
      onMouseDown: () => m(C),
      onMouseEnter: (v) => p(v, C),
      onMouseOut: g,
      onMouseLeave: g,
      onMouseUp: h
    })
  };
}, am = ({ cards: e }) => {
  const { cx: t, classes: n } = vd({ count: e.length }), o = Z(null), { firstShadow: a, lastShadow: i, updateScrollValues: l, cardEvents: c } = fd(o, e.length), d = (u, p) => u !== "none" ? /* @__PURE__ */ r.jsx(
    "div",
    {
      className: t(n.shadowCard, p, {
        [n.activeShadowCard]: u === "active"
      })
    }
  ) : null;
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      style: { position: "relative" },
      "data-testid": "dashboard-suggestion-card-list",
      children: [
        /* @__PURE__ */ r.jsxs("div", { className: n.shadowContainer, children: [
          d(a, n.leftShadowCard),
          d(i, n.rightShadowCard)
        ] }),
        /* @__PURE__ */ r.jsx(
          ue,
          {
            disableVerticalScroll: !0,
            ref: o,
            className: n.scrollView,
            onScroll: l,
            children: /* @__PURE__ */ r.jsx("div", { className: n.container, children: e.map((u, p) => {
              const m = p === 0 && a !== "none", g = p === e.length - 1 && i !== "none";
              return /* @__PURE__ */ r.jsx(
                "div",
                {
                  ...c(p),
                  className: n.cardContainer,
                  children: /* @__PURE__ */ r.jsx(
                    hd,
                    {
                      ...u,
                      testId: `suggestion-card-${p}`,
                      icon: u.icon,
                      hideShadow: m || g
                    }
                  )
                },
                `${u.heading}-${p}`
              );
            }) })
          }
        )
      ]
    }
  );
}, xd = (e, t) => Array.from({ length: t }, (n, o) => ({
  id: `activity-${Xe(e, "yyyy-MM-dd")}-${o}`,
  title: "[Item-Type-Activity]",
  description: "[Item-Name]",
  eventType: "INFORMATION",
  timestamp: e,
  user: {
    id: `person-${o}`,
    firstName: "Firstname",
    lastName: "Lastname",
    primaryEmailAddress: "email@example.com"
  }
})), zr = {
  1: [
    0,
    9,
    8,
    4,
    2,
    4,
    1,
    4,
    4,
    0,
    9,
    1,
    3,
    4,
    6,
    3,
    7,
    3,
    6,
    7,
    1,
    5,
    8,
    8,
    6,
    5,
    5,
    6,
    2,
    3,
    9
  ],
  // With 29 days for now
  2: [
    2,
    0,
    2,
    2,
    8,
    4,
    9,
    3,
    4,
    9,
    3,
    9,
    2,
    2,
    9,
    0,
    2,
    5,
    2,
    4,
    4,
    5,
    0,
    8,
    7,
    0,
    2,
    9,
    8
  ],
  3: [
    5,
    1,
    2,
    2,
    9,
    4,
    0,
    4,
    9,
    9,
    0,
    6,
    6,
    3,
    5,
    5,
    5,
    6,
    2,
    1,
    3,
    7,
    4,
    7,
    7,
    6,
    2,
    0,
    7,
    0,
    7
  ],
  4: [
    3,
    8,
    4,
    0,
    7,
    0,
    4,
    1,
    5,
    7,
    8,
    8,
    4,
    0,
    9,
    2,
    5,
    3,
    8,
    5,
    3,
    5,
    4,
    6,
    1,
    2,
    9,
    9,
    4,
    7
  ],
  5: [
    3,
    6,
    5,
    9,
    4,
    3,
    1,
    5,
    1,
    7,
    8,
    0,
    7,
    4,
    7,
    4,
    8,
    3,
    3,
    5,
    2,
    7,
    6,
    8,
    1,
    8,
    4,
    8,
    6,
    1,
    2
  ],
  6: [
    0,
    2,
    1,
    7,
    2,
    4,
    4,
    5,
    6,
    9,
    6,
    2,
    3,
    0,
    2,
    2,
    1,
    8,
    6,
    4,
    2,
    7,
    4,
    5,
    4,
    0,
    4,
    6,
    3,
    5
  ],
  7: [
    3,
    9,
    5,
    4,
    0,
    5,
    4,
    1,
    5,
    9,
    5,
    5,
    1,
    3,
    4,
    0,
    3,
    5,
    8,
    0,
    4,
    0,
    1,
    6,
    0,
    4,
    5,
    1,
    8,
    7,
    0
  ],
  8: [
    5,
    2,
    7,
    0,
    4,
    1,
    1,
    4,
    1,
    2,
    8,
    6,
    9,
    4,
    5,
    2,
    1,
    7,
    0,
    4,
    8,
    3,
    4,
    8,
    6,
    9,
    1,
    8,
    6,
    2,
    1
  ],
  9: [
    2,
    0,
    1,
    1,
    4,
    3,
    9,
    6,
    7,
    9,
    7,
    7,
    9,
    2,
    4,
    4,
    1,
    5,
    7,
    7,
    8,
    2,
    6,
    7,
    2,
    5,
    1,
    7,
    6,
    3
  ],
  10: [
    5,
    3,
    1,
    9,
    0,
    0,
    6,
    8,
    1,
    1,
    7,
    8,
    5,
    8,
    2,
    1,
    7,
    1,
    9,
    0,
    2,
    5,
    5,
    4,
    3,
    7,
    1,
    6,
    6,
    4,
    5
  ],
  11: [
    8,
    7,
    6,
    9,
    0,
    1,
    4,
    2,
    1,
    4,
    8,
    9,
    4,
    1,
    5,
    7,
    3,
    4,
    6,
    4,
    6,
    0,
    1,
    3,
    4,
    3,
    7,
    0,
    4,
    8
  ],
  12: [
    1,
    2,
    5,
    2,
    3,
    5,
    4,
    5,
    5,
    9,
    1,
    9,
    2,
    8,
    0,
    9,
    2,
    7,
    1,
    3,
    1,
    8,
    8,
    9,
    2,
    4,
    8,
    1,
    9,
    5,
    4
  ]
}, bd = 2020, im = Object.keys(zr).map((e) => {
  const t = zr[e];
  return rt(
    t.map((n, o) => {
      const a = new Date(bd, Number.parseInt(e) - 1, o + 1);
      if (!(!p0(a) && e === "2" && o > 27))
        return {
          date: a,
          activity: xd(a, n)
        };
    })
  );
}).flat(), wd = {
  combineAvatarAndInput: !1,
  visibleColumnIndices: [],
  useSubgrid: !1
}, Io = nt(wd), yd = ({
  combineAvatarAndInput: e,
  visibleColumnIndices: t,
  templateColumnsDefinition: n,
  minimumWidth: o,
  visibleWidth: a,
  useSubgrid: i,
  sortColumnIndex: l,
  children: c
}) => /* @__PURE__ */ r.jsx(
  Io,
  {
    value: {
      combineAvatarAndInput: e,
      visibleColumnIndices: t,
      templateColumnsDefinition: n,
      minimumWidth: o,
      visibleWidth: a,
      useSubgrid: i,
      sortColumnIndex: l
    },
    children: c
  }
), kd = () => $1(Io), jd = R()((e, {
  columnDefinition: t,
  hideTopBorder: n,
  centerTextColumns: o,
  treePosition: a,
  useSubgrid: i
}) => {
  const l = e.namedShadows["depth-2"], c = (d) => ({
    backgroundColor: d.palette.neutral.white,
    boxShadow: l
  });
  return {
    container: {
      position: "relative",
      backgroundColor: e.palette.neutral.white,
      border: "0.0625rem solid var(--border-rest)",
      borderRadius: a === "start" ? "0.25rem 0.25rem 0 0" : a === "end" ? "0 0 0.25rem 0.25rem" : a === "middle" ? 0 : "0.25rem",
      borderTopColor: a === "start" || !a ? "var(--border-rest)" : "transparent",
      borderBottomColor: a === "middle" ? "transparent" : "var(--border-rest)",
      display: "grid",
      gridColumn: "1/100",
      gridTemplateColumns: i ? "subgrid" : t,
      transition: "box-shadow 300ms ease",
      // Addresses several instances where the first data card's top
      // border would be transparent due to a missing treePosition prop
      "[class*='-headerRow'] + &, [class*='-groupHeading'] + &": {
        borderTopColor: "var(--border-rest)"
      },
      // NOTE: (2024-12-20) Noah Settersten => While the below rule prevents the contents of the data card from
      // overlapping the selected border, it unfortunately breaks the data card column layout on (at least) iOS 17.
      // See https://stackoverflow.com/questions/77927259/css-grid-with-subgrid-and-overflow-breaks-on-safari-but-works-on-all-other-brows
      // and https://github.com/WebKit/WebKit/commit/78a954e5a2bd3f1acacb08e8fd5c370809ea4fe7
      //overflow: "hidden",
      "&:hover": {
        ...c(e),
        zIndex: 10,
        cursor: "pointer"
      },
      "&:active": {
        backgroundColor: e.palette.neutral[10],
        boxShadow: l,
        "&:has(input:active)": {
          backgroundColor: e.palette.neutral.white
        },
        "&:has(button:active)": {
          backgroundColor: e.palette.neutral.white
        }
      },
      "&:focus-visible": {
        ...c(e),
        outline: `1px solid ${e.palette.primary["60-key"]}`,
        outlineOffset: "1px",
        zIndex: 10
        // brings focused row to the top so outline is not hidden by row below
      }
    },
    containerWithMenuOpen: {
      ...c(e)
    },
    containerDisabled: {
      color: e.palette.neutral[50],
      pointerEvents: "none",
      "&:hover, &:active, &:focus-visible": {
        backgroundColor: e.palette.neutral.white,
        boxShadow: "none",
        cursor: "unset"
      }
    },
    containerDisabledAndSelected: {
      ".MuiCheckbox-root span": {
        backgroundColor: e.palette.neutral[30]
      },
      "&:hover, &:active, &:focus-visible": {
        backgroundColor: e.palette.primary[10]
      }
    },
    containerSelected: {
      border: `0.0625rem solid ${e.palette.primary["60-key"]}`,
      borderTopColor: n ? "transparent !important" : `${e.palette.primary["60-key"]} !important`,
      backgroundColor: e.palette.primary[10],
      "&:has(input:active)": {
        backgroundColor: e.palette.primary[20]
      },
      "&:hover": {
        backgroundColor: e.palette.primary[20],
        boxShadow: l
      },
      "&:active": {
        backgroundColor: e.palette.primary[30],
        boxShadow: l,
        "&:has(input:active)": {
          backgroundColor: e.palette.primary[20]
        },
        "&:has(button:active)": {
          backgroundColor: e.palette.primary[20]
        }
      },
      "&:focus-visible": {
        backgroundColor: e.palette.primary[20],
        boxShadow: l
      }
    },
    containerSelectedWithOpenMenu: {
      backgroundColor: e.palette.primary[20],
      boxShadow: l
    },
    containerNoninteractive: {
      backgroundColor: e.palette.neutral.white,
      "&:hover, &:active, &:focus-visible": {
        backgroundColor: e.palette.neutral.white,
        boxShadow: "none",
        cursor: "unset",
        ".MuiCheckbox-root, .MuiRadio-root": {
          cursor: "pointer"
        },
        "&:has(input:active)": {
          backgroundColor: e.palette.neutral.white
        }
      },
      "& label": {
        cursor: "unset",
        "&:hover, &:active, &:focus-visible": {
          ".MuiCheckbox-root span, .MuiRadio-root span, circle.emptyIcon": {
            borderColor: e.palette.neutral[30],
            color: "inherit",
            stroke: e.palette.neutral[30]
          }
        }
      },
      ".MuiCheckbox-root, .MuiRadio-root": {
        cursor: "unset"
      }
    },
    containerTextNonSelectable: {
      // This prevents text selection, which is helpful when the user long-presses on mobile.
      // See https://github.com/mui/material-ui/issues/23232
      userSelect: "none"
    },
    input: {
      padding: "0.9375rem"
    },
    inputCombinedWithAvatarContainer: {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 10,
      marginLeft: "-0.25rem",
      marginTop: "-0.25rem",
      width: "3rem",
      height: "3rem",
      backgroundColor: "inherit"
    },
    inputCombinedWithAvatar: {
      position: "absolute",
      top: "0.25rem",
      left: "0.25rem",
      zIndex: 10,
      backgroundColor: e.palette.neutral.white,
      borderRadius: "100%",
      padding: 0,
      "& label": {
        backgroundColor: `${x["neutral-50"]}1A`,
        borderRadius: "100%",
        margin: 0,
        width: "2.5rem",
        height: "2.5rem",
        "span.MuiCheckbox-root": {
          margin: 0,
          padding: "0.6875rem",
          borderRadius: "100%"
        }
      }
    },
    contentColumn: {
      position: "relative",
      paddingTop: "0.9375rem",
      paddingBottom: "0.9375rem",
      display: "flex",
      flexDirection: "row",
      minHeight: "2.5rem",
      backgroundColor: "inherit",
      overflow: "hidden",
      ...o ? {
        alignItems: "center"
      } : {},
      paddingRight: "1rem",
      WebkitTapHighlightColor: "transparent"
    },
    firstColumn: {
      borderTopLeftRadius: a === "start" || a === void 0 ? "0.25rem" : 0,
      borderBottomLeftRadius: a === "end" || a === void 0 ? "0.25rem" : 0,
      paddingLeft: "0.9375rem"
    },
    lastContentColumn: {
      borderTopRightRadius: a === "start" || a === void 0 ? "0.25rem" : 0,
      borderBottomRightRadius: a === "end" || a === void 0 ? "0.25rem" : 0
    },
    internalContentColumn: {
      position: "relative",
      backgroundColor: "inherit",
      maxWidth: "100%"
    },
    hiddenInputContainer: {
      position: "absolute",
      zIndex: 10,
      width: "2.5rem",
      height: "2.5rem"
    },
    rightAlignedColumn: {
      display: "flex",
      flexDirection: "row",
      alignItems: "start",
      justifyContent: "end",
      paddingRight: "1rem"
    },
    hasChildrenLine: {
      position: "absolute",
      top: "2.75rem",
      width: "2.5rem",
      height: "100%"
    },
    actionsContainer: {
      paddingTop: "1rem"
    },
    divider: {
      position: "absolute",
      left: "-0.0625rem",
      right: "-0.0625rem",
      bottom: "-0.0625rem",
      zIndex: 1
    }
  };
}), $o = R()((e, { hasSubtext: t, wrappedHeading: n = !1 }) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    background: "inherit",
    paddingBottom: "0.25rem",
    marginBottom: "-0.25rem"
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    opacity: "1",
    minHeight: "2.5rem",
    paddingTop: t || n ? 0 : "0.625rem",
    gap: "0.125rem",
    maxWidth: "100%"
  },
  textDisabled: {
    color: e.palette.neutral[50]
  },
  disabledContainer: {
    opacity: 0.4
  },
  textAndChipContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  heading: {
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  headingText: {
    marginRight: "0.375rem"
  },
  chip: {
    position: "relative",
    top: "-0.125rem",
    ".MuiStack-root": {
      display: "inline-flex"
    }
  },
  subtext: {
    ...e.typography.subtitle,
    color: e.palette.neutral[70],
    paddingRight: "2.5rem",
    textAlign: "left",
    overflow: "hidden",
    wordBreak: "break-word",
    [e.breakpoints.down("sm")]: {
      paddingRight: 0
    }
  },
  searchMatch: {
    display: "inline-block",
    backgroundColor: e.palette.warning[10],
    border: `1px solid ${e.palette.warning["60-key"]}`,
    padding: "0 0.125rem",
    margin: "-0.0625rem -0.1875rem",
    borderRadius: "0.25rem"
  },
  searchMatchSubtext: {
    overflow: "visible"
  },
  chipSearchMatch: {
    margin: "0 0 0 0.1875rem",
    paddingBottom: "0.1875rem"
  }
})), Sd = R()(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "end",
    minHeight: "2.5rem"
  },
  disabledContainer: {
    opacity: 0.4
  }
})), Ld = ({
  parentTestId: e,
  avatar: t,
  heading: n,
  chip: o,
  subtext: a,
  disabled: i = !1,
  matchData: l
}) => {
  const c = Z(null), [d, u] = V(!1), { cx: p, classes: m } = $o({
    hasSubtext: !!a,
    wrappedHeading: d
  });
  K(() => {
    const h = () => {
      if (!c.current) return;
      const C = c.current.clientHeight > 20;
      u(C);
    };
    return h(), window.addEventListener("resize", h), () => window.removeEventListener("resize", h);
  }, [n, o]);
  const g = (h, C) => (l == null ? void 0 : l.attribute) === h && l.matches ? /* @__PURE__ */ r.jsx($t, { value: C, query: l.query }) : C;
  return /* @__PURE__ */ r.jsxs("div", { className: m.container, children: [
    /* @__PURE__ */ r.jsx(
      "div",
      {
        className: p({
          [m.disabledContainer]: i
        }),
        children: t
      }
    ),
    /* @__PURE__ */ r.jsxs("div", { className: m.textContainer, children: [
      /* @__PURE__ */ r.jsx("div", { className: m.textAndChipContainer, children: /* @__PURE__ */ r.jsxs(
        W,
        {
          ref: c,
          "data-testid": `${e}-heading`,
          component: "span",
          className: p(m.heading, {
            [m.textDisabled]: i
          }),
          variant: "h3",
          children: [
            /* @__PURE__ */ r.jsx("span", { className: m.headingText, children: g("heading", n) }),
            o && /* @__PURE__ */ r.jsx(
              "span",
              {
                className: p(m.chip, {
                  [m.searchMatch]: (l == null ? void 0 : l.attribute) === "chipText",
                  [m.chipSearchMatch]: (l == null ? void 0 : l.attribute) === "chipText",
                  [m.disabledContainer]: i
                }),
                children: /* @__PURE__ */ r.jsx(
                  _e,
                  {
                    ...o,
                    testId: `${e}-chip`,
                    variant: "small"
                  }
                )
              }
            )
          ]
        }
      ) }),
      a && a.length > 0 && /* @__PURE__ */ r.jsx(
        W,
        {
          "data-testid": `${e}-subtext`,
          className: p(m.subtext, {
            [m.searchMatchSubtext]: (l == null ? void 0 : l.attribute) === "subtext",
            [m.textDisabled]: i
          }),
          children: g("subtext", a)
        }
      )
    ] })
  ] });
}, Md = ({
  testId: e,
  ariaLabel: t,
  label: n,
  disabled: o = !1,
  matchData: a
}) => {
  const { cx: i, classes: l } = $o({ hasSubtext: !1 });
  return /* @__PURE__ */ r.jsx(
    W,
    {
      "data-testid": e,
      "aria-label": t,
      variant: "body2",
      className: i({
        [l.searchMatch]: (a == null ? void 0 : a.attribute) === "content",
        [l.textDisabled]: o
      }),
      children: n
    }
  );
}, Ed = ({
  children: e,
  disabled: t = !1
}) => {
  const { cx: n, classes: o } = Sd();
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      className: n(o.container, {
        [o.disabledContainer]: t
      }),
      children: e
    }
  );
}, tt = (e) => e.kind === "primary" || e.kind === "primary-with-avatar", Nd = 134, Id = 320, lm = 52, $d = (e, t = Nd, n = Id) => ({
  content: e,
  minWidth: t,
  maxWidth: n,
  kind: e.avatar !== void 0 ? "primary-with-avatar" : "primary"
}), _d = (e, t = 100, n = 176) => ({
  content: e,
  minWidth: t,
  maxWidth: n,
  alignment: "right",
  kind: "info"
}), _o = 52, Vo = 52, Ao = 58, _t = 36, Bo = (e) => e ? Vo : _o, Ho = (e) => e.every((t) => !!t.maxWidth), Do = ({
  headings: e = [],
  columns: t,
  hasActions: n = !1,
  hasInput: o = !1,
  maxWidth: a,
  largestTreeLineWidth: i = 0,
  inGrid: l = !1
}) => {
  var d, u;
  const c = t ? [...t] : [];
  if (c.length === 0)
    return {
      combineAvatarAndInput: !1,
      visibleHeadings: e,
      visibleColumns: [],
      templateColumnsDefinition: `repeat(${e.length || 1}, 1fr)`
    };
  if (a) {
    const p = er(
      i,
      o,
      n,
      t[0] ? [t[0]] : []
    ), m = {
      combineAvatarAndInput: Vt({
        visibleColumns: t[0] ? [t[0]] : [],
        hasInput: o
      }),
      visibleHeadings: e[0] ? [e[0]] : [],
      visibleColumns: t[0] ? [t[0]] : [],
      templateColumnsDefinition: g2({
        visibleColumns: t[0] ? [t[0]] : [],
        hasInput: o,
        hasActions: n,
        largestTreeLineWidth: i,
        inGrid: l,
        firstColumnShouldExpand: !!((d = t[0]) != null && d.maxWidth)
      })
    };
    if (p >= a)
      return m;
    const g = ((u = t[t.length - 1]) == null ? void 0 : u.kind) === "info", h = Vd({
      lastColumnIsInfo: g,
      headings: e,
      columns: t,
      smallestWidth: p,
      largestTreeLineWidth: i,
      maxWidth: a,
      hasInput: o,
      hasActions: n,
      inGrid: l
    });
    if (h) return h;
  }
  return {
    combineAvatarAndInput: Vt({
      visibleColumns: c,
      hasInput: o
    }),
    visibleHeadings: e,
    visibleColumns: c,
    templateColumnsDefinition: g2({
      visibleColumns: c,
      hasInput: o,
      hasActions: n,
      largestTreeLineWidth: i,
      inGrid: l,
      firstColumnShouldExpand: Ho(c)
    })
  };
}, Vd = ({
  lastColumnIsInfo: e,
  headings: t = [],
  columns: n,
  hasActions: o = !1,
  hasInput: a = !1,
  maxWidth: i,
  largestTreeLineWidth: l,
  smallestWidth: c,
  inGrid: d
}) => {
  var h;
  const u = ((h = n[n.length - 1]) == null ? void 0 : h.minWidth) ?? Ao, p = e ? t.slice(1, t.length - 1) : t.slice(1, t.length), m = e ? n.slice(1, n.length - 1) : n.slice(1, n.length), g = e ? m.length + 1 : m.length;
  for (let C = 1; C < g; C++) {
    const v = m.slice(0, C);
    if (c + u + To(v, l) >= i) {
      const f = n[n.length - 1], y = n[0] ? e && f ? [n[0], ...m.slice(0, C - 1), f] : [n[0], ...m.slice(0, C)] : [], w = t[t.length - 1], k = t[0] ? e && w ? [t[0], ...p.slice(0, C - 1), w] : [t[0], ...p.slice(0, C)] : [], M = Ho(y);
      return {
        combineAvatarAndInput: Vt({
          visibleColumns: y,
          hasInput: a
        }),
        visibleHeadings: k,
        visibleColumns: y,
        templateColumnsDefinition: g2({
          visibleColumns: y,
          hasInput: a,
          hasActions: o,
          largestTreeLineWidth: l,
          inGrid: d,
          firstColumnShouldExpand: M
        })
      };
    }
  }
}, Vt = ({
  visibleColumns: e,
  hasInput: t
}) => {
  var i;
  const n = ((i = e[0]) == null ? void 0 : i.kind) ?? "content", o = t && n === "primary-with-avatar", a = window.matchMedia("(width <= 480px)");
  return o && a.matches;
}, g2 = ({
  visibleColumns: e,
  hasInput: t,
  hasActions: n,
  largestTreeLineWidth: o,
  inGrid: a,
  firstColumnShouldExpand: i = !1
}) => {
  const l = t && !Vt({ visibleColumns: e, hasInput: t }), c = e.length === 1, u = Ro(
    e,
    o
  ).map(
    (g, h) => Ad(
      g,
      h === 0 && i,
      c
    )
  ), p = a ? _t : _t + 16;
  return [
    l ? `${Bo(a)}px` : "",
    ...u,
    n ? `${p}px` : ""
  ].join(" ");
}, Ad = (e, t, n = !1) => n ? "1fr" : e.minWidth && e.maxWidth ? t ? `minmax(${e.minWidth}px, 1fr)` : `minmax(${e.minWidth}px, ${e.maxWidth}px)` : "1fr", Bd = 17, er = (e, t, n, o, a = !1) => {
  const i = To(
    o,
    e
  );
  return 2 * Bd + e + (t ? Bo(a) : 0) + i + (n ? _t : 0);
}, To = (e, t) => e.length === 0 ? t ?? 0 : Ro(
  e,
  t
).map((o) => o.minWidth ?? Ao).reduce((o, a) => o + a), Ro = (e, t) => {
  let n = [];
  return t && t > 0 && e[0] ? n = [
    {
      ...e[0],
      minWidth: (e[0].minWidth ?? 0) + t
    },
    ...e.slice(1, e.length)
  ] : n = e, n;
}, Hd = 40, Fo = (e) => (e.reduce(
  (n, o) => o.length > n ? o.length : n,
  0
) - 1) * Hd, Dd = (e, t = !0) => {
  const n = t ? Vo : _o, o = e.variant !== "default" ? n : 0, a = (e.actionLists ?? []).length > 0 ? _t : 0;
  return o + a;
}, Td = (e, t) => {
  const n = e.visibleColumnIndices.length > 0 ? t.contentColumns.filter(
    (c, d) => e.visibleColumnIndices.includes(d)
  ) : t.contentColumns;
  if (e.templateColumnsDefinition)
    return {
      combineAvatarAndInput: e.combineAvatarAndInput,
      visibleColumns: n,
      templateColumnsDefinition: e.templateColumnsDefinition,
      minimumWidth: e.minimumWidth,
      visualWidth: e.visibleWidth
    };
  const { combineAvatarAndInput: o, visibleColumns: a, templateColumnsDefinition: i } = Do({
    columns: n,
    hasActions: t.hasActions,
    hasInput: t.hasInput,
    maxWidth: t.visibleWidth,
    largestTreeLineWidth: t.largestTreeLineWidth,
    inGrid: !1
  }), l = a.length <= 1 ? 0 : er(
    t.largestTreeLineWidth,
    t.hasInput,
    t.hasActions,
    t.contentColumns[0] ? [t.contentColumns[0]] : [],
    !1
  );
  return {
    combineAvatarAndInput: o,
    visibleColumns: a,
    templateColumnsDefinition: i,
    minimumWidth: l,
    visibleWidth: t.visibleWidth
  };
}, Rd = (e, t) => e.dataset.testid === `${t}-input-container`, Fd = (e) => e.tagName === "INPUT", zd = (e) => {
  var t;
  return e.tagName === "BUTTON" || ((t = e.parentElement) == null ? void 0 : t.tagName) === "BUTTON";
}, Wd = (e) => e.className.includes("MuiBackdrop-root"), Wr = (e) => {
  const t = e.target;
  return !Fd(t) && !zd(t) && !Wd(t);
}, Od = (e) => e.clientHeight < 40, Zd = "& > div[role='button'] > div[role='button'] p", Pd = (e) => {
  if (!e) return !1;
  try {
    const t = e.querySelectorAll(Zd);
    return t.length === 0 ? !0 : Array.from(t).every(Od);
  } catch {
    return !0;
  }
}, tr = ({
  id: e,
  testId: t = e,
  variant: n = "default",
  contentColumns: o = [],
  actionLists: a = [],
  hasDivider: i = !1,
  noninteractive: l = !1,
  hasChildren: c = !1,
  hierarchySpec: d = [],
  treePosition: u,
  largestTreeLineWidth: p = 0,
  showTreeLines: m = !0,
  disabled: g = !1,
  selected: h = !1,
  checked: C = !1,
  hideTopBorder: v = !1,
  showHiddenInput: b = !1,
  onSelection: f,
  onChecked: y,
  matchData: w,
  overrideSubtext: k,
  showDisabledMenuTrigger: M = !1
}) => {
  const L = Z(null), [j, N] = V(!0), [E, $] = V(), [S, _] = V(!1), B = m0(
    (J) => {
      J.stopPropagation(), J.preventDefault(), y == null || y({ id: e, value: !0 });
    },
    {
      filterEvents: (J) => Wr(J),
      onCancel: (J) => {
        F && Wr(J) && !Rd(J.target, t) && (f == null || f({ id: e, value: !h }));
      }
    }
  ), O = n === "checkbox", A = a.length > 0, F = !l && !g, z = kd(), I = {
    contentColumns: o,
    hasActions: A,
    hasInput: O,
    visibleWidth: E,
    largestTreeLineWidth: p
  }, {
    combineAvatarAndInput: D,
    visibleColumns: H,
    templateColumnsDefinition: T,
    minimumWidth: ne
  } = Td(z, I);
  K(() => {
    const J = () => {
      const ie = Pd(L.current);
      N(ie);
    };
    return J(), window.addEventListener("resize", J), () => window.removeEventListener("resize", J);
  }, [o, H]), K(() => {
    if (!z.visibleWidth) {
      const J = () => {
        var ie;
        $((ie = L.current) == null ? void 0 : ie.clientWidth);
      };
      return J(), window.addEventListener("resize", J), () => window.removeEventListener("resize", J);
    }
  }, [z.visibleWidth, o, a, n]);
  const { cx: de, classes: q } = jd({
    columnDefinition: T,
    hideTopBorder: v,
    centerTextColumns: j,
    treePosition: u,
    useSubgrid: z.useSubgrid
  }), U = o[0] && tt(o[0]) ? o[0].content.heading : e, se = O ? /* @__PURE__ */ r.jsx(
    "div",
    {
      onClick: (J) => J.stopPropagation(),
      className: de(q.input, {
        [q.inputCombinedWithAvatar]: D
      }),
      children: /* @__PURE__ */ r.jsx(
        io,
        {
          id: e,
          testId: `${t}-input`,
          labelSuffix: U,
          variant: n,
          disabled: g,
          selected: C,
          onSelection: (J) => !g && (y == null ? void 0 : y({ id: e, value: J.value })),
          fullHeight: !0
        }
      )
    },
    `${e}-input`
  ) : null, ve = C || b ? /* @__PURE__ */ r.jsx(
    "div",
    {
      className: q.inputCombinedWithAvatarContainer,
      children: se
    },
    `${e}-input`
  ) : /* @__PURE__ */ r.jsx(
    "div",
    {
      "data-testid": `${t}-input-container`,
      className: q.hiddenInputContainer,
      onClick: (J) => {
        J.stopPropagation(), y == null || y({ id: e, value: !0 });
      }
    },
    `${e}-input`
  ), Me = D ? B() : { onClick: () => F && (f == null ? void 0 : f({ id: e, value: !h })) }, Ee = F && !!f, ke = (J) => {
    Ee && J.target === J.currentTarget && (J.key === "Enter" || J.key === " ") && (J.preventDefault(), f({ id: e, value: !h }));
  }, Ae = (J) => {
    const ie = {
      disabled: g,
      matchData: w
    };
    if (tt(J)) {
      let be = J.content.subtext;
      if (k && (be = k), z.sortColumnIndex && z.sortColumnIndex !== 0) {
        const P = o[z.sortColumnIndex];
        P && typeof P.content == "string" && (be = P.content);
      }
      return /* @__PURE__ */ r.jsx(
        Ld,
        {
          ...ie,
          ...J.content,
          subtext: be
        }
      );
    }
    return J.kind === "info" ? /* @__PURE__ */ r.jsx(Ed, { disabled: g, children: J.content }) : typeof J.content == "string" ? /* @__PURE__ */ r.jsx(
      Md,
      {
        ...ie,
        ...J,
        label: J.content
      }
    ) : J.content;
  }, Fe = m && (z.visibleColumnIndices.length === 0 || z.visibleColumnIndices.includes(0));
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      id: e,
      "data-testid": t,
      "data-maintain-drawer": !0,
      className: de(q.container, {
        [q.containerSelected]: h || C,
        [q.containerDisabledAndSelected]: g && h,
        [q.containerNoninteractive]: l,
        [q.containerWithMenuOpen]: S && !l,
        [q.containerSelectedWithOpenMenu]: h && S && !l,
        [q.containerTextNonSelectable]: D,
        [q.containerDisabled]: g
      }),
      ref: L,
      style: { minWidth: `${ne}px` },
      tabIndex: Ee ? 0 : void 0,
      role: Ee ? "button" : void 0,
      "aria-pressed": Ee ? h : void 0,
      "aria-label": Ee ? U : void 0,
      onKeyDown: ke,
      children: [
        D ? null : se,
        H.map((J, ie) => /* @__PURE__ */ e1(
          "div",
          {
            ...Me,
            role: Ee ? "button" : void 0,
            key: `${e}-column-${ie}`,
            className: de(q.contentColumn, {
              [q.rightAlignedColumn]: J.alignment === "right",
              [q.firstColumn]: ie === 0 && (!O || D),
              [q.lastContentColumn]: ie === H.length - 1
            })
          },
          ie === 0 && Fe ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
            /* @__PURE__ */ r.jsx(
              lo,
              {
                parentId: e,
                hierarchySpec: d,
                density: "default"
              }
            ),
            c ? /* @__PURE__ */ r.jsx(
              "div",
              {
                className: q.hasChildrenLine,
                style: {
                  top: "3.75rem",
                  left: n === "default" || D ? `${d.length * 2.75 - 1.8}rem` : `${d.length * 2.75 - 2.75}rem`
                },
                children: /* @__PURE__ */ r.jsx(f1, { bottomLine: !0 })
              }
            ) : null
          ] }) : null,
          /* @__PURE__ */ r.jsxs("div", { className: q.internalContentColumn, children: [
            D && ie === 0 ? ve : null,
            Ae(J)
          ] })
        )),
        /* @__PURE__ */ r.jsx("div", { className: q.actionsContainer, children: A || M ? /* @__PURE__ */ r.jsx(
          Pt,
          {
            objectIds: [e],
            objectTestId: t,
            actionLists: a,
            noninteractive: g,
            setOpen: _,
            showDisabledMenuTrigger: M
          }
        ) : null }, `${e}-actions`),
        i && !h && !C && /* @__PURE__ */ r.jsx("div", { className: q.divider, children: /* @__PURE__ */ r.jsx(Ce, {}) }, `${e}-divider`)
      ]
    },
    e
  );
}, qd = ({
  id: e,
  heading: t,
  avatar: n,
  chip: o,
  subtext: a,
  info: i,
  infoMinWidth: l = 100,
  contentColumns: c = [],
  ...d
}) => {
  const p = [$d({
    parentTestId: e,
    avatar: n,
    heading: t,
    chip: o,
    subtext: a
  }), ...c];
  if (i) {
    const m = _d(i, l);
    p.push(m);
  }
  return /* @__PURE__ */ r.jsx(tr, { id: e, contentColumns: p, ...d });
}, Ud = R()(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  }
})), sm = ({
  id: e,
  testId: t = e,
  cards: n,
  variant: o,
  infoMinWidth: a,
  onSelection: i,
  onChecked: l
}) => {
  const { classes: c } = Ud(), [d, u] = V(null), [p, m] = V([]), g = (C) => {
    if (u(null), i == null || i(null), o === "checkbox") {
      const b = p.includes(C) ? p.filter((f) => f !== C) : [...p, C];
      m(b), l == null || l(b);
    }
  }, h = (C) => {
    d === C ? (u(null), i == null || i(null)) : (u(C), i == null || i(C), m([]), l == null || l([]));
  };
  return /* @__PURE__ */ r.jsx("div", { id: e, "data-testid": t, className: c.container, children: n.map((C) => /* @__PURE__ */ e1(
    qd,
    {
      ...C,
      id: C.id,
      testId: C.testId,
      key: C.id,
      variant: o,
      infoMinWidth: a,
      hasDivider: !1,
      selected: d === C.id,
      onSelection: ({ id: v }) => h(v),
      checked: p.includes(C.id),
      onChecked: ({ id: v }) => g(v),
      showHiddenInput: p.length > 0
    }
  )) });
}, Gd = X.create(() => ({
  noResultsContainer: {
    gridColumn: "1/100"
  }
})), Kd = (e, t) => {
  if (e !== 1)
    return t === 0 ? "start" : t === e - 1 ? "end" : "middle";
}, Yd = (e, t, n) => {
  if (!e) return !1;
  const o = t === e.id, a = n.includes(e.id);
  return o || a;
}, Qd = ({
  testId: e,
  items: t,
  selectedId: n,
  onSelection: o,
  checkedRowIds: a = [],
  onChecked: i,
  hierarchySpecs: l = E1(t),
  largestTreeLineWidth: c = Fo(l),
  flattened: d = !1,
  matchData: u = [],
  grouped: p = !1
}) => {
  const { classes: m } = Gd(), g = B1(t), h = d ? t : g, C = !d && g.length !== t.length, v = (p || C) && !d, b = p && !C ? t.length : l.length, f = (y) => y === h.length - 1 || d || !C && !p;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    h.map((y, w) => {
      var M;
      const k = (M = u.find(
        (L) => L.cardId === y.id
      )) == null ? void 0 : M.match;
      return /* @__PURE__ */ e1(
        tr,
        {
          ...y,
          key: `${e}-card-${y.id}`,
          hasChildren: y.childItems.length > 0,
          hierarchySpec: l[w],
          treePosition: v ? Kd(b, w) : void 0,
          largestTreeLineWidth: c,
          showTreeLines: !d,
          selected: n === y.id,
          onSelection: o,
          checked: a.includes(y.id),
          onChecked: i,
          hasDivider: f(w) ? !1 : y.hasDivider,
          hideTopBorder: v ? Yd(h[w - 1], n, a) : !1,
          showHiddenInput: a.length > 0,
          matchData: k,
          overrideSubtext: C && (k != null && k.attribute) ? y.cardPath : void 0
        }
      );
    }),
    h.length === 0 ? /* @__PURE__ */ r.jsx("div", { className: m.noResultsContainer, children: /* @__PURE__ */ r.jsx(b1, {}) }) : null
  ] });
}, C2 = (e) => {
  const t = () => window.sessionStorage.getItem(e), n = (l) => window.sessionStorage.setItem(e, l), o = (l) => {
    const c = t();
    if (c)
      try {
        return JSON.parse(c);
      } catch {
        i();
      }
    return l;
  }, a = (l) => {
    if (l === void 0) {
      i();
      return;
    }
    n(JSON.stringify(l));
  }, i = () => window.sessionStorage.removeItem(e);
  return {
    getJsonItem: o,
    setJsonItem: a,
    removeItem: i
  };
}, Xd = R()((e) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    "--data-grid-chrome-padding": "1.5rem"
  },
  chrome: {
    backgroundColor: e.palette.neutral[20],
    borderRadius: "1rem",
    padding: "var(--data-grid-chrome-padding) var(--data-grid-chrome-padding) 3rem var(--data-grid-chrome-padding)",
    width: "100%"
  },
  dataGridContainer: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  downloadDialogContents: {
    textAlign: "center"
  }
})), Jd = R()(
  (e, { columnDefinition: t, useSubgrid: n, combineItems: o, noResults: a }) => ({
    containerWrapper: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1
    },
    container: {
      borderRadius: "1rem",
      flexGrow: a ? 1 : "unset",
      alignContent: a ? "start" : void 0,
      display: "grid",
      gridTemplateColumns: t,
      gridRowGap: o ? "unset" : "0.5rem",
      [e.breakpoints.down(480)]: {
        padding: 0
      }
    },
    headerRow: {
      padding: "0 1rem 0 1rem",
      marginBottom: o ? "0.5rem" : "0rem",
      display: "grid",
      gridTemplateColumns: n ? "subgrid" : t,
      gridColumn: "1/100",
      alignItems: "center"
    },
    rightAlignedHeading: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "end",
      // contentColumn insets row content 1rem from the column track edge, so the
      // heading needs the same inset to share a right edge. The actions column is
      // its own grid track and never moves this edge.
      paddingRight: "1rem"
    },
    group: {
      display: "grid",
      gridTemplateColumns: "subgrid",
      gridColumn: "1/100",
      gridRowGap: o ? "unset" : "0.5rem",
      marginBottom: "0.5rem"
    },
    groupWithBottomMargin: {
      marginBottom: "1.5rem"
    },
    lastGroup: {
      marginBottom: 0
    },
    groupHeading: {
      display: "block",
      marginBottom: o ? "0.5rem" : "unset",
      gridColumn: "1/100"
    },
    noResultsContainer: {
      gridColumn: "1/100"
    },
    alertContainer: {
      gridColumn: "1/100"
    }
  })
), eu = 32, zo = R()((e, { maxWidth: t }, n) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    border: 0,
    borderRadius: "1rem",
    backgroundColor: "inherit",
    // No right padding: a right-aligned heading's label must end exactly at the
    // rightAlignedHeading wrapper's edge to line up with the row content below.
    padding: "0.3125rem 0 0.3125rem 0.5rem",
    marginLeft: "-0.5rem"
  },
  interactive: {
    padding: "0 0 0 0.5rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: vr,
      [`& .${n.sortIcon}`]: {
        opacity: 1
      }
    },
    "&:active": {
      backgroundColor: V3
    },
    "&:focus-visible": {
      backgroundColor: vr,
      outline: `1px solid ${e.palette.primary["60-key"]}`,
      outlineOffset: "1px"
    }
  },
  label: {
    ...e.typography.label,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    // This subtraction helps account for the sort icon and spacing width.
    maxWidth: t ? t - eu : void 0
  },
  sortIcon: {
    color: e.palette.neutral[80],
    opacity: 0.25
  },
  activeSortIcon: {
    color: e.palette.neutral[80]
  }
})), tu = ({ direction: e }) => {
  const { classes: t } = zo({ maxWidth: void 0 });
  return e === "ascending" ? /* @__PURE__ */ r.jsx(te, { name: "arrow-down", className: t.activeSortIcon }) : e === "descending" ? /* @__PURE__ */ r.jsx(te, { name: "arrow-up", className: t.activeSortIcon }) : /* @__PURE__ */ r.jsx(te, { name: "sort", className: t.sortIcon });
}, ru = ({
  testId: e,
  children: t,
  sortDirection: n,
  onClick: o,
  maxWidth: a,
  sortable: i = !0
}) => {
  const l = Z(null), c = Z(null), [d, u] = V(!1), { cx: p, classes: m } = zo({
    maxWidth: d ? a : void 0
  });
  cn(() => {
    var C;
    if (!a || a <= 0) {
      u(!1);
      return;
    }
    if (d) return;
    const h = l.current ? l.current.clientWidth : (C = c.current) == null ? void 0 : C.clientWidth;
    h && u(h > a);
  }, [a, d]);
  const g = i ? /* @__PURE__ */ r.jsxs(
    "button",
    {
      ref: l,
      "data-testid": e,
      type: "button",
      className: p(m.container, m.interactive),
      onClick: o,
      children: [
        /* @__PURE__ */ r.jsx(W, { className: m.label, children: t }),
        /* @__PURE__ */ r.jsx(tu, { direction: n })
      ]
    }
  ) : /* @__PURE__ */ r.jsx("div", { ref: c, "data-testid": e, className: m.container, children: /* @__PURE__ */ r.jsx(W, { className: m.label, children: t }) });
  return d ? /* @__PURE__ */ r.jsx(he, { testId: `${e}-tooltip`, title: t, children: g }) : g;
}, nu = R()((e) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.5rem",
    marginTop: "1rem",
    minWidth: "max-content"
  },
  button: {
    backgroundColor: "transparent",
    whiteSpace: "nowrap",
    "&:hover, &:active, &:focus, &:disabled": {
      backgroundColor: "transparent"
    }
  },
  helperText: {
    ...e.typography.body3,
    color: e.palette.neutral[70]
  }
})), ou = ({
  parentTestId: e,
  buttonProps: t,
  disabledTooltip: n,
  helperText: o
}) => {
  const { classes: a } = nu();
  if (!t && !o) return null;
  const i = (t == null ? void 0 : t.disabled) && n, l = t ? /* @__PURE__ */ r.jsx(G, { ...t, buttonVariant: "text", className: a.button }) : null;
  return /* @__PURE__ */ r.jsxs("div", { "data-testid": `${e}-footer`, className: a.root, children: [
    i ? /* @__PURE__ */ r.jsx(
      he,
      {
        testId: `${e}-footer-tooltip`,
        title: n,
        size: "auto",
        children: /* @__PURE__ */ r.jsx("div", { children: l })
      }
    ) : l,
    o ? /* @__PURE__ */ r.jsx(
      W,
      {
        "data-testid": `${e}-footer-helper-text`,
        className: a.helperText,
        children: o
      }
    ) : null
  ] });
}, au = ({
  parentTestId: e,
  headings: t,
  selectedHeadingIds: n,
  onSelection: o
}) => {
  const { translations: a } = Q(), [i, l] = V(!1), c = Z(null), d = t.slice(1, t.length).map((u) => ({
    ...u,
    testId: u.testId ?? u.id,
    selected: n.includes(u.id),
    variant: "checkbox"
  }));
  return /* @__PURE__ */ r.jsxs("div", { ref: c, children: [
    /* @__PURE__ */ r.jsx(
      he,
      {
        id: `${e}-settings-button-tooltip`,
        testId: `${e}-settings-button-tooltip`,
        title: a.data_grid.table_options,
        children: /* @__PURE__ */ r.jsx(
          G,
          {
            size: "small",
            buttonVariant: "icon",
            icon: "settings-small",
            iconVariant: "neutral",
            onClick: () => l(!0),
            "aria-label": a.data_grid.table_options,
            testId: `${e}-settings-button`
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsx(
      ze,
      {
        anchorRef: c,
        open: i,
        onClose: () => l(!1),
        children: /* @__PURE__ */ r.jsx(
          l1,
          {
            items: d,
            fullHeight: !0,
            itemComponent: Se,
            onSelection: ({ id: u }) => {
              o(u);
            }
          }
        )
      }
    )
  ] });
}, iu = ({
  open: e,
  onClose: t,
  headings: n,
  sortHeadingId: o,
  onSelection: a
}) => {
  const { translations: i } = Q();
  return /* @__PURE__ */ r.jsx(
    T2,
    {
      open: e,
      onClose: t,
      variant: "modal",
      contentSpacing: "fullWidth",
      headerProps: {
        heading: i.data_grid.sort_drawer_heading,
        showCloseButton: !0
      },
      children: /* @__PURE__ */ r.jsx(
        Ie,
        {
          variant: "spacious",
          lists: [
            {
              variant: "spacious",
              items: n.map((l) => ({
                ...l,
                size: "spacious",
                testId: l.testId ?? l.id,
                selected: l.id === o,
                variant: "radio"
              })),
              itemComponent: Se,
              onSelection: ({ id: l }) => {
                a(l);
              }
            }
          ]
        }
      )
    }
  );
}, lu = (e, t) => e.filter((n) => t.includes(n.id)), su = (e, t, n) => {
  const o = n.map(
    (a) => t.findIndex((i) => i.id === a)
  );
  return e.filter(
    (a, i) => o.includes(i)
  );
}, cu = ({
  headings: e,
  selectedHeadingIds: t,
  sampleCardColumns: n,
  hasActions: o,
  hasInput: a,
  visibleWidth: i,
  largestTreeLineWidth: l
}) => {
  const c = lu(e, t), d = su(
    n,
    e,
    t
  ), { combineAvatarAndInput: u, visibleHeadings: p, templateColumnsDefinition: m } = Do({
    headings: c,
    columns: d,
    hasActions: o,
    hasInput: a,
    maxWidth: i,
    largestTreeLineWidth: l,
    inGrid: !0
  }), g = p.map(
    (h) => e.findIndex((C) => C.id === h.id)
  );
  return {
    combineAvatarAndInput: u,
    visibleHeadings: p,
    templateColumnsDefinition: m,
    visibleHeadingIndices: g
  };
}, v2 = (e, t) => e === void 0 && t === void 0 ? 0 : e === void 0 ? 1 : t === void 0 ? -1 : e.localeCompare(t, void 0, {
  numeric: !0,
  sensitivity: "base"
}), At = (e, t) => {
  var o;
  const n = (o = e.contentColumns) == null ? void 0 : o[t];
  if (n)
    return n.sortValue ? n.sortValue() : tt(n) ? n.content.heading : typeof n.content == "string" ? n.content : void 0;
}, f2 = (e, t, n) => {
  if (n === void 0) return e;
  const o = t.findIndex(
    (i) => i.id === n.id
  ), a = [...e].sort(
    (i, l) => v2(At(i, o), At(l, o))
  );
  return n.direction === "descending" ? a.reverse() : a;
}, du = (e, t, n) => {
  var l;
  if (n === void 0) return Object.keys(e);
  const o = t.findIndex(
    (c) => c.id === n.id
  ), a = n.id === ((l = t[0]) == null ? void 0 : l.id), i = [...Object.keys(e)].sort((c, d) => {
    var h, C;
    if (a)
      return v2(c, d);
    const u = (h = e[c]) == null ? void 0 : h[0], p = (C = e[d]) == null ? void 0 : C[0], m = u ? At(u, o) : c, g = p ? At(p, o) : d;
    return v2(m, g);
  });
  return n.direction === "descending" ? i.reverse() : i;
}, uu = (e, t, n) => {
  const [o, a] = V(
    n
  ), i = (c) => {
    (o == null ? void 0 : o.id) === c ? o.direction === "ascending" ? a({ id: c, direction: "descending" }) : a(void 0) : a({ id: c, direction: "ascending" });
  }, l = f2(e, t, o);
  return {
    sortHeading: o,
    sortedData: l,
    sortByHeading: i
  };
}, pu = (e, t, n) => {
  const o = e ?? 0;
  if (!(t != null && t.contentColumns)) return [];
  if (n.length === 0) return [];
  const a = t.contentColumns.filter(
    (p, m) => n.includes(m)
  ), i = a.reduce(
    (p, m) => p + (m.maxWidth ?? 0),
    0
  ) || 0, l = o - (i + Dd(t)), c = a.reduce(
    (p, m) => p + (m.maxWidth ? 0 : 1),
    0
  ) || 0, d = l / c;
  return t.contentColumns.map(
    (p) => p.maxWidth ?? d - 8
  );
}, rr = (e) => [e.id, ...e.childItems.flatMap(rr)], Wo = (e) => e.childItems.length + e.childItems.map(Wo).reduce((t, n) => t + n, 0), mu = (e) => e.reduce((t, n) => t + 1 + Wo(n), 0), x2 = (e, t) => hu(e, t).filter((n) => n).join(" › "), hu = (e, t, n = []) => {
  var i;
  if (!e) return [];
  const o = t.find((l) => l.id === e);
  if (!o) return [];
  const a = (i = o.contentColumns) == null ? void 0 : i[0];
  return a && tt(a) ? [
    ...n,
    a.content.heading,
    x2(o.parentId, t)
  ] : [...n, x2(o.parentId, t)];
}, cm = (e) => e.rootName, gu = (e, t, n = "session") => ({
  id: `empty-${h0(e.singular_item_name)}-set`,
  disabled: !0,
  hasDivider: !1,
  contentColumns: [
    {
      kind: "primary-with-avatar",
      content: {
        heading: `No ${e.plural_item_name.toLocaleLowerCase()}`,
        avatar: /* @__PURE__ */ r.jsx(we, { icon: n, iconAvatarColor: "neutral" }),
        parentTestId: t
      }
    }
  ]
}), Oo = ({
  testId: e,
  headings: t,
  data: n,
  matchData: o = [],
  rawDataCount: a,
  customDummyCard: i,
  labels: l,
  defaultIcon: c,
  onRowClick: d,
  selectedRowId: u,
  onRowChecked: p,
  checkedRows: m,
  showSettingsButton: g = !0,
  flattened: h = !1,
  groupRowsBy: C,
  hideGroupLabels: v = !1,
  footerProps: b,
  withinTree: f = !1,
  showHeadings: y = !0,
  enableSorting: w = !0,
  alertProps: k,
  onClearFilters: M
}) => {
  const L = Z(null), [j, N] = V(
    void 0
  ), E = E1(n), $ = Fo(E), S = n.some(
    (re) => re.actionLists && re.actionLists.length > 0
  ), _ = n.some(
    (re) => re.showDisabledMenuTrigger
  ), B = n[0] ? n[0].variant === "checkbox" : !1, O = t.length, A = M1(() => {
    const re = i ?? gu(l, e, c), Y = re.contentColumns ?? [];
    return Y.length >= O ? re : {
      ...re,
      contentColumns: [
        ...Y,
        ...Array.from(
          { length: O - Y.length },
          () => ({ content: null })
        )
      ]
    };
  }, [i, O, l, e, c]), F = M1(
    () => {
      var re;
      return ((re = n[0]) == null ? void 0 : re.contentColumns) ?? A.contentColumns ?? [];
    },
    [n, A]
  ), { getJsonItem: z, setJsonItem: I } = C2(`${e}-columns`), D = () => g ? z(t.map((re) => re.id)) : t.map((re) => re.id), [H, T] = V(D());
  K(() => {
    H.length > 0 && I(H);
  }, [H, I]);
  const ne = g && t.length > 1, de = {
    headings: t,
    selectedHeadingIds: H,
    sampleCardColumns: F,
    hasActions: S || g || _,
    hasInput: B,
    visibleWidth: j,
    largestTreeLineWidth: $
  }, {
    combineAvatarAndInput: q,
    visibleHeadings: U,
    visibleHeadingIndices: se,
    templateColumnsDefinition: ve
  } = cu(de), ye = se.length <= 1 ? 0 : er(
    $,
    B,
    S || g || _,
    F.slice(0, 1),
    !0
  ), Me = Tt(L), Ee = n[0] ?? A, ke = pu(
    Me,
    Ee,
    se
  ), { getJsonItem: Ae, setJsonItem: Fe } = C2(`${e}-sorting`), J = t[0] ? f2(n, t, { id: t[0].id, direction: "ascending" }) : n, { sortHeading: ie, sortedData: be, sortByHeading: P } = uu(
    J,
    t,
    Ae(void 0)
  ), ee = t.findIndex(
    (re) => re.id === (ie == null ? void 0 : ie.id)
  );
  K(() => {
    Fe(ie);
  }, [ie, Fe]), K(() => {
    const re = () => {
      var ae;
      const Y = (ae = L.current) == null ? void 0 : ae.clientWidth;
      Y && N(Y - 48 - 48);
    };
    return re(), window.addEventListener("resize", re), () => window.removeEventListener("resize", re);
  }, [F, S, g, B]);
  const oe = J3(), { cx: fe, classes: xe, theme: Be } = Jd({
    columnDefinition: ve,
    useSubgrid: oe,
    combineItems: (!!C || f) && !h,
    noResults: be.length === 0
  }), [Ye, le] = V(!1), ce = $e(
    Be.breakpoints.down(B0)
  ), ge = (re, Y, ae, pe, He, Ne = !1) => /* @__PURE__ */ r.jsx(
    Qd,
    {
      testId: re,
      items: Y,
      selectedId: ae,
      onSelection: ({ id: De }) => d(De),
      checkedRowIds: pe,
      onChecked: ({ id: De }) => p(De),
      hierarchySpecs: He,
      largestTreeLineWidth: $,
      flattened: h,
      matchData: o,
      grouped: Ne
    }
  ), Ge = () => {
    if (!C) return;
    const re = ie ?? (t[0] ? { id: t[0].id, direction: "ascending" } : void 0), Y = g0(n, C), ae = du(Y, t, re);
    return ae.length > 0 ? ae.map((pe, He) => {
      const Ne = f2(
        Y[pe] ?? [],
        t,
        re
      ), De = E1(Ne), t1 = u, h1 = Ne.reduce(
        (r1, n1) => [...r1, ...rr(n1)],
        []
      ), g1 = m.filter(
        (r1) => h1.includes(r1)
      );
      return /* @__PURE__ */ r.jsxs(
        "div",
        {
          className: fe(xe.group, {
            [xe.groupWithBottomMargin]: !v,
            [xe.lastGroup]: He === ae.length - 1
          }),
          children: [
            v ? null : /* @__PURE__ */ r.jsx(W, { variant: "overline", className: xe.groupHeading, children: pe }),
            ge(
              `${e}-card-tree-${pe}`,
              Ne,
              t1,
              g1,
              De,
              !0
            )
          ]
        },
        pe
      );
    }) : /* @__PURE__ */ r.jsx("div", { className: xe.noResultsContainer, children: /* @__PURE__ */ r.jsx(b1, { onClearFilters: M }) });
  }, lt = () => a === 0 && !M ? /* @__PURE__ */ r.jsx(tr, { ...A }) : be.length === 0 && !C ? /* @__PURE__ */ r.jsx("div", { className: xe.noResultsContainer, children: /* @__PURE__ */ r.jsx(b1, { onClearFilters: M }) }) : C ? Ge() : ge(
    `${e}-card-tree`,
    be,
    u,
    m,
    E,
    !1
  ), st = (re, Y) => {
    var h1, g1, r1;
    let ae = re.label, pe = F1(re);
    if (Y === 0 && ie && ce) {
      const n1 = t.find(
        (Yo) => Yo.id === ie.id
      );
      pe = F1(n1 ?? re), ae = (n1 == null ? void 0 : n1.label) ?? re.label;
    }
    const Ne = q && Y == 0 ? void 0 : `${re.paddingLeft ?? 0}px`, De = (r1 = (g1 = (h1 = n[0]) == null ? void 0 : h1.contentColumns) == null ? void 0 : g1[Y]) == null ? void 0 : r1.maxWidth, t1 = De && De < (ke[Y] ?? 1e4) ? De : ke[Y];
    return ae ? /* @__PURE__ */ r.jsx(
      "div",
      {
        className: re.alignment === "right" ? xe.rightAlignedHeading : "",
        style: { paddingLeft: Ne },
        children: /* @__PURE__ */ r.jsx(
          ru,
          {
            testId: `${e}-heading-${Pe(ae)}`,
            sortDirection: pe,
            onClick: () => z1(re),
            sortable: w,
            maxWidth: t1,
            children: ae
          }
        )
      },
      `${re.label}-${Y}`
    ) : /* @__PURE__ */ r.jsx("div", {}, `empty-heading-${Y}`);
  }, F1 = (re) => (ie == null ? void 0 : ie.id) === re.id ? ie.direction : void 0, z1 = (re) => {
    if (ce) {
      le(!0);
      return;
    }
    P(re.id);
  }, W1 = (re) => {
    const Y = A1(H, re);
    T(Y);
  }, ct = () => /* @__PURE__ */ r.jsxs("div", { ref: L, className: xe.container, children: [
    k && /* @__PURE__ */ r.jsx(
      "div",
      {
        className: xe.alertContainer,
        style: { minWidth: `${ye}px` },
        children: /* @__PURE__ */ r.jsx(Ke, { ...k })
      }
    ),
    y ? /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: xe.headerRow,
        style: { minWidth: `${ye}px` },
        children: [
          B && !q ? /* @__PURE__ */ r.jsx("div", {}) : null,
          U.map(
            (re, Y) => st(re, Y)
          ),
          S || g ? /* @__PURE__ */ r.jsx("div", { style: { display: "grid", placeItems: "center" }, children: ne ? /* @__PURE__ */ r.jsx(
            au,
            {
              parentTestId: e,
              headings: t,
              selectedHeadingIds: H,
              onSelection: W1
            }
          ) : null }) : null
        ]
      }
    ) : null,
    lt()
  ] });
  return /* @__PURE__ */ r.jsxs(
    yd,
    {
      combineAvatarAndInput: q,
      visibleColumnIndices: se,
      templateColumnsDefinition: ve,
      minimumWidth: ye,
      visibleWidth: j,
      useSubgrid: oe,
      sortColumnIndex: ce ? ee : void 0,
      children: [
        b ? /* @__PURE__ */ r.jsxs("div", { className: xe.containerWrapper, children: [
          ct(),
          /* @__PURE__ */ r.jsx(ou, { parentTestId: e, ...b })
        ] }) : ct(),
        /* @__PURE__ */ r.jsx(
          iu,
          {
            open: Ye,
            onClose: () => le(!1),
            headings: t,
            sortHeadingId: ie == null ? void 0 : ie.id,
            onSelection: (re) => {
              P(re), le(!1);
            }
          }
        )
      ]
    }
  );
}, dm = (e) => {
  var d;
  const t = ((d = e.data[0]) == null ? void 0 : d.variant) ?? "default", [n, o] = V(
    void 0
  ), [a, i] = V([]);
  k2(
    e.ref,
    () => ({
      clearCheckedAndSelected: () => {
        o(void 0), i([]);
      }
    }),
    [i, o]
  );
  const l = (u) => {
    var p, m, g;
    n === u ? (o(void 0), (p = e.onSelection) == null || p.call(e, void 0)) : (o(u), (m = e.onSelection) == null || m.call(e, u), i([]), (g = e.onChecked) == null || g.call(e, []));
  }, c = (u) => {
    var p, m;
    if (t === "checkbox") {
      o(void 0), (p = e.onSelection) == null || p.call(e, void 0);
      const h = a.includes(u) ? a.filter((C) => C !== u) : [...a, u];
      i(h), (m = e.onChecked) == null || m.call(e, h);
    }
  };
  return /* @__PURE__ */ r.jsx(
    Oo,
    {
      ...e,
      selectedRowId: n,
      onRowClick: l,
      checkedRows: a,
      onRowChecked: c,
      showSettingsButton: !1,
      rawDataCount: e.data.length
    }
  );
}, nr = "clear-all", Cu = (e) => {
  var t;
  return (t = e.actionLists) == null ? void 0 : t.flat().filter((n) => n.bulkAction ?? !0);
}, vu = (e) => e !== void 0, fu = (e) => !e || !e.actionLists ? [] : [e.actionLists.flat()], Zo = (e, t) => {
  if (t.length === 1) {
    const o = B1(e).find((a) => a.id === t[0]);
    return fu(o);
  }
  return e.reduce((n, o) => {
    const a = t.includes(o.id) ? Cu(o) : void 0, i = Zo(o.childItems, t);
    return [...n, a, ...i].filter(vu);
  }, []);
}, xu = (e, t) => {
  const n = Zo(e, t);
  return C0(...n, (o) => o.id);
}, bu = (e, t) => t > 1 ? e.bulkLabel ?? e.label : e.label, s1 = 768, wu = R()((e, { showActionBar: t, topStyleOffset: n }) => ({
  root: {
    position: "relative",
    zIndex: xn,
    padding: "1rem 0",
    [e.breakpoints.down(s1)]: {
      padding: "1rem 0 0.625rem 0"
    }
  },
  rootActionBar: {
    paddingTop: "0.625rem",
    paddingBottom: "0.625rem"
  },
  rootSticky: {
    position: "sticky",
    top: "var(--data-grid-sticky-offset, 0)",
    background: e.palette.neutral.white,
    "--header-bg": e.palette.neutral.white,
    borderRadius: 0,
    margin: "0 -1.5rem 0 -1.5rem",
    padding: "1rem 1.5rem 1rem 1.5rem",
    boxShadow: e.namedShadows["depth-down"],
    height: "auto"
  },
  rootPrepend: {
    position: "absolute",
    top: `${n}px`,
    height: 1,
    // When the DataGrid is not chromeless, the header is offset from the top of the page.
    "[class*='root-chrome'] &": {
      top: "1.5rem"
    }
  },
  hidden: {
    display: "none"
  },
  topContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    [e.breakpoints.down(s1)]: {
      flexDirection: t ? "row" : "column-reverse"
    }
  },
  topContainerActionBar: {
    background: e.palette.neutral[30],
    borderRadius: "2.25rem",
    padding: "0.5rem 0.5rem 0.5rem 0"
  },
  leftContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    [e.breakpoints.down(s1)]: {
      marginTop: t ? void 0 : "0.35rem"
    }
  },
  checkbox: {
    marginLeft: "0.4125rem",
    alignItems: "center",
    "> div": {
      marginTop: 0
    },
    "& .MuiTypography-root": {
      ...e.typography.h3,
      fontWeight: 600,
      minWidth: "max-content"
    },
    [e.breakpoints.down(s1)]: t ? {} : {
      marginLeft: 0
    }
  },
  countLabel: {
    marginLeft: "0.4125rem",
    marginTop: "0.25rem",
    [e.breakpoints.down(s1)]: {
      marginTop: "0.375rem"
    },
    minWidth: "max-content"
  },
  actionsContainer: {
    marginLeft: "0.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "0.5rem"
  },
  rightContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1rem",
    [e.breakpoints.down(s1)]: {
      gap: "0.5rem"
    }
  },
  searchFieldContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    width: "20rem",
    [e.breakpoints.down(s1)]: {
      width: "100%"
    }
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  filterItemsWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    zIndex: 10,
    maxWidth: "100%",
    overflow: "hidden",
    padding: "0 0 0 0.25rem",
    height: 0,
    [e.breakpoints.down(s1)]: {
      paddingBottom: 0
    }
  },
  filterItemsWrapperOpen: {
    height: "3rem",
    overflow: "visible",
    paddingTop: "1rem",
    paddingBottom: "0.25rem"
  },
  filterItemsContainer: {
    flex: "0 1 auto",
    minWidth: 0,
    div: {
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      gap: "0.25rem"
    },
    // NOTE: (2024-09-23) Noah Settersten => These following three properties allow the filter chips to appear the same
    // before and after the scrollbars library initializes. These properties style the chips before, and the styles
    // under the descendant `div` above style the chips after (since the scrollbar library wraps the contents).
    display: "flex",
    flexDirection: "row",
    gap: "0.25rem"
  },
  filterItemsContainerMasked: {
    maskImage: "linear-gradient(to right, black calc(100% - 1.5rem), transparent 100%)"
  },
  chipsMaskSpacer: {
    flexShrink: 0,
    minWidth: "1.5rem"
  },
  clearAllButton: {
    flexShrink: 0
  }
})), yu = ({
  parentTestId: e,
  itemCount: t,
  labels: n,
  checkedIds: o,
  onCheckAll: a,
  actions: i,
  searchValue: l,
  onSearch: c,
  filterChips: d,
  topStyleOffset: u = 0,
  onFilterChipSelected: p,
  onDownload: m,
  onInfo: g
}) => {
  const { translations: h } = Q(), C = Ve(), v = o.length, b = v > 0, f = Z(null), y = Z(null), w = Z(null), [k, M] = V(!1), { cx: L, classes: j } = wu({
    showActionBar: b,
    topStyleOffset: u
  }), [N, E] = V(!0), $ = v === t && t > 0, S = v > 0 && v < t, _ = N && d.length > 0 && !b, B = d.some((T) => T.selected), O = () => p == null ? void 0 : p(nr), A = nn(C.breakpoints.down(768)), F = mo(
    w,
    y,
    v
  );
  K(() => {
    if (f.current) {
      const T = (de) => {
        de.forEach((q) => {
          const U = q.intersectionRatio < 1;
          M(U);
        });
      }, ne = new IntersectionObserver(T, {
        threshold: [0, 1]
      });
      return ne.observe(f.current), () => ne.disconnect();
    }
  }, []);
  const z = b ? `${v} ${h.data_grid.selected_count_suffix}` : `${t} ${t === 1 ? n.singular_item_name : n.plural_item_name}`, I = t === 0, D = p ? /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: L(j.filterItemsWrapper, {
        [j.filterItemsWrapperOpen]: _,
        [j.hidden]: b
      }),
      children: [
        /* @__PURE__ */ r.jsxs(
          ue,
          {
            removeFromTabOrder: !0,
            disableVerticalScroll: !0,
            theme: "os-theme-hidden",
            className: L(j.filterItemsContainer, {
              [j.filterItemsContainerMasked]: B
            }),
            children: [
              d.map((T, ne) => /* @__PURE__ */ r.jsx(
                uo,
                {
                  index: ne,
                  parentTestId: e,
                  filterChip: T,
                  onSelected: p
                },
                ne
              )),
              B && /* @__PURE__ */ r.jsx("div", { className: j.chipsMaskSpacer, "aria-hidden": "true" })
            ]
          }
        ),
        B ? /* @__PURE__ */ r.jsx(
          G,
          {
            className: j.clearAllButton,
            buttonVariant: "basicText",
            size: "small",
            label: h.common.clear_all,
            onClick: O
          }
        ) : null
      ]
    }
  ) : null, H = (T) => T.iconLeftVariant === "documentation" ? "neutral" : T.iconLeftVariant ?? "neutral";
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("div", { ref: f, className: j.rootPrepend }),
    /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: L(j.root, {
          [j.rootSticky]: k,
          [j.rootActionBar]: b
        }),
        ref: w,
        children: [
          /* @__PURE__ */ r.jsxs(
            "div",
            {
              className: L(j.topContainer, {
                [j.topContainerActionBar]: b
              }),
              children: [
                /* @__PURE__ */ r.jsxs("div", { className: j.leftContainer, children: [
                  a ? /* @__PURE__ */ r.jsx(
                    p1,
                    {
                      id: `${e}-select-all-checkbox`,
                      testId: `${e}-select-all-checkbox`,
                      checked: $ || S,
                      label: z,
                      onValueChange: ({ value: T }) => a(T),
                      type: S ? "dash" : "check",
                      className: j.checkbox
                    }
                  ) : /* @__PURE__ */ r.jsx(
                    W,
                    {
                      variant: "h3",
                      "data-testid": `${e}-total-count`,
                      className: j.countLabel,
                      children: z
                    }
                  ),
                  /* @__PURE__ */ r.jsxs(
                    "div",
                    {
                      className: L(j.actionsContainer, {
                        [j.hidden]: !b
                      }),
                      children: [
                        !F && i.map((T) => /* @__PURE__ */ r.jsx(
                          he,
                          {
                            testId: `${T.testId ?? T.id}-tooltip`,
                            title: bu(T, v),
                            children: /* @__PURE__ */ r.jsx(
                              G,
                              {
                                buttonVariant: "icon",
                                icon: T.iconLeft,
                                testId: `${T.testId ?? T.id}-button`,
                                iconVariant: H(T),
                                onClick: () => T.onClick(T.id, o)
                              }
                            )
                          },
                          T.id
                        )),
                        F && /* @__PURE__ */ r.jsx(
                          Pt,
                          {
                            objectIds: o,
                            objectTestId: e,
                            actionLists: i
                          }
                        )
                      ]
                    }
                  )
                ] }),
                A ? D : null,
                /* @__PURE__ */ r.jsxs("div", { className: j.rightContainer, ref: y, children: [
                  /* @__PURE__ */ r.jsx(
                    "div",
                    {
                      className: L(j.searchFieldContainer, {
                        [j.hidden]: b
                      }),
                      children: /* @__PURE__ */ r.jsx(
                        y1,
                        {
                          id: `${e}-search-field`,
                          placeholderText: h.common.search,
                          value: l,
                          handleOnChange: (T, ne) => c(ne),
                          label: h.common.search,
                          labelHidden: !0,
                          leftIcon: "search",
                          leftIconStyle: {
                            color: C.palette.neutral[30]
                          },
                          showClearButton: !0
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ r.jsxs(
                    "div",
                    {
                      className: L(j.buttonContainer, {
                        [j.hidden]: b
                      }),
                      children: [
                        d.length > 0 ? /* @__PURE__ */ r.jsx(
                          he,
                          {
                            testId: `${e}-filter-tooltip`,
                            title: h.data_grid.filter_tooltip,
                            children: /* @__PURE__ */ r.jsx(
                              G,
                              {
                                testId: `${e}-filter-button`,
                                buttonVariant: "icon",
                                icon: "filter",
                                iconVariant: "neutral",
                                "aria-label": h.data_grid.filter_tooltip,
                                onClick: () => {
                                  E(!N);
                                }
                              }
                            )
                          }
                        ) : null,
                        m ? /* @__PURE__ */ r.jsx(
                          he,
                          {
                            testId: `${e}-download-tooltip`,
                            title: I ? h.data_grid.download_tooltip_disabled : h.data_grid.download_tooltip,
                            size: "auto",
                            children: /* @__PURE__ */ r.jsx(
                              G,
                              {
                                testId: `${e}-download-button`,
                                disabled: I,
                                buttonVariant: "icon",
                                icon: "download",
                                iconVariant: "neutral",
                                "aria-label": I ? h.data_grid.download_tooltip_disabled : h.data_grid.download_tooltip,
                                onClick: () => {
                                  m();
                                }
                              }
                            )
                          }
                        ) : null,
                        /* @__PURE__ */ r.jsx("div", { style: { display: "none" }, children: /* @__PURE__ */ r.jsx(
                          he,
                          {
                            testId: `${e}-info-tooltip`,
                            title: h.data_grid.info_tooltip,
                            children: /* @__PURE__ */ r.jsx(
                              G,
                              {
                                buttonVariant: "icon",
                                icon: "inverted-info",
                                iconVariant: "neutral",
                                title: h.data_grid.info_tooltip,
                                onClick: g
                              }
                            )
                          }
                        ) })
                      ]
                    }
                  ),
                  /* @__PURE__ */ r.jsx(
                    "div",
                    {
                      className: L(j.buttonContainer, {
                        [j.hidden]: !b
                      }),
                      children: /* @__PURE__ */ r.jsx(
                        he,
                        {
                          testId: `${e}-clear-selection-tooltip`,
                          title: h.data_grid.clear_selection_tooltip,
                          children: /* @__PURE__ */ r.jsx(
                            G,
                            {
                              buttonVariant: "icon",
                              icon: "cross",
                              iconVariant: "neutral",
                              title: h.data_grid.clear_selection_tooltip,
                              onClick: () => a == null ? void 0 : a(null)
                            }
                          )
                        }
                      )
                    }
                  )
                ] })
              ]
            }
          ),
          A ? null : D
        ]
      }
    )
  ] });
}, ku = (e) => e.map((t) => t.replace(/"/g, '""')), Or = (e) => `"${ku(e).join('","')}"`, ju = (e) => {
  const t = e.rows.map((n) => Or(n)).join(`
`);
  return Or(e.headings) + `
` + t;
}, Su = (e, t) => {
  if (!e) return;
  const n = ju(e), o = Xe(/* @__PURE__ */ new Date(), "yyyy_MM_dd");
  En({
    data: n,
    filename: `${t}_${o}.csv`,
    kind: "csv"
  });
}, Lu = (e, t) => {
  const n = t;
  return n && Z3(n) ? !e || e.length === 0 ? [n] : A1(e, n) : e ?? [];
}, Zr = (e) => Gr(e ?? {}).some((t) => !!t), Mu = (e, t, n, o) => {
  if (n === nr) return {};
  const a = e.find((i) => i.id === n);
  if (a)
    return Eu(a, t, o);
}, Eu = (e, t, n) => {
  if (n === void 0)
    return e.variant === "filter" ? {
      ...t,
      [e.id]: !t[e.id]
    } : {
      ...t,
      [e.id]: []
    };
  if (q2(e)) {
    const o = t[e.id] ?? [];
    if (fn(o)) {
      const a = Lu(
        o,
        n
      );
      return {
        ...t,
        [e.id]: a
      };
    }
  } else if (typeof n != "string")
    return {
      ...t,
      [e.id]: n
    };
  return t;
}, Nu = (e) => {
  if (e === !0) return !0;
  if (typeof e == "object") {
    if ("length" in e)
      return e.length > 0;
    if ("from" in e)
      return e.from !== void 0;
  }
  return !1;
}, Pr = (e) => Object.keys(e).reduce((t, n) => {
  const o = e[n];
  return o && Nu(o) ? [...t, n] : t;
}, []), um = (e, t) => {
  if ((e == null ? void 0 : e.from) === void 0) return !0;
  if (e.to === void 0)
    return q1(e.from, t);
  {
    const n = v0(f0(x0(e.to, 23), 59), 59);
    return o1(e.from, t) && o1(t, n);
  }
}, Iu = (e, t, n) => e ? e.map((a) => {
  if (so(a))
    return {
      ...a,
      value: t[a.id],
      selected: n.includes(a.id)
    };
  const i = $u(a, t);
  return q2(a) ? {
    ...a,
    selected: n.includes(a.id),
    listItems: i
  } : P2(a) ? {
    ...a,
    selected: n.includes(a.id),
    listItems: i,
    value: t[a.id]
  } : {
    ...a,
    selected: n.includes(a.id),
    listItems: i,
    value: t[a.id]
  };
}) : [], ft = (e, t) => e.map((n) => {
  const o = t.includes(n.id);
  return {
    ...n,
    selected: o
  };
}), $u = (e, t) => {
  if (!t[e.id]) return e.listItems ?? [];
  const n = t[e.id];
  return fn(n) ? q2(e) ? ft(e.listItems ?? [], n) : P2(e) ? ft(e.listItems, n) : z8(e.listItems) ? e.listItems.map(
    (o) => ft(o, n)
  ) : e.listItems.map(
    (o) => ft(o, n)
  ) : e.listItems ?? [];
}, Po = (e, t) => t ? e.reduce((n, o) => {
  const a = _u(o, t), i = a.matches ? [{ card: o, match: a }] : [], l = Po(o.childItems, t);
  return [...n, ...i, ...l];
}, []) : e.map((n) => ({ card: n })), _u = (e, t) => {
  var l;
  const n = t.toLowerCase(), o = Vu(n), a = (l = e.contentColumns) == null ? void 0 : l.map((c) => {
    if (tt(c)) {
      const { heading: d, subtext: u } = c.content, p = o(d, "heading");
      if (p.matches) return p;
      const m = o(u, "subtext");
      if (m.matches) return m;
    }
  }), i = a == null ? void 0 : a.find((c) => c == null ? void 0 : c.matches);
  return i || { matches: !1, query: n };
}, Vu = (e) => (t, n) => Au(t, n, e), Au = (e, t, n) => ({
  matches: e ? e.toLowerCase().includes(n) : !1,
  query: n,
  value: e,
  attribute: t
}), pm = (e) => {
  var de;
  const { translations: t } = Q(), { cx: n, classes: o } = Xd(), [a, i] = V(
    void 0
  ), [l, c] = V([]), [d, u] = V(""), { getJsonItem: p, setJsonItem: m } = C2(
    `${e.testId}-filters`
  ), g = Zr(e.selectedFilters) && e.selectedFilters ? e.selectedFilters : p({}), h = Z(() => {
    var U;
    const q = p({});
    Zr(q) && ((U = e.onFiltersUpdated) == null || U.call(e, q));
  });
  K(() => {
    h.current();
  }, []);
  const [C, v] = V(!1);
  k2(
    e.ref,
    () => ({
      clearCheckedAndSelected: () => {
        i(void 0), c([]);
      }
    }),
    [c, i]
  );
  const b = Po(e.data, d), f = b.map((q) => ({
    cardId: q.card.id,
    match: q.match
  })), y = B1(
    e.data
  ), w = b.map((q) => {
    var U;
    return {
      ...q.card,
      cardPath: x2(
        (U = y.find((se) => se.id === q.card.id)) == null ? void 0 : U.parentId,
        y
      )
    };
  }), k = d.length > 0, M = ((de = w[0]) == null ? void 0 : de.variant) ?? "default", L = k ? w.length : mu(w), j = l.length > 0 && l.length < L, N = w.flatMap((q) => rr(q)), E = (q) => {
    var se;
    if (e.multiSelect === !1) return;
    let U = [];
    q !== null && (U = q || j ? N : []), c(U), (se = e.onChecked) == null || se.call(e, U);
  }, $ = (q) => {
    var U, se, ve;
    a === q ? (i(void 0), (U = e.onSelection) == null || U.call(e, void 0)) : (i(q), (se = e.onSelection) == null || se.call(e, q), c([]), (ve = e.onChecked) == null || ve.call(e, []));
  }, S = (q) => {
    var U, se;
    if (e.multiSelect !== !1 && M === "checkbox") {
      i(void 0), (U = e.onSelection) == null || U.call(e, void 0);
      const ye = l.includes(q) ? l.filter((Me) => Me !== q) : [...l, q];
      c(ye), (se = e.onChecked) == null || se.call(e, ye);
    }
  }, _ = (q, U) => {
    var ve;
    const se = Mu(
      e.filterChips ?? [],
      g,
      q,
      U
    );
    se && (m(se), (ve = e.onFiltersUpdated) == null || ve.call(e, se));
  }, B = Pr(g), O = () => v(!0), A = () => {
  }, F = Iu(
    e.filterChips,
    g,
    B
  ), z = l.reduce((q, U) => N.includes(U) ? [...q, U] : q, []), I = xu(w, l), D = Pr(g).length > 0 || d.length > 0, H = w.length === 0 && D, T = () => {
    _(nr), u("");
  }, ne = w.length === 0 ? void 0 : e.multiSelect !== !1 ? E : void 0;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      "div",
      {
        "data-testid": e.testId,
        className: n(o.root, {
          [o.chrome]: !e.chromeless
        }),
        children: [
          /* @__PURE__ */ r.jsx(
            yu,
            {
              parentTestId: e.testId,
              itemCount: L,
              labels: e.labels,
              checkedIds: z,
              onCheckAll: ne,
              actions: I,
              searchValue: d,
              onSearch: u,
              filterChips: F,
              topStyleOffset: e.headerTopStyleOffset,
              onFilterChipSelected: _,
              onDownload: O,
              onInfo: A
            }
          ),
          /* @__PURE__ */ r.jsx("div", { className: o.dataGridContainer, children: /* @__PURE__ */ r.jsx(
            Oo,
            {
              ...e,
              headings: e.headings,
              data: w,
              rawDataCount: e.data.length,
              matchData: f,
              selectedRowId: a,
              onRowClick: $,
              checkedRows: l,
              onRowChecked: S,
              flattened: k,
              footerProps: H ? void 0 : e.footerProps,
              withinTree: y.length !== e.data.length,
              onClearFilters: D ? T : void 0
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ r.jsx(
      Q2,
      {
        onClose: () => v(!1),
        testId: `${e.testId}-download-dialog`,
        headline: t.data_grid.download_dialog.headline,
        contentArea: /* @__PURE__ */ r.jsx("div", { className: o.downloadDialogContents, children: t.data_grid.download_dialog.content_area_text(
          L,
          L === 1 ? e.labels.singular_item_name : e.labels.plural_item_name
        ) }),
        isOpen: C,
        showCloseButton: !0,
        actions: [
          {
            label: t.data_grid.download_dialog.cancel_label,
            type: "cancel"
          },
          {
            label: t.data_grid.download_dialog.download_submit_label,
            type: "submit",
            onClick: () => {
              v(!1), Su(
                e.generateCsvData(e.data),
                Pe(e.testId)
              );
            }
          }
        ]
      }
    )
  ] });
}, mm = ({
  prefix: e,
  label: t,
  name: n,
  validateOnChange: o,
  ...a
}) => {
  const { setValue: i, trigger: l, watch: c } = Ue();
  return /* @__PURE__ */ r.jsx(
    p1,
    {
      ...a,
      id: `${e}-${n}`,
      testId: `${e}-${n}`,
      name: n,
      label: t,
      checked: c(n),
      onValueChange: ({ value: d }) => {
        i(n, d), o && l(n);
      }
    }
  );
}, hm = ({
  prefix: e,
  name: t,
  validateOnChange: n,
  chipOptions: { getLabelForSelected: o, label: a, icon: i },
  ...l
}) => {
  const {
    watch: c,
    setValue: d,
    trigger: u,
    formState: { defaultValues: p }
  } = Ue(), g = c(t) ?? (p == null ? void 0 : p[t]);
  return /* @__PURE__ */ r.jsx(
    t6,
    {
      ...l,
      id: `${e}-${t}`,
      chipOptions: {
        label: (g ? o == null ? void 0 : o(g) : a) ?? a,
        icon: i
      },
      selectedId: g,
      setSelectedId: (h) => {
        d(t, h), n && u(t);
      }
    }
  );
}, i1 = (e, t) => e[t] ?? sn(e, t), qo = (e, t, n) => () => {
  const o = t(n);
  if (typeof o != "string")
    return;
  const a = o.trim();
  o !== a && e(n, a, { shouldDirty: !0, shouldValidate: !0 });
}, gm = ({
  prefix: e,
  name: t,
  validateOnChange: n,
  ...o
}) => {
  const {
    watch: a,
    setValue: i,
    trigger: l,
    formState: { defaultValues: c, errors: d }
  } = Ue(), p = a(t) || (c == null ? void 0 : c[t]), m = i1(d, t);
  return /* @__PURE__ */ r.jsx(
    s6,
    {
      ...o,
      id: `${e}-${t}`,
      selectedValues: p,
      handleOnChange: (g) => {
        i(t, g), n && l(t);
      },
      hasError: !!m,
      errorMessage: m == null ? void 0 : m.message
    }
  );
}, Cm = ({
  prefix: e,
  name: t,
  label: n,
  options: o,
  onSelect: a,
  validateOnChange: i,
  isReadOnly: l = !1
}) => {
  const {
    setValue: c,
    trigger: d,
    watch: u,
    formState: { errors: p }
  } = Ue(), m = u(t) ?? [], g = i1(p, t);
  return /* @__PURE__ */ r.jsx(
    D2,
    {
      id: `${e}-${t}`,
      label: n,
      size: "medium",
      options: o,
      readOnly: l,
      handleOnChange: (h) => {
        a == null || a(h), c(t, h), i && d(t);
      },
      hasError: !!g,
      errorMessage: g == null ? void 0 : g.message,
      disabled: !1,
      isPlaceholder: !1,
      helperMessage: "",
      selectedValues: m instanceof Object ? [m] : m
    }
  );
}, vm = ({
  prefix: e,
  name: t,
  countryName: n,
  validateOnChange: o,
  onChange: a,
  ...i
}) => {
  const {
    setValue: l,
    trigger: c,
    watch: d,
    formState: { errors: u }
  } = Ue(), p = i1(u, t), m = n ? d(n) : void 0;
  return /* @__PURE__ */ r.jsx(
    O4,
    {
      ...i,
      id: `${e}-phone-${t}`,
      name: t,
      selectedCountry: m,
      handleOnChange: (g, h) => {
        l(t, h), a == null || a(h), o && c(t);
      },
      onCountryChange: (g) => {
        n && l(n, g), o && c(n);
      },
      value: d(t),
      hasError: !!p,
      errorMessage: i.errorMessage ?? (p == null ? void 0 : p.message)
    }
  );
}, Bu = R()({
  container: {
    maxWidth: "unset"
  }
}), fm = ({
  prefix: e,
  name: t,
  label: n,
  editLabel: o,
  onEdit: a
}) => {
  const { classes: i } = Bu(), { watch: l } = Ue();
  return /* @__PURE__ */ r.jsx(
    O2,
    {
      id: `${e}-${t}`,
      label: n,
      value: l(t) ?? "-",
      buttonLabel: o,
      buttonVariant: "text",
      buttonsAction: a,
      isReadOnly: !0,
      items: [],
      onChipChange: () => {
      },
      onChange: () => {
      },
      className: i.container
    }
  );
}, xm = ({
  prefix: e,
  label: t,
  labelHidden: n = !1,
  options: o,
  name: a,
  onSelect: i,
  validateOnChange: l,
  initialValue: c,
  isReadOnly: d = !1,
  disabled: u,
  autoFocus: p
}) => {
  const {
    watch: m,
    setValue: g,
    trigger: h,
    formState: { defaultValues: C, errors: v }
  } = Ue(), b = m(a), f = b || (c ?? (C == null ? void 0 : C[a])), y = i1(v, a);
  return /* @__PURE__ */ r.jsx(
    xc,
    {
      id: `${e}-${a}`,
      label: t,
      labelHidden: n,
      labelPosition: "top",
      size: "medium",
      options: o,
      selected: f,
      disabled: u,
      handleOnSelect: (w) => {
        i == null || i(w), g(a, w, { shouldDirty: !0 }), l && h(a);
      },
      hasError: !!y,
      errorMessage: y == null ? void 0 : y.message,
      isReadOnly: d,
      autoFocus: p
    }
  );
}, b2 = ({
  prefix: e,
  label: t,
  name: n,
  validateOnChange: o,
  ...a
}) => {
  const {
    setValue: i,
    getValues: l,
    trigger: c,
    watch: d,
    formState: { errors: u }
  } = Ue(), p = i1(u, n);
  return /* @__PURE__ */ r.jsx(
    y1,
    {
      ...a,
      id: `${e}-${n}`,
      name: n,
      label: t,
      handleOnChange: (m, g) => {
        i(n, g, { shouldDirty: !0 }), o && c(n);
      },
      handleOnBlur: qo(i, l, n),
      value: d(n) ?? "",
      hasError: !!p,
      errorMessage: p == null ? void 0 : p.message
    }
  );
}, or = R()((e) => ({
  root: {
    position: "relative"
  },
  addressFieldsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem"
  },
  suggestionsContainer: {
    position: "absolute",
    top: "100%",
    // Position it right below the text field
    left: 0,
    right: 0,
    zIndex: e.zIndex.modal,
    // A high z-index to appear on top
    backgroundColor: e.palette.background.paper,
    boxShadow: e.shadows[1],
    borderRadius: e.shape.borderRadius
  }
})), bm = ({
  prefix: e,
  isReadOnly: t = !1,
  autoFocusFirstField: n = !0
}) => {
  const { watch: o } = Ue(), { classes: a } = or(), { translations: i } = Q(), l = o("streetAddressLine2"), [c, d] = V(!1);
  return K(() => {
    d(!!l || t);
  }, [l, t]), /* @__PURE__ */ r.jsxs("div", { className: a.addressFieldsContainer, children: [
    /* @__PURE__ */ r.jsx(
      b2,
      {
        prefix: e,
        name: "streetAddressLine1",
        label: i.forms.street_address_line1,
        autoFocus: n,
        validateOnChange: !0,
        isReadOnly: t,
        helperMessage: c ? void 0 : /* @__PURE__ */ r.jsx(
          "a",
          {
            style: {
              textDecoration: "underline",
              color: "var(--primary-60-key)"
            },
            href: "#",
            onClick: (u) => {
              u.preventDefault(), u.stopPropagation(), d(!0);
            },
            children: i.forms.show_street_address_line2
          }
        )
      }
    ),
    c ? /* @__PURE__ */ r.jsx(r.Fragment, { children: !l && t ? /* @__PURE__ */ r.jsx(
      y1,
      {
        id: "streetAddressLine2",
        name: "streetAddressLine2",
        label: i.forms.street_address_line2,
        value: "-",
        handleOnChange: () => {
        },
        isReadOnly: !0
      }
    ) : /* @__PURE__ */ r.jsx(
      b2,
      {
        prefix: e,
        name: "streetAddressLine2",
        label: i.forms.street_address_line2,
        validateOnChange: !0,
        isReadOnly: t
      }
    ) }) : null
  ] });
}, Hu = ({
  prefix: e,
  name: t,
  // default to empty array
  suggestions: n = [],
  validateOnChange: o,
  onAddressSelected: a,
  onClearSuggestions: i,
  onLookupAddress: l,
  ...c
}) => {
  const {
    setValue: d,
    trigger: u,
    watch: p,
    formState: { errors: m }
  } = Ue(), g = i1(m, t), { classes: h } = or(), [C, v] = V(-1), b = n ?? [];
  K(() => {
    v(-1);
  }, [n]);
  const f = (k) => {
    if (b.length !== 0)
      switch (k.key) {
        case "Escape":
        case "Tab":
          i();
          break;
        case "ArrowDown":
          k.preventDefault(), v((M) => (M + 1) % b.length);
          break;
        case "ArrowUp":
          k.preventDefault(), v(
            (M) => M <= 0 ? b.length - 1 : (M - 1) % b.length
          );
          break;
        case "Enter": {
          k.preventDefault();
          const M = b[C];
          M && a(M.placePrediction.placeId);
          break;
        }
      }
  }, y = (k, M) => {
    d(t, M, { shouldDirty: !0 }), o && u(t), M.length === 0 && i(), l(M);
  }, w = b.map(
    (k, M) => ({
      id: k.placePrediction.placeId,
      label: k.placePrediction.text.text,
      density: "condensed",
      selected: M === C
    })
  );
  return /* @__PURE__ */ r.jsxs("div", { className: h.root, children: [
    /* @__PURE__ */ r.jsx(
      y1,
      {
        ...c,
        id: `${e}-${t}`,
        name: t,
        value: p(t) ?? "",
        handleOnChange: y,
        hasError: !!g,
        errorMessage: g == null ? void 0 : g.message,
        onKeyDown: f
      }
    ),
    w.length > 0 && /* @__PURE__ */ r.jsx(b0, { onClickAway: i, children: /* @__PURE__ */ r.jsx("div", { className: h.suggestionsContainer, children: /* @__PURE__ */ r.jsx(
      l1,
      {
        items: w,
        itemComponent: Se,
        onSelection: ({ id: k }) => a(k)
      }
    ) }) })
  ] });
}, wm = ({
  prefix: e,
  isReadOnly: t = !1,
  suggestions: n,
  autoFocusFirstField: o = !0,
  onAddressSelected: a,
  onClearSuggestions: i,
  onLookupAddress: l,
  line1Name: c = "streetAddressLine1",
  line2Name: d = "streetAddressLine2"
}) => {
  const { classes: u } = or(), { translations: p } = Q(), m = n ?? [];
  return /* @__PURE__ */ r.jsxs("div", { className: u.addressFieldsContainer, children: [
    /* @__PURE__ */ r.jsx(
      Hu,
      {
        prefix: e,
        name: c,
        label: p.forms.street_address_line1,
        autoFocus: o,
        validateOnChange: !0,
        isReadOnly: t,
        onAddressSelected: a,
        onLookupAddress: l,
        onClearSuggestions: i,
        suggestions: m
      }
    ),
    /* @__PURE__ */ r.jsx(
      b2,
      {
        prefix: e,
        name: d,
        label: p.forms.street_address_line2,
        validateOnChange: !0,
        isReadOnly: t
      }
    )
  ] });
}, ym = ({
  prefix: e,
  label: t,
  name: n,
  validateOnChange: o,
  ...a
}) => {
  const {
    setValue: i,
    getValues: l,
    trigger: c,
    watch: d,
    formState: { errors: u }
  } = Ue(), p = i1(u, n);
  return /* @__PURE__ */ r.jsx(
    Xn,
    {
      ...a,
      id: `${e}-${n}`,
      name: n,
      label: t,
      value: d(n) ?? "",
      handleOnChange: (m, g) => {
        i(n, g), o && c(n);
      },
      onBlur: qo(i, l, n),
      hasError: !!p,
      errorMessage: p == null ? void 0 : p.message
    }
  );
}, Du = (e, t) => {
  const n = Z(void 0);
  return Te(
    (...o) => {
      const a = () => {
        clearTimeout(n.current), e(...o);
      };
      clearTimeout(n.current), n.current = setTimeout(a, t);
    },
    [e, t]
  );
}, Tu = (e) => e instanceof w0 || e.name === "ValidationError", Ru = (e, t, n) => {
  let o = [];
  try {
    e.validateSync(t, { abortEarly: !1 });
  } catch (a) {
    if (Tu(a))
      o = a.inner.map((l) => l.path ?? "").filter((l) => l.includes(n)).map((l) => sn(t, l));
    else
      throw a;
  }
  return o;
}, km = ({
  label: e,
  helperMessage: t,
  placeholderText: n = "",
  name: o,
  inProgressValueName: a,
  prefix: i,
  defaultErrorMessage: l,
  schema: c,
  getChipsForValues: d,
  autoFocus: u
}) => {
  const {
    setValue: p,
    trigger: m,
    getValues: g,
    formState: { errors: h }
  } = Ue(), [C, v] = V(""), b = g(), f = i1(h, o), y = a ? i1(h, a) : void 0, w = Ru(c, b, o), k = b[o] ?? [], M = d ? d(k).map((E) => ({
    ...E,
    // We take the error provided and combine it with any error for the given text.
    error: !!E.error || w.includes(E.label)
  })) : k.map((E = "", $) => ({
    id: `${i}-${o}-${$}`,
    label: E,
    isRemovable: !0,
    isInteractable: !0,
    error: w.includes(E)
  })), L = !!f || !!y, j = () => {
    const E = f == null ? void 0 : f.message;
    return (y == null ? void 0 : y.message) ?? E ?? (L ? l : "") ?? "";
  }, N = Du(
    (E) => void m(E),
    500
  );
  return /* @__PURE__ */ r.jsx(
    to,
    {
      id: `${i}-${o}`,
      label: e,
      helperMessage: t,
      placeholderText: n,
      value: C,
      onChipChange: (E) => {
        p(
          o,
          E.map(($) => $.label)
        ), m(o), E.length > k.length && (v(""), a && p(a, ""));
      },
      onChange: (E) => {
        v(E), a && (p(a, E), N(a));
      },
      items: M,
      hasError: L,
      errorMessage: j(),
      autoFocus: u
    }
  );
}, Fu = (e) => e === "" || !e, jm = (e) => y0({
  countryCode: l2(),
  number: k0(
    (t) => Fu(t) ? l2() : zu(e)
  )
}), zu = (e) => l2().required().test(
  "is-numeric",
  () => e.non_numeric,
  (t) => !/[A-Za-z]+$/.exec(t)
).test(
  "is-possible",
  () => e.not_possible,
  (t, n) => j0(
    t,
    n.parent.countryCode ?? "US"
  )
), Sm = ({
  component: e,
  baseAssetUrl: t
}) => {
  const n = S0(e, {
    onRedirecting: () => /* @__PURE__ */ r.jsx(ko, { baseAssetUrl: t })
  });
  return /* @__PURE__ */ r.jsx(n, {});
}, c1 = class c1 {
  constructor() {
    Ut(this, "refreshMethod");
    this.refreshMethod = () => new Promise(() => (console.warn("No token refresh method set"), ""));
  }
  setRefreshMethod(t) {
    this.refreshMethod = t;
  }
  /**
   * Refreshes the authentication token by calling the installed refresh method.
   * Call before all API requests to get a current token.
   */
  async refreshToken() {
    return await this.refreshMethod();
  }
  static getInstance() {
    return c1.instance ?? (c1.instance = new c1()), c1.instance;
  }
};
Ut(c1, "instance");
let w2 = c1;
const Wu = w2.getInstance(), Uo = {
  auth0: void 0
}, Go = nt(Uo), Lm = ({ children: e }) => {
  const t = L0(), n = Z({ auth0: t }), [o, a] = V(Uo);
  return K(() => {
    Wu.setRefreshMethod(t.getAccessTokenSilently), n.current.auth0 = t, a(n.current);
  }, [t]), /* @__PURE__ */ r.jsx(Go.Provider, { value: o, children: e });
}, Ko = () => $1(Go), Mm = ({
  authRoute: e,
  noAuthRoute: t,
  replace: n = !0,
  baseAssetUrl: o = ""
}) => {
  const { auth0: a } = Ko(), i = A0(), l = Z(!1), c = `${e}${window.location.search}`, d = `${t}${window.location.search}`;
  return K(() => {
    if (!l.current) {
      if (l.current = !0, !a || typeof a.loginWithRedirect != "function") {
        i(d, { replace: n });
        return;
      }
      a.loginWithRedirect({
        appState: {
          returnTo: c
        },
        authorizationParams: {
          prompt: "none"
        }
      }).catch(() => {
        i(d, { replace: n });
      });
    }
  }, [a, c, i, d, n]), /* @__PURE__ */ r.jsx(ko, { baseAssetUrl: o });
}, Em = ({ visible: e, children: t }) => e ? t : null, Nm = ({
  auth0Config: e,
  children: t
}) => {
  const {
    AUTH0_DOMAIN: n,
    AUTH0_CLIENT_ID: o,
    AUTH0_CALLBACK_URL: a,
    onRedirectCallback: i
  } = e;
  return /* @__PURE__ */ r.jsx(
    M0,
    {
      domain: n,
      clientId: o,
      authorizationParams: {
        redirect_uri: a,
        audience: "https://data.ia.io",
        scope: "openid profile email offline_access read:all https://data.ia.io/ia_acct_uuid"
      },
      useRefreshTokens: !0,
      useRefreshTokensFallback: !0,
      cacheLocation: "memory",
      onRedirectCallback: i,
      children: t
    }
  );
}, Im = ({
  clientSideID: e,
  children: t
}) => {
  const { auth0: n } = Ko(), o = n == null ? void 0 : n.user, a = E0(), i = Te(() => /* @__PURE__ */ r.jsx(r.Fragment, { children: t }), [t]);
  K(() => {
    o && a && a.identify({
      key: o.email,
      name: o.name,
      email: o.email
    }).catch((c) => {
      console.error("Failed to identify user in LaunchDarkly:", c);
    });
  }, [o, a]);
  const l = N0({
    clientSideID: e,
    timeout: 3,
    // wait 3 seconds before timing out, to avoid blocking the app
    options: {
      bootstrap: "localStorage"
      // use local storage to cache feature flags
    }
  })(i);
  return /* @__PURE__ */ r.jsx(l, {});
}, Ou = () => {
  var t;
  const e = document.createElement("script");
  e.textContent = '!function(){window.semaphore=window.semaphore||[],window.ketch=function(){window.semaphore.push(arguments)};var e=document.createElement("script");e.type="text/javascript",e.src="https://global.ketchcdn.com/web/v3/config/inductive_automation/inductiveautomation_com/boot.js",e.defer=e.async=!0,document.getElementsByTagName("head")[0].appendChild(e)}();', (t = document.getElementsByTagName("head")[0]) == null || t.appendChild(e);
}, $m = ({ children: e }) => {
  const [t, n] = V(!1);
  return K(() => {
    t || (Ou(), n(!0));
  }, [t, n]), e;
}, _m = (e) => {
  const [t, n] = V(!1), [o, a] = V(
    []
  );
  return K(() => {
    e && (a(
      e.filter(
        (i) => !!(i.id && i.name)
      ).map((i) => ({
        value: i.id,
        label: i.name
      }))
    ), n(e.length > 0));
  }, [e]), {
    countryHasState: t,
    stateList: o
  };
}, Zu = () => {
  const { translations: e } = Q(), { addSnackbar: t } = Wt(), n = Te(
    (o) => {
      var l, c;
      const a = o.detail.error;
      console.warn("API Error:", a);
      let i = e.errors.request_failed;
      if ("status" in a)
        if (["FETCH_ERROR", "TIMEOUT_ERROR"].includes(a.status.toString()))
          i = e.errors.request_failed;
        else {
          const { data: d } = a;
          if (typeof d == "string")
            i = d;
          else if (d && typeof d == "object") {
            const u = d;
            i = typeof u.message == "string" && u.message || typeof u.error == "string" && u.error || i;
          }
          typeof a.status == "number" && (i = `${i} (${a.status})`);
        }
      t(i, {
        type: "error",
        // @ts-expect-error - `id` is not a required property in SnackbarProps, but we provide it for uniqueness
        id: `base-api-error-${((c = (l = a.data) == null ? void 0 : l.error) == null ? void 0 : c.requestId) || Date.now()}`
      });
    },
    [t, e]
  );
  K(() => (window.addEventListener("base-api-error", n), () => {
    window.removeEventListener("base-api-error", n);
  }), [t, e, n]);
}, Vm = () => (Zu(), null);
export {
  kp as APP_BAR_HEIGHTS,
  yp as AccountHeader,
  pm as AdvancedDataGrid,
  Ke as Alert,
  Vm as ApiErrorHandler,
  jp as AppBar,
  Mm as AuthenticationFork,
  Sm as AuthenticationGuard,
  we as Avatar,
  g8 as Backdrop,
  et as Badge,
  dm as BasicDataGrid,
  Y2 as Breadcrumbs,
  G as Button,
  E3 as CardGroup,
  bp as CheckAccess,
  p1 as Checkbox,
  $i as CheckboxCard,
  Qu as CheckboxGroup,
  $3 as CheckboxItem,
  _e as Chip,
  mn as CircularProgress,
  Rp as CodeBlock,
  Je as ComplexListItem,
  Fp as ComplexListItemAccordion,
  zp as ComplexListItemTree,
  Yu as ComponentProvider,
  Nm as ConfiguredAuth0Provider,
  ro as ContentEmpty,
  I1 as ContentSectionAccordion,
  Bp as CopyTextField,
  Lm as CustomAuth0Provider,
  t6 as CustomSelect,
  Z0 as CustomThemeProvider,
  em as DashboardActivityHeatMap,
  tm as DashboardCircle,
  rm as DashboardHorizontalBar,
  nm as DashboardLineChart,
  od as DashboardPieChart,
  om as DashboardStatisticWidget,
  am as DashboardSuggestionCardList,
  No as DashboardWidget,
  sm as DataCardList,
  Wp as DateDisplay,
  gp as DependentCardGroup,
  Up as DependentListAdvanced,
  Q2 as Dialog,
  Zp as DialogReviewField,
  R9 as DialogReviewFields,
  Ce as Divider,
  Lp as DrawerContainer,
  Hp as EnvironmentBanner,
  Dp as ErrorPage,
  Pp as ExternalLink,
  Cr as FabButtonContainer,
  a1 as FieldLabel,
  Cp as FileUpload,
  mm as FormCheckbox,
  hm as FormCustomSelect,
  gm as FormIndustrySelect,
  Cm as FormMultipleSelect,
  vm as FormPhoneInput,
  Hm as FormProvider,
  fm as FormReviewField,
  xm as FormSelect,
  bm as FormStreetAddressFields,
  wm as FormStreetAddressFieldsAutocomplete,
  ym as FormTextArea,
  b2 as FormTextField,
  km as FormTextFieldWithChips,
  Dm as Grid,
  lm as INPUT_COLUMN_WIDTH,
  te as Icon,
  Em as If,
  s6 as IndustrySelect,
  G6 as InfoDrawer,
  Q6 as InfoDrawerMeta,
  X6 as InfoDrawerSection,
  Mp as InfoDrawerTags,
  Q9 as ItemBanner,
  Ep as ItemDrawer,
  Np as ItemDrawerDefault,
  Im as LaunchDarklyProvider,
  qp as Layout,
  S3 as LinkCard,
  l1 as List,
  Ie as ListAdvanced,
  T1 as ListHeader,
  Se as ListItem,
  q8 as ListItemTree,
  ko as LoadingPage,
  Op as MultiStepDialog,
  D2 as MultipleSelect,
  wp as Navigation,
  m6 as NavigationItem,
  Id as PRIMARY_COLUMN_MAX_WIDTH,
  Nd as PRIMARY_COLUMN_MIN_WIDTH,
  Kp as Page,
  _p as PageNotFound,
  s7 as PageSection,
  So as PageSidebar,
  O4 as PhoneInput,
  Jp as ProfileWidget,
  no as PurchaseBar,
  at as Radio,
  Ti as RadioCard,
  fp as RadioGroup,
  xp as RadioItem,
  Qp as ReactWindowScrollView,
  Tp as RequestError,
  ue as ScrollView,
  xc as Select,
  Un as SideDrawer,
  l4 as SingleStatusChip,
  R1 as Skeleton,
  Vp as Slider,
  Jc as Snackbar,
  a8 as SnackbarList,
  Ap as SnackbarProvider,
  Fi as Switch,
  Wi as SwitchCard,
  On as TabBar,
  Xn as TextArea,
  y1 as TextField,
  O2 as TextFieldSplit,
  to as TextFieldWithChips,
  he as Tooltip,
  W as Typography,
  i9 as VerticalBox,
  $m as WithKetch,
  $p as WorkspaceHeader,
  Ip as WorkspaceSwitcherUtilities,
  zn as avatarPropsForPerson,
  lp as buildCurrentUserData,
  vn as canUseAvatarUrl,
  hp as chipStateForTrainingStatus,
  sp as componentZIndexes,
  Xu as createCountryCodeOptions,
  $d as createDataCardInitialColumnDefinition,
  _d as createInfoCardColumnDefinition,
  um as dateRangeMatches,
  Ju as formatAddress,
  j1 as formatDate,
  L2 as formatPersonInitials,
  ep as formatPersonName,
  ip as getAuth0TokenClaims,
  vp as getCountryCallingCode,
  ho as getDialogContentStyles,
  Z1 as getIcon,
  cm as getOrganizationNameFromCard,
  X2 as getPageStyles,
  Sp as getSideDrawerContentStyles,
  w1 as getTextFieldStyles,
  Gp as handleApiError,
  im as heatMapData,
  c2 as industryOptions,
  pp as initGTM,
  G1 as isDateRange,
  tt as isPrimaryColumn,
  Z3 as isString,
  fn as isStringArray,
  np as isValidDomain,
  mp as loadFavicons,
  R as makeStyles,
  tp as mapAddressToType,
  cp as matchers,
  jm as phoneSchema,
  $2 as random,
  Yp as randomSidebarImage,
  dp as randomString,
  ap as removeTrailingSlashSingle,
  op as removeWebsiteProtocolAndPrefix,
  up as scrollReviewSectionIntoView,
  En as sendFileDownload,
  rp as toggleElementInArrayByValue,
  Wu as tokenManager,
  Zu as useApiErrorHandler,
  L0 as useAuth0,
  Ku as useBelowBreakpoint,
  _m as useCountryStates,
  Ko as useCustomAuth0Context,
  Tm as useFlags,
  Ve as useMaterialTheme,
  z6 as useResponsiveSideDrawer,
  Xp as useScrollToTopOnNavigate,
  C2 as useSession,
  Wt as useSnackbarContext,
  ot as visuallyHidden,
  Cn as writeToClipboard
};
